export const plutoEarthSvs = [
    [
        631152000000,
        [
            -2961217564.513391,
            -3409931775.949904,
            -180001336.4341588,
        ],
    ],
    [
        631756800000,
        [
            -2940931150.328195,
            -3408126956.393779,
            -179707360.7327663,
        ],
    ],
    [
        632361600000,
        [
            -2921324557.344059,
            -3404369382.499015,
            -178567806.7740107,
        ],
    ],
    [
        632966400000,
        [
            -2902643586.899754,
            -3398747409.245665,
            -176619509.2666189,
        ],
    ],
    [
        633571200000,
        [
            -2885136931.253705,
            -3391372698.922672,
            -173910466.5930528,
        ],
    ],
    [
        634176000000,
        [
            -2869041242.613444,
            -3382399123.813864,
            -170508981.7880487,
        ],
    ],
    [
        634780800000,
        [
            -2854550692.137887,
            -3372012839.863382,
            -166496736.33109,
        ],
    ],
    [
        635385600000,
        [
            -2841827581.635003,
            -3360402970.537885,
            -161954746.8345195,
        ],
    ],
    [
        635990400000,
        [
            -2831024065.634386,
            -3347772592.777853,
            -156970928.1974189,
        ],
    ],
    [
        636595200000,
        [
            -2822266789.554673,
            -3334354602.791476,
            -151647558.321154,
        ],
    ],
    [
        637200000000,
        [
            -2815629344.157524,
            -3320396695.40927,
            -146092012.552393,
        ],
    ],
    [
        637804800000,
        [
            -2811150583.716413,
            -3306133246.871541,
            -140404096.7030137,
        ],
    ],
    [
        638409600000,
        [
            -2808854694.552525,
            -3291799147.388426,
            -134685090.1228005,
        ],
    ],
    [
        639014400000,
        [
            -2808736015.791546,
            -3277643852.766621,
            -129044268.2867875,
        ],
    ],
    [
        639619200000,
        [
            -2810735514.40113,
            -3263913546.062164,
            -123588359.5226897,
        ],
    ],
    [
        640224000000,
        [
            -2814766201.429732,
            -3250826390.810805,
            -118410866.4811325,
        ],
    ],
    [
        640828800000,
        [
            -2820731017.367564,
            -3238590179.011901,
            -113602390.2964499,
        ],
    ],
    [
        641433600000,
        [
            -2828507102.348469,
            -3227415024.868019,
            -109255832.528588,
        ],
    ],
    [
        642038400000,
        [
            -2837926079.252127,
            -3217493646.887075,
            -105454765.0950776,
        ],
    ],
    [
        642643200000,
        [
            -2848804305.629804,
            -3208980834.876187,
            -102265108.2525793,
        ],
    ],
    [
        643248000000,
        [
            -2860957283.505294,
            -3202014452.773273,
            -99746779.82488203,
        ],
    ],
    [
        643852800000,
        [
            -2874182179.970104,
            -3196726479.503181,
            -97957930.71085688,
        ],
    ],
    [
        644457600000,
        [
            -2888241829.419637,
            -3193221792.821244,
            -96943011.03012888,
        ],
    ],
    [
        645062400000,
        [
            -2902898063.142,
            -3191562712.018751,
            -96727530.46508008,
        ],
    ],
    [
        645667200000,
        [
            -2917922455.710704,
            -3191792936.94728,
            -97330893.68184692,
        ],
    ],
    [
        646272000000,
        [
            -2933077037.616029,
            -3193946940.960835,
            -98769436.45832527,
        ],
    ],
    [
        646876800000,
        [
            -2948102626.468491,
            -3198027484.132901,
            -101043884.6518555,
        ],
    ],
    [
        647481600000,
        [
            -2962753789.784015,
            -3203995671.661678,
            -104136767.3917284,
        ],
    ],
    [
        648086400000,
        [
            -2976805648.995453,
            -3211796679.441679,
            -108025482.888035,
        ],
    ],
    [
        648691200000,
        [
            -2990032516.33097,
            -3221366919.14799,
            -112683773.9509528,
        ],
    ],
    [
        649296000000,
        [
            -3002200616.235984,
            -3232609977.989177,
            -118068714.1841428,
        ],
    ],
    [
        649900800000,
        [
            -3013103071.131425,
            -3245392305.14398,
            -124121161.4781465,
        ],
    ],
    [
        650505600000,
        [
            -3022562529.165421,
            -3259569782.7879,
            -130779147.299547,
        ],
    ],
    [
        651110400000,
        [
            -3030408099.293086,
            -3274992825.026293,
            -137978395.927448,
        ],
    ],
    [
        651715200000,
        [
            -3036473038.710334,
            -3291481430.875905,
            -145639448.3073967,
        ],
    ],
    [
        652320000000,
        [
            -3040628983.458925,
            -3308827228.224494,
            -153671255.8248786,
        ],
    ],
    [
        652924800000,
        [
            -3042784519.721898,
            -3326820492.48221,
            -161984250.1430253,
        ],
    ],
    [
        653529600000,
        [
            -3042860904.25109,
            -3345253472.97454,
            -170489571.6011573,
        ],
    ],
    [
        654134400000,
        [
            -3040794499.982192,
            -3363895079.672475,
            -179086156.7496218,
        ],
    ],
    [
        654739200000,
        [
            -3036568748.68385,
            -3382499084.902716,
            -187667011.1247413,
        ],
    ],
    [
        655344000000,
        [
            -3030207730.229803,
            -3400830496.445998,
            -196131444.7576965,
        ],
    ],
    [
        655948800000,
        [
            -3021750347.978805,
            -3418666739.27443,
            -204383262.797777,
        ],
    ],
    [
        656553600000,
        [
            -3011256440.59622,
            -3435772366.976523,
            -212318604.9794838,
        ],
    ],
    [
        657158400000,
        [
            -2998835148.997036,
            -3451912912.828792,
            -219835120.4194194,
        ],
    ],
    [
        657763200000,
        [
            -2984632957.635073,
            -3466879855.979382,
            -226843321.5748066,
        ],
    ],
    [
        658368000000,
        [
            -2968806730.662184,
            -3480489346.032481,
            -233263681.2890576,
        ],
    ],
    [
        658972800000,
        [
            -2951532828.711076,
            -3492557450.274842,
            -239015218.4566528,
        ],
    ],
    [
        659577600000,
        [
            -2933031201.844993,
            -3502918403.660742,
            -244026459.3586843,
        ],
    ],
    [
        660182400000,
        [
            -2913547784.059858,
            -3511446746.368979,
            -248244742.410749,
        ],
    ],
    [
        660787200000,
        [
            -2893326756.232793,
            -3518051943.563032,
            -251631162.20205,
        ],
    ],
    [
        661392000000,
        [
            -2872621846.02635,
            -3522653559.619075,
            -254149546.769654,
        ],
    ],
    [
        661996800000,
        [
            -2851715707.553744,
            -3525201456.739571,
            -255778293.2759449,
        ],
    ],
    [
        662601600000,
        [
            -2830897338.791704,
            -3525693440.718376,
            -256517408.5001102,
        ],
    ],
    [
        663206400000,
        [
            -2810434982.495352,
            -3524164181.527474,
            -256381216.7421997,
        ],
    ],
    [
        663811200000,
        [
            -2790590481.947751,
            -3520660434.44727,
            -255388196.5784754,
        ],
    ],
    [
        664416000000,
        [
            -2771635224.593886,
            -3515261802.964984,
            -253573150.5872535,
        ],
    ],
    [
        665020800000,
        [
            -2753825208.762984,
            -3508093726.757723,
            -250991823.9918495,
        ],
    ],
    [
        665625600000,
        [
            -2737377212.925538,
            -3499310470.095337,
            -247710915.2888507,
        ],
    ],
    [
        666230400000,
        [
            -2722487989.097885,
            -3489071427.525736,
            -243798662.8419455,
        ],
    ],
    [
        666835200000,
        [
            -2709347829.164095,
            -3477561882.005383,
            -239336469.6097087,
        ],
    ],
    [
        667440000000,
        [
            -2698115390.610388,
            -3465001773.877617,
            -234421144.2770102,
        ],
    ],
    [
        668044800000,
        [
            -2688898597.208458,
            -3451623414.268679,
            -229152668.6359008,
        ],
    ],
    [
        668649600000,
        [
            -2681779368.046333,
            -3437650478.001152,
            -223626617.3014188,
        ],
    ],
    [
        669254400000,
        [
            -2676824753.060245,
            -3423319267.377444,
            -217945832.2465183,
        ],
    ],
    [
        669859200000,
        [
            -2674062839.624411,
            -3408884708.669012,
            -212221489.2180054,
        ],
    ],
    [
        670464000000,
        [
            -2673469180.255862,
            -3394594977.446709,
            -206559954.1689419,
        ],
    ],
    [
        671068800000,
        [
            -2674997085.781552,
            -3380675497.369024,
            -201058015.4817109,
        ],
    ],
    [
        671673600000,
        [
            -2678585848.067168,
            -3367351766.8043,
            -195814618.4039649,
        ],
    ],
    [
        672278400000,
        [
            -2684138082.164371,
            -3354853688.975339,
            -190930750.6968401,
        ],
    ],
    [
        672883200000,
        [
            -2691511261.525749,
            -3343388806.117742,
            -186495676.8463362,
        ],
    ],
    [
        673488000000,
        [
            -2700551901.373823,
            -3333132172.023222,
            -182584969.3691074,
        ],
    ],
    [
        674092800000,
        [
            -2711099401.012467,
            -3324250457.290373,
            -179272078.7547636,
        ],
    ],
    [
        674697600000,
        [
            -2722963975.278252,
            -3316904331.696565,
            -176627211.180699,
        ],
    ],
    [
        675302400000,
        [
            -2735922341.505106,
            -3311221176.41462,
            -174703873.8698094,
        ],
    ],
    [
        675907200000,
        [
            -2749753859.602685,
            -3307291010.614939,
            -173540248.4177216,
        ],
    ],
    [
        676512000000,
        [
            -2764239532.098747,
            -3305191581.681673,
            -173170879.4925539,
        ],
    ],
    [
        677116800000,
        [
            -2779140528.363853,
            -3304988716.556884,
            -173624664.9447131,
        ],
    ],
    [
        677721600000,
        [
            -2794198158.1129,
            -3306709510.271345,
            -174911986.946871,
        ],
    ],
    [
        678326400000,
        [
            -2809170624.818877,
            -3310344293.125383,
            -177028829.4113009,
        ],
    ],
    [
        678931200000,
        [
            -2823827399.538248,
            -3315872100.391584,
            -179967818.0545017,
        ],
    ],
    [
        679536000000,
        [
            -2837928213.970192,
            -3323258413.211306,
            -183714675.2914585,
        ],
    ],
    [
        680140800000,
        [
            -2851227164.62953,
            -3332428999.983932,
            -188235885.2208963,
        ],
    ],
    [
        680745600000,
        [
            -2863508208.712985,
            -3343277238.149546,
            -193485219.4103771,
        ],
    ],
    [
        681350400000,
        [
            -2874575004.34074,
            -3355689105.491608,
            -199414233.0367624,
        ],
    ],
    [
        681955200000,
        [
            -2884230267.521826,
            -3369538094.812573,
            -205967698.931361,
        ],
    ],
    [
        682560000000,
        [
            -2892284300.522795,
            -3384660401.304944,
            -213072666.7761747,
        ],
    ],
    [
        683164800000,
        [
            -2898588061.533997,
            -3400867714.082181,
            -220647507.5802548,
        ],
    ],
    [
        683769600000,
        [
            -2903019319.224761,
            -3417971653.07436,
            -228611811.9981725,
        ],
    ],
    [
        684374400000,
        [
            -2905462726.412329,
            -3435776400.138485,
            -236880735.6913323,
        ],
    ],
    [
        684979200000,
        [
            -2905822996.077632,
            -3454056026.906497,
            -245355332.4674082,
        ],
    ],
    [
        685584000000,
        [
            -2904054007.621867,
            -3472572519.451067,
            -253933331.658115,
        ],
    ],
    [
        686188800000,
        [
            -2900141230.779703,
            -3491098866.033354,
            -262517807.5634869,
        ],
    ],
    [
        686793600000,
        [
            -2894081859.199611,
            -3509409373.293067,
            -271010487.080306,
        ],
    ],
    [
        687398400000,
        [
            -2885901696.283916,
            -3527259259.465503,
            -279303772.3973134,
        ],
    ],
    [
        688003200000,
        [
            -2875678415.841284,
            -3544407215.044623,
            -287293347.4915345,
        ],
    ],
    [
        688608000000,
        [
            -2863520061.406873,
            -3560636211.831278,
            -294885774.6788202,
        ],
    ],
    [
        689212800000,
        [
            -2849545002.467641,
            -3575741765.477926,
            -301991301.7186854,
        ],
    ],
    [
        689817600000,
        [
            -2833901847.6947,
            -3589514084.403456,
            -308517769.2463599,
        ],
    ],
    [
        690422400000,
        [
            -2816786015.779031,
            -3601764349.170868,
            -314384367.7436212,
        ],
    ],
    [
        691027200000,
        [
            -2798414584.674212,
            -3612341942.164439,
            -319527148.9465325,
        ],
    ],
    [
        691632000000,
        [
            -2779006230.468159,
            -3621120101.204426,
            -323890594.1359073,
        ],
    ],
    [
        692236800000,
        [
            -2758803104.066411,
            -3627979722.046598,
            -327422535.0548949,
        ],
    ],
    [
        692841600000,
        [
            -2738080244.73097,
            -3632837182.333261,
            -330087952.1506193,
        ],
    ],
    [
        693446400000,
        [
            -2717117113.225028,
            -3635655851.920381,
            -331871721.5915677,
        ],
    ],
    [
        694051200000,
        [
            -2696178363.431865,
            -3636427897.893641,
            -332768921.2294794,
        ],
    ],
    [
        694656000000,
        [
            -2675537383.681613,
            -3635158897.706765,
            -332780818.8366646,
        ],
    ],
    [
        695260800000,
        [
            -2655479952.49128,
            -3631895566.887595,
            -331928454.6674204,
        ],
    ],
    [
        695865600000,
        [
            -2636274537.665427,
            -3626730845.045292,
            -330252595.3678664,
        ],
    ],
    [
        696470400000,
        [
            -2618156627.726655,
            -3619781744.433078,
            -327802700.0617391,
        ],
    ],
    [
        697075200000,
        [
            -2601355001.417273,
            -3611175282.790515,
            -324633633.6220785,
        ],
    ],
    [
        697680000000,
        [
            -2586091906.248601,
            -3601075377.960391,
            -320818151.7749589,
        ],
    ],
    [
        698284800000,
        [
            -2572554252.196324,
            -3589681934.537323,
            -316443829.4981521,
        ],
    ],
    [
        698889600000,
        [
            -2560883601.684012,
            -3577205146.014357,
            -311600689.6798409,
        ],
    ],
    [
        699494400000,
        [
            -2551205383.181353,
            -3563853944.094498,
            -306379087.8841745,
        ],
    ],
    [
        700099200000,
        [
            -2543626590.226703,
            -3549861892.766803,
            -300881329.0414172,
        ],
    ],
    [
        700704000000,
        [
            -2538208999.063809,
            -3535481865.021382,
            -295216869.0057273,
        ],
    ],
    [
        701308800000,
        [
            -2534965878.754071,
            -3520958438.906209,
            -289489906.8332061,
        ],
    ],
    [
        701913600000,
        [
            -2533893955.60463,
            -3506521243.526168,
            -283799725.1001553,
        ],
    ],
    [
        702518400000,
        [
            -2534968972.558028,
            -3492410575.431696,
            -278251713.9127055,
        ],
    ],
    [
        703123200000,
        [
            -2538121577.904194,
            -3478869810.869349,
            -272951548.1487908,
        ],
    ],
    [
        703728000000,
        [
            -2543240667.327104,
            -3466117663.45482,
            -267993034.6922108,
        ],
    ],
    [
        704332800000,
        [
            -2550206833.442017,
            -3454347934.054907,
            -263460963.2452006,
        ],
    ],
    [
        704937600000,
        [
            -2558884753.450331,
            -3443754442.628582,
            -259440967.3546682,
        ],
    ],
    [
        705542400000,
        [
            -2569101113.055079,
            -3434521800.053128,
            -256012918.3333595,
        ],
    ],
    [
        706147200000,
        [
            -2580653084.449342,
            -3426798185.616956,
            -253239539.2290316,
        ],
    ],
    [
        706752000000,
        [
            -2593341343.734581,
            -3420701700.503986,
            -251172259.5546443,
        ],
    ],
    [
        707356800000,
        [
            -2606958404.531756,
            -3416343866.282782,
            -249860179.1543266,
        ],
    ],
    [
        707961600000,
        [
            -2621268533.671235,
            -3413819104.621332,
            -249343324.3792152,
        ],
    ],
    [
        708566400000,
        [
            -2636020639.573611,
            -3413178989.691974,
            -249642553.1356951,
        ],
    ],
    [
        709171200000,
        [
            -2650979932.01402,
            -3414445222.024199,
            -250768160.555436,
        ],
    ],
    [
        709776000000,
        [
            -2665912390.586656,
            -3417631206.890337,
            -252727373.9741405,
        ],
    ],
    [
        710380800000,
        [
            -2680567036.641474,
            -3422730153.491343,
            -255516963.5249708,
        ],
    ],
    [
        710985600000,
        [
            -2694692479.572485,
            -3429691233.268507,
            -259114094.7758493,
        ],
    ],
    [
        711590400000,
        [
            -2708065930.317656,
            -3438438159.581739,
            -263486907.5626085,
        ],
    ],
    [
        712195200000,
        [
            -2720473749.780607,
            -3448888016.201153,
            -268600377.3060074,
        ],
    ],
    [
        712800000000,
        [
            -2731696032.921861,
            -3460937549.512837,
            -274408568.0846202,
        ],
    ],
    [
        713404800000,
        [
            -2741526147.59567,
            -3474441821.598444,
            -280847186.4582626,
        ],
    ],
    [
        714009600000,
        [
            -2749796182.027018,
            -3489237716.553072,
            -287846206.5308405,
        ],
    ],
    [
        714614400000,
        [
            -2756354324.106649,
            -3505160233.51406,
            -295334572.371014,
        ],
    ],
    [
        715219200000,
        [
            -2761052279.17494,
            -3522027438.541977,
            -303232328.1026163,
        ],
    ],
    [
        715824000000,
        [
            -2763767740.596119,
            -3539622802.944027,
            -311445032.4345097,
        ],
    ],
    [
        716428800000,
        [
            -2764425421.141232,
            -3557723007.020237,
            -319877501.4924132,
        ],
    ],
    [
        717033600000,
        [
            -2762971699.689875,
            -3576111765.959363,
            -328436945.3792458,
        ],
    ],
    [
        717638400000,
        [
            -2759364377.390185,
            -3594563392.754766,
            -337024648.8298399,
        ],
    ],
    [
        718243200000,
        [
            -2753597037.053598,
            -3612829197.272107,
            -345532361.0627062,
        ],
    ],
    [
        718848000000,
        [
            -2745713864.629554,
            -3630668207.909114,
            -353856744.6835561,
        ],
    ],
    [
        719452800000,
        [
            -2735781448.89315,
            -3647858182.980763,
            -361901377.2323303,
        ],
    ],
    [
        720057600000,
        [
            -2723880034.147768,
            -3664177792.846388,
            -369568537.0007716,
        ],
    ],
    [
        720662400000,
        [
            -2710128995.897491,
            -3679397498.522627,
            -376758118.685549,
        ],
    ],
    [
        721267200000,
        [
            -2694694387.263646,
            -3693312041.611543,
            -383382353.8725178,
        ],
    ],
    [
        721872000000,
        [
            -2677758547.500877,
            -3705748203.691792,
            -389366358.5051792,
        ],
    ],
    [
        722476800000,
        [
            -2659512443.84675,
            -3716545420.330212,
            -394639453.0576613,
        ],
    ],
    [
        723081600000,
        [
            -2640181639.565997,
            -3725550563.603678,
            -399135746.1163737,
        ],
    ],
    [
        723686400000,
        [
            -2620025788.046993,
            -3732650051.901999,
            -402807751.1895007,
        ],
    ],
    [
        724291200000,
        [
            -2599306673.575381,
            -3737772546.530344,
            -405624631.6886772,
        ],
    ],
    [
        724896000000,
        [
            -2578281348.376297,
            -3740866874.261032,
            -407562679.993448,
        ],
    ],
    [
        725500800000,
        [
            -2557228201.361053,
            -3741899243.649095,
            -408607255.2404001,
        ],
    ],
    [
        726105600000,
        [
            -2536438972.63174,
            -3740882990.330373,
            -408765008.650309,
        ],
    ],
    [
        726710400000,
        [
            -2516187239.838028,
            -3737874971.383576,
            -408059892.2326419,
        ],
    ],
    [
        727315200000,
        [
            -2496724050.816344,
            -3732950798.366833,
            -406523020.2092569,
        ],
    ],
    [
        727920000000,
        [
            -2478305225.173615,
            -3726204095.974216,
            -404195559.4877005,
        ],
    ],
    [
        728524800000,
        [
            -2461178319.18346,
            -3717773320.389999,
            -401138985.9596255,
        ],
    ],
    [
        729129600000,
        [
            -2445554210.777447,
            -3707831854.332066,
            -397428420.7267733,
        ],
    ],
    [
        729734400000,
        [
            -2431607348.707261,
            -3696561347.041687,
            -393141735.2669349,
        ],
    ],
    [
        730339200000,
        [
            -2419504690.512867,
            -3684153176.107163,
            -388362996.4269372,
        ],
    ],
    [
        730944000000,
        [
            -2409389384.491455,
            -3670832356.023924,
            -383190828.549105,
        ],
    ],
    [
        731548800000,
        [
            -2401356670.492881,
            -3656842326.685067,
            -377729886.8372898,
        ],
    ],
    [
        732153600000,
        [
            -2395459935.528447,
            -3642418050.42371,
            -372080484.3172867,
        ],
    ],
    [
        732758400000,
        [
            -2391740757.358721,
            -3627791050.737806,
            -366343583.2113347,
        ],
    ],
    [
        733363200000,
        [
            -2390210604.786184,
            -3613211474.995858,
            -360628145.0908224,
        ],
    ],
    [
        733968000000,
        [
            -2390831544.696001,
            -3598929867.727641,
            -355041806.5435266,
        ],
    ],
    [
        734572800000,
        [
            -2393528631.747372,
            -3585172197.51501,
            -349681727.2648712,
        ],
    ],
    [
        735177600000,
        [
            -2398219776.352087,
            -3572149965.17758,
            -344641189.7333379,
        ],
    ],
    [
        735782400000,
        [
            -2404795675.078409,
            -3560080673.060309,
            -340015595.0898913,
        ],
    ],
    [
        736387200000,
        [
            -2413104397.529585,
            -3549167906.965971,
            -335892496.9070487,
        ],
    ],
    [
        736992000000,
        [
            -2422968991.280926,
            -3539579010.10125,
            -332343838.8589446,
        ],
    ],
    [
        737596800000,
        [
            -2434214875.083594,
            -3531460410.685143,
            -329434350.2981876,
        ],
    ],
    [
        738201600000,
        [
            -2446647477.35151,
            -3524955619.503175,
            -327226392.5472529,
        ],
    ],
    [
        738806400000,
        [
            -2460039745.856896,
            -3520184379.352996,
            -325770207.8806903,
        ],
    ],
    [
        739411200000,
        [
            -2474154018.591224,
            -3517223519.316168,
            -325098171.4636304,
        ],
    ],
    [
        740016000000,
        [
            -2488765732.013958,
            -3516127659.964958,
            -325235175.6902751,
        ],
    ],
    [
        740620800000,
        [
            -2503639277.941384,
            -3516944149.490947,
            -326202092.6660517,
        ],
    ],
    [
        741225600000,
        [
            -2518518515.401179,
            -3519691989.373436,
            -328006132.4851918,
        ],
    ],
    [
        741830400000,
        [
            -2533152192.014765,
            -3524346106.762845,
            -330636572.7623717,
        ],
    ],
    [
        742435200000,
        [
            -2547313010.009484,
            -3530862783.368344,
            -334076300.4732708,
        ],
    ],
    [
        743040000000,
        [
            -2560771903.177332,
            -3539190478.87704,
            -338303318.0018363,
        ],
    ],
    [
        743644800000,
        [
            -2573291317.027069,
            -3549248505.058372,
            -343281288.943186,
        ],
    ],
    [
        744249600000,
        [
            -2584652941.303583,
            -3560914622.219133,
            -348956954.7200261,
        ],
    ],
    [
        744854400000,
        [
            -2594671360.198827,
            -3574054349.682932,
            -355272960.123842,
        ],
    ],
    [
        745459200000,
        [
            -2603167272.673038,
            -3588527490.719486,
            -362167949.7965329,
        ],
    ],
    [
        746064000000,
        [
            -2609963995.957368,
            -3604167255.797877,
            -369567963.0032022,
        ],
    ],
    [
        746668800000,
        [
            -2614916895.593391,
            -3620771986.850114,
            -377385787.35131,
        ],
    ],
    [
        747273600000,
        [
            -2617921598.517539,
            -3638137895.89889,
            -385534544.3752474,
        ],
    ],
    [
        747878400000,
        [
            -2618886749.590391,
            -3656061705.917587,
            -393926118.2990701,
        ],
    ],
    [
        748483200000,
        [
            -2617733767.617426,
            -3674320638.143159,
            -402463070.6535655,
        ],
    ],
    [
        749088000000,
        [
            -2614426554.826604,
            -3692668532.571245,
            -411039589.3184857,
        ],
    ],
    [
        749692800000,
        [
            -2608973395.273685,
            -3710870575.589395,
            -419555152.8965039,
        ],
    ],
    [
        750297600000,
        [
            -2601398767.767993,
            -3728702051.796956,
            -427911575.5798285,
        ],
    ],
    [
        750902400000,
        [
            -2591745529.573644,
            -3745929080.277954,
            -436005873.5350039,
        ],
    ],
    [
        751507200000,
        [
            -2580103342.61817,
            -3762309323.904881,
            -443733362.4609874,
        ],
    ],
    [
        752112000000,
        [
            -2566603734.312458,
            -3777627252.805459,
            -451001266.8481511,
        ],
    ],
    [
        752716800000,
        [
            -2551391054.089952,
            -3791689367.154956,
            -457724700.8443751,
        ],
    ],
    [
        753321600000,
        [
            -2534626726.595154,
            -3804305541.619323,
            -463820211.8508369,
        ],
    ],
    [
        753926400000,
        [
            -2516515545.767305,
            -3815294210.374918,
            -469210444.1325191,
        ],
    ],
    [
        754531200000,
        [
            -2497293719.146493,
            -3824515947.662471,
            -473836297.0041409,
        ],
    ],
    [
        755136000000,
        [
            -2477199228.677079,
            -3831864421.082973,
            -477651087.420055,
        ],
    ],
    [
        755740800000,
        [
            -2456477508.231316,
            -3837246927.494346,
            -480613880.9583355,
        ],
    ],
    [
        756345600000,
        [
            -2435404940.925806,
            -3840592716.167476,
            -482695157.9900479,
        ],
    ],
    [
        756950400000,
        [
            -2414270120.855501,
            -3841882119.220608,
            -483886836.4441448,
        ],
    ],
    [
        757555200000,
        [
            -2393345014.037239,
            -3841132283.544457,
            -484194817.1251666,
        ],
    ],
    [
        758160000000,
        [
            -2372892703.871274,
            -3838376072.920421,
            -483632155.1744414,
        ],
    ],
    [
        758764800000,
        [
            -2353189251.323632,
            -3833672937.809342,
            -482225653.6002353,
        ],
    ],
    [
        759369600000,
        [
            -2334500298.627637,
            -3827132407.086665,
            -480023278.0233603,
        ],
    ],
    [
        759974400000,
        [
            -2317056084.422765,
            -3818894832.501639,
            -477084932.6641041,
        ],
    ],
    [
        760579200000,
        [
            -2301062862.224935,
            -3809109112.7306,
            -473475059.0247886,
        ],
    ],
    [
        761184000000,
        [
            -2286724472.705839,
            -3797945998.569921,
            -469269503.9183397,
        ],
    ],
    [
        761788800000,
        [
            -2274216174.446825,
            -3785615753.931304,
            -464559976.6524954,
        ],
    ],
    [
        762393600000,
        [
            -2263665515.979398,
            -3772344713.236605,
            -459443445.8551725,
        ],
    ],
    [
        762998400000,
        [
            -2255168038.726167,
            -3758353163.511484,
            -454014976.26897,
        ],
    ],
    [
        763603200000,
        [
            -2248808701.261905,
            -3743871551.310761,
            -448375525.7678254,
        ],
    ],
    [
        764208000000,
        [
            -2244634209.104948,
            -3729153531.501192,
            -442634579.7031412,
        ],
    ],
    [
        764812800000,
        [
            -2242640725.741203,
            -3714450405.039533,
            -436899464.1955211,
        ],
    ],
    [
        765417600000,
        [
            -2242794133.967456,
            -3699991660.173381,
            -431269553.0241895,
        ],
    ],
    [
        766022400000,
        [
            -2245050775.21385,
            -3686005053.595242,
            -425845177.5294365,
        ],
    ],
    [
        766627200000,
        [
            -2249329015.31033,
            -3672726469.927606,
            -420728661.1309322,
        ],
    ],
    [
        767232000000,
        [
            -2255503252.277832,
            -3660373820.331686,
            -416013644.3396845,
        ],
    ],
    [
        767836800000,
        [
            -2263427754.401111,
            -3649131625.061092,
            -411780770.9505131,
        ],
    ],
    [
        768441600000,
        [
            -2272954699.789766,
            -3639174596.171621,
            -408107402.6435131,
        ],
    ],
    [
        769046400000,
        [
            -2283904680.231262,
            -3630674318.549628,
            -405067334.7618086,
        ],
    ],
    [
        769651200000,
        [
            -2296065399.252662,
            -3623773147.722668,
            -402720722.6883468,
        ],
    ],
    [
        770256000000,
        [
            -2309217907.57404,
            -3618573418.375674,
            -401111983.4294134,
        ],
    ],
    [
        770860800000,
        [
            -2323150373.151599,
            -3615164058.844147,
            -400280595.0664635,
        ],
    ],
    [
        771465600000,
        [
            -2337628209.566376,
            -3613624099.965243,
            -400259880.0814667,
        ],
    ],
    [
        772070400000,
        [
            -2352396808.714896,
            -3613997334.091043,
            -401067677.7083563,
        ],
    ],
    [
        772675200000,
        [
            -2367209790.046477,
            -3616286581.515021,
            -402706190.0859939,
        ],
    ],
    [
        773280000000,
        [
            -2381837597.702997,
            -3620482687.254345,
            -405173038.8902797,
        ],
    ],
    [
        773884800000,
        [
            -2396038088.933737,
            -3626564290.010388,
            -408458530.213454,
        ],
    ],
    [
        774489600000,
        [
            -2409562443.846367,
            -3634473341.515451,
            -412536744.721561,
        ],
    ],
    [
        775094400000,
        [
            -2422184448.382,
            -3644114009.864073,
            -417367095.9780359,
        ],
    ],
    [
        775699200000,
        [
            -2433702877.158751,
            -3655383008.537493,
            -422905518.5743161,
        ],
    ],
    [
        776304000000,
        [
            -2443913260.082056,
            -3668165204.982224,
            -429100689.3554728,
        ],
    ],
    [
        776908800000,
        [
            -2452616546.006955,
            -3682310629.039207,
            -435886280.5189461,
        ],
    ],
    [
        777513600000,
        [
            -2459648881.60463,
            -3697638212.05287,
            -443184596.375686,
        ],
    ],
    [
        778118400000,
        [
            -2464877772.06785,
            -3713967214.771286,
            -450917858.043301,
        ],
    ],
    [
        778723200000,
        [
            -2468176139.612043,
            -3731109171.877981,
            -459003399.2448438,
        ],
    ],
    [
        779328000000,
        [
            -2469433624.888221,
            -3748847356.21258,
            -467346960.0577185,
        ],
    ],
    [
        779932800000,
        [
            -2468585862.059399,
            -3766945261.812437,
            -475847768.6307043,
        ],
    ],
    [
        780537600000,
        [
            -2465604016.095208,
            -3785178290.128914,
            -484409215.4527642,
        ],
    ],
    [
        781142400000,
        [
            -2460470920.801279,
            -3803322026.107869,
            -492932925.4434027,
        ],
    ],
    [
        781747200000,
        [
            -2453193958.624326,
            -3821134370.30147,
            -501313343.2911385,
        ],
    ],
    [
        782352000000,
        [
            -2443831986.06759,
            -3838368130.7811,
            -509444415.937045,
        ],
    ],
    [
        782956800000,
        [
            -2432477920.312251,
            -3854801907.510953,
            -517229855.5384088,
        ],
    ],
    [
        783561600000,
        [
            -2419236586.910727,
            -3870225015.666279,
            -524576640.6288412,
        ],
    ],
    [
        784166400000,
        [
            -2404238693.354137,
            -3884422577.645232,
            -531391139.2799803,
        ],
    ],
    [
        784771200000,
        [
            -2387664221.890875,
            -3897191731.159581,
            -537586996.5883405,
        ],
    ],
    [
        785376000000,
        [
            -2369718615.836214,
            -3908370300.808898,
            -543094118.2898268,
        ],
    ],
    [
        785980800000,
        [
            -2350612052.112257,
            -3917818116.996605,
            -547850879.3259653,
        ],
    ],
    [
        786585600000,
        [
            -2330574057.240368,
            -3925404059.721552,
            -551800799.0892425,
        ],
    ],
    [
        787190400000,
        [
            -2309872163.54457,
            -3931024294.263324,
            -554900630.6335114,
        ],
    ],
    [
        787795200000,
        [
            -2288782389.724977,
            -3934626072.18279,
            -557127192.243539,
        ],
    ],
    [
        788400000000,
        [
            -2267569988.295137,
            -3936184530.847641,
            -558468195.8608423,
        ],
    ],
    [
        789004800000,
        [
            -2246505029.405516,
            -3935690265.654807,
            -558919338.3467791,
        ],
    ],
    [
        789609600000,
        [
            -2225876650.477397,
            -3933168558.319374,
            -558492574.647482,
        ],
    ],
    [
        790214400000,
        [
            -2205960265.402793,
            -3928696566.751498,
            -557220534.5243502,
        ],
    ],
    [
        790819200000,
        [
            -2187001895.343222,
            -3922376021.214983,
            -555146100.7800276,
        ],
    ],
    [
        791424000000,
        [
            -2169236476.84008,
            -3914321051.321869,
            -552319427.0996115,
        ],
    ],
    [
        792028800000,
        [
            -2152899267.320626,
            -3904678443.070499,
            -548805834.142642,
        ],
    ],
    [
        792633600000,
        [
            -2138192443.747609,
            -3893637520.978038,
            -544687103.9146268,
        ],
    ],
    [
        793238400000,
        [
            -2125275044.020439,
            -3881399907.13589,
            -540049921.7413778,
        ],
    ],
    [
        793843200000,
        [
            -2114284731.09331,
            -3868167950.474429,
            -534982862.4297453,
        ],
    ],
    [
        794448000000,
        [
            -2105347012.390656,
            -3854166468.894081,
            -529584352.6175187,
        ],
    ],
    [
        795052800000,
        [
            -2098542677.5372,
            -3839645872.169454,
            -523961643.9384479,
        ],
    ],
    [
        795657600000,
        [
            -2093904523.5281,
            -3824851270.593245,
            -518219611.2138931,
        ],
    ],
    [
        796262400000,
        [
            -2091442531.831321,
            -3810013253.129337,
            -512458840.067665,
        ],
    ],
    [
        796867200000,
        [
            -2091151209.217995,
            -3795372326.59908,
            -506784366.5858448,
        ],
    ],
    [
        797472000000,
        [
            -2092978711.679905,
            -3781176972.314456,
            -501302911.5292921,
        ],
    ],
    [
        798076800000,
        [
            -2096830540.577284,
            -3767654425.609279,
            -496112514.3414639,
        ],
    ],
    [
        798681600000,
        [
            -2102597014.818589,
            -3755005281.595402,
            -491301762.7714312,
        ],
    ],
    [
        799286400000,
        [
            -2110157793.754784,
            -3743430521.944805,
            -486958918.9266567,
        ],
    ],
    [
        799891200000,
        [
            -2119352143.802747,
            -3733125159.195835,
            -483167523.1193876,
        ],
    ],
    [
        800496000000,
        [
            -2129988184.607399,
            -3724251399.812401,
            -479997209.0127744,
        ],
    ],
    [
        801100800000,
        [
            -2141870767.530534,
            -3716937540.720692,
            -477504609.4806663,
        ],
    ],
    [
        801705600000,
        [
            -2154801990.504761,
            -3711306613.306797,
            -475743133.8305044,
        ],
    ],
    [
        802310400000,
        [
            -2168552551.627927,
            -3707466180.561723,
            -474757711.2528319,
        ],
    ],
    [
        802915200000,
        [
            -2182875662.92599,
            -3705484452.035189,
            -474577209.2053183,
        ],
    ],
    [
        803520000000,
        [
            -2197534581.727501,
            -3705394100.096626,
            -475217148.3695762,
        ],
    ],
    [
        804124800000,
        [
            -2212298830.17672,
            -3707221597.159108,
            -476689495.1134878,
        ],
    ],
    [
        804729600000,
        [
            -2226917356.286114,
            -3710973591.368537,
            -478996245.545116,
        ],
    ],
    [
        805334400000,
        [
            -2241136214.559017,
            -3716615893.167767,
            -482122812.1027973,
        ],
    ],
    [
        805939200000,
        [
            -2254724856.463444,
            -3724082007.947589,
            -486042067.7328686,
        ],
    ],
    [
        806544000000,
        [
            -2267467339.988846,
            -3733301627.738879,
            -490723560.7225716,
        ],
    ],
    [
        807148800000,
        [
            -2279137785.299009,
            -3744183637.905146,
            -496126305.7688191,
        ],
    ],
    [
        807753600000,
        [
            -2289520735.925997,
            -3756597843.278541,
            -502193524.2726932,
        ],
    ],
    [
        808358400000,
        [
            -2298435641.38326,
            -3770388244.086291,
            -508858529.4911866,
        ],
    ],
    [
        808963200000,
        [
            -2305723009.119584,
            -3785400023.379754,
            -516053528.2570515,
        ],
    ],
    [
        809568000000,
        [
            -2311223394.840617,
            -3801460197.802076,
            -523702148.5334314,
        ],
    ],
    [
        810172800000,
        [
            -2314799947.071162,
            -3818362735.570664,
            -531715522.0050704,
        ],
    ],
    [
        810777600000,
        [
            -2316360793.307814,
            -3835886724.785639,
            -539999593.3082906,
        ],
    ],
    [
        811382400000,
        [
            -2315839996.906454,
            -3853821249.64248,
            -548462772.4859264,
        ],
    ],
    [
        811987200000,
        [
            -2313180461.815551,
            -3871944262.600895,
            -557007982.0647615,
        ],
    ],
    [
        812592000000,
        [
            -2308357179.387888,
            -3890011120.996862,
            -565529884.7625933,
        ],
    ],
    [
        813196800000,
        [
            -2301396203.186799,
            -3907776813.831257,
            -573923467.7966979,
        ],
    ],
    [
        813801600000,
        [
            -2292349711.923587,
            -3925017787.390984,
            -582090663.8730615,
        ],
    ],
    [
        814406400000,
        [
            -2281282546.011258,
            -3941509425.795803,
            -589932561.1581043,
        ],
    ],
    [
        815011200000,
        [
            -2268294875.930714,
            -3957018232.398536,
            -597348265.5739886,
        ],
    ],
    [
        815616000000,
        [
            -2253536932.61873,
            -3971327286.742947,
            -604244690.5253023,
        ],
    ],
    [
        816220800000,
        [
            -2237178443.030906,
            -3984254370.30884,
            -610541856.3514256,
        ],
    ],
    [
        816825600000,
        [
            -2219398718.113347,
            -3995628150.963509,
            -616164821.4265971,
        ],
    ],
    [
        817430400000,
        [
            -2200407951.539466,
            -4005283608.478621,
            -621043370.8111753,
        ],
    ],
    [
        818035200000,
        [
            -2180456888.098801,
            -4013088766.696695,
            -625121733.4518272,
        ],
    ],
    [
        818640000000,
        [
            -2159801175.255438,
            -4018957340.484833,
            -628361625.64394,
        ],
    ],
    [
        819244800000,
        [
            -2138694542.001365,
            -4022822431.988192,
            -630733331.9009011,
        ],
    ],
    [
        819849600000,
        [
            -2117408406.518128,
            -4024633837.20356,
            -632215891.4327414,
        ],
    ],
    [
        820454400000,
        [
            -2096236354.371753,
            -4024383906.727946,
            -632806372.7715571,
        ],
    ],
    [
        821059200000,
        [
            -2075455603.58876,
            -4022113319.314262,
            -632520709.3196685,
        ],
    ],
    [
        821664000000,
        [
            -2055324318.354188,
            -4017881979.592211,
            -631384048.550866,
        ],
    ],
    [
        822268800000,
        [
            -2036101223.973207,
            -4011767813.134058,
            -629431256.5414405,
        ],
    ],
    [
        822873600000,
        [
            -2018046367.752909,
            -4003891088.326289,
            -626715181.599405,
        ],
    ],
    [
        823478400000,
        [
            -2001383213.178019,
            -3994413054.189133,
            -623304764.6202404,
        ],
    ],
    [
        824083200000,
        [
            -1986301551.46254,
            -3983504790.524355,
            -619274359.1112868,
        ],
    ],
    [
        824688000000,
        [
            -1972978641.437652,
            -3971347521.022521,
            -614704175.1592115,
        ],
    ],
    [
        825292800000,
        [
            -1961577015.88348,
            -3958155478.102957,
            -609687478.3220812,
        ],
    ],
    [
        825897600000,
        [
            -1952209565.338858,
            -3944167830.840479,
            -604326429.2253207,
        ],
    ],
    [
        826502400000,
        [
            -1944948508.310538,
            -3929617372.298364,
            -598721565.5186735,
        ],
    ],
    [
        827107200000,
        [
            -1939848577.009632,
            -3914733325.373212,
            -592973195.173778,
        ],
    ],
    [
        827712000000,
        [
            -1936942167.473108,
            -3899764092.107647,
            -587188597.2291958,
        ],
    ],
    [
        828316800000,
        [
            -1936208967.916942,
            -3884964160.44451,
            -581476508.0978183,
        ],
    ],
    [
        828921600000,
        [
            -1937590991.958995,
            -3870565479.961331,
            -575937717.7514524,
        ],
    ],
    [
        829526400000,
        [
            -1941017409.940504,
            -3856783964.033707,
            -570667558.118051,
        ],
    ],
    [
        830131200000,
        [
            -1946396598.917526,
            -3843842948.822985,
            -565763002.6403604,
        ],
    ],
    [
        830736000000,
        [
            -1953590233.613284,
            -3831956001.146455,
            -561315719.3387743,
        ],
    ],
    [
        831340800000,
        [
            -1962432933.736134,
            -3821302426.714546,
            -557404028.2260178,
        ],
    ],
    [
        831945600000,
        [
            -1972756842.284598,
            -3812037366.673851,
            -554096561.5135919,
        ],
    ],
    [
        832550400000,
        [
            -1984379519.194958,
            -3804315416.161914,
            -551459530.2180259,
        ],
    ],
    [
        833155200000,
        [
            -1997081859.226923,
            -3798269729.364831,
            -549549033.7259468,
        ],
    ],
    [
        833760000000,
        [
            -2010631111.087289,
            -3793992498.999294,
            -548405131.0515895,
        ],
    ],
    [
        834364800000,
        [
            -2024803985.139541,
            -3791548702.437985,
            -548056992.8804878,
        ],
    ],
    [
        834969600000,
        [
            -2039370602.26297,
            -3790999332.183544,
            -548530222.7648606,
        ],
    ],
    [
        835574400000,
        [
            -2054076461.53693,
            -3792377520.202876,
            -549838370.3595641,
        ],
    ],
    [
        836179200000,
        [
            -2068668155.542935,
            -3795674278.167614,
            -551978647.6521896,
        ],
    ],
    [
        836784000000,
        [
            -2082914014.257908,
            -3800855554.036777,
            -554937875.4533162,
        ],
    ],
    [
        837388800000,
        [
            -2096584289.773298,
            -3807883763.152591,
            -558699061.8941566,
        ],
    ],
    [
        837993600000,
        [
            -2109436970.117485,
            -3816691192.792572,
            -563232118.6064755,
        ],
    ],
    [
        838598400000,
        [
            -2121245091.275049,
            -3827170488.762414,
            -568491233.7765558,
        ],
    ],
    [
        839203200000,
        [
            -2131813887.558119,
            -3839194626.348716,
            -574421923.5479473,
        ],
    ],
    [
        839808000000,
        [
            -2140957660.682124,
            -3852635812.787036,
            -580967106.6627662,
        ],
    ],
    [
        840412800000,
        [
            -2148489790.314735,
            -3867337368.013964,
            -588057860.6261425,
        ],
    ],
    [
        841017600000,
        [
            -2154251239.669882,
            -3883109108.230139,
            -595612647.3599155,
        ],
    ],
    [
        841622400000,
        [
            -2158123971.896946,
            -3899750577.683897,
            -603545428.9756818,
        ],
    ],
    [
        842227200000,
        [
            -2160005215.50899,
            -3917066896.460621,
            -611770672.6925224,
        ],
    ],
    [
        842832000000,
        [
            -2159801843.271833,
            -3934840421.779839,
            -620194030.6570857,
        ],
    ],
    [
        843436800000,
        [
            -2157458978.104198,
            -3952830622.360915,
            -628712825.0226432,
        ],
    ],
    [
        844041600000,
        [
            -2152968634.816341,
            -3970800111.442003,
            -637224879.9935032,
        ],
    ],
    [
        844646400000,
        [
            -2146340962.750441,
            -3988526398.251431,
            -645632218.6777235,
        ],
    ],
    [
        845251200000,
        [
            -2137602299.340583,
            -4005774137.832767,
            -653832265.4291755,
        ],
    ],
    [
        845856000000,
        [
            -2126822305.506989,
            -4022298901.175985,
            -661719911.7881008,
        ],
    ],
    [
        846460800000,
        [
            -2114117060.927148,
            -4037875468.891254,
            -669197387.1896186,
        ],
    ],
    [
        847065600000,
        [
            -2099617274.700935,
            -4052304837.606018,
            -676176694.85779,
        ],
    ],
    [
        847670400000,
        [
            -2083469879.778308,
            -4065387902.336724,
            -682571465.9576671,
        ],
    ],
    [
        848275200000,
        [
            -2065862658.329221,
            -4076932495.784132,
            -688299970.5405694,
        ],
    ],
    [
        848880000000,
        [
            -2047021585.138509,
            -4086782595.341409,
            -693295003.984872,
        ],
    ],
    [
        849484800000,
        [
            -2027176152.527689,
            -4094819178.548512,
            -697503997.0344329,
        ],
    ],
    [
        850089600000,
        [
            -2006564120.850762,
            -4100934678.426538,
            -700880789.4193299,
        ],
    ],
    [
        850694400000,
        [
            -1985452538.983768,
            -4105041592.382634,
            -703388817.4601947,
        ],
    ],
    [
        851299200000,
        [
            -1964129479.140234,
            -4107100145.80804,
            -705010362.8963695,
        ],
    ],
    [
        851904000000,
        [
            -1942867533.213274,
            -4107111553.198904,
            -705744256.1547083,
        ],
    ],
    [
        852508800000,
        [
            -1921932360.722904,
            -4105092511.963334,
            -705597705.0042076,
        ],
    ],
    [
        853113600000,
        [
            -1901600844.527259,
            -4101084566.728274,
            -704589645.718956,
        ],
    ],
    [
        853718400000,
        [
            -1882149194.599705,
            -4095178844.304919,
            -702758909.4406788,
        ],
    ],
    [
        854323200000,
        [
            -1863817650.398494,
            -4087501893.783293,
            -700159328.0921118,
        ],
    ],
    [
        854928000000,
        [
            -1846824454.386122,
            -4078190375.932646,
            -696851162.9724088,
        ],
    ],
    [
        855532800000,
        [
            -1831382724.087172,
            -4067401249.245324,
            -692904101.488746,
        ],
    ],
    [
        856137600000,
        [
            -1817686593.628576,
            -4055332946.34086,
            -688403724.8309942,
        ],
    ],
    [
        856742400000,
        [
            -1805879661.705621,
            -4042204795.376943,
            -683444233.5793972,
        ],
    ],
    [
        857347200000,
        [
            -1796074781.980272,
            -4028232667.876546,
            -678119976.2537239,
        ],
    ],
    [
        857952000000,
        [
            -1788370439.923515,
            -4013640795.921905,
            -672528926.7538384,
        ],
    ],
    [
        858556800000,
        [
            -1782835507.216404,
            -3998680023.049867,
            -666778364.1001669,
        ],
    ],
    [
        859161600000,
        [
            -1779483321.044373,
            -3983603105.489324,
            -660976556.8800046,
        ],
    ],
    [
        859766400000,
        [
            -1778297007.069307,
            -3968643448.799123,
            -655225491.7090228,
        ],
    ],
    [
        860371200000,
        [
            -1779245772.191715,
            -3954030089.354423,
            -649625445.131149,
        ],
    ],
    [
        860976000000,
        [
            -1782268109.964023,
            -3940004144.771858,
            -644280054.5645128,
        ],
    ],
    [
        861580800000,
        [
            -1787252234.046426,
            -3926791900.771866,
            -639287131.6882449,
        ],
    ],
    [
        862185600000,
        [
            -1794065252.21882,
            -3914588101.14271,
            -634732658.6959801,
        ],
    ],
    [
        862790400000,
        [
            -1802568306.710144,
            -3903574177.386886,
            -630696306.3617967,
        ],
    ],
    [
        863395200000,
        [
            -1812596889.507553,
            -3893932700.806924,
            -627255949.1412666,
        ],
    ],
    [
        864000000000,
        [
            -1823947100.84849,
            -3885818856.83718,
            -624478136.110211,
        ],
    ],
    [
        864604800000,
        [
            -1836406544.98157,
            -3879348999.405099,
            -622414101.4820441,
        ],
    ],
    [
        865209600000,
        [
            -1849767330.866596,
            -3874621726.843409,
            -621106659.3735921,
        ],
    ],
    [
        865814400000,
        [
            -1863803215.844601,
            -3871730170.731265,
            -620594498.7006032,
        ],
    ],
    [
        866419200000,
        [
            -1878261869.598396,
            -3870732629.430423,
            -620902597.3071661,
        ],
    ],
    [
        867024000000,
        [
            -1892896398.210673,
            -3871647036.260436,
            -622040166.8374307,
        ],
    ],
    [
        867628800000,
        [
            -1907475782.120147,
            -3874474276.324432,
            -624008219.0275956,
        ],
    ],
    [
        868233600000,
        [
            -1921759206.266198,
            -3879207741.012311,
            -626802906.4490247,
        ],
    ],
    [
        868838400000,
        [
            -1935494072.831915,
            -3885803296.802805,
            -630405501.3072462,
        ],
    ],
    [
        869443200000,
        [
            -1948446808.76639,
            -3894179307.54765,
            -634782011.2249432,
        ],
    ],
    [
        870048000000,
        [
            -1960409832.570188,
            -3904241094.359915,
            -639891226.8853467,
        ],
    ],
    [
        870652800000,
        [
            -1971173552.437916,
            -3915887154.250974,
            -645687337.13462,
        ],
    ],
    [
        871257600000,
        [
            -1980529785.446918,
            -3928979089.039069,
            -652110213.2561679,
        ],
    ],
    [
        871862400000,
        [
            -1988301247.339938,
            -3943347220.064792,
            -659087175.4486579,
        ],
    ],
    [
        872467200000,
        [
            -1994344837.617529,
            -3958816046.359062,
            -666541678.7709333,
        ],
    ],
    [
        873072000000,
        [
            -1998522603.286715,
            -3975207408.371083,
            -674395133.3254588,
        ],
    ],
    [
        873676800000,
        [
            -2000710347.491797,
            -3992311596.405048,
            -682557488.5835445,
        ],
    ],
    [
        874281600000,
        [
            -2000825291.999851,
            -4009898365.638725,
            -690930585.3124301,
        ],
    ],
    [
        874886400000,
        [
            -1998824886.189797,
            -4027742934.620176,
            -699416883.2224432,
        ],
    ],
    [
        875491200000,
        [
            -1994677070.301798,
            -4045625708.938529,
            -707920062.4630325,
        ],
    ],
    [
        876096000000,
        [
            -1988372651.084997,
            -4063305185.19296,
            -716336141.340645,
        ],
    ],
    [
        876700800000,
        [
            -1979949904.266264,
            -4080533438.876908,
            -724558489.2266135,
        ],
    ],
    [
        877305600000,
        [
            -1969487743.558892,
            -4097082043.374716,
            -732486943.8975879,
        ],
    ],
    [
        877910400000,
        [
            -1957075515.444003,
            -4112737970.386596,
            -740027523.7744443,
        ],
    ],
    [
        878515200000,
        [
            -1942828079.181002,
            -4127279245.696089,
            -747084618.1875769,
        ],
    ],
    [
        879120000000,
        [
            -1926906773.112584,
            -4140494052.504318,
            -753567351.3014629,
        ],
    ],
    [
        879724800000,
        [
            -1909506595.532344,
            -4152205888.860112,
            -759398522.5326887,
        ],
    ],
    [
        880329600000,
        [
            -1890826010.088119,
            -4162264680.202169,
            -764512500.9303764,
        ],
    ],
    [
        880934400000,
        [
            -1871083797.395029,
            -4170525198.260848,
            -768847809.8836385,
        ],
    ],
    [
        881539200000,
        [
            -1850535614.805269,
            -4176867660.331409,
            -772353654.6575388,
        ],
    ],
    [
        882144000000,
        [
            -1829455071.791423,
            -4181220184.952953,
            -774997855.5214467,
        ],
    ],
    [
        882748800000,
        [
            -1808104073.47727,
            -4183543278.649319,
            -776762410.6892166,
        ],
    ],
    [
        883353600000,
        [
            -1786751206.110788,
            -4183810401.42613,
            -777636602.3965608,
        ],
    ],
    [
        883958400000,
        [
            -1765684149.275891,
            -4182028158.40706,
            -777623469.1333722,
        ],
    ],
    [
        884563200000,
        [
            -1745186508.265282,
            -4178254789.851439,
            -776746611.7302524,
        ],
    ],
    [
        885168000000,
        [
            -1725510997.960459,
            -4172577619.853508,
            -775043321.9977808,
        ],
    ],
    [
        885772800000,
        [
            -1706900929.64164,
            -4165096043.476851,
            -772558074.1221138,
        ],
    ],
    [
        886377600000,
        [
            -1689599994.415163,
            -4155940690.359937,
            -769348273.4124069,
        ],
    ],
    [
        886982400000,
        [
            -1673827570.388078,
            -4145287531.93038,
            -765489217.4315615,
        ],
    ],
    [
        887587200000,
        [
            -1659756959.087474,
            -4133329024.144233,
            -761064576.5443709,
        ],
    ],
    [
        888192000000,
        [
            -1647540919.162358,
            -4120259954.593752,
            -756160303.9718281,
        ],
    ],
    [
        888796800000,
        [
            -1637319473.833037,
            -4106295758.6846,
            -750869968.1668148,
        ],
    ],
    [
        889401600000,
        [
            -1629195263.616017,
            -4091682589.08227,
            -745298464.5757351,
        ],
    ],
    [
        890006400000,
        [
            -1623218100.593936,
            -4076664407.785509,
            -739551215.174963,
        ],
    ],
    [
        890611200000,
        [
            -1619414712.27024,
            -4061473130.173938,
            -733729653.2023493,
        ],
    ],
    [
        891216000000,
        [
            -1617794966.198629,
            -4046347663.009756,
            -727937136.2968851,
        ],
    ],
    [
        891820800000,
        [
            -1618328102.885276,
            -4031541173.253954,
            -722281921.439822,
        ],
    ],
    [
        892425600000,
        [
            -1620934212.538248,
            -4017287027.947003,
            -716865769.9096429,
        ],
    ],
    [
        893030400000,
        [
            -1625517172.478358,
            -4003794380.061378,
            -711781027.2065758,
        ],
    ],
    [
        893635200000,
        [
            -1631968637.947786,
            -3991268725.212829,
            -707117015.0485163,
        ],
    ],
    [
        894240000000,
        [
            -1640144316.740477,
            -3979916364.32037,
            -702962038.2141194,
        ],
    ],
    [
        894844800000,
        [
            -1649861563.79821,
            -3969910678.390636,
            -699391870.1624713,
        ],
    ],
    [
        895449600000,
        [
            -1660933196.418727,
            -3961393090.378948,
            -696468764.1377561,
        ],
    ],
    [
        896054400000,
        [
            -1673168273.298173,
            -3954494990.807774,
            -694248827.7149199,
        ],
    ],
    [
        896659200000,
        [
            -1686347670.257169,
            -3949339043.686439,
            -692783501.9742991,
        ],
    ],
    [
        897264000000,
        [
            -1700227575.641263,
            -3946007082.343726,
            -692108713.9593415,
        ],
    ],
    [
        897868800000,
        [
            -1714572690.315257,
            -3944546548.42352,
            -692245960.9932703,
        ],
    ],
    [
        898473600000,
        [
            -1729153918.109259,
            -3944993612.878789,
            -693210366.9283104,
        ],
    ],
    [
        899078400000,
        [
            -1743723386.958284,
            -3947371016.405233,
            -695011030.3023137,
        ],
    ],
    [
        899683200000,
        [
            -1758023786.593214,
            -3951658255.762494,
            -697640496.9100227,
        ],
    ],
    [
        900288000000,
        [
            -1771819370.377657,
            -3957802872.413549,
            -701077296.239623,
        ],
    ],
    [
        900892800000,
        [
            -1784890341.652163,
            -3965743745.925505,
            -705294129.8007033,
        ],
    ],
    [
        901497600000,
        [
            -1797007274.274034,
            -3975404863.04116,
            -710256994.441043,
        ],
    ],
    [
        902102400000,
        [
            -1807945802.235783,
            -3986668126.819199,
            -715915506.5163169,
        ],
    ],
    [
        902707200000,
        [
            -1817514171.601147,
            -3999389046.224555,
            -722207339.2766823,
        ],
    ],
    [
        903312000000,
        [
            -1825544579.658849,
            -4013419770.768871,
            -729066838.0071241,
        ],
    ],
    [
        903916800000,
        [
            -1831867862.499895,
            -4028599354.915545,
            -736423279.2282548,
        ],
    ],
    [
        904521600000,
        [
            -1836333472.912653,
            -4044730207.403958,
            -744192307.5893087,
        ],
    ],
    [
        905126400000,
        [
            -1838833036.949094,
            -4061598166.144047,
            -752281963.7136011,
        ],
    ],
    [
        905731200000,
        [
            -1839288748.723128,
            -4078994886.200245,
            -760601062.5788109,
        ],
    ],
    [
        906336000000,
        [
            -1837628758.400954,
            -4096705061.322342,
            -769056174.9841218,
        ],
    ],
    [
        906940800000,
        [
            -1833811167.712641,
            -4114486763.926171,
            -777543987.7328485,
        ],
    ],
    [
        907545600000,
        [
            -1827842338.417181,
            -4132095092.874463,
            -785958731.6053499,
        ],
    ],
    [
        908150400000,
        [
            -1819761418.331891,
            -4149302950.252465,
            -794200338.9935361,
        ],
    ],
    [
        908755200000,
        [
            -1809616397.077148,
            -4165885515.300744,
            -802170675.307738,
        ],
    ],
    [
        909360000000,
        [
            -1797490530.03957,
            -4181604705.571208,
            -809767403.8328811,
        ],
    ],
    [
        909964800000,
        [
            -1783514855.108821,
            -4196235755.717727,
            -816892940.3346665,
        ],
    ],
    [
        910569600000,
        [
            -1767848460.405365,
            -4209585683.62282,
            -823462168.7751167,
        ],
    ],
    [
        911174400000,
        [
            -1750655817.13926,
            -4221475188.772528,
            -829397585.1459136,
        ],
    ],
    [
        911779200000,
        [
            -1732134238.12294,
            -4231727008.731221,
            -834624023.6376809,
        ],
    ],
    [
        912384000000,
        [
            -1712520445.946976,
            -4240193802.385684,
            -839077960.6982424,
        ],
    ],
    [
        912988800000,
        [
            -1692066145.934067,
            -4246772536.662501,
            -842713693.3973335,
        ],
    ],
    [
        913593600000,
        [
            -1671017121.971365,
            -4251382544.12978,
            -845496692.7293394,
        ],
    ],
    [
        914198400000,
        [
            -1649640344.864306,
            -4253956584.380831,
            -847398911.3637565,
        ],
    ],
    [
        914803200000,
        [
            -1628225096.120807,
            -4254467772.98745,
            -848407986.241519,
        ],
    ],
    [
        915408000000,
        [
            -1607054710.997559,
            -4252938406.048525,
            -848531790.4984803,
        ],
    ],
    [
        916012800000,
        [
            -1586389431.328819,
            -4249413435.092534,
            -847790031.4320539,
        ],
    ],
    [
        916617600000,
        [
            -1566493702.930255,
            -4243954104.42356,
            -846210272.037723,
        ],
    ],
    [
        917222400000,
        [
            -1547634054.314217,
            -4236662793.007741,
            -843836410.649149,
        ],
    ],
    [
        917827200000,
        [
            -1530049550.078651,
            -4227686163.299392,
            -840731072.4696975,
        ],
    ],
    [
        918432000000,
        [
            -1513940959.006078,
            -4217184302.553713,
            -836964933.6644973,
        ],
    ],
    [
        919036800000,
        [
            -1499499075.676601,
            -4205327395.230807,
            -832613265.448305,
        ],
    ],
    [
        919641600000,
        [
            -1486900814.440683,
            -4192317907.767507,
            -827763306.3871439,
        ],
    ],
    [
        920246400000,
        [
            -1476280245.373202,
            -4178388699.091108,
            -822514803.3663745,
        ],
    ],
    [
        920851200000,
        [
            -1467725306.409202,
            -4163769148.493267,
            -816967938.4950755,
        ],
    ],
    [
        921456000000,
        [
            -1461307332.33675,
            -4148686157.065313,
            -811221582.796279,
        ],
    ],
    [
        922060800000,
        [
            -1457075975.1213,
            -4133384482.871555,
            -805380510.9762423,
        ],
    ],
    [
        922665600000,
        [
            -1455032278.881793,
            -4118121685.820028,
            -799555106.6546371,
        ],
    ],
    [
        923270400000,
        [
            -1455133354.02936,
            -4103133930.933089,
            -793848900.6456074,
        ],
    ],
    [
        923875200000,
        [
            -1457322809.95785,
            -4088642851.759928,
            -788358936.5546747,
        ],
    ],
    [
        924480000000,
        [
            -1461524174.630162,
            -4074874951.108755,
            -783182783.9739475,
        ],
    ],
    [
        925084800000,
        [
            -1467616152.722904,
            -4062054355.654569,
            -778417267.9221468,
        ],
    ],
    [
        925689600000,
        [
            -1475443964.149245,
            -4050370057.760221,
            -774145925.6487584,
        ],
    ],
    [
        926294400000,
        [
            -1484848953.954875,
            -4039988517.485145,
            -770441485.9512196,
        ],
    ],
    [
        926899200000,
        [
            -1495659193.949168,
            -4031071989.441484,
            -767372953.2306178,
        ],
    ],
    [
        927504000000,
        [
            -1507666357.711445,
            -4023768969.912791,
            -765003800.4456278,
        ],
    ],
    [
        928108800000,
        [
            -1520642329.638779,
            -4018184246.895636,
            -763380386.7797066,
        ],
    ],
    [
        928713600000,
        [
            -1534366784.237362,
            -4014396818.097122,
            -762536840.381802,
        ],
    ],
    [
        929318400000,
        [
            -1548614798.128629,
            -4012477288.584955,
            -762502375.3671539,
        ],
    ],
    [
        929923200000,
        [
            -1563135689.552979,
            -4012475947.270681,
            -763298673.5564045,
        ],
    ],
    [
        930528000000,
        [
            -1577674254.210067,
            -4014396805.462402,
            -764929255.6650062,
        ],
    ],
    [
        931132800000,
        [
            -1591995387.737173,
            -4018219851.4082,
            -767385889.8360265,
        ],
    ],
    [
        931737600000,
        [
            -1605868673.934798,
            -4023917078.815893,
            -770655482.0868279,
        ],
    ],
    [
        932342400000,
        [
            -1619049147.007217,
            -4031437471.950376,
            -774716120.8264996,
        ],
    ],
    [
        932947200000,
        [
            -1631302122.9358,
            -4040685447.10644,
            -779527724.6151507,
        ],
    ],
    [
        933552000000,
        [
            -1642423669.377417,
            -4051546149.919437,
            -785039971.3656484,
        ],
    ],
    [
        934156800000,
        [
            -1652222397.404779,
            -4063899907.316226,
            -791199166.6680101,
        ],
    ],
    [
        934761600000,
        [
            -1660502562.304596,
            -4077604242.859738,
            -797943405.0049413,
        ],
    ],
    [
        935366400000,
        [
            -1667092192.043563,
            -4092477791.420083,
            -805195185.8768369,
        ],
    ],
    [
        935971200000,
        [
            -1671858972.684849,
            -4108328172.289881,
            -812870718.4405813,
        ],
    ],
    [
        936576000000,
        [
            -1674690011.209003,
            -4124965170.511257,
            -820886461.1919453,
        ],
    ],
    [
        937180800000,
        [
            -1675477646.892925,
            -4142180338.552479,
            -829153000.452554,
        ],
    ],
    [
        937785600000,
        [
            -1674150036.787834,
            -4159736922.871747,
            -837569363.9039272,
        ],
    ],
    [
        938390400000,
        [
            -1670681273.456327,
            -4177399289.117549,
            -846033103.8375078,
        ],
    ],
    [
        938995200000,
        [
            -1665068847.856468,
            -4194944307.050178,
            -854446267.4045784,
        ],
    ],
    [
        939600000000,
        [
            -1657321538.577181,
            -4212138813.102026,
            -862708325.015376,
        ],
    ],
    [
        940204800000,
        [
            -1647490938.142041,
            -4228735501.386274,
            -870712706.1355147,
        ],
    ],
    [
        940809600000,
        [
            -1635674765.67881,
            -4244502996.689726,
            -878357907.726891,
        ],
    ],
    [
        941414400000,
        [
            -1621992024.282232,
            -4259234982.68461,
            -885553041.1596773,
        ],
    ],
    [
        942019200000,
        [
            -1606572841.331823,
            -4272726264.403432,
            -892210063.4267633,
        ],
    ],
    [
        942624000000,
        [
            -1589589863.971996,
            -4284774272.444523,
            -898242151.9980752,
        ],
    ],
    [
        943228800000,
        [
            -1571254503.88078,
            -4295208632.885686,
            -903574895.2848706,
        ],
    ],
    [
        943833600000,
        [
            -1551789843.688911,
            -4303896619.117646,
            -908150258.2601845,
        ],
    ],
    [
        944438400000,
        [
            -1531422239.959037,
            -4310717451.1551,
            -911917468.2362002,
        ],
    ],
    [
        945043200000,
        [
            -1510411195.586383,
            -4315567534.576537,
            -914832371.8696012,
        ],
    ],
    [
        945648000000,
        [
            -1489038710.712556,
            -4318387477.204767,
            -916868023.7693247,
        ],
    ],
    [
        946252800000,
        [
            -1467580384.304992,
            -4319161870.977522,
            -918016654.9552921,
        ],
    ],
    [
        946857600000,
        [
            -1446299759.072034,
            -4317891370.473765,
            -918279496.3738333,
        ],
    ],
    [
        947462400000,
        [
            -1425476647.149022,
            -4314600257.968627,
            -917667083.5564862,
        ],
    ],
    [
        948067200000,
        [
            -1405391875.555835,
            -4309359962.237047,
            -916208974.3521266,
        ],
    ],
    [
        948672000000,
        [
            -1386298776.68632,
            -4302282581.167508,
            -913953287.8306553,
        ],
    ],
    [
        949276800000,
        [
            -1368422853.870709,
            -4293491260.739849,
            -910955195.0314019,
        ],
    ],
    [
        949881600000,
        [
            -1351989307.791264,
            -4283129682.84954,
            -907277629.7316159,
        ],
    ],
    [
        950486400000,
        [
            -1337205706.308566,
            -4271381805.841689,
            -902999480.4735358,
        ],
    ],
    [
        951091200000,
        [
            -1324235599.74431,
            -4258459434.337639,
            -898212523.346664,
        ],
    ],
    [
        951696000000,
        [
            -1313205199.51098,
            -4244571902.291193,
            -893008999.9698102,
        ],
    ],
    [
        952300800000,
        [
            -1304229921.44592,
            -4229937987.108284,
            -887483506.5762038,
        ],
    ],
    [
        952905600000,
        [
            -1297396486.425879,
            -4214802468.234635,
            -881740440.6393932,
        ],
    ],
    [
        953510400000,
        [
            -1292739761.060142,
            -4199419609.695735,
            -875889567.7359889,
        ],
    ],
    [
        954115200000,
        [
            -1290257351.007742,
            -4184024444.528986,
            -870033919.1809623,
        ],
    ],
    [
        954720000000,
        [
            -1289934741.087161,
            -4168848735.354669,
            -864273698.8761133,
        ],
    ],
    [
        955324800000,
        [
            -1291727544.230507,
            -4154135437.217485,
            -858713161.3330929,
        ],
    ],
    [
        955929600000,
        [
            -1295541873.600243,
            -4140120103.319926,
            -853455081.126802,
        ],
    ],
    [
        956534400000,
        [
            -1301256064.919337,
            -4127005480.93188,
            -848589135.9510067,
        ],
    ],
    [
        957139200000,
        [
            -1308742848.188589,
            -4114981890.094511,
            -844197718.4489752,
        ],
    ],
    [
        957744000000,
        [
            -1317850866.916213,
            -4104239361.338341,
            -840362095.5297062,
        ],
    ],
    [
        958348800000,
        [
            -1328387796.025626,
            -4094947658.706616,
            -837156260.5626763,
        ],
    ],
    [
        958953600000,
        [
            -1340147266.993281,
            -4087234956.085274,
            -834636626.7035878,
        ],
    ],
    [
        959558400000,
        [
            -1352926760.439645,
            -4081212280.78977,
            -832850195.4838221,
        ],
    ],
    [
        960163200000,
        [
            -1366507991.210023,
            -4076983172.015057,
            -831840330.9375583,
        ],
    ],
    [
        960768000000,
        [
            -1380642962.27729,
            -4074622992.459631,
            -831640354.3197377,
        ],
    ],
    [
        961372800000,
        [
            -1395084857.562365,
            -4074162534.468571,
            -832264785.7681658,
        ],
    ],
    [
        961977600000,
        [
            -1409601390.205056,
            -4075615904.106163,
            -833719184.5760907,
        ],
    ],
    [
        962582400000,
        [
            -1423954066.646534,
            -4078987414.399906,
            -836004817.4244853,
        ],
    ],
    [
        963187200000,
        [
            -1437887382.988056,
            -4084250070.26295,
            -839111410.9221522,
        ],
    ],
    [
        963792000000,
        [
            -1451162012.669682,
            -4091334127.192485,
            -843009855.8123351,
        ],
    ],
    [
        964396800000,
        [
            -1463563070.602718,
            -4100157010.686742,
            -847663265.4044386,
        ],
    ],
    [
        965001600000,
        [
            -1474878040.592203,
            -4110627094.41364,
            -853030724.0470306,
        ],
    ],
    [
        965606400000,
        [
            -1484889377.142919,
            -4122621336.343503,
            -859059643.0247751,
        ],
    ],
    [
        966211200000,
        [
            -1493408802.046059,
            -4135979335.439165,
            -865680778.9377668,
        ],
    ],
    [
        966816000000,
        [
            -1500280698.297824,
            -4150534607.087193,
            -872820534.6392109,
        ],
    ],
    [
        967420800000,
        [
            -1505359277.935068,
            -4166115923.131523,
            -880403947.1389289,
        ],
    ],
    [
        968025600000,
        [
            -1508505279.288529,
            -4182524714.096718,
            -888346466.0486295,
        ],
    ],
    [
        968630400000,
        [
            -1509620376.294444,
            -4199535303.426201,
            -896551152.3485864,
        ],
    ],
    [
        969235200000,
        [
            -1508645476.492888,
            -4216926515.725325,
            -904921332.1743044,
        ],
    ],
    [
        969840000000,
        [
            -1505536935.275673,
            -4234480753.60975,
            -913362492.9377055,
        ],
    ],
    [
        970444800000,
        [
            -1500266818.351408,
            -4251961165.771686,
            -921773387.9658369,
        ],
    ],
    [
        971049600000,
        [
            -1492855602.961746,
            -4269118007.213483,
            -930045767.9162091,
        ],
    ],
    [
        971654400000,
        [
            -1483364526.753789,
            -4285719197.99351,
            -938077366.3491651,
        ],
    ],
    [
        972259200000,
        [
            -1471870592.305893,
            -4301547288.779758,
            -945773239.518704,
        ],
    ],
    [
        972864000000,
        [
            -1458469870.164857,
            -4316376766.952798,
            -953036686.0656804,
        ],
    ],
    [
        973468800000,
        [
            -1443307376.288712,
            -4329986516.412783,
            -959771649.4196688,
        ],
    ],
    [
        974073600000,
        [
            -1426563303.19974,
            -4342188091.090743,
            -965895293.3685538,
        ],
    ],
    [
        974678400000,
        [
            -1408427125.352148,
            -4352820247.542768,
            -971338108.929833,
        ],
    ],
    [
        975283200000,
        [
            -1389103290.252545,
            -4361726105.277036,
            -976033967.4361559,
        ],
    ],
    [
        975888000000,
        [
            -1368837223.971414,
            -4368770193.508567,
            -979924175.5522501,
        ],
    ],
    [
        976492800000,
        [
            -1347895267.74289,
            -4373862200.027348,
            -982968495.9831979,
        ],
    ],
    [
        977097600000,
        [
            -1326538288.375566,
            -4376947463.297608,
            -985143429.3646377,
        ],
    ],
    [
        977702400000,
        [
            -1305029349.621153,
            -4377983137.271977,
            -986431506.584553,
        ],
    ],
    [
        978307200000,
        [
            -1283655865.504536,
            -4376957867.129767,
            -986826780.7282599,
        ],
    ],
    [
        978912000000,
        [
            -1262704745.407368,
            -4373909671.825811,
            -986344119.1154348,
        ],
    ],
    [
        979516800000,
        [
            -1242437707.846265,
            -4368911610.260982,
            -985015460.1655154,
        ],
    ],
    [
        980121600000,
        [
            -1223102430.074684,
            -4362047351.037763,
            -982878460.9837372,
        ],
    ],
    [
        980726400000,
        [
            -1204952360.12692,
            -4353432404.935036,
            -979982693.5571777,
        ],
    ],
    [
        981331200000,
        [
            -1188219697.623738,
            -4343226126.198662,
            -976396569.5396715,
        ],
    ],
    [
        981936000000,
        [
            -1173094709.850929,
            -4331612506.734677,
            -972200973.9155921,
        ],
    ],
    [
        982540800000,
        [
            -1159741720.354618,
            -4318776172.790374,
            -967477437.395558,
        ],
    ],
    [
        983145600000,
        [
            -1148317101.047782,
            -4304924584.576955,
            -962314984.8480477,
        ],
    ],
    [
        983750400000,
        [
            -1138941860.894438,
            -4290295056.099646,
            -956815322.8723617,
        ],
    ],
    [
        984355200000,
        [
            -1131686113.095168,
            -4275131811.075616,
            -951084809.0779151,
        ],
    ],
    [
        984960000000,
        [
            -1126590720.773789,
            -4259664656.75907,
            -945223626.9701982,
        ],
    ],
    [
        985564800000,
        [
            -1123683309.764412,
            -4244132919.374847,
            -939334128.0395144,
        ],
    ],
    [
        986169600000,
        [
            -1122951856.90982,
            -4228789428.599236,
            -933525073.1233857,
        ],
    ],
    [
        986774400000,
        [
            -1124334663.306911,
            -4213875903.672785,
            -927902511.906847,
        ],
    ],
    [
        987379200000,
        [
            -1127747541.269654,
            -4199606532.586845,
            -922560410.1017419,
        ],
    ],
    [
        987984000000,
        [
            -1133096532.382211,
            -4186193960.610174,
            -917590194.9469596,
        ],
    ],
    [
        988588800000,
        [
            -1140252472.576511,
            -4173850920.5332,
            -913083881.5475936,
        ],
    ],
    [
        989193600000,
        [
            -1149045242.744616,
            -4162764876.357128,
            -909124141.3499897,
        ],
    ],
    [
        989798400000,
        [
            -1159294853.980983,
            -4153087221.738497,
            -905776934.3367361,
        ],
    ],
    [
        990403200000,
        [
            -1170819048.112719,
            -4144960716.580488,
            -903102509.4361987,
        ],
    ],
    [
        991008000000,
        [
            -1183408614.829888,
            -4138518753.392943,
            -901157879.4496064,
        ],
    ],
    [
        991612800000,
        [
            -1196825142.720694,
            -4133860140.441053,
            -899986896.3284047,
        ],
    ],
    [
        992217600000,
        [
            -1210834876.389789,
            -4131044485.189449,
            -899615384.3600106,
        ],
    ],
    [
        992822400000,
        [
            -1225210755.467465,
            -4130120680.975731,
            -900063272.3093129,
        ],
    ],
    [
        993427200000,
        [
            -1239708986.649618,
            -4131123768.939997,
            -901345879.8504407,
        ],
    ],
    [
        994032000000,
        [
            -1254070089.832422,
            -4134050401.673178,
            -903463681.2031926,
        ],
    ],
    [
        994636800000,
        [
            -1268054149.250053,
            -4138860083.739084,
            -906399448.9526023,
        ],
    ],
    [
        995241600000,
        [
            -1281436909.220017,
            -4145503604.595176,
            -910130769.6851691,
        ],
    ],
    [
        995846400000,
        [
            -1293987522.842438,
            -4153916910.552601,
            -914629877.89511,
        ],
    ],
    [
        996451200000,
        [
            -1305472541.788092,
            -4163997409.66985,
            -919853526.8562319,
        ],
    ],
    [
        997056000000,
        [
            -1315691042.559314,
            -4175610643.294244,
            -925742666.7657385,
        ],
    ],
    [
        997660800000,
        [
            -1324465098.352516,
            -4188618133.796282,
            -932235575.4201016,
        ],
    ],
    [
        998265600000,
        [
            -1331619144.415039,
            -4202868665.245384,
            -939266633.9564434,
        ],
    ],
    [
        998870400000,
        [
            -1336987434.385225,
            -4218176408.708189,
            -946756659.6981922,
        ],
    ],
    [
        999475200000,
        [
            -1340448008.150777,
            -4234333145.071167,
            -954615021.3050977,
        ],
    ],
    [
        1000080000000,
        [
            -1341908199.474162,
            -4251135229.378152,
            -962752686.2586973,
        ],
    ],
    [
        1000684800000,
        [
            -1341285527.980538,
            -4268372639.954258,
            -971079507.7011635,
        ],
    ],
    [
        1001289600000,
        [
            -1338518377.870899,
            -4285809286.563517,
            -979494762.0704798,
        ],
    ],
    [
        1001894400000,
        [
            -1333596766.788952,
            -4303200169.145036,
            -987891524.2801651,
        ],
    ],
    [
        1002499200000,
        [
            -1326542695.71949,
            -4320316445.88038,
            -996169408.2796206,
        ],
    ],
    [
        1003104000000,
        [
            -1317391686.329374,
            -4336932382.766582,
            -1004230883.998923,
        ],
    ],
    [
        1003708800000,
        [
            -1306206125.149286,
            -4352808091.94246,
            -1011972638.932459,
        ],
    ],
    [
        1004313600000,
        [
            -1293101151.423203,
            -4367711240.064757,
            -1019292558.657253,
        ],
    ],
    [
        1004918400000,
        [
            -1278220265.248226,
            -4381439370.681787,
            -1026101848.127893,
        ],
    ],
    [
        1005523200000,
        [
            -1261717230.947081,
            -4393805061.574954,
            -1032320300.636867,
        ],
    ],
    [
        1006128000000,
        [
            -1243771769.815746,
            -4404620942.287279,
            -1037867969.020882,
        ],
    ],
    [
        1006732800000,
        [
            -1224609324.070328,
            -4413724814.38787,
            -1042673786.018226,
        ],
    ],
    [
        1007337600000,
        [
            -1204472288.648096,
            -4420997229.722383,
            -1046685645.42201,
        ],
    ],
    [
        1007942400000,
        [
            -1183601958.293717,
            -4426343909.882284,
            -1049864015.847742,
        ],
    ],
    [
        1008547200000,
        [
            -1162255893.178187,
            -4429681639.375696,
            -1052173509.124477,
        ],
    ],
    [
        1009152000000,
        [
            -1140721002.453997,
            -4430964841.779319,
            -1053592767.045956,
        ],
    ],
    [
        1009756800000,
        [
            -1119281605.564265,
            -4430196390.201797,
            -1054122047.53158,
        ],
    ],
    [
        1010361600000,
        [
            -1098202766.183281,
            -4427406723.384728,
            -1053775395.09286,
        ],
    ],
    [
        1010966400000,
        [
            -1077750137.440438,
            -4422640066.490176,
            -1052572239.655187,
        ],
    ],
    [
        1011571200000,
        [
            -1058198003.946079,
            -4415981490.897633,
            -1050548108.414386,
        ],
    ],
    [
        1012176000000,
        [
            -1039796858.495941,
            -4407560425.038868,
            -1047759006.513299,
        ],
    ],
    [
        1012780800000,
        [
            -1022760705.228766,
            -4397526786.905023,
            -1044271682.812921,
        ],
    ],
    [
        1013385600000,
        [
            -1007290383.562152,
            -4386037821.010509,
            -1040155001.686745,
        ],
    ],
    [
        1013990400000,
        [
            -993578129.2828593,
            -4373285016.444373,
            -1035490934.044246,
        ],
    ],
    [
        1014595200000,
        [
            -981776476.4043267,
            -4359490791.689153,
            -1030375841.625298,
        ],
    ],
    [
        1015200000000,
        [
            -971991150.7183168,
            -4344882601.729337,
            -1024909491.053991,
        ],
    ],
    [
        1015804800000,
        [
            -964307978.1430597,
            -4329681862.812389,
            -1019187453.969074,
        ],
    ],
    [
        1016409600000,
        [
            -958794821.7789906,
            -4314131091.623819,
            -1013313110.254859,
        ],
    ],
    [
        1017014400000,
        [
            -955473021.2297504,
            -4298485907.498836,
            -1007397068.34882,
        ],
    ],
    [
        1017619200000,
        [
            -954316821.0629233,
            -4282989189.410173,
            -1001545860.559225,
        ],
    ],
    [
        1018224000000,
        [
            -955283538.0121167,
            -4267864473.435808,
            -995856225.9305942,
        ],
    ],
    [
        1018828800000,
        [
            -958312823.136456,
            -4253343688.919455,
            -990427814.7132742,
        ],
    ],
    [
        1019433600000,
        [
            -963300717.9824568,
            -4239656273.424119,
            -985360925.7580099,
        ],
    ],
    [
        1020038400000,
        [
            -970104806.6050498,
            -4227004415.289072,
            -980744913.3039546,
        ],
    ],
    [
        1020643200000,
        [
            -978575906.4149022,
            -4215561967.90566,
            -976654724.9706881,
        ],
    ],
    [
        1021248000000,
        [
            -988553258.3930622,
            -4205501837.581811,
            -973164039.4850588,
        ],
    ],
    [
        1021852800000,
        [
            -999840553.0119836,
            -4196982913.642691,
            -970342022.6515658,
        ],
    ],
    [
        1022457600000,
        [
            -1012215499.334328,
            -4190126822.447349,
            -968242220.9243311,
        ],
    ],
    [
        1023062400000,
        [
            -1025461693.814631,
            -4185023002.904356,
            -966902175.7453849,
        ],
    ],
    [
        1023667200000,
        [
            -1039359235.099319,
            -4181755004.923879,
            -966356807.7577001,
        ],
    ],
    [
        1024272000000,
        [
            -1053663175.119658,
            -4180385966.286427,
            -966634320.9066367,
        ],
    ],
    [
        1024876800000,
        [
            -1068116908.525344,
            -4180937329.229679,
            -967745444.8439809,
        ],
    ],
    [
        1025481600000,
        [
            -1082483326.664212,
            -4183400101.557736,
            -969685688.9809613,
        ],
    ],
    [
        1026086400000,
        [
            -1096530604.101642,
            -4187758923.924707,
            -972447898.4323713,
        ],
    ],
    [
        1026691200000,
        [
            -1110013289.733112,
            -4193975985.570059,
            -976016892.0527419,
        ],
    ],
    [
        1027296000000,
        [
            -1122688472.330653,
            -4201971546.555716,
            -980359104.6715457,
        ],
    ],
    [
        1027900800000,
        [
            -1134344946.984075,
            -4211640669.861156,
            -985427628.4994491,
        ],
    ],
    [
        1028505600000,
        [
            -1144784133.497209,
            -4222874204.323081,
            -991174018.2972791,
        ],
    ],
    [
        1029110400000,
        [
            -1153804304.502235,
            -4235541486.771467,
            -997542246.7448788,
        ],
    ],
    [
        1029715200000,
        [
            -1161219208.584421,
            -4249473411.318373,
            -1004459456.207123,
        ],
    ],
    [
        1030320000000,
        [
            -1166884697.936518,
            -4264484461.885741,
            -1011843845.839294,
        ],
    ],
    [
        1030924800000,
        [
            -1170675552.830901,
            -4280390699.031619,
            -1019615389.906388,
        ],
    ],
    [
        1031529600000,
        [
            -1172473336.469545,
            -4296991886.674653,
            -1027688822.269367,
        ],
    ],
    [
        1032134400000,
        [
            -1172186949.977168,
            -4314057777.106687,
            -1035965283.056316,
        ],
    ],
    [
        1032739200000,
        [
            -1169775402.524122,
            -4331354481.497537,
            -1044342335.685075,
        ],
    ],
    [
        1033344000000,
        [
            -1165220491.568736,
            -4348659055.871044,
            -1052723248.310528,
        ],
    ],
    [
        1033948800000,
        [
            -1158517492.093153,
            -4365741021.875731,
            -1061009207.980142,
        ],
    ],
    [
        1034553600000,
        [
            -1149696508.886294,
            -4382352151.972751,
            -1069092490.487197,
        ],
    ],
    [
        1035158400000,
        [
            -1138839812.742404,
            -4398255999.778158,
            -1076868690.474944,
        ],
    ],
    [
        1035763200000,
        [
            -1126050682.113016,
            -4413238991.724497,
            -1084244873.467607,
        ],
    ],
    [
        1036368000000,
        [
            -1111446359.462568,
            -4427091561.504028,
            -1091131304.223536,
        ],
    ],
    [
        1036972800000,
        [
            -1095179779.26002,
            -4439601764.11495,
            -1097436161.74155,
        ],
    ],
    [
        1037577600000,
        [
            -1077450437.572812,
            -4450586558.423913,
            -1103078945.494149,
        ],
    ],
    [
        1038182400000,
        [
            -1058470094.577641,
            -4459898598.931394,
            -1107996483.783848,
        ],
    ],
    [
        1038787200000,
        [
            -1038457171.995447,
            -4467406107.391922,
            -1112133385.180796,
        ],
    ],
    [
        1039392000000,
        [
            -1017658258.945219,
            -4472989196.387888,
            -1115437646.732889,
        ],
    ],
    [
        1039996800000,
        [
            -996351491.8607821,
            -4476570472.47267,
            -1117874285.528242,
        ],
    ],
    [
        1040601600000,
        [
            -974810245.2569771,
            -4478115828.394051,
            -1119428699.46773,
        ],
    ],
    [
        1041206400000,
        [
            -953298952.5704767,
            -4477611999.082017,
            -1120096008.723768,
        ],
    ],
    [
        1041811200000,
        [
            -932095071.6036975,
            -4475064587.905089,
            -1119877704.683769,
        ],
    ],
    [
        1042416000000,
        [
            -911485910.5676769,
            -4470526576.93191,
            -1118795199.614112,
        ],
    ],
    [
        1043020800000,
        [
            -891733321.4240665,
            -4464092472.644887,
            -1116890057.260395,
        ],
    ],
    [
        1043625600000,
        [
            -873072731.159816,
            -4455873782.789795,
            -1114212051.94864,
        ],
    ],
    [
        1044230400000,
        [
            -855737138.6099249,
            -4445998508.666823,
            -1110816327.04635,
        ],
    ],
    [
        1044835200000,
        [
            -839949074.0541903,
            -4434637036.132959,
            -1106776115.588269,
        ],
    ],
    [
        1045440000000,
        [
            -825888917.9604958,
            -4421989699.461204,
            -1102179387.64449,
        ],
    ],
    [
        1046044800000,
        [
            -813698480.0178903,
            -4408261132.390294,
            -1097116021.396405,
        ],
    ],
    [
        1046649600000,
        [
            -803507396.4983588,
            -4393661593.138829,
            -1091676001.327587,
        ],
    ],
    [
        1047254400000,
        [
            -795421355.5643525,
            -4378430676.847327,
            -1085961976.463082,
        ],
    ],
    [
        1047859200000,
        [
            -789495555.5450969,
            -4362819855.689818,
            -1080083478.611565,
        ],
    ],
    [
        1048464000000,
        [
            -785743762.5362695,
            -4347068026.722911,
            -1074144621.588303,
        ],
    ],
    [
        1049068800000,
        [
            -784166825.6789806,
            -4331406302.262196,
            -1068244235.591843,
        ],
    ],
    [
        1049673600000,
        [
            -784738070.5297164,
            -4316080716.458388,
            -1062488491.297044,
        ],
    ],
    [
        1050278400000,
        [
            -787382227.1994673,
            -4301331828.22062,
            -1056983125.585824,
        ],
    ],
    [
        1050883200000,
        [
            -791989718.3357533,
            -4287373250.94556,
            -1051821915.670499,
        ],
    ],
    [
        1051488000000,
        [
            -798445522.4578817,
            -4274400703.604918,
            -1047088713.805218,
        ],
    ],
    [
        1052092800000,
        [
            -806611297.2167245,
            -4262613442.22587,
            -1042869714.812344,
        ],
    ],
    [
        1052697600000,
        [
            -816308525.354266,
            -4252191838.791442,
            -1039244266.889243,
        ],
    ],
    [
        1053302400000,
        [
            -827336720.8477455,
            -4243279362.378277,
            -1036274788.198988,
        ],
    ],
    [
        1053907200000,
        [
            -839500617.3508056,
            -4235996095.362932,
            -1034011412.014888,
        ],
    ],
    [
        1054512000000,
        [
            -852588963.5204722,
            -4230458267.779723,
            -1032503935.951158,
        ],
    ],
    [
        1055116800000,
        [
            -866361400.5798235,
            -4226754834.587902,
            -1031791952.975144,
        ],
    ],
    [
        1055721600000,
        [
            -880570085.6632752,
            -4224933317.423183,
            -1031896367.49716,
        ],
    ],
    [
        1056326400000,
        [
            -894984176.34408,
            -4225017976.715972,
            -1032826446.559311,
        ],
    ],
    [
        1056931200000,
        [
            -909365812.9791704,
            -4227026542.208443,
            -1034590335.15856,
        ],
    ],
    [
        1057536000000,
        [
            -923460493.1602031,
            -4230946254.942628,
            -1037184225.944083,
        ],
    ],
    [
        1058140800000,
        [
            -937021212.2351571,
            -4236723110.433283,
            -1040585039.039671,
        ],
    ],
    [
        1058745600000,
        [
            -949828924.4476464,
            -4244284039.429422,
            -1044759687.029889,
        ],
    ],
    [
        1059350400000,
        [
            -961665900.3835557,
            -4253549607.283481,
            -1049673784.353366,
        ],
    ],
    [
        1059955200000,
        [
            -972309451.2931081,
            -4264409995.078013,
            -1055280583.23675,
        ],
    ],
    [
        1060560000000,
        [
            -981557877.9947821,
            -4276717599.021832,
            -1061515404.504458,
        ],
    ],
    [
        1061164800000,
        [
            -989246384.3764558,
            -4290313127.991005,
            -1068307494.252543,
        ],
    ],
    [
        1061769600000,
        [
            -995218767.6099744,
            -4305034158.407521,
            -1075586824.051401,
        ],
    ],
    [
        1062374400000,
        [
            -999325023.8830243,
            -4320692240.787883,
            -1083273050.292124,
        ],
    ],
    [
        1062979200000,
        [
            -1001448540.892263,
            -4337069202.670101,
            -1091271422.611151,
        ],
    ],
    [
        1063584000000,
        [
            -1001516891.395154,
            -4353946700.50143,
            -1099486500.158682,
        ],
    ],
    [
        1064188800000,
        [
            -999472069.909354,
            -4371110338.739071,
            -1107826426.085318,
        ],
    ],
    [
        1064793600000,
        [
            -995271439.759486,
            -4388328305.757509,
            -1116191976.3121,
        ],
    ],
    [
        1065398400000,
        [
            -988914532.2469546,
            -4405351137.977524,
            -1124474092.417571,
        ],
    ],
    [
        1066003200000,
        [
            -980447616.321212,
            -4421943557.327068,
            -1132569361.234194,
        ],
    ],
    [
        1066608000000,
        [
            -969932295.1783979,
            -4437884073.42386,
            -1140382234.360302,
        ],
    ],
    [
        1067212800000,
        [
            -957449214.0949295,
            -4452945540.812861,
            -1147814842.02198,
        ],
    ],
    [
        1067817600000,
        [
            -943123341.8232574,
            -4466898516.296837,
            -1154766473.243915,
        ],
    ],
    [
        1068422400000,
        [
            -927122027.7728809,
            -4479544157.131937,
            -1161150055.045058,
        ],
    ],
    [
        1069027200000,
        [
            -909622252.8911415,
            -4490709284.7934,
            -1166891874.030725,
        ],
    ],
    [
        1069632000000,
        [
            -890816557.7438295,
            -4500228360.703201,
            -1171921459.701191,
        ],
    ],
    [
        1070236800000,
        [
            -870935781.8470094,
            -4507949593.161736,
            -1176172243.55735,
        ],
    ],
    [
        1070841600000,
        [
            -850240219.4231216,
            -4513766309.294798,
            -1179597515.755271,
        ],
    ],
    [
        1071446400000,
        [
            -828985821.0690985,
            -4517606391.141527,
            -1182167200.043377,
        ],
    ],
    [
        1072051200000,
        [
            -807431834.3535699,
            -4519414073.021202,
            -1183857551.439854,
        ],
    ],
    [
        1072656000000,
        [
            -785860901.6678518,
            -4519157625.681716,
            -1184653114.317515,
        ],
    ],
    [
        1073260800000,
        [
            -764564173.0210949,
            -4516856939.243278,
            -1184561579.711414,
        ],
    ],
    [
        1073865600000,
        [
            -743808737.3857484,
            -4512567075.679402,
            -1183607755.831966,
        ],
    ],
    [
        1074470400000,
        [
            -723848205.4166465,
            -4506359313.352754,
            -1181822925.823258,
        ],
    ],
    [
        1075075200000,
        [
            -704941891.0637194,
            -4498330259.705925,
            -1179247814.376719,
        ],
    ],
    [
        1075680000000,
        [
            -687335863.0667509,
            -4488624575.828113,
            -1175945305.151448,
        ],
    ],
    [
        1076284800000,
        [
            -671234652.0818721,
            -4477413175.924635,
            -1171991217.383549,
        ],
    ],
    [
        1076889600000,
        [
            -656815820.2151994,
            -4464873695.65949,
            -1167463099.57431,
        ],
    ],
    [
        1077494400000,
        [
            -644249335.2232589,
            -4451201206.538554,
            -1162444240.63254,
        ],
    ],
    [
        1078099200000,
        [
            -633675688.5794098,
            -4436625963.961598,
            -1157034391.136321,
        ],
    ],
    [
        1078704000000,
        [
            -625183957.8558052,
            -4421387731.782932,
            -1151338422.779756,
        ],
    ],
    [
        1079308800000,
        [
            -618830667.7064917,
            -4405717322.216691,
            -1145455887.525418,
        ],
    ],
    [
        1079913600000,
        [
            -614659818.190858,
            -4389850171.638593,
            -1139487046.490693,
        ],
    ],
    [
        1080518400000,
        [
            -612678971.7469648,
            -4374040505.217671,
            -1133542290.28991,
        ],
    ],
    [
        1081123200000,
        [
            -612844858.306526,
            -4358534184.332298,
            -1127729559.403572,
        ],
    ],
    [
        1081728000000,
        [
            -615086139.5580845,
            -4343553489.284216,
            -1122145239.691506,
        ],
    ],
    [
        1082332800000,
        [
            -619323299.3334157,
            -4329314316.478498,
            -1116881953.453043,
        ],
    ],
    [
        1082937600000,
        [
            -625442506.3429502,
            -4316037408.945805,
            -1112036407.131809,
        ],
    ],
    [
        1083542400000,
        [
            -633287907.3219409,
            -4303920836.650162,
            -1107695896.972319,
        ],
    ],
    [
        1084147200000,
        [
            -642686601.3861376,
            -4293128832.722188,
            -1103931083.004316,
        ],
    ],
    [
        1084752000000,
        [
            -653466477.9531498,
            -4283812176.077162,
            -1100805705.052953,
        ],
    ],
    [
        1085356800000,
        [
            -665427581.570033,
            -4276116445.30091,
            -1098383257.084085,
        ],
    ],
    [
        1085961600000,
        [
            -678340071.2647507,
            -4270154893.15591,
            -1096713495.342394,
        ],
    ],
    [
        1086566400000,
        [
            -691970532.2939726,
            -4266001991.574378,
            -1095827734.418116,
        ],
    ],
    [
        1087171200000,
        [
            -706096740.4285587,
            -4263716722.370572,
            -1095750308.306625,
        ],
    ],
    [
        1087776000000,
        [
            -720477413.6491686,
            -4263347817.602652,
            -1096503555.132553,
        ],
    ],
    [
        1088380800000,
        [
            -734855205.9363192,
            -4264907526.235411,
            -1098094115.934899,
        ],
    ],
    [
        1088985600000,
        [
            -748983720.2431628,
            -4268369757.205501,
            -1100510243.904471,
        ],
    ],
    [
        1089590400000,
        [
            -762637979.5385867,
            -4273695323.292016,
            -1103734265.629311,
        ],
    ],
    [
        1090195200000,
        [
            -775583217.9835372,
            -4280833406.769439,
            -1107745356.259156,
        ],
    ],
    [
        1090800000000,
        [
            -787581880.8724334,
            -4289696281.411977,
            -1112506030.769852,
        ],
    ],
    [
        1091404800000,
        [
            -798420632.6598513,
            -4300161664.52692,
            -1117961839.911749,
        ],
    ],
    [
        1092009600000,
        [
            -807915676.0475154,
            -4312099374.745766,
            -1124055151.205602,
        ],
    ],
    [
        1092614400000,
        [
            -815881877.988588,
            -4325369052.915299,
            -1130726002.169656,
        ],
    ],
    [
        1093219200000,
        [
            -822143525.0588882,
            -4339796886.810355,
            -1137899421.168977,
        ],
    ],
    [
        1093824000000,
        [
            -826561240.4181052,
            -4355182386.645775,
            -1145487394.772499,
        ],
    ],
    [
        1094428800000,
        [
            -829031775.6503445,
            -4371326326.579907,
            -1153403428.657112,
        ],
    ],
    [
        1095033600000,
        [
            -829458485.7140039,
            -4388024816.4406,
            -1161560906.303603,
        ],
    ],
    [
        1095638400000,
        [
            -827764968.3622274,
            -4405048702.948317,
            -1169861181.686886,
        ],
    ],
    [
        1096243200000,
        [
            -823920744.2289135,
            -4422154176.531757,
            -1178197382.592499,
        ],
    ],
    [
        1096848000000,
        [
            -817934392.6000886,
            -4439111139.196305,
            -1186469485.214269,
        ],
    ],
    [
        1097452800000,
        [
            -809825349.2341722,
            -4455693395.162949,
            -1194580485.503105,
        ],
    ],
    [
        1098057600000,
        [
            -799639207.1139723,
            -4471661246.300453,
            -1202426145.49304,
        ],
    ],
    [
        1098662400000,
        [
            -787470980.5575447,
            -4486775424.825021,
            -1209900869.437233,
        ],
    ],
    [
        1099267200000,
        [
            -773451268.8935515,
            -4500825239.741611,
            -1216913147.135424,
        ],
    ],
    [
        1099872000000,
        [
            -757719646.8180321,
            -4513614983.434844,
            -1223379498.343423,
        ],
    ],
    [
        1100476800000,
        [
            -740440975.4045553,
            -4524949950.648752,
            -1229215708.492735,
        ],
    ],
    [
        1101081600000,
        [
            -721825250.4820396,
            -4534652631.126731,
            -1234343773.634766,
        ],
    ],
    [
        1101686400000,
        [
            -702106867.2219219,
            -4542588882.255855,
            -1238706299.420495,
        ],
    ],
    [
        1102291200000,
        [
            -681519415.7231891,
            -4548649542.536059,
            -1242257516.911223,
        ],
    ],
    [
        1102896000000,
        [
            -660312261.8756224,
            -4552738587.783133,
            -1244955570.359711,
        ],
    ],
    [
        1103500800000,
        [
            -638766111.1056454,
            -4554789715.028568,
            -1246770084.107204,
        ],
    ],
    [
        1104105600000,
        [
            -617166420.9747396,
            -4554788279.552046,
            -1247694887.130923,
        ],
    ],
    [
        1104710400000,
        [
            -595780536.1208892,
            -4552747495.856917,
            -1247736407.765133,
        ],
    ],
    [
        1105315200000,
        [
            -574875509.2609944,
            -4548697841.106468,
            -1246907046.352568,
        ],
    ],
    [
        1105920000000,
        [
            -554730452.3814962,
            -4542703384.946648,
            -1245233190.083508,
        ],
    ],
    [
        1106524800000,
        [
            -535606951.8234092,
            -4534878301.948476,
            -1242765328.409152,
        ],
    ],
    [
        1107129600000,
        [
            -517730842.2412702,
            -4525358309.163951,
            -1239563663.916017,
        ],
    ],
    [
        1107734400000,
        [
            -501312827.9364903,
            -4514290989.890094,
            -1235691912.558868,
        ],
    ],
    [
        1108339200000,
        [
            -486558814.5263935,
            -4501851939.120996,
            -1231225430.691575,
        ],
    ],
    [
        1108944000000,
        [
            -473639454.3804544,
            -4488255254.275104,
            -1226258236.647836,
        ],
    ],
    [
        1109548800000,
        [
            -462678163.6290408,
            -4473721744.77689,
            -1220886780.387882,
        ],
    ],
    [
        1110153600000,
        [
            -453775059.8397173,
            -4458470717.03238,
            -1215204865.212483,
        ],
    ],
    [
        1110758400000,
        [
            -447015889.5921681,
            -4442737149.008299,
            -1209312961.100997,
        ],
    ],
    [
        1111363200000,
        [
            -442442046.9181248,
            -4426777088.596019,
            -1203322904.176255,
        ],
    ],
    [
        1111968000000,
        [
            -440046055.8823671,
            -4410835546.138427,
            -1197341387.81491,
        ],
    ],
    [
        1112572800000,
        [
            -439798673.5157161,
            -4395141389.213256,
            -1191466573.173478,
        ],
    ],
    [
        1113177600000,
        [
            -441656453.7928729,
            -4379927005.428686,
            -1185798752.264192,
        ],
    ],
    [
        1113782400000,
        [
            -445532410.1454499,
            -4365429556.202756,
            -1180442516.087806,
        ],
    ],
    [
        1114387200000,
        [
            -451298643.0967327,
            -4351860526.146092,
            -1175490477.609934,
        ],
    ],
    [
        1114992000000,
        [
            -458814791.8994594,
            -4339404319.917841,
            -1171021591.046811,
        ],
    ],
    [
        1115596800000,
        [
            -467932921.7519207,
            -4328240281.501107,
            -1167113082.791771,
        ],
    ],
    [
        1116201600000,
        [
            -478468021.4114714,
            -4318539827.986096,
            -1163840399.879191,
        ],
    ],
    [
        1116806400000,
        [
            -490206671.2921029,
            -4310438607.155387,
            -1161262244.092911,
        ],
    ],
    [
        1117411200000,
        [
            -502935175.5194499,
            -4304039129.948008,
            -1159421306.925875,
        ],
    ],
    [
        1118016000000,
        [
            -516441159.218158,
            -4299434781.81297,
            -1158357511.34076,
        ],
    ],
    [
        1118620800000,
        [
            -530484251.8154488,
            -4296703213.040277,
            -1158105845.267108,
        ],
    ],
    [
        1119225600000,
        [
            -544810302.280732,
            -4295881831.958963,
            -1158682816.049965,
        ],
    ],
    [
        1119830400000,
        [
            -559178283.0417761,
            -4296974575.624252,
            -1160089186.329415,
        ],
    ],
    [
        1120435200000,
        [
            -573358196.4432995,
            -4299976890.303612,
            -1162323450.14978,
        ],
    ],
    [
        1121040000000,
        [
            -587102363.1788836,
            -4304865230.71032,
            -1165377077.171539,
        ],
    ],
    [
        1121644800000,
        [
            -600164054.7342405,
            -4311575656.646367,
            -1169222297.104763,
        ],
    ],
    [
        1122249600000,
        [
            -612322075.8286484,
            -4320014245.480028,
            -1173816908.16013,
        ],
    ],
    [
        1122854400000,
        [
            -623374422.014534,
            -4330081869.11914,
            -1179117888.785381,
        ],
    ],
    [
        1123459200000,
        [
            -633111009.5005065,
            -4341660182.981248,
            -1185074756.62279,
        ],
    ],
    [
        1124064000000,
        [
            -641336020.4748499,
            -4354593684.880329,
            -1191619311.640232,
        ],
    ],
    [
        1124668800000,
        [
            -647890036.4025936,
            -4368704053.016329,
            -1198672782.525165,
        ],
    ],
    [
        1125273600000,
        [
            -652639548.5789226,
            -4383814384.234492,
            -1206159169.823697,
        ],
    ],
    [
        1125878400000,
        [
            -655452385.6806943,
            -4399732635.393435,
            -1213996730.628925,
        ],
    ],
    [
        1126483200000,
        [
            -656222841.3300283,
            -4416237486.713162,
            -1222089319.579068,
        ],
    ],
    [
        1127088000000,
        [
            -654890786.9199278,
            -4433096363.903365,
            -1230335280.749729,
        ],
    ],
    [
        1127692800000,
        [
            -651426189.184656,
            -4450088235.132874,
            -1238639842.631714,
        ],
    ],
    [
        1128297600000,
        [
            -645807391.7969487,
            -4466984808.922497,
            -1246905065.100196,
        ],
    ],
    [
        1128902400000,
        [
            -638047186.6929526,
            -4483540097.364731,
            -1255023187.547194,
        ],
    ],
    [
        1129507200000,
        [
            -628207996.4764183,
            -4499511555.658958,
            -1262887507.037834,
        ],
    ],
    [
        1130112000000,
        [
            -616380666.8810275,
            -4514680767.228557,
            -1270403934.217124,
        ],
    ],
    [
        1130716800000,
        [
            -602665993.4658549,
            -4528832923.027029,
            -1277479993.453251,
        ],
    ],
    [
        1131321600000,
        [
            -587200476.5098386,
            -4541750270.672464,
            -1284020289.881194,
        ],
    ],
    [
        1131926400000,
        [
            -570167231.9139818,
            -4553235545.989188,
            -1289938582.877748,
        ],
    ],
    [
        1132531200000,
        [
            -551768874.7993912,
            -4563129448.989728,
            -1295167398.010755,
        ],
    ],
    [
        1133136000000,
        [
            -532212435.5870136,
            -4571287852.833716,
            -1299645399.542259,
        ],
    ],
    [
        1133740800000,
        [
            -511733422.4713203,
            -4577578113.789851,
            -1303314307.411733,
        ],
    ],
    [
        1134345600000,
        [
            -490601889.7203839,
            -4581902571.710019,
            -1306131105.523459,
        ],
    ],
    [
        1134950400000,
        [
            -469089744.2730434,
            -4584210847.140909,
            -1308075057.045581,
        ],
    ],
    [
        1135555200000,
        [
            -447459480.5413547,
            -4584473669.756984,
            -1309133541.484314,
        ],
    ],
    [
        1136160000000,
        [
            -425986518.9046861,
            -4582681049.76565,
            -1309300612.078542,
        ],
    ],
    [
        1136764800000,
        [
            -404961365.2396256,
            -4578864259.648921,
            -1308588979.022556,
        ],
    ],
    [
        1137369600000,
        [
            -384653990.1863191,
            -4573102115.032264,
            -1307034078.245359,
        ],
    ],
    [
        1137974400000,
        [
            -365308268.7856696,
            -4565491494.980296,
            -1304678232.098155,
        ],
    ],
    [
        1138579200000,
        [
            -347164179.6293614,
            -4556147197.861709,
            -1301570323.5423,
        ],
    ],
    [
        1139184000000,
        [
            -330457589.4829587,
            -4545221766.39793,
            -1297776690.324984,
        ],
    ],
    [
        1139788800000,
        [
            -315384686.0037811,
            -4532905592.919706,
            -1293381716.109327,
        ],
    ],
    [
        1140393600000,
        [
            -302103261.8318511,
            -4519394933.05117,
            -1288470584.939682,
        ],
    ],
    [
        1140998400000,
        [
            -290755737.8447111,
            -4504893662.139381,
            -1283130310.514144,
        ],
    ],
    [
        1141603200000,
        [
            -281467143.8992062,
            -4489631415.425549,
            -1277460138.052291,
        ],
    ],
    [
        1142208000000,
        [
            -274311772.5275688,
            -4473858533.721378,
            -1271569642.159625,
        ],
    ],
    [
        1142812800000,
        [
            -269321766.5062939,
            -4457814016.339886,
            -1265561718.668021,
        ],
    ],
    [
        1143417600000,
        [
            -266511570.8453267,
            -4441730566.785592,
            -1259535721.569993,
        ],
    ],
    [
        1144022400000,
        [
            -265874303.7130472,
            -4425852720.219935,
            -1253597938.619099,
        ],
    ],
    [
        1144627200000,
        [
            -267351868.8058867,
            -4410428113.057281,
            -1247857438.430579,
        ],
    ],
    [
        1145232000000,
        [
            -270850253.4244843,
            -4395677868.615102,
            -1242410006.350549,
        ],
    ],
    [
        1145836800000,
        [
            -276264528.8394125,
            -4381805492.033315,
            -1237343041.54697,
        ],
    ],
    [
        1146441600000,
        [
            -283472439.2098098,
            -4369015482.036333,
            -1232745967.286036,
        ],
    ],
    [
        1147046400000,
        [
            -292307483.5954847,
            -4357501082.107648,
            -1228703898.188333,
        ],
    ],
    [
        1147651200000,
        [
            -302579184.3009612,
            -4347418394.850859,
            -1225283602.133098,
        ],
    ],
    [
        1148256000000,
        [
            -314096989.82083,
            -4338898834.065885,
            -1222540483.7274,
        ],
    ],
    [
        1148860800000,
        [
            -326660229.6128264,
            -4332068195.510525,
            -1220529368.367043,
        ],
    ],
    [
        1149465600000,
        [
            -340034169.6149716,
            -4327031118.021464,
            -1219296409.41531,
        ],
    ],
    [
        1150070400000,
        [
            -353974377.608264,
            -4323850142.193872,
            -1218867787.71268,
        ],
    ],
    [
        1150675200000,
        [
            -368248680.1610655,
            -4322561490.314702,
            -1219258358.390766,
        ],
    ],
    [
        1151280000000,
        [
            -382623571.1654856,
            -4323194218.704994,
            -1220482068.36797,
        ],
    ],
    [
        1151884800000,
        [
            -396843487.8171054,
            -4325751349.578114,
            -1222541551.246348,
        ],
    ],
    [
        1152489600000,
        [
            -410658195.9165576,
            -4330194043.145806,
            -1225419329.129245,
        ],
    ],
    [
        1153094400000,
        [
            -423841568.8887874,
            -4336459747.644097,
            -1229087566.861994,
        ],
    ],
    [
        1153699200000,
        [
            -436174358.9759696,
            -4344480366.511321,
            -1233517813.207403,
        ],
    ],
    [
        1154304000000,
        [
            -447426756.9818309,
            -4354160145.173531,
            -1238668836.688448,
        ],
    ],
    [
        1154908800000,
        [
            -457387875.6438619,
            -4365365063.852629,
            -1244480957.813179,
        ],
    ],
    [
        1155513600000,
        [
            -465880790.8895833,
            -4377943144.627219,
            -1250887219.000115,
        ],
    ],
    [
        1156118400000,
        [
            -472742444.2489391,
            -4391741383.564704,
            -1257822466.674012,
        ],
    ],
    [
        1156723200000,
        [
            -477810206.621825,
            -4406581582.415039,
            -1265209894.37708,
        ],
    ],
    [
        1157328000000,
        [
            -480952941.6367911,
            -4422255274.26892,
            -1272958200.987402,
        ],
    ],
    [
        1157932800000,
        [
            -482081872.1269872,
            -4438546121.367745,
            -1280973545.607479,
        ],
    ],
    [
        1158537600000,
        [
            -481127793.0216328,
            -4455244986.636674,
            -1289167165.264979,
        ],
    ],
    [
        1159142400000,
        [
            -478031360.474862,
            -4472124476.271945,
            -1297440873.000157,
        ],
    ],
    [
        1159747200000,
        [
            -472774166.5816352,
            -4488938811.450813,
            -1305686823.777824,
        ],
    ],
    [
        1160352000000,
        [
            -465384325.0021427,
            -4505447786.288859,
            -1313800340.316993,
        ],
    ],
    [
        1160956800000,
        [
            -455910549.9275221,
            -4521429138.960242,
            -1321686165.756127,
        ],
    ],
    [
        1161561600000,
        [
            -444415809.9164803,
            -4536652762.381113,
            -1329244035.129035,
        ],
    ],
    [
        1162166400000,
        [
            -431007149.6413088,
            -4550885120.625542,
            -1336371128.057251,
        ],
    ],
    [
        1162771200000,
        [
            -415835691.3596272,
            -4563914466.319885,
            -1342975560.547061,
        ],
    ],
    [
        1163376000000,
        [
            -399067574.3885761,
            -4575559646.867501,
            -1348980487.762501,
        ],
    ],
    [
        1163980800000,
        [
            -380880934.2701995,
            -4585644413.912489,
            -1354309599.241583,
        ],
    ],
    [
        1164585600000,
        [
            -361493116.0814331,
            -4594005067.063819,
            -1358891128.323296,
        ],
    ],
    [
        1165190400000,
        [
            -341154827.9711781,
            -4600515308.594653,
            -1362670886.829535,
        ],
    ],
    [
        1165795200000,
        [
            -320117756.9421877,
            -4605089439.061633,
            -1365613200.868089,
        ],
    ],
    [
        1166400000000,
        [
            -298634869.9545649,
            -4607655981.125466,
            -1367686385.377963,
        ],
    ],
    [
        1167004800000,
        [
            -276984087.0354052,
            -4608166741.914139,
            -1368868007.678483,
        ],
    ],
    [
        1167609600000,
        [
            -255457580.9748702,
            -4606619554.331056,
            -1369157198.514114,
        ],
    ],
    [
        1168214400000,
        [
            -234327663.7590746,
            -4603054645.849967,
            -1368572274.416216,
        ],
    ],
    [
        1168819200000,
        [
            -213852153.2356923,
            -4597527523.829619,
            -1367136377.422856,
        ],
    ],
    [
        1169424000000,
        [
            -194295442.4737237,
            -4590118837.059185,
            -1364883499.418343,
        ],
    ],
    [
        1170028800000,
        [
            -175915381.2756663,
            -4580954152.087276,
            -1361869198.368217,
        ],
    ],
    [
        1170633600000,
        [
            -158930122.3227407,
            -4570193476.721617,
            -1358164383.01281,
        ],
    ],
    [
        1171238400000,
        [
            -143530190.6737301,
            -4558003795.360449,
            -1353840881.816661,
        ],
    ],
    [
        1171843200000,
        [
            -129897733.354488,
            -4544569691.889075,
            -1348977959.410568,
        ],
    ],
    [
        1172448000000,
        [
            -118192464.4822043,
            -4530109917.687354,
            -1343671406.162497,
        ],
    ],
    [
        1173052800000,
        [
            -108521489.3592994,
            -4514861236.750754,
            -1338024502.254794,
        ],
    ],
    [
        1173657600000,
        [
            -100958594.4938705,
            -4499052095.310925,
            -1332134739.674004,
        ],
    ],
    [
        1174262400000,
        [
            -95562249.58873993,
            -4482915304.517425,
            -1326101804.31269,
        ],
    ],
    [
        1174867200000,
        [
            -92361406.17589796,
            -4466702621.965778,
            -1320035745.992961,
        ],
    ],
    [
        1175472000000,
        [
            -91329929.9543511,
            -4450665314.123116,
            -1314046226.304963,
        ],
    ],
    [
        1176076800000,
        [
            -92412634.73582149,
            -4435031134.572044,
            -1308231019.542532,
        ],
    ],
    [
        1176681600000,
        [
            -95541901.73183313,
            -4420020237.451364,
            -1302685347.430252,
        ],
    ],
    [
        1177286400000,
        [
            -100622621.3976165,
            -4405858447.832148,
            -1297508818.027193,
        ],
    ],
    [
        1177891200000,
        [
            -107511261.740456,
            -4392755707.129407,
            -1292793250.674406,
        ],
    ],
    [
        1178496000000,
        [
            -116046407.3586633,
            -4380887331.189974,
            -1288613443.460718,
        ],
    ],
    [
        1179100800000,
        [
            -126062789.511529,
            -4370412960.954986,
            -1285037994.183831,
        ],
    ],
    [
        1179705600000,
        [
            -137374038.3731188,
            -4361488401.350476,
            -1282135397.69242,
        ],
    ],
    [
        1180310400000,
        [
            -149756295.8126389,
            -4354242510.292953,
            -1279961296.581424,
        ],
    ],
    [
        1180915200000,
        [
            -162981445.6407763,
            -4348763676.872957,
            -1278552373.730306,
        ],
    ],
    [
        1181520000000,
        [
            -176828240.6057031,
            -4345121563.498674,
            -1277938551.156516,
        ],
    ],
    [
        1182124800000,
        [
            -191062677.1224714,
            -4343377515.467455,
            -1278147958.835592,
        ],
    ],
    [
        1182729600000,
        [
            -205426652.7044167,
            -4343560224.866869,
            -1279193326.501731,
        ],
    ],
    [
        1183334400000,
        [
            -219672390.1496278,
            -4345657816.325308,
            -1281068660.386966,
        ],
    ],
    [
        1183939200000,
        [
            -233570202.3241454,
            -4349641302.437684,
            -1283761865.861853,
        ],
    ],
    [
        1184544000000,
        [
            -246886224.4805954,
            -4355472845.190955,
            -1287258120.796066,
        ],
    ],
    [
        1185148800000,
        [
            -259376056.4021324,
            -4363079981.73793,
            -1291525561.829265,
        ],
    ],
    [
        1185753600000,
        [
            -270818795.1512822,
            -4372353270.795038,
            -1296515153.574149,
        ],
    ],
    [
        1186358400000,
        [
            -281021082.1893339,
            -4383170577.960501,
            -1302173836.868363,
        ],
    ],
    [
        1186963200000,
        [
            -289792729.5918548,
            -4395403176.578629,
            -1308446791.933398,
        ],
    ],
    [
        1187568000000,
        [
            -296945819.2158193,
            -4408889333.344759,
            -1315263064.714909,
        ],
    ],
    [
        1188172800000,
        [
            -302327695.6790558,
            -4423438031.934068,
            -1322538683.50542,
        ],
    ],
    [
        1188777600000,
        [
            -305821362.6108747,
            -4438853805.252389,
            -1330189731.164849,
        ],
    ],
    [
        1189382400000,
        [
            -307319730.9820076,
            -4454940840.745615,
            -1338133076.355382,
        ],
    ],
    [
        1189987200000,
        [
            -306729859.1460404,
            -4471476598.222635,
            -1346271841.099459,
        ],
    ],
    [
        1190592000000,
        [
            -304003606.8034627,
            -4488221259.482134,
            -1354501254.816123,
        ],
    ],
    [
        1191196800000,
        [
            -299133400.0133393,
            -4504942260.171974,
            -1362721234.78418,
        ],
    ],
    [
        1191801600000,
        [
            -292125011.8482812,
            -4521416012.510592,
            -1370835812.566154,
        ],
    ],
    [
        1192406400000,
        [
            -283005795.3205284,
            -4537402143.449471,
            -1378739363.581329,
        ],
    ],
    [
        1193011200000,
        [
            -271851836.7522449,
            -4552658140.225499,
            -1386325405.38899,
        ],
    ],
    [
        1193616000000,
        [
            -258778470.2453308,
            -4566963146.677893,
            -1393498754.40171,
        ],
    ],
    [
        1194220800000,
        [
            -243912027.7810366,
            -4580117069.91362,
            -1400173589.173736,
        ],
    ],
    [
        1194825600000,
        [
            -227401247.8079833,
            -4591916166.179821,
            -1406260612.03296,
        ],
    ],
    [
        1195430400000,
        [
            -209440247.6471956,
            -4602171728.815823,
            -1411677697.33715,
        ],
    ],
    [
        1196035200000,
        [
            -190253365.5100996,
            -4610731990.855678,
            -1416360533.128154,
        ],
    ],
    [
        1196640000000,
        [
            -170066069.5935632,
            -4617477030.125154,
            -1420258239.43993,
        ],
    ],
    [
        1197244800000,
        [
            -149118452.6678757,
            -4622295198.240357,
            -1423321269.185005,
        ],
    ],
    [
        1197849600000,
        [
            -127683337.73482,
            -4625103441.869497,
            -1425513007.503473,
        ],
    ],
    [
        1198454400000,
        [
            -106045723.2401391,
            -4625865629.670221,
            -1426818629.585286,
        ],
    ],
    [
        1199059200000,
        [
            -84473982.77162367,
            -4624581555.7098,
            -1427238086.906852,
        ],
    ],
    [
        1199664000000,
        [
            -63236006.18999521,
            -4621264168.159559,
            -1426775236.072031,
        ],
    ],
    [
        1200268800000,
        [
            -42613467.8507132,
            -4615959966.868535,
            -1425449788.122203,
        ],
    ],
    [
        1200873600000,
        [
            -22878270.21091379,
            -4608763215.809237,
            -1423304009.298869,
        ],
    ],
    [
        1201478400000,
        [
            -4266595.863636762,
            -4599798542.561167,
            -1420392458.367138,
        ],
    ],
    [
        1202083200000,
        [
            13000667.21698,
            -4589199594.812052,
            -1416772100.038487,
        ],
    ],
    [
        1202688000000,
        [
            28706354.51846875,
            -4577128675.394049,
            -1412513645.024189,
        ],
    ],
    [
        1203292800000,
        [
            42661354.71264173,
            -4563786813.964211,
            -1407705893.404483,
        ],
    ],
    [
        1203897600000,
        [
            54725945.71979482,
            -4549390450.795808,
            -1402442607.746766,
        ],
    ],
    [
        1204502400000,
        [
            64784272.3646127,
            -4534152738.30654,
            -1396814535.797359,
        ],
    ],
    [
        1205107200000,
        [
            72735091.53628898,
            -4518302878.268429,
            -1390920740.730725,
        ],
    ],
    [
        1205712000000,
        [
            78515259.90384045,
            -4502093282.683846,
            -1384871649.899343,
        ],
    ],
    [
        1206316800000,
        [
            82115209.29126902,
            -4485772660.96706,
            -1378774488.764324,
        ],
    ],
    [
        1206921600000,
        [
            83548117.88061127,
            -4469572117.059152,
            -1372728111.757623,
        ],
    ],
    [
        1207526400000,
        [
            82843007.57156788,
            -4453725515.454132,
            -1366834441.92448,
        ],
    ],
    [
        1208131200000,
        [
            80066916.82793748,
            -4438474892.379274,
            -1361200189.665276,
        ],
    ],
    [
        1208736000000,
        [
            75334624.0579694,
            -4424041962.43101,
            -1355921344.180382,
        ],
    ],
    [
        1209340800000,
        [
            68774149.16725019,
            -4410619875.562403,
            -1351080809.966735,
        ],
    ],
    [
        1209945600000,
        [
            60523466.84625559,
            -4398394710.592619,
            -1346759871.443321,
        ],
    ],
    [
        1210550400000,
        [
            50752350.66439077,
            -4387548971.431211,
            -1343038745.565554,
        ],
    ],
    [
        1211155200000,
        [
            39667191.18230642,
            -4378232663.124655,
            -1339981261.576182,
        ],
    ],
    [
        1211760000000,
        [
            27474865.5956948,
            -4370560912.397565,
            -1337635892.834194,
        ],
    ],
    [
        1212364800000,
        [
            14383537.18954664,
            -4364636570.423875,
            -1336047600.119995,
        ],
    ],
    [
        1212969600000,
        [
            624394.9906085394,
            -4360551724.876914,
            -1335257277.550849,
        ],
    ],
    [
        1213574400000,
        [
            -13548563.00350088,
            -4358359480.569068,
            -1335287004.942082,
        ],
    ],
    [
        1214179200000,
        [
            -27894810.50843369,
            -4358077401.307371,
            -1336143923.446143,
        ],
    ],
    [
        1214784000000,
        [
            -42182532.64031599,
            -4359710717.818119,
            -1337831683.785464,
        ],
    ],
    [
        1215388800000,
        [
            -56166731.60825801,
            -4363251186.465524,
            -1340348054.024015,
        ],
    ],
    [
        1215993600000,
        [
            -69594279.08898748,
            -4368649789.004415,
            -1343670737.646042,
        ],
    ],
    [
        1216598400000,
        [
            -82238413.93874314,
            -4375825240.167578,
            -1347763793.662997,
        ],
    ],
    [
        1217203200000,
        [
            -93890039.62132473,
            -4384686943.491265,
            -1352588753.253025,
        ],
    ],
    [
        1217808000000,
        [
            -104335613.0036931,
            -4395130868.983281,
            -1358100833.052018,
        ],
    ],
    [
        1218412800000,
        [
            -113367264.7520974,
            -4407013876.871396,
            -1364236190.737834,
        ],
    ],
    [
        1219017600000,
        [
            -120814413.694582,
            -4420167329.924642,
            -1370921004.026052,
        ],
    ],
    [
        1219622400000,
        [
            -126531920.4330095,
            -4434419720.355595,
            -1378082156.091272,
        ],
    ],
    [
        1220227200000,
        [
            -130378312.9005924,
            -4449590041.053498,
            -1385641958.625204,
        ],
    ],
    [
        1220832000000,
        [
            -132231114.6644454,
            -4465464554.967926,
            -1393506747.003472,
        ],
    ],
    [
        1221436800000,
        [
            -132014245.3169485,
            -4481815227.049885,
            -1401577828.404545,
        ],
    ],
    [
        1222041600000,
        [
            -129682925.8426822,
            -4498421299.624089,
            -1409761096.242652,
        ],
    ],
    [
        1222646400000,
        [
            -125201867.3700291,
            -4515060140.499844,
            -1417960353.876414,
        ],
    ],
    [
        1223251200000,
        [
            -118564732.1778415,
            -4531486672.639335,
            -1426067729.134793,
        ],
    ],
    [
        1223856000000,
        [
            -109815694.6713684,
            -4547455982.499097,
            -1433976601.861168,
        ],
    ],
    [
        1224460800000,
        [
            -99030751.65833576,
            -4562743137.459997,
            -1441590334.652742,
        ],
    ],
    [
        1225065600000,
        [
            -86295884.63161775,
            -4577131897.051333,
            -1448814826.553919,
        ],
    ],
    [
        1225670400000,
        [
            -71729745.16512908,
            -4590397257.401088,
            -1455551057.656646,
        ],
    ],
    [
        1226275200000,
        [
            -55498695.54770932,
            -4602331544.378927,
            -1461709348.031608,
        ],
    ],
    [
        1226880000000,
        [
            -37794454.10435709,
            -4612761443.020779,
            -1467216232.80655,
        ],
    ],
    [
        1227484800000,
        [
            -18812430.54413726,
            -4621534133.407578,
            -1472005592.752848,
        ],
    ],
    [
        1228089600000,
        [
            1223820.104564115,
            -4628502189.078883,
            -1476012596.804766,
        ],
    ],
    [
        1228694400000,
        [
            22054605.41315602,
            -4633551047.052615,
            -1479188187.392799,
        ],
    ],
    [
        1229299200000,
        [
            43410284.03187115,
            -4636611231.71377,
            -1481503406.788511,
        ],
    ],
    [
        1229904000000,
        [
            65032074.94087836,
            -4637640614.136974,
            -1482939064.167046,
        ],
    ],
    [
        1230508800000,
        [
            86646581.76876709,
            -4636610769.433878,
            -1483481194.48279,
        ],
    ],
    [
        1231113600000,
        [
            107963617.4533746,
            -4633534021.91569,
            -1483135414.810456,
        ],
    ],
    [
        1231718400000,
        [
            128704541.7827407,
            -4628469961.673638,
            -1481928537.921435,
        ],
    ],
    [
        1232323200000,
        [
            148619626.0345327,
            -4621503400.454632,
            -1479896545.095959,
        ],
    ],
    [
        1232928000000,
        [
            167460725.6317719,
            -4612732391.932541,
            -1477081149.100402,
        ],
    ],
    [
        1233532800000,
        [
            184982641.2781155,
            -4602293783.451397,
            -1473542972.782233,
        ],
    ],
    [
        1234137600000,
        [
            200971480.6920024,
            -4590364051.480742,
            -1469360031.842015,
        ],
    ],
    [
        1234742400000,
        [
            215256335.6864815,
            -4577133017.76699,
            -1464613865.484823,
        ],
    ],
    [
        1235347200000,
        [
            227679742.5571482,
            -4562794389.329796,
            -1459387534.23064,
        ],
    ],
    [
        1235952000000,
        [
            238101307.6181495,
            -4547569481.589797,
            -1453777746.302504,
        ],
    ],
    [
        1236556800000,
        [
            246424607.9443691,
            -4531703684.616668,
            -1447891399.169962,
        ],
    ],
    [
        1237161600000,
        [
            252601765.946943,
            -4515437529.342332,
            -1441831167.365134,
        ],
    ],
    [
        1237766400000,
        [
            256601566.6584551,
            -4499001972.831637,
            -1435696157.516478,
        ],
    ],
    [
        1238371200000,
        [
            258414693.8256172,
            -4482641211.881865,
            -1429593276.437687,
        ],
    ],
    [
        1238976000000,
        [
            258078172.2804148,
            -4466606882.457597,
            -1423632527.047462,
        ],
    ],
    [
        1239580800000,
        [
            255672672.5280186,
            -4451128521.461183,
            -1417912515.822304,
        ],
    ],
    [
        1240185600000,
        [
            251289351.2065821,
            -4436415094.502922,
            -1412523826.567653,
        ],
    ],
    [
        1240790400000,
        [
            245037599.4125713,
            -4422676910.257966,
            -1407559166.118006,
        ],
    ],
    [
        1241395200000,
        [
            237067545.3897939,
            -4410118209.658789,
            -1403107677.507076,
        ],
    ],
    [
        1242000000000,
        [
            227561547.8346266,
            -4398908060.38874,
            -1399241121.393565,
        ],
    ],
    [
        1242604800000,
        [
            216701675.0089168,
            -4389188288.631623,
            -1396020453.237486,
        ],
    ],
    [
        1243209600000,
        [
            204680909.8308012,
            -4381094140.638433,
            -1393505106.570623,
        ],
    ],
    [
        1243814400000,
        [
            191723849.4172855,
            -4374745572.484639,
            -1391746928.852595,
        ],
    ],
    [
        1244419200000,
        [
            178073215.0980618,
            -4370219836.051812,
            -1390777769.35329,
        ],
    ],
    [
        1245024000000,
        [
            163958968.3610799,
            -4367565706.395203,
            -1390618958.305859,
        ],
    ],
    [
        1245628800000,
        [
            149612893.223046,
            -4366822652.965405,
            -1391289208.92423,
        ],
    ],
    [
        1246233600000,
        [
            135287261.8569103,
            -4368010591.534166,
            -1392797574.212043,
        ],
    ],
    [
        1246838400000,
        [
            121237223.7574854,
            -4371104745.451593,
            -1395132232.007882,
        ],
    ],
    [
        1247443200000,
        [
            107692890.061146,
            -4376054986.022449,
            -1398272022.086695,
        ],
    ],
    [
        1248048000000,
        [
            94877422.78525656,
            -4382802799.914235,
            -1402192825.16733,
        ],
    ],
    [
        1248652800000,
        [
            83023767.27000126,
            -4391268895.916354,
            -1406859733.44486,
        ],
    ],
    [
        1249257600000,
        [
            72353630.23099715,
            -4401330984.005877,
            -1412217854.469043,
        ],
    ],
    [
        1249862400000,
        [
            63053414.68482134,
            -4412847438.902506,
            -1418205915.240881,
        ],
    ],
    [
        1250467200000,
        [
            55295078.41579507,
            -4425672313.514256,
            -1424761592.845017,
        ],
    ],
    [
        1251072000000,
        [
            49250346.53894301,
            -4439641131.35626,
            -1431813073.018653,
        ],
    ],
    [
        1251676800000,
        [
            45066330.40054995,
            -4454552779.612137,
            -1439272065.726528,
        ],
    ],
    [
        1252281600000,
        [
            42846060.5121727,
            -4470196868.821468,
            -1447048502.531357,
        ],
    ],
    [
        1252886400000,
        [
            42671665.64227363,
            -4486366864.463137,
            -1455054409.927657,
        ],
    ],
    [
        1253491200000,
        [
            44616390.47949463,
            -4502843997.368607,
            -1463194554.580784,
        ],
    ],
    [
        1254096000000,
        [
            48717891.42369607,
            -4519383673.118904,
            -1471361837.462105,
        ],
    ],
    [
        1254700800000,
        [
            54965019.02407765,
            -4535745295.258649,
            -1479452668.228066,
        ],
    ],
    [
        1255305600000,
        [
            63323456.3055833,
            -4551703212.429395,
            -1487369819.844723,
        ],
    ],
    [
        1255910400000,
        [
            73746176.43956144,
            -4567028908.257843,
            -1495012835.582614,
        ],
    ],
    [
        1256515200000,
        [
            86145290.01824984,
            -4581482431.159607,
            -1502276426.591712,
        ],
    ],
    [
        1257120000000,
        [
            100386038.1563015,
            -4594843782.073779,
            -1509066119.704987,
        ],
    ],
    [
        1257724800000,
        [
            116314427.1285442,
            -4606921339.847837,
            -1515299777.594044,
        ],
    ],
    [
        1258329600000,
        [
            133766443.4671658,
            -4617532409.819983,
            -1520897380.645443,
        ],
    ],
    [
        1258934400000,
        [
            152539410.1459652,
            -4626499170.779119,
            -1525781637.446132,
        ],
    ],
    [
        1259539200000,
        [
            172393989.8634997,
            -4633679691.81304,
            -1529892573.166968,
        ],
    ],
    [
        1260144000000,
        [
            193083636.3791896,
            -4638972074.351206,
            -1533186835.006116,
        ],
    ],
    [
        1260748800000,
        [
            214362964.2133113,
            -4642292414.432935,
            -1535626624.052781,
        ],
    ],
    [
        1261353600000,
        [
            235959519.7297857,
            -4643573695.063841,
            -1537182186.583991,
        ],
    ],
    [
        1261958400000,
        [
            257583311.2240227,
            -4642794446.733674,
            -1537845032.983242,
        ],
    ],
    [
        1262563200000,
        [
            278956596.0488818,
            -4639977191.101333,
            -1537624960.964618,
        ],
    ],
    [
        1263168000000,
        [
            299819839.7210542,
            -4635163689.808855,
            -1536538354.012712,
        ],
    ],
    [
        1263772800000,
        [
            319903178.3340545,
            -4628416035.121218,
            -1534611995.589865,
        ],
    ],
    [
        1264377600000,
        [
            338940993.7235942,
            -4619842144.417997,
            -1531894230.058709,
        ],
    ],
    [
        1264982400000,
        [
            356699659.0734884,
            -4609588110.926712,
            -1528449063.932899,
        ],
    ],
    [
        1265587200000,
        [
            372978850.7907268,
            -4597811169.687461,
            -1524343576.090505,
        ],
    ],
    [
        1266192000000,
        [
            387582319.4678656,
            -4584682762.520938,
            -1519652463.913412,
        ],
    ],
    [
        1266796800000,
        [
            400335433.5482969,
            -4570410644.140572,
            -1514467118.743724,
        ],
    ],
    [
        1267401600000,
        [
            411109511.8529772,
            -4555225801.782436,
            -1508887481.510405,
        ],
    ],
    [
        1268006400000,
        [
            419816900.2554859,
            -4539354546.935295,
            -1503009783.820839,
        ],
    ],
    [
        1268611200000,
        [
            426381293.6712347,
            -4523024818.606033,
            -1496932721.24836,
        ],
    ],
    [
        1269216000000,
        [
            430756579.8228213,
            -4506485988.426856,
            -1490765298.988257,
        ],
    ],
    [
        1269820800000,
        [
            432946908.4227777,
            -4489992582.304162,
            -1484617520.473282,
        ],
    ],
    [
        1270425600000,
        [
            432994640.7542803,
            -4473777748.652317,
            -1478589240.393872,
        ],
    ],
    [
        1271030400000,
        [
            430951246.5210761,
            -4458064423.147531,
            -1472778044.974382,
        ],
    ],
    [
        1271635200000,
        [
            426897101.4495431,
            -4443083334.27879,
            -1467285552.875268,
        ],
    ],
    [
        1272240000000,
        [
            420957973.4150304,
            -4429054965.021163,
            -1462207202.237207,
        ],
    ],
    [
        1272844800000,
        [
            413286900.6462758,
            -4416165404.22759,
            -1457622560.559565,
        ],
    ],
    [
        1273449600000,
        [
            404037884.3473997,
            -4404582655.535101,
            -1453605150.531819,
        ],
    ],
    [
        1274054400000,
        [
            393387266.9200311,
            -4394472271.555428,
            -1450227450.968506,
        ],
    ],
    [
        1274659200000,
        [
            381547497.6711032,
            -4385978391.504292,
            -1447550733.341912,
        ],
    ],
    [
        1275264000000,
        [
            368744066.0998042,
            -4379202788.374379,
            -1445617610.823343,
        ],
    ],
    [
        1275868800000,
        [
            355193190.197946,
            -4374226429.189569,
            -1444463978.451556,
        ],
    ],
    [
        1276473600000,
        [
            341124483.7960556,
            -4371122376.552772,
            -1444122493.438181,
        ],
    ],
    [
        1277078400000,
        [
            326791920.2830285,
            -4369936537.603476,
            -1444612363.363956,
        ],
    ],
    [
        1277683200000,
        [
            312446808.8419092,
            -4370670322.481246,
            -1445933695.037763,
        ],
    ],
    [
        1278288000000,
        [
            298320368.2910327,
            -4373306623.027055,
            -1448080642.640769,
        ],
    ],
    [
        1278892800000,
        [
            284647685.3139732,
            -4377819085.499599,
            -1451042819.560483,
        ],
    ],
    [
        1279497600000,
        [
            271676084.6845364,
            -4384152354.993795,
            -1454795073.831931,
        ],
    ],
    [
        1280102400000,
        [
            259635592.3519942,
            -4392208350.915798,
            -1459293895.659352,
        ],
    ],
    [
        1280707200000,
        [
            248727004.3914818,
            -4401875643.633123,
            -1464491809.282794,
        ],
    ],
    [
        1281312000000,
        [
            239146745.9235072,
            -4413035016.90447,
            -1470337295.763887,
        ],
    ],
    [
        1281916800000,
        [
            231092094.6964505,
            -4425539690.171876,
            -1476765156.551182,
        ],
    ],
    [
        1282521600000,
        [
            224729826.1214695,
            -4439206090.994452,
            -1483695249.59544,
        ],
    ],
    [
        1283126400000,
        [
            220189608.8816144,
            -4453846089.170392,
            -1491047517.485389,
        ],
    ],
    [
        1283731200000,
        [
            217589228.6893858,
            -4469269331.909924,
            -1498740209.380013,
        ],
    ],
    [
        1284336000000,
        [
            217036472.5553265,
            -4485263707.110353,
            -1506680483.812418,
        ],
    ],
    [
        1284940800000,
        [
            218597359.574981,
            -4501590987.418509,
            -1514765176.653455,
        ],
    ],
    [
        1285545600000,
        [
            222295602.8041169,
            -4518020538.35794,
            -1522895729.22355,
        ],
    ],
    [
        1286150400000,
        [
            228138671.9752652,
            -4534328495.762591,
            -1530975067.122052,
        ],
    ],
    [
        1286755200000,
        [
            236116988.6071798,
            -4550278373.492366,
            -1538898934.565738,
        ],
    ],
    [
        1287360000000,
        [
            246173294.8000978,
            -4565621933.168663,
            -1546559332.06173,
        ],
    ],
    [
        1287964800000,
        [
            258208679.4988015,
            -4580133110.216015,
            -1553859181.954944,
        ],
    ],
    [
        1288569600000,
        [
            272109416.053874,
            -4593604495.547654,
            -1560708267.909888,
        ],
    ],
    [
        1289174400000,
        [
            287743770.7052433,
            -4605828150.100188,
            -1567015156.721063,
        ],
    ],
    [
        1289779200000,
        [
            304933510.2032423,
            -4616601720.333067,
            -1572692807.456458,
        ],
    ],
    [
        1290384000000,
        [
            323466808.9444814,
            -4625760600.483633,
            -1577671574.175455,
        ],
    ],
    [
        1290988800000,
        [
            343125816.2191719,
            -4633171024.690966,
            -1581893500.622723,
        ],
    ],
    [
        1291593600000,
        [
            363681912.2348372,
            -4638709926.284518,
            -1585304087.494862,
        ],
    ],
    [
        1292198400000,
        [
            384870393.5934917,
            -4642274911.680906,
            -1587859518.173709,
        ],
    ],
    [
        1292803200000,
        [
            406410251.6527834,
            -4643812020.351364,
            -1589537311.884244,
        ],
    ],
    [
        1293408000000,
        [
            428031460.6230091,
            -4643304304.840112,
            -1590329116.379375,
        ],
    ],
    [
        1294012800000,
        [
            449468314.8243796,
            -4640749980.31503,
            -1590232425.665186,
        ],
    ],
    [
        1294617600000,
        [
            470436500.891858,
            -4636175282.889079,
            -1589259176.617208,
        ],
    ],
    [
        1295222400000,
        [
            490657712.4503407,
            -4629656530.84629,
            -1587443509.059041,
        ],
    ],
    [
        1295827200000,
        [
            509883931.3886656,
            -4621303948.019035,
            -1584832703.940826,
        ],
    ],
    [
        1296432000000,
        [
            527887301.308674,
            -4611238378.045808,
            -1581478375.852098,
        ],
    ],
    [
        1297036800000,
        [
            544438315.8527076,
            -4599606374.64511,
            -1577445514.250456,
        ],
    ],
    [
        1297641600000,
        [
            559333148.152494,
            -4586596204.452573,
            -1572816940.559616,
        ],
    ],
    [
        1298246400000,
        [
            572412913.4078462,
            -4572417193.20628,
            -1567682585.491619,
        ],
    ],
    [
        1298851200000,
        [
            583549125.2357458,
            -4557276170.111581,
            -1562130927.476695,
        ],
    ],
    [
        1299456000000,
        [
            592622628.8561349,
            -4541394941.131442,
            -1556258910.709766,
        ],
    ],
    [
        1300060800000,
        [
            599551933.5908179,
            -4525021480.278262,
            -1550174262.700131,
        ],
    ],
    [
        1300665600000,
        [
            604306219.540652,
            -4508406625.362452,
            -1543984340.620749,
        ],
    ],
    [
        1301270400000,
        [
            606885622.5956308,
            -4491782824.980147,
            -1537789025.644765,
        ],
    ],
    [
        1301875200000,
        [
            607301223.7152877,
            -4475385016.858702,
            -1531691608.11704,
        ],
    ],
    [
        1302480000000,
        [
            605603340.0666759,
            -4459458660.585958,
            -1525799291.675874,
        ],
    ],
    [
        1303084800000,
        [
            601888613.3404949,
            -4444235420.921597,
            -1520211779.129271,
        ],
    ],
    [
        1303689600000,
        [
            596275844.8733946,
            -4429915846.908061,
            -1515015897.018017,
        ],
    ],
    [
        1304294400000,
        [
            588889026.8448586,
            -4416693484.163807,
            -1510297138.946118,
        ],
    ],
    [
        1304899200000,
        [
            579885859.1193539,
            -4404760008.681177,
            -1506138731.893809,
        ],
    ],
    [
        1305504000000,
        [
            569460474.3943523,
            -4394280591.163145,
            -1502610670.244241,
        ],
    ],
    [
        1306108800000,
        [
            557816038.0865042,
            -4385381324.451209,
            -1499766944.502185,
        ],
    ],
    [
        1306713600000,
        [
            545152453.7159551,
            -4378176210.08988,
            -1497658018.380895,
        ],
    ],
    [
        1307318400000,
        [
            531694580.6624811,
            -4372769536.931475,
            -1496328874.114097,
        ],
    ],
    [
        1307923200000,
        [
            517691264.0731129,
            -4369231768.456121,
            -1495808711.672058,
        ],
    ],
    [
        1308528000000,
        [
            503385297.0175233,
            -4367592260.811969,
            -1496110561.494989,
        ],
    ],
    [
        1309132800000,
        [
            489006693.6029695,
            -4367868433.582715,
            -1497243830.292157,
        ],
    ],
    [
        1309737600000,
        [
            474800005.1455601,
            -4370064857.269497,
            -1499210743.760735,
        ],
    ],
    [
        1310342400000,
        [
            461020469.7451641,
            -4374149731.619749,
            -1501996408.735782,
        ],
    ],
    [
        1310947200000,
        [
            447902564.3627729,
            -4380052494.397532,
            -1505570564.035247,
        ],
    ],
    [
        1311552000000,
        [
            435659724.0181028,
            -4387694027.291366,
            -1509900020.16598,
        ],
    ],
    [
        1312156800000,
        [
            424510257.8663626,
            -4396982023.588314,
            -1514943983.868788,
        ],
    ],
    [
        1312761600000,
        [
            414670882.5844612,
            -4407788587.45229,
            -1520645226.070283,
        ],
    ],
    [
        1313366400000,
        [
            406324601.0406088,
            -4419952940.057532,
            -1526934282.524203,
        ],
    ],
    [
        1313971200000,
        [
            399626596.8289427,
            -4433312360.645144,
            -1533741705.585779,
        ],
    ],
    [
        1314576000000,
        [
            394727809.213539,
            -4447694325.350524,
            -1540992313.838524,
        ],
    ],
    [
        1315180800000,
        [
            391765709.9321173,
            -4462896087.118346,
            -1548597350.343265,
        ],
    ],
    [
        1315785600000,
        [
            390832646.8465328,
            -4478692446.356896,
            -1556460453.049692,
        ],
    ],
    [
        1316390400000,
        [
            391988017.7752191,
            -4494866607.252989,
            -1564488997.210338,
        ],
    ],
    [
        1316995200000,
        [
            395279830.6994649,
            -4511199134.750643,
            -1572587238.972451,
        ],
    ],
    [
        1317600000000,
        [
            400733496.9744467,
            -4527449702.714456,
            -1580649773.07158,
        ],
    ],
    [
        1318204800000,
        [
            408322590.3616328,
            -4543369457.186622,
            -1588569432.409183,
        ],
    ],
    [
        1318809600000,
        [
            417987422.2208096,
            -4558730859.026505,
            -1596247932.167094,
        ],
    ],
    [
        1319414400000,
        [
            429655061.1453061,
            -4573313914.767952,
            -1603588561.570058,
        ],
    ],
    [
        1320019200000,
        [
            443226458.7483061,
            -4586890486.051215,
            -1610491287.289952,
        ],
    ],
    [
        1320624000000,
        [
            458550981.3347363,
            -4599240972.62492,
            -1616862233.127144,
        ],
    ],
    [
        1321228800000,
        [
            475450861.11075,
            -4610181914.077481,
            -1622622781.47466,
        ],
    ],
    [
        1321833600000,
        [
            493740162.7205178,
            -4619549406.857967,
            -1627701203.587606,
        ],
    ],
    [
        1322438400000,
        [
            513210774.6680729,
            -4627185125.137266,
            -1632028532.557127,
        ],
    ],
    [
        1323043200000,
        [
            533612207.8862141,
            -4632955845.921924,
            -1635548655.362558,
        ],
    ],
    [
        1323648000000,
        [
            554681484.210776,
            -4636776240.048771,
            -1638224997.748635,
        ],
    ],
    [
        1324252800000,
        [
            576161316.4937323,
            -4638588542.006926,
            -1640031029.539743,
        ],
    ],
    [
        1324857600000,
        [
            597784950.5901808,
            -4638348898.311738,
            -1640946789.887239,
        ],
    ],
    [
        1325462400000,
        [
            619261221.6552682,
            -4636048517.090038,
            -1640969484.196305,
        ],
    ],
    [
        1326067200000,
        [
            640307747.6831298,
            -4631729793.825845,
            -1640117427.733094,
        ],
    ],
    [
        1326672000000,
        [
            660666456.6970172,
            -4625462303.507753,
            -1638419443.603447,
        ],
    ],
    [
        1327276800000,
        [
            680085766.4174275,
            -4617329058.521758,
            -1635911454.988053,
        ],
    ],
    [
        1327881600000,
        [
            698309408.141367,
            -4607448848.970308,
            -1632646798.396526,
        ],
    ],
    [
        1328486400000,
        [
            715110294.5535417,
            -4595984776.426735,
            -1628696632.026858,
        ],
    ],
    [
        1329091200000,
        [
            730301294.2549638,
            -4583117174.324006,
            -1624138165.311402,
        ],
    ],
    [
        1329696000000,
        [
            743713941.4868037,
            -4569029985.57841,
            -1619051254.75035,
        ],
    ],
    [
        1330300800000,
        [
            755190091.27918,
            -4553934298.025995,
            -1613528639.156356,
        ],
    ],
    [
        1330905600000,
        [
            764614714.5901309,
            -4538069800.740438,
            -1607673618.810035,
        ],
    ],
    [
        1331510400000,
        [
            771920399.3519192,
            -4521676504.322217,
            -1601588513.571004,
        ],
    ],
    [
        1332115200000,
        [
            777062319.291163,
            -4504983108.412245,
            -1595372404.735337,
        ],
    ],
    [
        1332720000000,
        [
            780012033.4160497,
            -4488232766.184432,
            -1589131854.766795,
        ],
    ],
    [
        1333324800000,
        [
            780788038.1827346,
            -4471679434.476598,
            -1582976574.606121,
        ],
    ],
    [
        1333929600000,
        [
            779453502.9316885,
            -4455560592.459291,
            -1577008613.15342,
        ],
    ],
    [
        1334534400000,
        [
            776088371.9201486,
            -4440089419.847536,
            -1571321416.567769,
        ],
    ],
    [
        1335139200000,
        [
            770786070.3614144,
            -4425482721.091745,
            -1566010588.394507,
        ],
    ],
    [
        1335744000000,
        [
            763682264.3165452,
            -4411953220.76803,
            -1561167846.503229,
        ],
    ],
    [
        1336348800000,
        [
            754947164.644716,
            -4399684033.457763,
            -1556871362.556726,
        ],
    ],
    [
        1336953600000,
        [
            744756606.3421543,
            -4388825454.020441,
            -1553186822.20129,
        ],
    ],
    [
        1337558400000,
        [
            733292890.0558528,
            -4379524141.419465,
            -1550178467.22346,
        ],
    ],
    [
        1338163200000,
        [
            720771917.7071235,
            -4371912195.750537,
            -1547902244.449761,
        ],
    ],
    [
        1338768000000,
        [
            707430999.8776419,
            -4366083984.391501,
            -1546397751.031521,
        ],
    ],
    [
        1339372800000,
        [
            693499759.4326141,
            -4362098353.736053,
            -1545691500.199829,
        ],
    ],
    [
        1339977600000,
        [
            679205498.0394804,
            -4360008143.480502,
            -1545807577.30098,
        ],
    ],
    [
        1340582400000,
        [
            664798171.6239625,
            -4359846524.141146,
            -1546759736.664801,
        ],
    ],
    [
        1341187200000,
        [
            650534646.5762902,
            -4361606102.648683,
            -1548544317.363503,
        ],
    ],
    [
        1341792000000,
        [
            636650451.919743,
            -4365246394.651338,
            -1551145235.594851,
        ],
    ],
    [
        1342396800000,
        [
            623370388.906645,
            -4370722091.66889,
            -1554543633.453984,
        ],
    ],
    [
        1343001600000,
        [
            610930996.8799078,
            -4377966607.594138,
            -1558709307.077004,
        ],
    ],
    [
        1343606400000,
        [
            599562279.2494719,
            -4386873337.382331,
            -1563594962.906286,
        ],
    ],
    [
        1344211200000,
        [
            589460998.3379227,
            -4397308371.71349,
            -1569143386.317361,
        ],
    ],
    [
        1344816000000,
        [
            580806446.2077974,
            -4409136838.635906,
            -1575296222.548224,
        ],
    ],
    [
        1345420800000,
        [
            573779261.6791995,
            -4422204516.207891,
            -1581985281.064002,
        ],
    ],
    [
        1346025600000,
        [
            568540952.034647,
            -4436321958.13761,
            -1589128129.020346,
        ],
    ],
    [
        1346630400000,
        [
            565209138.8538841,
            -4451282541.01816,
            -1596636931.17113,
        ],
    ],
    [
        1347235200000,
        [
            563878373.0900433,
            -4466886335.667081,
            -1604425635.77397,
        ],
    ],
    [
        1347840000000,
        [
            564635001.409239,
            -4482920248.653346,
            -1612400980.557028,
        ],
    ],
    [
        1348444800000,
        [
            567535717.3967478,
            -4499145170.040448,
            -1620459284.552948,
        ],
    ],
    [
        1349049600000,
        [
            572586199.5731075,
            -4515318498.553,
            -1628496735.33768,
        ],
    ],
    [
        1349654400000,
        [
            579767377.5613811,
            -4531214795.836576,
            -1636415168.878883,
        ],
    ],
    [
        1350259200000,
        [
            589046746.7361116,
            -4546604852.351194,
            -1644113494.489543,
        ],
    ],
    [
        1350864000000,
        [
            600356998.2776048,
            -4561246291.28019,
            -1651486278.059069,
        ],
    ],
    [
        1351468800000,
        [
            613579069.7622147,
            -4574909802.628929,
            -1658435364.747308,
        ],
    ],
    [
        1352073600000,
        [
            628573433.6367514,
            -4587396222.815545,
            -1664874078.401185,
        ],
    ],
    [
        1352678400000,
        [
            645188199.1528575,
            -4598514719.006615,
            -1670718703.375552,
        ],
    ],
    [
        1353283200000,
        [
            663238546.487743,
            -4608076663.878071,
            -1675888163.687416,
        ],
    ],
    [
        1353888000000,
        [
            682495333.9102104,
            -4615923702.737529,
            -1680315691.478809,
        ],
    ],
    [
        1354492800000,
        [
            702720974.6108066,
            -4621939701.376898,
            -1683950623.608346,
        ],
    ],
    [
        1355097600000,
        [
            723675198.6271553,
            -4626026892.199012,
            -1686749397.131594,
        ],
    ],
    [
        1355702400000,
        [
            745095756.8009759,
            -4628101733.435911,
            -1688676038.225295,
        ],
    ],
    [
        1356307200000,
        [
            766693113.409688,
            -4628122604.621955,
            -1689713446.522477,
        ],
    ],
    [
        1356912000000,
        [
            788189001.8914598,
            -4626095155.748178,
            -1689862853.912273,
        ],
    ],
    [
        1357516800000,
        [
            809319161.7536973,
            -4622045900.373323,
            -1689134349.999303,
        ],
    ],
    [
        1358121600000,
        [
            829813805.6740967,
            -4616019499.023092,
            -1687547904.899095,
        ],
    ],
    [
        1358726400000,
        [
            849397149.698792,
            -4608105119.526142,
            -1685143527.455621,
        ],
    ],
    [
        1359331200000,
        [
            867825290.7561723,
            -4598434553.789593,
            -1681977792.47173,
        ],
    ],
    [
        1359936000000,
        [
            884884462.362711,
            -4587153606.049286,
            -1678113421.995682,
        ],
    ],
    [
        1360540800000,
        [
            900369753.941742,
            -4574420570.198371,
            -1673620305.874651,
        ],
    ],
    [
        1361145600000,
        [
            914088547.9497921,
            -4560430969.602437,
            -1668584275.490862,
        ],
    ],
    [
        1361750400000,
        [
            925895191.224755,
            -4545408559.813662,
            -1663101111.170782,
        ],
    ],
    [
        1362355200000,
        [
            935683917.7201076,
            -4529576075.41873,
            -1657266262.975712,
        ],
    ],
    [
        1362960000000,
        [
            943365124.3657084,
            -4513155823.573565,
            -1651176790.002442,
        ],
    ],
    [
        1363564800000,
        [
            948871969.1022227,
            -4496393960.774922,
            -1644939692.500247,
        ],
    ],
    [
        1364169600000,
        [
            952189993.9310272,
            -4479546141.298773,
            -1638664395.952481,
        ],
    ],
    [
        1364774400000,
        [
            953344242.4285235,
            -4462850383.390326,
            -1632453578.827623,
        ],
    ],
    [
        1365379200000,
        [
            952373378.1215025,
            -4446531209.716394,
            -1626406206.493819,
        ],
    ],
    [
        1365984000000,
        [
            949339489.3370119,
            -4430824305.488019,
            -1620625304.299964,
        ],
    ],
    [
        1366588800000,
        [
            944352669.4127104,
            -4415958105.37872,
            -1615209018.198885,
        ],
    ],
    [
        1367193600000,
        [
            937553510.5773839,
            -4402130252.711518,
            -1610242869.074035,
        ],
    ],
    [
        1367798400000,
        [
            929087029.8552306,
            -4389515522.878487,
            -1605804054.415406,
        ],
    ],
    [
        1368403200000,
        [
            919116550.3978046,
            -4378290377.156466,
            -1601968963.700688,
        ],
    ],
    [
        1369008000000,
        [
            907844062.0204079,
            -4368611266.027972,
            -1598803673.713826,
        ],
    ],
    [
        1369612800000,
        [
            895489256.0791652,
            -4360595514.974127,
            -1596358409.037407,
        ],
    ],
    [
        1370217600000,
        [
            882264642.1953768,
            -4354333361.263124,
            -1594673501.545702,
        ],
    ],
    [
        1370822400000,
        [
            868393273.0491786,
            -4349911836.673479,
            -1593786551.387827,
        ],
    ],
    [
        1371427200000,
        [
            854124943.2886342,
            -4347390703.87784,
            -1593722390.043016,
        ],
    ],
    [
        1372032000000,
        [
            839712422.3883839,
            -4346787982.127378,
            -1594489241.123836,
        ],
    ],
    [
        1372636800000,
        [
            825388912.7318337,
            -4348095905.369062,
            -1596085655.205468,
        ],
    ],
    [
        1373241600000,
        [
            811389475.6754222,
            -4351302703.847023,
            -1598506518.291492,
        ],
    ],
    [
        1373846400000,
        [
            797963476.5733069,
            -4356366432.456964,
            -1601732515.258975,
        ],
    ],
    [
        1374451200000,
        [
            785349076.387575,
            -4363204562.676672,
            -1605727951.096114,
        ],
    ],
    [
        1375056000000,
        [
            773754157.6365927,
            -4371713534.419968,
            -1610448947.694051,
        ],
    ],
    [
        1375660800000,
        [
            763380986.946625,
            -4381787391.75841,
            -1615848534.615264,
        ],
    ],
    [
        1376265600000,
        [
            754434587.7967523,
            -4393290600.32545,
            -1621866464.138294,
        ],
    ],
    [
        1376870400000,
        [
            747095804.4319756,
            -4406051872.031478,
            -1628428838.116825,
        ],
    ],
    [
        1377475200000,
        [
            741505975.7685344,
            -4419887646.944736,
            -1635457463.066157,
        ],
    ],
    [
        1378080000000,
        [
            737794019.4596641,
            -4434617110.013924,
            -1642873463.721288,
        ],
    ],
    [
        1378684800000,
        [
            736080497.5455573,
            -4450035184.81067,
            -1650587368.561687,
        ],
    ],
    [
        1379289600000,
        [
            736450248.1813984,
            -4465910314.090778,
            -1658499949.27825,
        ],
    ],
    [
        1379894400000,
        [
            738941861.0499488,
            -4482011373.616735,
            -1666512330.832826,
        ],
    ],
    [
        1380499200000,
        [
            743577422.011312,
            -4498118157.839904,
            -1674527956.006855,
        ],
    ],
    [
        1381104000000,
        [
            750362908.0072908,
            -4513995307.516445,
            -1682443605.286264,
        ],
    ],
    [
        1381708800000,
        [
            759261871.8070492,
            -4529393705.633353,
            -1690151828.952579,
        ],
    ],
    [
        1382313600000,
        [
            770190529.8410821,
            -4544080253.375448,
            -1697552099.959474,
        ],
    ],
    [
        1382918400000,
        [
            783050038.9151049,
            -4557843504.948001,
            -1704551310.944578,
        ],
    ],
    [
        1383523200000,
        [
            797723453.2770663,
            -4570469385.701912,
            -1711055916.459237,
        ],
    ],
    [
        1384128000000,
        [
            814051505.0079039,
            -4581745901.991473,
            -1716975417.223665,
        ],
    ],
    [
        1384732800000,
        [
            831833692.3979139,
            -4591494396.290111,
            -1722233521.321097,
        ],
    ],
    [
        1385337600000,
        [
            850863018.9854153,
            -4599569317.456708,
            -1726766280.422125,
        ],
    ],
    [
        1385942400000,
        [
            870920234.5394388,
            -4605835032.712575,
            -1730514630.772701,
        ],
    ],
    [
        1386547200000,
        [
            891752940.1173457,
            -4610172406.582402,
            -1733428233.745624,
        ],
    ],
    [
        1387152000000,
        [
            913082895.0527966,
            -4612508934.606628,
            -1735475954.608566,
        ],
    ],
    [
        1387756800000,
        [
            934642439.5968014,
            -4612811388.205044,
            -1736641664.842775,
        ],
    ],
    [
        1388361600000,
        [
            956165810.5868645,
            -4611062744.068983,
            -1736917199.663524,
        ],
    ],
    [
        1388966400000,
        [
            977370988.7083935,
            -4607269831.999934,
            -1736306495.957098,
        ],
    ],
    [
        1389571200000,
        [
            997971603.1371311,
            -4601490612.136558,
            -1734834802.987666,
        ],
    ],
    [
        1390176000000,
        [
            1017712199.627136,
            -4593819668.340032,
            -1732541943.281525,
        ],
    ],
    [
        1390780800000,
        [
            1036355207.139413,
            -4584364978.817857,
            -1729475002.924907,
        ],
    ],
    [
        1391385600000,
        [
            1053663908.059551,
            -4573256491.561416,
            -1725692107.007634,
        ],
    ],
    [
        1391990400000,
        [
            1069417321.382751,
            -4560669475.765708,
            -1721269546.129335,
        ],
    ],
    [
        1392595200000,
        [
            1083441620.133893,
            -4546803480.879239,
            -1716292668.443293,
        ],
    ],
    [
        1393200000000,
        [
            1095592168.833046,
            -4531859360.792759,
            -1710848613.56014,
        ],
    ],
    [
        1393804800000,
        [
            1105736576.786176,
            -4516049435.513194,
            -1705030451.316255,
        ],
    ],
    [
        1394409600000,
        [
            1113771691.62782,
            -4499617338.8525,
            -1698943006.864176,
        ],
    ],
    [
        1395014400000,
        [
            1119648895.820702,
            -4482812598.677194,
            -1692692765.970239,
        ],
    ],
    [
        1395619200000,
        [
            1123351087.001173,
            -4465870011.751554,
            -1686381703.984185,
        ],
    ],
    [
        1396224000000,
        [
            1124875166.023769,
            -4449022989.337486,
            -1680112391.553887,
        ],
    ],
    [
        1396828800000,
        [
            1124250921.993283,
            -4432521096.438934,
            -1673992698.60646,
        ],
    ],
    [
        1397433600000,
        [
            1121559273.609401,
            -4416602327.280072,
            -1668125019.994653,
        ],
    ],
    [
        1398038400000,
        [
            1116905558.597852,
            -4401476462.429518,
            -1662601329.032206,
        ],
    ],
    [
        1398643200000,
        [
            1110402544.425864,
            -4387341878.397423,
            -1657509169.438557,
        ],
    ],
    [
        1399248000000,
        [
            1102192300.017082,
            -4374400772.525532,
            -1652935379.649797,
        ],
    ],
    [
        1399852800000,
        [
            1092458037.321328,
            -4362830020.608262,
            -1648955315.760324,
        ],
    ],
    [
        1400457600000,
        [
            1081395667.999556,
            -4352769380.131949,
            -1645629924.95369,
        ],
    ],
    [
        1401062400000,
        [
            1069198555.660987,
            -4344341532.074507,
            -1643013111.382603,
        ],
    ],
    [
        1401667200000,
        [
            1056082535.631513,
            -4337664938.800963,
            -1641154899.943781,
        ],
    ],
    [
        1402272000000,
        [
            1042291515.10246,
            -4332824236.450783,
            -1640091018.018056,
        ],
    ],
    [
        1402876800000,
        [
            1028068270.597833,
            -4329863966.32543,
            -1639841883.511477,
        ],
    ],
    [
        1403481600000,
        [
            1013641663.108681,
            -4328811328.559901,
            -1640420653.134258,
        ],
    ],
    [
        1404086400000,
        [
            999254363.6908795,
            -4329686067.631766,
            -1641835150.418531,
        ],
    ],
    [
        1404691200000,
        [
            985162813.904719,
            -4332470603.19852,
            -1644077437.958138,
        ],
    ],
    [
        1405296000000,
        [
            971608463.6850637,
            -4337108889.427201,
            -1647124393.545142,
        ],
    ],
    [
        1405900800000,
        [
            958808599.7648368,
            -4343530820.498176,
            -1650946234.730959,
        ],
    ],
    [
        1406505600000,
        [
            946986172.9435754,
            -4351658418.733361,
            -1655507483.710836,
        ],
    ],
    [
        1407110400000,
        [
            936364667.3417943,
            -4361376279.027177,
            -1660757246.642729,
        ],
    ],
    [
        1407715200000,
        [
            927140203.9304283,
            -4372535561.472345,
            -1666631787.167242,
        ],
    ],
    [
        1408320000000,
        [
            919476330.1455047,
            -4384979927.0955,
            -1673063644.909579,
        ],
    ],
    [
        1408924800000,
        [
            913534482.4154336,
            -4398548183.857873,
            -1679981604.285473,
        ],
    ],
    [
        1409529600000,
        [
            909464028.0012373,
            -4413046214.974258,
            -1687301657.915486,
        ],
    ],
    [
        1410134400000,
        [
            907375586.6273171,
            -4428255939.290753,
            -1694930975.12704,
        ],
    ],
    [
        1410739200000,
        [
            907340614.0684018,
            -4443962352.420843,
            -1702776993.156074,
        ],
    ],
    [
        1411344000000,
        [
            909421984.2072458,
            -4459952229.483645,
            -1710746030.255286,
        ],
    ],
    [
        1411948800000,
        [
            913660563.7781504,
            -4475988168.627568,
            -1718735190.757842,
        ],
    ],
    [
        1412553600000,
        [
            920050894.6423193,
            -4491821726.302113,
            -1726637829.130248,
        ],
    ],
    [
        1413158400000,
        [
            928546720.9510734,
            -4507221012.522962,
            -1734352971.506093,
        ],
    ],
    [
        1413763200000,
        [
            939091349.8167791,
            -4521965243.570057,
            -1741783011.067251,
        ],
    ],
    [
        1414368000000,
        [
            951601773.2345102,
            -4535821939.968036,
            -1748827132.529143,
        ],
    ],
    [
        1414972800000,
        [
            965947346.220688,
            -4548563621.676509,
            -1755388037.316874,
        ],
    ],
    [
        1415577600000,
        [
            981961660.6182966,
            -4559995336.961055,
            -1761381164.099112,
        ],
    ],
    [
        1416182400000,
        [
            999472309.2439644,
            -4569944417.417833,
            -1766730688.462229,
        ],
    ],
    [
        1416787200000,
        [
            1018283602.062491,
            -4578240889.2782,
            -1771363793.680751,
        ],
    ],
    [
        1417392000000,
        [
            1038159274.180905,
            -4584735873.430211,
            -1775217559.566548,
        ],
    ],
    [
        1417996800000,
        [
            1058841030.386366,
            -4589327029.698896,
            -1778247168.675767,
        ],
    ],
    [
        1418601600000,
        [
            1080077529.690844,
            -4591941935.109876,
            -1780419826.294791,
        ],
    ],
    [
        1419206400000,
        [
            1101606206.24701,
            -4592520930.23035,
            -1781709899.574479,
        ],
    ],
    [
        1419811200000,
        [
            1123140098.810765,
            -4591035445.372536,
            -1782105755.73634,
        ],
    ],
    [
        1420416000000,
        [
            1144391451.229171,
            -4587509722.625233,
            -1781616744.182459,
        ],
    ],
    [
        1421020800000,
        [
            1165097975.812437,
            -4581997390.705646,
            -1780264949.618805,
        ],
    ],
    [
        1421625600000,
        [
            1185002417.361442,
            -4574566559.304276,
            -1778080818.838416,
        ],
    ],
    [
        1422230400000,
        [
            1203842153.011891,
            -4565317363.720483,
            -1775109171.141082,
        ],
    ],
    [
        1422835200000,
        [
            1221375168.957059,
            -4554398959.203523,
            -1771414060.897081,
        ],
    ],
    [
        1423440000000,
        [
            1237401441.847192,
            -4541979823.50737,
            -1767068103.096865,
        ],
    ],
    [
        1424044800000,
        [
            1251739185.57662,
            -4528235025.265503,
            -1762148361.215998,
        ],
    ],
    [
        1424649600000,
        [
            1264216367.131744,
            -4513363080.882028,
            -1756741731.415915,
        ],
    ],
    [
        1425254400000,
        [
            1274697199.478369,
            -4497598120.770204,
            -1750948142.490617,
        ],
    ],
    [
        1425859200000,
        [
            1283097065.883658,
            -4481176072.565473,
            -1744868827.741543,
        ],
    ],
    [
        1426464000000,
        [
            1289354931.240936,
            -4464325285.636328,
            -1738603489.276302,
        ],
    ],
    [
        1427068800000,
        [
            1293426049.195083,
            -4447284369.951096,
            -1732256050.207152,
        ],
    ],
    [
        1427673600000,
        [
            1295307798.193262,
            -4430310703.466982,
            -1725936694.972252,
        ],
    ],
    [
        1428278400000,
        [
            1295047223.37866,
            -4413645539.340162,
            -1719749865.198593,
        ],
    ],
    [
        1428883200000,
        [
            1292710332.280228,
            -4397509211.837816,
            -1713792728.594617,
        ],
    ],
    [
        1429488000000,
        [
            1288376490.850346,
            -4382120980.425728,
            -1708161288.543784,
        ],
    ],
    [
        1430092800000,
        [
            1282164267.560922,
            -4367704048.888603,
            -1702951130.318623,
        ],
    ],
    [
        1430697600000,
        [
            1274232319.059028,
            -4354451310.876397,
            -1698245720.599385,
        ],
    ],
    [
        1431302400000,
        [
            1264747765.872238,
            -4342525294.258034,
            -1694116581.820168,
        ],
    ],
    [
        1431907200000,
        [
            1253883360.865061,
            -4332080014.039881,
            -1690630355.714048,
        ],
    ],
    [
        1432512000000,
        [
            1241844050.360152,
            -4323262342.497454,
            -1687848806.356544,
        ],
    ],
    [
        1433116800000,
        [
            1228861577.794246,
            -4316179812.314192,
            -1685818247.971244,
        ],
    ],
    [
        1433721600000,
        [
            1215163394.048796,
            -4310905596.687407,
            -1684571586.282357,
        ],
    ],
    [
        1434326400000,
        [
            1200972724.203387,
            -4307502176.440377,
            -1684136067.586732,
        ],
    ],
    [
        1434931200000,
        [
            1186535675.238034,
            -4306018843.71939,
            -1684532018.690237,
        ],
    ],
    [
        1435536000000,
        [
            1172109885.519124,
            -4306462215.92179,
            -1685763032.458167,
        ],
    ],
    [
        1436140800000,
        [
            1157935477.682487,
            -4308805748.701453,
            -1687819228.105871,
        ],
    ],
    [
        1436745600000,
        [
            1144238492.330602,
            -4313014053.600345,
            -1690685125.262079,
        ],
    ],
    [
        1437350400000,
        [
            1131258468.073116,
            -4319035957.488245,
            -1694337099.134494,
        ],
    ],
    [
        1437955200000,
        [
            1119231885.610443,
            -4326777947.145243,
            -1698734796.389088,
        ],
    ],
    [
        1438560000000,
        [
            1108366247.624219,
            -4336117852.994226,
            -1703826016.597486,
        ],
    ],
    [
        1439164800000,
        [
            1098846800.69073,
            -4346929227.947661,
            -1709554968.224556,
        ],
    ],
    [
        1439769600000,
        [
            1090863501.361351,
            -4359070552.450163,
            -1715858864.771387,
        ],
    ],
    [
        1440374400000,
        [
            1084589500.308642,
            -4372362479.793015,
            -1722660756.334285,
        ],
    ],
    [
        1440979200000,
        [
            1080158666.989443,
            -4386605755.659577,
            -1729875689.225609,
        ],
    ],
    [
        1441584000000,
        [
            1077675601.499825,
            -4401605172.066003,
            -1737418654.031807,
        ],
    ],
    [
        1442188800000,
        [
            1077241307.909495,
            -4417155450.844772,
            -1745199986.54424,
        ],
    ],
    [
        1442793600000,
        [
            1078928076.19152,
            -4433022456.11812,
            -1753119379.810477,
        ],
    ],
    [
        1443398400000,
        [
            1082761478.192618,
            -4448964685.317244,
            -1761073160.996794,
        ],
    ],
    [
        1444003200000,
        [
            1088734636.501581,
            -4464755865.924864,
            -1768961976.144757,
        ],
    ],
    [
        1444608000000,
        [
            1096832433.2032,
            -4480167963.370992,
            -1776685618.481044,
        ],
    ],
    [
        1445212800000,
        [
            1107004395.757504,
            -4494956624.071207,
            -1784138797.008439,
        ],
    ],
    [
        1445817600000,
        [
            1119151616.830109,
            -4508885805.808922,
            -1791219740.63235,
        ],
    ],
    [
        1446422400000,
        [
            1133145772.219792,
            -4521748446.517582,
            -1797837467.815013,
        ],
    ],
    [
        1447027200000,
        [
            1148851254.217023,
            -4533346982.71166,
            -1803905805.13705,
        ],
    ],
    [
        1447632000000,
        [
            1166097531.227905,
            -4543482938.845985,
            -1809340275.211584,
        ],
    ],
    [
        1448236800000,
        [
            1184671326.427332,
            -4551983271.277505,
            -1814066960.759819,
        ],
    ],
    [
        1448841600000,
        [
            1204341045.656435,
            -4558717420.237347,
            -1818028335.929259,
        ],
    ],
    [
        1449446400000,
        [
            1224876609.27088,
            -4563574231.520622,
            -1821175860.285603,
        ],
    ],
    [
        1450051200000,
        [
            1246022856.648511,
            -4566454574.885575,
            -1823467646.415437,
        ],
    ],
    [
        1450656000000,
        [
            1267496895.345688,
            -4567297174.987579,
            -1824877182.559967,
        ],
    ],
    [
        1451260800000,
        [
            1289017319.673916,
            -4566090391.551726,
            -1825397612.694674,
        ],
    ],
    [
        1451865600000,
        [
            1310320142.766284,
            -4562844760.006872,
            -1825032947.841503,
        ],
    ],
    [
        1452470400000,
        [
            1331132869.684681,
            -4557588304.12426,
            -1823796441.886244,
        ],
    ],
    [
        1453075200000,
        [
            1351175197.929906,
            -4550390517.138114,
            -1821718477.17937,
        ],
    ],
    [
        1453680000000,
        [
            1370190486.232473,
            -4541368293.100722,
            -1818848617.500409,
        ],
    ],
    [
        1454284800000,
        [
            1387955476.745457,
            -4530654113.271229,
            -1815244848.620226,
        ],
    ],
    [
        1454889600000,
        [
            1404254092.652716,
            -4518394064.350646,
            -1810972195.919644,
        ],
    ],
    [
        1455494400000,
        [
            1418880080.553927,
            -4504769173.498916,
            -1806109285.673228,
        ],
    ],
    [
        1456099200000,
        [
            1431668469.09683,
            -4489995659.871375,
            -1800748339.20062,
        ],
    ],
    [
        1456704000000,
        [
            1442497801.84998,
            -4474289947.187971,
            -1794983272.485961,
        ],
    ],
    [
        1457308800000,
        [
            1451263054.224306,
            -4457870313.417874,
            -1788909546.243655,
        ],
    ],
    [
        1457913600000,
        [
            1457879383.487225,
            -4440976429.810098,
            -1782630349.787688,
        ],
    ],
    [
        1458518400000,
        [
            1462311595.25433,
            -4423865621.906482,
            -1776255512.371844,
        ],
    ],
    [
        1459123200000,
        [
            1464568295.733512,
            -4406777515.462765,
            -1769889502.588226,
        ],
    ],
    [
        1459728000000,
        [
            1464673783.005627,
            -4389940764.199745,
            -1763632868.678732,
        ],
    ],
    [
        1460332800000,
        [
            1462673069.714599,
            -4373592005.711218,
            -1757588121.682513,
        ],
    ],
    [
        1460937600000,
        [
            1458658907.395445,
            -4357969173.842481,
            -1751857492.376428,
        ],
    ],
    [
        1461542400000,
        [
            1452759083.087831,
            -4343277817.613203,
            -1746531208.135218,
        ],
    ],
    [
        1462147200000,
        [
            1445108786.355596,
            -4329702899.695845,
            -1741690589.905915,
        ],
    ],
    [
        1462752000000,
        [
            1435858279.603953,
            -4317427330.425299,
            -1737414058.313999,
        ],
    ],
    [
        1463356800000,
        [
            1425198009.491741,
            -4306622325.988668,
            -1733774270.100137,
        ],
    ],
    [
        1463961600000,
        [
            1413340492.243244,
            -4297417007.718029,
            -1730827733.003497,
        ],
    ],
    [
        1464566400000,
        [
            1400494356.796078,
            -4289914998.158277,
            -1728619914.284622,
        ],
    ],
    [
        1465171200000,
        [
            1386875019.670363,
            -4284212776.592129,
            -1727191612.258813,
        ],
    ],
    [
        1465776000000,
        [
            1372727601.505952,
            -4280387061.935164,
            -1726575264.007598,
        ],
    ],
    [
        1466380800000,
        [
            1358304157.13843,
            -4278468964.850549,
            -1726785840.459198,
        ],
    ],
    [
        1466985600000,
        [
            1343840394.014157,
            -4278464510.297151,
            -1727827114.414874,
        ],
    ],
    [
        1467590400000,
        [
            1329569551.465595,
            -4280372259.002748,
            -1729697747.682109,
        ],
    ],
    [
        1468195200000,
        [
            1315743178.127745,
            -4284167010.307899,
            -1732386302.651801,
        ],
    ],
    [
        1468800000000,
        [
            1302604860.895429,
            -4289778875.349957,
            -1735863659.606011,
        ],
    ],
    [
        1469404800000,
        [
            1290370829.944209,
            -4297116529.803569,
            -1740090439.902706,
        ],
    ],
    [
        1470009600000,
        [
            1279246879.472121,
            -4306083673.734545,
            -1745023177.855836,
        ],
    ],
    [
        1470614400000,
        [
            1269446507.121748,
            -4316559247.911103,
            -1750608549.142235,
        ],
    ],
    [
        1471219200000,
        [
            1261161549.070376,
            -4328382349.892089,
            -1756777900.592713,
        ],
    ],
    [
        1471824000000,
        [
            1254547012.873375,
            -4341377880.006361,
            -1763455686.65638,
        ],
    ],
    [
        1472428800000,
        [
            1249740254.958375,
            -4355371928.479821,
            -1770565375.479152,
        ],
    ],
    [
        1473033600000,
        [
            1246875963.632683,
            -4370169222.830559,
            -1778022569.577487,
        ],
    ],
    [
        1473638400000,
        [
            1246054601.495592,
            -4385544225.26251,
            -1785731284.233971,
        ],
    ],
    [
        1474243200000,
        [
            1247332473.788311,
            -4401268341.677591,
            -1793592857.898278,
        ],
    ],
    [
        1474848000000,
        [
            1250743404.706831,
            -4417123573.281416,
            -1801511346.595749,
        ],
    ],
    [
        1475452800000,
        [
            1256311053.324429,
            -4432877730.259487,
            -1809385958.287888,
        ],
    ],
    [
        1476057600000,
        [
            1264016704.667851,
            -4448281530.839315,
            -1817109543.83088,
        ],
    ],
    [
        1476662400000,
        [
            1273795458.659723,
            -4463096777.457643,
            -1824578351.309349,
        ],
    ],
    [
        1477267200000,
        [
            1285560461.708357,
            -4477107815.193136,
            -1831697105.058754,
        ],
    ],
    [
        1477872000000,
        [
            1299212607.697906,
            -4490095575.247847,
            -1838371088.880964,
        ],
    ],
    [
        1478476800000,
        [
            1314608815.555495,
            -4501840315.585444,
            -1844506449.314188,
        ],
    ],
    [
        1479081600000,
        [
            1331564634.843002,
            -4512149932.384857,
            -1850020008.79659,
        ],
    ],
    [
        1479686400000,
        [
            1349881224.279369,
            -4520867849.761052,
            -1854842952.831024,
        ],
    ],
    [
        1480291200000,
        [
            1369352740.863765,
            -4527845792.870903,
            -1858911965.545358,
        ],
    ],
    [
        1480896000000,
        [
            1389736724.540307,
            -4532950347.966726,
            -1862170474.932045,
        ],
    ],
    [
        1481500800000,
        [
            1410763230.69627,
            -4536089496.091795,
            -1864577950.718294,
        ],
    ],
    [
        1482105600000,
        [
            1432164482.165231,
            -4537214853.577228,
            -1866111809.951319,
        ],
    ],
    [
        1482710400000,
        [
            1453679236.245006,
            -4536292745.814857,
            -1866757857.423814,
        ],
    ],
    [
        1483315200000,
        [
            1475025593.697032,
            -4533313104.46637,
            -1866512323.888348,
        ],
    ],
    [
        1483920000000,
        [
            1495914711.006731,
            -4528313064.593751,
            -1865390343.411645,
        ],
    ],
    [
        1484524800000,
        [
            1516081144.800136,
            -4521372634.945983,
            -1863425542.007778,
        ],
    ],
    [
        1485129600000,
        [
            1535281841.882254,
            -4512584337.810977,
            -1860659393.960844,
        ],
    ],
    [
        1485734400000,
        [
            1553270686.85097,
            -4502063757.068748,
            -1857143296.884154,
        ],
    ],
    [
        1486339200000,
        [
            1569814364.149632,
            -4489969500.90729,
            -1852945448.7154,
        ],
    ],
    [
        1486944000000,
        [
            1584721440.115233,
            -4476492221.657981,
            -1848147796.896224,
        ],
    ],
    [
        1487548800000,
        [
            1597834282.389614,
            -4461823526.268168,
            -1842834618.357574,
        ],
    ],
    [
        1488153600000,
        [
            1609005184.146314,
            -4446168399.169956,
            -1837095223.741661,
        ],
    ],
    [
        1488758400000,
        [
            1618112696.451061,
            -4429761898.519053,
            -1831029958.301147,
        ],
    ],
    [
        1489363200000,
        [
            1625087794.669406,
            -4412853254.98061,
            -1824745682.501149,
        ],
    ],
    [
        1489968000000,
        [
            1629897708.572942,
            -4395676276.569272,
            -1818344774.762169,
        ],
    ],
    [
        1490572800000,
        [
            1632523509.164151,
            -4378465210.348976,
            -1811929255.807515,
        ],
    ],
    [
        1491177600000,
        [
            1632976061.247087,
            -4361469377.681181,
            -1805606180.307983,
        ],
    ],
    [
        1491782400000,
        [
            1631318468.003895,
            -4344934501.084992,
            -1799481953.316125,
        ],
    ],
    [
        1492387200000,
        [
            1627642594.782922,
            -4329076475.142555,
            -1793651965.5196,
        ],
    ],
    [
        1492992000000,
        [
            1622049271.723866,
            -4314101172.094254,
            -1788206098.064943,
        ],
    ],
    [
        1493596800000,
        [
            1614664848.861476,
            -4300217054.477232,
            -1783233531.399631,
        ],
    ],
    [
        1494201600000,
        [
            1605660451.905113,
            -4287614602.920164,
            -1778816442.773488,
        ],
    ],
    [
        1494806400000,
        [
            1595223287.536871,
            -4276444445.199957,
            -1775021125.039325,
        ],
    ],
    [
        1495411200000,
        [
            1583540604.00066,
            -4266840901.619622,
            -1771905411.292837,
        ],
    ],
    [
        1496016000000,
        [
            1570817535.025912,
            -4258932606.352599,
            -1769523370.005535,
        ],
    ],
    [
        1496620800000,
        [
            1557292916.486556,
            -4252820782.816565,
            -1767918775.866957,
        ],
    ],
    [
        1497225600000,
        [
            1543206815.334883,
            -4248562747.032948,
            -1767117920.684407,
        ],
    ],
    [
        1497830400000,
        [
            1528788489.482479,
            -4246198624.238285,
            -1767138328.816943,
        ],
    ],
    [
        1498435200000,
        [
            1514275763.018484,
            -4245759693.801996,
            -1767992672.992653,
        ],
    ],
    [
        1499040000000,
        [
            1499927191.438351,
            -4247245363.926799,
            -1769681441.805958,
        ],
    ],
    [
        1499644800000,
        [
            1485987644.04762,
            -4250612135.355082,
            -1772187288.428882,
        ],
    ],
    [
        1500249600000,
        [
            1472680819.676323,
            -4255802075.945498,
            -1775484610.774752,
        ],
    ],
    [
        1500854400000,
        [
            1460230477.915962,
            -4262748423.560742,
            -1779542867.82535,
        ],
    ],
    [
        1501459200000,
        [
            1448868658.280365,
            -4271351210.620776,
            -1784318897.934752,
        ],
    ],
    [
        1502064000000,
        [
            1438800563.371088,
            -4281472204.401372,
            -1789753571.476369,
        ],
    ],
    [
        1502668800000,
        [
            1430201404.473274,
            -4292964470.895352,
            -1795782281.737337,
        ],
    ],
    [
        1503273600000,
        [
            1423238861.137228,
            -4305675762.590996,
            -1802337774.9064,
        ],
    ],
    [
        1503878400000,
        [
            1418076611.715569,
            -4319423460.268887,
            -1809341961.396963,
        ],
    ],
    [
        1504483200000,
        [
            1414839490.77666,
            -4333996063.996366,
            -1816704657.49772,
        ],
    ],
    [
        1505088000000,
        [
            1413614847.88647,
            -4349182925.77373,
            -1824334168.862516,
        ],
    ],
    [
        1505692800000,
        [
            1414476278.635661,
            -4364775481.135625,
            -1832139263.118057,
        ],
    ],
    [
        1506297600000,
        [
            1417482950.443134,
            -4380541693.539386,
            -1840020438.51329,
        ],
    ],
    [
        1506902400000,
        [
            1422646771.119436,
            -4396233929.395874,
            -1847871049.823656,
        ],
    ],
    [
        1507507200000,
        [
            1429939082.278428,
            -4411617728.718451,
            -1855588117.04521,
        ],
    ],
    [
        1508112000000,
        [
            1439315772.967942,
            -4426470993.389978,
            -1863073962.977714,
        ],
    ],
    [
        1508716800000,
        [
            1450712943.861455,
            -4440558637.465592,
            -1870227512.238536,
        ],
    ],
    [
        1509321600000,
        [
            1464017147.717869,
            -4453646749.784952,
            -1876947904.711433,
        ],
    ],
    [
        1509926400000,
        [
            1479077676.365413,
            -4465529526.054335,
            -1883144998.461092,
        ],
    ],
    [
        1510531200000,
        [
            1495732770.176715,
            -4476026084.854313,
            -1888740009.050494,
        ],
    ],
    [
        1511136000000,
        [
            1513802451.917874,
            -4484955428.575135,
            -1893656239.447586,
        ],
    ],
    [
        1511740800000,
        [
            1533062990.104999,
            -4492155323.985354,
            -1897824142.195957,
        ],
    ],
    [
        1512345600000,
        [
            1553265242.01626,
            -4497505456.582461,
            -1901190565.359171,
        ],
    ],
    [
        1512950400000,
        [
            1574161811.755993,
            -4500920159.729571,
            -1903717798.631033,
        ],
    ],
    [
        1513555200000,
        [
            1595497789.523178,
            -4502323085.908853,
            -1905373853.60032,
        ],
    ],
    [
        1514160000000,
        [
            1616989668.112262,
            -4501668671.005986,
            -1906138678.816278,
        ],
    ],
    [
        1514764800000,
        [
            1638348597.890062,
            -4498960184.374763,
            -1906012028.03981,
        ],
    ],
    [
        1515369600000,
        [
            1659306604.020783,
            -4494237246.880786,
            -1905010609.783389,
        ],
    ],
    [
        1515974400000,
        [
            1679604009.671748,
            -4487550539.493925,
            -1903157923.22807,
        ],
    ],
    [
        1516579200000,
        [
            1698971456.530003,
            -4478984415.923307,
            -1900490721.563015,
        ],
    ],
    [
        1517184000000,
        [
            1717155587.159624,
            -4468669535.102948,
            -1897064765.640767,
        ],
    ],
    [
        1517788800000,
        [
            1733942052.565014,
            -4456764656.791495,
            -1892949308.42197,
        ],
    ],
    [
        1518393600000,
        [
            1749138243.875505,
            -4443432125.677062,
            -1888216498.49913,
        ],
    ],
    [
        1518998400000,
        [
            1762557722.737238,
            -4428860709.055952,
            -1882947895.494034,
        ],
    ],
    [
        1519603200000,
        [
            1774046355.692536,
            -4413273400.484998,
            -1877238624.58701,
        ],
    ],
    [
        1520208000000,
        [
            1783500610.52803,
            -4396904377.376519,
            -1871190044.386742,
        ],
    ],
    [
        1520812800000,
        [
            1790844529.221786,
            -4379977335.836692,
            -1864900098.540821,
        ],
    ],
    [
        1521417600000,
        [
            1796016312.749867,
            -4362729276.000899,
            -1858470727.370413,
        ],
    ],
    [
        1522022400000,
        [
            1798993232.026346,
            -4345415352.204777,
            -1852011200.680061,
        ],
    ],
    [
        1522627200000,
        [
            1799804390.907996,
            -4328283187.014468,
            -1845629554.355704,
        ],
    ],
    [
        1523232000000,
        [
            1798501896.869714,
            -4311556323.558826,
            -1839424330.069708,
        ],
    ],
    [
        1523836800000,
        [
            1795150558.166312,
            -4295459484.44216,
            -1833492729.553851,
        ],
    ],
    [
        1524441600000,
        [
            1789851566.564504,
            -4280221252.491737,
            -1827933044.246062,
        ],
    ],
    [
        1525046400000,
        [
            1782750655.150889,
            -4266047016.252098,
            -1822835223.984497,
        ],
    ],
    [
        1525651200000,
        [
            1774005213.061116,
            -4253108382.889376,
            -1818274584.072771,
        ],
    ],
    [
        1526256000000,
        [
            1763778715.473238,
            -4241569573.921848,
            -1814321122.10905,
        ],
    ],
    [
        1526860800000,
        [
            1752263625.36217,
            -4231588005.85179,
            -1811041611.377991,
        ],
    ],
    [
        1527465600000,
        [
            1739685581.624943,
            -4223287052.877768,
            -1808490177.478703,
        ],
    ],
    [
        1528070400000,
        [
            1726267854.401933,
            -4216752022.548533,
            -1806704440.731577,
        ],
    ],
    [
        1528675200000,
        [
            1712230852.793232,
            -4212057451.570114,
            -1805715774.196527,
        ],
    ],
    [
        1529280000000,
        [
            1697814069.703367,
            -4209265499.635247,
            -1805550567.842026,
        ],
    ],
    [
        1529884800000,
        [
            1683276445.725008,
            -4208399224.689173,
            -1806220502.494174,
        ],
    ],
    [
        1530489600000,
        [
            1668859816.066225,
            -4209444730.652252,
            -1807720575.598691,
        ],
    ],
    [
        1531094400000,
        [
            1654793783.815388,
            -4212378325.874446,
            -1810039612.021736,
        ],
    ],
    [
        1531699200000,
        [
            1641317032.878835,
            -4217162015.345094,
            -1813160431.718322,
        ],
    ],
    [
        1532304000000,
        [
            1628674144.875269,
            -4223717489.187495,
            -1817050221.317431,
        ],
    ],
    [
        1532908800000,
        [
            1617079709.826578,
            -4231933921.931012,
            -1821660904.951959,
        ],
    ],
    [
        1533513600000,
        [
            1606728134.369228,
            -4241694492.992536,
            -1826940171.993186,
        ],
    ],
    [
        1534118400000,
        [
            1597813974.838217,
            -4252869236.514361,
            -1832830899.456673,
        ],
    ],
    [
        1534723200000,
        [
            1590524584.723795,
            -4265290726.774646,
            -1839261944.335462,
        ],
    ],
    [
        1535328000000,
        [
            1585005940.155376,
            -4278767579.469557,
            -1846150731.058905,
        ],
    ],
    [
        1535932800000,
        [
            1581376633.864789,
            -4293110077.230527,
            -1853414138.543704,
        ],
    ],
    [
        1536537600000,
        [
            1579747258.508382,
            -4308120649.651139,
            -1860966699.234397,
        ],
    ],
    [
        1537142400000,
        [
            1580209036.692061,
            -4323571676.353466,
            -1868711550.137267,
        ],
    ],
    [
        1537747200000,
        [
            1582803319.140285,
            -4339224072.224468,
            -1876545085.580506,
        ],
    ],
    [
        1538352000000,
        [
            1587539933.943528,
            -4354851111.491862,
            -1884367574.498157,
        ],
    ],
    [
        1538956800000,
        [
            1594416334.830951,
            -4370226696.88765,
            -1892080630.31011,
        ],
    ],
    [
        1539561600000,
        [
            1603402752.791245,
            -4385105717.105723,
            -1899578978.388621,
        ],
    ],
    [
        1540166400000,
        [
            1614416951.684713,
            -4399247394.332756,
            -1906757569.583282,
        ],
    ],
    [
        1540771200000,
        [
            1627346635.870619,
            -4412436649.123164,
            -1913521773.203289,
        ],
    ],
    [
        1541376000000,
        [
            1642068502.369656,
            -4424470589.02919,
            -1919784036.397134,
        ],
    ],
    [
        1541980800000,
        [
            1658430413.368422,
            -4435141561.261531,
            -1925456026.269625,
        ],
    ],
    [
        1542585600000,
        [
            1676232661.379134,
            -4444264164.497253,
            -1930457264.305271,
        ],
    ],
    [
        1543190400000,
        [
            1695254416.949007,
            -4451692360.688306,
            -1934723659.796279,
        ],
    ],
    [
        1543795200000,
        [
            1715273054.633818,
            -4457303316.199161,
            -1938202738.776331,
        ],
    ],
    [
        1544400000000,
        [
            1736044469.797852,
            -4460981992.822287,
            -1940845810.638075,
        ],
    ],
    [
        1545004800000,
        [
            1757291529.593438,
            -4462649754.953876,
            -1942617704.67807,
        ],
    ],
    [
        1545609600000,
        [
            1778733827.983222,
            -4462275278.421867,
            -1943503308.711737,
        ],
    ],
    [
        1546214400000,
        [
            1800106105.646997,
            -4459855001.614092,
            -1943501471.397687,
        ],
    ],
    [
        1546819200000,
        [
            1821136400.170284,
            -4455398685.25695,
            -1942617275.533196,
        ],
    ],
    [
        1547424000000,
        [
            1841540097.310501,
            -4448958265.833695,
            -1940872262.804886,
        ],
    ],
    [
        1548028800000,
        [
            1861050658.667276,
            -4440631852.840583,
            -1938308234.809026,
        ],
    ],
    [
        1548633600000,
        [
            1879434599.916441,
            -4430540648.228132,
            -1934979148.882177,
        ],
    ],
    [
        1549238400000,
        [
            1896466682.79224,
            -4418815515.810996,
            -1930943116.748008,
        ],
    ],
    [
        1549843200000,
        [
            1911927787.376293,
            -4405625013.287776,
            -1926272396.353309,
        ],
    ],
    [
        1550448000000,
        [
            1925634778.895159,
            -4391172705.849566,
            -1921054469.460673,
        ],
    ],
    [
        1551052800000,
        [
            1937450147.642008,
            -4375671082.551968,
            -1915382381.140759,
        ],
    ],
    [
        1551657600000,
        [
            1947253935.741331,
            -4359330440.051322,
            -1909347639.676756,
        ],
    ],
    [
        1552262400000,
        [
            1954944163.153451,
            -4342386259.502159,
            -1903050676.24442,
        ],
    ],
    [
        1552867200000,
        [
            1960464334.050094,
            -4325091918.418926,
            -1896600376.227412,
        ],
    ],
    [
        1553472000000,
        [
            1963806369.465497,
            -4307691591.719219,
            -1890103720.878001,
        ],
    ],
    [
        1554076800000,
        [
            1964979294.112705,
            -4290413917.330352,
            -1883660455.422609,
        ],
    ],
    [
        1554681600000,
        [
            1964011974.84208,
            -4273499201.689877,
            -1877373851.759357,
        ],
    ],
    [
        1555286400000,
        [
            1960977967.063055,
            -4257189445.603746,
            -1871348888.978777,
        ],
    ],
    [
        1555891200000,
        [
            1955992274.889352,
            -4241701504.414284,
            -1865681286.372961,
        ],
    ],
    [
        1556496000000,
        [
            1949178445.457398,
            -4227226763.349256,
            -1860454363.210367,
        ],
    ],
    [
        1557100800000,
        [
            1940674949.180915,
            -4213957457.814788,
            -1855750055.803184,
        ],
    ],
    [
        1557705600000,
        [
            1930658010.947123,
            -4202074825.661931,
            -1851646474.416067,
        ],
    ],
    [
        1558310400000,
        [
            1919333444.522754,
            -4191723303.010271,
            -1848207200.942585,
        ],
    ],
    [
        1558915200000,
        [
            1906903632.103776,
            -4183016916.036008,
            -1845481155.727192,
        ],
    ],
    [
        1559520000000,
        [
            1893578074.082316,
            -4176064170.710896,
            -1843513850.100471,
        ],
    ],
    [
        1560124800000,
        [
            1879593907.26263,
            -4170955024.138143,
            -1842344428.367345,
        ],
    ],
    [
        1560729600000,
        [
            1865203463.085697,
            -4167736853.842303,
            -1841995163.533046,
        ],
    ],
    [
        1561334400000,
        [
            1850642223.189292,
            -4166427456.084544,
            -1842473821.157918,
        ],
    ],
    [
        1561939200000,
        [
            1836143777.674917,
            -4167037505.772392,
            -1843784181.509097,
        ],
    ],
    [
        1562544000000,
        [
            1821958011.554569,
            -4169556065.895235,
            -1845922090.246191,
        ],
    ],
    [
        1563148800000,
        [
            1808335465.482875,
            -4173928359.754359,
            -1848865247.934158,
        ],
    ],
    [
        1563753600000,
        [
            1795497662.252728,
            -4180074423.317273,
            -1852578128.874309,
        ],
    ],
    [
        1564358400000,
        [
            1783656424.646769,
            -4187908421.445989,
            -1857021926.140704,
        ],
    ],
    [
        1564963200000,
        [
            1773029367.27977,
            -4197322818.596538,
            -1862150096.888158,
        ],
    ],
    [
        1565568000000,
        [
            1763821323.642672,
            -4208168814.572085,
            -1867899169.178449,
        ],
    ],
    [
        1566172800000,
        [
            1756197610.38194,
            -4220280258.584128,
            -1874196215.216101,
        ],
    ],
    [
        1566777600000,
        [
            1750306813.237326,
            -4233490056.47479,
            -1880967941.005895,
        ],
    ],
    [
        1567382400000,
        [
            1746293126.521351,
            -4247613446.51553,
            -1888135336.440672,
        ],
    ],
    [
        1567987200000,
        [
            1744275238.703992,
            -4262431877.85002,
            -1895605292.572195,
        ],
    ],
    [
        1568592000000,
        [
            1744323809.107514,
            -4277721113.844064,
            -1903279944.93458,
        ],
    ],
    [
        1569196800000,
        [
            1746487672.519492,
            -4293264485.549698,
            -1911064623.918359,
        ],
    ],
    [
        1569801600000,
        [
            1750803749.699269,
            -4308835176.973598,
            -1918861751.225435,
        ],
    ],
    [
        1570406400000,
        [
            1757274388.081902,
            -4324184008.236217,
            -1926563922.037084,
        ],
    ],
    [
        1571011200000,
        [
            1765850599.08532,
            -4339070593.342671,
            -1934065318.51213,
        ],
    ],
    [
        1571616000000,
        [
            1776461363.698211,
            -4353273522.094808,
            -1941268904.546726,
        ],
    ],
    [
        1572220800000,
        [
            1789021604.708193,
            -4366571986.392778,
            -1948079847.764003,
        ],
    ],
    [
        1572825600000,
        [
            1803408428.559314,
            -4378738039.892168,
            -1954400133.054536,
        ],
    ],
    [
        1573430400000,
        [
            1819451241.477459,
            -4389569524.632369,
            -1960141148.677633,
        ],
    ],
    [
        1574035200000,
        [
            1836963647.627608,
            -4398896524.891151,
            -1965229205.700028,
        ],
    ],
    [
        1574640000000,
        [
            1855750350.181021,
            -4406561667.186365,
            -1969597733.642447,
        ],
    ],
    [
        1575244800000,
        [
            1875583187.229701,
            -4412415921.03646,
            -1973182815.67591,
        ],
    ],
    [
        1575849600000,
        [
            1896199321.774297,
            -4416350886.188562,
            -1975936056.02547,
        ],
    ],
    [
        1576454400000,
        [
            1917335021.3619,
            -4418299818.241962,
            -1977827965.211169,
        ],
    ],
    [
        1577059200000,
        [
            1938731682.725476,
            -4418215618.970291,
            -1978839072.424569,
        ],
    ],
    [
        1577664000000,
        [
            1960111482.131805,
            -4416069101.432763,
            -1978956488.289043,
        ],
    ],
    [
        1578268800000,
        [
            1981182802.000669,
            -4411879018.210916,
            -1978186661.987288,
        ],
    ],
    [
        1578873600000,
        [
            2001673329.902715,
            -4405706791.843669,
            -1976556088.809155,
        ],
    ],
    [
        1579478400000,
        [
            2021333484.958907,
            -4397632204.893706,
            -1974101018.924724,
        ],
    ],
    [
        1580083200000,
        [
            2039910479.641409,
            -4387753540.163727,
            -1970864392.552432,
        ],
    ],
    [
        1580688000000,
        [
            2057159077.480701,
            -4376214455.797169,
            -1966907574.000355,
        ],
    ],
    [
        1581292800000,
        [
            2072871589.889979,
            -4363192153.375136,
            -1962307796.589617,
        ],
    ],
    [
        1581897600000,
        [
            2086877086.071424,
            -4348871353.5268,
            -1957146652.926963,
        ],
    ],
    [
        1582502400000,
        [
            2099013510.514041,
            -4333446345.60275,
            -1951507854.115697,
        ],
    ],
    [
        1583107200000,
        [
            2109142121.580668,
            -4317144923.779673,
            -1945488517.232966,
        ],
    ],
    [
        1583712000000,
        [
            2117172767.095349,
            -4300211394.1726,
            -1939194412.684244,
        ],
    ],
    [
        1584316800000,
        [
            2123057416.987935,
            -4282880981.780701,
            -1932728508.35968,
        ],
    ],
    [
        1584921600000,
        [
            2126760432.870445,
            -4265385398.189332,
            -1926190502.434842,
        ],
    ],
    [
        1585526400000,
        [
            2128275302.320442,
            -4247975056.241268,
            -1919687948.468382,
        ],
    ],
    [
        1586131200000,
        [
            2127644702.582067,
            -4230899112.567849,
            -1913329744.554031,
        ],
    ],
    [
        1586736000000,
        [
            2124948178.609425,
            -4214382198.010093,
            -1907214961.465477,
        ],
    ],
    [
        1587340800000,
        [
            2120272249.472253,
            -4198634514.911095,
            -1901434251.4275,
        ],
    ],
    [
        1587945600000,
        [
            2113729686.155355,
            -4183872233.643349,
            -1896080542.268465,
        ],
    ],
    [
        1588550400000,
        [
            2105475585.567234,
            -4170295701.934557,
            -1891241390.912903,
        ],
    ],
    [
        1589155200000,
        [
            2095690360.605726,
            -4158069209.835644,
            -1886988822.119901,
        ],
    ],
    [
        1589760000000,
        [
            2084551787.065242,
            -4147336012.761163,
            -1883383418.536046,
        ],
    ],
    [
        1590364800000,
        [
            2072256929.674652,
            -4138236421.886517,
            -1880484759.73636,
        ],
    ],
    [
        1590969600000,
        [
            2059034790.991844,
            -4130885321.909877,
            -1878343374.588019,
        ],
    ],
    [
        1591574400000,
        [
            2045125183.812877,
            -4125355587.247509,
            -1876991808.340257,
        ],
    ],
    [
        1592179200000,
        [
            2030753881.572997,
            -4121698216.318418,
            -1876451182.857842,
        ],
    ],
    [
        1592784000000,
        [
            2016156797.411249,
            -4119957283.918389,
            -1876740353.894173,
        ],
    ],
    [
        1593388800000,
        [
            2001589532.872818,
            -4120147188.25808,
            -1877867124.611336,
        ],
    ],
    [
        1593993600000,
        [
            1987303164.235749,
            -4122239410.09019,
            -1879820172.933532,
        ],
    ],
    [
        1594598400000,
        [
            1973523857.207978,
            -4126186943.684331,
            -1882577824.834846,
        ],
    ],
    [
        1595203200000,
        [
            1960479170.513666,
            -4131934973.55325,
            -1886115619.367458,
        ],
    ],
    [
        1595808000000,
        [
            1948404668.812867,
            -4139398146.310614,
            -1890397389.675678,
        ],
    ],
    [
        1596412800000,
        [
            1937517431.106669,
            -4148450742.198536,
            -1895368705.850422,
        ],
    ],
    [
        1597017600000,
        [
            1928000588.295331,
            -4158955069.663894,
            -1900968159.007554,
        ],
    ],
    [
        1597622400000,
        [
            1920030806.109251,
            -4170767904.118951,
            -1907133290.425794,
        ],
    ],
    [
        1598227200000,
        [
            1913781368.595139,
            -4183718753.220876,
            -1913791641.415542,
        ],
    ],
    [
        1598832000000,
        [
            1909394000.020725,
            -4197603931.759015,
            -1920855525.454836,
        ],
    ],
    [
        1599436800000,
        [
            1906968754.469145,
            -4212218243.398157,
            -1928235051.943086,
        ],
    ],
    [
        1600041600000,
        [
            1906592442.11705,
            -4227357104.363745,
            -1935841881.691381,
        ],
    ],
    [
        1600646400000,
        [
            1908338592.306579,
            -4242796036.868609,
            -1943580172.363361,
        ],
    ],
    [
        1601251200000,
        [
            1912239191.994143,
            -4258288622.746636,
            -1951342942.07533,
        ],
    ],
    [
        1601856000000,
        [
            1918280895.949927,
            -4273600197.092155,
            -1959026773.354988,
        ],
    ],
    [
        1602460800000,
        [
            1926434570.46665,
            -4288505860.45862,
            -1966533963.876563,
        ],
    ],
    [
        1603065600000,
        [
            1936652596.604518,
            -4302771563.87708,
            -1973763962.118045,
        ],
    ],
    [
        1603670400000,
        [
            1948841649.671211,
            -4316156370.332833,
            -1980611768.227655,
        ],
    ],
    [
        1604275200000,
        [
            1962865518.624957,
            -4328446946.955826,
            -1986983648.840441,
        ],
    ],
    [
        1604880000000,
        [
            1978575578.939611,
            -4339451739.676875,
            -1992797338.371234,
        ],
    ],
    [
        1605484800000,
        [
            1995806013.023908,
            -4348983244.027063,
            -1997973262.384329,
        ],
    ],
    [
        1606089600000,
        [
            2014348826.779292,
            -4356863994.294318,
            -2002434306.942647,
        ],
    ],
    [
        1606694400000,
        [
            2033963873.846714,
            -4362959298.091023,
            -2006121115.778594,
        ],
    ],
    [
        1607299200000,
        [
            2054410260.845804,
            -4367166637.471871,
            -2008989942.414619,
        ],
    ],
    [
        1607904000000,
        [
            2075440224.496855,
            -4369397603.372082,
            -2011003418.373126,
        ],
    ],
    [
        1608508800000,
        [
            2096776829.276864,
            -4369586471.532283,
            -2012131813.981682,
        ],
    ],
    [
        1609113600000,
        [
            2118130611.812832,
            -4367718802.674472,
            -2012367330.233497,
        ],
    ],
    [
        1609718400000,
        [
            2139230024.26317,
            -4363815649.56251,
            -2011719644.298058,
        ],
    ],
    [
        1610323200000,
        [
            2159812965.717516,
            -4357914453.540201,
            -2010206009.780358,
        ],
    ],
    [
        1610928000000,
        [
            2179605741.663039,
            -4350079744.047011,
            -2007853592.153239,
        ],
    ],
    [
        1611532800000,
        [
            2198344381.121322,
            -4340426240.783184,
            -2004711597.928403,
        ],
    ],
    [
        1612137600000,
        [
            2215801278.378442,
            -4329097969.34997,
            -2000843891.07119,
        ],
    ],
    [
        1612742400000,
        [
            2231773238.918861,
            -4316248040.938145,
            -1996318101.979525,
        ],
    ],
    [
        1613347200000,
        [
            2246060626.960333,
            -4302051192.305889,
            -1991208927.960139,
        ],
    ],
    [
        1613952000000,
        [
            2258491850.567013,
            -4286721047.593712,
            -1985608156.540291,
        ],
    ],
    [
        1614556800000,
        [
            2268944034.775198,
            -4270485266.987195,
            -1979615207.750341,
        ],
    ],
    [
        1615161600000,
        [
            2277326816.003561,
            -4253565763.201734,
            -1973326531.141768,
        ],
    ],
    [
        1615766400000,
        [
            2283561058.829618,
            -4236194071.674246,
            -1966840804.548901,
        ],
    ],
    [
        1616371200000,
        [
            2287605047.030275,
            -4218624241.154215,
            -1960267585.734635,
        ],
    ],
    [
        1616976000000,
        [
            2289467846.158635,
            -4201106352.558701,
            -1953716559.324301,
        ],
    ],
    [
        1617580800000,
        [
            2289188725.235115,
            -4183869515.489401,
            -1947287830.357137,
        ],
    ],
    [
        1618185600000,
        [
            2286816169.942142,
            -4167140821.110435,
            -1941078850.259077,
        ],
    ],
    [
        1618790400000,
        [
            2282435585.090714,
            -4151154808.273105,
            -1935191568.24659,
        ],
    ],
    [
        1619395200000,
        [
            2276176215.66941,
            -4136126599.248004,
            -1929720719.513154,
        ],
    ],
    [
        1620000000000,
        [
            2268187591.682944,
            -4122238771.087181,
            -1924745641.646803,
        ],
    ],
    [
        1620604800000,
        [
            2258620873.519122,
            -4109663554.093737,
            -1920339206.236453,
        ],
    ],
    [
        1621209600000,
        [
            2247658225.653275,
            -4098569116.170562,
            -1916574004.758841,
        ],
    ],
    [
        1621814400000,
        [
            2235514483.409531,
            -4089093203.328068,
            -1913510616.309749,
        ],
    ],
    [
        1622419200000,
        [
            2222411418.987299,
            -4081334756.398166,
            -1911191651.950454,
        ],
    ],
    [
        1623024000000,
        [
            2208562631.172754,
            -4075379121.203647,
            -1909652572.883991,
        ],
    ],
    [
        1623628800000,
        [
            2194203763.401925,
            -4071301251.567708,
            -1908926445.897031,
        ],
    ],
    [
        1624233600000,
        [
            2179589711.166661,
            -4069140357.697706,
            -1909031960.387118,
        ],
    ],
    [
        1624838400000,
        [
            2164967390.092672,
            -4068896248.104977,
            -1909969229.36106,
        ],
    ],
    [
        1625443200000,
        [
            2150565514.928213,
            -4070556529.109473,
            -1911731756.691313,
        ],
    ],
    [
        1626048000000,
        [
            2136625123.802293,
            -4074095982.857953,
            -1914309223.838999,
        ],
    ],
    [
        1626652800000,
        [
            2123393403.044818,
            -4079452210.221239,
            -1917675616.680705,
        ],
    ],
    [
        1627257600000,
        [
            2111095743.796339,
            -4086526356.421541,
            -1921787207.395706,
        ],
    ],
    [
        1627862400000,
        [
            2099931241.200499,
            -4095211644.749918,
            -1926595973.173609,
        ],
    ],
    [
        1628467200000,
        [
            2090102301.423114,
            -4105388969.533815,
            -1932050645.959869,
        ],
    ],
    [
        1629072000000,
        [
            2081805216.591895,
            -4116904472.923672,
            -1938085507.965129,
        ],
    ],
    [
        1629676800000,
        [
            2075201688.996076,
            -4129574905.715022,
            -1944620505.850654,
        ],
    ],
    [
        1630281600000,
        [
            2070420266.536558,
            -4143217224.922343,
            -1951575557.71158,
        ],
    ],
    [
        1630886400000,
        [
            2067584066.814248,
            -4157640572.861252,
            -1958869265.634564,
        ],
    ],
    [
        1631491200000,
        [
            2066798747.154137,
            -4172626385.501081,
            -1966408242.981949,
        ],
    ],
    [
        1632096000000,
        [
            2068124751.883196,
            -4187937892.158361,
            -1974089039.995581,
        ],
    ],
    [
        1632700800000,
        [
            2071585564.331926,
            -4203349834.953039,
            -1981813079.097215,
        ],
    ],
    [
        1633305600000,
        [
            2077193629.688144,
            -4218636812.132324,
            -1989483385.818126,
        ],
    ],
    [
        1633910400000,
        [
            2084936688.032793,
            -4233556440.542593,
            -1996995267.316248,
        ],
    ],
    [
        1634515200000,
        [
            2094752069.925282,
            -4247862680.077035,
            -2004240433.172865,
        ],
    ],
    [
        1635120000000,
        [
            2106541860.635699,
            -4261335044.234616,
            -2011122449.277802,
        ],
    ],
    [
        1635724800000,
        [
            2120196920.441262,
            -4273763727.935997,
            -2017551559.727439,
        ],
    ],
    [
        1636329600000,
        [
            2135582102.535282,
            -4284936120.869646,
            -2023436518.683232,
        ],
    ],
    [
        1636934400000,
        [
            2152513852.44873,
            -4294653132.545926,
            -2028690057.235941,
        ],
    ],
    [
        1637539200000,
        [
            2170782193.083118,
            -4302756208.964916,
            -2033243488.259629,
        ],
    ],
    [
        1638144000000,
        [
            2190173400.144195,
            -4309108522.368731,
            -2037039036.804311,
        ],
    ],
    [
        1638748800000,
        [
            2210454942.755254,
            -4313583573.477622,
            -2040022366.595355,
        ],
    ],
    [
        1639353600000,
        [
            2231357626.871666,
            -4316082785.006991,
            -2042149046.398633,
        ],
    ],
    [
        1639958400000,
        [
            2252603571.06545,
            -4316558012.006206,
            -2043397644.124954,
        ],
    ],
    [
        1640563200000,
        [
            2273927068.000647,
            -4314988189.587907,
            -2043759871.762734,
        ],
    ],
    [
        1641168000000,
        [
            2295058495.959247,
            -4311368967.934067,
            -2043233762.481472,
        ],
    ],
    [
        1641772800000,
        [
            2315710260.320921,
            -4305730786.108644,
            -2041830934.156479,
        ],
    ],
    [
        1642377600000,
        [
            2335608119.937826,
            -4298155399.301694,
            -2039587076.076484,
        ],
    ],
    [
        1642982400000,
        [
            2354508179.711123,
            -4288748305.550622,
            -2036549566.577112,
        ],
    ],
    [
        1643587200000,
        [
            2372178262.85382,
            -4277628758.789478,
            -2032770536.054511,
        ],
    ],
    [
        1644192000000,
        [
            2388386493.736314,
            -4264948017.72792,
            -2028314478.93793,
        ],
    ],
    [
        1644796800000,
        [
            2402933740.845532,
            -4250898935.152308,
            -2023265471.744478,
        ],
    ],
    [
        1645401600000,
        [
            2415664978.38588,
            -4235685295.313056,
            -2017712957.408062,
        ],
    ],
    [
        1646006400000,
        [
            2426447361.228205,
            -4219512556.412917,
            -2011745367.794361,
        ],
    ],
    [
        1646611200000,
        [
            2435160589.903953,
            -4202607190.084186,
            -2005459076.523312,
        ],
    ],
    [
        1647216000000,
        [
            2441728710.038676,
            -4185220209.292631,
            -1998963087.144721,
        ],
    ],
    [
        1647820800000,
        [
            2446124259.08872,
            -4167596175.722869,
            -1992364367.331074,
        ],
    ],
    [
        1648425600000,
        [
            2448342832.894523,
            -4149966451.822839,
            -1985762707.088472,
        ],
    ],
    [
        1649030400000,
        [
            2448394945.367045,
            -4132570978.662672,
            -1979261170.809522,
        ],
    ],
    [
        1649635200000,
        [
            2446336629.40533,
            -4115656988.691683,
            -1972968185.803446,
        ],
    ],
    [
        1650240000000,
        [
            2442266523.15441,
            -4099449717.062971,
            -1966982873.917313,
        ],
    ],
    [
        1650844800000,
        [
            2436298525.113734,
            -4084149094.32225,
            -1961391352.619694,
        ],
    ],
    [
        1651449600000,
        [
            2428556425.339254,
            -4069953821.747821,
            -1956278634.784232,
        ],
    ],
    [
        1652054400000,
        [
            2419203978.053521,
            -4057055736.501552,
            -1951728629.968864,
        ],
    ],
    [
        1652659200000,
        [
            2408436131.143035,
            -4045613234.484473,
            -1947810528.853611,
        ],
    ],
    [
        1653264000000,
        [
            2396451367.987395,
            -4035752055.901188,
            -1944577414.963264,
        ],
    ],
    [
        1653868800000,
        [
            2383449853.359097,
            -4027591249.075152,
            -1942079645.562181,
        ],
    ],
    [
        1654473600000,
        [
            2369662684.971477,
            -4021233903.978776,
            -1940362999.914984,
        ],
    ],
    [
        1655078400000,
        [
            2355337960.584449,
            -4016743937.706132,
            -1939456177.091987,
        ],
    ],
    [
        1655683200000,
        [
            2340713708.749874,
            -4014151263.636281,
            -1939371411.216746,
        ],
    ],
    [
        1656288000000,
        [
            2326020121.339923,
            -4013478510.688921,
            -1940118215.90685,
        ],
    ],
    [
        1656892800000,
        [
            2311507669.330294,
            -4014728132.055624,
            -1941699227.759471,
        ],
    ],
    [
        1657497600000,
        [
            2297429263.991729,
            -4017862164.767642,
            -1944098678.569138,
        ],
    ],
    [
        1658102400000,
        [
            2284014860.145162,
            -4022811375.349889,
            -1947285165.040861,
        ],
    ],
    [
        1658707200000,
        [
            2271478434.730934,
            -4029501431.503168,
            -1951225615.220756,
        ],
    ],
    [
        1659312000000,
        [
            2260044169.974396,
            -4037836791.336332,
            -1955879455.988098,
        ],
    ],
    [
        1659916800000,
        [
            2249925396.89947,
            -4047683666.084737,
            -1961188661.704531,
        ],
    ],
    [
        1660521600000,
        [
            2241300990.516181,
            -4058883465.705779,
            -1967083001.839914,
        ],
    ],
    [
        1661126400000,
        [
            2234326974.890807,
            -4071277976.153805,
            -1973493798.578857,
        ],
    ],
    [
        1661731200000,
        [
            2229159483.15423,
            -4084690982.705493,
            -1980346312.887657,
        ],
    ],
    [
        1662336000000,
        [
            2225931283.023108,
            -4098914738.044455,
            -1987551023.936534,
        ],
    ],
    [
        1662940800000,
        [
            2224730564.433605,
            -4113727493.351808,
            -1995010824.843405,
        ],
    ],
    [
        1663545600000,
        [
            2225617869.540542,
            -4128916740.501767,
            -2002633912.102571,
        ],
    ],
    [
        1664150400000,
        [
            2228645630.25606,
            -4144258945.250867,
            -2010324658.917837,
        ],
    ],
    [
        1664755200000,
        [
            2233833916.273563,
            -4159509501.469221,
            -2017976592.033712,
        ],
    ],
    [
        1665360000000,
        [
            2241152622.788871,
            -4174423842.552337,
            -2025481847.88518,
        ],
    ],
    [
        1665964800000,
        [
            2250544236.929623,
            -4188778169.411088,
            -2032743366.992717,
        ],
    ],
    [
        1666569600000,
        [
            2261939645.863758,
            -4202348016.616141,
            -2039664862.38767,
        ],
    ],
    [
        1667174400000,
        [
            2275234202.29544,
            -4214902049.63064,
            -2046145676.763806,
        ],
    ],
    [
        1667779200000,
        [
            2290273896.513571,
            -4226226030.95811,
            -2052091782.273443,
        ],
    ],
    [
        1668384000000,
        [
            2306884008.937297,
            -4236140131.480624,
            -2057426261.799632,
        ],
    ],
    [
        1668988800000,
        [
            2324881395.993619,
            -4244476009.611387,
            -2062077769.986821,
        ],
    ],
    [
        1669593600000,
        [
            2344052222.545764,
            -4251073559.823377,
            -2065976663.25806,
        ],
    ],
    [
        1670198400000,
        [
            2364143118.66774,
            -4255805575.027065,
            -2069066542.362757,
        ],
    ],
    [
        1670803200000,
        [
            2384895449.986526,
            -4258589809.59306,
            -2071312397.05685,
        ],
    ],
    [
        1671408000000,
        [
            2406054221.448812,
            -4259363516.913665,
            -2072687681.873468,
        ],
    ],
    [
        1672012800000,
        [
            2427347592.427085,
            -4258082077.901432,
            -2073171892.402748,
        ],
    ],
    [
        1672617600000,
        [
            2448482567.836403,
            -4254742651.772314,
            -2072762272.389819,
        ],
    ],
    [
        1673222400000,
        [
            2469182377.973352,
            -4249390010.563869,
            -2071479128.228038,
        ],
    ],
    [
        1673827200000,
        [
            2489190590.133823,
            -4242088331.992011,
            -2069351271.161018,
        ],
    ],
    [
        1674432000000,
        [
            2508250824.361356,
            -4232921203.345848,
            -2066414406.25477,
        ],
    ],
    [
        1675036800000,
        [
            2526105702.11107,
            -4222013306.981764,
            -2062722059.309183,
        ],
    ],
    [
        1675641600000,
        [
            2542534284.195754,
            -4209529505.965006,
            -2058347266.632881,
        ],
    ],
    [
        1676246400000,
        [
            2557350289.808158,
            -4195644303.726853,
            -2053366488.207137,
        ],
    ],
    [
        1676851200000,
        [
            2570380788.073863,
            -4180543120.422879,
            -2047858957.728748,
        ],
    ],
    [
        1677456000000,
        [
            2581467686.290818,
            -4164442211.104183,
            -2041917371.142131,
        ],
    ],
    [
        1678060800000,
        [
            2590502678.446437,
            -4147581771.591821,
            -2035646738.113669,
        ],
    ],
    [
        1678665600000,
        [
            2597418778.247899,
            -4130195322.823043,
            -2029148303.987292,
        ],
    ],
    [
        1679270400000,
        [
            2602167038.442808,
            -4112513596.304113,
            -2022520642.574592,
        ],
    ],
    [
        1679875200000,
        [
            2604720086.507901,
            -4094784312.185382,
            -2015870692.069112,
        ],
    ],
    [
        1680480000000,
        [
            2605102965.789936,
            -4077260906.600317,
            -2009310010.336183,
        ],
    ],
    [
        1681084800000,
        [
            2603378247.863357,
            -4060174419.527088,
            -2002939404.994999,
        ],
    ],
    [
        1681689600000,
        [
            2599621488.690584,
            -4043740764.58758,
            -1996851564.569087,
        ],
    ],
    [
        1682294400000,
        [
            2593927797.876559,
            -4028180946.857438,
            -1991142353.647061,
        ],
    ],
    [
        1682899200000,
        [
            2586438935.083655,
            -4013705929.802855,
            -1985904691.655449,
        ],
    ],
    [
        1683504000000,
        [
            2577323637.114206,
            -4000492437.154873,
            -1981214995.798753,
        ],
    ],
    [
        1684108800000,
        [
            2566753501.371869,
            -3988693608.777594,
            -1977137847.2081,
        ],
    ],
    [
        1684713600000,
        [
            2554913416.615878,
            -3978459658.768598,
            -1973737970.895812,
        ],
    ],
    [
        1685318400000,
        [
            2542025032.369226,
            -3969919481.053073,
            -1971072312.940017,
        ],
    ],
    [
        1685923200000,
        [
            2528323222.954284,
            -3963161532.897064,
            -1969178982.167684,
        ],
    ],
    [
        1686528000000,
        [
            2514033381.036087,
            -3958247881.694978,
            -1968083672.737712,
        ],
    ],
    [
        1687132800000,
        [
            2499385667.344059,
            -3955234816.697102,
            -1967811488.001035,
        ],
    ],
    [
        1687737600000,
        [
            2484634817.856449,
            -3954151404.701682,
            -1968376759.077953,
        ],
    ],
    [
        1688342400000,
        [
            2470033872.646126,
            -3954985423.478324,
            -1969774187.370637,
        ],
    ],
    [
        1688947200000,
        [
            2455814219.540327,
            -3957700003.775773,
            -1971986602.170685,
        ],
    ],
    [
        1689552000000,
        [
            2442203776.445902,
            -3962252940.062069,
            -1974996178.121259,
        ],
    ],
    [
        1690156800000,
        [
            2429443220.457311,
            -3968572423.237167,
            -1978772576.527854,
        ],
    ],
    [
        1690761600000,
        [
            2417757868.862594,
            -3976547899.116332,
            -1983266851.774299,
        ],
    ],
    [
        1691366400000,
        [
            2407341071.143035,
            -3986049213.194821,
            -1988420969.035632,
        ],
    ],
    [
        1691971200000,
        [
            2398375515.918328,
            -3996944177.507662,
            -1994178291.345408,
        ],
    ],
    [
        1692576000000,
        [
            2391045186.582561,
            -4009072748.488304,
            -2000470484.620155,
        ],
    ],
    [
        1693180800000,
        [
            2385505811.796487,
            -4022242949.865576,
            -2007213850.426774,
        ],
    ],
    [
        1693785600000,
        [
            2381872043.198264,
            -4036252551.077996,
            -2014320073.216902,
        ],
    ],
    [
        1694390400000,
        [
            2380241614.309169,
            -4050904154.196099,
            -2021705091.138275,
        ],
    ],
    [
        1694995200000,
        [
            2380703233.67094,
            -4065978681.058023,
            -2029274988.197077,
        ],
    ],
    [
        1695600000000,
        [
            2383307043.826991,
            -4081235751.733786,
            -2036924570.956651,
        ],
    ],
    [
        1696204800000,
        [
            2388056675.378078,
            -4096437480.700661,
            -2044549523.588469,
        ],
    ],
    [
        1696809600000,
        [
            2394936562.120141,
            -4111360289.364084,
            -2052053772.146269,
        ],
    ],
    [
        1697414400000,
        [
            2403916071.423829,
            -4125768803.544791,
            -2059335489.931574,
        ],
    ],
    [
        1698019200000,
        [
            2414921155.641782,
            -4139420415.63922,
            -2066288089.064656,
        ],
    ],
    [
        1698624000000,
        [
            2427831678.561885,
            -4152091018.677913,
            -2072813637.076478,
        ],
    ],
    [
        1699228800000,
        [
            2442511840.064971,
            -4163582888.960482,
            -2078828010.347157,
        ],
    ],
    [
        1699833600000,
        [
            2458810721.739359,
            -4173699585.472991,
            -2084246905.947786,
        ],
    ],
    [
        1700438400000,
        [
            2476536531.768051,
            -4182253594.308405,
            -2088988251.510906,
        ],
    ],
    [
        1701043200000,
        [
            2495459757.951265,
            -4189092429.879947,
            -2092985765.53486,
        ],
    ],
    [
        1701648000000,
        [
            2515346994.974456,
            -4194100778.97163,
            -2096190971.611342,
        ],
    ],
    [
        1702252800000,
        [
            2535958315.371606,
            -4197175638.557278,
            -2098559288.073897,
        ],
    ],
    [
        1702857600000,
        [
            2557025184.79228,
            -4198235347.407048,
            -2100053663.645061,
        ],
    ],
    [
        1703462400000,
        [
            2578258894.727571,
            -4197244141.26882,
            -2100657904.542356,
        ],
    ],
    [
        1704067200000,
        [
            2599386376.003781,
            -4194207394.331953,
            -2100375379.331111,
        ],
    ],
    [
        1704672000000,
        [
            2620143151.277565,
            -4189146667.339086,
            -2099215263.684734,
        ],
    ],
    [
        1705276800000,
        [
            2640254041.410781,
            -4182109365.93422,
            -2097196924.0267,
        ],
    ],
    [
        1705881600000,
        [
            2659444801.506042,
            -4173190479.983989,
            -2094361923.388855,
        ],
    ],
    [
        1706486400000,
        [
            2677477203.119925,
            -4162520713.971251,
            -2090768738.666024,
        ],
    ],
    [
        1707091200000,
        [
            2694136184.153731,
            -4150241346.50137,
            -2086478732.230596,
        ],
    ],
    [
        1707696000000,
        [
            2709212319.237003,
            -4136514207.911445,
            -2081560979.915324,
        ],
    ],
    [
        1708300800000,
        [
            2722515205.706871,
            -4121539936.077036,
            -2076102737.025294,
        ],
    ],
    [
        1708905600000,
        [
            2733905411.217123,
            -4105539979.612143,
            -2070201024.028288,
        ],
    ],
    [
        1709510400000,
        [
            2743275180.81089,
            -4088732391.62486,
            -2063949408.698157,
        ],
    ],
    [
        1710115200000,
        [
            2750531632.786204,
            -4071343324.049723,
            -2057444260.442659,
        ],
    ],
    [
        1710720000000,
        [
            2755610893.493952,
            -4053622883.624927,
            -2050794332.641264,
        ],
    ],
    [
        1711324800000,
        [
            2758504787.866367,
            -4035823459.572169,
            -2044110273.423999,
        ],
    ],
    [
        1711929600000,
        [
            2759235328.169495,
            -4018178580.231078,
            -2037492836.347142,
        ],
    ],
    [
        1712534400000,
        [
            2757838419.932209,
            -4000917248.577778,
            -2031040538.505363,
        ],
    ],
    [
        1713139200000,
        [
            2754379296.898055,
            -3984278204.450516,
            -2024858114.513867,
        ],
    ],
    [
        1713744000000,
        [
            2748973666.529846,
            -3968485993.603805,
            -2019044320.146469,
        ],
    ],
    [
        1714348800000,
        [
            2741758076.331975,
            -3953733998.828001,
            -2013682149.060697,
        ],
    ],
    [
        1714953600000,
        [
            2732875286.607475,
            -3940201674.626354,
            -2008848141.858132,
        ],
    ],
    [
        1715558400000,
        [
            2722492327.349915,
            -3928067262.173483,
            -2004620163.207009,
        ],
    ],
    [
        1716163200000,
        [
            2710816229.042797,
            -3917482425.683963,
            -2001064441.209402,
        ],
    ],
    [
        1716768000000,
        [
            2698062048.676642,
            -3908560492.314326,
            -1998228739.340157,
        ],
    ],
    [
        1717372800000,
        [
            2684440400.269849,
            -3901396524.702651,
            -1996153274.169142,
        ],
    ],
    [
        1717977600000,
        [
            2670178353.53254,
            -3896078518.69778,
            -1994877496.638629,
        ],
    ],
    [
        1718582400000,
        [
            2655529462.223339,
            -3892661110.572396,
            -1994426137.865571,
        ],
    ],
    [
        1719187200000,
        [
            2640740923.09017,
            -3891159356.438138,
            -1994805049.5026,
        ],
    ],
    [
        1719792000000,
        [
            2626043969.775435,
            -3891570655.876427,
            -1996012815.603808,
        ],
    ],
    [
        1720396800000,
        [
            2611677822.894885,
            -3893883611.691016,
            -1998045965.769847,
        ],
    ],
    [
        1721001600000,
        [
            2597894312.746318,
            -3898050698.275294,
            -2000884209.410771,
        ],
    ],
    [
        1721606400000,
        [
            2584925655.853004,
            -3903987372.512689,
            -2004489366.479688,
        ],
    ],
    [
        1722211200000,
        [
            2572978269.799793,
            -3911595023.490117,
            -2008817817.776433,
        ],
    ],
    [
        1722816000000,
        [
            2562259060.167979,
            -3920767338.863558,
            -2013824494.636607,
        ],
    ],
    [
        1723420800000,
        [
            2552974359.500127,
            -3931362812.252068,
            -2019447958.877542,
        ],
    ],
    [
        1724025600000,
        [
            2545298789.023024,
            -3943209521.894091,
            -2025612459.417626,
        ],
    ],
    [
        1724630400000,
        [
            2539372553.052535,
            -3956128903.04746,
            -2032240679.950055,
        ],
    ],
    [
        1725235200000,
        [
            2535329080.662666,
            -3969939674.58665,
            -2039255965.902547,
        ],
    ],
    [
        1725840000000,
        [
            2533288716.702036,
            -3984430936.277202,
            -2046567179.300126,
        ],
    ],
    [
        1726444800000,
        [
            2533329737.30807,
            -3999372136.563168,
            -2054073361.484583,
        ],
    ],
    [
        1727049600000,
        [
            2535490170.383643,
            -4014536953.578554,
            -2061676452.542739,
        ],
    ],
    [
        1727654400000,
        [
            2539796648.435768,
            -4029704387.646811,
            -2069281929.333948,
        ],
    ],
    [
        1728259200000,
        [
            2546254062.154006,
            -4044633168.079785,
            -2076784417.290121,
        ],
    ],
    [
        1728864000000,
        [
            2554819700.655688,
            -4059076408.163948,
            -2084075191.713457,
        ],
    ],
    [
        1729468800000,
        [
            2565410287.702574,
            -4072805378.678617,
            -2091055038.769515,
        ],
    ],
    [
        1730073600000,
        [
            2577931495.394964,
            -4085607660.126132,
            -2097633258.29593,
        ],
    ],
    [
        1730678400000,
        [
            2592264448.076686,
            -4097263748.914213,
            -2103714305.444349,
        ],
    ],
    [
        1731283200000,
        [
            2608243657.156676,
            -4107565400.949492,
            -2109207104.08667,
        ],
    ],
    [
        1731888000000,
        [
            2625669904.48825,
            -4116338332.038721,
            -2114037028.787352,
        ],
    ],
    [
        1732492800000,
        [
            2644340357.096801,
            -4123436025.394724,
            -2118142232.678566,
        ],
    ],
    [
        1733097600000,
        [
            2664033217.778496,
            -4128718123.914677,
            -2121461237.143918,
        ],
    ],
    [
        1733702400000,
        [
            2684490377.323491,
            -4132070208.138435,
            -2123943234.107603,
        ],
    ],
    [
        1734307200000,
        [
            2705436222.04403,
            -4133423721.863353,
            -2125558871.370994,
        ],
    ],
    [
        1734912000000,
        [
            2726607510.407911,
            -4132743801.613224,
            -2126293701.287491,
        ],
    ],
    [
        1735516800000,
        [
            2747735929.506074,
            -4130009245.548898,
            -2126137209.509409,
        ],
    ],
    [
        1736121600000,
        [
            2768534737.251027,
            -4125232128.534754,
            -2125093518.896182,
        ],
    ],
    [
        1736726400000,
        [
            2788721385.427283,
            -4118474042.280704,
            -2123190374.023118,
        ],
    ],
    [
        1737331200000,
        [
            2808044773.112963,
            -4109827307.218473,
            -2120468987.395166,
        ],
    ],
    [
        1737936000000,
        [
            2826264286.517133,
            -4099396681.373898,
            -2116974113.143781,
        ],
    ],
    [
        1738540800000,
        [
            2843139321.223042,
            -4087317761.095118,
            -2112764171.50339,
        ],
    ],
    [
        1739145600000,
        [
            2858453458.224559,
            -4073768968.718587,
            -2107917931.940992,
        ],
    ],
    [
        1739750400000,
        [
            2872037156.945044,
            -4058946492.179958,
            -2102521052.93806,
        ],
    ],
    [
        1740355200000,
        [
            2883742383.411379,
            -4043048447.966773,
            -2096657925.310667,
        ],
    ],
    [
        1740960000000,
        [
            2893434281.539255,
            -4026292439.45222,
            -2090421848.002911,
        ],
    ],
    [
        1741564800000,
        [
            2901014987.573076,
            -4008924184.86738,
            -2083920269.834649,
        ],
    ],
    [
        1742169600000,
        [
            2906440107.939118,
            -3991188597.870244,
            -2077259476.776632,
        ],
    ],
    [
        1742774400000,
        [
            2909688477.293322,
            -3973318286.325859,
            -2070538980.164958,
        ],
    ],
    [
        1743379200000,
        [
            2910755587.674665,
            -3955551795.279737,
            -2063861987.449139,
        ],
    ],
    [
        1743984000000,
        [
            2909676341.689135,
            -3938140033.154857,
            -2057339120.733721,
        ],
    ],
    [
        1744588800000,
        [
            2906535107.762661,
            -3921315806.698474,
            -2051071898.423487,
        ],
    ],
    [
        1745193600000,
        [
            2901432070.521782,
            -3905287501.671368,
            -2045149669.196877,
        ],
    ],
    [
        1745798400000,
        [
            2894479471.869231,
            -3890258457.719846,
            -2039660455.390109,
        ],
    ],
    [
        1746403200000,
        [
            2885824295.235318,
            -3876431165.462956,
            -2034693330.809206,
        ],
    ],
    [
        1747008000000,
        [
            2875652653.954803,
            -3863976685.630595,
            -2030321982.506437,
        ],
    ],
    [
        1747612800000,
        [
            2864154764.779785,
            -3853033793.716243,
            -2026604844.185566,
        ],
    ],
    [
        1748217600000,
        [
            2851524535.794982,
            -3843729744.091066,
            -2023596751.712251,
        ],
    ],
    [
        1748822400000,
        [
            2837982545.518081,
            -3836182258.284326,
            -2021350023.986513,
        ],
    ],
    [
        1749427200000,
        [
            2823774696.724606,
            -3830470114.265356,
            -2019898582.167942,
        ],
    ],
    [
        1750032000000,
        [
            2809137348.438323,
            -3826637756.207021,
            -2019260821.561574,
        ],
    ],
    [
        1750636800000,
        [
            2794300309.345964,
            -3824717031.2815,
            -2019451292.31679,
        ],
    ],
    [
        1751241600000,
        [
            2779510448.216162,
            -3824726269.52979,
            -2020479689.635881,
        ],
    ],
    [
        1751846400000,
        [
            2765024945.39121,
            -3826642290.05915,
            -2022335555.607916,
        ],
    ],
    [
        1752451200000,
        [
            2751078524.122898,
            -3830409698.230931,
            -2024993681.339716,
        ],
    ],
    [
        1753056000000,
        [
            2737890008.015673,
            -3835962701.644328,
            -2028425806.283447,
        ],
    ],
    [
        1753660800000,
        [
            2725686530.689307,
            -3843220889.415553,
            -2032597889.076521,
        ],
    ],
    [
        1754265600000,
        [
            2714691306.333071,
            -3852063350.393816,
            -2037456256.33123,
        ],
    ],
    [
        1754870400000,
        [
            2705093947.673715,
            -3862342633.766428,
            -2042935709.318764,
        ],
    ],
    [
        1755475200000,
        [
            2697059915.036033,
            -3873906504.192617,
            -2048971065.741007,
        ],
    ],
    [
        1756080000000,
        [
            2690754526.919505,
            -3886590870.008165,
            -2055492571.860166,
        ],
    ],
    [
        1756684800000,
        [
            2686325281.289546,
            -3900196815.761844,
            -2062413384.919914,
        ],
    ],
    [
        1757289600000,
        [
            2683876355.663697,
            -3914508893.392353,
            -2069639635.962012,
        ],
    ],
    [
        1757894400000,
        [
            2683481148.617387,
            -3929316100.668841,
            -2077081146.310865,
        ],
    ],
    [
        1758499200000,
        [
            2685206151.929713,
            -3944402007.141665,
            -2084645095.71499,
        ],
    ],
    [
        1759104000000,
        [
            2689089063.710171,
            -3959524927.735797,
            -2092225329.979653,
        ],
    ],
    [
        1759708800000,
        [
            2695118796.755137,
            -3974439952.4876,
            -2099714538.030117,
        ],
    ],
    [
        1760313600000,
        [
            2703251585.334501,
            -3988918582.149574,
            -2107014356.547426,
        ],
    ],
    [
        1760918400000,
        [
            2713434450.445311,
            -4002736598.546656,
            -2114027996.215538,
        ],
    ],
    [
        1761523200000,
        [
            2725580192.970348,
            -4015657907.043358,
            -2120651741.54564,
        ],
    ],
    [
        1762128000000,
        [
            2739553394.289035,
            -4027459780.440583,
            -2126788657.836299,
        ],
    ],
    [
        1762732800000,
        [
            2755190419.762788,
            -4037950345.734344,
            -2132357166.056298,
        ],
    ],
    [
        1763337600000,
        [
            2772322224.488691,
            -4046953938.069234,
            -2137282053.191769,
        ],
    ],
    [
        1763942400000,
        [
            2790747946.303133,
            -4054297951.407506,
            -2141487549.756806,
        ],
    ],
    [
        1764547200000,
        [
            2810227494.259375,
            -4059839362.762809,
            -2144911511.77194,
        ],
    ],
    [
        1765152000000,
        [
            2830506037.912149,
            -4063478182.070983,
            -2147511786.116439,
        ],
    ],
    [
        1765756800000,
        [
            2851335654.46786,
            -4065139040.482615,
            -2149255568.863123,
        ],
    ],
    [
        1766361600000,
        [
            2872448608.295689,
            -4064760132.048578,
            -2150114282.408793,
        ],
    ],
    [
        1766966400000,
        [
            2893555578.438193,
            -4062319191.920273,
            -2150077824.312749,
        ],
    ],
    [
        1767571200000,
        [
            2914373335.168322,
            -4057841831.720225,
            -2149158433.471759,
        ],
    ],
    [
        1768176000000,
        [
            2934642871.553613,
            -4051378747.483128,
            -2147378040.05089,
        ],
    ],
    [
        1768780800000,
        [
            2954101778.766101,
            -4042996663.606232,
            -2144764517.706138,
        ],
    ],
    [
        1769385600000,
        [
            2972486027.19378,
            -4032802426.421455,
            -2141364806.733099,
        ],
    ],
    [
        1769990400000,
        [
            2989558740.347583,
            -4020945809.984791,
            -2137245632.786058,
        ],
    ],
    [
        1770595200000,
        [
            3005122566.487629,
            -4007592128.119337,
            -2132478547.558534,
        ],
    ],
    [
        1771200000000,
        [
            3018990705.987388,
            -3992915599.784705,
            -2127137775.518755,
        ],
    ],
    [
        1771804800000,
        [
            3030990834.871549,
            -3977121003.85448,
            -2121312240.991858,
        ],
    ],
    [
        1772409600000,
        [
            3040993110.109833,
            -3960441892.877113,
            -2115104137.195114,
        ],
    ],
    [
        1773014400000,
        [
            3048915114.401613,
            -3943110142.0625,
            -2108612924.457545,
        ],
    ],
    [
        1773619200000,
        [
            3054691059.135655,
            -3925353652.571334,
            -2101935879.816354,
        ],
    ],
    [
        1774224000000,
        [
            3058276880.175179,
            -3907416606.82454,
            -2095179368.869139,
        ],
    ],
    [
        1774828800000,
        [
            3059676021.507149,
            -3889555085.552718,
            -2088455888.471725,
        ],
    ],
    [
        1775433600000,
        [
            3058936562.335862,
            -3872005839.445096,
            -2081867621.322898,
        ],
    ],
    [
        1776038400000,
        [
            3056119345.642737,
            -3854989725.260082,
            -2075509701.179279,
        ],
    ],
    [
        1776643200000,
        [
            3051304988.285199,
            -3838730975.592696,
            -2069480418.339843,
        ],
    ],
    [
        1777248000000,
        [
            3044617763.363754,
            -3823450938.954544,
            -2063876996.473316,
        ],
    ],
    [
        1777852800000,
        [
            3036216342.760568,
            -3809337476.295606,
            -2058779694.628044,
        ],
    ],
    [
        1778457600000,
        [
            3026262623.124032,
            -3796554296.349358,
            -2054258273.995285,
        ],
    ],
    [
        1779062400000,
        [
            3014931655.726062,
            -3785259304.696679,
            -2050381640.279239,
        ],
    ],
    [
        1779667200000,
        [
            3002433795.16759,
            -3775596799.057503,
            -2047212920.819229,
        ],
    ],
    [
        1780272000000,
        [
            2988999983.178081,
            -3767669010.169614,
            -2044795051.283069,
        ],
    ],
    [
        1780876800000,
        [
            2974852280.413086,
            -3761551197.703297,
            -2043160128.235063,
        ],
    ],
    [
        1781481600000,
        [
            2960216825.181669,
            -3757309076.145278,
            -2042338019.172139,
        ],
    ],
    [
        1782086400000,
        [
            2945344128.266219,
            -3754989147.880405,
            -2042350048.885518,
        ],
    ],
    [
        1782691200000,
        [
            2930489875.180721,
            -3754593091.053756,
            -2043196003.315066,
        ],
    ],
    [
        1783296000000,
        [
            2915888541.409599,
            -3756097368.158776,
            -2044865518.299801,
        ],
    ],
    [
        1783900800000,
        [
            2901769658.970767,
            -3759469068.31461,
            -2047345492.88915,
        ],
    ],
    [
        1784505600000,
        [
            2888376384.524602,
            -3764653658.099437,
            -2050612487.049724,
        ],
    ],
    [
        1785110400000,
        [
            2875942606.339613,
            -3771552875.586482,
            -2054622033.074601,
        ],
    ],
    [
        1785715200000,
        [
            2864670516.114808,
            -3780048005.776381,
            -2059322071.425552,
        ],
    ],
    [
        1786320000000,
        [
            2854749499.904285,
            -3790014337.044987,
            -2064659572.45723,
        ],
    ],
    [
        1786924800000,
        [
            2846372293.976865,
            -3801306598.872793,
            -2070571766.303112,
        ],
    ],
    [
        1787529600000,
        [
            2839708507.079014,
            -3813741513.158545,
            -2076977962.27287,
        ],
    ],
    [
        1788134400000,
        [
            2834886795.071416,
            -3827124113.63699,
            -2083794079.681222,
        ],
    ],
    [
        1788739200000,
        [
            2832015919.310096,
            -3841260817.718248,
            -2090938005.116241,
        ],
    ],
    [
        1789344000000,
        [
            2831198619.243139,
            -3855942538.524256,
            -2098319386.37442,
        ],
    ],
    [
        1789948800000,
        [
            2832502650.397832,
            -3870932239.786124,
            -2105834120.078624,
        ],
    ],
    [
        1790553600000,
        [
            2835949023.901224,
            -3885993199.771542,
            -2113379620.900704,
        ],
    ],
    [
        1791158400000,
        [
            2841535379.834388,
            -3900900391.826905,
            -2120859316.990908,
        ],
    ],
    [
        1791763200000,
        [
            2849247992.038975,
            -3915421637.510408,
            -2128171811.557704,
        ],
    ],
    [
        1792368000000,
        [
            2859031309.407925,
            -3929310648.891074,
            -2135208666.950038,
        ],
    ],
    [
        1792972800000,
        [
            2870783037.813044,
            -3942336610.836489,
            -2141870099.397506,
        ],
    ],
    [
        1793577600000,
        [
            2884379520.471178,
            -3954293608.01681,
            -2148068274.046744,
        ],
    ],
    [
        1794182400000,
        [
            2899686078.129087,
            -3964980190.304905,
            -2153715637.45861,
        ],
    ],
    [
        1794787200000,
        [
            2916526267.022076,
            -3974197393.999829,
            -2158725230.709808,
        ],
    ],
    [
        1795392000000,
        [
            2934684584.670887,
            -3981778010.128768,
            -2163025572.847531,
        ],
    ],
    [
        1795996800000,
        [
            2953934080.83086,
            -3987592358.362692,
            -2166561832.340439,
        ],
    ],
    [
        1796601600000,
        [
            2974045518.523554,
            -3991525547.999577,
            -2169283279.188705,
        ],
    ],
    [
        1797206400000,
        [
            2994757667.218987,
            -3993478832.223383,
            -2171145814.907833,
        ],
    ],
    [
        1797811200000,
        [
            3015787296.231388,
            -3993396712.322143,
            -2172125758.962461,
        ],
    ],
    [
        1798416000000,
        [
            3036858035.252711,
            -3991267507.784942,
            -2172218697.555047,
        ],
    ],
    [
        1799020800000,
        [
            3057706960.617733,
            -3987098132.003928,
            -2171426291.720313,
        ],
    ],
    [
        1799625600000,
        [
            3078055587.632096,
            -3980917740.56889,
            -2169760393.669486,
        ],
    ],
    [
        1800230400000,
        [
            3097624798.045811,
            -3972801676.98389,
            -2167254928.353558,
        ],
    ],
    [
        1800835200000,
        [
            3116162862.344167,
            -3962866056.232215,
            -2163961561.957005,
        ],
    ],
    [
        1801440000000,
        [
            3133447227.91551,
            -3951240176.76089,
            -2159935496.926053,
        ],
    ],
    [
        1802044800000,
        [
            3149255896.451815,
            -3938071840.812967,
            -2155240464.128261,
        ],
    ],
    [
        1802649600000,
        [
            3163385069.847251,
            -3923547624.347779,
            -2149958518.763941,
        ],
    ],
    [
        1803254400000,
        [
            3175674790.668695,
            -3907881754.762542,
            -2144183028.156961,
        ],
    ],
    [
        1803859200000,
        [
            3186004088.577589,
            -3891287316.646334,
            -2138004573.836448,
        ],
    ],
    [
        1804464000000,
        [
            3194262687.913672,
            -3873984273.337297,
            -2131517630.345349,
        ],
    ],
    [
        1805068800000,
        [
            3200369399.436267,
            -3856217080.727953,
            -2124829064.728906,
        ],
    ],
    [
        1805673600000,
        [
            3204294078.824316,
            -3838239977.613494,
            -2118049487.298156,
        ],
    ],
    [
        1806278400000,
        [
            3206044962.206547,
            -3820289280.194051,
            -2111280077.685725,
        ],
    ],
    [
        1806883200000,
        [
            3205641351.608479,
            -3802595740.993741,
            -2104621027.799206,
        ],
    ],
    [
        1807488000000,
        [
            3203132260.750178,
            -3785400241.542608,
            -2098178473.053896,
        ],
    ],
    [
        1808092800000,
        [
            3198614995.396704,
            -3768937034.655691,
            -2092054558.407816,
        ],
    ],
    [
        1808697600000,
        [
            3192215699.627827,
            -3753408396.822045,
            -2086335693.250284,
        ],
    ],
    [
        1809302400000,
        [
            3184065003.26214,
            -3739001706.174324,
            -2081103033.061277,
        ],
    ],
    [
        1809907200000,
        [
            3174317675.196835,
            -3725902990.088689,
            -2076438155.409493,
        ],
    ],
    [
        1810512000000,
        [
            3163168506.204415,
            -3714279054.920019,
            -2072412873.469704,
        ],
    ],
    [
        1811116800000,
        [
            3150827398.770686,
            -3704255576.204859,
            -2069079878.614864,
        ],
    ],
    [
        1811721600000,
        [
            3137499062.749687,
            -3695939015.774683,
            -2066485424.309624,
        ],
    ],
    [
        1812326400000,
        [
            3123403664.756295,
            -3689427929.104482,
            -2064673551.617841,
        ],
    ],
    [
        1812931200000,
        [
            3108789870.959503,
            -3684794587.905646,
            -2063675555.472649,
        ],
    ],
    [
        1813536000000,
        [
            3093905760.126813,
            -3682067077.837866,
            -2063502711.142647,
        ],
    ],
    [
        1814140800000,
        [
            3078983366.861583,
            -3681255130.192322,
            -2064160210.36027,
        ],
    ],
    [
        1814745600000,
        [
            3064260597.507934,
            -3682358425.700072,
            -2065649385.590915,
        ],
    ],
    [
        1815350400000,
        [
            3049991591.567333,
            -3685347366.842882,
            -2067956815.450648,
        ],
    ],
    [
        1815955200000,
        [
            3036415128.285443,
            -3690149247.553578,
            -2071049480.253384,
        ],
    ],
    [
        1816560000000,
        [
            3023744498.952322,
            -3696676872.284019,
            -2074889931.524144,
        ],
    ],
    [
        1817164800000,
        [
            3012190459.685193,
            -3704833812.142925,
            -2079437072.486666,
        ],
    ],
    [
        1817769600000,
        [
            3001968264.47497,
            -3714494666.538624,
            -2084635439.133016,
        ],
    ],
    [
        1818374400000,
        [
            2993264365.332818,
            -3725496191.966141,
            -2090413092.457451,
        ],
    ],
    [
        1818979200000,
        [
            2986231299.995864,
            -3737668121.919668,
            -2096697368.3182,
        ],
    ],
    [
        1819584000000,
        [
            2981011187.297874,
            -3750835841.484332,
            -2103413983.065106,
        ],
    ],
    [
        1820188800000,
        [
            2977739100.172314,
            -3764800324.6432,
            -2110476121.189654,
        ],
    ],
    [
        1820793600000,
        [
            2976509465.696419,
            -3779334600.008331,
            -2117784795.096205,
        ],
    ],
    [
        1821398400000,
        [
            2977376583.436699,
            -3794215471.45849,
            -2125244430.582005,
        ],
    ],
    [
        1822003200000,
        [
            2980379085.27707,
            -3809223672.737619,
            -2132760666.793322,
        ],
    ],
    [
        1822608000000,
        [
            2985540142.098357,
            -3824123463.430359,
            -2140229809.35868,
        ],
    ],
    [
        1823212800000,
        [
            2992835091.30391,
            -3838664825.107415,
            -2147542333.114192,
        ],
    ],
    [
        1823817600000,
        [
            3002198034.491343,
            -3852615071.088096,
            -2154598160.569275,
        ],
    ],
    [
        1824422400000,
        [
            3013547166.672527,
            -3865756971.833728,
            -2161303587.487262,
        ],
    ],
    [
        1825027200000,
        [
            3026782066.690315,
            -3877868328.075064,
            -2167561116.139066,
        ],
    ],
    [
        1825632000000,
        [
            3041753651.691927,
            -3888729961.397732,
            -2173275646.547674,
        ],
    ],
    [
        1826236800000,
        [
            3058277269.473564,
            -3898155573.24017,
            -2178368097.951087,
        ],
    ],
    [
        1826841600000,
        [
            3076158987.217787,
            -3905987161.354597,
            -2182770772.426687,
        ],
    ],
    [
        1827446400000,
        [
            3095190945.642306,
            -3912073729.22832,
            -2186417037.064823,
        ],
    ],
    [
        1828051200000,
        [
            3115124960.582621,
            -3916283595.480455,
            -2189249639.947084,
        ],
    ],
    [
        1828656000000,
        [
            3135692333.585582,
            -3918530115.247765,
            -2191232014.97511,
        ],
    ],
    [
        1829260800000,
        [
            3156630439.2625,
            -3918763106.978978,
            -2192342137.230309,
        ],
    ],
    [
        1829865600000,
        [
            3177676088.268459,
            -3916946105.212335,
            -2192562292.576425,
        ],
    ],
    [
        1830470400000,
        [
            3198542333.150479,
            -3913071671.97066,
            -2191889138.46449,
        ],
    ],
    [
        1831075200000,
        [
            3218943159.3325,
            -3907181695.378155,
            -2190342109.189395,
        ],
    ],
    [
        1831680000000,
        [
            3238617974.502787,
            -3899354160.103581,
            -2187955195.362595,
        ],
    ],
    [
        1832284800000,
        [
            3257321607.20887,
            -3889679090.360961,
            -2184766319.918175,
        ],
    ],
    [
        1832889600000,
        [
            3274803160.435947,
            -3878275679.809387,
            -2180827982.382479,
        ],
    ],
    [
        1833494400000,
        [
            3290833391.980881,
            -3865306631.535409,
            -2176212274.12945,
        ],
    ],
    [
        1834099200000,
        [
            3305225117.110669,
            -3850960035.674222,
            -2171000537.837349,
        ],
    ],
    [
        1834704000000,
        [
            3317818696.818616,
            -3835424941.574723,
            -2165273067.012636,
        ],
    ],
    [
        1835308800000,
        [
            3328462341.162137,
            -3818910091.483824,
            -2159120567.404816,
        ],
    ],
    [
        1835913600000,
        [
            3337040135.411202,
            -3801653465.258257,
            -2152646916.745048,
        ],
    ],
    [
        1836518400000,
        [
            3343486821.364376,
            -3783900812.504605,
            -2145957817.582636,
        ],
    ],
    [
        1837123200000,
        [
            3347767623.218968,
            -3765883383.245837,
            -2139152054.191012,
        ],
    ],
    [
        1837728000000,
        [
            3349859991.980732,
            -3747839293.682507,
            -2132333785.691372,
        ],
    ],
    [
        1838332800000,
        [
            3349780946.484545,
            -3730020051.70281,
            -2125613426.642367,
        ],
    ],
    [
        1838937600000,
        [
            3347596238.963977,
            -3712667430.220147,
            -2119095521.80804,
        ],
    ],
    [
        1839542400000,
        [
            3343395002.534708,
            -3695995158.180689,
            -2112871964.777681,
        ],
    ],
    [
        1840147200000,
        [
            3337274755.436429,
            -3680212972.198552,
            -2107034835.801088,
        ],
    ],
    [
        1840752000000,
        [
            3329368299.85045,
            -3665530591.083796,
            -2101675840.896284,
        ],
    ],
    [
        1841356800000,
        [
            3319848638.400851,
            -3652133823.849672,
            -2096874265.813581,
        ],
    ],
    [
        1841961600000,
        [
            3308899727.245812,
            -3640171246.733345,
            -2092693169.639922,
        ],
    ],
    [
        1842566400000,
        [
            3296706326.49725,
            -3629780758.353946,
            -2089193063.086472,
        ],
    ],
    [
        1843171200000,
        [
            3283480131.614305,
            -3621091287.360764,
            -2086430317.769309,
        ],
    ],
    [
        1843776000000,
        [
            3269461032.630579,
            -3614199119.954812,
            -2084445539.909305,
        ],
    ],
    [
        1844380800000,
        [
            3254884852.545824,
            -3609160193.372338,
            -2083262588.665496,
        ],
    ],
    [
        1844985600000,
        [
            3239978867.989325,
            -3606018494.206361,
            -2082902219.440395,
        ],
    ],
    [
        1845590400000,
        [
            3224986859.289124,
            -3604805007.907258,
            -2083378839.367466,
        ],
    ],
    [
        1846195200000,
        [
            3210167449.884575,
            -3605514371.920877,
            -2084689075.193978,
        ],
    ],
    [
        1846800000000,
        [
            3195760359.507026,
            -3608102364.730106,
            -2086813374.667605,
        ],
    ],
    [
        1847404800000,
        [
            3181988276.129989,
            -3612514960.707815,
            -2089729418.766281,
        ],
    ],
    [
        1848009600000,
        [
            3169080584.555281,
            -3618684068.538248,
            -2093407655.464026,
        ],
    ],
    [
        1848614400000,
        [
            3157268912.017223,
            -3626504986.550038,
            -2097800827.803772,
        ],
    ],
    [
        1849219200000,
        [
            3146752861.656606,
            -3635839227.952178,
            -2102848422.507319,
        ],
    ],
    [
        1849824000000,
        [
            3137707706.324611,
            -3646543924.28559,
            -2108489757.575189,
        ],
    ],
    [
        1850428800000,
        [
            3130306046.000336,
            -3658464800.694053,
            -2114658305.303496,
        ],
    ],
    [
        1851033600000,
        [
            3124710216.67364,
            -3671415221.811067,
            -2121272082.427519,
        ],
    ],
    [
        1851638400000,
        [
            3121038753.686819,
            -3685184303.063576,
            -2128240219.487254,
        ],
    ],
    [
        1852243200000,
        [
            3119379765.564202,
            -3699565906.070154,
            -2135475010.956381,
        ],
    ],
    [
        1852848000000,
        [
            3119810933.274395,
            -3714348869.21609,
            -2142885005.567368,
        ],
    ],
    [
        1853452800000,
        [
            3122389324.822393,
            -3729297818.175801,
            -2150366621.763915,
        ],
    ],
    [
        1854057600000,
        [
            3127120572.295287,
            -3744166181.816532,
            -2157812992.543543,
        ],
    ],
    [
        1854662400000,
        [
            3133977904.983442,
            -3758724007.291952,
            -2165125206.815809,
        ],
    ],
    [
        1855267200000,
        [
            3142920970.441907,
            -3772745949.9066,
            -2172204881.815034,
        ],
    ],
    [
        1855872000000,
        [
            3153883218.694629,
            -3785994361.162769,
            -2178947455.033665,
        ],
    ],
    [
        1856476800000,
        [
            3166745217.897497,
            -3798237104.336106,
            -2185252994.278783,
        ],
    ],
    [
        1857081600000,
        [
            3181358879.766339,
            -3809273181.236606,
            -2191035794.035368,
        ],
    ],
    [
        1857686400000,
        [
            3197565642.173772,
            -3818918497.641135,
            -2196215922.219913,
        ],
    ],
    [
        1858291200000,
        [
            3215182043.463697,
            -3826990602.754471,
            -2200713458.795236,
        ],
    ],
    [
        1858896000000,
        [
            3233978878.254755,
            -3833329923.487999,
            -2204460345.553378,
        ],
    ],
    [
        1859500800000,
        [
            3253710460.608989,
            -3837820822.110966,
            -2207407451.443071,
        ],
    ],
    [
        1860105600000,
        [
            3274132624.979246,
            -3840374213.964502,
            -2209515091.529926,
        ],
    ],
    [
        1860710400000,
        [
            3294986830.870442,
            -3840912730.310869,
            -2210748191.113703,
        ],
    ],
    [
        1861315200000,
        [
            3315985426.428018,
            -3839393972.122486,
            -2211089002.738657,
        ],
    ],
    [
        1861920000000,
        [
            3336844175.695868,
            -3835825162.855563,
            -2210541246.533588,
        ],
    ],
    [
        1862524800000,
        [
            3357298436.479576,
            -3830242398.06719,
            -2209119527.965427,
        ],
    ],
    [
        1863129600000,
        [
            3377084668.314709,
            -3822695734.898299,
            -2206844808.242929,
        ],
    ],
    [
        1863734400000,
        [
            3395930395.604081,
            -3813273537.44634,
            -2203756993.656461,
        ],
    ],
    [
        1864339200000,
        [
            3413587524.741191,
            -3802109649.999489,
            -2199915263.523305,
        ],
    ],
    [
        1864944000000,
        [
            3429844596.182067,
            -3789359337.142761,
            -2195386126.570831,
        ],
    ],
    [
        1865548800000,
        [
            3444504963.352586,
            -3775184326.09528,
            -2190239044.390576,
        ],
    ],
    [
        1866153600000,
        [
            3457380229.292849,
            -3759777747.448519,
            -2184558862.394024,
        ],
    ],
    [
        1866758400000,
        [
            3468322438.299267,
            -3743364267.518183,
            -2178443105.860747,
        ],
    ],
    [
        1867363200000,
        [
            3477230565.850296,
            -3726174119.058757,
            -2171989912.718952,
        ],
    ],
    [
        1867968000000,
        [
            3484024839.58968,
            -3708429966.186989,
            -2165294942.355643,
        ],
    ],
    [
        1868572800000,
        [
            3488642519.631312,
            -3690373284.979093,
            -2158464053.616893,
        ],
    ],
    [
        1869177600000,
        [
            3491067520.512561,
            -3672259580.514194,
            -2151608374.705473,
        ],
    ],
    [
        1869782400000,
        [
            3491330270.15063,
            -3654332541.488383,
            -2144832594.662876,
        ],
    ],
    [
        1870387200000,
        [
            3489478770.404928,
            -3636814791.33001,
            -2138233452.640715,
        ],
    ],
    [
        1870992000000,
        [
            3485577235.220868,
            -3619935744.495702,
            -2131912157.698529,
        ],
    ],
    [
        1871596800000,
        [
            3479733474.667929,
            -3603923235.77354,
            -2125967689.037137,
        ],
    ],
    [
        1872201600000,
        [
            3472093255.903818,
            -3588978635.973881,
            -2120485956.029066,
        ],
    ],
    [
        1872806400000,
        [
            3462809878.032225,
            -3575272589.018055,
            -2115540718.040289,
        ],
    ],
    [
        1873411200000,
        [
            3452046897.187747,
            -3562973617.697526,
            -2111205955.28607,
        ],
    ],
    [
        1874016000000,
        [
            3440003513.203838,
            -3552237199.485141,
            -2107548408.998266,
        ],
    ],
    [
        1874620800000,
        [
            3426904346.07268,
            -3543182596.015609,
            -2104618168.971348,
        ],
    ],
    [
        1875225600000,
        [
            3412968498.004111,
            -3535894544.014459,
            -2102452322.054834,
        ],
    ],
    [
        1875830400000,
        [
            3398416821.996947,
            -3530451771.300167,
            -2101086566.663496,
        ],
    ],
    [
        1876435200000,
        [
            3383494945.44553,
            -3526914020.7894,
            -2100546766.860803,
        ],
    ],
    [
        1877040000000,
        [
            3368459439.429415,
            -3525300614.992684,
            -2100840405.706726,
        ],
    ],
    [
        1877644800000,
        [
            3353547594.681788,
            -3525597906.65717,
            -2101962479.804637,
        ],
    ],
    [
        1878249600000,
        [
            3338989929.691529,
            -3527786149.495533,
            -2103905716.671378,
        ],
    ],
    [
        1878854400000,
        [
            3325030691.98353,
            -3531824313.888931,
            -2106651498.500035,
        ],
    ],
    [
        1879459200000,
        [
            3311911408.634732,
            -3537630339.831527,
            -2110162607.283885,
        ],
    ],
    [
        1880064000000,
        [
            3299842233.525138,
            -3545094204.147584,
            -2114391736.974627,
        ],
    ],
    [
        1880668800000,
        [
            3289019437.750518,
            -3554102519.770914,
            -2119290461.851843,
        ],
    ],
    [
        1881273600000,
        [
            3279642396.958763,
            -3564521825.037273,
            -2124800023.689321,
        ],
    ],
    [
        1881878400000,
        [
            3271894706.319889,
            -3576181307.410558,
            -2130845407.692175,
        ],
    ],
    [
        1882483200000,
        [
            3265917617.793279,
            -3588891429.702617,
            -2137345845.67589,
        ],
    ],
    [
        1883088000000,
        [
            3261832150.00688,
            -3602465834.888984,
            -2144221859.310121,
        ],
    ],
    [
        1883692800000,
        [
            3259752370.219709,
            -3616703402.302567,
            -2151385712.914993,
        ],
    ],
    [
        1884297600000,
        [
            3259765081.028979,
            -3631373712.002063,
            -2158736765.746799,
        ],
    ],
    [
        1884902400000,
        [
            3261906860.713279,
            -3646240316.320504,
            -2166173636.589626,
        ],
    ],
    [
        1885507200000,
        [
            3266190957.515092,
            -3661079424.294353,
            -2173599604.161057,
        ],
    ],
    [
        1886112000000,
        [
            3272617337.129137,
            -3675661043.405927,
            -2180913463.353395,
        ],
    ],
    [
        1886716800000,
        [
            3281151762.789529,
            -3689737808.680603,
            -2188006874.806617,
        ],
    ],
    [
        1887321600000,
        [
            3291707569.223456,
            -3703072197.132898,
            -2194778011.32315,
        ],
    ],
    [
        1887926400000,
        [
            3304176799.700869,
            -3715451914.180376,
            -2201135247.221933,
        ],
    ],
    [
        1888531200000,
        [
            3318437478.928387,
            -3726670359.851846,
            -2206988120.639244,
        ],
    ],
    [
        1889136000000,
        [
            3334332745.068376,
            -3736518869.030927,
            -2212246136.455149,
        ],
    ],
    [
        1889740800000,
        [
            3351658741.892023,
            -3744816112.800032,
            -2216832583.923649,
        ],
    ],
    [
        1890345600000,
        [
            3370199694.405597,
            -3751418855.067683,
            -2220685773.691821,
        ],
    ],
    [
        1890950400000,
        [
            3389733533.384888,
            -3756200659.899912,
            -2223749637.046313,
        ],
    ],
    [
        1891555200000,
        [
            3410011736.003467,
            -3759046403.776074,
            -2225973798.8587,
        ],
    ],
    [
        1892160000000,
        [
            3430754201.466202,
            -3759881650.893787,
            -2227327092.422235,
        ],
    ],
    [
        1892764800000,
        [
            3451686689.954798,
            -3758677315.627958,
            -2227796392.680912,
        ],
    ],
    [
        1893369600000,
        [
            3472544412.907672,
            -3755425990.063085,
            -2227376846.837155,
        ],
    ],
    [
        1893974400000,
        [
            3493051409.475515,
            -3750138070.131491,
            -2226072898.841765,
        ],
    ],
    [
        1894579200000,
        [
            3512921360.741863,
            -3742869857.545363,
            -2223910613.294498,
        ],
    ],
    [
        1895184000000,
        [
            3531894319.566536,
            -3733721225.007302,
            -2220933397.905712,
        ],
    ],
    [
        1895788800000,
        [
            3549736862.460657,
            -3722809542.454549,
            -2217191256.453884,
        ],
    ],
    [
        1896393600000,
        [
            3566219669.583935,
            -3710266897.82458,
            -2212742073.322289,
        ],
    ],
    [
        1896998400000,
        [
            3581123154.83406,
            -3696266204.647414,
            -2207662288.355009,
        ],
    ],
    [
        1897603200000,
        [
            3594270965.058216,
            -3681011689.529873,
            -2202039830.416168,
        ],
    ],
    [
        1898208000000,
        [
            3605525495.194282,
            -3664711583.577805,
            -2195963353.718699,
        ],
    ],
    [
        1898812800000,
        [
            3614762897.008899,
            -3647577225.838048,
            -2189524576.910044,
        ],
    ],
    [
        1899417600000,
        [
            3621882251.086392,
            -3629848098.819734,
            -2182828114.192955,
        ],
    ],
    [
        1900022400000,
        [
            3626833798.394476,
            -3611776894.702393,
            -2175982649.676634,
        ],
    ],
    [
        1900627200000,
        [
            3629608802.12977,
            -3593603548.294444,
            -2169091113.226337,
        ],
    ],
    [
        1901232000000,
        [
            3630212142.526242,
            -3575557815.025772,
            -2162254245.535623,
        ],
    ],
    [
        1901836800000,
        [
            3628674585.038293,
            -3557884109.667227,
            -2155579436.493576,
        ],
    ],
    [
        1902441600000,
        [
            3625075678.039271,
            -3540822716.516399,
            -2149170393.876223,
        ],
    ],
    [
        1903046400000,
        [
            3619528761.49481,
            -3524586662.262631,
            -2143118669.442565,
        ],
    ],
    [
        1903651200000,
        [
            3612153146.090144,
            -3509368332.918566,
            -2137508718.216664,
        ],
    ],
    [
        1904256000000,
        [
            3603090115.62327,
            -3495363771.045237,
            -2132426059.517289,
        ],
    ],
    [
        1904860800000,
        [
            3592521455.343107,
            -3482751120.177841,
            -2127946459.943693,
        ],
    ],
    [
        1905465600000,
        [
            3580650630.755873,
            -3471671245.185608,
            -2124129673.215035,
        ],
    ],
    [
        1906070400000,
        [
            3567676098.758769,
            -3462238978.659196,
            -2121026464.776745,
        ],
    ],
    [
        1906675200000,
        [
            3553810797.049499,
            -3454566380.052538,
            -2118685989.568983,
        ],
    ],
    [
        1907280000000,
        [
            3539296598.702253,
            -3448739482.704604,
            -2117144607.426891,
        ],
    ],
    [
        1907884800000,
        [
            3524382316.035987,
            -3444802903.045642,
            -2116421363.701046,
        ],
    ],
    [
        1908489600000,
        [
            3509299471.155725,
            -3442775619.16216,
            -2116526318.297828,
        ],
    ],
    [
        1909094400000,
        [
            3494285182.805239,
            -3442671741.92876,
            -2117466324.63457,
        ],
    ],
    [
        1909699200000,
        [
            3479593134.334072,
            -3444475789.815077,
            -2119233528.268786,
        ],
    ],
    [
        1910304000000,
        [
            3465469473.154917,
            -3448130731.663766,
            -2121802553.065566,
        ],
    ],
    [
        1910908800000,
        [
            3452132268.384945,
            -3453557936.97488,
            -2125140381.728091,
        ],
    ],
    [
        1911513600000,
        [
            3439797327.105366,
            -3460674386.561814,
            -2129210764.657739,
        ],
    ],
    [
        1912118400000,
        [
            3428685408.377792,
            -3469367415.968084,
            -2133963232.61668,
        ],
    ],
    [
        1912723200000,
        [
            3418996301.186604,
            -3479486427.074169,
            -2139332128.009429,
        ],
    ],
    [
        1913328000000,
        [
            3410892273.154687,
            -3490867237.711622,
            -2145247842.359296,
        ],
    ],
    [
        1913932800000,
        [
            3404525913.685919,
            -3503345301.436677,
            -2151639323.664265,
        ],
    ],
    [
        1914537600000,
        [
            3400043312.303234,
            -3516730904.964449,
            -2158423513.211118,
        ],
    ],
    [
        1915142400000,
        [
            3397557241.727803,
            -3530804435.502568,
            -2165505658.035761,
        ],
    ],
    [
        1915747200000,
        [
            3397135621.983914,
            -3545344510.468523,
            -2172791400.276038,
        ],
    ],
    [
        1916352000000,
        [
            3398831479.872681,
            -3560136481.135047,
            -2180187301.639385,
        ],
    ],
    [
        1916956800000,
        [
            3402682651.981033,
            -3574948684.65116,
            -2187591397.933018,
        ],
    ],
    [
        1917561600000,
        [
            3408685477.660285,
            -3589531209.765161,
            -2194895258.184707,
        ],
    ],
    [
        1918166400000,
        [
            3416789063.266408,
            -3603647165.847752,
            -2201997121.63886,
        ],
    ],
    [
        1918771200000,
        [
            3426927120.180295,
            -3617076499.220609,
            -2208800766.854845,
        ],
    ],
    [
        1919376000000,
        [
            3439014440.828248,
            -3629594088.218983,
            -2215207422.769551,
        ],
    ],
    [
        1919980800000,
        [
            3452922141.95463,
            -3640972056.846462,
            -2221119162.975186,
        ],
    ],
    [
        1920585600000,
        [
            3468478215.955267,
            -3651012777.453486,
            -2226451994.093491,
        ],
    ],
    [
        1921190400000,
        [
            3485501264.483923,
            -3659547390.099802,
            -2231132351.622048,
        ],
    ],
    [
        1921795200000,
        [
            3503794681.843555,
            -3666415013.317292,
            -2235089685.171777,
        ],
    ],
    [
        1922400000000,
        [
            3523124827.713992,
            -3671467448.320792,
            -2238260612.538207,
        ],
    ],
    [
        1923004800000,
        [
            3543228366.175016,
            -3674601249.388616,
            -2240601211.920501,
        ],
    ],
    [
        1923609600000,
        [
            3563847426.244171,
            -3675749906.434132,
            -2242081280.292494,
        ],
    ],
    [
        1924214400000,
        [
            3584721633.162445,
            -3674863051.496604,
            -2242677561.644227,
        ],
    ],
    [
        1924819200000,
        [
            3605568866.756311,
            -3671912793.975696,
            -2242378604.800333,
        ],
    ],
    [
        1925424000000,
        [
            3626098093.131267,
            -3666922868.552873,
            -2241195541.384847,
        ],
    ],
    [
        1926028800000,
        [
            3646043431.171253,
            -3659954276.931081,
            -2239153866.415916,
        ],
    ],
    [
        1926633600000,
        [
            3665152831.211104,
            -3651083872.317788,
            -2236286460.177109,
        ],
    ],
    [
        1927238400000,
        [
            3683169925.49429,
            -3640411950.854229,
            -2232638363.964292,
        ],
    ],
    [
        1927843200000,
        [
            3699850799.901868,
            -3628087024.228799,
            -2228275038.708774,
        ],
    ],
    [
        1928448000000,
        [
            3714994282.949464,
            -3614285124.104231,
            -2223271753.634788,
        ],
    ],
    [
        1929052800000,
        [
            3728426509.14464,
            -3599187853.844608,
            -2217706541.355911,
        ],
    ],
    [
        1929657600000,
        [
            3739982683.771903,
            -3582991638.68251,
            -2211665465.675598,
        ],
    ],
    [
        1930262400000,
        [
            3749526585.309999,
            -3565928286.992681,
            -2205248997.672707,
        ],
    ],
    [
        1930867200000,
        [
            3756974542.276567,
            -3548239834.493298,
            -2198560386.782591,
        ],
    ],
    [
        1931472000000,
        [
            3762275294.152328,
            -3530158090.540102,
            -2191699550.813263,
        ],
    ],
    [
        1932076800000,
        [
            3765390849.213625,
            -3511917111.626995,
            -2184769362.962703,
        ],
    ],
    [
        1932681600000,
        [
            3766318012.018256,
            -3493770801.863575,
            -2177880310.952402,
        ],
    ],
    [
        1933286400000,
        [
            3765104929.201604,
            -3475965436.103704,
            -2171138272.409564,
        ],
    ],
    [
        1933891200000,
        [
            3761827186.712755,
            -3458722499.76878,
            -2164639555.964283,
        ],
    ],
    [
        1934496000000,
        [
            3756568866.737418,
            -3442254811.088261,
            -2158478133.790719,
        ],
    ],
    [
        1935100800000,
        [
            3749446833.00005,
            -3426781394.906796,
            -2152748812.926097,
        ],
    ],
    [
        1935705600000,
        [
            3740620616.617132,
            -3412498802.107169,
            -2147535237.53812,
        ],
    ],
    [
        1936310400000,
        [
            3730266461.511208,
            -3399568299.199006,
            -2142906988.313075,
        ],
    ],
    [
        1936915200000,
        [
            3718560015.82431,
            -3388135562.426167,
            -2138928266.10407,
        ],
    ],
    [
        1937520000000,
        [
            3705703364.863892,
            -3378342983.566864,
            -2135660087.715021,
        ],
    ],
    [
        1938124800000,
        [
            3691928743.065999,
            -3370300889.542067,
            -2133148948.707994,
        ],
    ],
    [
        1938729600000,
        [
            3677471375.519281,
            -3364079849.853808,
            -2131425924.59653,
        ],
    ],
    [
        1939334400000,
        [
            3662554801.030681,
            -3359733492.63135,
            -2130516101.950366,
        ],
    ],
    [
        1939939200000,
        [
            3647420157.752118,
            -3357307703.581921,
            -2130439191.299644,
        ],
    ],
    [
        1940544000000,
        [
            3632324647.174581,
            -3356811943.620917,
            -2131198481.136402,
        ],
    ],
    [
        1941148800000,
        [
            3617514270.301998,
            -3358216285.765814,
            -2132781614.709192,
        ],
    ],
    [
        1941753600000,
        [
            3603213138.368464,
            -3361476303.926742,
            -2135170524.079076,
        ],
    ],
    [
        1942358400000,
        [
            3589654373.09525,
            -3366538384.220462,
            -2138340779.616956,
        ],
    ],
    [
        1942963200000,
        [
            3577074035.470833,
            -3373311619.097327,
            -2142251511.821141,
        ],
    ],
    [
        1943568000000,
        [
            3565684077.839165,
            -3381669595.037595,
            -2146848246.830536,
        ],
    ],
    [
        1944172800000,
        [
            3555666080.201919,
            -3391477212.748818,
            -2152073393.648643,
        ],
    ],
    [
        1944777600000,
        [
            3547202230.752361,
            -3402592165.212112,
            -2157864334.980765,
        ],
    ],
    [
        1945382400000,
        [
            3540464964.453979,
            -3414838467.707027,
            -2164144262.788404,
        ],
    ],
    [
        1945987200000,
        [
            3535590414.654171,
            -3428012897.816238,
            -2170826449.431664,
        ],
    ],
    [
        1946592000000,
        [
            3532677399.799915,
            -3441913294.672165,
            -2177824599.907616,
        ],
    ],
    [
        1947196800000,
        [
            3531817867.64369,
            -3456335799.247458,
            -2185049397.948415,
        ],
    ],
    [
        1947801600000,
        [
            3533083455.727572,
            -3471050613.637862,
            -2192400539.10936,
        ],
    ],
    [
        1948406400000,
        [
            3536500562.077553,
            -3485812472.385615,
            -2199772555.670391,
        ],
    ],
    [
        1949011200000,
        [
            3542055634.278457,
            -3500389860.987854,
            -2207065348.659007,
        ],
    ],
    [
        1949616000000,
        [
            3549724658.215694,
            -3514557993.748314,
            -2214179749.933012,
        ],
    ],
    [
        1950220800000,
        [
            3559457519.184299,
            -3528077859.937119,
            -2221011392.711318,
        ],
    ],
    [
        1950825600000,
        [
            3571155433.59353,
            -3540710378.596621,
            -2227457910.12725,
        ],
    ],
    [
        1951430400000,
        [
            3584682888.09162,
            -3552245935.339037,
            -2233429102.904062,
        ],
    ],
    [
        1952035200000,
        [
            3599895909.928026,
            -3562492814.600214,
            -2238840905.727196,
        ],
    ],
    [
        1952640000000,
        [
            3616625301.627016,
            -3571259605.416178,
            -2243610476.682775,
        ],
    ],
    [
        1953244800000,
        [
            3634657739.198844,
            -3578371475.739584,
            -2247663751.709753,
        ],
    ],
    [
        1953849600000,
        [
            3653754773.251952,
            -3583697970.403934,
            -2250944439.228227,
        ],
    ],
    [
        1954454400000,
        [
            3673680071.664679,
            -3587135658.115909,
            -2253406152.060896,
        ],
    ],
    [
        1955059200000,
        [
            3694182244.935769,
            -3588592979.092983,
            -2255008698.192035,
        ],
    ],
    [
        1955664000000,
        [
            3714980071.955457,
            -3588007020.592636,
            -2255725795.457714,
        ],
    ],
    [
        1956268800000,
        [
            3735787156.523798,
            -3585367685.22109,
            -2255552620.575263,
        ],
    ],
    [
        1956873600000,
        [
            3756336664.717083,
            -3580694167.77317,
            -2254496038.695434,
        ],
    ],
    [
        1957478400000,
        [
            3776362574.163212,
            -3574021670.796034,
            -2252571531.805625,
        ],
    ],
    [
        1958083200000,
        [
            3795587917.704629,
            -3565417900.168418,
            -2249810201.25771,
        ],
    ],
    [
        1958688000000,
        [
            3813752518.512752,
            -3555002108.846839,
            -2246263822.062045,
        ],
    ],
    [
        1959292800000,
        [
            3830633245.772813,
            -3542915662.500905,
            -2241992835.195306,
        ],
    ],
    [
        1959897600000,
        [
            3846022547.158709,
            -3529310088.727671,
            -2237063453.483092,
        ],
    ],
    [
        1960502400000,
        [
            3859718773.027519,
            -3514363223.187698,
            -2231554023.39332,
        ],
    ],
    [
        1961107200000,
        [
            3871554926.811016,
            -3498292589.50828,
            -2225557887.999106,
        ],
    ],
    [
        1961712000000,
        [
            3881412621.682789,
            -3481321940.312964,
            -2219170484.117877,
        ],
    ],
    [
        1962316800000,
        [
            3889197030.808574,
            -3463671611.81756,
            -2212487494.260298,
        ],
    ],
    [
        1962921600000,
        [
            3894828284.998462,
            -3445575961.004386,
            -2205611496.550264,
        ],
    ],
    [
        1963526400000,
        [
            3898269684.753277,
            -3427292146.717108,
            -2198653090.625641,
        ],
    ],
    [
        1964131200000,
        [
            3899534076.237399,
            -3409065671.043993,
            -2191717964.154568,
        ],
    ],
    [
        1964736000000,
        [
            3898655603.278472,
            -3391124393.326252,
            -2184906123.036992,
        ],
    ],
    [
        1965340800000,
        [
            3895682508.388609,
            -3373698395.027771,
            -2178318840.402708,
        ],
    ],
    [
        1965945600000,
        [
            3890705179.248097,
            -3357024542.863755,
            -2172057992.987032,
        ],
    ],
    [
        1966550400000,
        [
            3883855557.369113,
            -3341312897.90064,
            -2166213818.231107,
        ],
    ],
    [
        1967155200000,
        [
            3875277717.927463,
            -3326744833.258561,
            -2160865713.003389,
        ],
    ],
    [
        1967760000000,
        [
            3865123226.073322,
            -3313495425.649893,
            -2156090113.53628,
        ],
    ],
    [
        1968364800000,
        [
            3853579604.633162,
            -3301733943.852728,
            -2151958721.635878,
        ],
    ],
    [
        1968969600000,
        [
            3840863329.241672,
            -3291592644.182606,
            -2148527846.776625,
        ],
    ],
    [
        1969574400000,
        [
            3827190621.004642,
            -3283169534.82884,
            -2145841000.545338,
        ],
    ],
    [
        1970179200000,
        [
            3812775704.013052,
            -3276553060.328111,
            -2143937428.793366,
        ],
    ],
    [
        1970784000000,
        [
            3797859493.938511,
            -3271818517.964249,
            -2142848825.75932,
        ],
    ],
    [
        1971388800000,
        [
            3782696808.361644,
            -3268999829.934663,
            -2142589864.052076,
        ],
    ],
    [
        1971993600000,
        [
            3767528794.585577,
            -3268096609.669356,
            -2143161956.610641,
        ],
    ],
    [
        1972598400000,
        [
            3752584795.777702,
            -3269099834.639842,
            -2144561837.238637,
        ],
    ],
    [
        1973203200000,
        [
            3738111138.043433,
            -3271983717.853605,
            -2146776849.804906,
        ],
    ],
    [
        1973808000000,
        [
            3724353545.530433,
            -3276680511.365767,
            -2149777054.299546,
        ],
    ],
    [
        1974412800000,
        [
            3711532142.319998,
            -3283091634.545677,
            -2153520548.036993,
        ],
    ],
    [
        1975017600000,
        [
            3699847023.205191,
            -3291113591.209842,
            -2157962282.600984,
        ],
    ],
    [
        1975622400000,
        [
            3689505939.609951,
            -3300625908.146837,
            -2163048447.460302,
        ],
    ],
    [
        1976227200000,
        [
            3680702280.598385,
            -3311469671.634484,
            -2168710237.625934,
        ],
    ],
    [
        1976832000000,
        [
            3673592803.750643,
            -3323462902.198335,
            -2174870378.398545,
        ],
    ],
    [
        1977436800000,
        [
            3668306993.513993,
            -3336426121.655769,
            -2181451424.945961,
        ],
    ],
    [
        1978041600000,
        [
            3664972790.290121,
            -3350166889.872764,
            -2188369005.631091,
        ],
    ],
    [
        1978646400000,
        [
            3663691482.845953,
            -3364462144.956335,
            -2195526958.730998,
        ],
    ],
    [
        1979251200000,
        [
            3664519069.805118,
            -3379077291.285515,
            -2202824914.363382,
        ],
    ],
    [
        1979856000000,
        [
            3667480373.107365,
            -3393790471.746523,
            -2210166094.414068,
        ],
    ],
    [
        1980460800000,
        [
            3672592480.395093,
            -3408374237.043468,
            -2217450156.447859,
        ],
    ],
    [
        1981065600000,
        [
            3679838079.000361,
            -3422582010.206704,
            -2224570278.835587,
        ],
    ],
    [
        1981670400000,
        [
            3689150879.09012,
            -3436170645.019445,
            -2231422057.293394,
        ],
    ],
    [
        1982275200000,
        [
            3700434940.322248,
            -3448922931.395265,
            -2237910677.549808,
        ],
    ],
    [
        1982880000000,
        [
            3713585211.402919,
            -3460626989.93885,
            -2243943257.104315,
        ],
    ],
    [
        1983484800000,
        [
            3728460750.093723,
            -3471066918.958298,
            -2249427285.754714,
        ],
    ],
    [
        1984089600000,
        [
            3744874745.460514,
            -3480047591.084924,
            -2254279842.610459,
        ],
    ],
    [
        1984694400000,
        [
            3762619783.693777,
            -3487413817.486059,
            -2258433178.615932,
        ],
    ],
    [
        1985299200000,
        [
            3781485555.958835,
            -3493026598.35605,
            -2261826066.050517,
        ],
    ],
    [
        1985904000000,
        [
            3801233638.468013,
            -3496756914.214368,
            -2264403259.560635,
        ],
    ],
    [
        1986508800000,
        [
            3821592460.632352,
            -3498510620.760851,
            -2266124668.726932,
        ],
    ],
    [
        1987113600000,
        [
            3842288047.558168,
            -3498242552.070041,
            -2266969251.469757,
        ],
    ],
    [
        1987718400000,
        [
            3863057815.026984,
            -3495928894.958975,
            -2266925439.334576,
        ],
    ],
    [
        1988323200000,
        [
            3883626657.458401,
            -3491563604.75838,
            -2265991406.735478,
        ],
    ],
    [
        1988928000000,
        [
            3903705505.911525,
            -3485181925.934937,
            -2264183424.983932,
        ],
    ],
    [
        1989532800000,
        [
            3923025050.439144,
            -3476868479.047647,
            -2261537302.830687,
        ],
    ],
    [
        1990137600000,
        [
            3941343725.019881,
            -3466725559.84331,
            -2258097210.174392,
        ],
    ],
    [
        1990742400000,
        [
            3958424055.482969,
            -3454871766.787882,
            -2253916044.267253,
        ],
    ],
    [
        1991347200000,
        [
            3974033573.464619,
            -3441463115.444911,
            -2249062335.456318,
        ],
    ],
    [
        1991952000000,
        [
            3987978967.357478,
            -3426694785.544111,
            -2243619287.108647,
        ],
    ],
    [
        1992556800000,
        [
            4000107010.997376,
            -3410766264.151672,
            -2237672733.410351,
        ],
    ],
    [
        1993161600000,
        [
            4010280152.940605,
            -3393882760.586447,
            -2231312391.402124,
        ],
    ],
    [
        1993766400000,
        [
            4018378794.539683,
            -3376274705.833741,
            -2224638182.632949,
        ],
    ],
    [
        1994371200000,
        [
            4024333382.74399,
            -3358194587.841617,
            -2217757806.380425,
        ],
    ],
    [
        1994976000000,
        [
            4028117472.882366,
            -3339881720.769894,
            -2210774876.036003,
        ],
    ],
    [
        1995580800000,
        [
            4029721964.485372,
            -3321567843.815861,
            -2203791355.450308,
        ],
    ],
    [
        1996185600000,
        [
            4029158712.930202,
            -3303496404.712238,
            -2196913414.015306,
        ],
    ],
    [
        1996790400000,
        [
            4026489738.377611,
            -3285915589.718783,
            -2190247536.882942,
        ],
    ],
    [
        1997395200000,
        [
            4021813471.637308,
            -3269044946.416019,
            -2183889313.789443,
        ],
    ],
    [
        1998000000000,
        [
            4015238899.330225,
            -3253085335.095638,
            -2177927187.273973,
        ],
    ],
    [
        1998604800000,
        [
            4006891859.763888,
            -3238238377.850421,
            -2172448356.875771,
        ],
    ],
    [
        1999209600000,
        [
            3996941799.470709,
            -3224695885.823191,
            -2167534079.4283,
        ],
    ],
    [
        1999814400000,
        [
            3985582654.286871,
            -3212610128.286591,
            -2163250229.538826,
        ],
    ],
    [
        2000419200000,
        [
            3973008107.397454,
            -3202108098.259831,
            -2159652789.922655,
        ],
    ],
    [
        2001024000000,
        [
            3959421055.065199,
            -3193311440.173183,
            -2156794098.363601,
        ],
    ],
    [
        2001628800000,
        [
            3945057691.780865,
            -3186322445.851131,
            -2154717240.618384,
        ],
    ],
    [
        2002233600000,
        [
            3930163896.091692,
            -3181199269.264669,
            -2153448295.11247,
        ],
    ],
    [
        2002838400000,
        [
            3914972686.150479,
            -3177973824.340269,
            -2153002760.198047,
        ],
    ],
    [
        2003443200000,
        [
            3899717199.083626,
            -3176671491.028175,
            -2153391487.327821,
        ],
    ],
    [
        2004048000000,
        [
            3884652231.562207,
            -3177293108.406655,
            -2154613797.411229,
        ],
    ],
    [
        2004652800000,
        [
            3870027407.603349,
            -3179795373.314707,
            -2156651552.466725,
        ],
    ],
    [
        2005257600000,
        [
            3856068085.102242,
            -3184111343.825459,
            -2159476531.167367,
        ],
    ],
    [
        2005862400000,
        [
            3842991751.977109,
            -3190169233.810913,
            -2163056370.930703,
        ],
    ],
    [
        2006467200000,
        [
            3831026517.953528,
            -3197870721.119212,
            -2167347015.158637,
        ],
    ],
    [
        2007072000000,
        [
            3820381539.684052,
            -3207077234.917446,
            -2172289066.718974,
        ],
    ],
    [
        2007676800000,
        [
            3811231675.371446,
            -3217632908.837976,
            -2177815971.382686,
        ],
    ],
    [
        2008281600000,
        [
            3803736494.732679,
            -3229382281.481996,
            -2183859558.242528,
        ],
    ],
    [
        2008886400000,
        [
            3798055130.762033,
            -3242145783.057447,
            -2190341596.922504,
        ],
    ],
    [
        2009491200000,
        [
            3794314863.296446,
            -3255712025.944168,
            -2197171950.601669,
        ],
    ],
    [
        2010096000000,
        [
            3792600422.577312,
            -3269862594.36923,
            -2204257061.731319,
        ],
    ],
    [
        2010700800000,
        [
            3792975787.713417,
            -3284387817.351531,
            -2211504817.804364,
        ],
    ],
    [
        2011305600000,
        [
            3795495776.685164,
            -3299060168.966475,
            -2218815758.197124,
        ],
    ],
    [
        2011910400000,
        [
            3800174271.233657,
            -3313632256.094992,
            -2226083423.631979,
        ],
    ],
    [
        2012515200000,
        [
            3806978955.709938,
            -3327863118.812214,
            -2233203591.781757,
        ],
    ],
    [
        2013120000000,
        [
            3815855924.118849,
            -3341531608.591291,
            -2240078689.139895,
        ],
    ],
    [
        2013724800000,
        [
            3826737998.125418,
            -3354409017.803296,
            -2246609093.31917,
        ],
    ],
    [
        2014329600000,
        [
            3839513708.714569,
            -3366262434.909433,
            -2252695273.20037,
        ],
    ],
    [
        2014934400000,
        [
            3854027819.225385,
            -3376881998.669835,
            -2258247100.002544,
        ],
    ],
    [
        2015539200000,
        [
            3870109044.627936,
            -3386090608.763088,
            -2263186806.687866,
        ],
    ],
    [
        2016144000000,
        [
            3887575519.631518,
            -3393715918.015922,
            -2267439877.903873,
        ],
    ],
    [
        2016748800000,
        [
            3906206280.922817,
            -3399597366.778713,
            -2270938136.879422,
        ],
    ],
    [
        2017353600000,
        [
            3925747983.130784,
            -3403612614.969418,
            -2273628646.334891,
        ],
    ],
    [
        2017958400000,
        [
            3945945922.912771,
            -3405681545.386631,
            -2275474886.287513,
        ],
    ],
    [
        2018563200000,
        [
            3966546283.683624,
            -3405737246.719868,
            -2276447491.212587,
        ],
    ],
    [
        2019168000000,
        [
            3987270662.74715,
            -3403735282.092533,
            -2276528072.053433,
        ],
    ],
    [
        2019772800000,
        [
            4007827467.738661,
            -3399677955.752149,
            -2275717369.443508,
        ],
    ],
    [
        2020377600000,
        [
            4027944468.823811,
            -3393611480.888958,
            -2274034069.520394,
        ],
    ],
    [
        2020982400000,
        [
            4047365842.561643,
            -3385595977.864094,
            -2271504889.868707,
        ],
    ],
    [
        2021587200000,
        [
            4065829125.345121,
            -3375716087.012573,
            -2268168183.037617,
        ],
    ],
    [
        2022192000000,
        [
            4083079125.538071,
            -3364101922.717673,
            -2264080423.048018,
        ],
    ],
    [
        2022796800000,
        [
            4098899880.654126,
            -3350918964.653707,
            -2259312234.78493,
        ],
    ],
    [
        2023401600000,
        [
            4113104955.691968,
            -3336337399.574788,
            -2253937989.434385,
        ],
    ],
    [
        2024006400000,
        [
            4125516331.64177,
            -3320544031.820624,
            -2248039567.866158,
        ],
    ],
    [
        2024611200000,
        [
            4135979088.37832,
            -3303759947.573346,
            -2241711786.803803,
        ],
    ],
    [
        2025216000000,
        [
            4144390568.533382,
            -3286224669.183744,
            -2235056771.478226,
        ],
    ],
    [
        2025820800000,
        [
            4150682830.167071,
            -3268166856.393862,
            -2228174177.592639,
        ],
    ],
    [
        2026425600000,
        [
            4154802787.14533,
            -3249819012.481565,
            -2221165817.451296,
        ],
    ],
    [
        2027030400000,
        [
            4156726645.100004,
            -3231433070.271779,
            -2214140305.428339,
        ],
    ],
    [
        2027635200000,
        [
            4156484914.021711,
            -3213261061.457561,
            -2207206145.339662,
        ],
    ],
    [
        2028240000000,
        [
            4154137732.315792,
            -3195529094.454529,
            -2200462798.406249,
        ],
    ],
    [
        2028844800000,
        [
            4149756980.127045,
            -3178455530.373597,
            -2194006193.328688,
        ],
    ],
    [
        2029449600000,
        [
            4143441472.36758,
            -3162264770.951929,
            -2187932738.286212,
        ],
    ],
    [
        2030054400000,
        [
            4135338080.069366,
            -3147165552.695938,
            -2182331789.713112,
        ],
    ],
    [
        2030659200000,
        [
            4125612064.006019,
            -3133329373.810719,
            -2177278453.515548,
        ],
    ],
    [
        2031264000000,
        [
            4114432139.476405,
            -3120912161.928732,
            -2172840633.573477,
        ],
    ],
    [
        2031868800000,
        [
            4101987299.678789,
            -3110066475.681378,
            -2169082984.915697,
        ],
    ],
    [
        2032473600000,
        [
            4088503769.095782,
            -3100918310.50186,
            -2166059237.375172,
        ],
    ],
    [
        2033078400000,
        [
            4074211908.339266,
            -3093551127.92462,
            -2163806905.544362,
        ],
    ],
    [
        2033683200000,
        [
            4059334532.161019,
            -3088030579.065976,
            -2162355326.85021,
        ],
    ],
    [
        2034288000000,
        [
            4044105808.877736,
            -3084414825.538461,
            -2161728926.811964,
        ],
    ],
    [
        2034892800000,
        [
            4028783902.820198,
            -3082729744.840761,
            -2161938874.530463,
        ],
    ],
    [
        2035497600000,
        [
            4013616367.579955,
            -3082958692.477901,
            -2162979462.810164,
        ],
    ],
    [
        2036102400000,
        [
            3998832396.562376,
            -3085068918.153552,
            -2164836756.442514,
        ],
    ],
    [
        2036707200000,
        [
            3984664184.161588,
            -3089019383.311881,
            -2167491334.16811,
        ],
    ],
    [
        2037312000000,
        [
            3971355014.379031,
            -3094734342.022057,
            -2170909779.226975,
        ],
    ],
    [
        2037916800000,
        [
            3959124398.396437,
            -3102099294.901681,
            -2175043372.937591,
        ],
    ],
    [
        2038521600000,
        [
            3948164121.064774,
            -3110988470.468693,
            -2179837416.017621,
        ],
    ],
    [
        2039126400000,
        [
            3938661331.129991,
            -3121270454.55999,
            -2185233517.565639,
        ],
    ],
    [
        2039731200000,
        [
            3930801364.65662,
            -3132780898.318234,
            -2191160823.268395,
        ],
    ],
    [
        2040336000000,
        [
            3924733528.476759,
            -3145325093.789626,
            -2197536681.425567,
        ],
    ],
    [
        2040940800000,
        [
            3920571155.434834,
            -3158705711.676263,
            -2204275856.281448,
        ],
    ],
    [
        2041545600000,
        [
            3918416252.383618,
            -3172726132.637789,
            -2211291968.162602,
        ],
    ],
    [
        2042150400000,
        [
            3918357574.670626,
            -3187162647.693089,
            -2218488511.12654,
        ],
    ],
    [
        2042755200000,
        [
            3920438642.214777,
            -3201773334.641251,
            -2225761698.082269,
        ],
    ],
    [
        2043360000000,
        [
            3924662623.291022,
            -3216325166.692582,
            -2233009795.590122,
        ],
    ],
    [
        2043964800000,
        [
            3931018437.270937,
            -3230595100.982163,
            -2240134248.409671,
        ],
    ],
    [
        2044569600000,
        [
            3939474689.190083,
            -3244342754.647303,
            -2247031151.106796,
        ],
    ],
    [
        2045174400000,
        [
            3949950826.870483,
            -3257325408.800683,
            -2253596338.591545,
        ],
    ],
    [
        2045779200000,
        [
            3962327191.884613,
            -3269323959.948512,
            -2259734466.015064,
        ],
    ],
    [
        2046384000000,
        [
            3976472235.262358,
            -3280141462.449644,
            -2265359204.671139,
        ],
    ],
    [
        2046988800000,
        [
            3992233308.596617,
            -3289576701.989114,
            -2270384635.36845,
        ],
    ],
    [
        2047593600000,
        [
            4009412121.887883,
            -3297443765.680473,
            -2274731556.270524,
        ],
    ],
    [
        2048198400000,
        [
            4027780712.314283,
            -3303595200.569016,
            -2278335516.904741,
        ],
    ],
    [
        2048803200000,
        [
            4047109833.115729,
            -3307916292.939202,
            -2281145550.813287,
        ],
    ],
    [
        2049408000000,
        [
            4067157625.297407,
            -3310299168.418478,
            -2283115617.537329,
        ],
    ],
    [
        2050012800000,
        [
            4087649817.707887,
            -3310664776.536674,
            -2284211824.962524,
        ],
    ],
    [
        2050617600000,
        [
            4108300869.290965,
            -3308981947.249202,
            -2284419346.599179,
        ],
    ],
    [
        2051222400000,
        [
            4128841948.395484,
            -3305256066.025855,
            -2283739353.554038,
        ],
    ],
    [
        2051827200000,
        [
            4149006567.262926,
            -3299503956.694149,
            -2282180385.209172,
        ],
    ],
    [
        2052432000000,
        [
            4168514417.425066,
            -3291776635.763942,
            -2279765455.795002,
        ],
    ],
    [
        2053036800000,
        [
            4187095454.262634,
            -3282173590.987364,
            -2276537014.824927,
        ],
    ],
    [
        2053641600000,
        [
            4204515279.34226,
            -3270824955.007347,
            -2272551192.659494,
        ],
    ],
    [
        2054246400000,
        [
            4220556460.517029,
            -3257867582.181044,
            -2267868926.160852,
        ],
    ],
    [
        2054851200000,
        [
            4235005237.411053,
            -3243467371.154526,
            -2262562581.60272,
        ],
    ],
    [
        2055456000000,
        [
            4247676448.630944,
            -3227828893.517009,
            -2256719332.962456,
        ],
    ],
    [
        2056060800000,
        [
            4258434489.051198,
            -3211171711.615707,
            -2250433484.806842,
        ],
    ],
    [
        2056665600000,
        [
            4267169096.669763,
            -3193709418.575591,
            -2243798592.770691,
        ],
    ],
    [
        2057270400000,
        [
            4273784255.229931,
            -3175672189.006923,
            -2236914367.625978,
        ],
    ],
    [
        2057875200000,
        [
            4278221987.389272,
            -3157313419.233801,
            -2229889198.898564,
        ],
    ],
    [
        2058480000000,
        [
            4280477578.548118,
            -3138882510.697162,
            -2222831175.522733,
        ],
    ],
    [
        2059084800000,
        [
            4280569630.257721,
            -3120609033.226272,
            -2215841598.808632,
        ],
    ],
    [
        2059689600000,
        [
            4278531667.703491,
            -3102726263.318031,
            -2209022098.757395,
        ],
    ],
    [
        2060294400000,
        [
            4274434684.454953,
            -3085475672.297918,
            -2202476294.769675,
        ],
    ],
    [
        2060899200000,
        [
            4268397228.555207,
            -3069077817.878198,
            -2196299994.417902,
        ],
    ],
    [
        2061504000000,
        [
            4260551492.8887,
            -3053722500.116868,
            -2190576683.278855,
        ],
    ],
    [
        2062108800000,
        [
            4251038999.778962,
            -3039593298.31013,
            -2185385440.369851,
        ],
    ],
    [
        2062713600000,
        [
            4240032518.090491,
            -3026870070.005709,
            -2180802403.466691,
        ],
    ],
    [
        2063318400000,
        [
            4227741520.565604,
            -3015699472.831356,
            -2176891110.089011,
        ],
    ],
    [
        2063923200000,
        [
            4214375875.006628,
            -3006191742.43661,
            -2173700398.361372,
        ],
    ],
    [
        2064528000000,
        [
            4200145899.041102,
            -2998446238.979242,
            -2171273036.455514,
        ],
    ],
    [
        2065132800000,
        [
            4185283764.931495,
            -2992551836.134606,
            -2169646550.03798,
        ],
    ],
    [
        2065737600000,
        [
            4170044447.61397,
            -2988557937.259078,
            -2168843427.869256,
        ],
    ],
    [
        2066342400000,
        [
            4154668854.425206,
            -2986477471.832629,
            -2168870806.215633,
        ],
    ],
    [
        2066947200000,
        [
            4139388564.965635,
            -2986312506.755681,
            -2169729210.385262,
        ],
    ],
    [
        2067552000000,
        [
            4124447252.480701,
            -2988051670.872369,
            -2171412478.847858,
        ],
    ],
    [
        2068156800000,
        [
            4110097379.714187,
            -2991641914.080377,
            -2173898240.23584,
        ],
    ],
    [
        2068761600000,
        [
            4096564545.186175,
            -2996997171.328241,
            -2177149749.451662,
        ],
    ],
    [
        2069366400000,
        [
            4084056495.400651,
            -3004023534.528711,
            -2181125046.311156,
        ],
    ],
    [
        2069971200000,
        [
            4072784238.906325,
            -3012613814.23349,
            -2185776294.627203,
        ],
    ],
    [
        2070576000000,
        [
            4062953846.067197,
            -3022621038.367169,
            -2191040852.227901,
        ],
    ],
    [
        2071180800000,
        [
            4054733052.412561,
            -3033872790.888978,
            -2196845042.11753,
        ],
    ],
    [
        2071785600000,
        [
            4048263795.322106,
            -3046195669.376493,
            -2203113100.797556,
        ],
    ],
    [
        2072390400000,
        [
            4043682906.122727,
            -3059407155.975523,
            -2209765427.859583,
        ],
    ],
    [
        2072995200000,
        [
            4041109171.370549,
            -3073291327.793613,
            -2216710008.643446,
        ],
    ],
    [
        2073600000000,
        [
            4040614016.643375,
            -3087618222.257849,
            -2223847924.50338,
        ],
    ],
    [
        2074204800000,
        [
            4042237752.311068,
            -3102166740.998707,
            -2231082033.102065,
        ],
    ],
    [
        2074809600000,
        [
            4046010306.849362,
            -3116714009.231372,
            -2238314624.337081,
        ],
    ],
    [
        2075414400000,
        [
            4051934160.175093,
            -3131013880.919346,
            -2245439899.183155,
        ],
    ],
    [
        2076019200000,
        [
            4059960489.819139,
            -3144821032.986959,
            -2252351615.557459,
        ],
    ],
    [
        2076624000000,
        [
            4070008953.182264,
            -3157911850.589673,
            -2258951476.677411,
        ],
    ],
    [
        2077228800000,
        [
            4081988390.58445,
            -3170071831.740988,
            -2265146136.343363,
        ],
    ],
    [
        2077833600000,
        [
            4095776355.94883,
            -3181077264.350094,
            -2270840351.127257,
        ],
    ],
    [
        2078438400000,
        [
            4111201849.905971,
            -3190723021.289573,
            -2275945865.165099,
        ],
    ],
    [
        2079043200000,
        [
            4128068949.992386,
            -3198839883.789676,
            -2280388455.929377,
        ],
    ],
    [
        2079648000000,
        [
            4146177810.798424,
            -3205279237.672137,
            -2284103701.467127,
        ],
    ],
    [
        2080252800000,
        [
            4165302317.512047,
            -3209896984.216334,
            -2287030479.103755,
        ],
    ],
    [
        2080857600000,
        [
            4185180125.765226,
            -3212582955.937841,
            -2289120681.111279,
        ],
    ],
    [
        2081462400000,
        [
            4205539923.25825,
            -3213272834.193457,
            -2290344700.851984,
        ],
    ],
    [
        2082067200000,
        [
            4226121702.512963,
            -3211929296.645545,
            -2290686023.564794,
        ],
    ],
    [
        2082672000000,
        [
            4246652707.262962,
            -3208527630.810796,
            -2290135074.518513,
        ],
    ],
    [
        2083276800000,
        [
            4266843314.637629,
            -3203085199.934554,
            -2288699069.059774,
        ],
    ],
    [
        2083881600000,
        [
            4286416020.046529,
            -3195667057.169437,
            -2286405168.214093,
        ],
    ],
    [
        2084486400000,
        [
            4305122552.994758,
            -3186363018.620286,
            -2283293069.893939,
        ],
    ],
    [
        2085091200000,
        [
            4322717586.667571,
            -3175274802.944599,
            -2279408651.811332,
        ],
    ],
    [
        2085696000000,
        [
            4338958630.69493,
            -3162544098.850466,
            -2274813084.593771,
        ],
    ],
    [
        2086300800000,
        [
            4353634944.75493,
            -3148351740.533208,
            -2269583547.305881,
        ],
    ],
    [
        2086905600000,
        [
            4366579414.788953,
            -3132890825.347781,
            -2263804114.323635,
        ],
    ],
    [
        2087510400000,
        [
            4377639594.23369,
            -3116356426.647907,
            -2257560211.805744,
        ],
    ],
    [
        2088115200000,
        [
            4386680024.74333,
            -3098972206.548974,
            -2250947614.057164,
        ],
    ],
    [
        2088720000000,
        [
            4393609258.818995,
            -3080985010.215998,
            -2244071804.023515,
        ],
    ],
    [
        2089324800000,
        [
            4398384734.404883,
            -3062635922.420674,
            -2237037965.2504,
        ],
    ],
    [
        2089929600000,
        [
            4400980871.720128,
            -3044154938.741559,
            -2229947057.015446,
        ],
    ],
    [
        2090534400000,
        [
            4401393242.598259,
            -3025786722.022208,
            -2222904617.548112,
        ],
    ],
    [
        2091139200000,
        [
            4399663086.340692,
            -3007782538.78896,
            -2216018966.749118,
        ],
    ],
    [
        2091744000000,
        [
            4395875423.564363,
            -2990370798.393402,
            -2209390475.417009,
        ],
    ],
    [
        2092348800000,
        [
            4390125692.428625,
            -2973757963.31232,
            -2203109691.330324,
        ],
    ],
    [
        2092953600000,
        [
            4382526951.188105,
            -2958153066.307998,
            -2197266115.230438,
        ],
    ],
    [
        2093558400000,
        [
            4373232453.61617,
            -2943757868.950158,
            -2191946012.647731,
        ],
    ],
    [
        2094163200000,
        [
            4362428178.931763,
            -2930738078.756263,
            -2187221947.510999,
        ],
    ],
    [
        2094768000000,
        [
            4350299528.866756,
            -2919231208.725877,
            -2183153753.523411,
        ],
    ],
    [
        2095372800000,
        [
            4337042119.572821,
            -2909369629.174835,
            -2179797471.877759,
        ],
    ],
    [
        2095977600000,
        [
            4322882242.885365,
            -2901269580.15547,
            -2177202881.043002,
        ],
    ],
    [
        2096582400000,
        [
            4308064536.371734,
            -2895004155.678176,
            -2175403296.271424,
        ],
    ],
    [
        2097187200000,
        [
            4292819968.305367,
            -2890617871.458506,
            -2174418798.380351,
        ],
    ],
    [
        2097792000000,
        [
            4277380530.95906,
            -2888147465.823317,
            -2174264521.291001,
        ],
    ],
    [
        2098396800000,
        [
            4261997731.701406,
            -2887609297.653265,
            -2174947391.183134,
        ],
    ],
    [
        2099001600000,
        [
            4246926546.740384,
            -2888974359.429943,
            -2176456318.515612,
        ],
    ],
    [
        2099606400000,
        [
            4232396165.26799,
            -2892188402.327847,
            -2178767639.364156,
        ],
    ],
    [
        2100211200000,
        [
            4218628551.401439,
            -2897189894.466298,
            -2181852995.57385,
        ],
    ],
    [
        2100816000000,
        [
            4205854691.851748,
            -2903895690.145255,
            -2185675701.411785,
        ],
    ],
    [
        2101420800000,
        [
            4194295111.065508,
            -2912179053.624323,
            -2190182049.228104,
        ],
    ],
    [
        2102025600000,
        [
            4184133943.219192,
            -2921894780.09246,
            -2195308884.305646,
        ],
    ],
    [
        2102630400000,
        [
            4175540443.007788,
            -2932894629.468758,
            -2200990853.389003,
        ],
    ],
    [
        2103235200000,
        [
            4168682509.701499,
            -2945011531.142193,
            -2207155944.538834,
        ],
    ],
    [
        2103840000000,
        [
            4163704111.485599,
            -2958041469.577119,
            -2213717692.505686,
        ],
    ],
    [
        2104444800000,
        [
            4160703886.11809,
            -2971772455.509355,
            -2220584195.846466,
        ],
    ],
    [
        2105049600000,
        [
            4159759504.326383,
            -2985997258.909467,
            -2227664495.666269,
        ],
    ],
    [
        2105654400000,
        [
            4160939062.651029,
            -3000496005.789688,
            -2234863402.060029,
        ],
    ],
    [
        2106259200000,
        [
            4164276360.201087,
            -3015022483.359457,
            -2242075259.130554,
        ],
    ],
    [
        2106864000000,
        [
            4169755467.096215,
            -3029335892.026245,
            -2249194681.04068,
        ],
    ],
    [
        2107468800000,
        [
            4177337628.065576,
            -3043211052.570694,
            -2256122500.657343,
        ],
    ],
    [
        2108073600000,
        [
            4186970848.851376,
            -3056419861.270577,
            -2262760177.711857,
        ],
    ],
    [
        2108678400000,
        [
            4198563532.306519,
            -3068722742.964062,
            -2269005211.84572,
        ],
    ],
    [
        2109283200000,
        [
            4211976076.801064,
            -3079902064.914254,
            -2274762829.621275,
        ],
    ],
    [
        2109888000000,
        [
            4227049998.889373,
            -3089769264.096272,
            -2279950670.015578,
        ],
    ],
    [
        2110492800000,
        [
            4243616516.703382,
            -3098144754.411089,
            -2284492075.632278,
        ],
    ],
    [
        2111097600000,
        [
            4261469746.436923,
            -3104853742.041488,
            -2288312568.425828,
        ],
    ],
    [
        2111702400000,
        [
            4280366584.334111,
            -3109759030.808234,
            -2291351706.273527,
        ],
    ],
    [
        2112307200000,
        [
            4300057769.247752,
            -3112763385.682819,
            -2293566128.905454,
        ],
    ],
    [
        2112912000000,
        [
            4320295750.873785,
            -3113787096.450911,
            -2294921888.519279,
        ],
    ],
    [
        2113516800000,
        [
            4340807786.163388,
            -3112767040.572316,
            -2295392036.740323,
        ],
    ],
    [
        2114121600000,
        [
            4361303356.167679,
            -3109687189.076284,
            -2294968244.03162,
        ],
    ],
    [
        2114726400000,
        [
            4381505132.801384,
            -3104575125.268465,
            -2293661644.756392,
        ],
    ],
    [
        2115331200000,
        [
            4401154509.9069,
            -3097477161.086136,
            -2291493780.087079,
        ],
    ],
    [
        2115936000000,
        [
            4419983843.935891,
            -3088459733.634577,
            -2288494477.182337,
        ],
    ],
    [
        2116540800000,
        [
            4437729392.984919,
            -3077636428.450579,
            -2284712194.077914,
        ],
    ],
    [
        2117145600000,
        [
            4454160056.273126,
            -3065157991.51233,
            -2280211963.342719,
        ],
    ],
    [
        2117750400000,
        [
            4469078786.877953,
            -3051185246.644819,
            -2275064951.618156,
        ],
    ],
    [
        2118355200000,
        [
            4482293694.317624,
            -3035892474.369531,
            -2269346924.068504,
        ],
    ],
    [
        2118960000000,
        [
            4493634458.587745,
            -3019490923.312237,
            -2263147789.853761,
        ],
    ],
    [
        2119564800000,
        [
            4502977122.11419,
            -3002213427.710408,
            -2256567595.703975,
        ],
    ],
    [
        2120169600000,
        [
            4510239485.374014,
            -2984287047.51278,
            -2249705835.906918,
        ],
    ],
    [
        2120774400000,
        [
            4515350938.685687,
            -2965939902.488073,
            -2242661413.006605,
        ],
    ],
    [
        2121379200000,
        [
            4518270532.421804,
            -2947422398.178708,
            -2235541701.543457,
        ],
    ],
    [
        2121984000000,
        [
            4519007060.251429,
            -2928988635.300963,
            -2228456999.213704,
        ],
    ],
    [
        2122588800000,
        [
            4517607855.715665,
            -2910870744.392819,
            -2221509806.9141,
        ],
    ],
    [
        2123193600000,
        [
            4514128829.245112,
            -2893290321.116349,
            -2214796467.181514,
        ],
    ],
    [
        2123798400000,
        [
            4508654258.75888,
            -2876477464.910551,
            -2208415644.434073,
        ],
    ],
    [
        2124403200000,
        [
            4501313205.523153,
            -2860650273.830105,
            -2202461880.158961,
        ],
    ],
    [
        2125008000000,
        [
            4492262739.589476,
            -2845991871.477147,
            -2197015648.766443,
        ],
    ],
    [
        2125612800000,
        [
            4481660251.73192,
            -2832667004.192691,
            -2192147550.559186,
        ],
    ],
    [
        2126217600000,
        [
            4469685145.741189,
            -2820838608.626198,
            -2187926578.243415,
        ],
    ],
    [
        2126822400000,
        [
            4456552110.692307,
            -2810646649.840119,
            -2184413503.571405,
        ],
    ],
    [
        2127427200000,
        [
            4442489459.283154,
            -2802188756.216273,
            -2181652006.113169,
        ],
    ],
    [
        2128032000000,
        [
            4427714933.568114,
            -2795542155.909732,
            -2179675191.828828,
        ],
    ],
    [
        2128636800000,
        [
            4412459079.338679,
            -2790777076.733261,
            -2178512773.655557,
        ],
    ],
    [
        2129241600000,
        [
            4396975719.012879,
            -2787935297.81106,
            -2178183891.537614,
        ],
    ],
    [
        2129846400000,
        [
            4381516659.890259,
            -2787014290.741934,
            -2178689001.376786,
        ],
    ],
    [
        2130451200000,
        [
            4366312361.87607,
            -2787993498.352334,
            -2180018378.789476,
        ],
    ],
    [
        2131056000000,
        [
            4351597022.010214,
            -2790843544.462213,
            -2182158021.589514,
        ],
    ],
    [
        2131660800000,
        [
            4337616403.431518,
            -2795504629.131446,
            -2185082418.437658,
        ],
    ],
    [
        2132265600000,
        [
            4324599905.108142,
            -2801874391.869153,
            -2188747893.474987,
        ],
    ],
    [
        2132870400000,
        [
            4312746421.691226,
            -2809837971.902962,
            -2193103293.865149,
        ],
    ],
    [
        2133475200000,
        [
            4302250275.839643,
            -2819273190.171759,
            -2198094644.529885,
        ],
    ],
    [
        2134080000000,
        [
            4293305731.08711,
            -2830029532.202885,
            -2203657843.498158,
        ],
    ],
    [
        2134684800000,
        [
            4286077105.732294,
            -2841920328.601192,
            -2209713310.407184,
        ],
    ],
    [
        2135289600000,
        [
            4280690062.103479,
            -2854755744.303498,
            -2216178042.956462,
        ],
    ],
    [
        2135894400000,
        [
            4277258190.238739,
            -2868344001.593411,
            -2222968548.842946,
        ],
    ],
    [
        2136499200000,
        [
            4275884469.460665,
            -2882471020.633406,
            -2229993294.798435,
        ],
    ],
    [
        2137104000000,
        [
            4276631021.261423,
            -2896897037.719581,
            -2237148975.831765,
        ],
    ],
    [
        2137708800000,
        [
            4279516627.684848,
            -2911391201.358938,
            -2244333934.204154,
        ],
    ],
    [
        2138313600000,
        [
            4284544149.925108,
            -2925729215.42365,
            -2251449992.259557,
        ],
    ],
    [
        2138918400000,
        [
            4291699235.495039,
            -2939673991.43948,
            -2258395201.303283,
        ],
    ],
    [
        2139523200000,
        [
            4300920817.217649,
            -2952977350.964049,
            -2265062238.336189,
        ],
    ],
    [
        2140128000000,
        [
            4312105116.410887,
            -2965415091.675257,
            -2271352654.769468,
        ],
    ],
    [
        2140732800000,
        [
            4325133773.425918,
            -2976781506.102948,
            -2277177312.781588,
        ],
    ],
    [
        2141337600000,
        [
            4339870330.734989,
            -2986870803.970959,
            -2282448755.689952,
        ],
    ],
    [
        2141942400000,
        [
            4356132812.543043,
            -2995483541.094664,
            -2287081118.822642,
        ],
    ],
    [
        2142547200000,
        [
            4373704967.474444,
            -3002459717.73091,
            -2291003948.193091,
        ],
    ],
    [
        2143152000000,
        [
            4392365340.688892,
            -3007669334.916397,
            -2294160868.164495,
        ],
    ],
    [
        2143756800000,
        [
            4411882435.118425,
            -3010993283.680769,
            -2296501382.383209,
        ],
    ],
    [
        2144361600000,
        [
            4431990173.282254,
            -3012333398.19132,
            -2297982401.579147,
        ],
    ],
    [
        2144966400000,
        [
            4452406044.342186,
            -3011641213.765609,
            -2298581125.503726,
        ],
    ],
    [
        2145571200000,
        [
            4472859601.64784,
            -3008903987.206046,
            -2298291917.829759,
        ],
    ],
    [
        2146176000000,
        [
            4493085559.938353,
            -3004124401.599098,
            -2297117302.207397,
        ],
    ],
    [
        2146780800000,
        [
            4512801113.318778,
            -2997333465.145666,
            -2295070535.117951,
        ],
    ],
    [
        2147385600000,
        [
            4531729113.357162,
            -2988613378.754754,
            -2292186339.588335,
        ],
    ],
    [
        2147990400000,
        [
            4549623449.907193,
            -2978078678.082481,
            -2288515182.463273,
        ],
    ],
    [
        2148595200000,
        [
            4566258974.70583,
            -2965854494.145688,
            -2284113035.406711,
        ],
    ],
    [
        2149200000000,
        [
            4581409718.944291,
            -2952091466.000079,
            -2279044677.308411,
        ],
    ],
    [
        2149804800000,
        [
            4594875308.250357,
            -2936982179.261703,
            -2273392253.766546,
        ],
    ],
    [
        2150409600000,
        [
            4606501073.240379,
            -2920738088.256703,
            -2267247606.74397,
        ],
    ],
    [
        2151014400000,
        [
            4616163679.035725,
            -2903567751.968936,
            -2260701983.687726,
        ],
    ],
    [
        2151619200000,
        [
            4623749431.466055,
            -2885694376.781939,
            -2253850905.942349,
        ],
    ],
    [
        2152224000000,
        [
            4629181954.369734,
            -2867367355.912956,
            -2246801298.20347,
        ],
    ],
    [
        2152828800000,
        [
            4632435490.29789,
            -2848837105.229039,
            -2239662527.029109,
        ],
    ],
    [
        2153433600000,
        [
            4633515609.671456,
            -2830335719.165696,
            -2232536653.681244,
        ],
    ],
    [
        2154038400000,
        [
            4632438146.227863,
            -2812097843.962265,
            -2225524772.020943,
        ],
    ],
    [
        2154643200000,
        [
            4629257584.501032,
            -2794368535.062953,
            -2218732705.473612,
        ],
    ],
    [
        2155248000000,
        [
            4624074291.835371,
            -2777377327.160412,
            -2212261082.069221,
        ],
    ],
    [
        2155852800000,
        [
            4617011387.894712,
            -2761322694.491454,
            -2206196823.783422,
        ],
    ],
    [
        2156457600000,
        [
            4608196356.685658,
            -2746396050.693489,
            -2200621377.644496,
        ],
    ],
    [
        2157062400000,
        [
            4597790228.488742,
            -2732786427.640767,
            -2195615659.841473,
        ],
    ],
    [
        2157667200000,
        [
            4585989943.616961,
            -2720654824.894886,
            -2191250121.639119,
        ],
    ],
    [
        2158272000000,
        [
            4573002141.667789,
            -2710123615.525963,
            -2187578244.485264,
        ],
    ],
    [
        2158876800000,
        [
            4559028792.139471,
            -2701303518.372354,
            -2184646625.976075,
        ],
    ],
    [
        2159481600000,
        [
            4544296459.748562,
            -2694295311.437496,
            -2182498797.67706,
        ],
    ],
    [
        2160086400000,
        [
            4529054661.742439,
            -2689165046.186239,
            -2181165037.52492,
        ],
    ],
    [
        2160691200000,
        [
            4513547402.276291,
            -2685938522.017988,
            -2180657438.299367,
        ],
    ],
    [
        2161296000000,
        [
            4498004236.204225,
            -2684630153.942792,
            -2180981112.547005,
        ],
    ],
    [
        2161900800000,
        [
            4482669249.266542,
            -2685240988.588915,
            -2182136391.834889,
        ],
    ],
    [
        2162505600000,
        [
            4467796484.156601,
            -2687734752.406055,
            -2184108699.5324,
        ],
    ],
    [
        2163110400000,
        [
            4453620201.367673,
            -2692037097.134459,
            -2186865641.419485,
        ],
    ],
    [
        2163715200000,
        [
            4440352110.291047,
            -2698065578.178699,
            -2190369585.287373,
        ],
    ],
    [
        2164320000000,
        [
            4428208998.377641,
            -2705724016.548771,
            -2194578484.454688,
        ],
    ],
    [
        2164924800000,
        [
            4417405234.877928,
            -2714880235.962615,
            -2199436287.517455,
        ],
    ],
    [
        2165529600000,
        [
            4408122114.476994,
            -2725370333.619331,
            -2204872032.33245,
        ],
    ],
    [
        2166134400000,
        [
            4400511228.883917,
            -2737029374.061035,
            -2210813196.113581,
        ],
    ],
    [
        2166739200000,
        [
            4394719916.895263,
            -2749682315.380054,
            -2217184550.513049,
        ],
    ],
    [
        2167344000000,
        [
            4390881256.11796,
            -2763123944.030489,
            -2223898880.489638,
        ],
    ],
    [
        2167948800000,
        [
            4389083881.824108,
            -2777127715.484931,
            -2230857837.661291,
        ],
    ],
    [
        2168553600000,
        [
            4389382069.476772,
            -2791476180.711709,
            -2237965819.128826,
        ],
    ],
    [
        2169158400000,
        [
            4391819201.261825,
            -2805948588.724332,
            -2245127240.222365,
        ],
    ],
    [
        2169763200000,
        [
            4396415926.327186,
            -2820303533.021393,
            -2252238307.905423,
        ],
    ],
    [
        2170368000000,
        [
            4403141901.861317,
            -2834292192.443255,
            -2259190135.927832,
        ],
    ],
    [
        2170972800000,
        [
            4411932444.049402,
            -2847687921.724418,
            -2265883120.351993,
        ],
    ],
    [
        2171577600000,
        [
            4422710055.571255,
            -2860271170.531666,
            -2272222757.637309,
        ],
    ],
    [
        2172182400000,
        [
            4435371085.681625,
            -2871815238.651574,
            -2278112243.6924,
        ],
    ],
    [
        2172787200000,
        [
            4449760849.775873,
            -2882103316.210758,
            -2283457135.748105,
        ],
    ],
    [
        2173392000000,
        [
            4465696741.608268,
            -2890955656.027915,
            -2288178973.176277,
        ],
    ],
    [
        2173996800000,
        [
            4482988642.565236,
            -2898211311.166755,
            -2292209121.990257,
        ],
    ],
    [
        2174601600000,
        [
            4501424969.754152,
            -2903715873.853438,
            -2295481752.793086,
        ],
    ],
    [
        2175206400000,
        [
            4520752745.801145,
            -2907340737.702861,
            -2297939785.566527,
        ],
    ],
    [
        2175811200000,
        [
            4540706569.532008,
            -2909005550.666621,
            -2299547163.09972,
        ],
    ],
    [
        2176416000000,
        [
            4561027804.823295,
            -2908656206.275303,
            -2300281010.206651,
        ],
    ],
    [
        2177020800000,
        [
            4581449524.218039,
            -2906253505.936911,
            -2300124921.075362,
        ],
    ],
    [
        2177625600000,
        [
            4601681133.404215,
            -2901793716.285556,
            -2299075923.205269,
        ],
    ],
    [
        2178230400000,
        [
            4621440825.802942,
            -2895324620.004235,
            -2297154249.600507,
        ],
    ],
    [
        2178835200000,
        [
            4640471772.966166,
            -2886919777.286352,
            -2294393305.112215,
        ],
    ],
    [
        2179440000000,
        [
            4658524657.513139,
            -2876667246.168874,
            -2290832418.448053,
        ],
    ],
    [
        2180044800000,
        [
            4675345803.359961,
            -2864690702.946494,
            -2286524205.400448,
        ],
    ],
    [
        2180649600000,
        [
            4690710856.515654,
            -2851157866.146448,
            -2281541067.931196,
        ],
    ],
    [
        2181254400000,
        [
            4704436142.351149,
            -2836251690.427732,
            -2275963406.677898,
        ],
    ],
    [
        2181859200000,
        [
            4716357895.204263,
            -2820159308.442635,
            -2269872463.154424,
        ],
    ],
    [
        2182464000000,
        [
            4726322782.054693,
            -2803094184.619153,
            -2263358920.233831,
        ],
    ],
    [
        2183068800000,
        [
            4734220701.498559,
            -2785297737.162066,
            -2256526838.375769,
        ],
    ],
    [
        2183673600000,
        [
            4739989408.962193,
            -2767009900.630356,
            -2249481276.83153,
        ],
    ],
    [
        2184278400000,
        [
            4743589900.624384,
            -2748460170.321213,
            -2242321972.787424,
        ],
    ],
    [
        2184883200000,
        [
            4744998713.353301,
            -2729891927.212243,
            -2235153309.369467,
        ],
    ],
    [
        2185488000000,
        [
            4744238928.415851,
            -2711558800.727674,
            -2228085740.568622,
        ],
    ],
    [
        2186092800000,
        [
            4741377963.003368,
            -2693696576.075219,
            -2221223160.144193,
        ],
    ],
    [
        2186697600000,
        [
            4736500444.773716,
            -2676517621.468439,
            -2214657785.771278,
        ],
    ],
    [
        2187302400000,
        [
            4729703427.942348,
            -2660237205.357262,
            -2208481512.485151,
        ],
    ],
    [
        2187907200000,
        [
            4721126143.288995,
            -2645065501.318424,
            -2202785525.89783,
        ],
    ],
    [
        2188512000000,
        [
            4710942121.936515,
            -2631181901.328497,
            -2197648433.236827,
        ],
    ],
    [
        2189116800000,
        [
            4699331085.616179,
            -2618733845.643963,
            -2193133364.229657,
        ],
    ],
    [
        2189721600000,
        [
            4686477892.170691,
            -2607864700.71826,
            -2189300800.545976,
        ],
    ],
    [
        2190326400000,
        [
            4672600819.187749,
            -2598702441.873348,
            -2186206740.787485,
        ],
    ],
    [
        2190931200000,
        [
            4657938812.714567,
            -2591337029.113571,
            -2183891617.144032,
        ],
    ],
    [
        2191536000000,
        [
            4642723347.93656,
            -2585824150.696058,
            -2182379387.748398,
        ],
    ],
    [
        2192140800000,
        [
            4627181804.763877,
            -2582213450.287138,
            -2181690737.293131,
        ],
    ],
    [
        2192745600000,
        [
            4611564118.712872,
            -2580534017.035577,
            -2181839380.490142,
        ],
    ],
    [
        2193350400000,
        [
            4596126490.142453,
            -2580774382.063869,
            -2182821592.844051,
        ],
    ],
    [
        2193955200000,
        [
            4581104382.986985,
            -2582890844.000166,
            -2184617487.529859,
        ],
    ],
    [
        2194560000000,
        [
            4566721033.184977,
            -2586834646.530185,
            -2187204435.852595,
        ],
    ],
    [
        2195164800000,
        [
            4553211780.973943,
            -2592534668.168027,
            -2190552087.455833,
        ],
    ],
    [
        2195769600000,
        [
            4540804895.050684,
            -2599880216.172698,
            -2194613093.934496,
        ],
    ],
    [
        2196374400000,
        [
            4529695910.156538,
            -2608734240.738074,
            -2199326911.697537,
        ],
    ],
    [
        2196979200000,
        [
            4520061056.270032,
            -2618958938.64954,
            -2204633001.349335,
        ],
    ],
    [
        2197584000000,
        [
            4512078049.312002,
            -2630396528.585845,
            -2210464356.463475,
        ],
    ],
    [
        2198188800000,
        [
            4505904681.012159,
            -2642855144.877679,
            -2216739079.977359,
        ],
    ],
    [
        2198793600000,
        [
            4501655193.342302,
            -2656126679.290029,
            -2223366214.729173,
        ],
    ],
    [
        2199398400000,
        [
            4499419108.897444,
            -2670009878.767941,
            -2230258094.852385,
        ],
    ],
    [
        2200003200000,
        [
            4499278327.772469,
            -2684289578.145246,
            -2237322565.381328,
        ],
    ],
    [
        2200608000000,
        [
            4501284872.434257,
            -2698725784.233188,
            -2244455920.702365,
        ],
    ],
    [
        2201212800000,
        [
            4505440421.23295,
            -2713075620.891848,
            -2251551138.745198,
        ],
    ],
    [
        2201817600000,
        [
            4511720763.257594,
            -2727113468.926067,
            -2258509639.783691,
        ],
    ],
    [
        2202422400000,
        [
            4520089009.959011,
            -2740609475.151749,
            -2265232769.242497,
        ],
    ],
    [
        2203027200000,
        [
            4530473363.102994,
            -2753322389.259638,
            -2271616337.753131,
        ],
    ],
    [
        2203632000000,
        [
            4542750619.097876,
            -2765024927.13492,
            -2277560627.735265,
        ],
    ],
    [
        2204236800000,
        [
            4556776117.969178,
            -2775520290.615288,
            -2282980664.037242,
        ],
    ],
    [
        2204841600000,
        [
            4572393574.160177,
            -2784619800.323035,
            -2287796386.716519,
        ],
    ],
    [
        2205446400000,
        [
            4589414136.381579,
            -2792138812.821689,
            -2291928243.717728,
        ],
    ],
    [
        2206051200000,
        [
            4607605239.218929,
            -2797923388.528809,
            -2295308049.331894,
        ],
    ],
    [
        2206656000000,
        [
            4626725827.485849,
            -2801861559.267716,
            -2297887237.330482,
        ],
    ],
    [
        2207260800000,
        [
            4646533426.240056,
            -2803859092.610936,
            -2299625860.869389,
        ],
    ],
    [
        2207865600000,
        [
            4666764710.846808,
            -2803837476.2861,
            -2300489408.540403,
        ],
    ],
    [
        2208470400000,
        [
            4687129697.956709,
            -2801760086.937365,
            -2300460134.515581,
        ],
    ],
    [
        2209075200000,
        [
            4707349949.794956,
            -2797637168.672151,
            -2299542744.838978,
        ],
    ],
    [
        2209680000000,
        [
            4727161913.82895,
            -2791499306.446276,
            -2297751880.183129,
        ],
    ],
    [
        2210284800000,
        [
            4746297542.897745,
            -2783396762.328227,
            -2295109428.480976,
        ],
    ],
    [
        2210889600000,
        [
            4764482804.692901,
            -2773423875.26994,
            -2291655289.187682,
        ],
    ],
    [
        2211494400000,
        [
            4781475901.521914,
            -2761716909.743605,
            -2287449501.11358,
        ],
    ],
    [
        2212099200000,
        [
            4797065844.205004,
            -2748425241.911443,
            -2282558134.267887,
        ],
    ],
    [
        2212704000000,
        [
            4811051811.481378,
            -2733711644.62757,
            -2277051151.955291,
        ],
    ],
    [
        2213308800000,
        [
            4823245126.554046,
            -2717774759.644751,
            -2271013050.639101,
        ],
    ],
    [
        2213913600000,
        [
            4833504721.464088,
            -2700840323.428824,
            -2264542032.960493,
        ],
    ],
    [
        2214518400000,
        [
            4841729797.716273,
            -2683132043.889995,
            -2257735683.867543,
        ],
    ],
    [
        2215123200000,
        [
            4847836730.613968,
            -2664874081.577902,
            -2250690180.172631,
        ],
    ],
    [
        2215728000000,
        [
            4851763644.47572,
            -2646313047.313705,
            -2243511361.752351,
        ],
    ],
    [
        2216332800000,
        [
            4853501178.11395,
            -2627704285.999431,
            -2236311176.537068,
        ],
    ],
    [
        2216937600000,
        [
            4853079066.815724,
            -2609285009.024461,
            -2229193759.57311,
        ],
    ],
    [
        2217542400000,
        [
            4850541155.322902,
            -2591279941.685818,
            -2222255940.940662,
        ],
    ],
    [
        2218147200000,
        [
            4845953240.492034,
            -2573923429.100988,
            -2215598702.166453,
        ],
    ],
    [
        2218752000000,
        [
            4839429376.84354,
            -2557441668.322408,
            -2209321260.978996,
        ],
    ],
    [
        2219356800000,
        [
            4831113788.561806,
            -2542029604.528396,
            -2203508623.754641,
        ],
    ],
    [
        2219961600000,
        [
            4821155739.142818,
            -2527860057.713001,
            -2198234082.761719,
        ],
    ],
    [
        2220566400000,
        [
            4809721328.093765,
            -2515105955.726829,
            -2193571508.705217,
        ],
    ],
    [
        2221171200000,
        [
            4797015597.351314,
            -2503919517.23794,
            -2189587820.59097,
        ],
    ],
    [
        2221776000000,
        [
            4783260662.472136,
            -2494414079.304347,
            -2186332640.396769,
        ],
    ],
    [
        2222380800000,
        [
            4768671585.728008,
            -2486676955.744679,
            -2183842649.324672,
        ],
    ],
    [
        2222985600000,
        [
            4753472064.719534,
            -2480791240.80415,
            -2182153836.926184,
        ],
    ],
    [
        2223590400000,
        [
            4737912572.609599,
            -2476812404.051078,
            -2181292003.608222,
        ],
    ],
    [
        2224195200000,
        [
            4722245845.651087,
            -2474754892.527331,
            -2181264152.932653,
        ],
    ],
    [
        2224800000000,
        [
            4706705239.464458,
            -2474608071.900205,
            -2182064396.040994,
        ],
    ],
    [
        2225404800000,
        [
            4691524426.582776,
            -2476356217.885009,
            -2183685628.688198,
        ],
    ],
    [
        2226009600000,
        [
            4676951863.976665,
            -2479952839.944451,
            -2186108662.232309,
        ],
    ],
    [
        2226614400000,
        [
            4663224474.946262,
            -2485311785.075901,
            -2189295868.353409,
        ],
    ],
    [
        2227219200000,
        [
            4650549160.064048,
            -2492326245.240814,
            -2193199137.532282,
        ],
    ],
    [
        2227824000000,
        [
            4639125669.55158,
            -2500886366.946482,
            -2197770772.381069,
        ],
    ],
    [
        2228428800000,
        [
            4629156773.228029,
            -2510852571.730755,
            -2202951621.318949,
        ],
    ],
    [
        2229033600000,
        [
            4620820450.465422,
            -2522051221.122211,
            -2208666639.536427,
        ],
    ],
    [
        2229638400000,
        [
            4614255019.68839,
            -2534296746.609539,
            -2214834434.788585,
        ],
    ],
    [
        2230243200000,
        [
            4609584820.520217,
            -2547406066.09266,
            -2221376448.947706,
        ],
    ],
    [
        2230848000000,
        [
            4606926241.89703,
            -2561171750.891029,
            -2228204226.28874,
        ],
    ],
    [
        2231452800000,
        [
            4606359737.070425,
            -2575361679.23981,
            -2235216781.380502,
        ],
    ],
    [
        2232057600000,
        [
            4607919685.469064,
            -2589743876.256003,
            -2242311961.050292,
        ],
    ],
    [
        2232662400000,
        [
            4611623038.860343,
            -2604097013.535193,
            -2249394058.232231,
        ],
    ],
    [
        2233267200000,
        [
            4617471440.693629,
            -2618184590.924418,
            -2256361264.91454,
        ],
    ],
    [
        2233872000000,
        [
            4625424151.087507,
            -2631758499.176228,
            -2263105145.191937,
        ],
    ],
    [
        2234476800000,
        [
            4635393101.796928,
            -2644586398.37932,
            -2269523702.365971,
        ],
    ],
    [
        2235081600000,
        [
            4647274324.795228,
            -2656457889.582181,
            -2275526838.739485,
        ],
    ],
    [
        2235686400000,
        [
            4660946436.845082,
            -2667160413.74843,
            -2281023854.170598,
        ],
    ],
    [
        2236291200000,
        [
            4676245883.007765,
            -2676485896.557351,
            -2285924182.567167,
        ],
    ],
    [
        2236896000000,
        [
            4692967962.617002,
            -2684259075.704172,
            -2290151058.892725,
        ],
    ],
    [
        2237500800000,
        [
            4710901375.933009,
            -2690337873.014476,
            -2293644055.557652,
        ],
    ],
    [
        2238105600000,
        [
            4729823851.838438,
            -2694590279.036683,
            -2296346676.417218,
        ],
    ],
    [
        2238710400000,
        [
            4749480914.493874,
            -2696902592.596655,
            -2298208281.997409,
        ],
    ],
    [
        2239315200000,
        [
            4769592722.013508,
            -2697206632.171225,
            -2299197913.63176,
        ],
    ],
    [
        2239920000000,
        [
            4789890534.66348,
            -2695473331.51202,
            -2299303797.023068,
        ],
    ],
    [
        2240524800000,
        [
            4810108737.668028,
            -2691690038.711836,
            -2298520998.830228,
        ],
    ],
    [
        2241129600000,
        [
            4829966369.770276,
            -2685869545.783317,
            -2296854074.823821,
        ],
    ],
    [
        2241734400000,
        [
            4849178064.333757,
            -2678074536.839481,
            -2294329798.67463,
        ],
    ],
    [
        2242339200000,
        [
            4867489862.621229,
            -2668404072.241251,
            -2290992833.582898,
        ],
    ],
    [
        2242944000000,
        [
            4884666515.334285,
            -2656970710.329412,
            -2286892835.129726,
        ],
    ],
    [
        2243548800000,
        [
            4900474634.153502,
            -2643909780.685887,
            -2282087465.629433,
        ],
    ],
    [
        2244153600000,
        [
            4914696349.408098,
            -2629399955.931906,
            -2276653645.289676,
        ],
    ],
    [
        2244758400000,
        [
            4927161857.111011,
            -2613643361.235916,
            -2270680031.952135,
        ],
    ],
    [
        2245363200000,
        [
            4937731200.415249,
            -2596843234.377627,
            -2264254507.93987,
        ],
    ],
    [
        2245968000000,
        [
            4946277663.401282,
            -2579214488.186241,
            -2257468523.328966,
        ],
    ],
    [
        2246572800000,
        [
            4952702907.13719,
            -2561001257.450723,
            -2250427467.161065,
        ],
    ],
    [
        2247177600000,
        [
            4956963707.020706,
            -2542453036.264251,
            -2243240869.311387,
        ],
    ],
    [
        2247782400000,
        [
            4959048081.399794,
            -2523804935.578619,
            -2236010872.818913,
        ],
    ],
    [
        2248387200000,
        [
            4958958431.334444,
            -2505290942.8929,
            -2228837962.510529,
        ],
    ],
    [
        2248992000000,
        [
            4956728421.08207,
            -2487159301.808022,
            -2221830275.622914,
        ],
    ],
    [
        2249596800000,
        [
            4952443344.738978,
            -2469646314.336422,
            -2215091916.877557,
        ],
    ],
    [
        2250201600000,
        [
            4946212425.865038,
            -2452960469.07193,
            -2208713070.836337,
        ],
    ],
    [
        2250806400000,
        [
            4938152837.208293,
            -2437298652.362188,
            -2202777489.13341,
        ],
    ],
    [
        2251411200000,
        [
            4928409483.033484,
            -2422859556.51569,
            -2197371268.767593,
        ],
    ],
    [
        2252016000000,
        [
            4917169192.078964,
            -2409816282.350276,
            -2192570320.116827,
        ],
    ],
    [
        2252620800000,
        [
            4904630862.455481,
            -2398305517.870641,
            -2188433123.642526,
        ],
    ],
    [
        2253225600000,
        [
            4890991058.890214,
            -2388446808.524844,
            -2185010030.558998,
        ],
    ],
    [
        2253830400000,
        [
            4876466834.57893,
            -2380354109.822062,
            -2182351204.366728,
        ],
    ],
    [
        2254435200000,
        [
            4861303753.67723,
            -2374107908.581433,
            -2180493097.719214,
        ],
    ],
    [
        2255040000000,
        [
            4845745276.400121,
            -2369749767.519326,
            -2179453575.928322,
        ],
    ],
    [
        2255644800000,
        [
            4830020914.886663,
            -2367303743.547422,
            -2179242180.833972,
        ],
    ],
    [
        2256249600000,
        [
            4814372216.422488,
            -2366785235.764226,
            -2179866600.021495,
        ],
    ],
    [
        2256854400000,
        [
            4799055247.887596,
            -2368172596.10817,
            -2181318371.497716,
        ],
    ],
    [
        2257459200000,
        [
            4784310562.693262,
            -2371406717.645852,
            -2183570784.305447,
        ],
    ],
    [
        2258064000000,
        [
            4770354699.556293,
            -2376413811.527031,
            -2186590306.276561,
        ],
    ],
    [
        2258668800000,
        [
            4757408463.666268,
            -2383111309.276482,
            -2190341804.809281,
        ],
    ],
    [
        2259273600000,
        [
            4745693833.168727,
            -2391379841.102567,
            -2194774123.671709,
        ],
    ],
    [
        2259878400000,
        [
            4735404772.447351,
            -2401068083.010318,
            -2199820786.728755,
        ],
    ],
    [
        2260483200000,
        [
            4726702281.919323,
            -2412016717.044167,
            -2205412114.110914,
        ],
    ],
    [
        2261088000000,
        [
            4719743801.143394,
            -2424061357.543498,
            -2211478531.236928,
        ],
    ],
    [
        2261692800000,
        [
            4714675070.348051,
            -2437005646.974439,
            -2217935925.262953,
        ],
    ],
    [
        2262297600000,
        [
            4711602651.885833,
            -2450630832.532313,
            -2224688661.847857,
        ],
    ],
    [
        2262902400000,
        [
            4710593648.710294,
            -2464720250.489024,
            -2231642148.103232,
        ],
    ],
    [
        2263507200000,
        [
            4711705879.685809,
            -2479058880.782423,
            -2238704337.988148,
        ],
    ],
    [
        2264112000000,
        [
            4714975887.882022,
            -2493408352.157511,
            -2245771850.361539,
        ],
    ],
    [
        2264716800000,
        [
            4720393998.025373,
            -2507520818.003044,
            -2252735603.761167,
        ],
    ],
    [
        2265321600000,
        [
            4727909431.501034,
            -2521163848.891503,
            -2259494074.189859,
        ],
    ],
    [
        2265926400000,
        [
            4737460573.581291,
            -2534116652.903105,
            -2265952970.001709,
        ],
    ],
    [
        2266531200000,
        [
            4748960007.456815,
            -2546148018.280697,
            -2272012411.533082,
        ],
    ],
    [
        2267136000000,
        [
            4762272799.093077,
            -2557033672.484009,
            -2277574270.96384,
        ],
    ],
    [
        2267740800000,
        [
            4777227753.899646,
            -2566580719.52789,
            -2282555158.455699,
        ],
    ],
    [
        2268345600000,
        [
            4793647788.026458,
            -2574619386.840514,
            -2286883325.812663,
        ],
    ],
    [
        2268950400000,
        [
            4811333432.189163,
            -2580983586.366475,
            -2290486862.009982,
        ],
    ],
    [
        2269555200000,
        [
            4830045497.197248,
            -2585529708.357085,
            -2293302041.340337,
        ],
    ],
    [
        2270160000000,
        [
            4849522799.680419,
            -2588158873.086232,
            -2295285684.232277,
        ],
    ],
    [
        2270764800000,
        [
            4869512093.456371,
            -2588802793.389961,
            -2296409166.536841,
        ],
    ],
    [
        2271369600000,
        [
            4889750113.50716,
            -2587406595.537159,
            -2296648072.589277,
        ],
    ],
    [
        2271974400000,
        [
            4909950216.320974,
            -2583947505.378043,
            -2295991031.474584,
        ],
    ],
    [
        2272579200000,
        [
            4929824744.267298,
            -2578453678.987217,
            -2294450646.215781,
        ],
    ],
    [
        2273184000000,
        [
            4949112442.61411,
            -2570983531.86584,
            -2292053851.995519,
        ],
    ],
    [
        2273788800000,
        [
            4967557867.602094,
            -2561610500.841846,
            -2288832455.682141,
        ],
    ],
    [
        2274393600000,
        [
            4984901014.557878,
            -2550440427.101539,
            -2284831491.496628,
        ],
    ],
    [
        2274998400000,
        [
            5000902101.80165,
            -2537625853.285824,
            -2280117916.486269,
        ],
    ],
    [
        2275603200000,
        [
            5015364536.062241,
            -2523339013.997503,
            -2274767504.351745,
        ],
    ],
    [
        2276208000000,
        [
            5028110707.304489,
            -2507758686.660793,
            -2268856785.659751,
        ],
    ],
    [
        2276812800000,
        [
            5038973632.650496,
            -2491086525.742708,
            -2262471584.591912,
        ],
    ],
    [
        2277417600000,
        [
            5047821981.55512,
            -2473557295.288931,
            -2255714108.225564,
        ],
    ],
    [
        2278022400000,
        [
            5054576599.072536,
            -2455407930.653854,
            -2248687763.0587,
        ],
    ],
    [
        2278627200000,
        [
            5059181900.687843,
            -2436868048.801423,
            -2241491159.17761,
        ],
    ],
    [
        2279232000000,
        [
            5061598763.521129,
            -2418176869.954809,
            -2234227177.119482,
        ],
    ],
    [
        2279836800000,
        [
            5061828786.884656,
            -2399590452.74405,
            -2227008311.193066,
        ],
    ],
    [
        2280441600000,
        [
            5059923824.496752,
            -2381349367.44029,
            -2219940100.626514,
        ],
    ],
    [
        2281046400000,
        [
            5055954181.33078,
            -2363673722.639808,
            -2213117225.298726,
        ],
    ],
    [
        2281651200000,
        [
            5050003627.590883,
            -2346781397.619421,
            -2206633327.0991,
        ],
    ],
    [
        2282256000000,
        [
            5042193769.354002,
            -2330892407.999735,
            -2200584851.60012,
        ],
    ],
    [
        2282860800000,
        [
            5032687234.328071,
            -2316196919.101706,
            -2195054487.664898,
        ],
    ],
    [
        2283465600000,
        [
            5021654604.13446,
            -2302855221.289271,
            -2190110105.319808,
        ],
    ],
    [
        2284070400000,
        [
            5009272156.295682,
            -2291017743.232242,
            -2185815858.00693,
        ],
    ],
    [
        2284675200000,
        [
            4995746733.791073,
            -2280826717.320991,
            -2182234607.994308,
        ],
    ],
    [
        2285280000000,
        [
            4981312645.417167,
            -2272385982.78789,
            -2179411912.578337,
        ],
    ],
    [
        2285884800000,
        [
            4966198869.282134,
            -2265766013.616247,
            -2177377436.087286,
        ],
    ],
    [
        2286489600000,
        [
            4950629811.264515,
            -2261025343.880132,
            -2176156540.868766,
        ],
    ],
    [
        2287094400000,
        [
            4934851024.664869,
            -2258208898.014859,
            -2175770495.808989,
        ],
    ],
    [
        2287699200000,
        [
            4919120389.72691,
            -2257319848.003651,
            -2176221045.90643,
        ],
    ],
    [
        2288304000000,
        [
            4903677472.627328,
            -2258328941.220698,
            -2177494184.030273,
        ],
    ],
    [
        2288908800000,
        [
            4888747696.329581,
            -2261196368.944931,
            -2179572161.018409,
        ],
    ],
    [
        2289513600000,
        [
            4874568765.016683,
            -2265866385.497022,
            -2182431800.279438,
        ],
    ],
    [
        2290118400000,
        [
            4861376279.933693,
            -2272241843.508909,
            -2186030482.216587,
        ],
    ],
    [
        2290723200000,
        [
            4849376074.471004,
            -2280197783.840913,
            -2190312531.889184,
        ],
    ],
    [
        2291328000000,
        [
            4838751309.629326,
            -2289603493.691219,
            -2195221394.519845,
        ],
    ],
    [
        2291932800000,
        [
            4829688567.181257,
            -2300313893.241499,
            -2200695859.254707,
        ],
    ],
    [
        2292537600000,
        [
            4822358130.981739,
            -2312147450.229043,
            -2206657298.679831,
        ],
    ],
    [
        2293142400000,
        [
            4816890143.624608,
            -2324903700.607036,
            -2213018006.609978,
        ],
    ],
    [
        2293747200000,
        [
            4813384951.290771,
            -2338384715.504611,
            -2219692840.04098,
        ],
    ],
    [
        2294352000000,
        [
            4811938627.197283,
            -2352383402.202358,
            -2226593449.468151,
        ],
    ],
    [
        2294956800000,
        [
            4812619292.060283,
            -2366664967.753035,
            -2233617243.191362,
        ],
    ],
    [
        2295561600000,
        [
            4815448147.905796,
            -2380987865.368493,
            -2240657924.757332,
        ],
    ],
    [
        2296166400000,
        [
            4820413638.236444,
            -2395124157.160674,
            -2247616839.356527,
        ],
    ],
    [
        2296771200000,
        [
            4827495884.373594,
            -2408845461.056162,
            -2254395946.091571,
        ],
    ],
    [
        2297376000000,
        [
            4836640228.608537,
            -2421908527.122591,
            -2260888897.412782,
        ],
    ],
    [
        2297980800000,
        [
            4847743470.736226,
            -2434079270.825389,
            -2266993288.763499,
        ],
    ],
    [
        2298585600000,
        [
            4860672332.535293,
            -2445151375.744857,
            -2272620850.646836,
        ],
    ],
    [
        2299190400000,
        [
            4875286507.183194,
            -2454929847.961448,
            -2277688656.9563,
        ],
    ],
    [
        2299795200000,
        [
            4891411302.419263,
            -2463220138.7153,
            -2282111784.460971,
        ],
    ],
    [
        2300400000000,
        [
            4908829788.729419,
            -2469853537.040185,
            -2285816303.561259,
        ],
    ],
    [
        2301004800000,
        [
            4927306458.922034,
            -2474702248.32522,
            -2288747673.552657,
        ],
    ],
    [
        2301609600000,
        [
            4946608610.830612,
            -2477659467.301621,
            -2290860197.876373,
        ],
    ],
    [
        2302214400000,
        [
            4966479413.801798,
            -2478631138.288162,
            -2292111571.674138,
        ],
    ],
    [
        2302819200000,
        [
            4986635362.166522,
            -2477560929.142855,
            -2292476204.737595,
        ],
    ],
    [
        2303424000000,
        [
            5006794145.403139,
            -2474440568.289056,
            -2291951426.345316,
        ],
    ],
    [
        2304028800000,
        [
            5026692350.189734,
            -2469285752.322471,
            -2290544758.874239,
        ],
    ],
    [
        2304633600000,
        [
            5046058561.702486,
            -2462130174.61697,
            -2288269906.572305,
        ],
    ],
    [
        2305238400000,
        [
            5064614372.591552,
            -2453048537.536325,
            -2285159118.370023,
        ],
    ],
    [
        2305843200000,
        [
            5082104427.847115,
            -2442161302.304011,
            -2281266311.074022,
        ],
    ],
    [
        2306448000000,
        [
            5098308368.961109,
            -2429605995.035264,
            -2276651730.578298,
        ],
    ],
    [
        2307052800000,
        [
            5113013440.938359,
            -2415533436.292839,
            -2271379481.517502,
        ],
    ],
    [
        2307657600000,
        [
            5126017659.075313,
            -2400128001.079449,
            -2265528882.162469,
        ],
    ],
    [
        2308262400000,
        [
            5137159794.395556,
            -2383607282.933829,
            -2259195248.759532,
        ],
    ],
    [
        2308867200000,
        [
            5146323768.52472,
            -2366190235.504275,
            -2252473142.908547,
        ],
    ],
    [
        2309472000000,
        [
            5153409904.541874,
            -2348097124.950349,
            -2245456420.620011,
        ],
    ],
    [
        2310076800000,
        [
            5158339037.858979,
            -2329568110.71348,
            -2238248972.85063,
        ],
    ],
    [
        2310681600000,
        [
            5161080469.55059,
            -2310859654.704222,
            -2230963662.677638,
        ],
    ],
    [
        2311286400000,
        [
            5161648229.70231,
            -2292211962.752496,
            -2223704830.819046,
        ],
    ],
    [
        2311891200000,
        [
            5160071311.050937,
            -2273853922.671067,
            -2216570828.855086,
        ],
    ],
    [
        2312496000000,
        [
            5156399292.193594,
            -2256020740.326307,
            -2209664007.299245,
        ],
    ],
    [
        2313100800000,
        [
            5150728273.820381,
            -2238947892.631948,
            -2203088059.148394,
        ],
    ],
    [
        2313705600000,
        [
            5143190394.767575,
            -2222839585.56729,
            -2196930944.623243,
        ],
    ],
    [
        2314310400000,
        [
            5133924596.363244,
            -2207878894.520122,
            -2191270414.586313,
        ],
    ],
    [
        2314915200000,
        [
            5123084814.914232,
            -2194244883.558955,
            -2186183907.474772,
        ],
    ],
    [
        2315520000000,
        [
            5110864045.025926,
            -2182104544.553876,
            -2181744862.710968,
        ],
    ],
    [
        2316124800000,
        [
            5097478118.721186,
            -2171584020.259789,
            -2178007159.110235,
        ],
    ],
    [
        2316729600000,
        [
            5083137978.796728,
            -2162783880.933896,
            -2175013348.09159,
        ],
    ],
    [
        2317334400000,
        [
            5068060744.205317,
            -2155795912.460453,
            -2172804040.565835,
        ],
    ],
    [
        2317939200000,
        [
            5052491870.913237,
            -2150692746.8715,
            -2171412452.877748,
        ],
    ],
    [
        2318544000000,
        [
            5036684290.317378,
            -2147502621.22721,
            -2170850394.569836,
        ],
    ],
    [
        2319148800000,
        [
            5020873618.741121,
            -2146228577.537457,
            -2171118413.660794,
        ],
    ],
    [
        2319753600000,
        [
            5005292555.593749,
            -2146864248.45389,
            -2172214457.985653,
        ],
    ],
    [
        2320358400000,
        [
            4990191292.980477,
            -2149380442.12289,
            -2174126696.373969,
        ],
    ],
    [
        2320963200000,
        [
            4975812897.406773,
            -2153704051.683437,
            -2176821984.775918,
        ],
    ],
    [
        2321568000000,
        [
            4962372338.480355,
            -2159740351.815979,
            -2180257999.280663,
        ],
    ],
    [
        2322172800000,
        [
            4950073621.065096,
            -2167387847.294399,
            -2184391454.425725,
        ],
    ],
    [
        2322777600000,
        [
            4939127660.690105,
            -2176522102.726254,
            -2189169283.756765,
        ],
    ],
    [
        2323382400000,
        [
            4929724108.60112,
            -2186979837.35222,
            -2194519764.118949,
        ],
    ],
    [
        2323987200000,
        [
            4922014759.406754,
            -2198583738.821682,
            -2200365769.328371,
        ],
    ],
    [
        2324592000000,
        [
            4916132960.744477,
            -2211156221.43756,
            -2206631947.223482,
        ],
    ],
    [
        2325196800000,
        [
            4912208896.008957,
            -2224500613.500337,
            -2213234027.247726,
        ],
    ],
    [
        2325801600000,
        [
            4910339032.206082,
            -2238390644.679993,
            -2220072716.994222,
        ],
    ],
    [
        2326406400000,
        [
            4910575179.918656,
            -2252596816.365326,
            -2227047838.989915,
        ],
    ],
    [
        2327011200000,
        [
            4912946304.950537,
            -2266898691.057718,
            -2234064790.180218,
        ],
    ],
    [
        2327616000000,
        [
            4917471430.97296,
            -2281064058.855499,
            -2241022893.896219,
        ],
    ],
    [
        2328220800000,
        [
            4924127775.991428,
            -2294844198.282114,
            -2247812648.143458,
        ],
    ],
    [
        2328825600000,
        [
            4932846055.882126,
            -2308001447.31585,
            -2254330572.261459,
        ],
    ],
    [
        2329430400000,
        [
            4943534480.776677,
            -2320319806.096041,
            -2260484578.748301,
        ],
    ],
    [
        2330035200000,
        [
            4956089393.285852,
            -2331582778.517184,
            -2266181345.337056,
        ],
    ],
    [
        2330640000000,
        [
            4970363455.813356,
            -2341573864.450424,
            -2271326143.672423,
        ],
    ],
    [
        2331244800000,
        [
            4986167956.230525,
            -2350104034.392898,
            -2275837304.383825,
        ],
    ],
    [
        2331849600000,
        [
            5003299503.864951,
            -2357019028.87663,
            -2279649565.216201,
        ],
    ],
    [
        2332454400000,
        [
            5021548981.89971,
            -2362175403.551698,
            -2282700566.021455,
        ],
    ],
    [
        2333059200000,
        [
            5040671382.431787,
            -2365444564.706008,
            -2284932968.769687,
        ],
    ],
    [
        2333664000000,
        [
            5060395002.213842,
            -2366738484.756001,
            -2286308301.913295,
        ],
    ],
    [
        2334268800000,
        [
            5080450303.083681,
            -2366012080.68124,
            -2286807993.191337,
        ],
    ],
    [
        2334873600000,
        [
            5100576018.753504,
            -2363237285.06727,
            -2286419247.968462,
        ],
    ],
    [
        2335478400000,
        [
            5120490621.466137,
            -2358409399.964271,
            -2285138834.843757,
        ],
    ],
    [
        2336083200000,
        [
            5139906336.001804,
            -2351569921.43538,
            -2282985389.39409,
        ],
    ],
    [
        2336688000000,
        [
            5158558351.510377,
            -2342802882.511636,
            -2279997078.750707,
        ],
    ],
    [
        2337292800000,
        [
            5176205998.167522,
            -2332206805.840188,
            -2276216373.554904,
        ],
    ],
    [
        2337897600000,
        [
            5192605621.952887,
            -2319902388.596413,
            -2271694742.682508,
        ],
    ],
    [
        2338502400000,
        [
            5207527251.369433,
            -2306051573.582684,
            -2266503037.992798,
        ],
    ],
    [
        2339107200000,
        [
            5220782440.70963,
            -2290847743.101426,
            -2260726089.606567,
        ],
    ],
    [
        2339712000000,
        [
            5232218567.227883,
            -2274486445.749767,
            -2254447356.114481,
        ],
    ],
    [
        2340316800000,
        [
            5241692768.777186,
            -2257175123.172103,
            -2247755285.614959,
        ],
    ],
    [
        2340921600000,
        [
            5249089079.955276,
            -2239149266.001939,
            -2240752452.050298,
        ],
    ],
    [
        2341526400000,
        [
            5254343087.140485,
            -2220658422.219546,
            -2233548038.933235,
        ],
    ],
    [
        2342131200000,
        [
            5257427997.605853,
            -2201937973.641841,
            -2226243163.247836,
        ],
    ],
    [
        2342736000000,
        [
            5258329820.835798,
            -2183222450.097659,
            -2218938978.051022,
        ],
    ],
    [
        2343340800000,
        [
            5257064318.956374,
            -2164759663.555166,
            -2211744328.694575,
        ],
    ],
    [
        2343945600000,
        [
            5253698294.118684,
            -2146794184.509735,
            -2204766529.984597,
        ],
    ],
    [
        2344550400000,
        [
            5248328444.375434,
            -2129541633.831464,
            -2198097978.086276,
        ],
    ],
    [
        2345155200000,
        [
            5241059400.901109,
            -2113206055.578368,
            -2191826313.934937,
        ],
    ],
    [
        2345760000000,
        [
            5232021342.454546,
            -2097992144.968247,
            -2186041022.096394,
        ],
    ],
    [
        2346364800000,
        [
            5221388349.718147,
            -2084087296.299161,
            -2180823608.209086,
        ],
    ],
    [
        2346969600000,
        [
            5209351569.823442,
            -2071639704.720629,
            -2176236609.138779,
        ],
    ],
    [
        2347574400000,
        [
            5196101003.218056,
            -2060780018.287232,
            -2172336004.59409,
        ],
    ],
    [
        2348179200000,
        [
            5181844063.869151,
            -2051631825.175124,
            -2169176617.729341,
        ],
    ],
    [
        2348784000000,
        [
            5166820798.644583,
            -2044292919.512385,
            -2166801600.064591,
        ],
    ],
    [
        2349388800000,
        [
            5151272896.124652,
            -2038817891.11783,
            -2165233679.729007,
        ],
    ],
    [
        2349993600000,
        [
            5135429952.344256,
            -2035243163.223341,
            -2164488868.546138,
        ],
    ],
    [
        2350598400000,
        [
            5119529537.17174,
            -2033595072.986363,
            -2164580103.035652,
        ],
    ],
    [
        2351203200000,
        [
            5103829401.015243,
            -2033869956.417916,
            -2165505971.281255,
        ],
    ],
    [
        2351808000000,
        [
            5088574171.899188,
            -2036021307.65301,
            -2167244656.099672,
        ],
    ],
    [
        2352412800000,
        [
            5073986537.055651,
            -2039987047.803575,
            -2169768891.486659,
        ],
    ],
    [
        2353017600000,
        [
            5060288744.330371,
            -2045695111.722356,
            -2173048332.962471,
        ],
    ],
    [
        2353622400000,
        [
            5047711084.442896,
            -2053042621.486205,
            -2177037996.024476,
        ],
    ],
    [
        2354227200000,
        [
            5036457166.547144,
            -2061888463.084565,
            -2181675263.638945,
        ],
    ],
    [
        2354832000000,
        [
            5026699656.393873,
            -2072082189.560132,
            -2186895425.211421,
        ],
    ],
    [
        2355436800000,
        [
            5018602720.123198,
            -2083467489.085226,
            -2192632469.434291,
        ],
    ],
    [
        2356041600000,
        [
            5012326345.383386,
            -2095860638.970592,
            -2198806849.735785,
        ],
    ],
    [
        2356646400000,
        [
            5007991608.191619,
            -2109048801.087264,
            -2205325304.834229,
        ],
    ],
    [
        2357251200000,
        [
            5005681510.464679,
            -2122819335.476832,
            -2212096264.691035,
        ],
    ],
    [
        2357856000000,
        [
            5005464675.253751,
            -2136961140.075709,
            -2219029384.821529,
        ],
    ],
    [
        2358460800000,
        [
            5007395890.865012,
            -2151242511.446965,
            -2226023267.64683,
        ],
    ],
    [
        2359065600000,
        [
            5011482855.381507,
            -2165415478.046359,
            -2232968760.073222,
        ],
    ],
    [
        2359670400000,
        [
            5017692498.14495,
            -2179244752.388313,
            -2239764164.652078,
        ],
    ],
    [
        2360275200000,
        [
            5025975719.973495,
            -2192507429.13416,
            -2246313924.324251,
        ],
    ],
    [
        2360880000000,
        [
            5036264384.795555,
            -2204970859.313138,
            -2252516472.808969,
        ],
    ],
    [
        2361484800000,
        [
            5048440650.690711,
            -2216403030.628195,
            -2258270537.693301,
        ],
    ],
    [
        2362089600000,
        [
            5062349249.94147,
            -2226599898.357962,
            -2263488930.376746,
        ],
    ],
    [
        2362694400000,
        [
            5077823425.089933,
            -2235382784.881242,
            -2268095679.5285,
        ],
    ],
    [
        2363299200000,
        [
            5094679505.180896,
            -2242575769.920743,
            -2272013704.998086,
        ],
    ],
    [
        2363904000000,
        [
            5112690302.549739,
            -2248020561.14583,
            -2275173540.129618,
        ],
    ],
    [
        2364508800000,
        [
            5131603826.812182,
            -2251600169.694045,
            -2277525142.47954,
        ],
    ],
    [
        2365113600000,
        [
            5151170048.184068,
            -2253232637.971882,
            -2279033441.332078,
        ],
    ],
    [
        2365718400000,
        [
            5171133318.727763,
            -2252847547.821232,
            -2279666249.409374,
        ],
    ],
    [
        2366323200000,
        [
            5191209671.95744,
            -2250403819.772443,
            -2279404933.258782,
        ],
    ],
    [
        2366928000000,
        [
            5211110455.266344,
            -2245908526.910888,
            -2278253641.853949,
        ],
    ],
    [
        2367532800000,
        [
            5230567861.655969,
            -2239405931.38674,
            -2276232481.754894,
        ],
    ],
    [
        2368137600000,
        [
            5249324071.101117,
            -2230953147.372716,
            -2273365215.845398,
        ],
    ],
    [
        2368742400000,
        [
            5267111462.802387,
            -2220639244.87634,
            -2269690560.219728,
        ],
    ],
    [
        2369347200000,
        [
            5283679073.718149,
            -2208598449.533594,
            -2265268211.543661,
        ],
    ],
    [
        2369952000000,
        [
            5298814954.564396,
            -2194993764.707336,
            -2260169351.207178,
        ],
    ],
    [
        2370556800000,
        [
            5312330812.618973,
            -2179992462.062983,
            -2254464780.068256,
        ],
    ],
    [
        2371161600000,
        [
            5324044375.691585,
            -2163785890.700963,
            -2248236934.374183,
        ],
    ],
    [
        2371766400000,
        [
            5333806394.038051,
            -2146598005.185629,
            -2241583723.636203,
        ],
    ],
    [
        2372371200000,
        [
            5341517959.18273,
            -2128664834.928946,
            -2234607336.55553,
        ],
    ],
    [
        2372976000000,
        [
            5347109194.750923,
            -2110212199.159979,
            -2227404006.461285,
        ],
    ],
    [
        2373580800000,
        [
            5350523393.639313,
            -2091477177.499476,
            -2220076724.434446,
        ],
    ],
    [
        2374185600000,
        [
            5351742936.004115,
            -2072713748.599179,
            -2212737239.48012,
        ],
    ],
    [
        2374790400000,
        [
            5350801155.198279,
            -2054169854.751942,
            -2205493443.136709,
        ],
    ],
    [
        2375395200000,
        [
            5347755368.677009,
            -2036069224.907958,
            -2198441231.745875,
        ],
    ],
    [
        2376000000000,
        [
            5342674295.90833,
            -2018634762.199456,
            -2191677694.209109,
        ],
    ],
    [
        2376604800000,
        [
            5335663085.660604,
            -2002091938.809843,
            -2185301750.237975,
        ],
    ],
    [
        2377209600000,
        [
            5326870811.731356,
            -1986644604.704648,
            -2179401134.739079,
        ],
    ],
    [
        2377814400000,
        [
            5316459211.609164,
            -1972462089.895756,
            -2174047467.424321,
        ],
    ],
    [
        2378419200000,
        [
            5304594801.816433,
            -1959704572.504286,
            -2169310281.371891,
        ],
    ],
    [
        2379024000000,
        [
            5291472913.831328,
            -1948524669.359224,
            -2165256707.181366,
        ],
    ],
    [
        2379628800000,
        [
            5277321274.297034,
            -1939043194.372916,
            -2161938552.484936,
        ],
    ],
    [
        2380233600000,
        [
            5262365609.821792,
            -1931342220.150011,
            -2159390492.019993,
        ],
    ],
    [
        2380838400000,
        [
            5246827171.322293,
            -1925491906.149233,
            -2157644091.051834,
        ],
    ],
    [
        2381443200000,
        [
            5230945799.142024,
            -1921549820.181926,
            -2156725843.147985,
        ],
    ],
    [
        2382048000000,
        [
            5214980239.188686,
            -1919536836.675856,
            -2156644212.394906,
        ],
    ],
    [
        2382652800000,
        [
            5199172459.26643,
            -1919435665.834238,
            -2157390728.068527,
        ],
    ],
    [
        2383257600000,
        [
            5183751131.984021,
            -1921218010.725127,
            -2158953815.219494,
        ],
    ],
    [
        2383862400000,
        [
            5168953770.281507,
            -1924841113.156429,
            -2161315529.307083,
        ],
    ],
    [
        2384467200000,
        [
            5155023783.485312,
            -1930224275.684141,
            -2164439362.723106,
        ],
    ],
    [
        2385072000000,
        [
            5142174678.06021,
            -1937252891.73857,
            -2168274500.242987,
        ],
    ],
    [
        2385676800000,
        [
            5130598789.355221,
            -1945805650.767409,
            -2172769354.20996,
        ],
    ],
    [
        2386281600000,
        [
            5120487885.951234,
            -1955748654.427491,
            -2177866918.211329,
        ],
    ],
    [
        2386886400000,
        [
            5112026473.650756,
            -1966913317.575976,
            -2183493245.148593,
        ],
    ],
    [
        2387491200000,
        [
            5105357215.857785,
            -1979105767.9547,
            -2189564123.773245,
        ],
    ],
    [
        2388096000000,
        [
            5100594609.746036,
            -1992133403.754006,
            -2195997614.932139,
        ],
    ],
    [
        2388700800000,
        [
            5097844479.118805,
            -2005796528.199693,
            -2202707966.60447,
        ],
    ],
    [
        2389305600000,
        [
            5097193912.850487,
            -2019867825.103046,
            -2209595165.464014,
        ],
    ],
    [
        2389910400000,
        [
            5098679861.11631,
            -2034106757.417825,
            -2216554196.783022,
        ],
    ],
    [
        2390515200000,
        [
            5102307642.937264,
            -2048284853.50074,
            -2223486833.378492,
        ],
    ],
    [
        2391120000000,
        [
            5108069711.461708,
            -2062175375.966222,
            -2230294848.701995,
        ],
    ],
    [
        2391724800000,
        [
            5115932306.948111,
            -2075535023.858854,
            -2236871186.607883,
        ],
    ],
    [
        2392329600000,
        [
            5125808613.278571,
            -2088123314.382162,
            -2243111523.878147,
        ],
    ],
    [
        2392934400000,
        [
            5137581705.734453,
            -2099725836.913448,
            -2248924506.033999,
        ],
    ],
    [
        2393539200000,
        [
            5151123056.694126,
            -2110142056.451349,
            -2254223826.764431,
        ],
    ],
    [
        2394144000000,
        [
            5166276647.305345,
            -2119168865.399115,
            -2258920443.958754,
        ],
    ],
    [
        2394748800000,
        [
            5182838456.408764,
            -2126623637.063031,
            -2262935555.630492,
        ],
    ],
    [
        2395353600000,
        [
            5200584001.673364,
            -2132363344.048945,
            -2266208418.604136,
        ],
    ],
    [
        2395958400000,
        [
            5219287119.475313,
            -2136269608.1104,
            -2268687353.659701,
        ],
    ],
    [
        2396563200000,
        [
            5238702264.801461,
            -2138233089.722323,
            -2270323137.811728,
        ],
    ],
    [
        2397168000000,
        [
            5258550784.544514,
            -2138178683.867223,
            -2271083173.728834,
        ],
    ],
    [
        2397772800000,
        [
            5278551730.81001,
            -2136078794.953702,
            -2270956450.37526,
        ],
    ],
    [
        2398377600000,
        [
            5298439462.632638,
            -2131935192.246804,
            -2269943325.708492,
        ],
    ],
    [
        2398982400000,
        [
            5317943487.862009,
            -2125763719.34194,
            -2268049516.383554,
        ],
    ],
    [
        2399587200000,
        [
            5336780201.235322,
            -2117620280.436295,
            -2265300290.328136,
        ],
    ],
    [
        2400192000000,
        [
            5354684802.457973,
            -2107607078.574261,
            -2261741567.166605,
        ],
    ],
    [
        2400796800000,
        [
            5371425652.681635,
            -2095850828.638838,
            -2257428004.814402,
        ],
    ],
    [
        2401401600000,
        [
            5386781137.560752,
            -2082487572.202031,
            -2252417372.612211,
        ],
    ],
    [
        2402006400000,
        [
            5400535417.270996,
            -2067688451.855507,
            -2246784521.525456,
        ],
    ],
    [
        2402611200000,
        [
            5412509490.810001,
            -2051659180.458394,
            -2240619315.073871,
        ],
    ],
    [
        2403216000000,
        [
            5422570190.015921,
            -2034615548.097655,
            -2234014056.946749,
        ],
    ],
    [
        2403820800000,
        [
            5430603343.446364,
            -2016770079.692382,
            -2227059340.537329,
        ],
    ],
    [
        2404425600000,
        [
            5436511953.420304,
            -1998358226.952639,
            -2219858064.701774,
        ],
    ],
    [
        2405030400000,
        [
            5440244682.549255,
            -1979633200.323261,
            -2212521012.124705,
        ],
    ],
    [
        2405635200000,
        [
            5441798194.428816,
            -1960840644.55338,
            -2205154047.200038,
        ],
    ],
    [
        2406240000000,
        [
            5441186917.439309,
            -1942209308.781516,
            -2197855813.471602,
        ],
    ],
    [
        2406844800000,
        [
            5438443847.719215,
            -1923977830.2162,
            -2190731268.27577,
        ],
    ],
    [
        2407449600000,
        [
            5433646605.987852,
            -1906386428.3277,
            -2183885466.738825,
        ],
    ],
    [
        2408054400000,
        [
            5426913984.270242,
            -1889651734.109537,
            -2177411144.266424,
        ],
    ],
    [
        2408659200000,
        [
            5418373980.474443,
            -1873962790.048178,
            -2171389253.373548,
        ],
    ],
    [
        2409264000000,
        [
            5408168397.904124,
            -1859507978.632063,
            -2165902241.39663,
        ],
    ],
    [
        2409868800000,
        [
            5396476736.527452,
            -1846464755.479085,
            -2161027120.254408,
        ],
    ],
    [
        2410473600000,
        [
            5383507789.429155,
            -1834975630.528076,
            -2156824147.079839,
        ],
    ],
    [
        2411078400000,
        [
            5369467051.005252,
            -1825150566.212993,
            -2153340582.110313,
        ],
    ],
    [
        2411683200000,
        [
            5354565622.603539,
            -1817093419.488826,
            -2150622998.856484,
        ],
    ],
    [
        2412288000000,
        [
            5339041737.877369,
            -1810890205.250292,
            -2148709394.869827,
        ],
    ],
    [
        2412892800000,
        [
            5323148416.233032,
            -1806586450.523033,
            -2147618555.352986,
        ],
    ],
    [
        2413497600000,
        [
            5307121695.613063,
            -1804195708.633302,
            -2147356543.696764,
        ],
    ],
    [
        2414102400000,
        [
            5291194523.334124,
            -1803724083.714939,
            -2147927406.223504,
        ],
    ],
    [
        2414707200000,
        [
            5275615948.242649,
            -1805156733.000739,
            -2149324595.519446,
        ],
    ],
    [
        2415312000000,
        [
            5260635821.676147,
            -1808436682.986471,
            -2151521557.782534,
        ],
    ],
    [
        2415916800000,
        [
            5246474885.435463,
            -1813479110.56506,
            -2154481244.416381,
        ],
    ],
    [
        2416521600000,
        [
            5233343255.714019,
            -1820193438.121711,
            -2158165383.007761,
        ],
    ],
    [
        2417126400000,
        [
            5221456443.813151,
            -1828468559.063732,
            -2162525593.340991,
        ],
    ],
    [
        2417731200000,
        [
            5211017210.02527,
            -1838153986.897577,
            -2167495317.854565,
        ],
    ],
    [
        2418336000000,
        [
            5202188100.916089,
            -1849079632.693172,
            -2173001610.918988,
        ],
    ],
    [
        2418940800000,
        [
            5195113974.34045,
            -1861075196.905383,
            -2178972361.594632,
        ],
    ],
    [
        2419545600000,
        [
            5189934737.129905,
            -1873954219.023561,
            -2185326820.92496,
        ],
    ],
    [
        2420150400000,
        [
            5186765197.979008,
            -1887497918.183316,
            -2191968908.094395,
        ],
    ],
    [
        2420755200000,
        [
            5185671562.985844,
            -1901479457.271441,
            -2198800852.86426,
        ],
    ],
    [
        2421360000000,
        [
            5186697996.451623,
            -1915680310.417032,
            -2205728743.207963,
        ],
    ],
    [
        2421964800000,
        [
            5189876542.485409,
            -1929873355.763457,
            -2212653180.484529,
        ],
    ],
    [
        2422569600000,
        [
            5195205616.256073,
            -1943810178.217315,
            -2219464799.251189,
        ],
    ],
    [
        2423174400000,
        [
            5202631591.555166,
            -1957249193.982747,
            -2226059530.533731,
        ],
    ],
    [
        2423779200000,
        [
            5212078801.32942,
            -1969969151.027459,
            -2232342489.857964,
        ],
    ],
    [
        2424384000000,
        [
            5223457095.241161,
            -1981751542.438074,
            -2238218518.999588,
        ],
    ],
    [
        2424988800000,
        [
            5236639584.094325,
            -1992371627.543938,
            -2243589528.116175,
        ],
    ],
    [
        2425593600000,
        [
            5251450830.681198,
            -2001628831.950695,
            -2248370067.537851,
        ],
    ],
    [
        2426198400000,
        [
            5267700146.410233,
            -2009356253.227439,
            -2252488866.571647,
        ],
    ],
    [
        2426803200000,
        [
            5285188009.255083,
            -2015401434.102403,
            -2255878904.685679,
        ],
    ],
    [
        2427408000000,
        [
            5303683947.581947,
            -2019620141.994738,
            -2258476524.477805,
        ],
    ],
    [
        2428012800000,
        [
            5322922451.228114,
            -2021906897.145628,
            -2260236823.460659,
        ],
    ],
    [
        2428617600000,
        [
            5342638366.245619,
            -2022199070.646621,
            -2261132849.099221,
        ],
    ],
    [
        2429222400000,
        [
            5362571992.14979,
            -2020455393.763602,
            -2261145247.546131,
        ],
    ],
    [
        2429827200000,
        [
            5382446376.039016,
            -2016651787.445817,
            -2260262828.866391,
        ],
    ],
    [
        2430432000000,
        [
            5401970079.588998,
            -2010810530.240527,
            -2258496776.552693,
        ],
    ],
    [
        2431036800000,
        [
            5420872006.226583,
            -2002997843.864015,
            -2255876642.805727,
        ],
    ],
    [
        2431641600000,
        [
            5438903867.634184,
            -1993299827.574062,
            -2252438893.049111,
        ],
    ],
    [
        2432246400000,
        [
            5455815909.395202,
            -1981819520.013992,
            -2248228097.401846,
        ],
    ],
    [
        2432851200000,
        [
            5471365223.335568,
            -1968703567.314096,
            -2243309328.418308,
        ],
    ],
    [
        2433456000000,
        [
            5485347618.570447,
            -1954132832.475897,
            -2237761123.588853,
        ],
    ],
    [
        2434060800000,
        [
            5497595967.871842,
            -1938296501.017581,
            -2231663752.743899,
        ],
    ],
    [
        2434665600000,
        [
            5507953600.74437,
            -1921390885.878341,
            -2225101674.666217,
        ],
    ],
    [
        2435270400000,
        [
            5516286339.511865,
            -1903644242.3537,
            -2218174805.363219,
        ],
    ],
    [
        2435875200000,
        [
            5522509265.045872,
            -1885302051.662627,
            -2210989432.391937,
        ],
    ],
    [
        2436480000000,
        [
            5526579399.10115,
            -1866601633.082841,
            -2203647110.496302,
        ],
    ],
    [
        2437084800000,
        [
            5528466763.929937,
            -1847774322.541308,
            -2196248520.749889,
        ],
    ],
    [
        2437689600000,
        [
            5528169163.152463,
            -1829069366.536622,
            -2188903442.475052,
        ],
    ],
    [
        2438294400000,
        [
            5525733663.111522,
            -1810735593.37764,
            -2181719969.025367,
        ],
    ],
    [
        2438899200000,
        [
            5521243969.120133,
            -1792998053.44554,
            -2174794520.823971,
        ],
    ],
    [
        2439504000000,
        [
            5514791090.257138,
            -1776064410.726614,
            -2168217469.165183,
        ],
    ],
    [
        2440108800000,
        [
            5506491266.396379,
            -1760147791.820018,
            -2162082141.886434,
        ],
    ],
    [
        2440713600000,
        [
            5496503168.533091,
            -1745446156.138551,
            -2156473501.106294,
        ],
    ],
    [
        2441318400000,
        [
            5485010812.22613,
            -1732122021.48484,
            -2151460258.343299,
        ],
    ],
    [
        2441923200000,
        [
            5472195485.767861,
            -1720313906.202106,
            -2147102837.063503,
        ],
    ],
    [
        2442528000000,
        [
            5458256600.073868,
            -1710157801.391087,
            -2143461274.755093,
        ],
    ],
    [
        2443132800000,
        [
            5443425041.278895,
            -1701765413.69197,
            -2140583567.221416,
        ],
    ],
    [
        2443737600000,
        [
            5427942298.264857,
            -1695207350.771024,
            -2138499508.740318,
        ],
    ],
    [
        2444342400000,
        [
            5412035152.060233,
            -1690529571.841504,
            -2137230367.914068,
        ],
    ],
    [
        2444947200000,
        [
            5395939450.325578,
            -1687772099.866916,
            -2136794825.477376,
        ],
    ],
    [
        2445552000000,
        [
            5379910319.492092,
            -1686946310.410638,
            -2137197053.952087,
        ],
    ],
    [
        2446156800000,
        [
            5364198659.474195,
            -1688021124.641028,
            -2138422314.49371,
        ],
    ],
    [
        2446761600000,
        [
            5349029921.991588,
            -1690943993.738384,
            -2140448547.37416,
        ],
    ],
    [
        2447366400000,
        [
            5334630366.338202,
            -1695655836.731971,
            -2143250557.370224,
        ],
    ],
    [
        2447971200000,
        [
            5321233907.416741,
            -1702068144.933254,
            -2146788616.878599,
        ],
    ],
    [
        2448576000000,
        [
            5309056314.504065,
            -1710052521.438969,
            -2151006001.683915,
        ],
    ],
    [
        2449180800000,
        [
            5298278369.447421,
            -1719466222.495377,
            -2155842193.064273,
        ],
    ],
    [
        2449785600000,
        [
            5289073653.329097,
            -1730163003.665194,
            -2161234815.642733,
        ],
    ],
    [
        2450390400000,
        [
            5281611722.357725,
            -1741970784.58652,
            -2167108614.757011,
        ],
    ],
    [
        2450995200000,
        [
            5276030939.571468,
            -1754684573.963876,
            -2173374423.609147,
        ],
    ],
    [
        2451600000000,
        [
            5272426940.905887,
            -1768095773.215061,
            -2179943353.327343,
        ],
    ],
    [
        2452204800000,
        [
            5270881953.967737,
            -1781998434.483187,
            -2186726508.422233,
        ],
    ],
    [
        2452809600000,
        [
            5271464760.407567,
            -1796167877.579375,
            -2193625003.805728,
        ],
    ],
    [
        2453414400000,
        [
            5274203499.23063,
            -1810357181.230266,
            -2200530927.292012,
        ],
    ],
    [
        2454019200000,
        [
            5279080113.015052,
            -1824329528.654337,
            -2207342604.454767,
        ],
    ],
    [
        2454624000000,
        [
            5286060914.19501,
            -1837860218.508389,
            -2213962565.971379,
        ],
    ],
    [
        2455228800000,
        [
            5295093513.064261,
            -1850716913.47003,
            -2220288859.32006,
        ],
    ],
    [
        2455833600000,
        [
            5306080620.042727,
            -1862660065.897396,
            -2226217743.092896,
        ],
    ],
    [
        2456438400000,
        [
            5318880983.918629,
            -1873476941.758617,
            -2231658850.091016,
        ],
    ],
    [
        2457043200000,
        [
            5333341322.221715,
            -1882979111.614349,
            -2236530848.516282,
        ],
    ],
    [
        2457648000000,
        [
            5349291224.37079,
            -1890983606.761706,
            -2240753427.473155,
        ],
    ],
    [
        2458252800000,
        [
            5366519476.266733,
            -1897316410.891178,
            -2244251308.53007,
        ],
    ],
    [
        2458857600000,
        [
            5384782220.074008,
            -1901845542.519878,
            -2246968493.980142,
        ],
    ],
    [
        2459462400000,
        [
            5403836068.746564,
            -1904473177.092363,
            -2248861849.539328,
        ],
    ],
    [
        2460067200000,
        [
            5423431379.432812,
            -1905116573.387323,
            -2249893759.54899,
        ],
    ],
    [
        2460672000000,
        [
            5443291064.637438,
            -1903713935.114155,
            -2250037452.669727,
        ],
    ],
    [
        2461276800000,
        [
            5463124987.313107,
            -1900254425.608408,
            -2249289499.020458,
        ],
    ],
    [
        2461881600000,
        [
            5482662095.989986,
            -1894764575.098688,
            -2247661017.265849,
        ],
    ],
    [
        2462486400000,
        [
            5501641110.840969,
            -1887288160.352736,
            -2245170078.250653,
        ],
    ],
    [
        2463091200000,
        [
            5519790595.457361,
            -1877893803.269154,
            -2241847450.932364,
        ],
    ],
    [
        2463696000000,
        [
            5536848102.213783,
            -1866700130.516703,
            -2237746175.198024,
        ],
    ],
    [
        2464300800000,
        [
            5552588803.94702,
            -1853856255.540965,
            -2232930331.123901,
        ],
    ],
    [
        2464905600000,
        [
            5566812743.578312,
            -1839520404.527624,
            -2227467212.849181,
        ],
    ],
    [
        2465510400000,
        [
            5579324992.836894,
            -1823869287.045045,
            -2221433880.138704,
        ],
    ],
    [
        2466115200000,
        [
            5589957977.550356,
            -1807118305.050556,
            -2214924315.221504,
        ],
    ],
    [
        2466720000000,
        [
            5598593948.007038,
            -1789497634.029113,
            -2208037026.558239,
        ],
    ],
    [
        2467324800000,
        [
            5605147754.036791,
            -1771231489.764861,
            -2200867950.37643,
        ],
    ],
    [
        2467929600000,
        [
            5609546111.077065,
            -1752550665.235462,
            -2193518190.717534,
        ],
    ],
    [
        2468534400000,
        [
            5611751839.292833,
            -1733709087.522833,
            -2186098925.647329,
        ],
    ],
    [
        2469139200000,
        [
            5611778903.133593,
            -1714957571.922081,
            -2178718301.77424,
        ],
    ],
    [
        2469744000000,
        [
            5609671140.143177,
            -1696525655.152068,
            -2171475378.330395,
        ],
    ],
    [
        2470348800000,
        [
            5605481699.278893,
            -1678637811.403224,
            -2164468937.212101,
        ],
    ],
    [
        2470953600000,
        [
            5599299509.962708,
            -1661526877.175061,
            -2157800472.354382,
        ],
    ],
    [
        2471558400000,
        [
            5591257714.642406,
            -1645406731.439817,
            -2151561313.126503,
        ],
    ],
    [
        2472163200000,
        [
            5581509741.197229,
            -1630457986.125687,
            -2145828677.719113,
        ],
    ],
    [
        2472768000000,
        [
            5570210513.264612,
            -1616847970.915422,
            -2140676053.751387,
        ],
    ],
    [
        2473372800000,
        [
            5557544975.461338,
            -1604741465.402734,
            -2136174875.304669,
        ],
    ],
    [
        2473977600000,
        [
            5543730638.590584,
            -1594273522.52493,
            -2132382390.129539,
        ],
    ],
    [
        2474582400000,
        [
            5528991726.822172,
            -1585539947.580226,
            -2129339880.943227,
        ],
    ],
    [
        2475187200000,
        [
            5513543404.847268,
            -1578620680.709307,
            -2127083895.822701,
        ],
    ],
    [
        2475792000000,
        [
            5497621863.703301,
            -1573587425.411307,
            -2125646045.704118,
        ],
    ],
    [
        2476396800000,
        [
            5481482146.708403,
            -1570476805.294137,
            -2125041267.912753,
        ],
    ],
    [
        2477001600000,
        [
            5465371450.912182,
            -1569285313.34706,
            -2125267943.971849,
        ],
    ],
    [
        2477606400000,
        [
            5449517899.333439,
            -1569995021.930579,
            -2126319696.424639,
        ],
    ],
    [
        2478211200000,
        [
            5434161583.705826,
            -1572577330.36924,
            -2128183638.794943,
        ],
    ],
    [
        2478816000000,
        [
            5419548491.867195,
            -1576966839.322795,
            -2130829689.468446,
        ],
    ],
    [
        2479420800000,
        [
            5405903291.560196,
            -1583060833.830827,
            -2134212975.072571,
        ],
    ],
    [
        2480025600000,
        [
            5393423121.975384,
            -1590747103.971839,
            -2138286173.172888,
        ],
    ],
    [
        2480630400000,
        [
            5382308078.787266,
            -1599903834.293233,
            -2142996233.642799,
        ],
    ],
    [
        2481235200000,
        [
            5372751434.313774,
            -1610375128.715112,
            -2148274660.492888,
        ],
    ],
    [
        2481840000000,
        [
            5364912211.034307,
            -1621975002.448964,
            -2154041573.786883,
        ],
    ],
    [
        2482444800000,
        [
            5358914717.204432,
            -1634516767.834343,
            -2160217832.754984,
        ],
    ],
    [
        2483049600000,
        [
            5354877847.039881,
            -1647808682.442322,
            -2166720000.637737,
        ],
    ],
    [
        2483654400000,
        [
            5352902624.179304,
            -1661631598.572309,
            -2173451886.169331,
        ],
    ],
    [
        2484259200000,
        [
            5353045748.187963,
            -1675746997.468632,
            -2180310395.273757,
        ],
    ],
    [
        2484864000000,
        [
            5355325745.356195,
            -1689927333.355763,
            -2187197682.340188,
        ],
    ],
    [
        2485468800000,
        [
            5359750671.308425,
            -1703947602.633616,
            -2194015032.126667,
        ],
    ],
    [
        2486073600000,
        [
            5366303632.251995,
            -1717566129.557699,
            -2200656352.143482,
        ],
    ],
    [
        2486678400000,
        [
            5374918167.674431,
            -1730536556.379551,
            -2207015680.45136,
        ],
    ],
    [
        2487283200000,
        [
            5385491189.547963,
            -1742638557.22904,
            -2212998779.553095,
        ],
    ],
    [
        2487888000000,
        [
            5397908958.57112,
            -1753665372.249089,
            -2218515485.090467,
        ],
    ],
    [
        2488492800000,
        [
            5412031555.453794,
            -1763407798.935141,
            -2223474612.039125,
        ],
    ],
    [
        2489097600000,
        [
            5427671665.742901,
            -1771668882.267488,
            -2227792186.829818,
        ],
    ],
    [
        2489702400000,
        [
            5444614709.678782,
            -1778292973.576125,
            -2231401657.346581,
        ],
    ],
    [
        2490307200000,
        [
            5462643644.519533,
            -1783148319.816911,
            -2234244621.983154,
        ],
    ],
    [
        2490912000000,
        [
            5481523216.215149,
            -1786113289.434232,
            -2236267169.66247,
        ],
    ],
    [
        2491516800000,
        [
            5500982988.417345,
            -1787092337.395283,
            -2237428689.974539,
        ],
    ],
    [
        2492121600000,
        [
            5520743441.512265,
            -1786041405.849952,
            -2237710362.854597,
        ],
    ],
    [
        2492726400000,
        [
            5540538610.437486,
            -1782945248.752912,
            -2237104229.096178,
        ],
    ],
    [
        2493331200000,
        [
            5560099164.032845,
            -1777805069.35931,
            -2235610308.76877,
        ],
    ],
    [
        2493936000000,
        [
            5579138890.712868,
            -1770654892.257726,
            -2233245048.046633,
        ],
    ],
    [
        2494540800000,
        [
            5597384362.609929,
            -1761581451.128291,
            -2230046894.647857,
        ],
    ],
    [
        2495145600000,
        [
            5614593712.417723,
            -1750696208.850315,
            -2226063277.153257,
        ],
    ],
    [
        2495750400000,
        [
            5630537421.775178,
            -1738123497.181847,
            -2221347864.091565,
        ],
    ],
    [
        2496355200000,
        [
            5644987345.104993,
            -1724016955.728968,
            -2215968567.376126,
        ],
    ],
    [
        2496960000000,
        [
            5657747749.145386,
            -1708572971.991501,
            -2210010348.483453,
        ],
    ],
    [
        2497564800000,
        [
            5668668261.241181,
            -1691998882.801394,
            -2203561352.57433,
        ],
    ],
    [
        2498169600000,
        [
            5677621214.828915,
            -1674502387.052062,
            -2196711041.375904,
        ],
    ],
    [
        2498774400000,
        [
            5684491957.978618,
            -1656309501.213758,
            -2189558549.620074,
        ],
    ],
    [
        2499379200000,
        [
            5689209323.726182,
            -1637672508.639581,
            -2182213116.17161,
        ],
    ],
    [
        2499984000000,
        [
            5691751121.854285,
            -1618837176.530578,
            -2174780262.126015,
        ],
    ],
    [
        2500588800000,
        [
            5692118059.275762,
            -1600034938.820211,
            -2167360840.621891,
        ],
    ],
    [
        2501193600000,
        [
            5690325449.479588,
            -1581503498.058223,
            -2160059708.696769,
        ],
    ],
    [
        2501798400000,
        [
            5686433106.461462,
            -1563489910.894931,
            -2152983823.624337,
        ],
    ],
    [
        2502403200000,
        [
            5680543815.660198,
            -1546218716.915189,
            -2146229309.528272,
        ],
    ],
    [
        2503008000000,
        [
            5672775622.220219,
            -1529887673.21042,
            -2139882034.876064,
        ],
    ],
    [
        2503612800000,
        [
            5663256099.160051,
            -1514691140.955342,
            -2134027203.134436,
        ],
    ],
    [
        2504217600000,
        [
            5652152081.484824,
            -1500818845.701969,
            -2128745946.278683,
        ],
    ],
    [
        2504822400000,
        [
            5639661795.452291,
            -1488426492.073592,
            -2124104258.014732,
        ],
    ],
    [
        2505427200000,
        [
            5625986819.994688,
            -1477635914.606863,
            -2120155450.235062,
        ],
    ],
    [
        2506032000000,
        [
            5611329425.74233,
            -1468560982.177307,
            -2116950333.534194,
        ],
    ],
    [
        2506636800000,
        [
            5595921940.742866,
            -1461302358.384341,
            -2114532047.2165,
        ],
    ],
    [
        2507241600000,
        [
            5580013425.040401,
            -1455921115.302663,
            -2112926455.687541,
        ],
    ],
    [
        2507846400000,
        [
            5563842688.87785,
            -1452443151.376918,
            -2112145935.675012,
        ],
    ],
    [
        2508451200000,
        [
            5547639604.44113,
            -1450886189.02648,
            -2112199472.346339,
        ],
    ],
    [
        2509056000000,
        [
            5531654024.584947,
            -1451250223.119901,
            -2113085917.336143,
        ],
    ],
    [
        2509660800000,
        [
            5516138191.007715,
            -1453494018.517679,
            -2114786163.027529,
        ],
    ],
    [
        2510265600000,
        [
            5501321683.011453,
            -1457543674.473526,
            -2117268682.309182,
        ],
    ],
    [
        2510870400000,
        [
            5487416924.339133,
            -1463319838.865548,
            -2120499644.331303,
        ],
    ],
    [
        2511475200000,
        [
            5474646455.059041,
            -1470724470.17851,
            -2124435193.209439,
        ],
    ],
    [
        2512080000000,
        [
            5463221483.459504,
            -1479620757.068212,
            -2129015394.450622,
        ],
    ],
    [
        2512684800000,
        [
            5453318847.628431,
            -1489846104.457121,
            -2134171170.830736,
        ],
    ],
    [
        2513289600000,
        [
            5445090831.182627,
            -1501238872.889993,
            -2139833603.611205,
        ],
    ],
    [
        2513894400000,
        [
            5438689869.060533,
            -1513621928.209423,
            -2145925077.130919,
        ],
    ],
    [
        2514499200000,
        [
            5434244500.234797,
            -1526785987.053428,
            -2152354662.444641,
        ],
    ],
    [
        2515104000000,
        [
            5431839205.262231,
            -1540506596.781821,
            -2159026305.414119,
        ],
    ],
    [
        2515708800000,
        [
            5431529419.131233,
            -1554569439.763912,
            -2165847279.882708,
        ],
    ],
    [
        2516313600000,
        [
            5433363252.251307,
            -1568751209.182732,
            -2172719047.535386,
        ],
    ],
    [
        2516918400000,
        [
            5437356207.784903,
            -1582806770.157882,
            -2179534681.781249,
        ],
    ],
    [
        2517523200000,
        [
            5443474379.028866,
            -1596490031.499033,
            -2186188572.242007,
        ],
    ],
    [
        2518128000000,
        [
            5451654977.404875,
            -1609577426.202388,
            -2192583894.964931,
        ],
    ],
    [
        2518732800000,
        [
            5461824480.192433,
            -1621846855.855797,
            -2198623223.414664,
        ],
    ],
    [
        2519337600000,
        [
            5473873429.788897,
            -1633068882.495428,
            -2204207478.75294,
        ],
    ],
    [
        2519942400000,
        [
            5487643755.196815,
            -1643030421.562305,
            -2209246179.186533,
        ],
    ],
    [
        2520547200000,
        [
            5502955459.409405,
            -1651554970.949084,
            -2213663014.531629,
        ],
    ],
    [
        2521152000000,
        [
            5519621565.467671,
            -1658478997.376594,
            -2217385861.145224,
        ],
    ],
    [
        2521756800000,
        [
            5537424678.06828,
            -1663646236.833764,
            -2220346998.07559,
        ],
    ],
    [
        2522361600000,
        [
            5556109200.742286,
            -1666932173.179503,
            -2222493542.12195,
        ],
    ],
    [
        2522966400000,
        [
            5575413778.788863,
            -1668259355.919977,
            -2223791070.229279,
        ],
    ],
    [
        2523571200000,
        [
            5595082522.149278,
            -1667570602.324739,
            -2224213150.04511,
        ],
    ],
    [
        2524176000000,
        [
            5614843176.192199,
            -1664825775.734365,
            -2223742565.274091,
        ],
    ],
];
export const plutoSunSvs = [
    [
        631152000000,
        [
            -2987889058.121497,
            -3277203784.613476,
            -122453201.369005,
        ],
    ],
    [
        631756800000,
        [
            -2985363026.691783,
            -3279465996.320589,
            -123923032.127533,
        ],
    ],
    [
        632361600000,
        [
            -2982835805.25019,
            -3281726854.358368,
            -125392407.533665,
        ],
    ],
    [
        632966400000,
        [
            -2980307154.516192,
            -3283986094.261433,
            -126861051.5493469,
        ],
    ],
    [
        633571200000,
        [
            -2977776749.037891,
            -3286243405.878999,
            -128328933.3317228,
        ],
    ],
    [
        634176000000,
        [
            -2975244290.487912,
            -3288498542.057545,
            -129796278.4570054,
        ],
    ],
    [
        634780800000,
        [
            -2972709612.454251,
            -3290751404.677063,
            -131263488.4831379,
        ],
    ],
    [
        635385600000,
        [
            -2970172738.683215,
            -3293002077.526146,
            -132730998.0358868,
        ],
    ],
    [
        635990400000,
        [
            -2967633874.263133,
            -3295250795.004168,
            -134199121.1664808,
        ],
    ],
    [
        636595200000,
        [
            -2965093333.718703,
            -3297497858.427058,
            -135667940.4216421,
        ],
    ],
    [
        637200000000,
        [
            -2962551430.775812,
            -3299743528.750264,
            -137137276.7116979,
        ],
    ],
    [
        637804800000,
        [
            -2960008368.051208,
            -3301987933.205496,
            -138606751.6215941,
        ],
    ],
    [
        638409600000,
        [
            -2957464166.036085,
            -3304231019.569924,
            -140075920.7172775,
        ],
    ],
    [
        639014400000,
        [
            -2954918656.16787,
            -3306472574.070024,
            -141544429.7995095,
        ],
    ],
    [
        639619200000,
        [
            -2952371539.819581,
            -3308712294.802203,
            -143012138.4553718,
        ],
    ],
    [
        640224000000,
        [
            -2949822494.636804,
            -3310949895.752722,
            -144479168.7670874,
        ],
    ],
    [
        640828800000,
        [
            -2947271290.538761,
            -3313185207.757705,
            -145945862.435485,
        ],
    ],
    [
        641433600000,
        [
            -2944717871.537114,
            -3315418238.293953,
            -147412659.6742281,
        ],
    ],
    [
        642038400000,
        [
            -2942162375.275245,
            -3317649167.318164,
            -148879943.0832039,
        ],
    ],
    [
        642643200000,
        [
            -2939605085.108463,
            -3319878282.548405,
            -150347902.8325008,
        ],
    ],
    [
        643248000000,
        [
            -2937046331.870335,
            -3322105877.710524,
            -151816469.3674423,
        ],
    ],
    [
        643852800000,
        [
            -2934486378.639113,
            -3324332148.528111,
            -153285337.0249041,
        ],
    ],
    [
        644457600000,
        [
            -2931925328.961504,
            -3326557123.166163,
            -154754071.4714827,
        ],
    ],
    [
        645062400000,
        [
            -2929363091.588133,
            -3328780652.297313,
            -156222262.8923899,
        ],
    ],
    [
        645667200000,
        [
            -2926799413.862616,
            -3331002462.047441,
            -157689670.1800698,
        ],
    ],
    [
        646272000000,
        [
            -2924233971.06528,
            -3333222250.711678,
            -159156305.9877883,
        ],
    ],
    [
        646876800000,
        [
            -2921666480.51772,
            -3335439795.300664,
            -160622432.9681159,
        ],
    ],
    [
        647481600000,
        [
            -2919096801.77945,
            -3337655029.633882,
            -162088470.6142082,
        ],
    ],
    [
        648086400000,
        [
            -2916524987.880693,
            -3339868067.296198,
            -163554846.2021839,
        ],
    ],
    [
        648691200000,
        [
            -2913951266.593441,
            -3342079162.127919,
            -165021844.6646748,
        ],
    ],
    [
        649296000000,
        [
            -2911375959.345846,
            -3344288619.104294,
            -166489509.1767881,
        ],
    ],
    [
        649900800000,
        [
            -2908799368.067266,
            -3346496686.830034,
            -167957625.5719087,
        ],
    ],
    [
        650505600000,
        [
            -2906221668.713288,
            -3348703469.25744,
            -169425796.9598016,
        ],
    ],
    [
        651110400000,
        [
            -2903642849.085291,
            -3350908888.407039,
            -170893583.5020275,
        ],
    ],
    [
        651715200000,
        [
            -2901062713.380926,
            -3353112711.637087,
            -172360657.3359426,
        ],
    ],
    [
        652320000000,
        [
            -2898480951.289537,
            -3355314633.200555,
            -173826917.5522079,
        ],
    ],
    [
        652924800000,
        [
            -2895897247.124645,
            -3357514381.396403,
            -175292525.8131097,
        ],
    ],
    [
        653529600000,
        [
            -2893311391.367435,
            -3359711814.49584,
            -176757849.7889217,
        ],
    ],
    [
        654134400000,
        [
            -2890723354.452774,
            -3361906970.91448,
            -178223333.0244508,
        ],
    ],
    [
        654739200000,
        [
            -2888133295.819059,
            -3364100054.16914,
            -179689337.4083138,
        ],
    ],
    [
        655344000000,
        [
            -2885541507.534471,
            -3366291358.752622,
            -181156015.0033834,
        ],
    ],
    [
        655948800000,
        [
            -2882948312.980812,
            -3368481166.337966,
            -182623254.8192211,
        ],
    ],
    [
        656553600000,
        [
            -2880353953.075338,
            -3370669646.908975,
            -184090721.6013359,
        ],
    ],
    [
        657158400000,
        [
            -2877758500.626853,
            -3372856797.554281,
            -185557973.1053306,
        ],
    ],
    [
        657763200000,
        [
            -2875161834.695745,
            -3375042442.043424,
            -187024615.4936869,
        ],
    ],
    [
        658368000000,
        [
            -2872563683.99455,
            -3377226291.965618,
            -188490441.475732,
        ],
    ],
    [
        658972800000,
        [
            -2869963723.087411,
            -3379408047.250007,
            -189955502.562584,
        ],
    ],
    [
        659577600000,
        [
            -2867361687.733869,
            -3381587501.053328,
            -191420090.9687865,
        ],
    ],
    [
        660182400000,
        [
            -2864757469.484371,
            -3383764612.623454,
            -192884636.4488883,
        ],
    ],
    [
        660787200000,
        [
            -2862151155.121186,
            -3385939521.489197,
            -194349553.7053389,
        ],
    ],
    [
        661392000000,
        [
            -2859542996.103531,
            -3388112497.667974,
            -195815095.7761946,
        ],
    ],
    [
        661996800000,
        [
            -2856933319.45446,
            -3390283846.157277,
            -197281265.5992146,
        ],
    ],
    [
        662601600000,
        [
            -2854322412.989102,
            -3392453798.708926,
            -198747814.6076237,
        ],
    ],
    [
        663206400000,
        [
            -2851710425.847669,
            -3394622431.382975,
            -200214329.0555685,
        ],
    ],
    [
        663811200000,
        [
            -2849097316.789345,
            -3396789638.262554,
            -201680375.9662394,
        ],
    ],
    [
        664416000000,
        [
            -2846482868.28873,
            -3398955169.029822,
            -203145656.0840414,
        ],
    ],
    [
        665020800000,
        [
            -2843866763.123787,
            -3401118716.680503,
            -204610108.8661609,
        ],
    ],
    [
        665625600000,
        [
            -2841248696.202035,
            -3403280024.91867,
            -206073933.4566847,
        ],
    ],
    [
        666230400000,
        [
            -2838628482.551832,
            -3405438978.257966,
            -207537518.7791747,
        ],
    ],
    [
        666835200000,
        [
            -2836006123.444772,
            -3407595642.962844,
            -209001306.0137962,
        ],
    ],
    [
        667440000000,
        [
            -2833381806.175157,
            -3409750243.294588,
            -210465632.0097717,
        ],
    ],
    [
        668044800000,
        [
            -2830755837.559978,
            -3411903081.694348,
            -211930610.5319838,
        ],
    ],
    [
        668649600000,
        [
            -2828128535.866201,
            -3414054432.365667,
            -213396093.0552733,
        ],
    ],
    [
        669254400000,
        [
            -2825500118.726838,
            -3416204445.27741,
            -214861721.0408823,
        ],
    ],
    [
        669859200000,
        [
            -2822870625.12674,
            -3418353092.436496,
            -216327051.406453,
        ],
    ],
    [
        670464000000,
        [
            -2820239901.23133,
            -3420500175.716513,
            -217791711.8732041,
        ],
    ],
    [
        671068800000,
        [
            -2817607655.824941,
            -3422645396.316537,
            -219255531.9373598,
        ],
    ],
    [
        671673600000,
        [
            -2814973562.486466,
            -3424788460.182851,
            -220718602.8560439,
        ],
    ],
    [
        672278400000,
        [
            -2812337373.328166,
            -3426929180.425014,
            -222181245.3547613,
        ],
    ],
    [
        672883200000,
        [
            -2809699006.341021,
            -3429067542.025116,
            -223643896.254916,
        ],
    ],
    [
        673488000000,
        [
            -2807058574.849231,
            -3431203705.970582,
            -225106953.170606,
        ],
    ],
    [
        674092800000,
        [
            -2804416347.535375,
            -3433337950.700205,
            -226570633.0291666,
        ],
    ],
    [
        674697600000,
        [
            -2801772653.695642,
            -3435470572.236593,
            -228034895.4688678,
        ],
    ],
    [
        675302400000,
        [
            -2799127768.175453,
            -3437601779.046493,
            -229499457.0754609,
        ],
    ],
    [
        675907200000,
        [
            -2796481815.743757,
            -3439731617.867652,
            -230963890.2212281,
        ],
    ],
    [
        676512000000,
        [
            -2793834727.545308,
            -3441859956.156533,
            -232427772.9944843,
        ],
    ],
    [
        677116800000,
        [
            -2791186265.301918,
            -3443986527.869483,
            -233890837.865539,
        ],
    ],
    [
        677721600000,
        [
            -2788536105.598703,
            -3446111025.532287,
            -235353065.0307443,
        ],
    ],
    [
        678326400000,
        [
            -2785883955.709797,
            -3448233206.56993,
            -236814688.0125984,
        ],
    ],
    [
        678931200000,
        [
            -2783229658.557359,
            -3450352978.693241,
            -238276111.7161028,
        ],
    ],
    [
        679536000000,
        [
            -2780573248.994072,
            -3452470432.702598,
            -239737769.7700878,
        ],
    ],
    [
        680140800000,
        [
            -2777914942.300148,
            -3454585809.482511,
            -241199970.3236695,
        ],
    ],
    [
        680745600000,
        [
            -2775255058.931373,
            -3456699413.530413,
            -242662786.6172123,
        ],
    ],
    [
        681350400000,
        [
            -2772593912.782974,
            -3458811504.867633,
            -244126031.4772392,
        ],
    ],
    [
        681955200000,
        [
            -2769931702.543438,
            -3460922207.505578,
            -245589323.1222667,
        ],
    ],
    [
        682560000000,
        [
            -2767268443.233032,
            -3463031465.584477,
            -247052218.8553711,
        ],
    ],
    [
        683164800000,
        [
            -2764603961.944974,
            -3465139062.789117,
            -248514370.9351763,
        ],
    ],
    [
        683769600000,
        [
            -2761937960.018211,
            -3467244699.025441,
            -249975649.5244762,
        ],
    ],
    [
        684374400000,
        [
            -2759270119.149547,
            -3469348096.990381,
            -251436188.5090923,
        ],
    ],
    [
        684979200000,
        [
            -2756600213.102224,
            -3471449099.806741,
            -252896338.2445793,
        ],
    ],
    [
        685584000000,
        [
            -2753928187.885902,
            -3473547725.46169,
            -254356541.9963802,
        ],
    ],
    [
        686188800000,
        [
            -2751254183.122071,
            -3475644161.102583,
            -255817179.3717185,
        ],
    ],
    [
        686793600000,
        [
            -2748578483.067918,
            -3477738698.157082,
            -257278432.3636991,
        ],
    ],
    [
        687398400000,
        [
            -2745901415.119366,
            -3479831629.369632,
            -258740221.5785692,
        ],
    ],
    [
        688003200000,
        [
            -2743223234.264388,
            -3481923145.52177,
            -260202234.7257071,
        ],
    ],
    [
        688608000000,
        [
            -2740544033.735277,
            -3484013268.30582,
            -261664036.1017842,
        ],
    ],
    [
        689212800000,
        [
            -2737863711.962614,
            -3486101842.160277,
            -263125219.4302528,
        ],
    ],
    [
        689817600000,
        [
            -2735182008.077738,
            -3488188588.656695,
            -264585551.2052917,
        ],
    ],
    [
        690422400000,
        [
            -2732498594.048271,
            -3490273204.636461,
            -266045052.9956605,
        ],
    ],
    [
        691027200000,
        [
            -2729813190.306528,
            -3492355468.868906,
            -267503993.2996727,
        ],
    ],
    [
        691632000000,
        [
            -2727125663.714947,
            -3494435319.656438,
            -268962792.9160348,
        ],
    ],
    [
        692236800000,
        [
            -2724436073.740695,
            -3496512876.565693,
            -270421876.9632876,
        ],
    ],
    [
        692841600000,
        [
            -2721744650.593864,
            -3498588397.131837,
            -271881523.97408,
        ],
    ],
    [
        693446400000,
        [
            -2719051714.272037,
            -3500662183.822333,
            -273341766.1981496,
        ],
    ],
    [
        694051200000,
        [
            -2716357562.347435,
            -3502734476.908446,
            -274802378.5078362,
        ],
    ],
    [
        694656000000,
        [
            -2713662364.809769,
            -3504805369.861968,
            -276262958.017774,
        ],
    ],
    [
        695260800000,
        [
            -2710966103.788978,
            -3506874775.110812,
            -277723064.7630761,
        ],
    ],
    [
        695865600000,
        [
            -2708268579.540332,
            -3508942452.823129,
            -279182375.7457635,
        ],
    ],
    [
        696470400000,
        [
            -2705569481.319143,
            -3511008093.987263,
            -280640798.5335512,
        ],
    ],
    [
        697075200000,
        [
            -2702868498.036999,
            -3513071428.366589,
            -282098503.0213176,
        ],
    ],
    [
        697680000000,
        [
            -2700165428.699167,
            -3515132318.407804,
            -283555860.3855277,
        ],
    ],
    [
        698284800000,
        [
            -2697460253.97013,
            -3517190806.487046,
            -285013311.9846331,
        ],
    ],
    [
        698889600000,
        [
            -2694753144.389541,
            -3519247099.57959,
            -286471213.5729331,
        ],
    ],
    [
        699494400000,
        [
            -2692044401.186708,
            -3521301495.937819,
            -287929709.114181,
        ],
    ],
    [
        700099200000,
        [
            -2689334349.77149,
            -3523354278.853791,
            -289388679.6128162,
        ],
    ],
    [
        700704000000,
        [
            -2686623225.600376,
            -3525405615.031811,
            -290847784.6269456,
        ],
    ],
    [
        701308800000,
        [
            -2683911093.991656,
            -3527455495.285384,
            -292306581.429844,
        ],
    ],
    [
        701913600000,
        [
            -2681197828.312449,
            -3529503738.119021,
            -293764680.6180214,
        ],
    ],
    [
        702518400000,
        [
            -2678483154.285878,
            -3531550053.104868,
            -295221883.52047,
        ],
    ],
    [
        703123200000,
        [
            -2675766747.402595,
            -3533594142.672195,
            -296678252.230103,
        ],
    ],
    [
        703728000000,
        [
            -2673048348.635655,
            -3535635806.585666,
            -298134086.8754433,
        ],
    ],
    [
        704332800000,
        [
            -2670327856.509104,
            -3537675011.747253,
            -299589819.0785361,
        ],
    ],
    [
        704937600000,
        [
            -2667605363.662152,
            -3539711903.449613,
            -301045860.018822,
        ],
    ],
    [
        705542400000,
        [
            -2664881125.490087,
            -3541746754.334709,
            -302502455.3274045,
        ],
    ],
    [
        706147200000,
        [
            -2662155470.923027,
            -3543779868.160613,
            -303959597.9239107,
        ],
    ],
    [
        706752000000,
        [
            -2659428686.766204,
            -3545811472.677004,
            -305417030.8025569,
        ],
    ],
    [
        707356800000,
        [
            -2656700916.800004,
            -3547841639.932756,
            -306874338.1672856,
        ],
    ],
    [
        707961600000,
        [
            -2653972110.731071,
            -3549870260.416399,
            -308331091.1236438,
        ],
    ],
    [
        708566400000,
        [
            -2651242042.171503,
            -3551897079.763488,
            -309786997.6785312,
        ],
    ],
    [
        709171200000,
        [
            -2648510389.627726,
            -3553921788.437167,
            -311242006.2368374,
        ],
    ],
    [
        709776000000,
        [
            -2645776849.958845,
            -3555944131.693225,
            -312696324.2479755,
        ],
    ],
    [
        710380800000,
        [
            -2643041244.792284,
            -3557963998.701468,
            -314150344.1246716,
        ],
    ],
    [
        710985600000,
        [
            -2640303582.993183,
            -3559981460.082457,
            -315604504.1683315,
        ],
    ],
    [
        711590400000,
        [
            -2637564057.842789,
            -3561996741.997079,
            -317059133.9699354,
        ],
    ],
    [
        712195200000,
        [
            -2634822979.675069,
            -3564010145.70546,
            -318514337.5707495,
        ],
    ],
    [
        712800000000,
        [
            -2632080666.926539,
            -3566021940.281713,
            -319969956.0159593,
        ],
    ],
    [
        713404800000,
        [
            -2629337334.463727,
            -3568032266.857975,
            -321425623.2753752,
        ],
    ],
    [
        714009600000,
        [
            -2626593019.036865,
            -3570041088.591336,
            -322880894.9061295,
        ],
    ],
    [
        714614400000,
        [
            -2623847566.91511,
            -3572048203.119145,
            -324335403.7350867,
        ],
    ],
    [
        715219200000,
        [
            -2621100687.378504,
            -3574053312.672009,
            -325788989.1259824,
        ],
    ],
    [
        715824000000,
        [
            -2618352055.495778,
            -3576056127.397169,
            -327241753.437403,
        ],
    ],
    [
        716428800000,
        [
            -2615601429.363998,
            -3578056466.653006,
            -328694024.8024251,
        ],
    ],
    [
        717033600000,
        [
            -2612848736.840671,
            -3580054322.778624,
            -330146240.7671202,
        ],
    ],
    [
        717638400000,
        [
            -2610094100.716351,
            -3582049863.117785,
            -331598794.1071004,
        ],
    ],
    [
        718243200000,
        [
            -2607337796.152151,
            -3584043370.205995,
            -333051894.1879268,
        ],
    ],
    [
        718848000000,
        [
            -2604580154.985821,
            -3586035141.394855,
            -334505492.3491912,
        ],
    ],
    [
        719452800000,
        [
            -2601821449.921407,
            -3588025383.27418,
            -335959298.5847899,
        ],
    ],
    [
        720057600000,
        [
            -2599061799.857368,
            -3590014138.62328,
            -337412883.7281871,
        ],
    ],
    [
        720662400000,
        [
            -2596301129.657781,
            -3592001271.437686,
            -338865830.1308991,
        ],
    ],
    [
        721267200000,
        [
            -2593539197.601488,
            -3593986514.551655,
            -340317878.1989764,
        ],
    ],
    [
        721872000000,
        [
            -2590775681.211734,
            -3595969563.835081,
            -341769018.5257778,
        ],
    ],
    [
        722476800000,
        [
            -2588010291.806395,
            -3597950186.458138,
            -343219496.0134732,
        ],
    ],
    [
        723081600000,
        [
            -2585242876.437064,
            -3599928303.206245,
            -344669722.8375126,
        ],
    ],
    [
        723686400000,
        [
            -2582473472.193019,
            -3601904014.958461,
            -346120131.8760675,
        ],
    ],
    [
        724291200000,
        [
            -2579702294.561092,
            -3603877567.307743,
            -347571024.5684355,
        ],
    ],
    [
        724896000000,
        [
            -2576929661.780671,
            -3605849265.383229,
            -349022465.3620533,
        ],
    ],
    [
        725500800000,
        [
            -2574155882.016411,
            -3607819366.254841,
            -350474258.7035252,
        ],
    ],
    [
        726105600000,
        [
            -2571381144.429012,
            -3609787987.750193,
            -351926017.8429536,
        ],
    ],
    [
        726710400000,
        [
            -2568605452.893926,
            -3611755066.815671,
            -353377300.9700652,
        ],
    ],
    [
        727315200000,
        [
            -2565828624.883493,
            -3613720381.436469,
            -354827766.0303096,
        ],
    ],
    [
        727920000000,
        [
            -2563050355.295815,
            -3615683627.987045,
            -356277290.8885174,
        ],
    ],
    [
        728524800000,
        [
            -2560270323.883373,
            -3617644527.862485,
            -357726016.9781668,
        ],
    ],
    [
        729129600000,
        [
            -2557488308.780226,
            -3619602925.962385,
            -359174299.3936917,
        ],
    ],
    [
        729734400000,
        [
            -2554704264.723663,
            -3621558845.245686,
            -360622580.7745525,
        ],
    ],
    [
        730339200000,
        [
            -2551918337.566873,
            -3623512477.637383,
            -362071234.8488531,
        ],
    ],
    [
        730944000000,
        [
            -2549130811.775828,
            -3625464114.551447,
            -363520434.4144299,
        ],
    ],
    [
        731548800000,
        [
            -2546342011.390694,
            -3627414042.574072,
            -364970089.3635448,
        ],
    ],
    [
        732153600000,
        [
            -2543552186.597564,
            -3629362442.1291,
            -366419878.0899353,
        ],
    ],
    [
        732758400000,
        [
            -2540761424.927433,
            -3631309323.213895,
            -367869360.8438737,
        ],
    ],
    [
        733363200000,
        [
            -2537969620.496805,
            -3633254520.508143,
            -369318133.7628462,
        ],
    ],
    [
        733968000000,
        [
            -2535176511.644572,
            -3635197749.634181,
            -370765969.6001609,
        ],
    ],
    [
        734572800000,
        [
            -2532381773.38041,
            -3637138705.277185,
            -372212897.3189988,
        ],
    ],
    [
        735177600000,
        [
            -2529585133.225739,
            -3639077167.722189,
            -373659191.9495128,
        ],
    ],
    [
        735782400000,
        [
            -2526786469.152528,
            -3641013079.589904,
            -375105276.5577648,
        ],
    ],
    [
        736387200000,
        [
            -2523985853.850735,
            -3642946564.741502,
            -376551571.6659666,
        ],
    ],
    [
        736992000000,
        [
            -2521183530.020478,
            -3644877883.4064,
            -377998346.7520444,
        ],
    ],
    [
        737596800000,
        [
            -2518379826.002183,
            -3646807340.167104,
            -379445625.4597108,
        ],
    ],
    [
        738201600000,
        [
            -2515575040.633093,
            -3648735175.813958,
            -380893176.6287767,
        ],
    ],
    [
        738806400000,
        [
            -2512769339.154778,
            -3650661480.481447,
            -382340594.6660404,
        ],
    ],
    [
        739411200000,
        [
            -2509962697.940752,
            -3652586161.448978,
            -383787442.1552146,
        ],
    ],
    [
        740016000000,
        [
            -2507154914.533463,
            -3654508976.608445,
            -385233403.8506631,
        ],
    ],
    [
        740620800000,
        [
            -2504345679.172124,
            -3656429619.072295,
            -386678397.1587741,
        ],
    ],
    [
        741225600000,
        [
            -2501534684.630642,
            -3658347824.347902,
            -388122601.4809236,
        ],
    ],
    [
        741830400000,
        [
            -2498721736.468916,
            -3660263463.662829,
            -389566395.1176097,
        ],
    ],
    [
        742435200000,
        [
            -2495906823.508834,
            -3662176589.475088,
            -391010220.9142069,
        ],
    ],
    [
        743040000000,
        [
            -2493090122.728797,
            -3664087416.473032,
            -392454429.4498731,
        ],
    ],
    [
        743644800000,
        [
            -2490271937.850605,
            -3665996245.818854,
            -393899155.9432925,
        ],
    ],
    [
        744249600000,
        [
            -2487452593.782502,
            -3667903359.668337,
            -395344272.8129856,
        ],
    ],
    [
        744854400000,
        [
            -2484632322.978897,
            -3669808922.315426,
            -396789434.5593414,
        ],
    ],
    [
        745459200000,
        [
            -2481811183.430174,
            -3671712922.786568,
            -398234199.9788353,
        ],
    ],
    [
        746064000000,
        [
            -2478989038.097105,
            -3673615178.464504,
            -399678187.4650965,
        ],
    ],
    [
        746668800000,
        [
            -2476165604.496743,
            -3675515398.590327,
            -401121208.3069359,
        ],
    ],
    [
        747273600000,
        [
            -2473340555.074286,
            -3677413287.068684,
            -402563333.3819191,
        ],
    ],
    [
        747878400000,
        [
            -2470513632.108072,
            -3679308647.526504,
            -404004869.3210867,
        ],
    ],
    [
        748483200000,
        [
            -2467684738.627376,
            -3681201452.652991,
            -405446250.2409514,
        ],
    ],
    [
        749088000000,
        [
            -2464853972.759729,
            -3683091853.123604,
            -406887883.4580467,
        ],
    ],
    [
        749692800000,
        [
            -2462021592.856446,
            -3684980123.322012,
            -408330005.3887257,
        ],
    ],
    [
        750297600000,
        [
            -2459187926.70244,
            -3686866564.070602,
            -409772598.4652349,
        ],
    ],
    [
        750902400000,
        [
            -2456353256.712416,
            -3688751396.313977,
            -411215396.8284546,
        ],
    ],
    [
        751507200000,
        [
            -2453517720.707332,
            -3690634682.518351,
            -412657979.4262873,
        ],
    ],
    [
        752112000000,
        [
            -2450681263.757629,
            -3692516304.221511,
            -414099918.4422172,
        ],
    ],
    [
        752716800000,
        [
            -2447843658.058651,
            -3694396003.830528,
            -415540929.8181055,
        ],
    ],
    [
        753321600000,
        [
            -2445004582.578449,
            -3696273474.465035,
            -416980972.4398937,
        ],
    ],
    [
        753926400000,
        [
            -2442163735.853301,
            -3698148465.751877,
            -418420261.9190159,
        ],
    ],
    [
        754531200000,
        [
            -2439320944.453944,
            -3700020871.321387,
            -419859194.4847,
        ],
    ],
    [
        755136000000,
        [
            -2436476225.579563,
            -3701890766.977567,
            -421298206.9328631,
        ],
    ],
    [
        755740800000,
        [
            -2433629780.660853,
            -3703758383.046114,
            -422737621.6878355,
        ],
    ],
    [
        756345600000,
        [
            -2430781924.369423,
            -3705624021.577394,
            -424177532.7876813,
        ],
    ],
    [
        756950400000,
        [
            -2427932974.947067,
            -3707487949.071036,
            -425617772.4880226,
        ],
    ],
    [
        757555200000,
        [
            -2425083143.456151,
            -3709350301.839191,
            -427057969.4420477,
        ],
    ],
    [
        758160000000,
        [
            -2422232460.425841,
            -3711211037.070692,
            -428497679.0206891,
        ],
    ],
    [
        758764800000,
        [
            -2419380766.456838,
            -3713069947.536478,
            -429936539.966728,
        ],
    ],
    [
        759369600000,
        [
            -2416527770.043406,
            -3714926734.634178,
            -431374401.1813952,
        ],
    ],
    [
        759974400000,
        [
            -2413673151.205308,
            -3716781113.392291,
            -432811374.4668636,
        ],
    ],
    [
        760579200000,
        [
            -2410816674.4552,
            -3718632912.907194,
            -434247795.7167337,
        ],
    ],
    [
        761184000000,
        [
            -2407958272.226291,
            -3720482136.39401,
            -435684106.4495111,
        ],
    ],
    [
        761788800000,
        [
            -2405098070.355443,
            -3722328958.947458,
            -437120696.6386141,
        ],
    ],
    [
        762393600000,
        [
            -2402236345.263395,
            -3724173665.801361,
            -438557766.9909495,
        ],
    ],
    [
        762998400000,
        [
            -2399373426.567553,
            -3726016552.472778,
            -439995259.1679303,
        ],
    ],
    [
        763603200000,
        [
            -2396509581.20272,
            -3727857820.668885,
            -441432876.142319,
        ],
    ],
    [
        764208000000,
        [
            -2393644919.692646,
            -3729697506.468949,
            -442870185.9877569,
        ],
    ],
    [
        764812800000,
        [
            -2390779357.541317,
            -3731535466.907617,
            -444306773.9684895,
        ],
    ],
    [
        765417600000,
        [
            -2387912645.855702,
            -3733371430.240262,
            -445742388.7114166,
        ],
    ],
    [
        766022400000,
        [
            -2385044459.884955,
            -3735205091.549117,
            -447177030.1394562,
        ],
    ],
    [
        766627200000,
        [
            -2382174513.713145,
            -3737036219.599261,
            -448610949.1132236,
        ],
    ],
    [
        767232000000,
        [
            -2379302661.498824,
            -3738864738.215332,
            -450044559.4042615,
        ],
    ],
    [
        767836800000,
        [
            -2376428949.51747,
            -3740690753.535977,
            -451478291.7326534,
        ],
    ],
    [
        768441600000,
        [
            -2373553599.213706,
            -3742514516.069908,
            -452912441.163928,
        ],
    ],
    [
        769046400000,
        [
            -2370676928.379397,
            -3744336330.288076,
            -454347062.4154465,
        ],
    ],
    [
        769651200000,
        [
            -2367799240.880434,
            -3746156446.261368,
            -455781950.3217703,
        ],
    ],
    [
        770256000000,
        [
            -2364920720.863144,
            -3747974972.025116,
            -457216711.7565081,
        ],
    ],
    [
        770860800000,
        [
            -2362041367.148048,
            -3749791834.556815,
            -458650903.5735579,
        ],
    ],
    [
        771465600000,
        [
            -2359160993.533223,
            -3751606803.952536,
            -460084188.5489619,
        ],
    ],
    [
        772070400000,
        [
            -2356279295.535907,
            -3753419573.389583,
            -461516453.5888004,
        ],
    ],
    [
        772675200000,
        [
            -2353395958.822531,
            -3755229865.998406,
            -462947848.369545,
        ],
    ],
    [
        773280000000,
        [
            -2350510770.88658,
            -3757037531.049249,
            -464378732.0634562,
        ],
    ],
    [
        773884800000,
        [
            -2347623697.527629,
            -3758842596.362386,
            -465809546.5329618,
        ],
    ],
    [
        774489600000,
        [
            -2344734896.706699,
            -3760645257.951716,
            -467240659.6679487,
        ],
    ],
    [
        775094400000,
        [
            -2341844664.062816,
            -3762445810.157948,
            -468672235.0586813,
        ],
    ],
    [
        775699200000,
        [
            -2338953329.487502,
            -3764244541.527705,
            -470104174.6881825,
        ],
    ],
    [
        776304000000,
        [
            -2336061141.758192,
            -3766041632.67429,
            -471536153.2520086,
        ],
    ],
    [
        776908800000,
        [
            -2333168182.803251,
            -3767837091.052135,
            -472967731.1108173,
        ],
    ],
    [
        777513600000,
        [
            -2330274341.218843,
            -3769630747.867451,
            -474398508.8622445,
        ],
    ],
    [
        778118400000,
        [
            -2327379352.687645,
            -3771422318.340724,
            -475828268.9978721,
        ],
    ],
    [
        778723200000,
        [
            -2324482894.229526,
            -3773211502.241708,
            -477257052.3205015,
        ],
    ],
    [
        779328000000,
        [
            -2321584699.194756,
            -3774998089.096824,
            -478685142.6987655,
        ],
    ],
    [
        779932800000,
        [
            -2318684652.534172,
            -3776782032.001095,
            -480112967.017868,
        ],
    ],
    [
        780537600000,
        [
            -2315782833.190287,
            -3778563464.52201,
            -481540944.6312473,
        ],
    ],
    [
        781142400000,
        [
            -2312879487.720645,
            -3780342653.800395,
            -482969338.9332775,
        ],
    ],
    [
        781747200000,
        [
            -2309974944.28229,
            -3782119906.411804,
            -484398164.6520761,
        ],
    ],
    [
        782352000000,
        [
            -2307069498.24649,
            -3783895461.134589,
            -485827183.4417868,
        ],
    ],
    [
        782956800000,
        [
            -2304163309.410011,
            -3785669406.161467,
            -487255987.9159727,
        ],
    ],
    [
        783561600000,
        [
            -2301256345.359449,
            -3787441648.471052,
            -488684144.8293285,
        ],
    ],
    [
        784166400000,
        [
            -2298348392.108311,
            -3789211945.724053,
            -490111347.7514937,
        ],
    ],
    [
        784771200000,
        [
            -2295439131.065566,
            -3790979991.494397,
            -491537525.1674309,
        ],
    ],
    [
        785376000000,
        [
            -2292528252.661309,
            -3792745524.802059,
            -492962865.8523139,
        ],
    ],
    [
        785980800000,
        [
            -2289615564.556755,
            -3794508422.534942,
            -494387752.3162568,
        ],
    ],
    [
        786585600000,
        [
            -2286701058.764857,
            -3796268742.430076,
            -495812626.0326195,
        ],
    ],
    [
        787190400000,
        [
            -2283784914.642696,
            -3798026702.392348,
            -497237831.2881747,
        ],
    ],
    [
        787795200000,
        [
            -2280867435.547736,
            -3799782602.924483,
            -498663493.0940465,
        ],
    ],
    [
        788400000000,
        [
            -2277948941.717469,
            -3801536720.457893,
            -500089473.2472737,
        ],
    ],
    [
        789004800000,
        [
            -2275029658.015301,
            -3803289209.842491,
            -501515419.1259691,
        ],
    ],
    [
        789609600000,
        [
            -2272109635.342855,
            -3805040049.488645,
            -502940886.8595372,
        ],
    ],
    [
        790214400000,
        [
            -2269188732.441012,
            -3806789047.984437,
            -504365497.037006,
        ],
    ],
    [
        790819200000,
        [
            -2266266665.222484,
            -3808535910.977938,
            -505789068.899927,
        ],
    ],
    [
        791424000000,
        [
            -2263343106.573494,
            -3810280344.262013,
            -507211683.8829891,
        ],
    ],
    [
        792028800000,
        [
            -2260417802.248251,
            -3812022155.415013,
            -508633655.229639,
        ],
    ],
    [
        792633600000,
        [
            -2257490662.166508,
            -3813761320.395776,
            -510055416.7672857,
        ],
    ],
    [
        793238400000,
        [
            -2254561792.852586,
            -3815497992.079541,
            -511477370.1249972,
        ],
    ],
    [
        793843200000,
        [
            -2251631459.939693,
            -3817232445.338389,
            -512899742.2915422,
        ],
    ],
    [
        794448000000,
        [
            -2248699994.865074,
            -3818964978.283288,
            -514322504.7061952,
        ],
    ],
    [
        795052800000,
        [
            -2245767679.195415,
            -3820695805.874131,
            -515745383.1759945,
        ],
    ],
    [
        795657600000,
        [
            -2242834647.441817,
            -3822424983.62904,
            -517167953.8594432,
        ],
    ],
    [
        796262400000,
        [
            -2239900841.324821,
            -3824152387.12028,
            -518589791.1299416,
        ],
    ],
    [
        796867200000,
        [
            -2236966031.339689,
            -3825877754.538272,
            -520010617.0679434,
        ],
    ],
    [
        797472000000,
        [
            -2234029899.302409,
            -3827600778.621229,
            -521430399.8625687,
        ],
    ],
    [
        798076800000,
        [
            -2231092152.566519,
            -3829321215.410962,
            -522849364.898657,
        ],
    ],
    [
        798681600000,
        [
            -2228152628.061156,
            -3831038970.232598,
            -524267914.7296895,
        ],
    ],
    [
        799286400000,
        [
            -2225211350.132354,
            -3832754129.947351,
            -525686486.7453017,
        ],
    ],
    [
        799891200000,
        [
            -2222268524.413578,
            -3834466931.433825,
            -527105398.1873761,
        ],
    ],
    [
        800496000000,
        [
            -2219324467.568078,
            -3836177678.692791,
            -528524734.099737,
        ],
    ],
    [
        801100800000,
        [
            -2216379495.872689,
            -3837886636.077664,
            -529944317.9730938,
        ],
    ],
    [
        801705600000,
        [
            -2213433814.529861,
            -3839593935.200241,
            -531363774.3488375,
        ],
    ],
    [
        802310400000,
        [
            -2210487446.953677,
            -3841299528.675101,
            -532782660.3432679,
        ],
    ],
    [
        802915200000,
        [
            -2207540227.393009,
            -3843003206.287983,
            -534200620.7156685,
        ],
    ],
    [
        803520000000,
        [
            -2204591859.903449,
            -3844704668.624383,
            -535617513.3587863,
        ],
    ],
    [
        804124800000,
        [
            -2201642023.925411,
            -3846403633.004617,
            -537033459.9787,
        ],
    ],
    [
        804729600000,
        [
            -2198690488.73618,
            -3848099933.714343,
            -538448802.8642856,
        ],
    ],
    [
        805334400000,
        [
            -2195737195.493407,
            -3849793580.581538,
            -539863983.8534237,
        ],
    ],
    [
        805939200000,
        [
            -2192782278.226781,
            -3851484755.935209,
            -541279388.9840447,
        ],
    ],
    [
        806544000000,
        [
            -2189826016.313441,
            -3853173750.431249,
            -542695212.2459207,
        ],
    ],
    [
        807148800000,
        [
            -2186868735.892129,
            -3854860859.021162,
            -544111386.2182176,
        ],
    ],
    [
        807753600000,
        [
            -2183910696.472479,
            -3856546276.405354,
            -545527605.9557323,
        ],
    ],
    [
        808358400000,
        [
            -2180952000.627178,
            -3858230029.688159,
            -546943437.1018302,
        ],
    ],
    [
        808963200000,
        [
            -2177992557.777522,
            -3859911968.740349,
            -548358467.9791318,
        ],
    ],
    [
        809568000000,
        [
            -2175032115.667235,
            -3861591817.510351,
            -549772453.7596939,
        ],
    ],
    [
        810172800000,
        [
            -2172070349.661349,
            -3863269270.213307,
            -551185402.953688,
        ],
    ],
    [
        810777600000,
        [
            -2169106978.548984,
            -3864944098.785495,
            -552597574.2094741,
        ],
    ],
    [
        811382400000,
        [
            -2166141864.972398,
            -3866616232.732138,
            -554009384.1422704,
        ],
    ],
    [
        811987200000,
        [
            -2163175064.768165,
            -3868285783.120181,
            -555421259.8798492,
        ],
    ],
    [
        812592000000,
        [
            -2160206808.590896,
            -3869953003.060045,
            -556833488.3465662,
        ],
    ],
    [
        813196800000,
        [
            -2157237421.89973,
            -3871618198.385066,
            -558246114.657131,
        ],
    ],
    [
        813801600000,
        [
            -2154267210.563248,
            -3873281619.506628,
            -559658926.1150529,
        ],
    ],
    [
        814406400000,
        [
            -2151296353.286558,
            -3874943372.289085,
            -561071527.2685131,
        ],
    ],
    [
        815011200000,
        [
            -2148324841.086934,
            -3876603379.871773,
            -562483478.273053,
        ],
    ],
    [
        815616000000,
        [
            -2145352482.950727,
            -3878261410.008156,
            -563894448.9071854,
        ],
    ],
    [
        816220800000,
        [
            -2142378973.243903,
            -3879917156.961401,
            -565304335.3116167,
        ],
    ],
    [
        816825600000,
        [
            -2139404000.026182,
            -3881570349.094172,
            -566713297.1336825,
        ],
    ],
    [
        817430400000,
        [
            -2136427356.67523,
            -3883220844.625931,
            -568121700.7244332,
        ],
    ],
    [
        818035200000,
        [
            -2133449016.077126,
            -3884868681.289957,
            -569529989.1477724,
        ],
    ],
    [
        818640000000,
        [
            -2130469141.357631,
            -3886514062.867374,
            -570938525.9670542,
        ],
    ],
    [
        819244800000,
        [
            -2127488029.92376,
            -3888157287.736754,
            -572347467.027669,
        ],
    ],
    [
        819849600000,
        [
            -2124506009.83984,
            -3889798643.936205,
            -573756705.1460427,
        ],
    ],
    [
        820454400000,
        [
            -2121523325.022385,
            -3891438307.965909,
            -575165908.2536107,
        ],
    ],
    [
        821059200000,
        [
            -2118540050.201042,
            -3893076283.706856,
            -576574637.2173836,
        ],
    ],
    [
        821664000000,
        [
            -2115556064.877285,
            -3894712401.949126,
            -577982500.3488876,
        ],
    ],
    [
        822268800000,
        [
            -2112571095.497927,
            -3896346378.895435,
            -579389290.270351,
        ],
    ],
    [
        822873600000,
        [
            -2109584813.077428,
            -3897977915.584008,
            -580795057.1219804,
        ],
    ],
    [
        823478400000,
        [
            -2106596950.256857,
            -3899606804.880364,
            -582200091.9307948,
        ],
    ],
    [
        824083200000,
        [
            -2103607395.322073,
            -3901233005.183208,
            -583604823.75212,
        ],
    ],
    [
        824688000000,
        [
            -2100616231.038083,
            -3902856654.311704,
            -585009667.7573849,
        ],
    ],
    [
        825292800000,
        [
            -2097623705.55486,
            -3904478020.333618,
            -586414878.8712146,
        ],
    ],
    [
        825897600000,
        [
            -2094630145.544539,
            -3906097406.823517,
            -587820461.4231254,
        ],
    ],
    [
        826502400000,
        [
            -2091635841.239405,
            -3907715045.147493,
            -589226166.9729576,
        ],
    ],
    [
        827107200000,
        [
            -2088640944.362036,
            -3909331012.285177,
            -590631581.9805201,
        ],
    ],
    [
        827712000000,
        [
            -2085645415.587821,
            -3910945203.663756,
            -592036273.4854373,
        ],
    ],
    [
        828316800000,
        [
            -2082649039.130648,
            -3912557369.812814,
            -593439940.7665534,
        ],
    ],
    [
        828921600000,
        [
            -2079651498.28318,
            -3914167203.469536,
            -594842520.95739,
        ],
    ],
    [
        829526400000,
        [
            -2076652486.421584,
            -3915774446.655097,
            -596244211.3363521,
        ],
    ],
    [
        830131200000,
        [
            -2073651816.537081,
            -3917378980.002997,
            -597645398.6994408,
        ],
    ],
    [
        830736000000,
        [
            -2070649489.36464,
            -3918980864.294912,
            -599046521.9381734,
        ],
    ],
    [
        831340800000,
        [
            -2067645693.340806,
            -3920580318.684694,
            -600447917.324721,
        ],
    ],
    [
        831945600000,
        [
            -2064640738.561599,
            -3922177642.531216,
            -601849699.8199408,
        ],
    ],
    [
        832550400000,
        [
            -2061634948.761786,
            -3923773108.695525,
            -603251721.4510996,
        ],
    ],
    [
        833155200000,
        [
            -2058628548.45113,
            -3925366865.950413,
            -604653622.5737628,
        ],
    ],
    [
        833760000000,
        [
            -2055621585.428137,
            -3926958885.661793,
            -606054958.5161996,
        ],
    ],
    [
        834364800000,
        [
            -2052613916.232042,
            -3928548971.636003,
            -607455355.795487,
        ],
    ],
    [
        834969600000,
        [
            -2049605258.639084,
            -3930136828.723976,
            -608854642.6862258,
        ],
    ],
    [
        835574400000,
        [
            -2046595292.635338,
            -3931722166.321252,
            -610252909.7445253,
        ],
    ],
    [
        836179200000,
        [
            -2043583775.171855,
            -3933304801.369666,
            -611650478.4566668,
        ],
    ],
    [
        836784000000,
        [
            -2040570627.244059,
            -3934884723.451522,
            -613047787.5523337,
        ],
    ],
    [
        837388800000,
        [
            -2037555962.48021,
            -3936462097.32593,
            -614445237.3270929,
        ],
    ],
    [
        837993600000,
        [
            -2034540049.583396,
            -3938037204.159393,
            -615843048.3993827,
        ],
    ],
    [
        838598400000,
        [
            -2031523220.252318,
            -3939610344.070718,
            -617241184.5525584,
        ],
    ],
    [
        839203200000,
        [
            -2028505753.02219,
            -3941181731.236435,
            -618639365.3647763,
        ],
    ],
    [
        839808000000,
        [
            -2025487775.595469,
            -3942751418.187059,
            -620037164.9688536,
        ],
    ],
    [
        840412800000,
        [
            -2022469221.166389,
            -3944319277.545039,
            -621434162.4302707,
        ],
    ],
    [
        841017600000,
        [
            -2019449853.650268,
            -3945885047.561517,
            -622830089.8268701,
        ],
    ],
    [
        841622400000,
        [
            -2016429351.905536,
            -3947448424.602584,
            -624224926.306492,
        ],
    ],
    [
        842227200000,
        [
            -2013407423.786595,
            -3949009170.606643,
            -625618906.030404,
        ],
    ],
    [
        842832000000,
        [
            -2010383910.555956,
            -3950567198.152432,
            -627012436.0424529,
        ],
    ],
    [
        843436800000,
        [
            -2007358843.833539,
            -3952122602.271983,
            -628405952.4288174,
        ],
    ],
    [
        844041600000,
        [
            -2004332434.149265,
            -3953675627.496226,
            -629799766.8663119,
        ],
    ],
    [
        844646400000,
        [
            -2001304996.050603,
            -3955226581.981781,
            -631193957.5256828,
        ],
    ],
    [
        845251200000,
        [
            -1998276838.017318,
            -3956775728.465983,
            -632588340.7811258,
        ],
    ],
    [
        845856000000,
        [
            -1995248155.208661,
            -3958323191.830834,
            -633982535.3225439,
        ],
    ],
    [
        846460800000,
        [
            -1992218960.422534,
            -3959868915.973549,
            -635376097.297192,
        ],
    ],
    [
        847065600000,
        [
            -1989189079.09683,
            -3961412683.769717,
            -636768676.9582534,
        ],
    ],
    [
        847670400000,
        [
            -1986158210.893304,
            -3962954193.054144,
            -638160141.1289408,
        ],
    ],
    [
        848275200000,
        [
            -1983126035.5613,
            -3964493162.206539,
            -639550619.6851046,
        ],
    ],
    [
        848880000000,
        [
            -1980092326.406345,
            -3966029429.035365,
            -640940459.8825938,
        ],
    ],
    [
        849484800000,
        [
            -1977057031.264946,
            -3967563007.830875,
            -642330103.3219955,
        ],
    ],
    [
        850089600000,
        [
            -1974020291.49127,
            -3969094083.643614,
            -643719929.2737328,
        ],
    ],
    [
        850694400000,
        [
            -1970982392.464754,
            -3970622946.297904,
            -645110120.9922359,
        ],
    ],
    [
        851299200000,
        [
            -1967943663.987417,
            -3972149888.468837,
            -646500601.5982332,
        ],
    ],
    [
        851904000000,
        [
            -1964904364.627095,
            -3973675102.710495,
            -647891060.5828055,
        ],
    ],
    [
        852508800000,
        [
            -1961864590.331282,
            -3975198611.993729,
            -649281062.0912746,
        ],
    ],
    [
        853113600000,
        [
            -1958824242.270115,
            -3976720260.058192,
            -650670197.9492891,
        ],
    ],
    [
        853718400000,
        [
            -1955783063.951729,
            -3978239767.163559,
            -652058231.6131363,
        ],
    ],
    [
        854323200000,
        [
            -1952740732.016924,
            -3979756828.848914,
            -653445181.2307202,
        ],
    ],
    [
        854928000000,
        [
            -1949696970.52016,
            -3981271222.389907,
            -654831313.1068702,
        ],
    ],
    [
        855532800000,
        [
            -1946651649.763416,
            -3982782885.001031,
            -656217047.5678307,
        ],
    ],
    [
        856137600000,
        [
            -1943604833.739058,
            -3984291935.694155,
            -657602809.7372328,
        ],
    ],
    [
        856742400000,
        [
            -1940556758.62243,
            -3985798632.640232,
            -658988879.0461808,
        ],
    ],
    [
        857347200000,
        [
            -1937507750.763441,
            -3987303281.99168,
            -660375291.2465228,
        ],
    ],
    [
        857952000000,
        [
            -1934458113.723413,
            -3988806130.715549,
            -661761826.0003276,
        ],
    ],
    [
        858556800000,
        [
            -1931408022.953432,
            -3990307280.157743,
            -663148083.8881731,
        ],
    ],
    [
        859161600000,
        [
            -1928357464.497381,
            -3991806650.671492,
            -664533627.2099135,
        ],
    ],
    [
        859766400000,
        [
            -1925306239.901194,
            -3993304009.936038,
            -665918134.7462429,
        ],
    ],
    [
        860371200000,
        [
            -1922254037.139733,
            -3994799054.229884,
            -667301514.334941,
        ],
    ],
    [
        860976000000,
        [
            -1919200542.70303,
            -3996291515.502059,
            -668683934.9271399,
        ],
    ],
    [
        861580800000,
        [
            -1916145552.948746,
            -3997781257.245543,
            -670065768.0257883,
        ],
    ],
    [
        862185600000,
        [
            -1913089046.165295,
            -3999268323.432452,
            -671447456.7802138,
        ],
    ],
    [
        862790400000,
        [
            -1910031190.461158,
            -4000752922.626186,
            -672829358.7790656,
        ],
    ],
    [
        863395200000,
        [
            -1906972284.533756,
            -4002235353.700288,
            -674211619.8699048,
        ],
    ],
    [
        864000000000,
        [
            -1903912653.169577,
            -4003715900.580131,
            -675594123.4345964,
        ],
    ],
    [
        864604800000,
        [
            -1900852534.150747,
            -4005194732.698211,
            -676976531.1432842,
        ],
    ],
    [
        865209600000,
        [
            -1897791995.136137,
            -4006671845.087401,
            -678358401.3136064,
        ],
    ],
    [
        865814400000,
        [
            -1894730910.170853,
            -4008147059.819817,
            -679739344.5958058,
        ],
    ],
    [
        866419200000,
        [
            -1891669004.768542,
            -4009620089.048168,
            -681119161.5463173,
        ],
    ],
    [
        867024000000,
        [
            -1888605952.807022,
            -4011090636.723167,
            -682497912.7940891,
        ],
    ],
    [
        867628800000,
        [
            -1885541490.94418,
            -4012558501.865807,
            -683875897.2461985,
        ],
    ],
    [
        868233600000,
        [
            -1882475512.991746,
            -4014023648.202173,
            -685253546.1410098,
        ],
    ],
    [
        868838400000,
        [
            -1879408109.659687,
            -4015486217.476633,
            -686631270.476725,
        ],
    ],
    [
        869443200000,
        [
            -1876339536.555671,
            -4016946479.40943,
            -688009315.6686375,
        ],
    ],
    [
        870048000000,
        [
            -1873270123.817866,
            -4018404735.465717,
            -689387675.169273,
        ],
    ],
    [
        870652800000,
        [
            -1870200161.15104,
            -4019861212.167956,
            -690766092.9138849,
        ],
    ],
    [
        871257600000,
        [
            -1867129797.688111,
            -4021315981.021916,
            -692144152.4701183,
        ],
    ],
    [
        871862400000,
        [
            -1864058990.689915,
            -4022768932.484595,
            -693521422.814918,
        ],
    ],
    [
        872467200000,
        [
            -1860987521.976096,
            -4024219814.073108,
            -694897610.2877438,
        ],
    ],
    [
        873072000000,
        [
            -1857915076.803535,
            -4025668319.5353,
            -696272662.0612825,
        ],
    ],
    [
        873676800000,
        [
            -1854841356.590622,
            -4027114197.041671,
            -697646784.4659581,
        ],
    ],
    [
        874281600000,
        [
            -1851766185.487032,
            -4028557338.511242,
            -699020370.6979582,
        ],
    ],
    [
        874886400000,
        [
            -1848689573.432019,
            -4029997818.503407,
            -700393862.3885899,
        ],
    ],
    [
        875491200000,
        [
            -1845611713.822172,
            -4031435867.268596,
            -701767592.6505945,
        ],
    ],
    [
        876096000000,
        [
            -1842532917.523268,
            -4032871789.114883,
            -703141668.1498734,
        ],
    ],
    [
        876700800000,
        [
            -1839453504.811541,
            -4034305856.701293,
            -704515932.9574213,
        ],
    ],
    [
        877305600000,
        [
            -1836373693.515277,
            -4035738216.510066,
            -705890024.13384,
        ],
    ],
    [
        877910400000,
        [
            -1833293523.236475,
            -4037168837.643824,
            -707263498.7889289,
        ],
    ],
    [
        878515200000,
        [
            -1830212842.030764,
            -4038597522.654304,
            -708635989.8931439,
        ],
    ],
    [
        879120000000,
        [
            -1827131360.940264,
            -4040023977.695341,
            -710007336.1943187,
        ],
    ],
    [
        879724800000,
        [
            -1824048757.123167,
            -4041447917.103025,
            -711377639.2142981,
        ],
    ],
    [
        880329600000,
        [
            -1820964788.451113,
            -4042869164.824586,
            -712747227.4741846,
        ],
    ],
    [
        880934400000,
        [
            -1817879379.619556,
            -4044287717.498305,
            -714116541.3457894,
        ],
    ],
    [
        881539200000,
        [
            -1814792649.64935,
            -4045703747.188861,
            -715485978.0016153,
        ],
    ],
    [
        882144000000,
        [
            -1811704869.577312,
            -4047117541.672095,
            -716855751.1627555,
        ],
    ],
    [
        882748800000,
        [
            -1808616365.405297,
            -4048529402.688917,
            -718225816.0792623,
        ],
    ],
    [
        883353600000,
        [
            -1805527403.723221,
            -4049939539.189054,
            -719595885.5928968,
        ],
    ],
    [
        883958400000,
        [
            -1802438099.610006,
            -4051347995.040402,
            -720965531.2118134,
        ],
    ],
    [
        884563200000,
        [
            -1799348375.454749,
            -4052754634.471037,
            -722334333.9014113,
        ],
    ],
    [
        885168000000,
        [
            -1796257986.974868,
            -4054159189.4374,
            -723702031.845808,
        ],
    ],
    [
        885772800000,
        [
            -1793166609.136904,
            -4055561353.667837,
            -725068612.7125592,
        ],
    ],
    [
        886377600000,
        [
            -1790073951.026266,
            -4056960890.219166,
            -726434317.4031699,
        ],
    ],
    [
        886982400000,
        [
            -1786979858.492976,
            -4058357714.319237,
            -727799554.7298373,
        ],
    ],
    [
        887587200000,
        [
            -1783884369.058798,
            -4059751922.942132,
            -729164757.2580833,
        ],
    ],
    [
        888192000000,
        [
            -1780787699.604662,
            -4061143760.410049,
            -730530227.9995027,
        ],
    ],
    [
        888796800000,
        [
            -1777690170.242873,
            -4062533531.507908,
            -731896032.7767203,
        ],
    ],
    [
        889401600000,
        [
            -1774592091.56031,
            -4063921493.569336,
            -733261977.4504641,
        ],
    ],
    [
        890006400000,
        [
            -1771493655.51151,
            -4065307765.90354,
            -734627676.7139308,
        ],
    ],
    [
        890611200000,
        [
            -1768394868.39626,
            -4066692286.514111,
            -735992688.3520142,
        ],
    ],
    [
        891216000000,
        [
            -1765295550.399025,
            -4068074832.294088,
            -737356667.7735447,
        ],
    ],
    [
        891820800000,
        [
            -1762195400.499531,
            -4069455097.997344,
            -738719489.987751,
        ],
    ],
    [
        892425600000,
        [
            -1759094103.249229,
            -4070832804.090581,
            -740081293.7225053,
        ],
    ],
    [
        893030400000,
        [
            -1755991440.7799,
            -4072207794.482589,
            -741442431.7026225,
        ],
    ],
    [
        893635200000,
        [
            -1752887370.853215,
            -4073580090.750539,
            -742803346.0109384,
        ],
    ],
    [
        894240000000,
        [
            -1749782043.754492,
            -4074949884.505257,
            -744164412.0077518,
        ],
    ],
    [
        894844800000,
        [
            -1746675751.209429,
            -4076317469.791424,
            -745525805.1392922,
        ],
    ],
    [
        895449600000,
        [
            -1743568824.862189,
            -4077683139.109862,
            -746887438.7946248,
        ],
    ],
    [
        896054400000,
        [
            -1740461521.00476,
            -4079047080.674481,
            -748248995.5308536,
        ],
    ],
    [
        896659200000,
        [
            -1737353932.468147,
            -4080409313.37219,
            -749610039.2266923,
        ],
    ],
    [
        897264000000,
        [
            -1734245957.0821,
            -4081769681.100401,
            -750970168.3578664,
        ],
    ],
    [
        897868800000,
        [
            -1731137333.483672,
            -4083127907.720659,
            -752329157.5938184,
        ],
    ],
    [
        898473600000,
        [
            -1728027734.542382,
            -4084483693.972842,
            -753687037.246879,
        ],
    ],
    [
        899078400000,
        [
            -1724916885.445769,
            -4085836824.163029,
            -755044082.5399766,
        ],
    ],
    [
        899683200000,
        [
            -1721804661.168581,
            -4087187243.749018,
            -756400717.0100023,
        ],
    ],
    [
        900288000000,
        [
            -1718691130.392578,
            -4088535079.211481,
            -757757363.8570292,
        ],
    ],
    [
        900892800000,
        [
            -1715576532.138723,
            -4089880594.083614,
            -759114296.6609409,
        ],
    ],
    [
        901497600000,
        [
            -1712461192.157884,
            -4091224096.275609,
            -760471542.3577367,
        ],
    ],
    [
        902102400000,
        [
            -1709345408.38952,
            -4092565829.662143,
            -761828872.0264435,
        ],
    ],
    [
        902707200000,
        [
            -1706229346.789478,
            -4093905888.932377,
            -763185882.261765,
        ],
    ],
    [
        903312000000,
        [
            -1703112983.922438,
            -4095244187.183985,
            -764542137.0847352,
        ],
    ],
    [
        903916800000,
        [
            -1699996115.506827,
            -4096580486.898554,
            -765897321.233004,
        ],
    ],
    [
        904521600000,
        [
            -1696878428.361309,
            -4097914484.241225,
            -767251351.9803344,
        ],
    ],
    [
        905126400000,
        [
            -1693759610.621383,
            -4099245917.114007,
            -768604408.8772308,
        ],
    ],
    [
        905731200000,
        [
            -1690639461.278439,
            -4100574657.094696,
            -769956869.6390343,
        ],
    ],
    [
        906336000000,
        [
            -1687517961.910947,
            -4101900753.626724,
            -771309176.2198632,
        ],
    ],
    [
        906940800000,
        [
            -1684395284.360358,
            -4103224417.580797,
            -772661679.7575268,
        ],
    ],
    [
        907545600000,
        [
            -1681271730.125609,
            -4104545947.786228,
            -774014516.8019626,
        ],
    ],
    [
        908150400000,
        [
            -1678147623.682729,
            -4105865624.98215,
            -775367560.4285183,
        ],
    ],
    [
        908755200000,
        [
            -1675023198.293441,
            -4107183612.081779,
            -776720464.9537554,
        ],
    ],
    [
        909360000000,
        [
            -1671898514.978033,
            -4108499896.77234,
            -778072787.7069893,
        ],
    ],
    [
        909964800000,
        [
            -1668773442.172312,
            -4109814295.727525,
            -779424144.0874578,
        ],
    ],
    [
        910569600000,
        [
            -1665647702.682179,
            -4111126518.670653,
            -780774342.7662067,
        ],
    ],
    [
        911174400000,
        [
            -1662520972.511774,
            -4112436270.836513,
            -782123453.5724828,
        ],
    ],
    [
        911779200000,
        [
            -1659392996.660718,
            -4113743357.632111,
            -783471782.7523735,
        ],
    ],
    [
        912384000000,
        [
            -1656263679.711578,
            -4115047753.72873,
            -784819764.6030055,
        ],
    ],
    [
        912988800000,
        [
            -1653133119.105927,
            -4116349611.82883,
            -786167808.539545,
        ],
    ],
    [
        913593600000,
        [
            -1650001571.800171,
            -4117649208.193489,
            -787516154.4834772,
        ],
    ],
    [
        914198400000,
        [
            -1646869366.273872,
            -4118946845.703845,
            -788864787.6939197,
        ],
    ],
    [
        914803200000,
        [
            -1643736787.473071,
            -4120242748.309932,
            -790213444.3293535,
        ],
    ],
    [
        915408000000,
        [
            -1640603976.292384,
            -4121536982.648833,
            -791561705.0485487,
        ],
    ],
    [
        916012800000,
        [
            -1637470880.820465,
            -4122829434.992898,
            -792909142.5759101,
        ],
    ],
    [
        916617600000,
        [
            -1634337275.38705,
            -4124119851.362494,
            -794255471.5497822,
        ],
    ],
    [
        917222400000,
        [
            -1631202840.541233,
            -4125407927.093801,
            -795600649.4190953,
        ],
    ],
    [
        917827200000,
        [
            -1628067276.78704,
            -4126693415.150723,
            -796944892.0459739,
        ],
    ],
    [
        918432000000,
        [
            -1624930411.358048,
            -4127976214.205522,
            -798288597.2175218,
        ],
    ],
    [
        919036800000,
        [
            -1621792259.461358,
            -4129256404.788613,
            -799632204.1184832,
        ],
    ],
    [
        919641600000,
        [
            -1618653019.006824,
            -4130534221.722648,
            -800976039.3542018,
        ],
    ],
    [
        920246400000,
        [
            -1615513000.817186,
            -4131809972.679505,
            -802320202.4123659,
        ],
    ],
    [
        920851200000,
        [
            -1612372518.312031,
            -4133083929.62258,
            -803664530.0397812,
        ],
    ],
    [
        921456000000,
        [
            -1609231777.551862,
            -4134356232.121556,
            -805008653.2808008,
        ],
    ],
    [
        922060800000,
        [
            -1606090805.833501,
            -4135626839.361575,
            -806352128.0851512,
        ],
    ],
    [
        922665600000,
        [
            -1602949441.642639,
            -4136895545.642251,
            -807694591.8475283,
        ],
    ],
    [
        923270400000,
        [
            -1599807390.423171,
            -4138162052.267027,
            -809035890.7841375,
        ],
    ],
    [
        923875200000,
        [
            -1596664328.061965,
            -4139426072.243338,
            -810376134.4371619,
        ],
    ],
    [
        924480000000,
        [
            -1593520015.85719,
            -4140687431.559557,
            -811715656.9085993,
        ],
    ],
    [
        925084800000,
        [
            -1590374385.196184,
            -4141946130.243331,
            -813054897.9701353,
        ],
    ],
    [
        925689600000,
        [
            -1587227561.619397,
            -4143202341.457672,
            -814394247.5102453,
        ],
    ],
    [
        926294400000,
        [
            -1584079820.983284,
            -4144456350.135675,
            -815733908.4974501,
        ],
    ],
    [
        926899200000,
        [
            -1580931493.266103,
            -4145708452.780981,
            -817073825.211508,
        ],
    ],
    [
        927504000000,
        [
            -1577782846.598445,
            -4146958852.907763,
            -818413702.4276377,
        ],
    ],
    [
        928108800000,
        [
            -1574633992.329802,
            -4148207588.83748,
            -819753109.4539114,
        ],
    ],
    [
        928713600000,
        [
            -1571484846.381023,
            -4149454518.908855,
            -821091631.0864277,
        ],
    ],
    [
        929318400000,
        [
            -1568335161.072389,
            -4150699370.561913,
            -822429012.7575364,
        ],
    ],
    [
        929923200000,
        [
            -1565184613.274452,
            -4151941836.715572,
            -823765250.6859429,
        ],
    ],
    [
        930528000000,
        [
            -1562032918.718827,
            -4153181684.248152,
            -825100593.8305508,
        ],
    ],
    [
        931132800000,
        [
            -1558879933.584663,
            -4154418836.044068,
            -826435455.3370972,
        ],
    ],
    [
        931737600000,
        [
            -1555725706.409865,
            -4155653397.477257,
            -827770265.6599452,
        ],
    ],
    [
        932342400000,
        [
            -1552570461.966003,
            -4156885618.621261,
            -829105320.747717,
        ],
    ],
    [
        932947200000,
        [
            -1549414523.779329,
            -4158115806.428389,
            -830440678.1667897,
        ],
    ],
    [
        933552000000,
        [
            -1546258202.088306,
            -4159344217.174515,
            -831776136.49309,
        ],
    ],
    [
        934156800000,
        [
            -1543101685.990741,
            -4160570966.595929,
            -833111306.1051629,
        ],
    ],
    [
        934761600000,
        [
            -1539944978.181656,
            -4161795990.078479,
            -834445746.9855871,
        ],
    ],
    [
        935366400000,
        [
            -1536787895.000823,
            -4163019066.822943,
            -835779124.055134,
        ],
    ],
    [
        935971200000,
        [
            -1533630131.010643,
            -4164239897.759175,
            -837111324.9156256,
        ],
    ],
    [
        936576000000,
        [
            -1530471367.702777,
            -4165458210.471603,
            -838442499.6312399,
        ],
    ],
    [
        937180800000,
        [
            -1527311388.371019,
            -4166673857.230113,
            -839773008.7117335,
        ],
    ],
    [
        937785600000,
        [
            -1524150155.214904,
            -4167886869.269552,
            -841103296.0790771,
        ],
    ],
    [
        938390400000,
        [
            -1520987821.964196,
            -4169097446.075012,
            -842433732.2766466,
        ],
    ],
    [
        938995200000,
        [
            -1517824679.517358,
            -4170305885.300411,
            -843764484.5246156,
        ],
    ],
    [
        939600000000,
        [
            -1514661054.180042,
            -4171512478.914846,
            -845095458.2513751,
        ],
    ],
    [
        940204800000,
        [
            -1511497193.192067,
            -4172717411.190633,
            -846426330.2244103,
        ],
    ],
    [
        940809600000,
        [
            -1508333177.69627,
            -4173920694.433111,
            -847756662.6147014,
        ],
    ],
    [
        941414400000,
        [
            -1505168894.396276,
            -4175122165.589327,
            -849086057.6334598,
        ],
    ],
    [
        942019200000,
        [
            -1502004075.623988,
            -4176321544.672189,
            -850414297.643591,
        ],
    ],
    [
        942624000000,
        [
            -1498838392.917728,
            -4177518534.082809,
            -851741422.1886371,
        ],
    ],
    [
        943228800000,
        [
            -1495671571.552594,
            -4178712924.212224,
            -853067715.1013737,
        ],
    ],
    [
        943833600000,
        [
            -1492503487.027857,
            -4179904667.28182,
            -854393604.0642885,
        ],
    ],
    [
        944438400000,
        [
            -1489334209.933552,
            -4181093893.760159,
            -855719508.4005287,
        ],
    ],
    [
        945043200000,
        [
            -1486163980.642447,
            -4182280866.779667,
            -857045691.4624932,
        ],
    ],
    [
        945648000000,
        [
            -1482993123.291973,
            -4183465889.666496,
            -858372168.743251,
        ],
    ],
    [
        946252800000,
        [
            -1479821931.28582,
            -4184649198.836655,
            -859698702.0305163,
        ],
    ],
    [
        946857600000,
        [
            -1476650563.795729,
            -4185830879.694412,
            -861024882.4564073,
        ],
    ],
    [
        947462400000,
        [
            -1473478989.758378,
            -4187010835.841152,
            -862350274.2490393,
        ],
    ],
    [
        948067200000,
        [
            -1470306999.396973,
            -4188188822.711738,
            -863674567.8495129,
        ],
    ],
    [
        948672000000,
        [
            -1467134278.583742,
            -4189364533.179163,
            -864997688.215036,
        ],
    ],
    [
        949276800000,
        [
            -1463960519.815171,
            -4190537705.174441,
            -866319821.2873005,
        ],
    ],
    [
        949881600000,
        [
            -1460785531.586385,
            -4191708214.398117,
            -867641348.9202652,
        ],
    ],
    [
        950486400000,
        [
            -1457609306.767069,
            -4192876118.785923,
            -868962713.7926046,
        ],
    ],
    [
        951091200000,
        [
            -1454432024.6043,
            -4194041637.250204,
            -870284262.2089037,
        ],
    ],
    [
        951696000000,
        [
            -1451253987.876057,
            -4195205070.616111,
            -871606121.4173319,
        ],
    ],
    [
        952300800000,
        [
            -1448075518.548891,
            -4196366696.001554,
            -872928155.2039645,
        ],
    ],
    [
        952905600000,
        [
            -1444896845.348198,
            -4197526670.441191,
            -874250011.9451988,
        ],
    ],
    [
        953510400000,
        [
            -1441718023.034286,
            -4198684975.319215,
            -875571248.1204028,
        ],
    ],
    [
        954115200000,
        [
            -1438538913.714853,
            -4199841422.581941,
            -876891484.4944237,
        ],
    ],
    [
        954720000000,
        [
            -1435359236.683517,
            -4200995721.100852,
            -878210539.3198988,
        ],
    ],
    [
        955324800000,
        [
            -1432178668.161392,
            -4202147579.12855,
            -879528491.9043715,
        ],
    ],
    [
        955929600000,
        [
            -1428996956.176921,
            -4203296807.284589,
            -880845655.2071369,
        ],
    ],
    [
        956534400000,
        [
            -1425814010.913652,
            -4204443386.357245,
            -882162465.8957275,
        ],
    ],
    [
        957139200000,
        [
            -1422629937.634949,
            -4205587475.012668,
            -883479329.7888992,
        ],
    ],
    [
        957744000000,
        [
            -1419444999.654444,
            -4206729354.336948,
            -884796478.6980163,
        ],
    ],
    [
        958348800000,
        [
            -1416259524.913806,
            -4207869329.417227,
            -886113889.7150493,
        ],
    ],
    [
        958953600000,
        [
            -1413073790.344459,
            -4209007621.957547,
            -887431293.3327824,
        ],
    ],
    [
        959558400000,
        [
            -1409887925.67338,
            -4210144291.91405,
            -888748267.5236105,
        ],
    ],
    [
        960163200000,
        [
            -1406701868.468712,
            -4211279217.531905,
            -890064386.9317663,
        ],
    ],
    [
        960768000000,
        [
            -1403515385.539615,
            -4212412139.322055,
            -891379373.4227039,
        ],
    ],
    [
        961372800000,
        [
            -1400328154.697214,
            -4213542751.542986,
            -892693193.6539171,
        ],
    ],
    [
        961977600000,
        [
            -1397139877.901392,
            -4214670809.380265,
            -894006070.4668363,
        ],
    ],
    [
        962582400000,
        [
            -1393950386.428577,
            -4215796215.170872,
            -895318404.8121184,
        ],
    ],
    [
        963187200000,
        [
            -1390759701.17546,
            -4216919053.312831,
            -896630634.1818255,
        ],
    ],
    [
        963792000000,
        [
            -1387568025.619508,
            -4218039560.377259,
            -897943077.3683418,
        ],
    ],
    [
        964396800000,
        [
            -1384375673.843023,
            -4219158041.156902,
            -899255821.9581202,
        ],
    ],
    [
        965001600000,
        [
            -1381182960.171597,
            -4220274761.496934,
            -900568694.1442041,
        ],
    ],
    [
        965606400000,
        [
            -1377990088.83074,
            -4221389855.307027,
            -901881319.8881401,
        ],
    ],
    [
        966211200000,
        [
            -1374797081.161016,
            -4222503276.866069,
            -903193256.1169605,
        ],
    ],
    [
        966816000000,
        [
            -1371603768.17951,
            -4223614815.363273,
            -904504146.2418631,
        ],
    ],
    [
        967420800000,
        [
            -1368409852.240124,
            -4224724169.155023,
            -905813845.4887928,
        ],
    ],
    [
        968025600000,
        [
            -1365215012.535355,
            -4225831052.845286,
            -907122471.7991153,
        ],
    ],
    [
        968630400000,
        [
            -1362019017.597632,
            -4226935297.415125,
            -908430364.2995011,
        ],
    ],
    [
        969235200000,
        [
            -1358821807.546566,
            -4228036909.460021,
            -909737963.8152181,
        ],
    ],
    [
        969840000000,
        [
            -1355623516.584171,
            -4229136068.806244,
            -911045656.6425549,
        ],
    ],
    [
        970444800000,
        [
            -1352424426.536972,
            -4230233064.637938,
            -912353637.4774034,
        ],
    ],
    [
        971049600000,
        [
            -1349224868.228489,
            -4231328193.265595,
            -913661841.0073476,
        ],
    ],
    [
        971654400000,
        [
            -1346025106.39038,
            -4232421654.328815,
            -914969965.3278139,
        ],
    ],
    [
        972259200000,
        [
            -1342825247.863556,
            -4233513481.194301,
            -916277577.84564,
        ],
    ],
    [
        972864000000,
        [
            -1339625204.539906,
            -4234603529.725978,
            -917584267.7499603,
        ],
    ],
    [
        973468800000,
        [
            -1336424724.538857,
            -4235691530.046008,
            -918889791.5856223,
        ],
    ],
    [
        974073600000,
        [
            -1333223481.115365,
            -4236777181.948836,
            -920194158.8053641,
        ],
    ],
    [
        974678400000,
        [
            -1330021189.059219,
            -4237860260.220831,
            -921497627.508887,
        ],
    ],
    [
        975283200000,
        [
            -1326817706.475419,
            -4238940695.314626,
            -922800614.3104477,
        ],
    ],
    [
        975888000000,
        [
            -1323613084.878803,
            -4240018599.725897,
            -924103548.3454744,
        ],
    ],
    [
        976492800000,
        [
            -1320407550.759283,
            -4241094228.87638,
            -925406719.4813133,
        ],
    ],
    [
        977097600000,
        [
            -1317201425.337958,
            -4242167890.942103,
            -926710175.9103096,
        ],
    ],
    [
        977702400000,
        [
            -1313995011.3735,
            -4243239838.628057,
            -928013707.7502551,
        ],
    ],
    [
        978307200000,
        [
            -1310788487.006523,
            -4244310181.04135,
            -929316921.0724591,
        ],
    ],
    [
        978912000000,
        [
            -1307581842.965433,
            -4245378845.664079,
            -930619376.1964498,
        ],
    ],
    [
        979516800000,
        [
            -1304374885.359719,
            -4246445604.111755,
            -931920742.9022567,
        ],
    ],
    [
        980121600000,
        [
            -1301167303.960461,
            -4247510153.472346,
            -933220917.4485,
        ],
    ],
    [
        980726400000,
        [
            -1297958781.258372,
            -4248572224.087965,
            -934520059.0800618,
        ],
    ],
    [
        981331200000,
        [
            -1294749102.657306,
            -4249631674.470432,
            -935818533.611974,
        ],
    ],
    [
        981936000000,
        [
            -1291538231.055565,
            -4250688539.95006,
            -937116784.2831411,
        ],
    ],
    [
        982540800000,
        [
            -1288326321.156007,
            -4251743020.124288,
            -938415174.9994123,
        ],
    ],
    [
        983145600000,
        [
            -1285113664.675735,
            -4252795409.111265,
            -939713861.7795568,
        ],
    ],
    [
        983750400000,
        [
            -1281900585.832751,
            -4253845991.266272,
            -941012737.8660768,
        ],
    ],
    [
        984355200000,
        [
            -1278687326.615246,
            -4254894940.204426,
            -942311471.27758,
        ],
    ],
    [
        984960000000,
        [
            -1275473961.815043,
            -4255942256.85995,
            -943609620.6960243,
        ],
    ],
    [
        985564800000,
        [
            -1272260372.531332,
            -4256987767.830338,
            -944906789.9849185,
        ],
    ],
    [
        986169600000,
        [
            -1269046288.203445,
            -4258031185.457593,
            -946202767.7599051,
        ],
    ],
    [
        986774400000,
        [
            -1265831382.91179,
            -4259072208.821905,
            -947497601.6397277,
        ],
    ],
    [
        987379200000,
        [
            -1262615391.227223,
            -4260110629.334677,
            -948791580.5110636,
        ],
    ],
    [
        987984000000,
        [
            -1259398202.199329,
            -4261146403.621856,
            -950085132.2900904,
        ],
    ],
    [
        988588800000,
        [
            -1256179898.769497,
            -4262179668.71143,
            -951378673.3125088,
        ],
    ],
    [
        989193600000,
        [
            -1252960728.69765,
            -4263210692.92419,
            -952672460.7501348,
        ],
    ],
    [
        989798400000,
        [
            -1249741018.465591,
            -4264239779.445871,
            -953966500.615948,
        ],
    ],
    [
        990403200000,
        [
            -1246521060.266172,
            -4265267159.540136,
            -955260545.9596236,
        ],
    ],
    [
        991008000000,
        [
            -1243301010.105736,
            -4266292912.121601,
            -956554184.2975175,
        ],
    ],
    [
        991612800000,
        [
            -1240080833.341499,
            -4267316935.626537,
            -957846981.9231391,
        ],
    ],
    [
        992217600000,
        [
            -1236860317.319317,
            -4268338982.798019,
            -959138636.2932762,
        ],
    ],
    [
        992822400000,
        [
            -1233639147.581397,
            -4269358747.736423,
            -960429083.0910347,
        ],
    ],
    [
        993427200000,
        [
            -1230417020.559123,
            -4270375974.304034,
            -961718518.6828004,
        ],
    ],
    [
        994032000000,
        [
            -1227193751.895772,
            -4271390546.656053,
            -963007330.219747,
        ],
    ],
    [
        994636800000,
        [
            -1223969342.354412,
            -4272402530.325403,
            -964295959.3196084,
        ],
    ],
    [
        995241600000,
        [
            -1220743978.823057,
            -4273412150.108118,
            -965584746.8013382,
        ],
    ],
    [
        995846400000,
        [
            -1217517969.195973,
            -4274419711.955494,
            -966873812.607811,
        ],
    ],
    [
        996451200000,
        [
            -1214291633.348188,
            -4275425495.752811,
            -968163013.9307082,
        ],
    ],
    [
        997056000000,
        [
            -1211065190.393117,
            -4276429656.530758,
            -969451995.7153972,
        ],
    ],
    [
        997660800000,
        [
            -1207838683.525908,
            -4277432170.376514,
            -970740315.2313964,
        ],
    ],
    [
        998265600000,
        [
            -1204611965.316256,
            -4278432844.232402,
            -972027598.0415616,
        ],
    ],
    [
        998870400000,
        [
            -1201384748.346421,
            -4279431384.440931,
            -973313670.8149102,
        ],
    ],
    [
        999475200000,
        [
            -1198156706.274899,
            -4280427500.692306,
            -974598623.0414313,
        ],
    ],
    [
        1000080000000,
        [
            -1194927589.324308,
            -4281421008.822288,
            -975882774.9514616,
        ],
    ],
    [
        1000684800000,
        [
            -1191697312.162637,
            -4282411895.581864,
            -977166563.9670894,
        ],
    ],
    [
        1001289600000,
        [
            -1188465983.760888,
            -4283400323.272112,
            -978450390.7436446,
        ],
    ],
    [
        1001894400000,
        [
            -1185233869.231512,
            -4284386572.896559,
            -979734477.9071344,
        ],
    ],
    [
        1002499200000,
        [
            -1182001296.330105,
            -4285370945.169046,
            -981018791.2473204,
        ],
    ],
    [
        1003104000000,
        [
            -1178768539.675712,
            -4286353654.699033,
            -982303052.1545768,
        ],
    ],
    [
        1003708800000,
        [
            -1175535723.789812,
            -4287334755.109983,
            -983586836.2040579,
        ],
    ],
    [
        1004313600000,
        [
            -1172302778.368593,
            -4288314119.81392,
            -984869721.750031,
        ],
    ],
    [
        1004918400000,
        [
            -1169069462.672458,
            -4289291484.599335,
            -986151437.2495276,
        ],
    ],
    [
        1005523200000,
        [
            -1165835451.424596,
            -4290266540.554776,
            -987431957.4676088,
        ],
    ],
    [
        1006128000000,
        [
            -1162600449.783311,
            -4291239044.061448,
            -988711512.9542891,
        ],
    ],
    [
        1006732800000,
        [
            -1159364296.978694,
            -4292208902.36943,
            -989990507.8213549,
        ],
    ],
    [
        1007337600000,
        [
            -1156127022.722146,
            -4293176205.0345,
            -991269376.3943783,
        ],
    ],
    [
        1007942400000,
        [
            -1152888837.167272,
            -4294141191.594523,
            -992548429.9281914,
        ],
    ],
    [
        1008547200000,
        [
            -1149650057.723425,
            -4295104166.77136,
            -993827746.3337924,
        ],
    ],
    [
        1009152000000,
        [
            -1146410997.790736,
            -4296065392.513945,
            -995107142.2313262,
        ],
    ],
    [
        1009756800000,
        [
            -1143171857.160097,
            -4297024995.537086,
            -996386237.7693979,
        ],
    ],
    [
        1010361600000,
        [
            -1139932653.049513,
            -4297982923.219049,
            -997664590.2727041,
        ],
    ],
    [
        1010966400000,
        [
            -1136693214.722898,
            -4298938962.412297,
            -998941849.3900543,
        ],
    ],
    [
        1011571200000,
        [
            -1133453242.905785,
            -4299892814.254237,
            -1000217880.755231,
        ],
    ],
    [
        1012176000000,
        [
            -1130212415.186657,
            -4300844198.895587,
            -1001492813.711817,
        ],
    ],
    [
        1012780800000,
        [
            -1126970501.9496,
            -4301792954.079341,
            -1002766994.992992,
        ],
    ],
    [
        1013385600000,
        [
            -1123727448.703899,
            -4302739093.411798,
            -1004040866.110559,
        ],
    ],
    [
        1013990400000,
        [
            -1120483394.629319,
            -4303682801.974021,
            -1005314808.024098,
        ],
    ],
    [
        1014595200000,
        [
            -1117238623.418432,
            -4304624371.032129,
            -1006589006.897201,
        ],
    ],
    [
        1015200000000,
        [
            -1113993463.659349,
            -4305564095.213728,
            -1007863388.027503,
        ],
    ],
    [
        1015804800000,
        [
            -1110748173.302773,
            -4306502168.526524,
            -1009137642.13016,
        ],
    ],
    [
        1016409600000,
        [
            -1107502849.394227,
            -4307438616.373785,
            -1010411334.618889,
        ],
    ],
    [
        1017014400000,
        [
            -1104257394.722279,
            -4308373287.182216,
            -1011684058.249299,
        ],
    ],
    [
        1017619200000,
        [
            -1101011552.072408,
            -4309305905.69855,
            -1012955575.910655,
        ],
    ],
    [
        1018224000000,
        [
            -1097764994.484311,
            -4310236170.008542,
            -1014225904.876334,
        ],
    ],
    [
        1018828800000,
        [
            -1094517440.541085,
            -4311163858.993177,
            -1015495311.645346,
        ],
    ],
    [
        1019433600000,
        [
            -1091268753.008838,
            -4312088910.580591,
            -1016764217.40476,
        ],
    ],
    [
        1020038400000,
        [
            -1088018986.754889,
            -4313011442.005424,
            -1018033048.174178,
        ],
    ],
    [
        1020643200000,
        [
            -1084768370.362761,
            -4313931708.103468,
            -1019302084.638185,
        ],
    ],
    [
        1021248000000,
        [
            -1081517225.568959,
            -4314850012.397553,
            -1020571363.590313,
        ],
    ],
    [
        1021852800000,
        [
            -1078265852.812527,
            -4315766599.595266,
            -1021840664.56523,
        ],
    ],
    [
        1022457600000,
        [
            -1075014424.909339,
            -4316681568.277328,
            -1023109587.301263,
        ],
    ],
    [
        1023062400000,
        [
            -1071762926.723037,
            -4317594835.594302,
            -1024377692.384511,
        ],
    ],
    [
        1023667200000,
        [
            -1068511161.151681,
            -4318506165.751506,
            -1025644654.874203,
        ],
    ],
    [
        1024272000000,
        [
            -1065258818.601389,
            -4319415251.797841,
            -1026910378.038747,
        ],
    ],
    [
        1024876800000,
        [
            -1062005586.576085,
            -4320321823.045896,
            -1028175027.805275,
        ],
    ],
    [
        1025481600000,
        [
            -1058751261.248878,
            -4321225740.577039,
            -1029438974.170082,
        ],
    ],
    [
        1026086400000,
        [
            -1055495820.370023,
            -4322127046.167783,
            -1030702659.82317,
        ],
    ],
    [
        1026691200000,
        [
            -1052239430.883013,
            -4323025946.945067,
            -1031966443.697363,
        ],
    ],
    [
        1027296000000,
        [
            -1048982390.0293,
            -4323922741.178617,
            -1033230474.214611,
        ],
    ],
    [
        1027900800000,
        [
            -1045725022.638081,
            -4324817711.960146,
            -1034494635.859467,
        ],
    ],
    [
        1028505600000,
        [
            -1042467568.517139,
            -4325711027.699832,
            -1035758589.757854,
        ],
    ],
    [
        1029110400000,
        [
            -1039210098.354203,
            -4326602683.289822,
            -1037021893.704128,
        ],
    ],
    [
        1029715200000,
        [
            -1035952489.759996,
            -4327492501.911726,
            -1038284157.579004,
        ],
    ],
    [
        1030320000000,
        [
            -1032694471.458508,
            -4328380196.777124,
            -1039545179.654183,
        ],
    ],
    [
        1030924800000,
        [
            -1029435719.624919,
            -4329265471.554235,
            -1040805017.594122,
        ],
    ],
    [
        1031529600000,
        [
            -1026175973.501226,
            -4330148125.200951,
            -1042063968.751078,
        ],
    ],
    [
        1032134400000,
        [
            -1022915129.189586,
            -4331028123.694582,
            -1043322465.072057,
        ],
    ],
    [
        1032739200000,
        [
            -1019653277.457419,
            -4331905612.453438,
            -1044580920.211528,
        ],
    ],
    [
        1033344000000,
        [
            -1016390672.434692,
            -4332780865.616971,
            -1045839584.088545,
        ],
    ],
    [
        1033948800000,
        [
            -1013127642.751398,
            -4333654190.769966,
            -1047098455.505985,
        ],
    ],
    [
        1034553600000,
        [
            -1009864475.45933,
            -4334525821.331112,
            -1048357282.538278,
        ],
    ],
    [
        1035158400000,
        [
            -1006601314.731256,
            -4335395833.657122,
            -1049615650.955616,
        ],
    ],
    [
        1035763200000,
        [
            -1003338112.809384,
            -4336264120.800216,
            -1050873130.516905,
        ],
    ],
    [
        1036368000000,
        [
            -1000074647.570061,
            -4337130432.280694,
            -1052129426.965941,
        ],
    ],
    [
        1036972800000,
        [
            -996810599.6118405,
            -4337994462.788813,
            -1053384485.471846,
        ],
    ],
    [
        1037577600000,
        [
            -993545663.8572171,
            -4338855959.526371,
            -1054638510.40635,
        ],
    ],
    [
        1038182400000,
        [
            -990279657.3348795,
            -4339714811.840577,
            -1055891893.65805,
        ],
    ],
    [
        1038787200000,
        [
            -987012583.9432385,
            -4340571090.627611,
            -1057145075.776633,
        ],
    ],
    [
        1039392000000,
        [
            -983744632.5437086,
            -4341425023.049103,
            -1058398390.170877,
        ],
    ],
    [
        1039996800000,
        [
            -980476110.0085773,
            -4342276912.424645,
            -1059651945.971889,
        ],
    ],
    [
        1040601600000,
        [
            -977207333.2087088,
            -4343127031.725304,
            -1060905589.491738,
        ],
    ],
    [
        1041206400000,
        [
            -973938516.9367596,
            -4343975527.439243,
            -1062158958.000203,
        ],
    ],
    [
        1041811200000,
        [
            -970669697.0532119,
            -4344822367.870016,
            -1063411607.82022,
        ],
    ],
    [
        1042416000000,
        [
            -967400716.771357,
            -4345667353.598461,
            -1064663170.430604,
        ],
    ],
    [
        1043020800000,
        [
            -964131282.4382226,
            -4346510186.21839,
            -1065913480.823659,
        ],
    ],
    [
        1043625600000,
        [
            -960861067.6636719,
            -4347350573.016935,
            -1067162635.210985,
        ],
    ],
    [
        1044230400000,
        [
            -957589827.6868677,
            -4348188330.186015,
            -1068410957.75216,
        ],
    ],
    [
        1044835200000,
        [
            -954317485.5165648,
            -4349023447.016236,
            -1069658885.750703,
        ],
    ],
    [
        1045440000000,
        [
            -951044159.2731086,
            -4349856088.305732,
            -1070906814.033036,
        ],
    ],
    [
        1046044800000,
        [
            -947770120.6573632,
            -4350686534.677502,
            -1072154955.089305,
        ],
    ],
    [
        1046649600000,
        [
            -944495700.0962269,
            -4351515082.881355,
            -1073403264.110333,
        ],
    ],
    [
        1047254400000,
        [
            -941221171.6309006,
            -4352341940.690593,
            -1074651453.859814,
        ],
    ],
    [
        1047859200000,
        [
            -937946657.1781298,
            -4353167152.742721,
            -1075899095.073139,
        ],
    ],
    [
        1048464000000,
        [
            -934672084.5713613,
            -4353990584.362384,
            -1077145767.830244,
        ],
    ],
    [
        1049068800000,
        [
            -931397214.2900788,
            -4354811969.367354,
            -1078391209.484889,
        ],
    ],
    [
        1049673600000,
        [
            -928121724.1132948,
            -4355631003.614911,
            -1079635406.521235,
        ],
    ],
    [
        1050278400000,
        [
            -924845322.8618808,
            -4356447450.559013,
            -1080878598.662158,
        ],
    ],
    [
        1050883200000,
        [
            -921567855.5935965,
            -4357261224.224448,
            -1082121194.17602,
        ],
    ],
    [
        1051488000000,
        [
            -918289360.1406946,
            -4358072420.783707,
            -1083363625.87767,
        ],
    ],
    [
        1052092800000,
        [
            -915010053.7022675,
            -4358881284.700284,
            -1084606198.193726,
        ],
    ],
    [
        1052697600000,
        [
            -911730256.4769974,
            -4359688121.978692,
            -1085848979.983635,
        ],
    ],
    [
        1053302400000,
        [
            -908450280.1653241,
            -4360493192.498204,
            -1087091780.286731,
        ],
    ],
    [
        1053907200000,
        [
            -905170319.4018531,
            -4361296618.568663,
            -1088334214.839601,
        ],
    ],
    [
        1054512000000,
        [
            -901890383.7793351,
            -4362098341.639098,
            -1089575841.262013,
        ],
    ],
    [
        1055116800000,
        [
            -898610295.3620253,
            -4362898143.302288,
            -1090816315.448833,
        ],
    ],
    [
        1055721600000,
        [
            -895329752.6292274,
            -4363695723.095201,
            -1092055512.791466,
        ],
    ],
    [
        1056326400000,
        [
            -892048437.2421093,
            -4364490804.919185,
            -1093293571.859961,
        ],
    ],
    [
        1056931200000,
        [
            -888766125.9868225,
            -4365283235.002248,
            -1094530846.267705,
        ],
    ],
    [
        1057536000000,
        [
            -885482769.1129713,
            -4366073036.436846,
            -1095767780.088289,
        ],
    ],
    [
        1058140800000,
        [
            -882198508.4614029,
            -4366860400.091421,
            -1097004750.012442,
        ],
    ],
    [
        1058745600000,
        [
            -878913628.440321,
            -4367645617.380226,
            -1098241932.514114,
        ],
    ],
    [
        1059350400000,
        [
            -875628455.4991624,
            -4368428978.603471,
            -1099479242.774034,
        ],
    ],
    [
        1059955200000,
        [
            -872343242.8640201,
            -4369210670.918624,
            -1100716364.328641,
        ],
    ],
    [
        1060560000000,
        [
            -869058081.1204413,
            -4369990711.595492,
            -1101952859.510161,
        ],
    ],
    [
        1061164800000,
        [
            -865772866.1311871,
            -4370768941.003533,
            -1103188323.42449,
        ],
    ],
    [
        1061769600000,
        [
            -862487336.2467319,
            -4371545078.566758,
            -1104422526.722398,
        ],
    ],
    [
        1062374400000,
        [
            -859201165.3072207,
            -4372318821.458836,
            -1105655495.832879,
        ],
    ],
    [
        1062979200000,
        [
            -855914078.0031122,
            -4373089950.75857,
            -1106887503.123142,
        ],
    ],
    [
        1063584000000,
        [
            -852625947.6049503,
            -4373858408.472918,
            -1108118971.025599,
        ],
    ],
    [
        1064188800000,
        [
            -849336841.5183034,
            -4374624318.330659,
            -1109350322.785773,
        ],
    ],
    [
        1064793600000,
        [
            -846046997.161379,
            -4375387941.761291,
            -1110581832.588341,
        ],
    ],
    [
        1065398400000,
        [
            -842756737.7552323,
            -4376149584.074928,
            -1111813528.571207,
        ],
    ],
    [
        1066003200000,
        [
            -839466360.6042457,
            -4376909486.195542,
            -1113045182.714745,
        ],
    ],
    [
        1066608000000,
        [
            -836176034.3812062,
            -4377667740.82088,
            -1114276390.742486,
        ],
    ],
    [
        1067212800000,
        [
            -832885739.3943563,
            -4378424259.595668,
            -1115506714.098675,
        ],
    ],
    [
        1067817600000,
        [
            -829595274.5351985,
            -4379178803.443044,
            -1116735834.555269,
        ],
    ],
    [
        1068422400000,
        [
            -826304329.377144,
            -4379931066.64367,
            -1117963666.22199,
        ],
    ],
    [
        1069027200000,
        [
            -823012594.8923633,
            -4380680784.474909,
            -1119190385.144268,
        ],
    ],
    [
        1069632000000,
        [
            -819719873.3694909,
            -4381427826.368579,
            -1120416367.061995,
        ],
    ],
    [
        1070236800000,
        [
            -816426149.4785572,
            -4382172242.361418,
            -1121642055.000642,
        ],
    ],
    [
        1070841600000,
        [
            -813131596.9592348,
            -4382914245.946612,
            -1122867802.568449,
        ],
    ],
    [
        1071446400000,
        [
            -809836517.905717,
            -4383654139.087148,
            -1124093749.229928,
        ],
    ],
    [
        1072051200000,
        [
            -806541236.426272,
            -4384392206.591559,
            -1125319772.161694,
        ],
    ],
    [
        1072656000000,
        [
            -803245984.5590233,
            -4385128616.623748,
            -1126545529.844763,
        ],
    ],
    [
        1073260800000,
        [
            -799950821.1948683,
            -4385863360.821609,
            -1127770580.962988,
        ],
    ],
    [
        1073865600000,
        [
            -796655612.4697695,
            -4386596257.253274,
            -1128994539.660047,
        ],
    ],
    [
        1074470400000,
        [
            -793360078.8664325,
            -4387327015.920573,
            -1130217212.768228,
        ],
    ],
    [
        1075075200000,
        [
            -790063893.3423886,
            -4388055341.685609,
            -1131438668.06283,
        ],
    ],
    [
        1075680000000,
        [
            -786766796.3216102,
            -4388781038.045568,
            -1132659209.768632,
        ],
    ],
    [
        1076284800000,
        [
            -783468687.1216768,
            -4389504076.182803,
            -1133879271.306451,
        ],
    ],
    [
        1076889600000,
        [
            -780169659.855769,
            -4390224605.338926,
            -1135099262.218601,
        ],
    ],
    [
        1077494400000,
        [
            -776869970.2243167,
            -4390942899.952502,
            -1136319423.022723,
        ],
    ],
    [
        1078099200000,
        [
            -773569944.9293976,
            -4391659262.384644,
            -1137539740.472391,
        ],
    ],
    [
        1078704000000,
        [
            -770269866.709303,
            -4392373916.535718,
            -1138759952.857002,
        ],
    ],
    [
        1079308800000,
        [
            -766969875.2186991,
            -4393086929.590637,
            -1139979641.926353,
        ],
    ],
    [
        1079913600000,
        [
            -763669916.9164057,
            -4393798188.015774,
            -1141198379.385101,
        ],
    ],
    [
        1080518400000,
        [
            -760369762.4384501,
            -4394507435.763128,
            -1142415877.313149,
        ],
    ],
    [
        1081123200000,
        [
            -757069088.3887835,
            -4395214363.043478,
            -1143632089.227911,
        ],
    ],
    [
        1081728000000,
        [
            -753767592.7664046,
            -4395918715.888573,
            -1144847226.202029,
        ],
    ],
    [
        1082332800000,
        [
            -750465100.8641418,
            -4396620385.342212,
            -1146061682.127708,
        ],
    ],
    [
        1082937600000,
        [
            -747161626.6441396,
            -4397319444.70612,
            -1147275894.457411,
        ],
    ],
    [
        1083542400000,
        [
            -743857368.6125993,
            -4398016122.564947,
            -1148490188.85182,
        ],
    ],
    [
        1084147200000,
        [
            -740552640.411468,
            -4398710720.671755,
            -1149704663.218675,
        ],
    ],
    [
        1084752000000,
        [
            -737247760.954938,
            -4399403506.311139,
            -1150919153.18029,
        ],
    ],
    [
        1085356800000,
        [
            -733942943.7908977,
            -4400094617.830674,
            -1152133290.032673,
        ],
    ],
    [
        1085961600000,
        [
            -730638223.7836726,
            -4400784015.658087,
            -1153346629.465268,
        ],
    ],
    [
        1086566400000,
        [
            -727333445.8606578,
            -4401471495.470537,
            -1154558807.258048,
        ],
    ],
    [
        1087171200000,
        [
            -724028320.4152684,
            -4402156759.968634,
            -1155769668.063984,
        ],
    ],
    [
        1087776000000,
        [
            -720722526.0835652,
            -4402839523.654625,
            -1156979320.304029,
        ],
    ],
    [
        1088380800000,
        [
            -717415824.3931546,
            -4403519612.285319,
            -1158188096.775856,
        ],
    ],
    [
        1088985600000,
        [
            -714108146.4755439,
            -4404197023.933351,
            -1159396436.838775,
        ],
    ],
    [
        1089590400000,
        [
            -710799619.0536445,
            -4404871930.977793,
            -1160604732.034351,
        ],
    ],
    [
        1090195200000,
        [
            -707490520.3396314,
            -4405544619.671659,
            -1161813187.624569,
        ],
    ],
    [
        1090800000000,
        [
            -704181182.4382743,
            -4406215388.613283,
            -1163021749.854106,
        ],
    ],
    [
        1091404800000,
        [
            -700871875.4391006,
            -4406884443.495676,
            -1164230125.457686,
        ],
    ],
    [
        1092009600000,
        [
            -697562714.2283171,
            -4407551825.541752,
            -1165437885.077552,
        ],
    ],
    [
        1092614400000,
        [
            -694253619.4437582,
            -4408217397.483098,
            -1166644613.627559,
        ],
    ],
    [
        1093219200000,
        [
            -690944345.987771,
            -4408880891.977062,
            -1167850056.541513,
        ],
    ],
    [
        1093824000000,
        [
            -687634570.3270572,
            -4409542006.64614,
            -1169054210.37537,
        ],
    ],
    [
        1094428800000,
        [
            -684324005.6554424,
            -4410200512.110591,
            -1170257324.397729,
        ],
    ],
    [
        1095033600000,
        [
            -681012502.9229071,
            -4410856333.868836,
            -1171459812.776047,
        ],
    ],
    [
        1095638400000,
        [
            -677700102.6230533,
            -4411509578.528482,
            -1172662108.693719,
        ],
    ],
    [
        1096243200000,
        [
            -674387021.6245625,
            -4412160495.947483,
            -1173864511.049971,
        ],
    ],
    [
        1096848000000,
        [
            -671073577.861073,
            -4412809392.094264,
            -1175067078.894004,
        ],
    ],
    [
        1097452800000,
        [
            -667760077.2433491,
            -4413456521.963793,
            -1176269611.375748,
        ],
    ],
    [
        1098057600000,
        [
            -664446705.1976657,
            -4414101999.932073,
            -1177471719.151083,
        ],
    ],
    [
        1098662400000,
        [
            -661133461.7058913,
            -4414745759.618147,
            -1178672960.961027,
        ],
    ],
    [
        1099267200000,
        [
            -657820161.1861975,
            -4415387576.700311,
            -1179872998.051315,
        ],
    ],
    [
        1099872000000,
        [
            -654506497.5126157,
            -4416027147.274135,
            -1181071713.577215,
        ],
    ],
    [
        1100476800000,
        [
            -651192152.2747641,
            -4416664194.941666,
            -1182269254.062119,
        ],
    ],
    [
        1101081600000,
        [
            -647876907.6328126,
            -4417298568.267421,
            -1183465977.193045,
        ],
    ],
    [
        1101686400000,
        [
            -644560723.2376741,
            -4417930293.810842,
            -1184662325.268008,
        ],
    ],
    [
        1102291200000,
        [
            -641243750.5050391,
            -4418559566.828788,
            -1185858669.511471,
        ],
    ],
    [
        1102896000000,
        [
            -637926278.9112581,
            -4419186682.304968,
            -1187055178.714512,
        ],
    ],
    [
        1103500800000,
        [
            -634608633.5339644,
            -4419811929.033519,
            -1188251758.409505,
        ],
    ],
    [
        1104105600000,
        [
            -631291061.8871113,
            -4420435486.594886,
            -1189448083.910871,
        ],
    ],
    [
        1104710400000,
        [
            -627973648.1023566,
            -4421057363.034596,
            -1190643715.285351,
        ],
    ],
    [
        1105315200000,
        [
            -624656283.465471,
            -4421677392.021615,
            -1191838251.508823,
        ],
    ],
    [
        1105920000000,
        [
            -621338704.5941548,
            -4422295290.019332,
            -1193031470.794859,
        ],
    ],
    [
        1106524800000,
        [
            -618020586.9284588,
            -4422910755.219474,
            -1194223408.733594,
        ],
    ],
    [
        1107129600000,
        [
            -614701660.6427467,
            -4423523573.696959,
            -1195414345.449313,
        ],
    ],
    [
        1107734400000,
        [
            -611381807.1362809,
            -4424133694.486791,
            -1196604705.987711,
        ],
    ],
    [
        1108339200000,
        [
            -608061101.8667583,
            -4424741247.090046,
            -1197794910.156938,
        ],
    ],
    [
        1108944000000,
        [
            -604739789.2069612,
            -4425346496.012138,
            -1198985224.612898,
        ],
    ],
    [
        1109548800000,
        [
            -601418197.6841558,
            -4425949747.988029,
            -1200175668.437284,
        ],
    ],
    [
        1110153600000,
        [
            -598096624.4029036,
            -4426551244.029687,
            -1201366006.367258,
        ],
    ],
    [
        1110758400000,
        [
            -594775230.144603,
            -4427151074.197437,
            -1202555832.091364,
        ],
    ],
    [
        1111363200000,
        [
            -591453984.474758,
            -4427749145.380999,
            -1203744710.756773,
        ],
    ],
    [
        1111968000000,
        [
            -588132678.630532,
            -4428345214.681121,
            -1204932331.452621,
        ],
    ],
    [
        1112572800000,
        [
            -584810998.9127358,
            -4428938975.687856,
            -1206118617.375205,
        ],
    ],
    [
        1113177600000,
        [
            -581488637.2080566,
            -4429530166.746553,
            -1207303753.467048,
        ],
    ],
    [
        1113782400000,
        [
            -578165400.408876,
            -4430118663.297832,
            -1208488120.686088,
        ],
    ],
    [
        1114387200000,
        [
            -574841278.9629245,
            -4430704521.455514,
            -1209672161.025434,
        ],
    ],
    [
        1114992000000,
        [
            -571516450.6586336,
            -4431287958.067369,
            -1210856221.865506,
        ],
    ],
    [
        1115596800000,
        [
            -568191218.8740606,
            -4431869274.646819,
            -1212040433.519582,
        ],
    ],
    [
        1116201600000,
        [
            -564865906.2771506,
            -4432448751.183859,
            -1213224662.737374,
        ],
    ],
    [
        1116806400000,
        [
            -561540741.2990878,
            -4433026547.383875,
            -1214408559.701641,
        ],
    ],
    [
        1117411200000,
        [
            -558215777.9391179,
            -4433602646.921159,
            -1215591681.894202,
        ],
    ],
    [
        1118016000000,
        [
            -554890876.6169438,
            -4434176863.635522,
            -1216773649.806626,
        ],
    ],
    [
        1118620800000,
        [
            -551565752.7017621,
            -4434748905.655396,
            -1217954279.504877,
        ],
    ],
    [
        1119225600000,
        [
            -548240077.9313408,
            -4435318477.002175,
            -1219133647.17698,
        ],
    ],
    [
        1119830400000,
        [
            -544913597.5390244,
            -4435885382.90567,
            -1220312062.771655,
        ],
    ],
    [
        1120435200000,
        [
            -541586219.9441506,
            -4436449598.578769,
            -1221489960.113485,
        ],
    ],
    [
        1121040000000,
        [
            -538258048.6216841,
            -4437011276.581915,
            -1222667743.214834,
        ],
    ],
    [
        1121644800000,
        [
            -534929346.2259343,
            -4437570692.080682,
            -1223845643.810498,
        ],
    ],
    [
        1122249600000,
        [
            -531600443.4059255,
            -4438128145.417685,
            -1225023638.989489,
        ],
    ],
    [
        1122854400000,
        [
            -528271623.2907448,
            -4438683855.421359,
            -1226201458.318003,
        ],
    ],
    [
        1123459200000,
        [
            -524943022.7174498,
            -4439237881.565742,
            -1227378678.997512,
        ],
    ],
    [
        1124064000000,
        [
            -521614585.671126,
            -4439790102.985168,
            -1228554874.800844,
        ],
    ],
    [
        1124668800000,
        [
            -518286084.6249336,
            -4440340261.183074,
            -1229729765.629478,
        ],
    ],
    [
        1125273600000,
        [
            -514957201.3087115,
            -4440888051.019637,
            -1230903316.137955,
        ],
    ],
    [
        1125878400000,
        [
            -511627639.2017736,
            -4441433228.022891,
            -1232075748.529453,
        ],
    ],
    [
        1126483200000,
        [
            -508297229.9661157,
            -4441975693.805709,
            -1233247463.285191,
        ],
    ],
    [
        1127088000000,
        [
            -504965995.4847885,
            -4442515530.893865,
            -1234418897.094925,
        ],
    ],
    [
        1127692800000,
        [
            -501634140.8222625,
            -4443052974.430911,
            -1235590369.533196,
        ],
    ],
    [
        1128297600000,
        [
            -498301982.5289855,
            -4443588329.804755,
            -1236761971.003606,
        ],
    ],
    [
        1128902400000,
        [
            -494969838.4195511,
            -4444121865.253448,
            -1237933530.279652,
        ],
    ],
    [
        1129507200000,
        [
            -491637916.5972368,
            -4444653717.23083,
            -1239104674.34986,
        ],
    ],
    [
        1130112000000,
        [
            -488306243.2388725,
            -4445183842.65432,
            -1240274960.193134,
        ],
    ],
    [
        1130716800000,
        [
            -484974654.8703189,
            -4445712034.981383,
            -1241444030.969454,
        ],
    ],
    [
        1131321600000,
        [
            -481642856.9786167,
            -4446237997.599237,
            -1242611741.429954,
        ],
    ],
    [
        1131926400000,
        [
            -478310528.3878502,
            -4446761449.018837,
            -1243778209.702726,
        ],
    ],
    [
        1132531200000,
        [
            -474977435.3831453,
            -4447282223.674651,
            -1244943776.507009,
        ],
    ],
    [
        1133136000000,
        [
            -471643514.202534,
            -4447800331.650138,
            -1246108884.888751,
        ],
    ],
    [
        1133740800000,
        [
            -468308892.5135983,
            -4448315954.577691,
            -1247273923.341521,
        ],
    ],
    [
        1134345600000,
        [
            -464973845.0523828,
            -4448829381.038107,
            -1248439088.981851,
        ],
    ],
    [
        1134950400000,
        [
            -461638698.0668262,
            -4449340906.62148,
            -1249604318.904144,
        ],
    ],
    [
        1135555200000,
        [
            -458303713.7208405,
            -4449850730.863723,
            -1250769312.2746,
        ],
    ],
    [
        1136160000000,
        [
            -454968996.6138862,
            -4450358886.507407,
            -1251933636.02823,
        ],
    ],
    [
        1136764800000,
        [
            -451634456.6221033,
            -4450865227.610443,
            -1253096877.467638,
        ],
    ],
    [
        1137369600000,
        [
            -448299840.8387799,
            -4451369480.829145,
            -1254258789.222332,
        ],
    ],
    [
        1137974400000,
        [
            -444964822.4834516,
            -4451871341.146566,
            -1255419375.901736,
        ],
    ],
    [
        1138579200000,
        [
            -441629116.0612181,
            -4452370578.979838,
            -1256578892.736615,
        ],
    ],
    [
        1139184000000,
        [
            -438292578.7621757,
            -4452867121.266011,
            -1257737755.359773,
        ],
    ],
    [
        1139788800000,
        [
            -434955261.1840134,
            -4453361076.950138,
            -1258896392.183185,
        ],
    ],
    [
        1140393600000,
        [
            -431617388.7916139,
            -4453852697.814296,
            -1260055093.111785,
        ],
    ],
    [
        1140998400000,
        [
            -428279281.6367987,
            -4454342288.986763,
            -1261213907.80321,
        ],
    ],
    [
        1141603200000,
        [
            -424941242.3226196,
            -4454830099.969647,
            -1262372627.062522,
        ],
    ],
    [
        1142208000000,
        [
            -421603451.3222116,
            -4455316235.730024,
            -1263530855.272567,
        ],
    ],
    [
        1142812800000,
        [
            -418265903.9118143,
            -4455800619.724386,
            -1264688149.906602,
        ],
    ],
    [
        1143417600000,
        [
            -414928411.9126012,
            -4456283020.296408,
            -1265844177.280003,
        ],
    ],
    [
        1144022400000,
        [
            -411590670.7399509,
            -4456763131.117468,
            -1266998829.147957,
        ],
    ],
    [
        1144627200000,
        [
            -408252367.6938747,
            -4457240677.856957,
            -1268152260.296135,
        ],
    ],
    [
        1145232000000,
        [
            -404913293.8581749,
            -4457715514.375942,
            -1269304833.942836,
        ],
    ],
    [
        1145836800000,
        [
            -401573419.8911379,
            -4458187674.151513,
            -1270456992.856775,
        ],
    ],
    [
        1146441600000,
        [
            -398232907.8724599,
            -4458657357.8613,
            -1271609102.10896,
        ],
    ],
    [
        1147046400000,
        [
            -394892055.2810379,
            -4459124862.076119,
            -1272761320.493438,
        ],
    ],
    [
        1147651200000,
        [
            -391551191.9388329,
            -4459590475.394232,
            -1273913545.332941,
        ],
    ],
    [
        1148256000000,
        [
            -388210565.2062274,
            -4460054377.649642,
            -1275065448.414206,
        ],
    ],
    [
        1148860800000,
        [
            -384870253.1050313,
            -4460516575.874152,
            -1276216590.847305,
        ],
    ],
    [
        1149465600000,
        [
            -381530138.691425,
            -4460976900.922327,
            -1277366577.285637,
        ],
    ],
    [
        1150070400000,
        [
            -378189953.8555128,
            -4461435068.326008,
            -1278515195.510274,
        ],
    ],
    [
        1150675200000,
        [
            -374849374.2709808,
            -4461890779.591459,
            -1279662491.452281,
        ],
    ],
    [
        1151280000000,
        [
            -371508133.8670825,
            -4462343827.483275,
            -1280808753.444791,
        ],
    ],
    [
        1151884800000,
        [
            -368166119.9851789,
            -4462794169.631817,
            -1281954410.705055,
        ],
    ],
    [
        1152489600000,
        [
            -364823414.4845356,
            -4463241943.9411,
            -1283099881.192872,
        ],
    ],
    [
        1153094400000,
        [
            -361480265.3844978,
            -4463687419.850741,
            -1284245423.797897,
        ],
    ],
    [
        1153699200000,
        [
            -358136999.9326376,
            -4464130903.573963,
            -1285391047.847359,
        ],
    ],
    [
        1154304000000,
        [
            -354793910.5763271,
            -4464572631.266184,
            -1286536510.394987,
        ],
    ],
    [
        1154908800000,
        [
            -351451152.9444579,
            -4465012686.756713,
            -1287681401.445981,
        ],
    ],
    [
        1155513600000,
        [
            -348108690.9792287,
            -4465450972.585593,
            -1288825288.498116,
        ],
    ],
    [
        1156118400000,
        [
            -344766308.9827536,
            -4465887244.74159,
            -1289967869.409052,
        ],
    ],
    [
        1156723200000,
        [
            -341423687.6260478,
            -4466321197.92727,
            -1291109078.199054,
        ],
    ],
    [
        1157328000000,
        [
            -338080517.8141897,
            -4466752572.665927,
            -1292249107.801479,
        ],
    ],
    [
        1157932800000,
        [
            -334736610.2308283,
            -4467181247.935163,
            -1293388343.077625,
        ],
    ],
    [
        1158537600000,
        [
            -331391962.0776179,
            -4467607284.545753,
            -1294527225.091081,
        ],
    ],
    [
        1159142400000,
        [
            -328046757.9839016,
            -4468030902.970698,
            -1295666094.315715,
        ],
    ],
    [
        1159747200000,
        [
            -324701304.7180989,
            -4468452404.387072,
            -1296805070.175092,
        ],
    ],
    [
        1160352000000,
        [
            -321355923.7140745,
            -4468872064.120317,
            -1297944009.421238,
        ],
    ],
    [
        1160956800000,
        [
            -318010839.2162781,
            -4469290034.772782,
            -1299082556.22841,
        ],
    ],
    [
        1161561600000,
        [
            -314666100.2412629,
            -4469706292.085515,
            -1300220266.633099,
        ],
    ],
    [
        1162166400000,
        [
            -311321564.0672541,
            -4470120643.075994,
            -1301356764.77218,
        ],
    ],
    [
        1162771200000,
        [
            -307976947.6133872,
            -4470532794.275142,
            -1302491875.456495,
        ],
    ],
    [
        1163376000000,
        [
            -304631927.7795891,
            -4470942455.45935,
            -1303625685.707502,
        ],
    ],
    [
        1163980800000,
        [
            -301286255.0641466,
            -4471349441.156944,
            -1304758513.837941,
        ],
    ],
    [
        1164585600000,
        [
            -297939843.2035916,
            -4471753735.086421,
            -1305890796.850233,
        ],
    ],
    [
        1165190400000,
        [
            -294592802.4327648,
            -4472155496.766095,
            -1307022935.844596,
        ],
    ],
    [
        1165795200000,
        [
            -291245401.0075103,
            -4472555005.86794,
            -1308155154.251195,
        ],
    ],
    [
        1166400000000,
        [
            -287897970.3663657,
            -4472952563.108732,
            -1309287419.36761,
        ],
    ],
    [
        1167004800000,
        [
            -284550789.5241092,
            -4473348384.382099,
            -1310419454.253715,
        ],
    ],
    [
        1167609600000,
        [
            -281203988.4326093,
            -4473742525.033505,
            -1311550834.609333,
        ],
    ],
    [
        1168214400000,
        [
            -277857503.1693774,
            -4474134860.254084,
            -1312681137.723571,
        ],
    ],
    [
        1168819200000,
        [
            -274511099.47956,
            -4474525129.299352,
            -1313810091.689653,
        ],
    ],
    [
        1169424000000,
        [
            -271164456.6938736,
            -4474913028.099672,
            -1314937671.278095,
        ],
    ],
    [
        1170028800000,
        [
            -267817281.7001646,
            -4475298317.034319,
            -1316064106.679967,
        ],
    ],
    [
        1170633600000,
        [
            -264469412.6901964,
            -4475680906.230386,
            -1317189803.058136,
        ],
    ],
    [
        1171238400000,
        [
            -261120876.3934086,
            -4476060888.401643,
            -1318315198.232144,
        ],
    ],
    [
        1171843200000,
        [
            -257771878.7499998,
            -4476438505.813627,
            -1319440607.256779,
        ],
    ],
    [
        1172448000000,
        [
            -254422733.4005174,
            -4476814064.181179,
            -1320566110.607308,
        ],
    ],
    [
        1173052800000,
        [
            -251073751.7380291,
            -4477187826.094964,
            -1321691527.011152,
        ],
    ],
    [
        1173657600000,
        [
            -247725133.0507175,
            -4477559919.661006,
            -1322816477.93257,
        ],
    ],
    [
        1174262400000,
        [
            -244376894.1737338,
            -4477930293.206737,
            -1323940520.096072,
        ],
    ],
    [
        1174867200000,
        [
            -241028863.358964,
            -4478298732.774853,
            -1325063301.271854,
        ],
    ],
    [
        1175472000000,
        [
            -237680741.1608805,
            -4478664937.314675,
            -1326184684.521134,
        ],
    ],
    [
        1176076800000,
        [
            -234332206.6505982,
            -4479028624.75244,
            -1327304796.004419,
        ],
    ],
    [
        1176681600000,
        [
            -230983030.7808941,
            -4479389630.912996,
            -1328423980.018701,
        ],
    ],
    [
        1177286400000,
        [
            -227633157.6030154,
            -4479747967.18254,
            -1329542677.914439,
        ],
    ],
    [
        1177891200000,
        [
            -224282725.0284911,
            -4480103816.877939,
            -1330661272.283697,
        ],
    ],
    [
        1178496000000,
        [
            -220932016.3058113,
            -4480457470.502183,
            -1331779951.314205,
        ],
    ],
    [
        1179100800000,
        [
            -217581359.1960652,
            -4480809222.0911,
            -1332898642.179225,
        ],
    ],
    [
        1179705600000,
        [
            -214231011.3454617,
            -4481159263.990326,
            -1334017036.357044,
        ],
    ],
    [
        1180310400000,
        [
            -210881072.1750925,
            -4481507619.150998,
            -1335134697.707961,
        ],
    ],
    [
        1180915200000,
        [
            -207531448.4495892,
            -4481854133.244143,
            -1336251215.74493,
        ],
    ],
    [
        1181520000000,
        [
            -204181887.0611674,
            -4482198528.160159,
            -1337366350.191101,
        ],
    ],
    [
        1182124800000,
        [
            -200832065.4278425,
            -4482540499.27856,
            -1338480115.323756,
        ],
    ],
    [
        1182729600000,
        [
            -197481706.8684269,
            -4482879822.205014,
            -1339592773.998022,
        ],
    ],
    [
        1183334400000,
        [
            -194130679.5085244,
            -4483216431.077884,
            -1340704744.461493,
        ],
    ],
    [
        1183939200000,
        [
            -190779044.6341938,
            -4483550441.654835,
            -1341816453.049797,
        ],
    ],
    [
        1184544000000,
        [
            -187427037.3794731,
            -4483882110.808377,
            -1342928183.34339,
        ],
    ],
    [
        1185148800000,
        [
            -184074985.5116245,
            -4484211745.952309,
            -1344039975.588968,
        ],
    ],
    [
        1185753600000,
        [
            -180723195.1930898,
            -4484539597.058398,
            -1345151613.093672,
        ],
    ],
    [
        1186358400000,
        [
            -177371844.3764001,
            -4484865769.652716,
            -1346262699.218347,
        ],
    ],
    [
        1186963200000,
        [
            -174020921.142788,
            -4485190187.47367,
            -1347372796.208493,
        ],
    ],
    [
        1187568000000,
        [
            -170670229.9750304,
            -4485512618.682961,
            -1348481578.781605,
        ],
    ],
    [
        1188172800000,
        [
            -167319462.8436861,
            -4485832759.173362,
            -1349588949.831612,
        ],
    ],
    [
        1188777600000,
        [
            -163968308.7069489,
            -4486150341.469148,
            -1350695075.187283,
        ],
    ],
    [
        1189382400000,
        [
            -160616563.7178655,
            -4486465229.403152,
            -1351800324.710193,
        ],
    ],
    [
        1189987200000,
        [
            -157264203.7734328,
            -4486777466.288936,
            -1352905142.078115,
        ],
    ],
    [
        1190592000000,
        [
            -153911394.338243,
            -4487087260.576647,
            -1354009888.804341,
        ],
    ],
    [
        1191196800000,
        [
            -150558433.3677888,
            -4487394913.344219,
            -1355114716.542274,
        ],
    ],
    [
        1191801600000,
        [
            -147205646.856266,
            -4487700712.742108,
            -1356219513.631999,
        ],
    ],
    [
        1192406400000,
        [
            -143853274.588912,
            -4488004833.389953,
            -1357323945.263952,
        ],
    ],
    [
        1193011200000,
        [
            -140501386.6760087,
            -4488307276.422865,
            -1358427571.852391,
        ],
    ],
    [
        1193616000000,
        [
            -137149858.8194209,
            -4488607870.22635,
            -1359530003.771707,
        ],
    ],
    [
        1194220800000,
        [
            -133798414.7922164,
            -4488906331.101272,
            -1360631039.136211,
        ],
    ],
    [
        1194825600000,
        [
            -130446723.9038475,
            -4489202362.899831,
            -1361730735.03322,
        ],
    ],
    [
        1195430400000,
        [
            -127094519.3664178,
            -4489495762.136886,
            -1362829386.926943,
        ],
    ],
    [
        1196035200000,
        [
            -123741692.0811245,
            -4489786490.761798,
            -1363927424.592537,
        ],
    ],
    [
        1196640000000,
        [
            -120388327.9237766,
            -4490074689.600472,
            -1365025261.08686,
        ],
    ],
    [
        1197244800000,
        [
            -117034677.4647769,
            -4490360628.555852,
            -1366123146.896276,
        ],
    ],
    [
        1197849600000,
        [
            -113681067.8208059,
            -4490644610.946844,
            -1367221080.811818,
        ],
    ],
    [
        1198454400000,
        [
            -110327787.4179849,
            -4490926865.93226,
            -1368318810.117931,
        ],
    ],
    [
        1199059200000,
        [
            -106974985.0052293,
            -4491207467.592972,
            -1369415919.710083,
        ],
    ],
    [
        1199664000000,
        [
            -103622618.2180068,
            -4491486308.751986,
            -1370511977.616889,
        ],
    ],
    [
        1200268800000,
        [
            -100270468.9058967,
            -4491763138.1222,
            -1371606686.530069,
        ],
    ],
    [
        1200873600000,
        [
            -96918220.40320049,
            -4492037648.67218,
            -1372699989.050286,
        ],
    ],
    [
        1201478400000,
        [
            -93565569.7419396,
            -4492309586.311514,
            -1373792088.184606,
        ],
    ],
    [
        1202083200000,
        [
            -90212334.68744637,
            -4492578838.62669,
            -1374883374.542952,
        ],
    ],
    [
        1202688000000,
        [
            -86858519.28625475,
            -4492845472.726842,
            -1375974287.385109,
        ],
    ],
    [
        1203292800000,
        [
            -83504314.4563331,
            -4493109712.001093,
            -1377065160.252901,
        ],
    ],
    [
        1203897600000,
        [
            -80150031.51565517,
            -4493371858.15725,
            -1378156103.479054,
        ],
    ],
    [
        1204502400000,
        [
            -76795992.85542093,
            -4493632184.269058,
            -1379246964.637734,
        ],
    ],
    [
        1205107200000,
        [
            -73442419.34867431,
            -4493890837.920459,
            -1380337382.138417,
        ],
    ],
    [
        1205712000000,
        [
            -70089354.38021074,
            -4494147789.326118,
            -1381426912.393902,
        ],
    ],
    [
        1206316800000,
        [
            -66736650.18553922,
            -4494402841.796174,
            -1382515185.225705,
        ],
    ],
    [
        1206921600000,
        [
            -63384020.9372559,
            -4494655700.745361,
            -1383602034.251816,
        ],
    ],
    [
        1207526400000,
        [
            -60031145.08960813,
            -4494906078.091899,
            -1384687556.297364,
        ],
    ],
    [
        1208131200000,
        [
            -56677780.79184754,
            -4495153795.053515,
            -1385772077.295736,
        ],
    ],
    [
        1208736000000,
        [
            -53323852.21072101,
            -4495398846.093759,
            -1386856036.951085,
        ],
    ],
    [
        1209340800000,
        [
            -49969475.95217849,
            -4495641401.075236,
            -1387939833.985112,
        ],
    ],
    [
        1209945600000,
        [
            -46614920.60616917,
            -4495881744.989821,
            -1389023685.60994,
        ],
    ],
    [
        1210550400000,
        [
            -43260514.53159411,
            -4496120177.993495,
            -1390107550.597224,
        ],
    ],
    [
        1211155200000,
        [
            -39906531.05142007,
            -4496356911.13025,
            -1391191144.349594,
        ],
    ],
    [
        1211760000000,
        [
            -36553091.96755484,
            -4496591992.817542,
            -1392274039.845416,
        ],
    ],
    [
        1212364800000,
        [
            -33200125.22259129,
            -4496825292.17131,
            -1393355817.771801,
        ],
    ],
    [
        1212969600000,
        [
            -29847390.65862234,
            -4497056544.898196,
            -1394436213.545689,
        ],
    ],
    [
        1213574400000,
        [
            -26494564.84920666,
            -4497285446.246695,
            -1395515211.021907,
        ],
    ],
    [
        1214179200000,
        [
            -23141356.20108787,
            -4497511759.148665,
            -1396593048.808105,
        ],
    ],
    [
        1214784000000,
        [
            -19787609.00451661,
            -4497735398.494258,
            -1397670135.556998,
        ],
    ],
    [
        1215388800000,
        [
            -16433358.75078467,
            -4497956461.107373,
            -1398746905.268861,
        ],
    ],
    [
        1215993600000,
        [
            -13078819.83484906,
            -4498175191.821364,
            -1399823664.809966,
        ],
    ],
    [
        1216598400000,
        [
            -9724310.235630065,
            -4498391897.933866,
            -1400900486.197524,
        ],
    ],
    [
        1217203200000,
        [
            -6370139.079024385,
            -4498606840.457639,
            -1401977180.689884,
        ],
    ],
    [
        1217808000000,
        [
            -3016498.676316173,
            -4498820140.834526,
            -1403053364.577065,
        ],
    ],
    [
        1218412800000,
        [
            336601.0809810671,
            -4499031738.789654,
            -1404128594.536178,
        ],
    ],
    [
        1219017600000,
        [
            3689335.654085526,
            -4499241414.430978,
            -1405202523.632873,
        ],
    ],
    [
        1219622400000,
        [
            7042004.370027526,
            -4499448864.899965,
            -1406275023.048897,
        ],
    ],
    [
        1220227200000,
        [
            10394924.31969152,
            -4499653810.401329,
            -1407346227.837147,
        ],
    ],
    [
        1220832000000,
        [
            13748316.67908741,
            -4499856093.087532,
            -1408416489.239554,
        ],
    ],
    [
        1221436800000,
        [
            17102226.95325891,
            -4500055732.743326,
            -1409486249.730696,
        ],
    ],
    [
        1222041600000,
        [
            20456507.89727396,
            -4500252919.321293,
            -1410555886.469621,
        ],
    ],
    [
        1222646400000,
        [
            23810869.98363139,
            -4500447946.142237,
            -1411625578.824771,
        ],
    ],
    [
        1223251200000,
        [
            27164981.51922413,
            -4500641107.334081,
            -1412695245.210149,
        ],
    ],
    [
        1223856000000,
        [
            30518584.27352586,
            -4500832594.98034,
            -1413764571.884495,
        ],
    ],
    [
        1224460800000,
        [
            33871583.96579003,
            -4501022432.177683,
            -1414833124.00187,
        ],
    ],
    [
        1225065600000,
        [
            37224082.41929853,
            -4501210464.846483,
            -1415900498.367862,
        ],
    ],
    [
        1225670400000,
        [
            40576339.25399195,
            -4501396416.040914,
            -1416966464.581322,
        ],
    ],
    [
        1226275200000,
        [
            43928679.22572621,
            -4501579984.893643,
            -1418031047.108592,
        ],
    ],
    [
        1226880000000,
        [
            47281377.3939786,
            -4501760954.160333,
            -1419094517.990884,
        ],
    ],
    [
        1227484800000,
        [
            50634561.000862,
            -4501939267.898238,
            -1420157300.797137,
        ],
    ],
    [
        1228089600000,
        [
            53988163.71892596,
            -4502115051.612293,
            -1421219820.454893,
        ],
    ],
    [
        1228694400000,
        [
            57341948.63971035,
            -4502288568.26144,
            -1422282353.636257,
        ],
    ],
    [
        1229299200000,
        [
            60695590.86960287,
            -4502460126.587108,
            -1423344931.991446,
        ],
    ],
    [
        1229904000000,
        [
            64048791.02002617,
            -4502629973.481581,
            -1424407331.064447,
        ],
    ],
    [
        1230508800000,
        [
            67401380.20373337,
            -4502798207.896828,
            -1425469149.595567,
        ],
    ],
    [
        1231113600000,
        [
            70753379.04797478,
            -4502964747.313781,
            -1426529951.606567,
        ],
    ],
    [
        1231718400000,
        [
            74104990.32298157,
            -4503129358.355223,
            -1427589420.226032,
        ],
    ],
    [
        1232323200000,
        [
            77456528.76978548,
            -4503291739.064855,
            -1428647468.974553,
        ],
    ],
    [
        1232928000000,
        [
            80808310.44728048,
            -4503451624.384577,
            -1429704272.341515,
        ],
    ],
    [
        1233532800000,
        [
            84160539.57702325,
            -4503608880.828312,
            -1430760204.94182,
        ],
    ],
    [
        1234137600000,
        [
            87513236.39993332,
            -4503763555.172857,
            -1431815709.35677,
        ],
    ],
    [
        1234742400000,
        [
            90866231.3036472,
            -4503915857.584378,
            -1432871139.47905,
        ],
    ],
    [
        1235347200000,
        [
            94219225.25008197,
            -4504066086.759186,
            -1433926635.863195,
        ],
    ],
    [
        1235952000000,
        [
            97571894.712456,
            -4504214524.493718,
            -1434982076.103039,
        ],
    ],
    [
        1236556800000,
        [
            100924005.2150279,
            -4504361336.022246,
            -1436037117.323822,
        ],
    ],
    [
        1237161600000,
        [
            104275493.5856676,
            -4504506511.283929,
            -1437091316.757086,
        ],
    ],
    [
        1237766400000,
        [
            107626489.3252819,
            -4504649868.354542,
            -1438144287.640617,
        ],
    ],
    [
        1238371200000,
        [
            110977267.9401472,
            -4504791117.483619,
            -1439195834.787983,
        ],
    ],
    [
        1238976000000,
        [
            114328153.5682343,
            -4504929962.801419,
            -1440246023.058343,
        ],
    ],
    [
        1239580800000,
        [
            117679404.7775252,
            -4505066206.461613,
            -1441295155.171577,
        ],
    ],
    [
        1240185600000,
        [
            121031122.5720496,
            -4505199817.775646,
            -1442343664.457324,
        ],
    ],
    [
        1240790400000,
        [
            124383212.3909575,
            -4505330943.009795,
            -1443391960.417189,
        ],
    ],
    [
        1241395200000,
        [
            127735415.9093416,
            -4505459854.004678,
            -1444440284.306055,
        ],
    ],
    [
        1242000000000,
        [
            131087401.6020058,
            -4505586852.761163,
            -1445488624.835384,
        ],
    ],
    [
        1242604800000,
        [
            134438880.3640689,
            -4505712164.905391,
            -1446536721.708255,
        ],
    ],
    [
        1243209600000,
        [
            137789706.008174,
            -4505835859.677435,
            -1447584156.679376,
        ],
    ],
    [
        1243814400000,
        [
            141139925.1134929,
            -4505957825.45778,
            -1448630500.980499,
        ],
    ],
    [
        1244419200000,
        [
            144489758.4616818,
            -4506077809.646196,
            -1449675466.286858,
        ],
    ],
    [
        1245024000000,
        [
            147839521.3958277,
            -4506195508.074435,
            -1450719005.762772,
        ],
    ],
    [
        1245628800000,
        [
            151189511.3221442,
            -4506310672.536371,
            -1451761330.84998,
        ],
    ],
    [
        1246233600000,
        [
            154539901.0368826,
            -4506423199.599572,
            -1452802837.71158,
        ],
    ],
    [
        1246838400000,
        [
            157890676.1102642,
            -4506533168.920107,
            -1453843967.7975,
        ],
    ],
    [
        1247443200000,
        [
            161241639.7837479,
            -4506640815.804703,
            -1454885051.798381,
        ],
    ],
    [
        1248048000000,
        [
            164592481.7259942,
            -4506746447.69288,
            -1455926192.9816,
        ],
    ],
    [
        1248652800000,
        [
            167942884.7814272,
            -4506850337.167545,
            -1456967231.49997,
        ],
    ],
    [
        1249257600000,
        [
            171292635.5783101,
            -4506952628.252136,
            -1458007801.233823,
        ],
    ],
    [
        1249862400000,
        [
            174641700.0979046,
            -4507053286.508352,
            -1459047459.109321,
        ],
    ],
    [
        1250467200000,
        [
            177990235.3204601,
            -4507152111.83388,
            -1460085841.753693,
        ],
    ],
    [
        1251072000000,
        [
            181338532.9085758,
            -4507248809.979709,
            -1461122793.487617,
        ],
    ],
    [
        1251676800000,
        [
            184686915.9745796,
            -4507343096.806776,
            -1462158420.9089,
        ],
    ],
    [
        1252281600000,
        [
            188035624.9502296,
            -4507434799.053523,
            -1463193056.008738,
        ],
    ],
    [
        1252886400000,
        [
            191384731.9056878,
            -4507523916.722553,
            -1464227139.734749,
        ],
    ],
    [
        1253491200000,
        [
            194734114.3795753,
            -4507610624.220167,
            -1465261066.228474,
        ],
    ],
    [
        1254096000000,
        [
            198083498.7106683,
            -4507695209.567592,
            -1466295043.954116,
        ],
    ],
    [
        1254700800000,
        [
            201432557.2128841,
            -4507777973.714781,
            -1467329023.172291,
        ],
    ],
    [
        1255305600000,
        [
            204781024.0283721,
            -4507859124.673248,
            -1468362713.409707,
        ],
    ],
    [
        1255910400000,
        [
            208128787.812025,
            -4507938703.574202,
            -1469395684.716662,
        ],
    ],
    [
        1256515200000,
        [
            211475930.0932333,
            -4508016570.933539,
            -1470427519.580908,
        ],
    ],
    [
        1257120000000,
        [
            214822696.8206035,
            -4508092456.893482,
            -1471457960.866629,
        ],
    ],
    [
        1257724800000,
        [
            218169411.6991386,
            -4508166056.400092,
            -1472487001.905904,
        ],
    ],
    [
        1258329600000,
        [
            221516362.0362411,
            -4508237136.047384,
            -1473514888.19696,
        ],
    ],
    [
        1258934400000,
        [
            224863696.885902,
            -4508305616.125548,
            -1474542031.118994,
        ],
    ],
    [
        1259539200000,
        [
            228211373.1664699,
            -4508371599.117446,
            -1475568862.672014,
        ],
    ],
    [
        1260144000000,
        [
            231559169.8623521,
            -4508435333.564495,
            -1476595682.382161,
        ],
    ],
    [
        1260748800000,
        [
            234906765.2905697,
            -4508497126.308064,
            -1477622551.759279,
        ],
    ],
    [
        1261353600000,
        [
            238253849.2223905,
            -4508557235.079733,
            -1478649273.232659,
        ],
    ],
    [
        1261958400000,
        [
            241600231.0167022,
            -4508615778.814554,
            -1479675459.634684,
        ],
    ],
    [
        1262563200000,
        [
            244945907.0359379,
            -4508672695.848468,
            -1480700670.29113,
        ],
    ],
    [
        1263168000000,
        [
            248291061.560014,
            -4508727764.777261,
            -1481724566.16696,
        ],
    ],
    [
        1263772800000,
        [
            251635999.2043739,
            -4508780683.084515,
            -1482747029.375555,
        ],
    ],
    [
        1264377600000,
        [
            254981036.1908647,
            -4508831175.530417,
            -1483768204.882329,
        ],
    ],
    [
        1264982400000,
        [
            258326389.1735762,
            -4508879091.68695,
            -1484788449.64267,
        ],
    ],
    [
        1265587200000,
        [
            261672098.2905847,
            -4508924459.347551,
            -1485808207.114317,
        ],
    ],
    [
        1266192000000,
        [
            265018011.7711344,
            -4508967475.377437,
            -1486827850.563273,
        ],
    ],
    [
        1266796800000,
        [
            268363838.7118403,
            -4509008436.614661,
            -1487847551.119497,
        ],
    ],
    [
        1267401600000,
        [
            271709250.9933046,
            -4509047635.766882,
            -1488867218.071581,
        ],
    ],
    [
        1268006400000,
        [
            275053997.614347,
            -4509085259.565923,
            -1489886531.363117,
        ],
    ],
    [
        1268611200000,
        [
            278397992.1041159,
            -4509121324.096283,
            -1490905053.954298,
        ],
    ],
    [
        1269216000000,
        [
            281741342.927674,
            -4509155669.881778,
            -1491922386.092414,
        ],
    ],
    [
        1269820800000,
        [
            285084315.532995,
            -4509188019.328096,
            -1492938307.32283,
        ],
    ],
    [
        1270425600000,
        [
            288427239.0971196,
            -4509218075.209831,
            -1493952854.246418,
        ],
    ],
    [
        1271030400000,
        [
            291770389.7710013,
            -4509245624.937489,
            -1494966306.667948,
        ],
    ],
    [
        1271635200000,
        [
            295113892.2440733,
            -4509270616.47418,
            -1495979089.483815,
        ],
    ],
    [
        1272240000000,
        [
            298457675.9541302,
            -4509293178.267024,
            -1496991623.650573,
        ],
    ],
    [
        1272844800000,
        [
            301801500.5549592,
            -4509313574.122254,
            -1498004177.331068,
        ],
    ],
    [
        1273449600000,
        [
            305145041.0580283,
            -4509332109.669318,
            -1499016771.153609,
        ],
    ],
    [
        1274054400000,
        [
            308488002.0579014,
            -4509349024.64104,
            -1500029171.366351,
        ],
    ],
    [
        1274659200000,
        [
            311830220.826686,
            -4509364408.861526,
            -1501040971.897642,
        ],
    ],
    [
        1275264000000,
        [
            315171724.1842399,
            -4509378170.403137,
            -1502051736.508118,
        ],
    ],
    [
        1275868800000,
        [
            318512718.9300559,
            -4509390067.551991,
            -1503061152.594492,
        ],
    ],
    [
        1276473600000,
        [
            321853518.1029868,
            -4509399794.407569,
            -1504069141.981771,
        ],
    ],
    [
        1277078400000,
        [
            325194429.6465364,
            -4509407089.53023,
            -1505075888.355085,
        ],
    ],
    [
        1277683200000,
        [
            328535648.1167496,
            -4509411828.041903,
            -1506081772.098474,
        ],
    ],
    [
        1278288000000,
        [
            331877185.9404872,
            -4509414064.52656,
            -1507087235.829785,
        ],
    ],
    [
        1278892800000,
        [
            335218866.554478,
            -4509414013.537742,
            -1508092627.693213,
        ],
    ],
    [
        1279497600000,
        [
            338560385.2715893,
            -4509411974.872127,
            -1509098078.613494,
        ],
    ],
    [
        1280102400000,
        [
            341901416.7263156,
            -4509408228.145408,
            -1510103456.736142,
        ],
    ],
    [
        1280707200000,
        [
            345241728.4147156,
            -4509402934.491589,
            -1511108414.122058,
        ],
    ],
    [
        1281312000000,
        [
            348581260.8482862,
            -4509396080.073102,
            -1512112508.462793,
        ],
    ],
    [
        1281916800000,
        [
            351920147.4165781,
            -4509387480.747984,
            -1513115358.296186,
        ],
    ],
    [
        1282521600000,
        [
            355258666.1970337,
            -4509376847.208612,
            -1514116778.031177,
        ],
    ],
    [
        1283126400000,
        [
            358597140.006884,
            -4509363888.105652,
            -1515116843.943034,
        ],
    ],
    [
        1283731200000,
        [
            361935820.7034478,
            -4509348414.032217,
            -1516115867.091557,
        ],
    ],
    [
        1284336000000,
        [
            365274799.2447158,
            -4509330405.431149,
            -1517114283.861927,
        ],
    ],
    [
        1284940800000,
        [
            368613972.8875551,
            -4509310021.146483,
            -1518112502.994394,
        ],
    ],
    [
        1285545600000,
        [
            371953081.2403317,
            -4509287543.454535,
            -1519110761.515674,
        ],
    ],
    [
        1286150400000,
        [
            375291797.2385096,
            -4509263278.354484,
            -1520109040.774183,
        ],
    ],
    [
        1286755200000,
        [
            378629840.5097985,
            -4509237449.367251,
            -1521107074.137356,
        ],
    ],
    [
        1287360000000,
        [
            381967075.3213349,
            -4509210121.661744,
            -1522104442.081758,
        ],
    ],
    [
        1287964800000,
        [
            385303558.6460227,
            -4509181180.335981,
            -1523100719.565147,
        ],
    ],
    [
        1288569600000,
        [
            388639520.6662499,
            -4509150371.143441,
            -1524095625.922067,
        ],
    ],
    [
        1289174400000,
        [
            391975283.5033438,
            -4509117391.0661,
            -1525089124.81526,
        ],
    ],
    [
        1289779200000,
        [
            395311146.9599948,
            -4509081996.656584,
            -1526081437.448789,
        ],
    ],
    [
        1290384000000,
        [
            398647282.5962755,
            -4509044090.966178,
            -1527072964.393702,
        ],
    ],
    [
        1290988800000,
        [
            401983673.4207672,
            -4509003758.608602,
            -1528064144.720495,
        ],
    ],
    [
        1291593600000,
        [
            405320119.8006801,
            -4508961237.212147,
            -1529055301.674756,
        ],
    ],
    [
        1292198400000,
        [
            408656310.2396156,
            -4508916834.837676,
            -1530046528.873116,
        ],
    ],
    [
        1292803200000,
        [
            411991932.6977951,
            -4508870822.036934,
            -1531037657.898877,
        ],
    ],
    [
        1293408000000,
        [
            415326785.590009,
            -4508823336.365198,
            -1532028318.021637,
        ],
    ],
    [
        1294012800000,
        [
            418660847.5185043,
            -4508774334.074377,
            -1533018066.064154,
        ],
    ],
    [
        1294617600000,
        [
            421994284.6112711,
            -4508723606.417789,
            -1534006542.100496,
        ],
    ],
    [
        1295222400000,
        [
            425327393.7059606,
            -4508670853.271051,
            -1534993596.921111,
        ],
    ],
    [
        1295827200000,
        [
            428660498.299101,
            -4508615788.78964,
            -1535979345.098379,
        ],
    ],
    [
        1296432000000,
        [
            431993834.0653213,
            -4508558242.08952,
            -1536964123.941142,
        ],
    ],
    [
        1297036800000,
        [
            435327465.5998563,
            -4508498216.933346,
            -1537948373.756517,
        ],
    ],
    [
        1297641600000,
        [
            438661263.3063019,
            -4508435890.029513,
            -1538932482.510044,
        ],
    ],
    [
        1298246400000,
        [
            441994948.2573873,
            -4508371548.708311,
            -1539916648.666698,
        ],
    ],
    [
        1298851200000,
        [
            445328189.9307521,
            -4508305489.367113,
            -1540900810.770528,
        ],
    ],
    [
        1299456000000,
        [
            448660722.1011292,
            -4508237913.084474,
            -1541884669.537544,
        ],
    ],
    [
        1300060800000,
        [
            451992435.7400124,
            -4508168855.706298,
            -1542867793.830798,
        ],
    ],
    [
        1300665600000,
        [
            455323417.1557117,
            -4508098175.420421,
            -1543849771.733525,
        ],
    ],
    [
        1301270400000,
        [
            458653917.1745323,
            -4508025601.149323,
            -1544830354.447587,
        ],
    ],
    [
        1301875200000,
        [
            461984260.7755163,
            -4507950828.159808,
            -1545809544.508745,
        ],
    ],
    [
        1302480000000,
        [
            465314731.1911432,
            -4507873627.332461,
            -1546787595.887817,
        ],
    ],
    [
        1303084800000,
        [
            468645469.5638533,
            -4507793926.629645,
            -1547764924.048809,
        ],
    ],
    [
        1303689600000,
        [
            471976424.7239148,
            -4507711836.286143,
            -1548741959.072081,
        ],
    ],
    [
        1304294400000,
        [
            475307370.1342478,
            -4507627610.296365,
            -1549718994.234262,
        ],
    ],
    [
        1304899200000,
        [
            478637982.4207887,
            -4507541557.569251,
            -1550696082.412484,
        ],
    ],
    [
        1305504000000,
        [
            481967954.5383456,
            -4507453933.515459,
            -1551673017.487608,
        ],
    ],
    [
        1306108800000,
        [
            485297102.9936723,
            -4507364851.002198,
            -1552649407.836777,
        ],
    ],
    [
        1306713600000,
        [
            488625430.9632791,
            -4507274242.293736,
            -1553624814.744048,
        ],
    ],
    [
        1307318400000,
        [
            491953126.4255376,
            -4507181884.334957,
            -1554598906.65083,
        ],
    ],
    [
        1307923200000,
        [
            495280496.7150698,
            -4507087478.181127,
            -1555571576.598777,
        ],
    ],
    [
        1308528000000,
        [
            498607860.755168,
            -4506990754.760751,
            -1556542980.744165,
        ],
    ],
    [
        1309132800000,
        [
            501935435.0208991,
            -4506891570.254669,
            -1557513483.028425,
        ],
    ],
    [
        1309737600000,
        [
            505263256.0657037,
            -4506789958.518875,
            -1558483526.963108,
        ],
    ],
    [
        1310342400000,
        [
            508591168.5522139,
            -4506686120.442113,
            -1559453480.061926,
        ],
    ],
    [
        1310947200000,
        [
            511918880.5244383,
            -4506580353.75506,
            -1560423504.57721,
        ],
    ],
    [
        1311552000000,
        [
            515246066.401897,
            -4506472948.313951,
            -1561393499.927007,
        ],
    ],
    [
        1312156800000,
        [
            518572481.9518062,
            -4506364083.995969,
            -1562363138.260367,
        ],
    ],
    [
        1312761600000,
        [
            521898050.0717477,
            -4506253767.90537,
            -1563331980.589753,
        ],
    ],
    [
        1313366400000,
        [
            525222887.2126275,
            -4506141832.743162,
            -1564299631.232023,
        ],
    ],
    [
        1313971200000,
        [
            528547262.2864442,
            -4506027995.909784,
            -1565265876.55397,
        ],
    ],
    [
        1314576000000,
        [
            531871502.1620631,
            -4505911959.267963,
            -1566230760.846217,
        ],
    ],
    [
        1315180800000,
        [
            535195876.2288817,
            -4505793515.355087,
            -1567194571.593663,
        ],
    ],
    [
        1315785600000,
        [
            538520501.7713554,
            -4505672621.089658,
            -1568157737.782624,
        ],
    ],
    [
        1316390400000,
        [
            541845302.8776766,
            -4505549411.736566,
            -1569120677.651387,
        ],
    ],
    [
        1316995200000,
        [
            545170035.6148381,
            -4505424153.168329,
            -1570083651.309698,
        ],
    ],
    [
        1317600000000,
        [
            548494373.1354462,
            -4505297149.681875,
            -1571046669.475003,
        ],
    ],
    [
        1318204800000,
        [
            551818021.3878192,
            -4505168636.953908,
            -1572009489.472743,
        ],
    ],
    [
        1318809600000,
        [
            555140822.7671154,
            -4505038698.631787,
            -1572971700.853156,
        ],
    ],
    [
        1319414400000,
        [
            558462810.5961843,
            -4504907237.194665,
            -1573932870.148175,
        ],
    ],
    [
        1320019200000,
        [
            561784196.1328921,
            -4504774008.794044,
            -1574892692.955293,
        ],
    ],
    [
        1320624000000,
        [
            565105293.5712633,
            -4504638709.197222,
            -1575851100.845975,
        ],
    ],
    [
        1321228800000,
        [
            568426408.5375252,
            -4504501081.545198,
            -1576808286.214975,
        ],
    ],
    [
        1321833600000,
        [
            571747728.8896677,
            -4504361008.2702,
            -1577764634.870342,
        ],
    ],
    [
        1322438400000,
        [
            575069257.5334384,
            -4504218553.840275,
            -1578720589.774058,
        ],
    ],
    [
        1323043200000,
        [
            578390811.7358687,
            -4504073942.98299,
            -1579676495.340928,
        ],
    ],
    [
        1323648000000,
        [
            581712087.9229077,
            -4503927482.03892,
            -1580632476.585396,
        ],
    ],
    [
        1324252800000,
        [
            585032767.3509119,
            -4503779451.166997,
            -1581588394.394248,
        ],
    ],
    [
        1324857600000,
        [
            588352627.2394845,
            -4503630006.996287,
            -1582543894.815405,
        ],
    ],
    [
        1325462400000,
        [
            591671619.7809792,
            -4503479129.230557,
            -1583498535.06127,
        ],
    ],
    [
        1326067200000,
        [
            594989889.2524563,
            -4503326628.971377,
            -1584451939.869398,
        ],
    ],
    [
        1326672000000,
        [
            598307721.288762,
            -4503172215.78342,
            -1585403933.217329,
        ],
    ],
    [
        1327276800000,
        [
            601625442.6381065,
            -4503015600.33779,
            -1586354600.609644,
        ],
    ],
    [
        1327881600000,
        [
            604943305.8600591,
            -4502856597.376638,
            -1587304259.678331,
        ],
    ],
    [
        1328486400000,
        [
            608261399.9417782,
            -4502695192.16971,
            -1588253348.132863,
        ],
    ],
    [
        1329091200000,
        [
            611579619.2361349,
            -4502531546.272255,
            -1589202269.138172,
        ],
    ],
    [
        1329696000000,
        [
            614897701.2939528,
            -4502365941.187002,
            -1590151249.840801,
        ],
    ],
    [
        1330300800000,
        [
            618215319.6668627,
            -4502198680.49702,
            -1591100262.04458,
        ],
    ],
    [
        1330905600000,
        [
            621532200.1657997,
            -4502029983.535862,
            -1592049031.888071,
        ],
    ],
    [
        1331510400000,
        [
            624848218.8926417,
            -4501859906.957043,
            -1592997135.762482,
        ],
    ],
    [
        1332115200000,
        [
            628163445.1376727,
            -4501688324.510697,
            -1593944149.665241,
        ],
    ],
    [
        1332720000000,
        [
            631478116.5895655,
            -4501514972.937366,
            -1594889798.899331,
        ],
    ],
    [
        1333324800000,
        [
            634792556.9737965,
            -4501339544.707097,
            -1595834054.514838,
        ],
    ],
    [
        1333929600000,
        [
            638107062.9430187,
            -4501161795.560337,
            -1596777143.563763,
        ],
    ],
    [
        1334534400000,
        [
            641421799.1717639,
            -4500981630.347331,
            -1597719468.860795,
        ],
    ],
    [
        1335139200000,
        [
            644736739.8431255,
            -4500799136.144152,
            -1598661465.956465,
        ],
    ],
    [
        1335744000000,
        [
            648051677.7674276,
            -4500614550.6759,
            -1599603449.039982,
        ],
    ],
    [
        1336348800000,
        [
            651366296.9259684,
            -4500428178.181264,
            -1600545500.515571,
        ],
    ],
    [
        1336953600000,
        [
            654680282.614466,
            -4500240282.469039,
            -1601487441.709667,
        ],
    ],
    [
        1337558400000,
        [
            657993431.586796,
            -4500050993.987788,
            -1602428895.195484,
        ],
    ],
    [
        1338163200000,
        [
            661305723.6902065,
            -4499860263.882644,
            -1603369417.99513,
        ],
    ],
    [
        1338768000000,
        [
            664617329.006848,
            -4499667880.970384,
            -1604308657.773888,
        ],
    ],
    [
        1339372800000,
        [
            667928546.4212741,
            -4499473545.231643,
            -1605246475.905612,
        ],
    ],
    [
        1339977600000,
        [
            671239696.2791444,
            -4499276973.834065,
            -1606182996.16001,
        ],
    ],
    [
        1340582400000,
        [
            674551006.8275945,
            -4499078002.112851,
            -1607118562.081651,
        ],
    ],
    [
        1341187200000,
        [
            677862533.0564489,
            -4498876642.292552,
            -1608053615.734248,
        ],
    ],
    [
        1341792000000,
        [
            681174136.5659834,
            -4498673079.045189,
            -1608988540.987537,
        ],
    ],
    [
        1342396800000,
        [
            684485533.764925,
            -4498467604.253848,
            -1609923528.375259,
        ],
    ],
    [
        1343001600000,
        [
            687796394.4540247,
            -4498260515.045864,
            -1610858508.713531,
        ],
    ],
    [
        1343606400000,
        [
            691106456.5783283,
            -4498052010.316998,
            -1611793177.256026,
        ],
    ],
    [
        1344211200000,
        [
            694415617.7689109,
            -4497842121.377665,
            -1612727100.858469,
        ],
    ],
    [
        1344816000000,
        [
            697723970.773805,
            -4497630702.008647,
            -1613659871.362473,
        ],
    ],
    [
        1345420800000,
        [
            701031770.0431286,
            -4497417481.819786,
            -1614591250.222088,
        ],
    ],
    [
        1346025600000,
        [
            704339342.4060782,
            -4497202162.964859,
            -1615521252.863337,
        ],
    ],
    [
        1346630400000,
        [
            707646972.5866435,
            -4496984525.182489,
            -1616450143.42113,
        ],
    ],
    [
        1347235200000,
        [
            710954801.3306644,
            -4496764504.218133,
            -1617378341.833725,
        ],
    ],
    [
        1347840000000,
        [
            714262774.84538,
            -4496542216.776837,
            -1618306276.084486,
        ],
    ],
    [
        1348444800000,
        [
            717570665.180585,
            -4496317920.432967,
            -1619234231.565968,
        ],
    ],
    [
        1349049600000,
        [
            720878151.8298453,
            -4496091923.103788,
            -1620162251.29706,
        ],
    ],
    [
        1349654400000,
        [
            724184934.5825865,
            -4495864475.4889,
            -1621090121.276854,
        ],
    ],
    [
        1350259200000,
        [
            727490839.2228175,
            -4495635683.460167,
            -1622017445.280263,
        ],
    ],
    [
        1350864000000,
        [
            730795879.598813,
            -4495405470.846288,
            -1622943784.270968,
        ],
    ],
    [
        1351468800000,
        [
            734100253.1695052,
            -4495173606.700194,
            -1623868811.680972,
        ],
    ],
    [
        1352073600000,
        [
            737404271.3875072,
            -4494939787.469261,
            -1624792428.630535,
        ],
    ],
    [
        1352678400000,
        [
            740708250.3436002,
            -4494703744.483297,
            -1625714798.721735,
        ],
    ],
    [
        1353283200000,
        [
            744012400.1947708,
            -4494465339.338129,
            -1626636291.047048,
        ],
    ],
    [
        1353888000000,
        [
            747316752.0319678,
            -4494224613.024664,
            -1627557349.960403,
        ],
    ],
    [
        1354492800000,
        [
            750621147.1868184,
            -4493981770.211799,
            -1628478336.94071,
        ],
    ],
    [
        1355097600000,
        [
            753925292.6121944,
            -4493737106.652765,
            -1629399402.977164,
        ],
    ],
    [
        1355702400000,
        [
            757228864.5037526,
            -4493490905.942801,
            -1630320436.577496,
        ],
    ],
    [
        1356307200000,
        [
            760531622.6726325,
            -4493243340.002449,
            -1631241102.915327,
        ],
    ],
    [
        1356912000000,
        [
            763833495.3115698,
            -4492994407.817775,
            -1632160960.615404,
        ],
    ],
    [
        1357516800000,
        [
            767134604.4273633,
            -4492743934.923652,
            -1633079616.88407,
        ],
    ],
    [
        1358121600000,
        [
            770435222.3170527,
            -4492491634.703876,
            -1633996866.063721,
        ],
    ],
    [
        1358726400000,
        [
            773735674.7366452,
            -4492237209.508673,
            -1634912761.742242,
        ],
    ],
    [
        1359331200000,
        [
            777036225.529675,
            -4491980455.473524,
            -1635827597.637036,
        ],
    ],
    [
        1359936000000,
        [
            780336982.7196679,
            -4491721334.885913,
            -1636741804.431652,
        ],
    ],
    [
        1360540800000,
        [
            783637859.3947786,
            -4491459990.494552,
            -1637655797.704038,
        ],
    ],
    [
        1361145600000,
        [
            786938604.7504165,
            -4491196695.478178,
            -1638569830.979172,
        ],
    ],
    [
        1361750400000,
        [
            790238893.4013803,
            -4490931756.296488,
            -1639483906.530955,
        ],
    ],
    [
        1362355200000,
        [
            793538438.319211,
            -4490665404.644814,
            -1640397774.815758,
        ],
    ],
    [
        1362960000000,
        [
            796837090.0196574,
            -4490397717.63466,
            -1641311022.35409,
        ],
    ],
    [
        1363564800000,
        [
            800134889.813571,
            -4490128591.475836,
            -1642223217.328934,
        ],
    ],
    [
        1364169600000,
        [
            803432055.9003973,
            -4489857778.008083,
            -1643134062.047002,
        ],
    ],
    [
        1364774400000,
        [
            806728906.1036769,
            -4489584972.507204,
            -1644043498.02795,
        ],
    ],
    [
        1365379200000,
        [
            810025745.3916813,
            -4489309921.504246,
            -1644951726.406907,
        ],
    ],
    [
        1365984000000,
        [
            813322758.1758219,
            -4489032512.528197,
            -1645859137.273163,
        ],
    ],
    [
        1366588800000,
        [
            816619942.688313,
            -4488752814.675471,
            -1646766172.457198,
        ],
    ],
    [
        1367193600000,
        [
            819917111.1395909,
            -4488471055.051854,
            -1647673169.290479,
        ],
    ],
    [
        1367798400000,
        [
            823213956.3371825,
            -4488187539.020273,
            -1648580241.624478,
        ],
    ],
    [
        1368403200000,
        [
            826510160.7108476,
            -4487902543.335139,
            -1649487240.912732,
        ],
    ],
    [
        1369008000000,
        [
            829805508.8394748,
            -4487616219.607165,
            -1650393809.15666,
        ],
    ],
    [
        1369612800000,
        [
            833099963.5146348,
            -4487328540.231329,
            -1651299503.707945,
        ],
    ],
    [
        1370217600000,
        [
            836393678.2216793,
            -4487039307.728106,
            -1652203952.749357,
        ],
    ],
    [
        1370822400000,
        [
            839686943.3891504,
            -4486748225.431129,
            -1653106987.339965,
        ],
    ],
    [
        1371427200000,
        [
            842980084.8909737,
            -4486455002.417885,
            -1654008701.072734,
        ],
    ],
    [
        1372032000000,
        [
            846273349.7684838,
            -4486159455.416415,
            -1654909416.530558,
        ],
    ],
    [
        1372636800000,
        [
            849566819.1830548,
            -4485861572.91234,
            -1655809571.532847,
        ],
    ],
    [
        1373241600000,
        [
            852860379.1516131,
            -4485561519.196766,
            -1656709564.347501,
        ],
    ],
    [
        1373846400000,
        [
            856153760.413635,
            -4485259575.989789,
            -1657609612.307908,
        ],
    ],
    [
        1374451200000,
        [
            859446633.4058174,
            -4484956042.408213,
            -1658509675.085062,
        ],
    ],
    [
        1375056000000,
        [
            862738723.7619712,
            -4484651129.64386,
            -1659409469.575614,
        ],
    ],
    [
        1375660800000,
        [
            866029907.7808019,
            -4484344887.365034,
            -1660308569.550647,
        ],
    ],
    [
        1376265600000,
        [
            869320256.0098218,
            -4484037186.39672,
            -1661206555.158521,
        ],
    ],
    [
        1376870400000,
        [
            872610009.1472629,
            -4483727763.195894,
            -1662103160.595286,
        ],
    ],
    [
        1377475200000,
        [
            875899491.7496918,
            -4483416311.852851,
            -1662998367.480874,
        ],
    ],
    [
        1378080000000,
        [
            879188995.667657,
            -4483102592.941938,
            -1663892411.292419,
        ],
    ],
    [
        1378684800000,
        [
            882478677.1307963,
            -4482786518.736349,
            -1664785698.653844,
        ],
    ],
    [
        1379289600000,
        [
            885768501.476737,
            -4482468184.342985,
            -1665678664.298029,
        ],
    ],
    [
        1379894400000,
        [
            889058254.2497867,
            -4482147834.485394,
            -1666571617.23193,
        ],
    ],
    [
        1380499200000,
        [
            892347616.1194904,
            -4481825777.163026,
            -1667464631.14904,
        ],
    ],
    [
        1381104000000,
        [
            895636274.9320152,
            -4481502275.256862,
            -1668357518.99432,
        ],
    ],
    [
        1381708800000,
        [
            898924034.4295311,
            -4481177455.053514,
            -1669249899.64211,
        ],
    ],
    [
        1382313600000,
        [
            902210882.0793862,
            -4480851263.044312,
            -1670141331.88461,
        ],
    ],
    [
        1382918400000,
        [
            905496993.1088493,
            -4480523485.619856,
            -1671031469.81822,
        ],
    ],
    [
        1383523200000,
        [
            908782668.8061906,
            -4480193825.645542,
            -1671920185.72599,
        ],
    ],
    [
        1384128000000,
        [
            912068230.7894164,
            -4479862008.593774,
            -1672807615.776332,
        ],
    ],
    [
        1384732800000,
        [
            915353907.9702702,
            -4479527879.296388,
            -1673694111.491782,
        ],
    ],
    [
        1385337600000,
        [
            918639754.8939967,
            -4479191457.047416,
            -1674580115.905439,
        ],
    ],
    [
        1385942400000,
        [
            921925632.1641215,
            -4478852931.066589,
            -1675466008.487834,
        ],
    ],
    [
        1386547200000,
        [
            925211256.6108617,
            -4478512595.061491,
            -1676351971.344722,
        ],
    ],
    [
        1387152000000,
        [
            928496302.4844795,
            -4478170743.549321,
            -1677237924.771578,
        ],
    ],
    [
        1387756800000,
        [
            931780517.0640409,
            -4477827568.166064,
            -1678123556.015257,
        ],
    ],
    [
        1388361600000,
        [
            935063809.6235414,
            -4477483090.98237,
            -1679008429.721631,
        ],
    ],
    [
        1388966400000,
        [
            938346283.7032801,
            -4477137157.053217,
            -1679892140.579525,
        ],
    ],
    [
        1389571200000,
        [
            941628201.5739514,
            -4476789488.802849,
            -1680774456.102123,
        ],
    ],
    [
        1390176000000,
        [
            944909892.2424612,
            -4476439784.179881,
            -1681655399.11021,
        ],
    ],
    [
        1390780800000,
        [
            948191635.6815786,
            -4476087823.759871,
            -1682535239.625738,
        ],
    ],
    [
        1391385600000,
        [
            951473565.3274899,
            -4475733548.224379,
            -1683414399.464683,
        ],
    ],
    [
        1391990400000,
        [
            954755622.760978,
            -4475377078.468322,
            -1684293303.521484,
        ],
    ],
    [
        1392595200000,
        [
            958037578.0121605,
            -4475018671.752927,
            -1685172229.101286,
        ],
    ],
    [
        1393200000000,
        [
            961319109.6368529,
            -4474658630.930258,
            -1686051207.419267,
        ],
    ],
    [
        1393804800000,
        [
            964599919.0113521,
            -4474297197.665947,
            -1686930012.824232,
        ],
    ],
    [
        1394409600000,
        [
            967879836.3329988,
            -4473934466.630849,
            -1687808242.535701,
        ],
    ],
    [
        1395014400000,
        [
            971158879.9815869,
            -4473570351.485775,
            -1688685457.714173,
        ],
    ],
    [
        1395619200000,
        [
            974437249.7621824,
            -4473204614.143703,
            -1689561336.900253,
        ],
    ],
    [
        1396224000000,
        [
            977715256.1988904,
            -4472836947.659695,
            -1690435789.19398,
        ],
    ],
    [
        1396828800000,
        [
            980993209.9300263,
            -4472467084.236559,
            -1691308986.28903,
        ],
    ],
    [
        1397433600000,
        [
            984271310.9226862,
            -4472094889.493517,
            -1692181301.139708,
        ],
    ],
    [
        1398038400000,
        [
            987549577.2485305,
            -4471720409.449513,
            -1693053176.078148,
        ],
    ],
    [
        1398643200000,
        [
            990827837.915657,
            -4471343854.649931,
            -1693924967.413352,
        ],
    ],
    [
        1399248000000,
        [
            994105792.63979,
            -4470965526.492993,
            -1694796819.710423,
        ],
    ],
    [
        1399852800000,
        [
            997383117.5608702,
            -4470585709.930103,
            -1695668613.82677,
        ],
    ],
    [
        1400457600000,
        [
            1000659577.585383,
            -4470204572.372656,
            -1696540008.694409,
        ],
    ],
    [
        1401062400000,
        [
            1003935107.409356,
            -4469822106.343794,
            -1697410562.317403,
        ],
    ],
    [
        1401667200000,
        [
            1007209834.260505,
            -4469438133.111835,
            -1698279887.347339,
        ],
    ],
    [
        1402272000000,
        [
            1010484033.211423,
            -4469052365.352065,
            -1699147787.308153,
        ],
    ],
    [
        1402876800000,
        [
            1013758029.606898,
            -4468664508.57497,
            -1700014326.341952,
        ],
    ],
    [
        1403481600000,
        [
            1017032083.095463,
            -4468274365.781703,
            -1700879806.630841,
        ],
    ],
    [
        1404086400000,
        [
            1020306295.285236,
            -4467881907.450667,
            -1701744661.330225,
        ],
    ],
    [
        1404691200000,
        [
            1023580573.69013,
            -4467487282.262137,
            -1702609302.112037,
        ],
    ],
    [
        1405296000000,
        [
            1026854663.632749,
            -4467090765.736582,
            -1703473974.802447,
        ],
    ],
    [
        1405900800000,
        [
            1030128237.326319,
            -4466692664.442102,
            -1704338672.780902,
        ],
    ],
    [
        1406505600000,
        [
            1033401009.913761,
            -4466293208.859665,
            -1705203139.53548,
        ],
    ],
    [
        1407110400000,
        [
            1036672841.043172,
            -4465892472.512076,
            -1706066959.669968,
        ],
    ],
    [
        1407715200000,
        [
            1039943783.949304,
            -4465490345.804893,
            -1706929704.82064,
        ],
    ],
    [
        1408320000000,
        [
            1043214065.578527,
            -4465086575.195893,
            -1707791084.109968,
        ],
    ],
    [
        1408924800000,
        [
            1046484007.499859,
            -4464680853.558836,
            -1708651047.59207,
        ],
    ],
    [
        1409529600000,
        [
            1049753913.423296,
            -4464272928.977916,
            -1709509804.529437,
        ],
    ],
    [
        1410134400000,
        [
            1053023962.18111,
            -4463862693.614973,
            -1710367748.952288,
        ],
    ],
    [
        1410739200000,
        [
            1056294145.036847,
            -4463450221.153209,
            -1711225319.932034,
        ],
    ],
    [
        1411344000000,
        [
            1059564269.091671,
            -4463035740.36517,
            -1712082846.986589,
        ],
    ],
    [
        1411948800000,
        [
            1062834024.85203,
            -4462619554.664368,
            -1712940434.058754,
        ],
    ],
    [
        1412553600000,
        [
            1066103094.901089,
            -4462201935.19295,
            -1713797922.319134,
        ],
    ],
    [
        1413158400000,
        [
            1069371265.67676,
            -4461783025.10067,
            -1714654945.975816,
        ],
    ],
    [
        1413763200000,
        [
            1072638502.495911,
            -4461362789.499468,
            -1715511061.552264,
        ],
    ],
    [
        1414368000000,
        [
            1075904961.941645,
            -4460941028.182501,
            -1716365903.923735,
        ],
    ],
    [
        1414972800000,
        [
            1079170937.523741,
            -4460517444.89254,
            -1717219314.091959,
        ],
    ],
    [
        1415577600000,
        [
            1082436755.145586,
            -4460091750.633906,
            -1718071395.13882,
        ],
    ],
    [
        1416182400000,
        [
            1085702656.341851,
            -4459663766.946385,
            -1718922476.402599,
        ],
    ],
    [
        1416787200000,
        [
            1088968713.07407,
            -4459233489.567945,
            -1719772996.813434,
        ],
    ],
    [
        1417392000000,
        [
            1092234802.956382,
            -4458801089.099022,
            -1720623349.584851,
        ],
    ],
    [
        1417996800000,
        [
            1095500652.048211,
            -4458366850.4845,
            -1721473743.943979,
        ],
    ],
    [
        1418601600000,
        [
            1098765930.224533,
            -4457931072.933821,
            -1722324131.23106,
        ],
    ],
    [
        1419206400000,
        [
            1102030366.686299,
            -4457493964.609774,
            -1723174221.547028,
        ],
    ],
    [
        1419811200000,
        [
            1105293844.734766,
            -4457055569.49808,
            -1724023585.991944,
        ],
    ],
    [
        1420416000000,
        [
            1108556441.920479,
            -4456615752.646817,
            -1724871807.971164,
        ],
    ],
    [
        1421020800000,
        [
            1111818402.009584,
            -4456174248.526375,
            -1725718629.785563,
        ],
    ],
    [
        1421625600000,
        [
            1115080049.376981,
            -4455730755.278924,
            -1726564043.938495,
        ],
    ],
    [
        1422230400000,
        [
            1118341675.300658,
            -4455285041.835623,
            -1727408296.700875,
        ],
    ],
    [
        1422835200000,
        [
            1121603434.640901,
            -4454837029.367466,
            -1728251800.648267,
        ],
    ],
    [
        1423440000000,
        [
            1124865289.822364,
            -4454386819.442055,
            -1729094988.286094,
        ],
    ],
    [
        1424044800000,
        [
            1128127024.696158,
            -4453934659.26158,
            -1729938160.384464,
        ],
    ],
    [
        1424649600000,
        [
            1131388321.669672,
            -4453480855.275184,
            -1730781380.936411,
        ],
    ],
    [
        1425254400000,
        [
            1134648873.763066,
            -4453025665.481854,
            -1731624454.26108,
        ],
    ],
    [
        1425859200000,
        [
            1137908493.091022,
            -4452569208.336443,
            -1732466993.511341,
        ],
    ],
    [
        1426464000000,
        [
            1141167177.243204,
            -4452111421.049828,
            -1733308557.120025,
        ],
    ],
    [
        1427068800000,
        [
            1144425109.995507,
            -4451652082.0133,
            -1734148804.19644,
        ],
    ],
    [
        1427673600000,
        [
            1147682596.849755,
            -4451190888.728801,
            -1734987614.18659,
        ],
    ],
    [
        1428278400000,
        [
            1150939957.817367,
            -4450727564.292496,
            -1735825129.840009,
        ],
    ],
    [
        1428883200000,
        [
            1154197414.429051,
            -4450261955.75912,
            -1736661707.485051,
        ],
    ],
    [
        1429488000000,
        [
            1157455012.000977,
            -4449794088.601626,
            -1737497790.872396,
        ],
    ],
    [
        1430092800000,
        [
            1160712605.171442,
            -4449324156.331024,
            -1738333753.595893,
        ],
    ],
    [
        1430697600000,
        [
            1163969909.039367,
            -4448852450.444979,
            -1739169766.999199,
        ],
    ],
    [
        1431302400000,
        [
            1167226598.207339,
            -4448379258.27407,
            -1740005740.247942,
        ],
    ],
    [
        1431907200000,
        [
            1170482421.702592,
            -4447904762.11001,
            -1740841352.081518,
        ],
    ],
    [
        1432512000000,
        [
            1173737292.053723,
            -4447428973.903475,
            -1741676163.427761,
        ],
    ],
    [
        1433116800000,
        [
            1176991315.76326,
            -4446951730.083346,
            -1742509771.705484,
        ],
    ],
    [
        1433721600000,
        [
            1180244754.885296,
            -4446472748.473002,
            -1743341951.826518,
        ],
    ],
    [
        1434326400000,
        [
            1183497934.146663,
            -4445991726.698556,
            -1744172734.88414,
        ],
    ],
    [
        1434931200000,
        [
            1186751125.571862,
            -4445508448.274736,
            -1745002397.578036,
        ],
    ],
    [
        1435536000000,
        [
            1190004450.733409,
            -4445022859.296024,
            -1745831364.530374,
        ],
    ],
    [
        1436140800000,
        [
            1193257836.413372,
            -4444535087.573406,
            -1746660057.540098,
        ],
    ],
    [
        1436745600000,
        [
            1196511040.080323,
            -4444045397.373259,
            -1747488746.705731,
        ],
    ],
    [
        1437350400000,
        [
            1199763735.396259,
            -4443554096.304638,
            -1748317455.976401,
        ],
    ],
    [
        1437955200000,
        [
            1203015626.074226,
            -4443061426.410213,
            -1749145954.218124,
        ],
    ],
    [
        1438560000000,
        [
            1206266547.785014,
            -4442567478.836149,
            -1749973835.917661,
        ],
    ],
    [
        1439164800000,
        [
            1209516524.8265,
            -4442072163.07443,
            -1750800664.69174,
        ],
    ],
    [
        1439769600000,
        [
            1212765761.285328,
            -4441575239.752758,
            -1751626127.407102,
        ],
    ],
    [
        1440374400000,
        [
            1216014568.597858,
            -4441076405.096602,
            -1752450144.072141,
        ],
    ],
    [
        1440979200000,
        [
            1219263255.293554,
            -4440575397.962926,
            -1753272896.173169,
        ],
    ],
    [
        1441584000000,
        [
            1222512017.117857,
            -4440072092.749506,
            -1754094763.49193,
        ],
    ],
    [
        1442188800000,
        [
            1225760866.51991,
            -4439566545.000296,
            -1754916190.077875,
        ],
    ],
    [
        1442793600000,
        [
            1229009627.638753,
            -4439058972.487241,
            -1755737527.066598,
        ],
    ],
    [
        1443398400000,
        [
            1232257998.324218,
            -4438549678.949369,
            -1756558909.464308,
        ],
    ],
    [
        1444003200000,
        [
            1235505656.174868,
            -4438038948.576322,
            -1757380209.801988,
        ],
    ],
    [
        1444608000000,
        [
            1238752372.144336,
            -4437526947.574588,
            -1758201083.377395,
        ],
    ],
    [
        1445212800000,
        [
            1241998092.503696,
            -4437013665.803046,
            -1759021089.548463,
        ],
    ],
    [
        1445817600000,
        [
            1245242957.619135,
            -4436498919.934629,
            -1759839846.833976,
        ],
    ],
    [
        1446422400000,
        [
            1248487251.348447,
            -4435982419.418715,
            -1760657167.577506,
        ],
    ],
    [
        1447027200000,
        [
            1251731302.074049,
            -4435463870.054885,
            -1761473124.401584,
        ],
    ],
    [
        1447632000000,
        [
            1254975368.534762,
            -4434943077.665343,
            -1762288025.166926,
        ],
    ],
    [
        1448236800000,
        [
            1258219548.851675,
            -4434420016.799814,
            -1763102304.657788,
        ],
    ],
    [
        1448841600000,
        [
            1261463745.877553,
            -4433894839.817513,
            -1763916370.440969,
        ],
    ],
    [
        1449446400000,
        [
            1264707702.097807,
            -4433367822.564697,
            -1764730458.44777,
        ],
    ],
    [
        1450051200000,
        [
            1267951091.001165,
            -4432839266.659637,
            -1765544550.176987,
        ],
    ],
    [
        1450656000000,
        [
            1271193631.85609,
            -4432309393.436257,
            -1766358379.44041,
        ],
    ],
    [
        1451260800000,
        [
            1274435188.41312,
            -4431778266.021366,
            -1767171525.536375,
        ],
    ],
    [
        1451865600000,
        [
            1277675817.396603,
            -4431245766.920426,
            -1767983561.395614,
        ],
    ],
    [
        1452470400000,
        [
            1280915749.317104,
            -4430711639.306849,
            -1768794204.273898,
        ],
    ],
    [
        1453075200000,
        [
            1284155307.54161,
            -4430175576.253795,
            -1769603414.300509,
        ],
    ],
    [
        1453680000000,
        [
            1287394793.25349,
            -4429637327.490005,
            -1770411407.52692,
        ],
    ],
    [
        1454284800000,
        [
            1290634378.510275,
            -4429096788.15174,
            -1771218580.574319,
        ],
    ],
    [
        1454889600000,
        [
            1293874045.418682,
            -4428554036.224879,
            -1772025370.808844,
        ],
    ],
    [
        1455494400000,
        [
            1297113592.280766,
            -4428009304.19805,
            -1772832100.851246,
        ],
    ],
    [
        1456099200000,
        [
            1300352704.549432,
            -4427462895.837483,
            -1773638864.2475,
        ],
    ],
    [
        1456704000000,
        [
            1303591064.819747,
            -4426915078.662992,
            -1774445492.765805,
        ],
    ],
    [
        1457308800000,
        [
            1306828463.180547,
            -4426365989.817814,
            -1775251615.329225,
        ],
    ],
    [
        1457913600000,
        [
            1310064870.118746,
            -4425815587.554936,
            -1776056788.0954,
        ],
    ],
    [
        1458518400000,
        [
            1313300446.013076,
            -4425263665.915513,
            -1776860650.945686,
        ],
    ],
    [
        1459123200000,
        [
            1316535483.374586,
            -4424709928.022627,
            -1777663054.685585,
        ],
    ],
    [
        1459728000000,
        [
            1319770303.143506,
            -4424154091.499054,
            -1778464113.472409,
        ],
    ],
    [
        1460332800000,
        [
            1323005142.17209,
            -4423595987.707017,
            -1779264164.560607,
        ],
    ],
    [
        1460937600000,
        [
            1326240068.737842,
            -4423035620.582018,
            -1780063649.400012,
        ],
    ],
    [
        1461542400000,
        [
            1329474955.976237,
            -4422473166.376036,
            -1780862957.768822,
        ],
    ],
    [
        1462147200000,
        [
            1332709526.49943,
            -4421908912.692149,
            -1781662290.34762,
        ],
    ],
    [
        1462752000000,
        [
            1335943451.031291,
            -4421343157.103065,
            -1782461588.489734,
        ],
    ],
    [
        1463356800000,
        [
            1339176464.031163,
            -4420776102.611885,
            -1783260555.294759,
        ],
    ],
    [
        1463961600000,
        [
            1342408456.506944,
            -4420207786.486988,
            -1784058759.660957,
        ],
    ],
    [
        1464566400000,
        [
            1345639514.312007,
            -4419638067.046594,
            -1784855787.929888,
        ],
    ],
    [
        1465171200000,
        [
            1348869887.609329,
            -4419066673.8717,
            -1785651390.123569,
        ],
    ],
    [
        1465776000000,
        [
            1352099902.017454,
            -4418493303.787036,
            -1786445568.102733,
        ],
    ],
    [
        1466380800000,
        [
            1355329843.564817,
            -4417917728.096404,
            -1787238574.575515,
        ],
    ],
    [
        1466985600000,
        [
            1358559858.149546,
            -4417339873.580731,
            -1788030824.501606,
        ],
    ],
    [
        1467590400000,
        [
            1361789900.555295,
            -4416759849.034956,
            -1788822749.361829,
        ],
    ],
    [
        1468195200000,
        [
            1365019750.905611,
            -4416177906.275803,
            -1789614644.120063,
        ],
    ],
    [
        1468800000000,
        [
            1368249091.476433,
            -4415594350.115805,
            -1790406562.310141,
        ],
    ],
    [
        1469404800000,
        [
            1371477617.966549,
            -4415009431.604768,
            -1791198298.000636,
        ],
    ],
    [
        1470009600000,
        [
            1374705146.876794,
            -4414423260.346587,
            -1791989458.668872,
        ],
    ],
    [
        1470614400000,
        [
            1377931680.463909,
            -4413835765.176717,
            -1792779602.487691,
        ],
    ],
    [
        1471219200000,
        [
            1381157406.063891,
            -4413246718.104946,
            -1793568393.676014,
        ],
    ],
    [
        1471824000000,
        [
            1384382629.286115,
            -4412655814.310644,
            -1794355720.979974,
        ],
    ],
    [
        1472428800000,
        [
            1387607665.066917,
            -4412062779.525948,
            -1795141736.271481,
        ],
    ],
    [
        1473033600000,
        [
            1390832725.917001,
            -4411467466.202984,
            -1795926800.32143,
        ],
    ],
    [
        1473638400000,
        [
            1394057846.141098,
            -4410869905.343596,
            -1796711355.851657,
        ],
    ],
    [
        1474243200000,
        [
            1397282868.31488,
            -4410270296.152914,
            -1797495771.494991,
        ],
    ],
    [
        1474848000000,
        [
            1400507498.092223,
            -4409668936.274865,
            -1798280211.491571,
        ],
    ],
    [
        1475452800000,
        [
            1403731408.354536,
            -4409066116.58377,
            -1799064577.880226,
        ],
    ],
    [
        1476057600000,
        [
            1406954353.48957,
            -4408462017.92328,
            -1799848544.860284,
        ],
    ],
    [
        1476662400000,
        [
            1410176253.17023,
            -4407856648.051082,
            -1800631673.089704,
        ],
    ],
    [
        1477267200000,
        [
            1413397220.021724,
            -4407249840.047367,
            -1801413564.588987,
        ],
    ],
    [
        1477872000000,
        [
            1416617520.291678,
            -4406641311.431965,
            -1802194003.654297,
        ],
    ],
    [
        1478476800000,
        [
            1419837479.171552,
            -4406030764.221324,
            -1802973033.181191,
        ],
    ],
    [
        1479081600000,
        [
            1423057365.012309,
            -4405417990.507705,
            -1803750938.98881,
        ],
    ],
    [
        1479686400000,
        [
            1426277294.201651,
            -4404802945.958122,
            -1804528148.875931,
        ],
    ],
    [
        1480291200000,
        [
            1429497189.411324,
            -4404185766.179369,
            -1805305082.40511,
        ],
    ],
    [
        1480896000000,
        [
            1432716805.871146,
            -4403566720.025497,
            -1806082003.037727,
        ],
    ],
    [
        1481500800000,
        [
            1435935817.307396,
            -4402946115.60146,
            -1806858925.233655,
        ],
    ],
    [
        1482105600000,
        [
            1439153930.959353,
            -4402324192.762211,
            -1807635610.278104,
        ],
    ],
    [
        1482710400000,
        [
            1442370990.920458,
            -4401701040.199391,
            -1808411651.153208,
        ],
    ],
    [
        1483315200000,
        [
            1445587033.924288,
            -4401076564.307991,
            -1809186615.195306,
        ],
    ],
    [
        1483920000000,
        [
            1448802276.398975,
            -4400450521.28285,
            -1809960196.015449,
        ],
    ],
    [
        1484524800000,
        [
            1452017037.601304,
            -4399822604.327031,
            -1810732322.649561,
        ],
    ],
    [
        1485129600000,
        [
            1455231627.663634,
            -4399192553.355334,
            -1811503185.20435,
        ],
    ],
    [
        1485734400000,
        [
            1458446239.282208,
            -4398560246.634188,
            -1812273167.158327,
        ],
    ],
    [
        1486339200000,
        [
            1461660880.685288,
            -4397925743.009832,
            -1813042709.883164,
        ],
    ],
    [
        1486944000000,
        [
            1464875372.937257,
            -4397289260.961719,
            -1813812157.098349,
        ],
    ],
    [
        1487548800000,
        [
            1468089413.040482,
            -4396651101.380549,
            -1814581633.194161,
        ],
    ],
    [
        1488153600000,
        [
            1471302681.085304,
            -4396011540.923656,
            -1815350999.084838,
        ],
    ],
    [
        1488758400000,
        [
            1474514952.933442,
            -4395370734.291152,
            -1816119901.497583,
        ],
    ],
    [
        1489363200000,
        [
            1477726178.57605,
            -4394728659.954886,
            -1816887897.079181,
        ],
    ],
    [
        1489968000000,
        [
            1480936500.071079,
            -4394085127.405937,
            -1817654607.762315,
        ],
    ],
    [
        1490572800000,
        [
            1484146202.881449,
            -4393439843.219294,
            -1818419854.125739,
        ],
    ],
    [
        1491177600000,
        [
            1487355615.112803,
            -4392792513.023237,
            -1819183718.431303,
        ],
    ],
    [
        1491782400000,
        [
            1490564989.520904,
            -4392142944.803027,
            -1819946514.614034,
        ],
    ],
    [
        1492387200000,
        [
            1493774413.70834,
            -4391491116.806919,
            -1820708677.154744,
        ],
    ],
    [
        1492992000000,
        [
            1496983779.680869,
            -4390837184.568254,
            -1821470607.934227,
        ],
    ],
    [
        1493596800000,
        [
            1500192821.274691,
            -4390181425.248927,
            -1822232534.103534,
        ],
    ],
    [
        1494201600000,
        [
            1503401206.935468,
            -4389524139.051637,
            -1822994427.2257,
        ],
    ],
    [
        1494806400000,
        [
            1506608655.451954,
            -4388865542.725946,
            -1823756013.109077,
        ],
    ],
    [
        1495411200000,
        [
            1509815033.336761,
            -4388205693.204106,
            -1824516868.452752,
        ],
    ],
    [
        1496016000000,
        [
            1513020399.98071,
            -4387544467.734608,
            -1825276569.215282,
        ],
    ],
    [
        1496620800000,
        [
            1516224985.649933,
            -4386881606.842581,
            -1826034839.469883,
        ],
    ],
    [
        1497225600000,
        [
            1519429109.355826,
            -4386216806.094502,
            -1826791649.524117,
        ],
    ],
    [
        1497830400000,
        [
            1522633065.173785,
            -4385549824.72442,
            -1827547227.179166,
        ],
    ],
    [
        1498435200000,
        [
            1525837017.969665,
            -4384880570.769954,
            -1828301976.687779,
        ],
    ],
    [
        1499040000000,
        [
            1529040944.0061,
            -4384209132.552641,
            -1829056335.313567,
        ],
    ],
    [
        1499644800000,
        [
            1532244637.225712,
            -4383535748.677956,
            -1829810619.899657,
        ],
    ],
    [
        1500249600000,
        [
            1535447781.294979,
            -4382860725.651073,
            -1830564915.793902,
        ],
    ],
    [
        1500854400000,
        [
            1538650061.26299,
            -4382184330.187388,
            -1831319046.810373,
        ],
    ],
    [
        1501459200000,
        [
            1541851274.096777,
            -4381506695.540977,
            -1832072637.769041,
        ],
    ],
    [
        1502064000000,
        [
            1545051399.046484,
            -4380827775.496159,
            -1832825246.797199,
        ],
    ],
    [
        1502668800000,
        [
            1548250604.217702,
            -4380147361.257391,
            -1833576520.37921,
        ],
    ],
    [
        1503273600000,
        [
            1551449187.415554,
            -4379465155.150185,
            -1834326318.119882,
        ],
    ],
    [
        1503878400000,
        [
            1554647470.782204,
            -4378780876.393676,
            -1835074763.34772,
        ],
    ],
    [
        1504483200000,
        [
            1557845686.286002,
            -4378094361.577354,
            -1835822200.038817,
        ],
    ],
    [
        1505088000000,
        [
            1561043893.850012,
            -4377405623.381483,
            -1836569071.258684,
        ],
    ],
    [
        1505692800000,
        [
            1564241961.540924,
            -4376714846.408239,
            -1837315763.218585,
        ],
    ],
    [
        1506297600000,
        [
            1567439612.753356,
            -4376022321.559111,
            -1838062469.093784,
        ],
    ],
    [
        1506902400000,
        [
            1570636522.493974,
            -4375328343.336213,
            -1838809120.387187,
        ],
    ],
    [
        1507507200000,
        [
            1573832431.769043,
            -4374633107.071078,
            -1839555411.633535,
        ],
    ],
    [
        1508112000000,
        [
            1577027239.689906,
            -4373936640.706772,
            -1840300908.72761,
        ],
    ],
    [
        1508716800000,
        [
            1580221039.068496,
            -4373238794.905884,
            -1841045201.267285,
        ],
    ],
    [
        1509321600000,
        [
            1583414083.922728,
            -4372539294.809689,
            -1841788046.045638,
        ],
    ],
    [
        1509926400000,
        [
            1586606700.255267,
            -4371837836.028064,
            -1842529452.94814,
        ],
    ],
    [
        1510531200000,
        [
            1589799170.387889,
            -4371134192.042197,
            -1843269681.9563,
        ],
    ],
    [
        1511136000000,
        [
            1592991632.297723,
            -4370428294.315781,
            -1844009150.845645,
        ],
    ],
    [
        1511740800000,
        [
            1596184030.463293,
            -4369720256.126657,
            -1844748287.091698,
        ],
    ],
    [
        1512345600000,
        [
            1599376135.094124,
            -4369010332.545789,
            -1845487377.380427,
        ],
    ],
    [
        1512950400000,
        [
            1602567622.769152,
            -4368298831.042064,
            -1846226466.813917,
        ],
    ],
    [
        1513555200000,
        [
            1605758190.812067,
            -4367586002.668632,
            -1846965342.566104,
        ],
    ],
    [
        1514160000000,
        [
            1608947663.17838,
            -4366871952.255659,
            -1847703608.305054,
        ],
    ],
    [
        1514764800000,
        [
            1612136050.112118,
            -4366156602.139593,
            -1848440824.027507,
        ],
    ],
    [
        1515369600000,
        [
            1615323543.738974,
            -4365439720.796878,
            -1849176660.952116,
        ],
    ],
    [
        1515974400000,
        [
            1618510450.895802,
            -4364721003.949965,
            -1849911016.901882,
        ],
    ],
    [
        1516579200000,
        [
            1621697084.765113,
            -4364000181.346894,
            -1850644052.822561,
        ],
    ],
    [
        1517184000000,
        [
            1624883653.012786,
            -4363277112.575727,
            -1851376136.234838,
        ],
    ],
    [
        1517788800000,
        [
            1628070183.271128,
            -4362551836.974249,
            -1852107710.858477,
        ],
    ],
    [
        1518393600000,
        [
            1631256512.86999,
            -4361824559.691385,
            -1852839139.875592,
        ],
    ],
    [
        1518998400000,
        [
            1634442345.374691,
            -4361095579.8616,
            -1853570578.442505,
        ],
    ],
    [
        1519603200000,
        [
            1637627354.007325,
            -4360365186.10646,
            -1854301919.079836,
        ],
    ],
    [
        1520208000000,
        [
            1640811296.514209,
            -4359633555.617329,
            -1855032829.746918,
        ],
    ],
    [
        1520812800000,
        [
            1643994100.963655,
            -4358900692.54265,
            -1855762871.621937,
        ],
    ],
    [
        1521417600000,
        [
            1647175891.149245,
            -4358166426.556038,
            -1856491653.495956,
        ],
    ],
    [
        1522022400000,
        [
            1650356941.631128,
            -4357430472.54877,
            -1857218968.551637,
        ],
    ],
    [
        1522627200000,
        [
            1653537580.632363,
            -4356692531.969422,
            -1857944867.814703,
        ],
    ],
    [
        1523232000000,
        [
            1656718075.075627,
            -4355952399.034931,
            -1858669643.371018,
        ],
    ],
    [
        1523836800000,
        [
            1659898536.475589,
            -4355210033.663009,
            -1859393725.220643,
        ],
    ],
    [
        1524441600000,
        [
            1663078881.619946,
            -4354465575.253558,
            -1860117528.73737,
        ],
    ],
    [
        1525046400000,
        [
            1666258862.159812,
            -4353719292.974324,
            -1860841308.140148,
        ],
    ],
    [
        1525651200000,
        [
            1669438151.761312,
            -4352971490.939661,
            -1861565067.13107,
        ],
    ],
    [
        1526256000000,
        [
            1672616460.623725,
            -4352222401.025336,
            -1862288557.094828,
        ],
    ],
    [
        1526860800000,
        [
            1675793637.508946,
            -4351472100.798283,
            -1863011364.54705,
        ],
    ],
    [
        1527465600000,
        [
            1678969722.585611,
            -4350720486.379061,
            -1863733057.263299,
        ],
    ],
    [
        1528070400000,
        [
            1682144932.839309,
            -4349967309.59618,
            -1864453336.407479,
        ],
    ],
    [
        1528675200000,
        [
            1685319586.43435,
            -4349212264.666048,
            -1865172141.029015,
        ],
    ],
    [
        1529280000000,
        [
            1688493990.570804,
            -4348455094.043193,
            -1865889669.099093,
        ],
    ],
    [
        1529884800000,
        [
            1691668330.856246,
            -4347695679.267976,
            -1866606307.854712,
        ],
    ],
    [
        1530489600000,
        [
            1694842604.79364,
            -4346934083.691781,
            -1867322497.077395,
        ],
    ],
    [
        1531094400000,
        [
            1698016622.955807,
            -4346170529.46581,
            -1868038573.415124,
        ],
    ],
    [
        1531699200000,
        [
            1701190075.33777,
            -4345405318.268109,
            -1868754651.657885,
        ],
    ],
    [
        1532304000000,
        [
            1704362639.088744,
            -4344638724.737274,
            -1869470583.99726,
        ],
    ],
    [
        1532908800000,
        [
            1707534090.84912,
            -4343870899.358576,
            -1870186011.374231,
        ],
    ],
    [
        1533513600000,
        [
            1710704384.246921,
            -4343101815.118466,
            -1870900489.93942,
        ],
    ],
    [
        1534118400000,
        [
            1713873664.475389,
            -4342331277.42161,
            -1871613647.735275,
        ],
    ],
    [
        1534723200000,
        [
            1717042215.212872,
            -4341558993.364477,
            -1872325315.404663,
        ],
    ],
    [
        1535328000000,
        [
            1720210357.61869,
            -4340784675.429045,
            -1873035585.812153,
        ],
    ],
    [
        1535932800000,
        [
            1723378336.666493,
            -4340008143.676029,
            -1873744782.298958,
        ],
    ],
    [
        1536537600000,
        [
            1726546233.96343,
            -4339229389.618667,
            -1874453344.659536,
        ],
    ],
    [
        1537142400000,
        [
            1729713936.906332,
            -4338448579.03018,
            -1875161673.030635,
        ],
    ],
    [
        1537747200000,
        [
            1732881176.819289,
            -4337665994.742114,
            -1875869987.40812,
        ],
    ],
    [
        1538352000000,
        [
            1736047623.380785,
            -4336881938.697635,
            -1876578251.403404,
        ],
    ],
    [
        1538956800000,
        [
            1739213000.527282,
            -4336096626.523713,
            -1877286185.008528,
        ],
    ],
    [
        1539561600000,
        [
            1742377183.368623,
            -4335310111.854852,
            -1877993362.960871,
        ],
    ],
    [
        1540166400000,
        [
            1745540241.757621,
            -4334522268.022728,
            -1878699365.140082,
        ],
    ],
    [
        1540771200000,
        [
            1748702414.785926,
            -4333732833.89535,
            -1879403925.088499,
        ],
    ],
    [
        1541376000000,
        [
            1751864025.907202,
            -4332941506.931395,
            -1880107023.751721,
        ],
    ],
    [
        1541980800000,
        [
            1755025368.928018,
            -4332148050.512341,
            -1880808896.540614,
        ],
    ],
    [
        1542585600000,
        [
            1758186604.163234,
            -4331352378.677479,
            -1881509951.275656,
        ],
    ],
    [
        1543190400000,
        [
            1761347701.851889,
            -4330554588.039551,
            -1882210624.678549,
        ],
    ],
    [
        1543795200000,
        [
            1764508454.060107,
            -4329754924.141307,
            -1882911228.222753,
        ],
    ],
    [
        1544400000000,
        [
            1767668549.005419,
            -4328953693.984197,
            -1883611838.344871,
        ],
    ],
    [
        1545004800000,
        [
            1770827679.583911,
            -4328151158.408297,
            -1884312269.780296,
        ],
    ],
    [
        1545609600000,
        [
            1773985651.50393,
            -4327347441.654955,
            -1885012140.830701,
        ],
    ],
    [
        1546214400000,
        [
            1777142453.416975,
            -4326542487.406833,
            -1885711007.79372,
        ],
    ],
    [
        1546819200000,
        [
            1780298261.715055,
            -4325736078.083623,
            -1886408521.538873,
        ],
    ],
    [
        1547424000000,
        [
            1783453378.140751,
            -4324927911.309138,
            -1887104550.161317,
        ],
    ],
    [
        1548028800000,
        [
            1786608123.398482,
            -4324117705.879979,
            -1887799224.696648,
        ],
    ],
    [
        1548633600000,
        [
            1789762724.099984,
            -4323305300.252616,
            -1888492892.89064,
        ],
    ],
    [
        1549238400000,
        [
            1792917232.142641,
            -4322490709.412889,
            -1889185996.487642,
        ],
    ],
    [
        1549843200000,
        [
            1796071505.693787,
            -4321674119.366364,
            -1889878914.702978,
        ],
    ],
    [
        1550448000000,
        [
            1799225259.057566,
            -4320855821.099725,
            -1890571830.280427,
        ],
    ],
    [
        1551052800000,
        [
            1802378163.444962,
            -4320036107.999724,
            -1891264665.717414,
        ],
    ],
    [
        1551657600000,
        [
            1805529962.572779,
            -4319215172.044052,
            -1891957110.131443,
        ],
    ],
    [
        1552262400000,
        [
            1808680561.517798,
            -4318393034.652316,
            -1892648727.151966,
        ],
    ],
    [
        1552867200000,
        [
            1811830058.53479,
            -4317569539.039077,
            -1893339108.690821,
        ],
    ],
    [
        1553472000000,
        [
            1814978709.906593,
            -4316744406.217087,
            -1894028019.57327,
        ],
    ],
    [
        1554076800000,
        [
            1818126838.925921,
            -4315917333.275444,
            -1894715479.99099,
        ],
    ],
    [
        1554681600000,
        [
            1821274721.104984,
            -4315088099.475536,
            -1895401757.730083,
        ],
    ],
    [
        1555286400000,
        [
            1824422485.753338,
            -4314256643.909429,
            -1896087273.899631,
        ],
    ],
    [
        1555891200000,
        [
            1827570068.584537,
            -4313423087.395999,
            -1896772454.144789,
        ],
    ],
    [
        1556496000000,
        [
            1830717233.120548,
            -4312587689.952115,
            -1897457577.99062,
        ],
    ],
    [
        1557100800000,
        [
            1833863653.116282,
            -4311750759.266625,
            -1898142680.735809,
        ],
    ],
    [
        1557705600000,
        [
            1837009025.961567,
            -4310912543.409335,
            -1898827541.905967,
        ],
    ],
    [
        1558310400000,
        [
            1840153177.873573,
            -4310073144.967382,
            -1899511762.913886,
        ],
    ],
    [
        1558915200000,
        [
            1843296125.369848,
            -4309232485.409451,
            -1900194907.258308,
        ],
    ],
    [
        1559520000000,
        [
            1846438069.610421,
            -4308390332.112921,
            -1900876654.425828,
        ],
    ],
    [
        1560124800000,
        [
            1849579323.346077,
            -4307546380.882703,
            -1901556913.139444,
        ],
    ],
    [
        1560729600000,
        [
            1852720199.403828,
            -4306700365.161407,
            -1902235853.990864,
        ],
    ],
    [
        1561334400000,
        [
            1855860901.00398,
            -4305852150.831134,
            -1902913849.71144,
        ],
    ],
    [
        1561939200000,
        [
            1859001450.069448,
            -4305001783.887881,
            -1903591344.06075,
        ],
    ],
    [
        1562544000000,
        [
            1862141678.908465,
            -4304149474.601346,
            -1904268694.911541,
        ],
    ],
    [
        1563148800000,
        [
            1865281289.28736,
            -4303295523.29536,
            -1904946047.813312,
        ],
    ],
    [
        1563753600000,
        [
            1868419957.413445,
            -4302440214.693327,
            -1905623285.465583,
        ],
    ],
    [
        1564358400000,
        [
            1871557447.021804,
            -4301583718.572661,
            -1906300069.496379,
        ],
    ],
    [
        1564963200000,
        [
            1874693691.863159,
            -4300726030.56312,
            -1906975958.964449,
        ],
    ],
    [
        1565568000000,
        [
            1877828819.231428,
            -4299866973.760276,
            -1907650565.653219,
        ],
    ],
    [
        1566172800000,
        [
            1880963105.516594,
            -4299006261.600727,
            -1908323691.793641,
        ],
    ],
    [
        1566777600000,
        [
            1884096879.18887,
            -4298143598.973433,
            -1908995399.827778,
        ],
    ],
    [
        1567382400000,
        [
            1887230404.300082,
            -4297278785.146394,
            -1909665989.332165,
        ],
    ],
    [
        1567987200000,
        [
            1890363785.806418,
            -4296411784.81304,
            -1910335891.506626,
        ],
    ],
    [
        1568592000000,
        [
            1893496932.154031,
            -4295542741.701756,
            -1911005517.590258,
        ],
    ],
    [
        1569196800000,
        [
            1896629587.781966,
            -4294671927.644426,
            -1911675113.228,
        ],
    ],
    [
        1569801600000,
        [
            1899761423.207697,
            -4293799645.808093,
            -1912344671.597022,
        ],
    ],
    [
        1570406400000,
        [
            1902892150.213972,
            -4292926123.673749,
            -1913013936.317954,
        ],
    ],
    [
        1571011200000,
        [
            1906021621.624178,
            -4292051433.418353,
            -1913682491.492244,
        ],
    ],
    [
        1571616000000,
        [
            1909149881.970786,
            -4291175466.440299,
            -1914349907.214303,
        ],
    ],
    [
        1572220800000,
        [
            1912277151.122843,
            -4290297971.386894,
            -1915015891.124255,
        ],
    ],
    [
        1572825600000,
        [
            1915403745.492346,
            -4289418643.425453,
            -1915680392.197721,
        ],
    ],
    [
        1573430400000,
        [
            1918529965.106799,
            -4288537232.942778,
            -1916343618.927372,
        ],
    ],
    [
        1574035200000,
        [
            1921655987.68349,
            -4287653634.239345,
            -1917005965.878056,
        ],
    ],
    [
        1574640000000,
        [
            1924781805.72344,
            -4286767922.561407,
            -1917667874.562364,
        ],
    ],
    [
        1575244800000,
        [
            1927907226.834034,
            -4285880327.811079,
            -1918329677.185436,
        ],
    ],
    [
        1575849600000,
        [
            1931031940.277026,
            -4284991154.93576,
            -1918991479.729359,
        ],
    ],
    [
        1576454400000,
        [
            1934155626.999479,
            -4284100677.417335,
            -1919653125.676696,
        ],
    ],
    [
        1577059200000,
        [
            1937278071.608931,
            -4283209041.796148,
            -1920314251.921288,
        ],
    ],
    [
        1577664000000,
        [
            1940399237.149083,
            -4282316216.942969,
            -1920974416.174221,
        ],
    ],
    [
        1578268800000,
        [
            1943519277.819496,
            -4281422005.265685,
            -1921633252.27284,
        ],
    ],
    [
        1578873600000,
        [
            1946638484.521201,
            -4280526112.754932,
            -1922290599.867015,
        ],
    ],
    [
        1579478400000,
        [
            1949757181.601746,
            -4279628253.750849,
            -1922946561.675071,
        ],
    ],
    [
        1580083200000,
        [
            1952875611.828086,
            -4278728252.793779,
            -1923601467.276871,
        ],
    ],
    [
        1580688000000,
        [
            1955993850.741807,
            -4277826107.396746,
            -1924255757.207341,
        ],
    ],
    [
        1581292800000,
        [
            1959111780.257388,
            -4276921990.238826,
            -1924909828.372396,
        ],
    ],
    [
        1581897600000,
        [
            1962229131.241498,
            -4276016188.79552,
            -1925563893.863971,
        ],
    ],
    [
        1582502400000,
        [
            1965345578.979384,
            -4275109002.828743,
            -1926217907.134539,
        ],
    ],
    [
        1583107200000,
        [
            1968460856.673,
            -4274200639.09056,
            -1926871579.165427,
        ],
    ],
    [
        1583712000000,
        [
            1971574849.161201,
            -4273291140.307996,
            -1927524481.162989,
        ],
    ],
    [
        1584316800000,
        [
            1974687634.279344,
            -4272380370.272449,
            -1928176194.800376,
        ],
    ],
    [
        1584921600000,
        [
            1977799456.381889,
            -4271468060.734323,
            -1928826459.096907,
        ],
    ],
    [
        1585526400000,
        [
            1980910640.292331,
            -4270553905.374135,
            -1929475262.711894,
        ],
    ],
    [
        1586131200000,
        [
            1984021476.112913,
            -4269637667.715784,
            -1930122847.759812,
        ],
    ],
    [
        1586736000000,
        [
            1987132116.407064,
            -4268719264.116672,
            -1930769623.786552,
        ],
    ],
    [
        1587340800000,
        [
            1990242521.937291,
            -4267798792.791486,
            -1931416023.221946,
        ],
    ],
    [
        1587945600000,
        [
            1993352474.488499,
            -4266876499.225424,
            -1932062348.794868,
        ],
    ],
    [
        1588550400000,
        [
            1996461653.069623,
            -4265952689.645265,
            -1932708666.294179,
        ],
    ],
    [
        1589155200000,
        [
            1999569747.35574,
            -4265027622.708381,
            -1933354781.474275,
        ],
    ],
    [
        1589760000000,
        [
            2002676566.936289,
            -4264101417.469314,
            -1934000308.696346,
        ],
    ],
    [
        1590364800000,
        [
            2005782105.8092,
            -4263174010.873459,
            -1934644805.849426,
        ],
    ],
    [
        1590969600000,
        [
            2008886542.470141,
            -4262245180.481151,
            -1935287929.459837,
        ],
    ],
    [
        1591574400000,
        [
            2011990177.014296,
            -4261314622.991867,
            -1935929556.25723,
        ],
    ],
    [
        1592179200000,
        [
            2015093324.517359,
            -4260382061.122348,
            -1936569826.999018,
        ],
    ],
    [
        1592784000000,
        [
            2018196202.265282,
            -4259447341.420621,
            -1937209096.306201,
        ],
    ],
    [
        1593388800000,
        [
            2021298851.71333,
            -4258510488.255641,
            -1937847807.222066,
        ],
    ],
    [
        1593993600000,
        [
            2024401122.247422,
            -4257571695.603654,
            -1938486335.316082,
        ],
    ],
    [
        1594598400000,
        [
            2027502722.317003,
            -4256631259.524446,
            -1939124856.199385,
        ],
    ],
    [
        1595203200000,
        [
            2030603320.764499,
            -4255689474.418301,
            -1939763283.42688,
        ],
    ],
    [
        1595808000000,
        [
            2033702662.389269,
            -4254746530.188727,
            -1940401299.752769,
        ],
    ],
    [
        1596412800000,
        [
            2036800656.58585,
            -4253802447.188064,
            -1941038470.051836,
        ],
    ],
    [
        1597017600000,
        [
            2039897408.708903,
            -4252857070.471627,
            -1941674394.570867,
        ],
    ],
    [
        1597622400000,
        [
            2042993182.626885,
            -4251910123.976937,
            -1942308849.098992,
        ],
    ],
    [
        1598227200000,
        [
            2046088305.894331,
            -4250961308.631489,
            -1942941864.737545,
        ],
    ],
    [
        1598832000000,
        [
            2049183053.147319,
            -4250010410.440512,
            -1943573718.245331,
        ],
    ],
    [
        1599436800000,
        [
            2052277549.473314,
            -4249057377.349923,
            -1944204834.569485,
        ],
    ],
    [
        1600041600000,
        [
            2055371726.615238,
            -4248102337.986266,
            -1944835637.195481,
        ],
    ],
    [
        1600646400000,
        [
            2058465346.59131,
            -4247145557.21463,
            -1945466399.438773,
        ],
    ],
    [
        1601251200000,
        [
            2061558084.972693,
            -4246187343.814007,
            -1946097147.982908,
        ],
    ],
    [
        1601856000000,
        [
            2064649645.281818,
            -4245227942.188771,
            -1946727653.518648,
        ],
    ],
    [
        1602460800000,
        [
            2067739863.426186,
            -4244267447.053613,
            -1947357512.417843,
        ],
    ],
    [
        1603065600000,
        [
            2070828764.879549,
            -4243305771.464438,
            -1947986289.45591,
        ],
    ],
    [
        1603670400000,
        [
            2073916555.615231,
            -4242342678.546829,
            -1948613670.917704,
        ],
    ],
    [
        1604275200000,
        [
            2077003550.705896,
            -4241377865.509333,
            -1949239575.629373,
        ],
    ],
    [
        1604880000000,
        [
            2080090064.3519,
            -4240411070.367227,
            -1949864184.105129,
        ],
    ],
    [
        1605484800000,
        [
            2083176298.16091,
            -4239442163.957583,
            -1950487874.215842,
        ],
    ],
    [
        1606089600000,
        [
            2086262269.080685,
            -4238471196.218238,
            -1951111087.710382,
        ],
    ],
    [
        1606694400000,
        [
            2089347804.313936,
            -4237498379.257179,
            -1951734175.20166,
        ],
    ],
    [
        1607299200000,
        [
            2092432602.591302,
            -4236524012.681652,
            -1952357272.722923,
        ],
    ],
    [
        1607904000000,
        [
            2095516340.105714,
            -4235548377.636092,
            -1952980252.981561,
        ],
    ],
    [
        1608508800000,
        [
            2098598784.490033,
            -4234571637.10307,
            -1953602769.880453,
        ],
    ],
    [
        1609113600000,
        [
            2101679876.024931,
            -4233593778.420263,
            -1954224380.784806,
        ],
    ],
    [
        1609718400000,
        [
            2104759747.441529,
            -4232614618.116497,
            -1954844702.168627,
        ],
    ],
    [
        1610323200000,
        [
            2107838676.403685,
            -4231633866.458583,
            -1955463544.123135,
        ],
    ],
    [
        1610928000000,
        [
            2110916987.037035,
            -4230651229.689786,
            -1956080977.770231,
        ],
    ],
    [
        1611532800000,
        [
            2113994934.615814,
            -4229666514.675273,
            -1956697310.804873,
        ],
    ],
    [
        1612137600000,
        [
            2117072615.307899,
            -4228679697.602108,
            -1957312978.609216,
        ],
    ],
    [
        1612742400000,
        [
            2120149932.264205,
            -4227690931.267979,
            -1957928389.986067,
        ],
    ],
    [
        1613347200000,
        [
            2123226627.722124,
            -4226700491.189838,
            -1958543783.309179,
        ],
    ],
    [
        1613952000000,
        [
            2126302372.177484,
            -4225708680.453322,
            -1959159143.137226,
        ],
    ],
    [
        1614556800000,
        [
            2129376880.550026,
            -4224715723.666261,
            -1959774205.537292,
        ],
    ],
    [
        1615161600000,
        [
            2132450012.560959,
            -4223721687.752635,
            -1960388551.20515,
        ],
    ],
    [
        1615766400000,
        [
            2135521821.171532,
            -4222726458.889696,
            -1961001753.553157,
        ],
    ],
    [
        1616371200000,
        [
            2138592532.721755,
            -4221729783.361209,
            -1961613528.753029,
        ],
    ],
    [
        1616976000000,
        [
            2141662466.60432,
            -4220731357.340889,
            -1962223835.735651,
        ],
    ],
    [
        1617580800000,
        [
            2144731921.931708,
            -4219730934.83465,
            -1962832891.514844,
        ],
    ],
    [
        1618185600000,
        [
            2147801070.804424,
            -4218728415.878263,
            -1963441095.012357,
        ],
    ],
    [
        1618790400000,
        [
            2150869897.049812,
            -4217723882.930242,
            -1964048886.161025,
        ],
    ],
    [
        1619395200000,
        [
            2153938202.573041,
            -4216717572.623297,
            -1964656591.498917,
        ],
    ],
    [
        1620000000000,
        [
            2157005677.848548,
            -4215709792.961489,
            -1965264309.906641,
        ],
    ],
    [
        1620604800000,
        [
            2160072010.054666,
            -4214700814.695454,
            -1965871877.063919,
        ],
    ],
    [
        1621209600000,
        [
            2163136992.11893,
            -4213690776.761641,
            -1966478923.296738,
        ],
    ],
    [
        1621814400000,
        [
            2166200596.201902,
            -4212679638.678782,
            -1967085004.873665,
        ],
    ],
    [
        1622419200000,
        [
            2169262983.999746,
            -4211667195.367606,
            -1967689760.598053,
        ],
    ],
    [
        1623024000000,
        [
            2172324449.887669,
            -4210653149.251086,
            -1968293038.55262,
        ],
    ],
    [
        1623628800000,
        [
            2175385317.261577,
            -4209637214.830019,
            -1968894949.771369,
        ],
    ],
    [
        1624233600000,
        [
            2178445823.889083,
            -4208619219.700036,
            -1969495829.511311,
        ],
    ],
    [
        1624838400000,
        [
            2181506037.141887,
            -4207599165.792464,
            -1970096118.548346,
        ],
    ],
    [
        1625443200000,
        [
            2184565829.937076,
            -4206577228.489391,
            -1970696207.122073,
        ],
    ],
    [
        1626048000000,
        [
            2187624925.340437,
            -4205553694.734862,
            -1971296297.912783,
        ],
    ],
    [
        1626652800000,
        [
            2190682993.316041,
            -4204528862.860925,
            -1971896335.342781,
        ],
    ],
    [
        1627257600000,
        [
            2193739766.843859,
            -4203502938.03814,
            -1972496024.809938,
        ],
    ],
    [
        1627862400000,
        [
            2196795136.24168,
            -4202475958.850441,
            -1973094935.768156,
        ],
    ],
    [
        1628467200000,
        [
            2199849185.888755,
            -4201447783.193619,
            -1973692653.270532,
        ],
    ],
    [
        1629072000000,
        [
            2202902162.664802,
            -4200418139.790236,
            -1974288924.517779,
        ],
    ],
    [
        1629676800000,
        [
            2205954388.996866,
            -4199386724.28868,
            -1974883748.035562,
        ],
    ],
    [
        1630281600000,
        [
            2209006148.82223,
            -4198353306.473033,
            -1975477374.641792,
        ],
    ],
    [
        1630886400000,
        [
            2212057585.828202,
            -4197317812.030238,
            -1976070219.020195,
        ],
    ],
    [
        1631491200000,
        [
            2215108651.25131,
            -4196280349.213063,
            -1976662712.721347,
        ],
    ],
    [
        1632096000000,
        [
            2218159120.250189,
            -4195241170.764826,
            -1977255151.909362,
        ],
    ],
    [
        1632700800000,
        [
            2221208669.996377,
            -4194200585.618332,
            -1977847593.976993,
        ],
    ],
    [
        1633305600000,
        [
            2224256991.565166,
            -4193158851.670012,
            -1978439837.840202,
        ],
    ],
    [
        1633910400000,
        [
            2227303897.480521,
            -4192116086.400883,
            -1979031494.721074,
        ],
    ],
    [
        1634515200000,
        [
            2230349387.51422,
            -4191072226.899992,
            -1979622125.800155,
        ],
    ],
    [
        1635120000000,
        [
            2233393648.972975,
            -4190027053.197426,
            -1980211397.57641,
        ],
    ],
    [
        1635724800000,
        [
            2236436989.838129,
            -4188980266.036499,
            -1980799199.00505,
        ],
    ],
    [
        1636329600000,
        [
            2239479728.668249,
            -4187931593.630644,
            -1981385681.122078,
        ],
    ],
    [
        1636934400000,
        [
            2242522082.033504,
            -4186880890.060576,
            -1981971205.476548,
        ],
    ],
    [
        1637539200000,
        [
            2245564088.257752,
            -4185828188.524428,
            -1982556216.946096,
        ],
    ],
    [
        1638144000000,
        [
            2248605594.262967,
            -4184773690.215464,
            -1983141086.324405,
        ],
    ],
    [
        1638748800000,
        [
            2251646310.151,
            -4183717693.748629,
            -1983725980.154891,
        ],
    ],
    [
        1639353600000,
        [
            2254685911.225312,
            -4182660491.170058,
            -1984310803.184785,
        ],
    ],
    [
        1639958400000,
        [
            2257724151.939399,
            -4181602266.518392,
            -1984895232.020568,
        ],
    ],
    [
        1640563200000,
        [
            2260760952.666678,
            -4180543031.79112,
            -1985478828.929674,
        ],
    ],
    [
        1641168000000,
        [
            2263796428.181395,
            -4179482623.577273,
            -1986061196.652244,
        ],
    ],
    [
        1641772800000,
        [
            2266830847.539535,
            -4178420761.944421,
            -1986642118.989766,
        ],
    ],
    [
        1642377600000,
        [
            2269864540.501409,
            -4177357149.932791,
            -1987221637.204494,
        ],
    ],
    [
        1642982400000,
        [
            2272897782.888412,
            -4176291577.687991,
            -1987800035.618643,
        ],
    ],
    [
        1643587200000,
        [
            2275930698.47154,
            -4175223996.273727,
            -1988377741.276282,
        ],
    ],
    [
        1644192000000,
        [
            2278963214.401495,
            -4174154536.262001,
            -1988955173.126075,
        ],
    ],
    [
        1644796800000,
        [
            2281995088.357967,
            -4173083461.84524,
            -1989532594.070314,
        ],
    ],
    [
        1645401600000,
        [
            2285025995.268022,
            -4172011076.912365,
            -1990110018.718099,
        ],
    ],
    [
        1646006400000,
        [
            2288055641.498367,
            -4170937617.875717,
            -1990687208.462132,
        ],
    ],
    [
        1646611200000,
        [
            2291083867.601537,
            -4169863170.233343,
            -1991263754.67061,
        ],
    ],
    [
        1647216000000,
        [
            2294110704.253946,
            -4168787637.839332,
            -1991839222.107033,
        ],
    ],
    [
        1647820800000,
        [
            2297136360.835519,
            -4167710776.565322,
            -1992413302.383964,
        ],
    ],
    [
        1648425600000,
        [
            2300161150.588471,
            -4166632280.48438,
            -1992985922.419394,
        ],
    ],
    [
        1649030400000,
        [
            2303185379.483289,
            -4165551889.755837,
            -1993557270.06971,
        ],
    ],
    [
        1649635200000,
        [
            2306209237.79934,
            -4164469482.813861,
            -1994127728.668795,
        ],
    ],
    [
        1650240000000,
        [
            2309232732.522336,
            -4163385119.872052,
            -1994697741.907743,
        ],
    ],
    [
        1650844800000,
        [
            2312255683.962895,
            -4162299020.781705,
            -1995267655.966887,
        ],
    ],
    [
        1651449600000,
        [
            2315277787.293796,
            -4161211487.247008,
            -1995837597.215373,
        ],
    ],
    [
        1652054400000,
        [
            2318298719.032676,
            -4160122798.026935,
            -1996407429.180223,
        ],
    ],
    [
        1652659200000,
        [
            2321318250.282065,
            -4159033111.975243,
            -1996976801.073383,
        ],
    ],
    [
        1653264000000,
        [
            2324336326.552345,
            -4157942412.352605,
            -1997545270.725446,
        ],
    ],
    [
        1653868800000,
        [
            2327353086.207466,
            -4156850512.88939,
            -1998112460.414289,
        ],
    ],
    [
        1654473600000,
        [
            2330368810.50607,
            -4155757124.276188,
            -1998678190.465807,
        ],
    ],
    [
        1655078400000,
        [
            2333383823.219131,
            -4154661957.204654,
            -1999242542.645099,
        ],
    ],
    [
        1655683200000,
        [
            2336398375.755474,
            -4153564825.231203,
            -1999805831.741937,
        ],
    ],
    [
        1656288000000,
        [
            2339412557.457885,
            -4152465712.086028,
            -2000368495.655889,
        ],
    ],
    [
        1656892800000,
        [
            2342426262.936496,
            -4151364779.503484,
            -2000930941.313435,
        ],
    ],
    [
        1657497600000,
        [
            2345439229.607703,
            -4150262311.551486,
            -2001493401.215518,
        ],
    ],
    [
        1658102400000,
        [
            2348451131.507833,
            -4149158614.639238,
            -2002055852.106128,
        ],
    ],
    [
        1658707200000,
        [
            2351461693.094135,
            -4148053910.01953,
            -2002618023.744647,
        ],
    ],
    [
        1659312000000,
        [
            2354470784.700684,
            -4146948258.097651,
            -2003179494.500049,
        ],
    ],
    [
        1659916800000,
        [
            2357478469.08297,
            -4145841538.73655,
            -2003739840.342444,
        ],
    ],
    [
        1660521600000,
        [
            2360484980.373901,
            -4144733494.122918,
            -2004298784.830105,
        ],
    ],
    [
        1661126400000,
        [
            2363490641.6636,
            -4143623820.262065,
            -2004856296.781022,
        ],
    ],
    [
        1661731200000,
        [
            2366495751.140872,
            -4142512274.622547,
            -2005412601.091935,
        ],
    ],
    [
        1662336000000,
        [
            2369500477.224955,
            -4141398761.996919,
            -2005968099.863262,
        ],
    ],
    [
        1662940800000,
        [
            2372504798.81465,
            -4140283369.011582,
            -2006523231.195198,
        ],
    ],
    [
        1663545600000,
        [
            2375508512.246876,
            -4139166334.467578,
            -2007078314.333838,
        ],
    ],
    [
        1664150400000,
        [
            2378511303.39851,
            -4138047965.447668,
            -2007633436.935133,
        ],
    ],
    [
        1664755200000,
        [
            2381512858.963391,
            -4136928529.755316,
            -2008188425.232725,
        ],
    ],
    [
        1665360000000,
        [
            2384512977.271448,
            -4135808162.542859,
            -2008742905.90934,
        ],
    ],
    [
        1665964800000,
        [
            2387511639.434773,
            -4134686818.105975,
            -2009296436.543268,
        ],
    ],
    [
        1666569600000,
        [
            2390509014.878116,
            -4133564285.629473,
            -2009848661.125552,
        ],
    ],
    [
        1667174400000,
        [
            2393505401.057047,
            -4132440264.966668,
            -2010399436.527637,
        ],
    ],
    [
        1667779200000,
        [
            2396501118.903893,
            -4131314473.281505,
            -2010948883.089164,
        ],
    ],
    [
        1668384000000,
        [
            2399496399.890561,
            -4130186744.517889,
            -2011497341.802386,
        ],
    ],
    [
        1668988800000,
        [
            2402491304.042791,
            -4129057087.966154,
            -2012045254.421327,
        ],
    ],
    [
        1669593600000,
        [
            2405485697.617179,
            -4127925685.748793,
            -2012593007.774727,
        ],
    ],
    [
        1670198400000,
        [
            2408479299.374078,
            -4126792829.146884,
            -2013140796.818111,
        ],
    ],
    [
        1670803200000,
        [
            2411471779.389244,
            -4125658816.188393,
            -2013688556.04303,
        ],
    ],
    [
        1671408000000,
        [
            2414462874.561867,
            -4124523847.632683,
            -2014235983.555272,
        ],
    ],
    [
        1672012800000,
        [
            2417452480.152325,
            -4123387957.984215,
            -2014782647.841768,
        ],
    ],
    [
        1672617600000,
        [
            2420440686.764438,
            -4122251004.604445,
            -2015328139.795035,
        ],
    ],
    [
        1673222400000,
        [
            2423427749.425444,
            -4121112718.253006,
            -2015872217.342771,
        ],
    ],
    [
        1673827200000,
        [
            2426413996.775408,
            -4119972798.155996,
            -2016414890.857669,
        ],
    ],
    [
        1674432000000,
        [
            2429399713.521511,
            -4118831019.78544,
            -2016956419.631815,
        ],
    ],
    [
        1675036800000,
        [
            2432385040.735572,
            -4117687315.675578,
            -2017497221.225578,
        ],
    ],
    [
        1675641600000,
        [
            2435369926.911541,
            -4116541800.174277,
            -2018037725.138939,
        ],
    ],
    [
        1676246400000,
        [
            2438354145.979822,
            -4115394730.063732,
            -2018578221.332384,
        ],
    ],
    [
        1676851200000,
        [
            2441337377.210156,
            -4114246414.515909,
            -2019118757.686431,
        ],
    ],
    [
        1677456000000,
        [
            2444319318.688175,
            -4113097106.628826,
            -2019659123.73297,
        ],
    ],
    [
        1678060800000,
        [
            2447299793.528952,
            -4111946915.414128,
            -2020198925.565228,
        ],
    ],
    [
        1678665600000,
        [
            2450278812.016985,
            -4110795768.491404,
            -2020737724.442975,
        ],
    ],
    [
        1679270400000,
        [
            2453256568.567231,
            -4109643438.167158,
            -2021275191.478366,
        ],
    ],
    [
        1679875200000,
        [
            2456233373.929266,
            -4108489622.699458,
            -2021811224.577104,
        ],
    ],
    [
        1680480000000,
        [
            2459209546.590476,
            -4107334053.784795,
            -2022345984.941267,
        ],
    ],
    [
        1681084800000,
        [
            2462185301.552387,
            -4106176590.578572,
            -2022879839.37343,
        ],
    ],
    [
        1681689600000,
        [
            2465160674.198335,
            -4105017268.679554,
            -2023413230.652255,
        ],
    ],
    [
        1682294400000,
        [
            2468135507.500443,
            -4103856288.974014,
            -2023946522.407294,
        ],
    ],
    [
        1682899200000,
        [
            2471109508.24406,
            -4102693947.531713,
            -2024479870.861864,
        ],
    ],
    [
        1683504000000,
        [
            2474082351.404594,
            -4101530530.511331,
            -2025013169.247525,
        ],
    ],
    [
        1684108800000,
        [
            2477053794.943687,
            -4100366212.757855,
            -2025546085.635911,
        ],
    ],
    [
        1684713600000,
        [
            2480023764.405085,
            -4099200996.306303,
            -2026078179.719904,
        ],
    ],
    [
        1685318400000,
        [
            2482992378.716849,
            -4098034709.381408,
            -2026609057.101228,
        ],
    ],
    [
        1685923200000,
        [
            2485959908.178207,
            -4096867066.434293,
            -2027138508.31866,
        ],
    ],
    [
        1686528000000,
        [
            2488926678.297457,
            -4095697769.129701,
            -2027666583.217596,
        ],
    ],
    [
        1687132800000,
        [
            2491892953.837998,
            -4094526612.295418,
            -2028193573.18999,
        ],
    ],
    [
        1687737600000,
        [
            2494858845.296935,
            -4093353556.665543,
            -2028719908.171769,
        ],
    ],
    [
        1688342400000,
        [
            2497824270.515362,
            -4092178742.47493,
            -2029246005.362213,
        ],
    ],
    [
        1688947200000,
        [
            2500788982.404166,
            -4091002439.474882,
            -2029772121.794977,
        ],
    ],
    [
        1689552000000,
        [
            2503752653.691282,
            -4089824952.629705,
            -2030298263.435869,
        ],
    ],
    [
        1690156800000,
        [
            2506714991.896875,
            -4088646515.959867,
            -2030824183.77859,
        ],
    ],
    [
        1690761600000,
        [
            2509675842.287091,
            -4087467210.859792,
            -2031349471.408964,
        ],
    ],
    [
        1691366400000,
        [
            2512635241.37771,
            -4086286938.109066,
            -2031873694.680196,
        ],
    ],
    [
        1691971200000,
        [
            2515593403.436055,
            -4085105453.102994,
            -2032396553.414647,
        ],
    ],
    [
        1692576000000,
        [
            2518550644.394743,
            -4083922452.691264,
            -2032917985.544764,
        ],
    ],
    [
        1693180800000,
        [
            2521507269.149555,
            -4082737683.634891,
            -2033438189.796291,
        ],
    ],
    [
        1693785600000,
        [
            2524463462.898437,
            -4081551033.441494,
            -2033957555.456856,
        ],
    ],
    [
        1694390400000,
        [
            2527419225.571587,
            -4080362571.156093,
            -2034476525.358594,
        ],
    ],
    [
        1694995200000,
        [
            2530374371.743002,
            -4079172524.777734,
            -2034995441.032763,
        ],
    ],
    [
        1695600000000,
        [
            2533328596.301481,
            -4077981202.904471,
            -2035514423.12648,
        ],
    ],
    [
        1696204800000,
        [
            2536281582.911407,
            -4076788886.447624,
            -2036033328.793657,
        ],
    ],
    [
        1696809600000,
        [
            2539233114.855139,
            -4075595730.075069,
            -2036551802.286943,
        ],
    ],
    [
        1697414400000,
        [
            2542183150.61256,
            -4074401710.241074,
            -2037069401.400031,
        ],
    ],
    [
        1698019200000,
        [
            2545131839.605123,
            -4073206635.320704,
            -2037585753.567785,
        ],
    ],
    [
        1698624000000,
        [
            2548079471.274243,
            -4072010213.385472,
            -2038100687.391484,
        ],
    ],
    [
        1699228800000,
        [
            2551026373.876269,
            -4070812155.706536,
            -2038614294.037845,
        ],
    ],
    [
        1699833600000,
        [
            2553972798.711755,
            -4069612279.761958,
            -2039126895.365911,
        ],
    ],
    [
        1700438400000,
        [
            2556918831.947009,
            -4068410574.235743,
            -2039638929.841295,
        ],
    ],
    [
        1701043200000,
        [
            2559864365.310817,
            -4067207203.118553,
            -2040150798.086257,
        ],
    ],
    [
        1701648000000,
        [
            2562809134.782348,
            -4066002448.585618,
            -2040662722.41433,
        ],
    ],
    [
        1702252800000,
        [
            2565752813.935506,
            -4064796612.463639,
            -2041174668.584653,
        ],
    ],
    [
        1702857600000,
        [
            2568695130.07669,
            -4063589910.473414,
            -2041686358.085722,
        ],
    ],
    [
        1703462400000,
        [
            2571635961.946407,
            -4062382396.364609,
            -2042197366.687416,
        ],
    ],
    [
        1704067200000,
        [
            2574575382.744127,
            -4061173942.200798,
            -2042707273.090932,
        ],
    ],
    [
        1704672000000,
        [
            2577513633.575653,
            -4059964283.164007,
            -2043215806.565064,
        ],
    ],
    [
        1705276800000,
        [
            2580451039.310351,
            -4058753111.481242,
            -2043722943.268781,
        ],
    ],
    [
        1705881600000,
        [
            2583387894.835102,
            -4057540185.293095,
            -2044228915.384016,
        ],
    ],
    [
        1706486400000,
        [
            2586324360.887548,
            -4056325413.858988,
            -2044734128.495628,
        ],
    ],
    [
        1707091200000,
        [
            2589260407.407373,
            -4055108888.863018,
            -2045239017.543637,
        ],
    ],
    [
        1707696000000,
        [
            2592195824.199668,
            -4053890851.518287,
            -2045743893.560122,
        ],
    ],
    [
        1708300800000,
        [
            2595130294.317207,
            -4052671607.765119,
            -2046248834.295127,
        ],
    ],
    [
        1708905600000,
        [
            2598063504.969802,
            -4051451420.734042,
            -2046753656.510847,
        ],
    ],
    [
        1709510400000,
        [
            2600995257.210957,
            -4050230418.299746,
            -2047257980.637439,
        ],
    ],
    [
        1710115200000,
        [
            2603925535.332458,
            -4049008548.981714,
            -2047761365.036602,
        ],
    ],
    [
        1710720000000,
        [
            2606854512.242011,
            -4047785601.12377,
            -2048263461.529064,
        ],
    ],
    [
        1711324800000,
        [
            2609782489.442757,
            -4046561276.891062,
            -2048764137.598133,
        ],
    ],
    [
        1711929600000,
        [
            2612709789.905231,
            -4045335296.670099,
            -2049263523.452874,
        ],
    ],
    [
        1712534400000,
        [
            2615636642.181788,
            -4044107499.695527,
            -2049761967.039962,
        ],
    ],
    [
        1713139200000,
        [
            2618563099.769615,
            -4042877902.445713,
            -2050259911.287876,
        ],
    ],
    [
        1713744000000,
        [
            2621489023.155913,
            -4041646692.834577,
            -2050757737.706831,
        ],
    ],
    [
        1714348800000,
        [
            2624414129.170844,
            -4040414164.189723,
            -2051255632.501789,
        ],
    ],
    [
        1714953600000,
        [
            2627338090.255747,
            -4039180612.725249,
            -2051753521.208672,
        ],
    ],
    [
        1715558400000,
        [
            2630260649.676823,
            -4037946233.846244,
            -2052251094.954078,
        ],
    ],
    [
        1716163200000,
        [
            2633181711.897153,
            -4036711054.085344,
            -2052747919.770106,
        ],
    ],
    [
        1716768000000,
        [
            2636101375.854396,
            -4035474922.945832,
            -2053243589.867085,
        ],
    ],
    [
        1717372800000,
        [
            2639019900.087774,
            -4034237566.960912,
            -2053737870.467104,
        ],
    ],
    [
        1717977600000,
        [
            2641937612.67031,
            -4032998686.791903,
            -2054230781.167529,
        ],
    ],
    [
        1718582400000,
        [
            2644854796.896039,
            -4031758063.609193,
            -2054722590.315249,
        ],
    ],
    [
        1719187200000,
        [
            2647771591.535816,
            -4030515636.349782,
            -2055213720.032771,
        ],
    ],
    [
        1719792000000,
        [
            2650687940.957374,
            -4029271523.379995,
            -2055704596.37931,
        ],
    ],
    [
        1720396800000,
        [
            2653603615.518576,
            -4028025981.680861,
            -2056195499.813688,
        ],
    ],
    [
        1721001600000,
        [
            2656518293.835237,
            -4026779316.857271,
            -2056686467.247112,
        ],
    ],
    [
        1721606400000,
        [
            2659431676.555227,
            -4025531775.416682,
            -2057177278.731217,
        ],
    ],
    [
        1722211200000,
        [
            2662343592.226696,
            -4024283457.509095,
            -2057667534.648414,
        ],
    ],
    [
        1722816000000,
        [
            2665254057.66936,
            -4023034281.609814,
            -2058156796.66081,
        ],
    ],
    [
        1723420800000,
        [
            2668163271.601582,
            -4021784013.481589,
            -2058644741.809134,
        ],
    ],
    [
        1724025600000,
        [
            2671071544.598729,
            -4020532348.482827,
            -2059131275.739552,
        ],
    ],
    [
        1724630400000,
        [
            2673979189.731146,
            -4019279018.799538,
            -2059616566.463106,
        ],
    ],
    [
        1725235200000,
        [
            2676886411.51995,
            -4018023888.784584,
            -2060100985.936381,
        ],
    ],
    [
        1725840000000,
        [
            2679793233.485187,
            -4016767003.836029,
            -2060584978.703723,
        ],
    ],
    [
        1726444800000,
        [
            2682699490.751017,
            -4015508573.810418,
            -2061068904.332168,
        ],
    ],
    [
        1727049600000,
        [
            2685604887.735752,
            -4014248897.849311,
            -2061552910.427086,
        ],
    ],
    [
        1727654400000,
        [
            2688509100.407211,
            -4012988260.178991,
            -2062036881.26496,
        ],
    ],
    [
        1728259200000,
        [
            2691411890.316636,
            -4011726831.40026,
            -2062520478.852271,
        ],
    ],
    [
        1728864000000,
        [
            2694313189.136982,
            -4010464608.536722,
            -2063003262.160212,
        ],
    ],
    [
        1729468800000,
        [
            2697213122.27604,
            -4009201416.477183,
            -2063484842.768219,
        ],
    ],
    [
        1730073600000,
        [
            2700111963.838638,
            -4007936970.342811,
            -2063965021.360356,
        ],
    ],
    [
        1730678400000,
        [
            2703010039.854677,
            -4006670976.165504,
            -2064443857.837857,
        ],
    ],
    [
        1731283200000,
        [
            2705907613.06491,
            -4005403235.296109,
            -2064921651.213643,
        ],
    ],
    [
        1731888000000,
        [
            2708804789.264641,
            -4004133716.085768,
            -2065398834.802492,
        ],
    ],
    [
        1732492800000,
        [
            2711701479.432321,
            -4002862566.490031,
            -2065875823.195439,
        ],
    ],
    [
        1733097600000,
        [
            2714597431.704648,
            -4001590063.026277,
            -2066352866.515833,
        ],
    ],
    [
        1733702400000,
        [
            2717492321.359664,
            -4000316514.554155,
            -2066829963.452717,
        ],
    ],
    [
        1734307200000,
        [
            2720385865.842941,
            -3999042153.852891,
            -2067306861.69896,
        ],
    ],
    [
        1734912000000,
        [
            2723277923.639328,
            -3997767055.996806,
            -2067783146.512352,
        ],
    ],
    [
        1735516800000,
        [
            2726168544.389777,
            -3996491113.790017,
            -2068258387.969547,
        ],
    ],
    [
        1736121600000,
        [
            2729057952.7116,
            -3995214077.069173,
            -2068732293.249829,
        ],
    ],
    [
        1736726400000,
        [
            2731946470.243366,
            -3993935641.235458,
            -2069204809.423167,
        ],
    ],
    [
        1737331200000,
        [
            2734834403.621008,
            -3992655554.416606,
            -2069676142.144527,
        ],
    ],
    [
        1737936000000,
        [
            2737721937.085791,
            -3991373706.69764,
            -2070146683.953238,
        ],
    ],
    [
        1738540800000,
        [
            2740609067.669542,
            -3990090169.676086,
            -2070616875.77554,
        ],
    ],
    [
        1739145600000,
        [
            2743495607.005859,
            -3988805171.293389,
            -2071087050.794558,
        ],
    ],
    [
        1739750400000,
        [
            2746381248.886154,
            -3987519015.289043,
            -2071557317.2567,
        ],
    ],
    [
        1740355200000,
        [
            2749265677.720267,
            -3986231974.730796,
            -2072027521.003515,
        ],
    ],
    [
        1740960000000,
        [
            2752148680.614077,
            -3984944196.373037,
            -2072497299.655914,
        ],
    ],
    [
        1741564800000,
        [
            2755030224.357347,
            -3983655648.151608,
            -2072966209.926478,
        ],
    ],
    [
        1742169600000,
        [
            2757910467.547918,
            -3982366128.979348,
            -2073433883.37664,
        ],
    ],
    [
        1742774400000,
        [
            2760789703.4669,
            -3981075339.81979,
            -2073900155.983085,
        ],
    ],
    [
        1743379200000,
        [
            2763668257.383116,
            -3979782989.447833,
            -2074365125.760146,
        ],
    ],
    [
        1743984000000,
        [
            2766546373.239316,
            -3978488896.23167,
            -2074829118.288294,
        ],
    ],
    [
        1744588800000,
        [
            2769424127.552916,
            -3977193051.566082,
            -2075292571.872763,
        ],
    ],
    [
        1745193600000,
        [
            2772301401.754029,
            -3975895622.424612,
            -2075755882.068638,
        ],
    ],
    [
        1745798400000,
        [
            2775177923.763441,
            -3974596891.597495,
            -2076219261.451139,
        ],
    ],
    [
        1746403200000,
        [
            2778053363.492435,
            -3973297157.479212,
            -2076682664.947567,
        ],
    ],
    [
        1747008000000,
        [
            2780927447.916972,
            -3971996629.213538,
            -2077145805.785505,
        ],
    ],
    [
        1747612800000,
        [
            2783800056.265563,
            -3970695353.182509,
            -2077608255.921656,
        ],
    ],
    [
        1748217600000,
        [
            2786671262.261589,
            -3969393196.846661,
            -2078069597.103188,
        ],
    ],
    [
        1748822400000,
        [
            2789541308.065242,
            -3968089896.128869,
            -2078529568.98005,
        ],
    ],
    [
        1749427200000,
        [
            2792410518.619848,
            -3966785148.263706,
            -2078988160.263999,
        ],
    ],
    [
        1750032000000,
        [
            2795279185.616412,
            -3965478717.918786,
            -2079445611.936746,
        ],
    ],
    [
        1750636800000,
        [
            2798147463.40765,
            -3964170521.578215,
            -2079902333.366431,
        ],
    ],
    [
        1751241600000,
        [
            2801015314.38736,
            -3962860658.577949,
            -2080358758.626867,
        ],
    ],
    [
        1751846400000,
        [
            2803882522.28712,
            -3961549376.411801,
            -2080815193.002316,
        ],
    ],
    [
        1752451200000,
        [
            2806748768.438596,
            -3960236983.508327,
            -2081271705.492582,
        ],
    ],
    [
        1753056000000,
        [
            2809613743.531426,
            -3958923741.315097,
            -2081728105.251871,
        ],
    ],
    [
        1753660800000,
        [
            2812477255.727672,
            -3957609773.376884,
            -2082184008.860964,
        ],
    ],
    [
        1754265600000,
        [
            2815339298.125054,
            -3956295022.483167,
            -2082638975.226166,
        ],
    ],
    [
        1754870400000,
        [
            2818200051.340431,
            -3954979271.602273,
            -2083092661.770979,
        ],
    ],
    [
        1755475200000,
        [
            2821059819.575234,
            -3953662221.940927,
            -2083544946.106779,
        ],
    ],
    [
        1756080000000,
        [
            2823918923.680954,
            -3952343599.863716,
            -2083995969.390313,
        ],
    ],
    [
        1756684800000,
        [
            2826777589.794436,
            -3951023253.748486,
            -2084446086.772361,
        ],
    ],
    [
        1757289600000,
        [
            2829635870.190486,
            -3949701207.087954,
            -2084895742.349546,
        ],
    ],
    [
        1757894400000,
        [
            2832493623.696152,
            -3948377651.206755,
            -2085345312.501813,
        ],
    ],
    [
        1758499200000,
        [
            2835350566.375295,
            -3947052879.132148,
            -2085794973.558213,
        ],
    ],
    [
        1759104000000,
        [
            2838206373.486096,
            -3945727182.522499,
            -2086244640.375104,
        ],
    ],
    [
        1759708800000,
        [
            2841060794.494149,
            -3944400749.148046,
            -2086693996.602953,
        ],
    ],
    [
        1760313600000,
        [
            2843913741.597682,
            -3943073596.756474,
            -2087142605.368685,
        ],
    ],
    [
        1760918400000,
        [
            2846765321.4846,
            -3941745566.300046,
            -2087590062.865067,
        ],
    ],
    [
        1761523200000,
        [
            2849615798.196266,
            -3940416377.868824,
            -2088036141.151834,
        ],
    ],
    [
        1762128000000,
        [
            2852465499.845143,
            -3939085729.745827,
            -2088480868.585709,
        ],
    ],
    [
        1762732800000,
        [
            2855314702.923638,
            -3937753404.924912,
            -2088924519.327173,
        ],
    ],
    [
        1763337600000,
        [
            2858163535.297207,
            -3936419347.714157,
            -2089367516.864793,
        ],
    ],
    [
        1763942400000,
        [
            2861011931.74829,
            -3935083683.865281,
            -2089810285.134655,
        ],
    ],
    [
        1764547200000,
        [
            2863859657.787387,
            -3933746675.560967,
            -2090253098.266731,
        ],
    ],
    [
        1765152000000,
        [
            2866706391.865529,
            -3932408627.605089,
            -2090695983.145531,
        ],
    ],
    [
        1765756800000,
        [
            2869551837.686538,
            -3931069780.800421,
            -2091138710.825107,
        ],
    ],
    [
        1766361600000,
        [
            2872395828.562123,
            -3929730228.350481,
            -2091580877.529357,
        ],
    ],
    [
        1766966400000,
        [
            2875238386.637414,
            -3928389882.634076,
            -2092022045.916034,
        ],
    ],
    [
        1767571200000,
        [
            2878079715.510486,
            -3927048505.244194,
            -2092461899.063635,
        ],
    ],
    [
        1768176000000,
        [
            2880920127.983818,
            -3925705791.109493,
            -2092900352.69556,
        ],
    ],
    [
        1768780800000,
        [
            2883759934.847961,
            -3924361476.595116,
            -2093337584.688234,
        ],
    ],
    [
        1769385600000,
        [
            2886599334.879913,
            -3923015432.646932,
            -2093773971.951254,
        ],
    ],
    [
        1769990400000,
        [
            2889438344.424259,
            -3921667710.694297,
            -2094209957.871803,
        ],
    ],
    [
        1770595200000,
        [
            2892276791.009742,
            -3920318525.508456,
            -2094645896.235686,
        ],
    ],
    [
        1771200000000,
        [
            2895114374.320478,
            -3918968180.385151,
            -2095081926.596894,
        ],
    ],
    [
        1771804800000,
        [
            2897950773.30422,
            -3917616960.594186,
            -2095517925.71205,
        ],
    ],
    [
        1772409600000,
        [
            2900785759.426147,
            -3916265032.654544,
            -2095953551.166919,
        ],
    ],
    [
        1773014400000,
        [
            2903619275.462635,
            -3914912386.437877,
            -2096388361.45632,
        ],
    ],
    [
        1773619200000,
        [
            2906451456.056432,
            -3913558839.945932,
            -2096821971.635443,
        ],
    ],
    [
        1774224000000,
        [
            2909282581.991723,
            -3912204103.749259,
            -2097254189.894491,
        ],
    ],
    [
        1774828800000,
        [
            2912112981.697185,
            -3910847883.385297,
            -2097685085.719381,
        ],
    ],
    [
        1775433600000,
        [
            2914942915.447551,
            -3909489983.502676,
            -2098114964.918753,
        ],
    ],
    [
        1776038400000,
        [
            2917772484.11928,
            -3908130376.604803,
            -2098544261.495321,
        ],
    ],
    [
        1776643200000,
        [
            2920601593.951721,
            -3906769212.911395,
            -2098973384.926416,
        ],
    ],
    [
        1777248000000,
        [
            2923429989.697715,
            -3905406767.702953,
            -2099402575.597562,
        ],
    ],
    [
        1777852800000,
        [
            2926257345.163177,
            -3904043344.199656,
            -2099831819.949043,
        ],
    ],
    [
        1778457600000,
        [
            2929083378.740436,
            -3902679166.992529,
            -2100260856.027885,
        ],
    ],
    [
        1779062400000,
        [
            2931907953.08315,
            -3901314303.766045,
            -2100689266.238016,
        ],
    ],
    [
        1779667200000,
        [
            2934731124.643646,
            -3899948640.84252,
            -2101116623.351058,
        ],
    ],
    [
        1780272000000,
        [
            2937553124.146138,
            -3898581921.271716,
            -2101542640.023915,
        ],
    ],
    [
        1780876800000,
        [
            2940374274.531566,
            -3897213835.548051,
            -2101967270.843586,
        ],
    ],
    [
        1781481600000,
        [
            2943194877.288655,
            -3895844131.632152,
            -2102390728.875259,
        ],
    ],
    [
        1782086400000,
        [
            2946015106.701854,
            -3894472703.269023,
            -2102813409.728424,
        ],
    ],
    [
        1782691200000,
        [
            2948834948.650007,
            -3893099626.323109,
            -2103235751.530532,
        ],
    ],
    [
        1783296000000,
        [
            2951654205.047253,
            -3891725131.477657,
            -2103658080.243495,
        ],
    ],
    [
        1783900800000,
        [
            2954472562.972201,
            -3890349522.45517,
            -2104080494.099013,
        ],
    ],
    [
        1784505600000,
        [
            2957289704.556924,
            -3888973068.348475,
            -2104502828.81858,
        ],
    ],
    [
        1785110400000,
        [
            2960105418.043571,
            -3887595908.883138,
            -2104924716.052954,
        ],
    ],
    [
        1785715200000,
        [
            2962919670.813676,
            -3886218005.989952,
            -2105345712.987563,
        ],
    ],
    [
        1786320000000,
        [
            2965732620.327797,
            -3884839157.572514,
            -2105765457.670137,
        ],
    ],
    [
        1786924800000,
        [
            2968544559.388631,
            -3883459068.556556,
            -2106183797.013832,
        ],
    ],
    [
        1787529600000,
        [
            2971355812.625046,
            -3882077454.43226,
            -2106600841.101011,
        ],
    ],
    [
        1788134400000,
        [
            2974166619.568867,
            -3880694141.974696,
            -2107016923.947508,
        ],
    ],
    [
        1788739200000,
        [
            2976977049.09655,
            -3879309131.844798,
            -2107432485.942194,
        ],
    ],
    [
        1789344000000,
        [
            2979786975.588132,
            -3877922599.226753,
            -2107847919.2006,
        ],
    ],
    [
        1789948800000,
        [
            2982596123.015389,
            -3876534832.547529,
            -2108263429.378698,
        ],
    ],
    [
        1790553600000,
        [
            2985404161.926428,
            -3875146132.091479,
            -2108678962.983195,
        ],
    ],
    [
        1791158400000,
        [
            2988210825.346412,
            -3873756704.652231,
            -2109094226.786667,
        ],
    ],
    [
        1791763200000,
        [
            2991016002.120696,
            -3872366591.911774,
            -2109508791.94235,
        ],
    ],
    [
        1792368000000,
        [
            2993819775.285774,
            -3870975657.128336,
            -2109922244.846651,
        ],
    ],
    [
        1792972800000,
        [
            2996622393.089021,
            -3869583633.943952,
            -2110334332.653379,
        ],
    ],
    [
        1793577600000,
        [
            2999424182.10142,
            -3868190221.229812,
            -2110745053.609447,
        ],
    ],
    [
        1794182400000,
        [
            3002225432.515717,
            -3866795191.091017,
            -2111154658.895326,
        ],
    ],
    [
        1794787200000,
        [
            3005026297.027666,
            -3865398470.008753,
            -2111563563.844548,
        ],
    ],
    [
        1795392000000,
        [
            3007826737.665197,
            -3864000164.044454,
            -2111972200.881025,
        ],
    ],
    [
        1795996800000,
        [
            3010626538.668092,
            -3862600522.446692,
            -2112380867.675988,
        ],
    ],
    [
        1796601600000,
        [
            3013425383.558773,
            -3861199851.349432,
            -2112789622.734031,
        ],
    ],
    [
        1797206400000,
        [
            3016222968.686675,
            -3859798405.790942,
            -2113198264.779481,
        ],
    ],
    [
        1797811200000,
        [
            3019019111.466711,
            -3858396299.513841,
            -2113606404.063166,
        ],
    ],
    [
        1798416000000,
        [
            3021813814.968928,
            -3856993465.090503,
            -2114013599.663842,
        ],
    ],
    [
        1799020800000,
        [
            3024607267.249753,
            -3855589677.493704,
            -2114419513.89396,
        ],
    ],
    [
        1799625600000,
        [
            3027399776.171017,
            -3854184632.559072,
            -2114824030.965564,
        ],
    ],
    [
        1800230400000,
        [
            3030191661.424528,
            -3852778053.895797,
            -2115227298.392503,
        ],
    ],
    [
        1800835200000,
        [
            3032983141.607642,
            -3851369790.632226,
            -2115629674.98217,
        ],
    ],
    [
        1801440000000,
        [
            3035774257.469643,
            -3849959870.613685,
            -2116031603.716991,
        ],
    ],
    [
        1802044800000,
        [
            3038564858.926295,
            -3848548490.04565,
            -2116433455.562434,
        ],
    ],
    [
        1802649600000,
        [
            3041354658.707023,
            -3847135943.069938,
            -2116835398.271462,
        ],
    ],
    [
        1803254400000,
        [
            3044143332.411735,
            -3845722516.861863,
            -2117237336.065054,
        ],
    ],
    [
        1803859200000,
        [
            3046930632.331427,
            -3844308390.54244,
            -2117638943.555766,
        ],
    ],
    [
        1804464000000,
        [
            3049716475.23028,
            -3842893572.207316,
            -2118039781.053676,
        ],
    ],
    [
        1805068800000,
        [
            3052500971.329894,
            -3841477895.719861,
            -2118439448.875605,
        ],
    ],
    [
        1805673600000,
        [
            3055284385.126299,
            -3840061078.250728,
            -2118837726.978576,
        ],
    ],
    [
        1806278400000,
        [
            3058067041.934083,
            -3838642819.027007,
            -2119234652.486878,
        ],
    ],
    [
        1806883200000,
        [
            3060849212.129505,
            -3837222905.396198,
            -2119630506.985542,
        ],
    ],
    [
        1807488000000,
        [
            3063631014.469965,
            -3835801288.114588,
            -2120025716.803427,
        ],
    ],
    [
        1808092800000,
        [
            3066412373.439366,
            -3834378098.686455,
            -2120420702.247527,
        ],
    ],
    [
        1808697600000,
        [
            3069193045.217186,
            -3832953603.396927,
            -2120815729.916896,
        ],
    ],
    [
        1809302400000,
        [
            3071972703.006405,
            -3831528110.531562,
            -2121210819.149083,
        ],
    ],
    [
        1809907200000,
        [
            3074751052.683118,
            -3830101861.881924,
            -2121605734.937723,
        ],
    ],
    [
        1810512000000,
        [
            3077527936.267239,
            -3828674946.576315,
            -2122000070.496122,
        ],
    ],
    [
        1811116800000,
        [
            3080303385.574315,
            -3827247270.598719,
            -2122393391.141554,
        ],
    ],
    [
        1811721600000,
        [
            3083077610.401298,
            -3825818591.832015,
            -2122785387.769307,
        ],
    ],
    [
        1812326400000,
        [
            3085850925.637176,
            -3824388605.541012,
            -2123175985.628472,
        ],
    ],
    [
        1812931200000,
        [
            3088623640.750265,
            -3822957051.704731,
            -2123565371.293023,
        ],
    ],
    [
        1813536000000,
        [
            3091395950.111731,
            -3821523807.370718,
            -2123953927.181398,
        ],
    ],
    [
        1814140800000,
        [
            3094167864.121053,
            -3820088930.461821,
            -2124342096.210121,
        ],
    ],
    [
        1814745600000,
        [
            3096939205.853224,
            -3818652639.388032,
            -2124730225.674945,
        ],
    ],
    [
        1815350400000,
        [
            3099709673.36282,
            -3817215236.612414,
            -2125118445.485264,
        ],
    ],
    [
        1815955200000,
        [
            3102478945.787344,
            -3815777002.876577,
            -2125506622.371169,
        ],
    ],
    [
        1816560000000,
        [
            3105246796.886811,
            -3814338098.746876,
            -2125894406.869245,
        ],
    ],
    [
        1817164800000,
        [
            3108013175.940813,
            -3812898508.48168,
            -2126281357.187956,
        ],
    ],
    [
        1817769600000,
        [
            3110778226.500014,
            -3811458045.295197,
            -2126667094.809046,
        ],
    ],
    [
        1818374400000,
        [
            3113542235.083913,
            -3810016416.33465,
            -2127051436.749511,
        ],
    ],
    [
        1818979200000,
        [
            3116305529.912096,
            -3808573326.280275,
            -2127434460.33637,
        ],
    ],
    [
        1819584000000,
        [
            3119068366.061319,
            -3807128582.101622,
            -2127816476.878425,
        ],
    ],
    [
        1820188800000,
        [
            3121830835.831233,
            -3805682161.00041,
            -2128197921.49997,
        ],
    ],
    [
        1820793600000,
        [
            3124592836.39341,
            -3804234217.583038,
            -2128579198.748074,
        ],
    ],
    [
        1821398400000,
        [
            3127354106.196078,
            -3802785028.519404,
            -2128960539.987577,
        ],
    ],
    [
        1822003200000,
        [
            3130114316.419174,
            -3801334895.045168,
            -2129341922.063883,
        ],
    ],
    [
        1822608000000,
        [
            3132873186.020936,
            -3799884036.794052,
            -2129723074.763387,
        ],
    ],
    [
        1823212800000,
        [
            3135630580.464236,
            -3798432514.025986,
            -2130103575.739215,
        ],
    ],
    [
        1823817600000,
        [
            3138386558.51677,
            -3796980206.661797,
            -2130482999.856058,
        ],
    ],
    [
        1824422400000,
        [
            3141141350.864877,
            -3795526857.478916,
            -2130861069.168911,
        ],
    ],
    [
        1825027200000,
        [
            3143895279.333699,
            -3794072162.75188,
            -2131237750.514314,
        ],
    ],
    [
        1825632000000,
        [
            3146648643.457852,
            -3792615878.180503,
            -2131613266.976741,
        ],
    ],
    [
        1826236800000,
        [
            3149401612.649333,
            -3791157905.519603,
            -2131988019.356367,
        ],
    ],
    [
        1826841600000,
        [
            3152154165.558152,
            -3789698328.854541,
            -2132362444.981966,
        ],
    ],
    [
        1827446400000,
        [
            3154906098.425452,
            -3788237385.157177,
            -2132736863.523177,
        ],
    ],
    [
        1828051200000,
        [
            3157657097.098423,
            -3786775380.717153,
            -2133111364.875508,
        ],
    ],
    [
        1828656000000,
        [
            3160406846.861581,
            -3785312583.902071,
            -2133485777.608327,
        ],
    ],
    [
        1829260800000,
        [
            3163155142.791062,
            -3783849131.042499,
            -2133859728.824532,
        ],
    ],
    [
        1829865600000,
        [
            3165901961.9866,
            -3782384978.627416,
            -2134232775.752127,
        ],
    ],
    [
        1830470400000,
        [
            3168647471.278278,
            -3780919919.491333,
            -2134604562.460451,
        ],
    ],
    [
        1831075200000,
        [
            3171391967.94599,
            -3779453656.936444,
            -2134974945.36723,
        ],
    ],
    [
        1831680000000,
        [
            3174135775.296589,
            -3777985910.119632,
            -2135344044.08867,
        ],
    ],
    [
        1832284800000,
        [
            3176879129.594953,
            -3776516514.161293,
            -2135712200.333744,
        ],
    ],
    [
        1832889600000,
        [
            3179622097.685969,
            -3775045478.721791,
            -2136079857.358713,
        ],
    ],
    [
        1833494400000,
        [
            3182364553.374197,
            -3773572983.858878,
            -2136447402.567649,
        ],
    ],
    [
        1834099200000,
        [
            3185106221.882712,
            -3772099317.101735,
            -2136815031.489583,
        ],
    ],
    [
        1834704000000,
        [
            3187846777.801038,
            -3770624773.371911,
            -2137182680.168036,
        ],
    ],
    [
        1835308800000,
        [
            3190585960.647044,
            -3769149551.362339,
            -2137550047.419572,
        ],
    ],
    [
        1835913600000,
        [
            3193323667.580949,
            -3767673682.828539,
            -2137916700.136582,
        ],
    ],
    [
        1836518400000,
        [
            3196059990.448619,
            -3766197020.690473,
            -2138282225.887345,
        ],
    ],
    [
        1837123200000,
        [
            3198795183.59606,
            -3764719290.662857,
            -2138646378.336558,
        ],
    ],
    [
        1837728000000,
        [
            3201529574.333159,
            -3763240187.602254,
            -2139009163.547508,
        ],
    ],
    [
        1838332800000,
        [
            3204263447.931177,
            -3761759482.457036,
            -2139370837.716487,
        ],
    ],
    [
        1838937600000,
        [
            3206996946.862988,
            -3760277103.0183,
            -2139731817.109035,
        ],
    ],
    [
        1839542400000,
        [
            3209730020.426692,
            -3758793159.577428,
            -2140092530.789822,
        ],
    ],
    [
        1840147200000,
        [
            3212462443.876537,
            -3757307905.147214,
            -2140453268.681708,
        ],
    ],
    [
        1840752000000,
        [
            3215193898.476089,
            -3755821644.251615,
            -2140814079.164793,
        ],
    ],
    [
        1841356800000,
        [
            3217924081.796023,
            -3754334625.071657,
            -2141174751.898349,
        ],
    ],
    [
        1841961600000,
        [
            3220652813.027685,
            -3752846952.763191,
            -2141534891.494362,
        ],
    ],
    [
        1842566400000,
        [
            3223380097.378023,
            -3751358551.764007,
            -2141894056.397861,
        ],
    ],
    [
        1843171200000,
        [
            3226106124.214181,
            -3749869191.385823,
            -2142251914.435605,
        ],
    ],
    [
        1843776000000,
        [
            3228831199.246305,
            -3748378566.60177,
            -2142608359.538936,
        ],
    ],
    [
        1844380800000,
        [
            3231555635.704588,
            -3746886405.051926,
            -2142963548.574163,
        ],
    ],
    [
        1844985600000,
        [
            3234279642.834639,
            -3745392562.803653,
            -2143317846.149622,
        ],
    ],
    [
        1845590400000,
        [
            3237003250.469457,
            -3743897075.517536,
            -2143671696.022753,
        ],
    ],
    [
        1846195200000,
        [
            3239726297.124952,
            -3742400146.190778,
            -2144025464.000045,
        ],
    ],
    [
        1846800000000,
        [
            3242448486.35208,
            -3740902073.744379,
            -2144379309.098909,
        ],
    ],
    [
        1847404800000,
        [
            3245169490.88027,
            -3739403148.559144,
            -2144733128.776115,
        ],
    ],
    [
        1848009600000,
        [
            3247889067.44632,
            -3737903550.969683,
            -2145086595.288304,
        ],
    ],
    [
        1848614400000,
        [
            3250607141.245644,
            -3736403287.245925,
            -2145439269.926538,
        ],
    ],
    [
        1849219200000,
        [
            3253323830.812997,
            -3734902188.089064,
            -2145790757.886199,
        ],
    ],
    [
        1849824000000,
        [
            3256039406.125968,
            -3733399970.061012,
            -2146140848.718679,
        ],
    ],
    [
        1850428800000,
        [
            3258754193.596369,
            -3731896336.384781,
            -2146489590.726635,
        ],
    ],
    [
        1851033600000,
        [
            3261468461.083243,
            -3730391081.772131,
            -2146837273.927671,
        ],
    ],
    [
        1851638400000,
        [
            3264182323.089964,
            -3728884165.480278,
            -2147184328.386396,
        ],
    ],
    [
        1852243200000,
        [
            3266895699.699862,
            -3727375726.735232,
            -2147531172.509848,
        ],
    ],
    [
        1852848000000,
        [
            3269608344.815888,
            -3725866036.104352,
            -2147878065.144352,
        ],
    ],
    [
        1853452800000,
        [
            3272319933.431036,
            -3724355400.444149,
            -2148225015.00806,
        ],
    ],
    [
        1854057600000,
        [
            3275030176.032074,
            -3722844055.978903,
            -2148571778.805213,
        ],
    ],
    [
        1854662400000,
        [
            3277738920.440973,
            -3721332086.645367,
            -2148917947.123219,
        ],
    ],
    [
        1855267200000,
        [
            3280446206.852413,
            -3719819395.023617,
            -2149263088.432337,
        ],
    ],
    [
        1855872000000,
        [
            3283152255.309452,
            -3718305735.759052,
            -2149606901.095321,
        ],
    ],
    [
        1856476800000,
        [
            3285857387.452106,
            -3716790801.767855,
            -2149949319.666243,
        ],
    ],
    [
        1857081600000,
        [
            3288561912.861753,
            -3715274333.711497,
            -2150290538.251103,
        ],
    ],
    [
        1857686400000,
        [
            3291266021.45713,
            -3713756211.714213,
            -2150630942.472913,
        ],
    ],
    [
        1858291200000,
        [
            3293969717.273043,
            -3712236497.406213,
            -2150970973.591524,
        ],
    ],
    [
        1858896000000,
        [
            3296672817.083862,
            -3710715411.79171,
            -2151310971.98486,
        ],
    ],
    [
        1859500800000,
        [
            3299375015.548579,
            -3709193256.329271,
            -2151651056.412509,
        ],
    ],
    [
        1860105600000,
        [
            3302075993.17687,
            -3707670305.985702,
            -2151991082.648694,
        ],
    ],
    [
        1860710400000,
        [
            3304775528.164986,
            -3706146712.576844,
            -2152330694.573868,
        ],
    ],
    [
        1861315200000,
        [
            3307473573.815633,
            -3704622451.315956,
            -2152669448.751746,
        ],
    ],
    [
        1861920000000,
        [
            3310170275.036036,
            -3703097329.140231,
            -2153006970.266095,
        ],
    ],
    [
        1862524800000,
        [
            3312865917.535088,
            -3701571052.824026,
            -2153343085.377781,
        ],
    ],
    [
        1863129600000,
        [
            3315560827.552701,
            -3700043332.134161,
            -2153677882.721622,
        ],
    ],
    [
        1863734400000,
        [
            3318255256.359759,
            -3698513980.752261,
            -2154011681.04094,
        ],
    ],
    [
        1864339200000,
        [
            3320949289.921205,
            -3696982981.955772,
            -2154344916.8792,
        ],
    ],
    [
        1864944000000,
        [
            3323642817.857317,
            -3695450495.835363,
            -2154677991.155806,
        ],
    ],
    [
        1865548800000,
        [
            3326335572.605135,
            -3693916802.803551,
            -2155011127.149833,
        ],
    ],
    [
        1866153600000,
        [
            3329027224.003997,
            -3692382203.836207,
            -2155344291.489012,
        ],
    ],
    [
        1866758400000,
        [
            3331717495.075786,
            -3690846914.277827,
            -2155677206.586328,
        ],
    ],
    [
        1867363200000,
        [
            3334406258.200541,
            -3689310988.667061,
            -2156009448.401184,
        ],
    ],
    [
        1867968000000,
        [
            3337093579.286688,
            -3687774301.704062,
            -2156340595.035326,
        ],
    ],
    [
        1868572800000,
        [
            3339779694.323274,
            -3686236592.376233,
            -2156670375.564309,
        ],
    ],
    [
        1869177600000,
        [
            3342464925.522229,
            -3684697556.697115,
            -2156998766.224803,
        ],
    ],
    [
        1869782400000,
        [
            3345149567.141499,
            -3683156955.99037,
            -2157325999.016734,
        ],
    ],
    [
        1870387200000,
        [
            3347833782.387433,
            -3681614701.686687,
            -2157652480.199986,
        ],
    ],
    [
        1870992000000,
        [
            3350517546.58015,
            -3680070886.339996,
            -2157978647.295566,
        ],
    ],
    [
        1871596800000,
        [
            3353200654.513381,
            -3678525750.878807,
            -2158304814.184489,
        ],
    ],
    [
        1872201600000,
        [
            3355882792.12701,
            -3676979600.67587,
            -2158631060.418172,
        ],
    ],
    [
        1872806400000,
        [
            3358563648.542932,
            -3675432698.462061,
            -2158957204.064447,
        ],
    ],
    [
        1873411200000,
        [
            3361243026.196457,
            -3673885171.953999,
            -2159282866.478508,
        ],
    ],
    [
        1874016000000,
        [
            3363920910.17093,
            -3672336969.00766,
            -2159607605.143858,
        ],
    ],
    [
        1874620800000,
        [
            3366597473.732886,
            -3670787875.491675,
            -2159931068.894496,
        ],
    ],
    [
        1875225600000,
        [
            3369273017.578837,
            -3669237590.358036,
            -2160253121.960236,
        ],
    ],
    [
        1875830400000,
        [
            3371947863.496911,
            -3667685831.92598,
            -2160573892.031067,
        ],
    ],
    [
        1876435200000,
        [
            3374622240.613944,
            -3666132437.196298,
            -2160893724.803089,
        ],
    ],
    [
        1877040000000,
        [
            3377296204.720742,
            -3664577419.142558,
            -2161213062.1653,
        ],
    ],
    [
        1877644800000,
        [
            3379969618.583647,
            -3663020962.597325,
            -2161532286.931927,
        ],
    ],
    [
        1878249600000,
        [
            3382642200.850366,
            -3661463358.963533,
            -2161851587.324984,
        ],
    ],
    [
        1878854400000,
        [
            3385313625.573038,
            -3659904901.589789,
            -2162170889.489152,
        ],
    ],
    [
        1879459200000,
        [
            3387983635.64803,
            -3658345781.752383,
            -2162489883.746971,
        ],
    ],
    [
        1880064000000,
        [
            3390652132.382216,
            -3656786022.484986,
            -2162808134.397562,
        ],
    ],
    [
        1880668800000,
        [
            3393319210.350978,
            -3655225470.379482,
            -2163125232.51351,
        ],
    ],
    [
        1881273600000,
        [
            3395985124.17439,
            -3653663848.50247,
            -2163440939.516996,
        ],
    ],
    [
        1881878400000,
        [
            3398650197.966689,
            -3652100853.498318,
            -2163755271.449149,
        ],
    ],
    [
        1882483200000,
        [
            3401314709.654229,
            -3650536262.594382,
            -2164068493.043815,
        ],
    ],
    [
        1883088000000,
        [
            3403978791.87894,
            -3648970012.006168,
            -2164381023.853769,
        ],
    ],
    [
        1883692800000,
        [
            3406642384.265237,
            -3647402219.42836,
            -2164693290.564566,
        ],
    ],
    [
        1884297600000,
        [
            3409305253.174546,
            -3645833143.331955,
            -2165005576.890296,
        ],
    ],
    [
        1884902400000,
        [
            3411967072.890509,
            -3644263092.750263,
            -2165317923.351505,
        ],
    ],
    [
        1885507200000,
        [
            3414627540.50439,
            -3642692318.940969,
            -2165630113.377585,
        ],
    ],
    [
        1886112000000,
        [
            3417286482.824309,
            -3641120926.982445,
            -2165941750.261851,
        ],
    ],
    [
        1886716800000,
        [
            3419943915.477463,
            -3639548838.927051,
            -2166252396.451759,
        ],
    ],
    [
        1887321600000,
        [
            3422600035.8046,
            -3637975822.573233,
            -2166561727.626503,
        ],
    ],
    [
        1887926400000,
        [
            3425255153.856925,
            -3636401574.600325,
            -2166869648.143292,
        ],
    ],
    [
        1888531200000,
        [
            3427909583.198163,
            -3634825828.442803,
            -2167176325.476888,
        ],
    ],
    [
        1889136000000,
        [
            3430563529.931784,
            -3633248448.958041,
            -2167482130.858648,
        ],
    ],
    [
        1889740800000,
        [
            3433217020.089046,
            -3631669480.386762,
            -2167787508.301515,
        ],
    ],
    [
        1890345600000,
        [
            3435869890.406448,
            -3630089131.46411,
            -2168092818.793366,
        ],
    ],
    [
        1890950400000,
        [
            3438521845.456602,
            -3628507702.978972,
            -2168398213.322455,
        ],
    ],
    [
        1891555200000,
        [
            3441172561.857594,
            -3626925482.502422,
            -2168703579.543968,
        ],
    ],
    [
        1892160000000,
        [
            3443821802.737097,
            -3625342643.740288,
            -2169008581.960082,
        ],
    ],
    [
        1892764800000,
        [
            3446469501.653057,
            -3623759186.63931,
            -2169312781.077298,
        ],
    ],
    [
        1893369600000,
        [
            3449115787.180271,
            -3622174938.215014,
            -2169615788.190315,
        ],
    ],
    [
        1893974400000,
        [
            3451760939.073885,
            -3620589612.351961,
            -2169917401.658783,
        ],
    ],
    [
        1894579200000,
        [
            3454405289.213315,
            -3619002910.355875,
            -2170217678.340304,
        ],
    ],
    [
        1895184000000,
        [
            3457049104.4143,
            -3617414627.814103,
            -2170516914.209028,
        ],
    ],
    [
        1895788800000,
        [
            3459692493.743582,
            -3615824726.780468,
            -2170815539.469092,
        ],
    ],
    [
        1896393600000,
        [
            3462335371.517068,
            -3614233347.978043,
            -2171113966.556047,
        ],
    ],
    [
        1896998400000,
        [
            3464977487.806601,
            -3612640760.564936,
            -2171412444.911382,
        ],
    ],
    [
        1897603200000,
        [
            3467618516.270714,
            -3611047266.861156,
            -2171710972.41921,
        ],
    ],
    [
        1898208000000,
        [
            3470258169.277786,
            -3609453094.93147,
            -2172009295.483404,
        ],
    ],
    [
        1898812800000,
        [
            3472896299.162479,
            -3607858317.536962,
            -2172306998.413193,
        ],
    ],
    [
        1899417600000,
        [
            3475532949.506947,
            -3606262826.351454,
            -2172603649.715347,
        ],
    ],
    [
        1900022400000,
        [
            3478168339.315328,
            -3604666369.86297,
            -2172898953.48836,
        ],
    ],
    [
        1900627200000,
        [
            3480802786.257855,
            -3603068641.552598,
            -2173192853.869018,
        ],
    ],
    [
        1901232000000,
        [
            3483436594.95492,
            -3601469387.274814,
            -2173485554.9415,
        ],
    ],
    [
        1901836800000,
        [
            3486069947.956183,
            -3599868493.723419,
            -2173777447.577489,
        ],
    ],
    [
        1902441600000,
        [
            3488702839.469226,
            -3598266028.262707,
            -2174068970.849158,
        ],
    ],
    [
        1903046400000,
        [
            3491335077.40917,
            -3596662215.452333,
            -2174360457.911074,
        ],
    ],
    [
        1903651200000,
        [
            3493966350.692517,
            -3595057357.890142,
            -2174652018.885049,
        ],
    ],
    [
        1904256000000,
        [
            3496596337.797479,
            -3593451729.25663,
            -2174943501.324934,
        ],
    ],
    [
        1904860800000,
        [
            3499224819.150552,
            -3591845477.423114,
            -2175234543.594986,
        ],
    ],
    [
        1905465600000,
        [
            3501851753.238056,
            -3590238572.499876,
            -2175524702.575667,
        ],
    ],
    [
        1906070400000,
        [
            3504477289.689576,
            -3588630817.926378,
            -2175813609.588288,
        ],
    ],
    [
        1906675200000,
        [
            3507101715.636689,
            -3587021919.932577,
            -2176101100.06763,
        ],
    ],
    [
        1907280000000,
        [
            3509725353.704727,
            -3585411591.694619,
            -2176387272.463622,
        ],
    ],
    [
        1907884800000,
        [
            3512348447.057122,
            -3583799656.095379,
            -2176672454.395089,
        ],
    ],
    [
        1908489600000,
        [
            3514971073.460303,
            -3582186109.345579,
            -2176957086.911121,
        ],
    ],
    [
        1909094400000,
        [
            3517593118.443353,
            -3580571121.622594,
            -2177241568.419662,
        ],
    ],
    [
        1909699200000,
        [
            3520214314.364131,
            -3578954977.029139,
            -2177526114.709035,
        ],
    ],
    [
        1910304000000,
        [
            3522834333.45102,
            -3577337975.619463,
            -2177810683.906445,
        ],
    ],
    [
        1910908800000,
        [
            3525452903.86457,
            -3575720328.838496,
            -2178094991.43926,
        ],
    ],
    [
        1911513600000,
        [
            3528069906.125655,
            -3574102085.087673,
            -2178378610.441902,
        ],
    ],
    [
        1912118400000,
        [
            3530685415.067334,
            -3572483113.020365,
            -2178661122.387479,
        ],
    ],
    [
        1912723200000,
        [
            3533299673.213056,
            -3570863148.186692,
            -2178942264.244834,
        ],
    ],
    [
        1913328000000,
        [
            3535913005.62891,
            -3569241886.170653,
            -2179222021.267718,
        ],
    ],
    [
        1913932800000,
        [
            3538525705.234091,
            -3567619090.372507,
            -2179500633.096042,
        ],
    ],
    [
        1914537600000,
        [
            3541137928.753521,
            -3565994676.436237,
            -2179778509.348222,
        ],
    ],
    [
        1915142400000,
        [
            3543749641.385829,
            -3564368742.44637,
            -2180056084.535439,
        ],
    ],
    [
        1915747200000,
        [
            3546360630.166874,
            -3562741534.377489,
            -2180333665.233025,
        ],
    ],
    [
        1916352000000,
        [
            3548970580.136055,
            -3561113359.316647,
            -2180611322.750076,
        ],
    ],
    [
        1916956800000,
        [
            3551579184.804178,
            -3559484476.418733,
            -2180888867.208343,
        ],
    ],
    [
        1917561600000,
        [
            3554186252.802758,
            -3557855005.633704,
            -2181165914.031895,
        ],
    ],
    [
        1918166400000,
        [
            3556791775.484017,
            -3556224886.272439,
            -2181442020.085055,
        ],
    ],
    [
        1918771200000,
        [
            3559395930.384543,
            -3554593898.385466,
            -2181716839.726706,
        ],
    ],
    [
        1919376000000,
        [
            3561999018.697039,
            -3552961739.509617,
            -2181990245.885481,
        ],
    ],
    [
        1919980800000,
        [
            3564601358.953356,
            -3551328130.547513,
            -2182262374.933787,
        ],
    ],
    [
        1920585600000,
        [
            3567203173.675245,
            -3549692914.344527,
            -2182533579.022898,
        ],
    ],
    [
        1921190400000,
        [
            3569804509.517228,
            -3548056111.519088,
            -2182804301.293653,
        ],
    ],
    [
        1921795200000,
        [
            3572405220.191778,
            -3546417912.958057,
            -2183074918.822189,
        ],
    ],
    [
        1922400000000,
        [
            3575005017.682094,
            -3544778612.448179,
            -2183345610.20784,
        ],
    ],
    [
        1923004800000,
        [
            3577603572.774762,
            -3543138504.206205,
            -2183616293.518233,
        ],
    ],
    [
        1923609600000,
        [
            3580200630.776358,
            -3541497780.149673,
            -2183886655.11895,
        ],
    ],
    [
        1924214400000,
        [
            3582796101.629793,
            -3539856461.704402,
            -2184156259.780379,
        ],
    ],
    [
        1924819200000,
        [
            3585390090.044215,
            -3538214391.984589,
            -2184424703.859395,
        ],
    ],
    [
        1925424000000,
        [
            3587982857.010063,
            -3536571292.687508,
            -2184691757.82583,
        ],
    ],
    [
        1926028800000,
        [
            3590574728.47579,
            -3534926863.001148,
            -2184957447.520293,
        ],
    ],
    [
        1926633600000,
        [
            3593165980.895377,
            -3533280885.822821,
            -2185222045.831434,
        ],
    ],
    [
        1927238400000,
        [
            3595756742.922235,
            -3531633305.097301,
            -2185485976.735471,
        ],
    ],
    [
        1927843200000,
        [
            3598346949.351415,
            -3529984246.149917,
            -2185749665.085641,
        ],
    ],
    [
        1928448000000,
        [
            3600936364.286035,
            -3528333971.482229,
            -2186013386.594241,
        ],
    ],
    [
        1929052800000,
        [
            3603524664.336106,
            -3526682788.643844,
            -2186277171.550279,
        ],
    ],
    [
        1929657600000,
        [
            3606111551.946778,
            -3525030942.970465,
            -2186540794.687307,
        ],
    ],
    [
        1930262400000,
        [
            3608696860.032338,
            -3523378532.04606,
            -2186803854.473258,
        ],
    ],
    [
        1930867200000,
        [
            3611280611.498714,
            -3521725472.086042,
            -2187065915.069681,
        ],
    ],
    [
        1931472000000,
        [
            3613863012.294344,
            -3520071527.901943,
            -2187326660.284093,
        ],
    ],
    [
        1932076800000,
        [
            3616444379.209776,
            -3518416394.883943,
            -2187586004.102048,
        ],
    ],
    [
        1932681600000,
        [
            3619025027.608341,
            -3516759806.057276,
            -2187844120.967626,
        ],
    ],
    [
        1933286400000,
        [
            3621605160.448108,
            -3515101627.481196,
            -2188101385.630807,
        ],
    ],
    [
        1933891200000,
        [
            3624184797.226698,
            -3513441906.027775,
            -2188358240.887474,
        ],
    ],
    [
        1934496000000,
        [
            3626763767.700116,
            -3511780851.993138,
            -2188615040.264918,
        ],
    ],
    [
        1935100800000,
        [
            3629341772.537943,
            -3510118763.749673,
            -2188871923.179922,
        ],
    ],
    [
        1935705600000,
        [
            3631918488.567725,
            -3508455922.181655,
            -2189128766.238302,
        ],
    ],
    [
        1936310400000,
        [
            3634493681.851612,
            -3506792491.602209,
            -2189385226.294286,
        ],
    ],
    [
        1936915200000,
        [
            3637067289.676334,
            -3505128461.304107,
            -2189640860.759676,
        ],
    ],
    [
        1937520000000,
        [
            3639639442.108021,
            -3503463648.973144,
            -2189895283.565676,
        ],
    ],
    [
        1938124800000,
        [
            3642210415.327069,
            -3501797765.124328,
            -2190148301.199951,
        ],
    ],
    [
        1938729600000,
        [
            3644780534.286509,
            -3500130515.024019,
            -2190399980.585146,
        ],
    ],
    [
        1939334400000,
        [
            3647350058.670915,
            -3498461701.340146,
            -2190650625.395343,
        ],
    ],
    [
        1939939200000,
        [
            3649919089.359218,
            -3496791292.855921,
            -2190900668.753932,
        ],
    ],
    [
        1940544000000,
        [
            3652487530.28016,
            -3495119436.450646,
            -2191150520.112429,
        ],
    ],
    [
        1941148800000,
        [
            3655055122.188444,
            -3493446405.587315,
            -2191400420.628919,
        ],
    ],
    [
        1941753600000,
        [
            3657621534.082848,
            -3491772503.33108,
            -2191650358.558854,
        ],
    ],
    [
        1942358400000,
        [
            3660186478.412029,
            -3490097955.69531,
            -2191900073.651854,
        ],
    ],
    [
        1942963200000,
        [
            3662749810.765985,
            -3488422832.240239,
            -2192149148.274566,
        ],
    ],
    [
        1943568000000,
        [
            3665311579.615582,
            -3486747021.635991,
            -2192397154.489932,
        ],
    ],
    [
        1944172800000,
        [
            3667872007.800071,
            -3485070271.545915,
            -2192643805.3203,
        ],
    ],
    [
        1944777600000,
        [
            3670431412.382103,
            -3483392278.572906,
            -2192889055.920703,
        ],
    ],
    [
        1945382400000,
        [
            3672990091.922771,
            -3481712796.045668,
            -2193133119.537459,
        ],
    ],
    [
        1945987200000,
        [
            3675548220.681829,
            -3480031722.328972,
            -2193376393.535408,
        ],
    ],
    [
        1946592000000,
        [
            3678105786.846682,
            -3478349138.260012,
            -2193619320.025548,
        ],
    ],
    [
        1947196800000,
        [
            3680662596.273278,
            -3476665278.714432,
            -2193862229.167681,
        ],
    ],
    [
        1947801600000,
        [
            3683218339.616651,
            -3474980450.111386,
            -2194105222.714672,
        ],
    ],
    [
        1948406400000,
        [
            3685772700.923449,
            -3473294924.538166,
            -2194348139.825274,
        ],
    ],
    [
        1949011200000,
        [
            3688325469.222373,
            -3471608845.615949,
            -2194590614.472436,
        ],
    ],
    [
        1949616000000,
        [
            3690876613.240818,
            -3469922178.392872,
            -2194832204.110896,
        ],
    ],
    [
        1950220800000,
        [
            3693426292.760965,
            -3468234721.984832,
            -2195072545.987365,
        ],
    ],
    [
        1950825600000,
        [
            3695974802.11037,
            -3466546181.2771,
            -2195311485.526464,
        ],
    ],
    [
        1951430400000,
        [
            3698522466.275823,
            -3464856271.771592,
            -2195549130.667272,
        ],
    ],
    [
        1952035200000,
        [
            3701069526.826504,
            -3463164820.203461,
            -2195785814.003456,
        ],
    ],
    [
        1952640000000,
        [
            3703616056.868256,
            -3461471826.463681,
            -2196021976.441323,
        ],
    ],
    [
        1953244800000,
        [
            3706161935.077974,
            -3459777464.916607,
            -2196258011.936382,
        ],
    ],
    [
        1953849600000,
        [
            3708706889.521645,
            -3458082023.502168,
            -2196494128.393194,
        ],
    ],
    [
        1954454400000,
        [
            3711250595.392319,
            -3456385801.600928,
            -2196730274.592905,
        ],
    ],
    [
        1955059200000,
        [
            3713792789.187972,
            -3454689003.750757,
            -2196966158.167747,
        ],
    ],
    [
        1955664000000,
        [
            3716333360.253512,
            -3452991668.371673,
            -2197201348.358135,
        ],
    ],
    [
        1956268800000,
        [
            3718872390.732119,
            -3451293654.67382,
            -2197435427.890973,
        ],
    ],
    [
        1956873600000,
        [
            3721410127.695732,
            -3449594691.749062,
            -2197668140.284567,
        ],
    ],
    [
        1957478400000,
        [
            3723946895.876741,
            -3447894473.656724,
            -2197899479.997577,
        ],
    ],
    [
        1958083200000,
        [
            3726482982.810825,
            -3446192766.698865,
            -2198129693.54299,
        ],
    ],
    [
        1958688000000,
        [
            3729018537.313992,
            -3444489491.074142,
            -2198359192.41317,
        ],
    ],
    [
        1959292800000,
        [
            3731553516.158571,
            -3442784748.976963,
            -2198588408.239841,
        ],
    ],
    [
        1959897600000,
        [
            3734087698.16232,
            -3441078788.702355,
            -2198817640.04388,
        ],
    ],
    [
        1960502400000,
        [
            3736620761.605544,
            -3439371916.88633,
            -2199046948.451806,
        ],
    ],
    [
        1961107200000,
        [
            3739152397.204096,
            -3437664390.741539,
            -2199276135.068711,
        ],
    ],
    [
        1961712000000,
        [
            3741682416.686329,
            -3435956328.148746,
            -2199504812.710948,
        ],
    ],
    [
        1962316800000,
        [
            3744210818.844721,
            -3434247665.262727,
            -2199732540.685814,
        ],
    ],
    [
        1962921600000,
        [
            3746737788.378186,
            -3432538178.261415,
            -2199958979.749329,
        ],
    ],
    [
        1963526400000,
        [
            3749263629.352836,
            -3430827563.729866,
            -2200184012.796919,
        ],
    ],
    [
        1964131200000,
        [
            3751788657.660289,
            -3429115546.75484,
            -2200407786.378642,
        ],
    ],
    [
        1964736000000,
        [
            3754313089.491884,
            -3427401977.726961,
            -2200630658.539215,
        ],
    ],
    [
        1965340800000,
        [
            3756836964.629993,
            -3425686885.035348,
            -2200853072.854769,
        ],
    ],
    [
        1965945600000,
        [
            3759360131.268474,
            -3423970465.753244,
            -2201075402.330902,
        ],
    ],
    [
        1966550400000,
        [
            3761882298.573621,
            -3422253016.786839,
            -2201297817.636754,
        ],
    ],
    [
        1967155200000,
        [
            3764403138.770768,
            -3420534830.610712,
            -2201520227.204708,
        ],
    ],
    [
        1967760000000,
        [
            3766922401.891503,
            -3418816093.208071,
            -2201742310.39746,
        ],
    ],
    [
        1968364800000,
        [
            3769440002.863844,
            -3417096820.05439,
            -2201963630.704172,
        ],
    ],
    [
        1968969600000,
        [
            3771956051.850368,
            -3415376851.576442,
            -2202183789.540512,
        ],
    ],
    [
        1969574400000,
        [
            3774470816.729148,
            -3413655909.480002,
            -2202402567.442023,
        ],
    ],
    [
        1970179200000,
        [
            3776984628.093142,
            -3411933694.6767,
            -2202620001.539027,
        ],
    ],
    [
        1970784000000,
        [
            3779497760.991811,
            -3410209993.842821,
            -2202836372.25043,
        ],
    ],
    [
        1971388800000,
        [
            3782010338.568637,
            -3408484755.761479,
            -2203052104.873882,
        ],
    ],
    [
        1971993600000,
        [
            3784522289.650611,
            -3406758109.638708,
            -2203267620.268156,
        ],
    ],
    [
        1972598400000,
        [
            3787033373.834014,
            -3405030319.630473,
            -2203483186.301565,
        ],
    ],
    [
        1973203200000,
        [
            3789543266.243264,
            -3403301691.450016,
            -2203698823.004487,
        ],
    ],
    [
        1973808000000,
        [
            3792051672.007928,
            -3401572464.434238,
            -2203914295.803241,
        ],
    ],
    [
        1974412800000,
        [
            3794558429.470368,
            -3399842727.601954,
            -2204129198.451435,
        ],
    ],
    [
        1975017600000,
        [
            3797063566.406864,
            -3398112388.541319,
            -2204343095.526984,
        ],
    ],
    [
        1975622400000,
        [
            3799567290.199207,
            -3396381205.698787,
            -2204555675.657937,
        ],
    ],
    [
        1976227200000,
        [
            3802069914.5825,
            -3394648873.880366,
            -2204766862.204118,
        ],
    ],
    [
        1976832000000,
        [
            3804571748.797712,
            -3392915132.681937,
            -2204976840.727452,
        ],
    ],
    [
        1977436800000,
        [
            3807072988.56817,
            -3391179857.609105,
            -2205185992.525364,
        ],
    ],
    [
        1978041600000,
        [
            3809573645.784765,
            -3389443102.901894,
            -2205394759.548358,
        ],
    ],
    [
        1978646400000,
        [
            3812073542.73241,
            -3387705083.596611,
            -2205603489.394358,
        ],
    ],
    [
        1979251200000,
        [
            3814572374.528255,
            -3385966100.63566,
            -2205812312.93867,
        ],
    ],
    [
        1979856000000,
        [
            3817069816.571153,
            -3384226434.484647,
            -2206021098.051283,
        ],
    ],
    [
        1980460800000,
        [
            3819565638.059479,
            -3382486246.358768,
            -2206229496.558876,
        ],
    ],
    [
        1981065600000,
        [
            3822059781.695132,
            -3380745522.163579,
            -2206437066.805905,
        ],
    ],
    [
        1981670400000,
        [
            3824552382.806777,
            -3379004077.801798,
            -2206643428.604329,
        ],
    ],
    [
        1982275200000,
        [
            3827043721.137758,
            -3377261624.25873,
            -2206848397.68349,
        ],
    ],
    [
        1982880000000,
        [
            3829534121.024856,
            -3375517870.67792,
            -2207052051.765024,
        ],
    ],
    [
        1983484800000,
        [
            3832023835.545464,
            -3373772628.688528,
            -2207254703.497294,
        ],
    ],
    [
        1984089600000,
        [
            3834512956.939312,
            -3372025880.239929,
            -2207456790.256194,
        ],
    ],
    [
        1984694400000,
        [
            3837001384.911314,
            -3370277784.665381,
            -2207658720.557071,
        ],
    ],
    [
        1985299200000,
        [
            3839488861.565219,
            -3368528622.628735,
            -2207860730.110584,
        ],
    ],
    [
        1985904000000,
        [
            3841975060.629723,
            -3366778698.376676,
            -2208062798.833672,
        ],
    ],
    [
        1986508800000,
        [
            3844459702.588971,
            -3365028234.52226,
            -2208264659.121095,
        ],
    ],
    [
        1987113600000,
        [
            3846942653.854876,
            -3363277295.017031,
            -2208465891.127311,
        ],
    ],
    [
        1987718400000,
        [
            3849423973.854948,
            -3361525763.525778,
            -2208666070.4093,
        ],
    ],
    [
        1988323200000,
        [
            3851903894.673714,
            -3359773384.558682,
            -2208864917.095198,
        ],
    ],
    [
        1988928000000,
        [
            3854382739.888533,
            -3358019853.871743,
            -2209062395.484908,
        ],
    ],
    [
        1989532800000,
        [
            3856860810.252931,
            -3356264926.935794,
            -2209258727.493704,
        ],
    ],
    [
        1990137600000,
        [
            3859338277.443613,
            -3354508506.180869,
            -2209454314.118063,
        ],
    ],
    [
        1990742400000,
        [
            3861815124.10335,
            -3352750675.778757,
            -2209649593.919913,
        ],
    ],
    [
        1991347200000,
        [
            3864291150.637311,
            -3350991672.681991,
            -2209844889.163374,
        ],
    ],
    [
        1991952000000,
        [
            3866766046.554741,
            -3349231803.938111,
            -2210040292.623042,
        ],
    ],
    [
        1992556800000,
        [
            3869239501.440889,
            -3347471337.810977,
            -2210235634.541222,
        ],
    ],
    [
        1993161600000,
        [
            3871711314.085738,
            -3345710408.253186,
            -2210430542.21658,
        ],
    ],
    [
        1993766400000,
        [
            3874181462.297986,
            -3343948968.791834,
            -2210624571.730861,
        ],
    ],
    [
        1994371200000,
        [
            3876650111.433332,
            -3342186809.481193,
            -2210817363.975963,
        ],
    ],
    [
        1994976000000,
        [
            3879117557.513638,
            -3340423629.704467,
            -2211008770.775419,
        ],
    ],
    [
        1995580800000,
        [
            3881584123.107716,
            -3338659143.312753,
            -2211198907.603608,
        ],
    ],
    [
        1996185600000,
        [
            3884050042.598966,
            -3336893179.509755,
            -2211388112.739304,
        ],
    ],
    [
        1996790400000,
        [
            3886515378.709565,
            -3335125742.714942,
            -2211576826.950961,
        ],
    ],
    [
        1997395200000,
        [
            3888980000.02644,
            -3333357010.273703,
            -2211765437.741167,
        ],
    ],
    [
        1998000000000,
        [
            3891443626.371699,
            -3331587269.871879,
            -2211954142.996733,
        ],
    ],
    [
        1998604800000,
        [
            3893905926.385588,
            -3329816818.402464,
            -2212142881.060918,
        ],
    ],
    [
        1999209600000,
        [
            3896366633.784128,
            -3328045857.614721,
            -2212331352.69978,
        ],
    ],
    [
        1999814400000,
        [
            3898825641.03975,
            -3326274423.340973,
            -2212519127.105688,
        ],
    ],
    [
        2000419200000,
        [
            3901283036.090887,
            -3324502372.387513,
            -2212705792.914979,
        ],
    ],
    [
        2001024000000,
        [
            3903739069.086283,
            -3322729432.837009,
            -2212891102.223451,
        ],
    ],
    [
        2001628800000,
        [
            3906194063.524366,
            -3320955300.919018,
            -2213075058.985675,
        ],
    ],
    [
        2002233600000,
        [
            3908648301.859742,
            -3319179749.169344,
            -2213257918.816431,
        ],
    ],
    [
        2002838400000,
        [
            3911101924.681766,
            -3317402707.407069,
            -2213440098.671947,
        ],
    ],
    [
        2003443200000,
        [
            3913554880.170507,
            -3315624287.758959,
            -2213622029.226814,
        ],
    ],
    [
        2004048000000,
        [
            3916006941.644451,
            -3313844745.52819,
            -2213804003.456122,
        ],
    ],
    [
        2004652800000,
        [
            3918457786.254604,
            -3312064390.33749,
            -2213986073.977047,
        ],
    ],
    [
        2005257600000,
        [
            3920907107.750332,
            -3310283478.137332,
            -2214168034.666096,
        ],
    ],
    [
        2005862400000,
        [
            3923354723.767341,
            -3308502122.157327,
            -2214349494.014466,
        ],
    ],
    [
        2006467200000,
        [
            3925800639.252626,
            -3306720254.908475,
            -2214530014.152177,
        ],
    ],
    [
        2007072000000,
        [
            3928245044.523305,
            -3304937653.910815,
            -2214709265.413952,
        ],
    ],
    [
        2007676800000,
        [
            3930688249.451582,
            -3303154020.321275,
            -2214887142.373528,
        ],
    ],
    [
        2008281600000,
        [
            3933130574.062203,
            -3301369084.069272,
            -2215063801.59324,
        ],
    ],
    [
        2008886400000,
        [
            3935572234.088432,
            -3299582701.283177,
            -2215239607.560287,
        ],
    ],
    [
        2009491200000,
        [
            3938013265.220886,
            -3297794907.144242,
            -2215415004.51584,
        ],
    ],
    [
        2010096000000,
        [
            3940453511.893363,
            -3296005903.801683,
            -2215590359.826595,
        ],
    ],
    [
        2010700800000,
        [
            3942892682.752192,
            -3294215989.373524,
            -2215765835.048363,
        ],
    ],
    [
        2011305600000,
        [
            3945330453.274204,
            -3292425453.545226,
            -2215941329.134918,
        ],
    ],
    [
        2011910400000,
        [
            3947766580.350872,
            -3290634475.838276,
            -2216116513.984195,
        ],
    ],
    [
        2012515200000,
        [
            3950200988.180785,
            -3288843062.75774,
            -2216290950.564252,
        ],
    ],
    [
        2013120000000,
        [
            3952633794.640827,
            -3287051046.380183,
            -2216464243.977898,
        ],
    ],
    [
        2013724800000,
        [
            3955065269.569679,
            -3285258144.229916,
            -2216636182.237315,
        ],
    ],
    [
        2014329600000,
        [
            3957495740.462897,
            -3283464059.122906,
            -2216806811.247407,
        ],
    ],
    [
        2014934400000,
        [
            3959925478.076741,
            -3281668584.426348,
            -2216976419.705321,
        ],
    ],
    [
        2015539200000,
        [
            3962354600.989754,
            -3279871676.676524,
            -2217145436.926592,
        ],
    ],
    [
        2016144000000,
        [
            3964783032.426353,
            -3278073470.570533,
            -2217314280.416769,
        ],
    ],
    [
        2016748800000,
        [
            3967210527.134429,
            -3276274232.340918,
            -2217483209.297241,
        ],
    ],
    [
        2017353600000,
        [
            3969636758.360028,
            -3274474266.665836,
            -2217652233.740294,
        ],
    ],
    [
        2017958400000,
        [
            3972061432.959282,
            -3272673809.287392,
            -2217821110.947345,
        ],
    ],
    [
        2018563200000,
        [
            3974484394.556201,
            -3270872943.592286,
            -2217989430.463923,
        ],
    ],
    [
        2019168000000,
        [
            3976905678.008011,
            -3269071571.459505,
            -2218156759.216444,
        ],
    ],
    [
        2019772800000,
        [
            3979325495.99996,
            -3267269448.561028,
            -2218322794.053644,
        ],
    ],
    [
        2020377600000,
        [
            3981744163.426034,
            -3265466270.831924,
            -2218487468.124858,
        ],
    ],
    [
        2020982400000,
        [
            3984161986.086438,
            -3263661782.017261,
            -2218650974.983405,
        ],
    ],
    [
        2021587200000,
        [
            3986579152.011026,
            -3261855865.385465,
            -2218813701.360271,
        ],
    ],
    [
        2022192000000,
        [
            3988995664.663028,
            -3260048586.519198,
            -2218976091.028365,
        ],
    ],
    [
        2022796800000,
        [
            3991411342.580665,
            -3258240170.433698,
            -2219138488.064297,
        ],
    ],
    [
        2023401600000,
        [
            3993825883.12611,
            -3256430921.713093,
            -2219301015.656898,
        ],
    ],
    [
        2024006400000,
        [
            3996238967.26083,
            -3254621118.774203,
            -2219463533.356432,
        ],
    ],
    [
        2024611200000,
        [
            3998650372.05229,
            -3252810917.663288,
            -2219625686.997252,
        ],
    ],
    [
        2025216000000,
        [
            4001060050.35279,
            -3251000297.567805,
            -2219787033.977331,
        ],
    ],
    [
        2025820800000,
        [
            4003468147.523324,
            -3249189068.781361,
            -2219947199.813272,
        ],
    ],
    [
        2026425600000,
        [
            4005874949.835054,
            -3247376940.398498,
            -2220106009.950669,
        ],
    ],
    [
        2027030400000,
        [
            4008280783.845964,
            -3245563623.188734,
            -2220263551.168192,
        ],
    ],
    [
        2027635200000,
        [
            4010685901.525705,
            -3243748932.162745,
            -2220420141.83569,
        ],
    ],
    [
        2028240000000,
        [
            4013090391.03143,
            -3241932853.001676,
            -2220576220.153165,
        ],
    ],
    [
        2028844800000,
        [
            4015494145.59138,
            -3240115548.021715,
            -2220732189.443457,
        ],
    ],
    [
        2029449600000,
        [
            4017896901.966959,
            -3238297299.574438,
            -2220888276.380826,
        ],
    ],
    [
        2030054400000,
        [
            4020298334.437664,
            -3236478411.343296,
            -2221044452.14138,
        ],
    ],
    [
        2030659200000,
        [
            4022698170.310411,
            -3234659101.200276,
            -2221200442.220492,
        ],
    ],
    [
        2031264000000,
        [
            4025096285.419358,
            -3232839423.77742,
            -2221355822.275177,
        ],
    ],
    [
        2031868800000,
        [
            4027492747.77745,
            -3231019252.08848,
            -2221510168.450894,
        ],
    ],
    [
        2032473600000,
        [
            4029887794.407612,
            -3229198323.159454,
            -2221663207.498593,
        ],
    ],
    [
        2033078400000,
        [
            4032281748.284229,
            -3227376330.498015,
            -2221814912.493528,
        ],
    ],
    [
        2033683200000,
        [
            4034674904.880025,
            -3225553031.335063,
            -2221965511.969853,
        ],
    ],
    [
        2034288000000,
        [
            4037067427.66347,
            -3223728332.05088,
            -2222115409.706275,
        ],
    ],
    [
        2034892800000,
        [
            4039459289.563948,
            -3221902321.407505,
            -2222265041.997021,
        ],
    ],
    [
        2035497600000,
        [
            4041850282.079357,
            -3220075238.992424,
            -2222414723.229668,
        ],
    ],
    [
        2036102400000,
        [
            4044240088.416409,
            -3218247390.617104,
            -2222564535.467223,
        ],
    ],
    [
        2036707200000,
        [
            4046628394.0202,
            -3216419041.38655,
            -2222714300.166967,
        ],
    ],
    [
        2037312000000,
        [
            4049014996.678381,
            -3214590323.254733,
            -2222863640.900311,
        ],
    ],
    [
        2037916800000,
        [
            4051399878.383657,
            -3212761188.356124,
            -2223012115.806461,
        ],
    ],
    [
        2038521600000,
        [
            4053783211.109018,
            -3210931425.034557,
            -2223159373.285307,
        ],
    ],
    [
        2039126400000,
        [
            4056165293.667702,
            -3209100733.425961,
            -2223305276.143684,
        ],
    ],
    [
        2039731200000,
        [
            4058546445.593469,
            -3207268832.881406,
            -2223449950.32655,
        ],
    ],
    [
        2040336000000,
        [
            4060926894.851526,
            -3205435561.485003,
            -2223593741.057575,
        ],
    ],
    [
        2040940800000,
        [
            4063306696.757822,
            -3203600933.864444,
            -2223737091.544856,
        ],
    ],
    [
        2041545600000,
        [
            4065685713.437738,
            -3201765136.87781,
            -2223880386.430212,
        ],
    ],
    [
        2042150400000,
        [
            4068063662.010297,
            -3199928464.295552,
            -2224023816.283736,
        ],
    ],
    [
        2042755200000,
        [
            4070440213.744331,
            -3198091214.345422,
            -2224167311.559325,
        ],
    ],
    [
        2043360000000,
        [
            4072815108.68565,
            -3196253586.516698,
            -2224310567.770062,
        ],
    ],
    [
        2043964800000,
        [
            4075188246.634828,
            -3194415612.823468,
            -2224453152.653471,
        ],
    ],
    [
        2044569600000,
        [
            4077559722.798051,
            -3192577147.909307,
            -2224594659.298233,
        ],
    ],
    [
        2045174400000,
        [
            4079929794.953246,
            -3190737922.146747,
            -2224734850.984936,
        ],
    ],
    [
        2045779200000,
        [
            4082298793.362944,
            -3188897637.66202,
            -2224873744.830915,
        ],
    ],
    [
        2046384000000,
        [
            4084667003.996945,
            -3187056073.597274,
            -2225011605.459016,
        ],
    ],
    [
        2046988800000,
        [
            4087034567.351029,
            -3185213166.035088,
            -2225148852.929149,
        ],
    ],
    [
        2047593600000,
        [
            4089401429.926685,
            -3183369032.67974,
            -2225285915.498572,
        ],
    ],
    [
        2048198400000,
        [
            4091767364.60751,
            -3181523931.919813,
            -2225423078.461267,
        ],
    ],
    [
        2048803200000,
        [
            4094132052.105818,
            -3179678171.807992,
            -2225560383.991821,
        ],
    ],
    [
        2049408000000,
        [
            4096495194.052819,
            -3177832002.266074,
            -2225697617.214424,
        ],
    ],
    [
        2050012800000,
        [
            4098856618.214842,
            -3175985528.056559,
            -2225834381.802808,
        ],
    ],
    [
        2050617600000,
        [
            4101216340.021675,
            -3174138672.070162,
            -2225970239.078376,
        ],
    ],
    [
        2051222400000,
        [
            4103574558.2364,
            -3172291202.543552,
            -2226104863.086785,
        ],
    ],
    [
        2051827200000,
        [
            4105931585.342784,
            -3170442815.524142,
            -2226238156.257914,
        ],
    ],
    [
        2052432000000,
        [
            4108287738.026438,
            -3168593242.89914,
            -2226370283.878398,
        ],
    ],
    [
        2053036800000,
        [
            4110643227.327425,
            -3166742346.78216,
            -2226501615.807126,
        ],
    ],
    [
        2053641600000,
        [
            4112998084.966055,
            -3164890167.089958,
            -2226632595.764919,
        ],
    ],
    [
        2054246400000,
        [
            4115352150.943125,
            -3163036907.37203,
            -2226763584.17989,
        ],
    ],
    [
        2054851200000,
        [
            4117705130.431077,
            -3161182863.591056,
            -2226894731.244243,
        ],
    ],
    [
        2055456000000,
        [
            4120056699.064942,
            -3159328319.581707,
            -2227025924.702948,
        ],
    ],
    [
        2056060800000,
        [
            4122406617.108269,
            -3157473446.965327,
            -2227156829.548998,
        ],
    ],
    [
        2056665600000,
        [
            4124754813.310106,
            -3155618244.463953,
            -2227287005.007542,
        ],
    ],
    [
        2057270400000,
        [
            4127101410.001915,
            -3153762537.621497,
            -2227416059.225709,
        ],
    ],
    [
        2057875200000,
        [
            4129446679.698666,
            -3151906040.034959,
            -2227543787.820094,
        ],
    ],
    [
        2058480000000,
        [
            4131790948.013071,
            -3150048454.807853,
            -2227670246.215767,
        ],
    ],
    [
        2059084800000,
        [
            4134134477.915381,
            -3148189579.739785,
            -2227795729.864083,
        ],
    ],
    [
        2059689600000,
        [
            4136477376.537276,
            -3146329379.234695,
            -2227920670.421326,
        ],
    ],
    [
        2060294400000,
        [
            4138819557.158007,
            -3144467998.000543,
            -2228045484.135886,
        ],
    ],
    [
        2060899200000,
        [
            4141160770.136109,
            -3142605710.093001,
            -2228170424.593787,
        ],
    ],
    [
        2061504000000,
        [
            4143500690.321579,
            -3140742821.451797,
            -2228295492.922416,
        ],
    ],
    [
        2062108800000,
        [
            4145839030.124677,
            -3138879563.537629,
            -2228420438.752398,
        ],
    ],
    [
        2062713600000,
        [
            4148175640.349912,
            -3137016014.082289,
            -2228544849.280998,
        ],
    ],
    [
        2063318400000,
        [
            4150510563.174961,
            -3135152070.27014,
            -2228668294.110948,
        ],
    ],
    [
        2063923200000,
        [
            4152844017.82063,
            -3133287484.901533,
            -2228790477.092023,
        ],
    ],
    [
        2064528000000,
        [
            4155176323.079073,
            -3131421954.260215,
            -2228911341.584728,
        ],
    ],
    [
        2065132800000,
        [
            4157507784.362698,
            -3129555226.353061,
            -2229031090.738166,
        ],
    ],
    [
        2065737600000,
        [
            4159838585.916712,
            -3127687190.627685,
            -2229150115.964161,
        ],
    ],
    [
        2066342400000,
        [
            4162168725.852926,
            -3125817917.959188,
            -2229268859.566516,
        ],
    ],
    [
        2066947200000,
        [
            4164498016.613216,
            -3123947637.071604,
            -2229387659.173875,
        ],
    ],
    [
        2067552000000,
        [
            4166826151.745366,
            -3122076655.036166,
            -2229506628.909593,
        ],
    ],
    [
        2068156800000,
        [
            4169152815.723644,
            -3120205249.60581,
            -2229625620.062819,
        ],
    ],
    [
        2068761600000,
        [
            4171477795.934966,
            -3118333571.334961,
            -2229744274.073359,
        ],
    ],
    [
        2069366400000,
        [
            4173801056.218688,
            -3116461591.223988,
            -2229862148.341004,
        ],
    ],
    [
        2069971200000,
        [
            4176122749.995797,
            -3114589112.14149,
            -2229978872.151564,
        ],
    ],
    [
        2070576000000,
        [
            4178443168.144948,
            -3112715838.583932,
            -2230094278.180819,
        ],
    ],
    [
        2071180800000,
        [
            4180762637.219167,
            -3110841480.999438,
            -2230208461.984958,
        ],
    ],
    [
        2071785600000,
        [
            4183081404.404451,
            -3108965857.969688,
            -2230321747.929209,
        ],
    ],
    [
        2072390400000,
        [
            4185399550.675347,
            -3107088959.991263,
            -2230434574.640279,
        ],
    ],
    [
        2072995200000,
        [
            4187716962.159562,
            -3105210953.040256,
            -2230547340.58323,
        ],
    ],
    [
        2073600000000,
        [
            4190033369.973738,
            -3103332120.365105,
            -2230660263.211666,
        ],
    ],
    [
        2074204800000,
        [
            4192348445.177081,
            -3101452762.571528,
            -2230773302.162514,
        ],
    ],
    [
        2074809600000,
        [
            4194661914.791021,
            -3099573092.116225,
            -2230886174.385829,
        ],
    ],
    [
        2075414400000,
        [
            4196973657.778021,
            -3097693159.733218,
            -2230998454.645286,
        ],
    ],
    [
        2076019200000,
        [
            4199283748.177576,
            -3095812836.750836,
            -2231109724.580797,
        ],
    ],
    [
        2076624000000,
        [
            4201592428.997442,
            -3093931859.135406,
            -2231219719.236695,
        ],
    ],
    [
        2077228800000,
        [
            4203900025.295639,
            -3092049921.260663,
            -2231328421.31834,
        ],
    ],
    [
        2077833600000,
        [
            4206206829.322563,
            -3090166785.523644,
            -2231436068.259688,
        ],
    ],
    [
        2078438400000,
        [
            4208512997.915809,
            -3088282366.657747,
            -2231543068.310571,
        ],
    ],
    [
        2079043200000,
        [
            4210818497.389255,
            -3086396761.835773,
            -2231649856.681263,
        ],
    ],
    [
        2079648000000,
        [
            4213123114.860734,
            -3084510217.1188,
            -2231756742.389531,
        ],
    ],
    [
        2080252800000,
        [
            4215426532.850774,
            -3082623041.439009,
            -2231863799.055023,
        ],
    ],
    [
        2080857600000,
        [
            4217728441.323557,
            -3080735498.185225,
            -2231970839.273222,
        ],
    ],
    [
        2081462400000,
        [
            4220028646.725254,
            -3078847713.525432,
            -2232077481.793885,
        ],
    ],
    [
        2082067200000,
        [
            4222327139.44842,
            -3076959633.783641,
            -2232183286.311011,
        ],
    ],
    [
        2082672000000,
        [
            4224624097.509998,
            -3075071045.743363,
            -2232287908.482683,
        ],
    ],
    [
        2083276800000,
        [
            4226919825.514432,
            -3073181652.63513,
            -2232391222.110979,
        ],
    ],
    [
        2083881600000,
        [
            4229214648.428672,
            -3071291179.023968,
            -2232493364.259581,
        ],
    ],
    [
        2084486400000,
        [
            4231508796.15909,
            -3069399468.512981,
            -2232594686.706102,
        ],
    ],
    [
        2085091200000,
        [
            4233802322.658414,
            -3067506540.614089,
            -2232695632.432437,
        ],
    ],
    [
        2085696000000,
        [
            4236095088.698092,
            -3065612585.063103,
            -2232796580.43496,
        ],
    ],
    [
        2086300800000,
        [
            4238386812.128116,
            -3063717895.49186,
            -2232897712.245793,
        ],
    ],
    [
        2086905600000,
        [
            4240677168.387106,
            -3061822765.935281,
            -2232998947.530416,
        ],
    ],
    [
        2087510400000,
        [
            4242965906.088913,
            -3059927387.089475,
            -2233099972.733647,
        ],
    ],
    [
        2088115200000,
        [
            4245252936.162133,
            -3058031779.61987,
            -2233200352.260295,
        ],
    ],
    [
        2088720000000,
        [
            4247538363.448866,
            -3056135787.483144,
            -2233299681.618078,
        ],
    ],
    [
        2089324800000,
        [
            4249822450.741536,
            -3054239132.726763,
            -2233397729.456492,
        ],
    ],
    [
        2089929600000,
        [
            4252105527.22742,
            -3052341513.483585,
            -2233494519.799028,
        ],
    ],
    [
        2090534400000,
        [
            4254387873.186313,
            -3050442711.136519,
            -2233590324.191257,
        ],
    ],
    [
        2091139200000,
        [
            4256669622.649932,
            -3048542667.130751,
            -2233685565.405761,
        ],
    ],
    [
        2091744000000,
        [
            4258950716.989103,
            -3046641501.833006,
            -2233780667.540459,
        ],
    ],
    [
        2092348800000,
        [
            4261230924.579111,
            -3044739472.009701,
            -2233875906.689964,
        ],
    ],
    [
        2092953600000,
        [
            4263509922.583462,
            -3042836881.195397,
            -2233971313.721666,
        ],
    ],
    [
        2093558400000,
        [
            4265787411.997448,
            -3040933972.021388,
            -2234066662.985305,
        ],
    ],
    [
        2094163200000,
        [
            4268063223.499217,
            -3039030839.735376,
            -2234161551.873426,
        ],
    ],
    [
        2094768000000,
        [
            4270337376.456195,
            -3037127398.389478,
            -2234255542.599708,
        ],
    ],
    [
        2095372800000,
        [
            4272610071.362164,
            -3035223410.842251,
            -2234348315.594431,
        ],
    ],
    [
        2095977600000,
        [
            4274881618.981028,
            -3033318571.693895,
            -2234439781.830238,
        ],
    ],
    [
        2096582400000,
        [
            4277152330.107329,
            -3031412614.992324,
            -2234530114.779882,
        ],
    ],
    [
        2097187200000,
        [
            4279422404.697499,
            -3029505408.744204,
            -2234619689.302182,
        ],
    ],
    [
        2097792000000,
        [
            4281691860.757658,
            -3027597002.029017,
            -2234708949.173025,
        ],
    ],
    [
        2098396800000,
        [
            4283960528.446491,
            -3025687608.114151,
            -2234798251.24305,
        ],
    ],
    [
        2099001600000,
        [
            4286228109.966936,
            -3023777529.334712,
            -2234887739.905221,
        ],
    ],
    [
        2099606400000,
        [
            4288494282.851057,
            -3021867050.410089,
            -2234977295.397433,
        ],
    ],
    [
        2100211200000,
        [
            4290758812.531166,
            -3019956339.376376,
            -2235066576.537377,
        ],
    ],
    [
        2100816000000,
        [
            4293021635.369175,
            -3018045389.882195,
            -2235155142.191219,
        ],
    ],
    [
        2101420800000,
        [
            4295282881.028402,
            -3016134024.358648,
            -2235242606.882241,
        ],
    ],
    [
        2102025600000,
        [
            4297542826.76102,
            -3014221956.950822,
            -2235328776.287024,
        ],
    ],
    [
        2102630400000,
        [
            4299801799.80584,
            -3012308894.756062,
            -2235413716.351861,
        ],
    ],
    [
        2103235200000,
        [
            4302060061.568158,
            -3010394642.361544,
            -2235497730.848253,
        ],
    ],
    [
        2103840000000,
        [
            4304317715.049459,
            -3008479172.055546,
            -2235581254.243735,
        ],
    ],
    [
        2104444800000,
        [
            4306574668.920651,
            -3006562634.396632,
            -2235664698.617822,
        ],
    ],
    [
        2105049600000,
        [
            4308830670.238304,
            -3004645306.311877,
            -2235748309.543643,
        ],
    ],
    [
        2105654400000,
        [
            4311085393.98919,
            -3002727495.394003,
            -2235832080.463936,
        ],
    ],
    [
        2106259200000,
        [
            4313338559.221115,
            -3000809432.402543,
            -2235915754.973485,
        ],
    ],
    [
        2106864000000,
        [
            4315590029.441165,
            -2998891189.293014,
            -2235998917.012565,
        ],
    ],
    [
        2107468800000,
        [
            4317839860.132612,
            -2996972654.592472,
            -2236081138.019622,
        ],
    ],
    [
        2108073600000,
        [
            4320088279.743116,
            -2995053574.562682,
            -2236162128.476272,
        ],
    ],
    [
        2108678400000,
        [
            4322335611.366161,
            -2993133642.841487,
            -2236241840.066293,
        ],
    ],
    [
        2109283200000,
        [
            4324582160.300676,
            -2991212608.256861,
            -2236320483.255643,
        ],
    ],
    [
        2109888000000,
        [
            4326828106.768395,
            -2989290363.687872,
            -2236398453.036626,
        ],
    ],
    [
        2110492800000,
        [
            4329073442.96901,
            -2987366983.69874,
            -2236476188.879437,
        ],
    ],
    [
        2111097600000,
        [
            4331317976.914863,
            -2985442697.696659,
            -2236554019.745962,
        ],
    ],
    [
        2111702400000,
        [
            4333561400.547606,
            -2983517809.134282,
            -2236632048.763864,
        ],
    ],
    [
        2112307200000,
        [
            4335803398.200031,
            -2981592589.021657,
            -2236710116.731621,
        ],
    ],
    [
        2112912000000,
        [
            4338043758.347737,
            -2979667180.530636,
            -2236787857.88426,
        ],
    ],
    [
        2113516800000,
        [
            4340282449.357985,
            -2977741548.613146,
            -2236864829.179402,
        ],
    ],
    [
        2114121600000,
        [
            4342519631.707441,
            -2975815491.834726,
            -2236940666.315426,
        ],
    ],
    [
        2114726400000,
        [
            4344755600.904326,
            -2973888712.185148,
            -2237015210.996524,
        ],
    ],
    [
        2115331200000,
        [
            4346990682.692438,
            -2971960920.363963,
            -2237088567.013356,
        ],
    ],
    [
        2115936000000,
        [
            4349225118.675081,
            -2970031938.735195,
            -2237161064.632093,
        ],
    ],
    [
        2116540800000,
        [
            4351458981.331163,
            -2968101764.093594,
            -2237233143.647601,
        ],
    ],
    [
        2117145600000,
        [
            4353692148.750645,
            -2966170568.04838,
            -2237305197.359816,
        ],
    ],
    [
        2117750400000,
        [
            4355924347.880116,
            -2964238635.928655,
            -2237377434.205734,
        ],
    ],
    [
        2118355200000,
        [
            4358155250.095487,
            -2962306266.669643,
            -2237449804.865992,
        ],
    ],
    [
        2118960000000,
        [
            4360384586.23888,
            -2960373668.018551,
            -2237522019.228505,
        ],
    ],
    [
        2119564800000,
        [
            4362612241.329799,
            -2958440883.497992,
            -2237593648.443265,
        ],
    ],
    [
        2120169600000,
        [
            4364838294.889394,
            -2956507777.721584,
            -2237664276.61111,
        ],
    ],
    [
        2120774400000,
        [
            4367062992.818477,
            -2954574085.288155,
            -2237733647.769355,
        ],
    ],
    [
        2121379200000,
        [
            4369286661.856298,
            -2952639504.804402,
            -2237801756.23524,
        ],
    ],
    [
        2121984000000,
        [
            4371509595.224983,
            -2950703804.5151,
            -2237868848.810588,
        ],
    ],
    [
        2122588800000,
        [
            4373731947.728146,
            -2948766904.660735,
            -2237935337.915712,
        ],
    ],
    [
        2123193600000,
        [
            4375953680.838593,
            -2946828907.393743,
            -2238001656.24292,
        ],
    ],
    [
        2123798400000,
        [
            4378174578.1076,
            -2944890061.014813,
            -2238068104.309301,
        ],
    ],
    [
        2124403200000,
        [
            4380394322.737506,
            -2942950672.277891,
            -2238134745.338686,
        ],
    ],
    [
        2125008000000,
        [
            4382612609.198214,
            -2941010998.864223,
            -2238201383.317736,
        ],
    ],
    [
        2125612800000,
        [
            4384829251.053254,
            -2939071158.848123,
            -2238267631.475625,
        ],
    ],
    [
        2126217600000,
        [
            4387044247.382408,
            -2937131088.95587,
            -2238333048.529007,
        ],
    ],
    [
        2126822400000,
        [
            4389257783.494712,
            -2935190567.120472,
            -2238397294.592847,
        ],
    ],
    [
        2127427200000,
        [
            4391470165.841551,
            -2933249291.122544,
            -2238460250.886138,
        ],
    ],
    [
        2128032000000,
        [
            4393681714.789362,
            -2931306985.244222,
            -2238522061.81395,
        ],
    ],
    [
        2128636800000,
        [
            4395892652.648642,
            -2929363498.046818,
            -2238583084.975646,
        ],
    ],
    [
        2129241600000,
        [
            4398103026.27296,
            -2927418855.747938,
            -2238643764.738495,
        ],
    ],
    [
        2129846400000,
        [
            4400312690.694591,
            -2925473251.449308,
            -2238704474.028718,
        ],
    ],
    [
        2130451200000,
        [
            4402521359.959746,
            -2923526976.70085,
            -2238765383.013997,
        ],
    ],
    [
        2131056000000,
        [
            4404728708.57579,
            -2921580319.509621,
            -2238826400.373007,
        ],
    ],
    [
        2131660800000,
        [
            4406934486.603178,
            -2919633462.880932,
            -2238887205.225616,
        ],
    ],
    [
        2132265600000,
        [
            4409138607.959003,
            -2917686419.453302,
            -2238947359.231894,
        ],
    ],
    [
        2132870400000,
        [
            4411341180.810605,
            -2915739026.211495,
            -2239006460.827058,
        ],
    ],
    [
        2133475200000,
        [
            4413542468.921014,
            -2913791001.707503,
            -2239064286.720403,
        ],
    ],
    [
        2134080000000,
        [
            4415742798.100122,
            -2911842045.071796,
            -2239120870.177421,
        ],
    ],
    [
        2134684800000,
        [
            4417942441.005182,
            -2909891941.848768,
            -2239176489.481698,
        ],
    ],
    [
        2135289600000,
        [
            4420141520.007243,
            -2907940640.289825,
            -2239231570.42027,
        ],
    ],
    [
        2135894400000,
        [
            4422339963.118391,
            -2905988270.647301,
            -2239286535.87726,
        ],
    ],
    [
        2136499200000,
        [
            4424537530.08367,
            -2904035099.359722,
            -2239341656.386437,
        ],
    ],
    [
        2137104000000,
        [
            4426733897.839149,
            -2902081434.198608,
            -2239396955.072892,
        ],
    ],
    [
        2137708800000,
        [
            4428928772.423857,
            -2900127516.146412,
            -2239452199.883707,
        ],
    ],
    [
        2138313600000,
        [
            4431121991.148552,
            -2898173436.46401,
            -2239506985.591268,
        ],
    ],
    [
        2138918400000,
        [
            4433313580.728913,
            -2896219105.424045,
            -2239560876.822822,
        ],
    ],
    [
        2139523200000,
        [
            4435503748.386821,
            -2894264284.217841,
            -2239613561.878318,
        ],
    ],
    [
        2140128000000,
        [
            4437692808.602542,
            -2892308669.710257,
            -2239664962.715872,
        ],
    ],
    [
        2140732800000,
        [
            4439881072.272501,
            -2890352001.811514,
            -2239715262.511187,
        ],
    ],
    [
        2141337600000,
        [
            4442068737.216275,
            -2888394155.932326,
            -2239764841.871994,
        ],
    ],
    [
        2141942400000,
        [
            4444255818.017499,
            -2886435188.328156,
            -2239814145.185612,
        ],
    ],
    [
        2142547200000,
        [
            4446442140.860723,
            -2884475317.403897,
            -2239863523.593515,
        ],
    ],
    [
        2143152000000,
        [
            4448627405.840664,
            -2882514847.351984,
            -2239913111.488461,
        ],
    ],
    [
        2143756800000,
        [
            4450811294.035541,
            -2880554062.113912,
            -2239962780.674413,
        ],
    ],
    [
        2144361600000,
        [
            4452993581.206094,
            -2878593126.409678,
            -2240012186.133692,
        ],
    ],
    [
        2144966400000,
        [
            4455174217.516311,
            -2876632027.181424,
            -2240060886.566986,
        ],
    ],
    [
        2145571200000,
        [
            4457353345.154522,
            -2874670578.529333,
            -2240108500.038567,
        ],
    ],
    [
        2146176000000,
        [
            4459531249.526014,
            -2872708488.620928,
            -2240154839.625604,
        ],
    ],
    [
        2146780800000,
        [
            4461708260.510076,
            -2870745462.773127,
            -2240199979.271978,
        ],
    ],
    [
        2147385600000,
        [
            4463884637.825916,
            -2868781306.612509,
            -2240244227.505538,
        ],
    ],
    [
        2147990400000,
        [
            4466060480.363351,
            -2866815994.279094,
            -2240288018.984499,
        ],
    ],
    [
        2148595200000,
        [
            4468235691.595576,
            -2864849677.549451,
            -2240331760.797866,
        ],
    ],
    [
        2149200000000,
        [
            4470410014.399831,
            -2862882631.657626,
            -2240375687.995946,
        ],
    ],
    [
        2149804800000,
        [
            4472583122.80585,
            -2860915157.319271,
            -2240419780.746414,
        ],
    ],
    [
        2150409600000,
        [
            4474754737.175959,
            -2858947474.609533,
            -2240463771.944502,
        ],
    ],
    [
        2151014400000,
        [
            4476924722.684173,
            -2856979645.730695,
            -2240507241.077524,
        ],
    ],
    [
        2151619200000,
        [
            4479093138.012164,
            -2855011552.600111,
            -2240549761.800278,
        ],
    ],
    [
        2152224000000,
        [
            4481260216.025773,
            -2853042936.782856,
            -2240591051.781455,
        ],
    ],
    [
        2152828800000,
        [
            4483426280.62642,
            -2851073489.304923,
            -2240631071.581652,
        ],
    ],
    [
        2153433600000,
        [
            4485591631.551474,
            -2849102959.894136,
            -2240670038.30909,
        ],
    ],
    [
        2154038400000,
        [
            4487756439.58035,
            -2847131245.001001,
            -2240708349.363138,
        ],
    ],
    [
        2154643200000,
        [
            4489920686.383137,
            -2845158423.796471,
            -2240746442.42695,
        ],
    ],
    [
        2155248000000,
        [
            4492084170.200684,
            -2843184729.769706,
            -2240784640.207898,
        ],
    ],
    [
        2155852800000,
        [
            4494246576.663465,
            -2841210467.498871,
            -2240823035.858704,
        ],
    ],
    [
        2156457600000,
        [
            4496407589.219311,
            -2839235904.771671,
            -2240861460.546108,
        ],
    ],
    [
        2157062400000,
        [
            4498566999.449081,
            -2837261178.650493,
            -2240899543.312772,
        ],
    ],
    [
        2157667200000,
        [
            4500724779.359024,
            -2835286247.602854,
            -2240936841.266273,
        ],
    ],
    [
        2158272000000,
        [
            4502881090.826728,
            -2833310906.357618,
            -2240972995.666389,
        ],
    ],
    [
        2158876800000,
        [
            4505036228.365095,
            -2831334859.106942,
            -2241007859.180587,
        ],
    ],
    [
        2159481600000,
        [
            4507190515.596612,
            -2829357824.440533,
            -2241041548.036854,
        ],
    ],
    [
        2160086400000,
        [
            4509344191.102656,
            -2827379633.789913,
            -2241074400.319708,
        ],
    ],
    [
        2160691200000,
        [
            4511497322.94737,
            -2825400291.217571,
            -2241106857.203131,
        ],
    ],
    [
        2161296000000,
        [
            4513649784.145225,
            -2823419974.065351,
            -2241139308.483668,
        ],
    ],
    [
        2161900800000,
        [
            4515801298.121355,
            -2821438971.249801,
            -2241171954.957326,
        ],
    ],
    [
        2162505600000,
        [
            4517951537.132403,
            -2819457581.114809,
            -2241204737.5512,
        ],
    ],
    [
        2163110400000,
        [
            4520100238.023245,
            -2817476006.536397,
            -2241237358.948708,
        ],
    ],
    [
        2163715200000,
        [
            4522247294.516534,
            -2815494284.332556,
            -2241269388.514671,
        ],
    ],
    [
        2164320000000,
        [
            4524392794.853498,
            -2813512272.615429,
            -2241300413.569248,
        ],
    ],
    [
        2164924800000,
        [
            4526536991.315258,
            -2811529700.937115,
            -2241330185.255299,
        ],
    ],
    [
        2165529600000,
        [
            4528680211.391213,
            -2809546266.410636,
            -2241358706.931058,
        ],
    ],
    [
        2166134400000,
        [
            4530822742.558336,
            -2807561741.408848,
            -2241386233.032662,
        ],
    ],
    [
        2166739200000,
        [
            4532964732.382203,
            -2805576054.162606,
            -2241413179.559532,
        ],
    ],
    [
        2167344000000,
        [
            4535106138.121203,
            -2803589313.560813,
            -2241439977.721836,
        ],
    ],
    [
        2167948800000,
        [
            4537246741.286196,
            -2801601770.1102,
            -2241466921.26718,
        ],
    ],
    [
        2168553600000,
        [
            4539386224.176946,
            -2799613728.161569,
            -2241494062.68798,
        ],
    ],
    [
        2169158400000,
        [
            4541524283.361372,
            -2797625438.914786,
            -2241521195.343514,
        ],
    ],
    [
        2169763200000,
        [
            4543660737.532551,
            -2795637011.662156,
            -2241547926.647049,
        ],
    ],
    [
        2170368000000,
        [
            4545795591.397514,
            -2793648374.897729,
            -2241573815.637969,
        ],
    ],
    [
        2170972800000,
        [
            4547929034.401363,
            -2791659300.599243,
            -2241598527.654377,
        ],
    ],
    [
        2171577600000,
        [
            4550061374.105762,
            -2789669484.046311,
            -2241621952.623143,
        ],
    ],
    [
        2172182400000,
        [
            4552192927.120853,
            -2787678651.400359,
            -2241644243.913362,
        ],
    ],
    [
        2172787200000,
        [
            4554323906.982332,
            -2785686656.209591,
            -2241665763.578685,
        ],
    ],
    [
        2173392000000,
        [
            4556454348.90257,
            -2783693530.820641,
            -2241686954.723473,
        ],
    ],
    [
        2173996800000,
        [
            4558584097.219938,
            -2781699475.578383,
            -2241708185.995837,
        ],
    ],
    [
        2174601600000,
        [
            4560712860.64752,
            -2779704788.58403,
            -2241729621.472134,
        ],
    ],
    [
        2175206400000,
        [
            4562840315.356273,
            -2777709759.383465,
            -2241751161.988999,
        ],
    ],
    [
        2175811200000,
        [
            4564966217.728068,
            -2775714566.670159,
            -2241772480.238474,
        ],
    ],
    [
        2176416000000,
        [
            4567090489.297481,
            -2773719217.025224,
            -2241793136.851886,
        ],
    ],
    [
        2177020800000,
        [
            4569213245.034187,
            -2771723543.132902,
            -2241812734.919106,
        ],
    ],
    [
        2177625600000,
        [
            4571334753.607053,
            -2769727262.22176,
            -2241831059.851807,
        ],
    ],
    [
        2178230400000,
        [
            4573455342.512728,
            -2767730075.918191,
            -2241848155.622566,
        ],
    ],
    [
        2178835200000,
        [
            4575575281.919811,
            -2765731776.137943,
            -2241864309.159185,
        ],
    ],
    [
        2179440000000,
        [
            4577694689.336596,
            -2763732318.693424,
            -2241879948.669792,
        ],
    ],
    [
        2180044800000,
        [
            4579813488.509577,
            -2761731839.040983,
            -2241895493.10247,
        ],
    ],
    [
        2180649600000,
        [
            4581931436.08447,
            -2759730605.446476,
            -2241911205.10734,
        ],
    ],
    [
        2181254400000,
        [
            4584048207.42509,
            -2757728925.422448,
            -2241927098.490121,
        ],
    ],
    [
        2181859200000,
        [
            4586163512.23957,
            -2755727037.987391,
            -2241942933.786537,
        ],
    ],
    [
        2182464000000,
        [
            4588277198.390727,
            -2753725029.495843,
            -2241958303.164914,
        ],
    ],
    [
        2183068800000,
        [
            4590389305.278539,
            -2751722802.723585,
            -2241972773.374084,
        ],
    ],
    [
        2183673600000,
        [
            4592500049.664629,
            -2749720111.51174,
            -2241986038.127847,
        ],
    ],
    [
        2184278400000,
        [
            4594609750.891562,
            -2747716648.180189,
            -2241998027.181124,
        ],
    ],
    [
        2184883200000,
        [
            4596718719.462375,
            -2745712152.197045,
            -2242008931.605327,
        ],
    ],
    [
        2185488000000,
        [
            4598827148.052946,
            -2743706501.721492,
            -2242019135.624383,
        ],
    ],
    [
        2186092800000,
        [
            4600935044.441679,
            -2741699755.634805,
            -2242029080.425629,
        ],
    ],
    [
        2186697600000,
        [
            4603042229.440184,
            -2739692132.087364,
            -2242039108.83601,
        ],
    ],
    [
        2187302400000,
        [
            4605148400.079936,
            -2737683931.379385,
            -2242049344.402442,
        ],
    ],
    [
        2187907200000,
        [
            4607253236.537155,
            -2735675429.634694,
            -2242059647.339694,
        ],
    ],
    [
        2188512000000,
        [
            4609356515.105646,
            -2733666781.004937,
            -2242069663.814763,
        ],
    ],
    [
        2189116800000,
        [
            4611458187.028036,
            -2731657963.485959,
            -2242078950.874803,
        ],
    ],
    [
        2189721600000,
        [
            4613558396.336541,
            -2729648786.392368,
            -2242087131.901431,
        ],
    ],
    [
        2190326400000,
        [
            4615657430.178061,
            -2727638955.431849,
            -2242094028.377604,
        ],
    ],
    [
        2190931200000,
        [
            4617755616.38709,
            -2725628175.193926,
            -2242099722.935481,
        ],
    ],
    [
        2191536000000,
        [
            4619853206.376514,
            -2723616254.370725,
            -2242104530.624157,
        ],
    ],
    [
        2192140800000,
        [
            4621950286.689121,
            -2721603173.172637,
            -2242108887.058661,
        ],
    ],
    [
        2192745600000,
        [
            4624046748.951857,
            -2719589088.963105,
            -2242113194.292773,
        ],
    ],
    [
        2193350400000,
        [
            4626142327.470008,
            -2717574280.085987,
            -2242117679.247417,
        ],
    ],
    [
        2193955200000,
        [
            4628236691.676882,
            -2715559047.583572,
            -2242122313.388392,
        ],
    ],
    [
        2194560000000,
        [
            4630329561.712284,
            -2713543608.834465,
            -2242126822.479445,
        ],
    ],
    [
        2195164800000,
        [
            4632420805.992222,
            -2711528021.063139,
            -2242130783.444397,
        ],
    ],
    [
        2195769600000,
        [
            4634510486.178566,
            -2709512161.817418,
            -2242133773.431961,
        ],
    ],
    [
        2196374400000,
        [
            4636598834.615629,
            -2707495772.652114,
            -2242135518.514774,
        ],
    ],
    [
        2196979200000,
        [
            4638686172.649129,
            -2705478550.726308,
            -2242135990.996295,
        ],
    ],
    [
        2197584000000,
        [
            4640772797.575669,
            -2703460256.189529,
            -2242135420.184084,
        ],
    ],
    [
        2198188800000,
        [
            4642858876.511286,
            -2701440796.815259,
            -2242134210.890552,
        ],
    ],
    [
        2198793600000,
        [
            4644944385.847284,
            -2699420261.317685,
            -2242132800.186069,
        ],
    ],
    [
        2199398400000,
        [
            4647029120.120528,
            -2697398889.397212,
            -2242131504.432486,
        ],
    ],
    [
        2200003200000,
        [
            4649112765.026273,
            -2695376988.211675,
            -2242130408.678908,
        ],
    ],
    [
        2200608000000,
        [
            4651195008.258825,
            -2693354824.632305,
            -2242129336.574886,
        ],
    ],
    [
        2201212800000,
        [
            4653275649.779143,
            -2691332531.537218,
            -2242127912.687025,
        ],
    ],
    [
        2201817600000,
        [
            4655354672.243164,
            -2689310061.789339,
            -2242125695.312273,
        ],
    ],
    [
        2202422400000,
        [
            4657432247.010562,
            -2687287205.732109,
            -2242122331.991489,
        ],
    ],
    [
        2203027200000,
        [
            4659508674.433717,
            -2685263665.34956,
            -2242117683.620167,
        ],
    ],
    [
        2203632000000,
        [
            4661584278.763854,
            -2683239159.84547,
            -2242111874.548816,
        ],
    ],
    [
        2204236800000,
        [
            4663659294.057792,
            -2681213526.103145,
            -2242105249.719028,
        ],
    ],
    [
        2204841600000,
        [
            4665733782.725471,
            -2679186777.190464,
            -2242098252.818708,
        ],
    ],
    [
        2205446400000,
        [
            4667807615.550826,
            -2677159096.702591,
            -2242091269.068382,
        ],
    ],
    [
        2206051200000,
        [
            4669880517.447715,
            -2675130773.04488,
            -2242084489.449983,
        ],
    ],
    [
        2206656000000,
        [
            4671952164.149424,
            -2673102098.942966,
            -2242077844.061106,
        ],
    ],
    [
        2207260800000,
        [
            4674022297.985042,
            -2671073268.66874,
            -2242071026.791906,
        ],
    ],
    [
        2207865600000,
        [
            4676090820.1306,
            -2669044308.795228,
            -2242063603.080269,
        ],
    ],
    [
        2208470400000,
        [
            4678157825.803801,
            -2667015068.266938,
            -2242055162.767573,
        ],
    ],
    [
        2209075200000,
        [
            4680223570.889594,
            -2664985270.934577,
            -2242045463.672328,
        ],
    ],
    [
        2209680000000,
        [
            4682288382.459444,
            -2662954611.695792,
            -2242034516.546511,
        ],
    ],
    [
        2210284800000,
        [
            4684352543.542297,
            -2660922863.528127,
            -2242022581.889271,
        ],
    ],
    [
        2210889600000,
        [
            4686416192.489927,
            -2658889957.71921,
            -2242010077.91849,
        ],
    ],
    [
        2211494400000,
        [
            4688479273.827456,
            -2656856007.885851,
            -2241997432.136879,
        ],
    ],
    [
        2212099200000,
        [
            4690541558.472269,
            -2654821269.405923,
            -2241984930.545684,
        ],
    ],
    [
        2212704000000,
        [
            4692602725.3128,
            -2652786048.899041,
            -2241972617.26099,
        ],
    ],
    [
        2213308800000,
        [
            4694662473.876113,
            -2650750594.886155,
            -2241960278.096554,
        ],
    ],
    [
        2213913600000,
        [
            4696720628.525026,
            -2648715009.812107,
            -2241947515.553129,
        ],
    ],
    [
        2214518400000,
        [
            4698777199.929677,
            -2646679214.815941,
            -2241933889.554858,
        ],
    ],
    [
        2215123200000,
        [
            4700832381.412517,
            -2644642977.708153,
            -2241919072.420499,
        ],
    ],
    [
        2215728000000,
        [
            4702886480.773399,
            -2642605994.080066,
            -2241902963.506126,
        ],
    ],
    [
        2216332800000,
        [
            4704939811.728774,
            -2640567993.861906,
            -2241885724.808533,
        ],
    ],
    [
        2216937600000,
        [
            4706992582.377172,
            -2638528836.834787,
            -2241867724.518994,
        ],
    ],
    [
        2217542400000,
        [
            4709044820.541426,
            -2636488562.730034,
            -2241849406.816872,
        ],
    ],
    [
        2218147200000,
        [
            4711096363.51674,
            -2634447377.243885,
            -2241831134.595788,
        ],
    ],
    [
        2218752000000,
        [
            4713146915.375346,
            -2632405579.629238,
            -2241813062.081071,
        ],
    ],
    [
        2219356800000,
        [
            4715196150.747868,
            -2630363458.330329,
            -2241795081.347826,
        ],
    ],
    [
        2219961600000,
        [
            4717243829.762233,
            -2628321190.296394,
            -2241776860.484963,
        ],
    ],
    [
        2220566400000,
        [
            4719289883.682153,
            -2626278778.186869,
            -2241757960.473106,
        ],
    ],
    [
        2221171200000,
        [
            4721334438.309318,
            -2624236048.996262,
            -2241737989.768268,
        ],
    ],
    [
        2221776000000,
        [
            4723377768.488624,
            -2622192716.352818,
            -2241716742.412128,
        ],
    ],
    [
        2222380800000,
        [
            4725420202.478425,
            -2620148482.084826,
            -2241694270.86772,
        ],
    ],
    [
        2222985600000,
        [
            4727462007.529912,
            -2618103141.047966,
            -2241670868.192213,
        ],
    ],
    [
        2223590400000,
        [
            4729503295.599694,
            -2616056653.637483,
            -2241646964.931247,
        ],
    ],
    [
        2224195200000,
        [
            4731543983.721059,
            -2614009159.744022,
            -2241622976.55724,
        ],
    ],
    [
        2224800000000,
        [
            4733583823.782942,
            -2611960928.830485,
            -2241599156.543574,
        ],
    ],
    [
        2225404800000,
        [
            4735622490.308148,
            -2609912264.654207,
            -2241575507.533584,
        ],
    ],
    [
        2226009600000,
        [
            4737659694.776238,
            -2607863398.491554,
            -2241551780.510246,
        ],
    ],
    [
        2226614400000,
        [
            4739695287.264981,
            -2605814407.624437,
            -2241527562.159471,
        ],
    ],
    [
        2227219200000,
        [
            4741729309.820402,
            -2603765188.108716,
            -2241502420.873968,
        ],
    ],
    [
        2227824000000,
        [
            4743761982.370869,
            -2601715491.408761,
            -2241476059.10054,
        ],
    ],
    [
        2228428800000,
        [
            4745793625.347657,
            -2599665010.622491,
            -2241448416.977819,
        ],
    ],
    [
        2229033600000,
        [
            4747824545.717507,
            -2597613487.57399,
            -2241419692.885718,
        ],
    ],
    [
        2229638400000,
        [
            4749854928.301548,
            -2595560804.63422,
            -2241390274.617595,
        ],
    ],
    [
        2230243200000,
        [
            4751884770.60163,
            -2593507026.578398,
            -2241360602.609658,
        ],
    ],
    [
        2230848000000,
        [
            4753913883.651868,
            -2591452376.910685,
            -2241331013.616682,
        ],
    ],
    [
        2231452800000,
        [
            4755941958.504491,
            -2589397158.087271,
            -2241301621.776085,
        ],
    ],
    [
        2232057600000,
        [
            4757968674.222208,
            -2587341644.784623,
            -2241272278.720403,
        ],
    ],
    [
        2232662400000,
        [
            4759993809.745595,
            -2585285987.311976,
            -2241242625.49226,
        ],
    ],
    [
        2233267200000,
        [
            4762017321.060491,
            -2583230158.54937,
            -2241212218.727864,
        ],
    ],
    [
        2233872000000,
        [
            4764039355.921773,
            -2581173963.813405,
            -2241180687.363565,
        ],
    ],
    [
        2234476800000,
        [
            4766060200.691788,
            -2579117110.536822,
            -2241147863.797163,
        ],
    ],
    [
        2235081600000,
        [
            4768080179.292967,
            -2577059312.249647,
            -2241113842.892905,
        ],
    ],
    [
        2235686400000,
        [
            4770099539.928761,
            -2575000389.276242,
            -2241078948.777707,
        ],
    ],
    [
        2236291200000,
        [
            4772118366.443645,
            -2572940331.882064,
            -2241043620.722206,
        ],
    ],
    [
        2236896000000,
        [
            4774136546.82157,
            -2570879305.284708,
            -2241008258.28174,
        ],
    ],
    [
        2237500800000,
        [
            4776153813.306081,
            -2568817592.623595,
            -2240973080.765478,
        ],
    ],
    [
        2238105600000,
        [
            4778169837.835494,
            -2566755495.43514,
            -2240938050.721095,
        ],
    ],
    [
        2238710400000,
        [
            4780184347.477195,
            -2564693228.066097,
            -2240902887.499415,
        ],
    ],
    [
        2239315200000,
        [
            4782197220.496022,
            -2562630842.606914,
            -2240867165.702888,
        ],
    ],
    [
        2239920000000,
        [
            4784208529.730723,
            -2560568210.692162,
            -2240830465.258199,
        ],
    ],
    [
        2240524800000,
        [
            4786218517.100326,
            -2558505069.379857,
            -2240792520.160134,
        ],
    ],
    [
        2241129600000,
        [
            4788227508.259366,
            -2556441114.719105,
            -2240753312.338125,
        ],
    ],
    [
        2241734400000,
        [
            4790235798.332913,
            -2554376109.377213,
            -2240713077.939753,
        ],
    ],
    [
        2242339200000,
        [
            4792243548.89674,
            -2552309966.929865,
            -2240672224.87552,
        ],
    ],
    [
        2242944000000,
        [
            4794250732.277346,
            -2550242783.053171,
            -2240631189.506021,
        ],
    ],
    [
        2243548800000,
        [
            4796257142.546788,
            -2548174800.871963,
            -2240590281.84585,
        ],
    ],
    [
        2244153600000,
        [
            4798262468.081655,
            -2546106324.220376,
            -2240549575.806283,
        ],
    ],
    [
        2244758400000,
        [
            4800266401.639238,
            -2544037611.432996,
            -2240508884.218593,
        ],
    ],
    [
        2245363200000,
        [
            4802268749.651386,
            -2541968784.741439,
            -2240467824.77186,
        ],
    ],
    [
        2245968000000,
        [
            4804269501.651508,
            -2539899786.029873,
            -2240425953.701017,
        ],
    ],
    [
        2246572800000,
        [
            4806268834.830558,
            -2537830395.9415,
            -2240382922.019053,
        ],
    ],
    [
        2247177600000,
        [
            4808267051.47802,
            -2535760310.567391,
            -2240338598.56782,
        ],
    ],
    [
        2247782400000,
        [
            4810264472.027029,
            -2533689247.990279,
            -2240293115.467117,
        ],
    ],
    [
        2248387200000,
        [
            4812261322.113069,
            -2531617046.62111,
            -2240246820.932507,
        ],
    ],
    [
        2248992000000,
        [
            4814257652.643579,
            -2529543721.571385,
            -2240200156.633726,
        ],
    ],
    [
        2249596800000,
        [
            4816253321.041512,
            -2527469459.263078,
            -2240153501.673561,
        ],
    ],
    [
        2250201600000,
        [
            4818248041.594775,
            -2525394551.332993,
            -2240107038.515463,
        ],
    ],
    [
        2250806400000,
        [
            4820241486.933192,
            -2523319290.709818,
            -2240060688.699953,
        ],
    ],
    [
        2251411200000,
        [
            4822233402.157776,
            -2521243867.087815,
            -2240014140.044963,
        ],
    ],
    [
        2252016000000,
        [
            4824223692.171597,
            -2519168300.286449,
            -2239966955.899621,
        ],
    ],
    [
        2252620800000,
        [
            4826212455.047971,
            -2517092433.521213,
            -2239918729.001071,
        ],
    ],
    [
        2253225600000,
        [
            4828199947.703737,
            -2515015988.199145,
            -2239869225.496382,
        ],
    ],
    [
        2253830400000,
        [
            4830186494.251195,
            -2512938662.016381,
            -2239818467.382809,
        ],
    ],
    [
        2254435200000,
        [
            4832172370.478915,
            -2510860235.417187,
            -2239766724.059477,
        ],
    ],
    [
        2255040000000,
        [
            4834157705.797125,
            -2508780648.774357,
            -2239714417.266751,
        ],
    ],
    [
        2255644800000,
        [
            4836142436.379099,
            -2506700023.868852,
            -2239661972.787014,
        ],
    ],
    [
        2256249600000,
        [
            4838126326.39594,
            -2504618621.597242,
            -2239609670.126676,
        ],
    ],
    [
        2256854400000,
        [
            4840109050.546531,
            -2502536750.42572,
            -2239557544.1621,
        ],
    ],
    [
        2257459200000,
        [
            4842090308.218699,
            -2500454658.775228,
            -2239505374.023107,
        ],
    ],
    [
        2258064000000,
        [
            4844069929.111897,
            -2498372449.032535,
            -2239452761.518964,
        ],
    ],
    [
        2258668800000,
        [
            4846047933.598207,
            -2496290041.281584,
            -2239399270.556876,
        ],
    ],
    [
        2259273600000,
        [
            4848024524.848989,
            -2494207200.909685,
            -2239344580.66064,
        ],
    ],
    [
        2259878400000,
        [
            4850000016.421895,
            -2492123623.037577,
            -2239288601.386373,
        ],
    ],
    [
        2260483200000,
        [
            4851974722.121112,
            -2490039041.619298,
            -2239231504.898021,
        ],
    ],
    [
        2261088000000,
        [
            4853948846.076192,
            -2487953323.426842,
            -2239173664.940259,
        ],
    ],
    [
        2261692800000,
        [
            4855922411.255322,
            -2485866514.959191,
            -2239115525.230927,
        ],
    ],
    [
        2262297600000,
        [
            4857895251.312428,
            -2483778826.45904,
            -2239057443.197899,
        ],
    ],
    [
        2262902400000,
        [
            4859867069.392082,
            -2481690557.983716,
            -2238999563.713331,
        ],
    ],
    [
        2263507200000,
        [
            4861837543.29058,
            -2479601993.593195,
            -2238941768.371845,
        ],
    ],
    [
        2264112000000,
        [
            4863806438.948518,
            -2477513301.825751,
            -2238883718.010175,
        ],
    ],
    [
        2264716800000,
        [
            4865773692.534731,
            -2475424477.230946,
            -2238824972.0064,
        ],
    ],
    [
        2265321600000,
        [
            4867739433.901326,
            -2473335342.394894,
            -2238765143.074775,
        ],
    ],
    [
        2265926400000,
        [
            4869703942.728232,
            -2471245609.805615,
            -2238704034.263279,
        ],
    ],
    [
        2266531200000,
        [
            4871667550.009432,
            -2469154982.201751,
            -2238641708.340672,
        ],
    ],
    [
        2267136000000,
        [
            4873630519.764372,
            -2467063257.557524,
            -2238578465.12657,
        ],
    ],
    [
        2267740800000,
        [
            4875592956.299059,
            -2464970400.889673,
            -2238514735.880276,
        ],
    ],
    [
        2268345600000,
        [
            4877554768.413105,
            -2462876556.27226,
            -2238450931.43348,
        ],
    ],
    [
        2268950400000,
        [
            4879515701.60673,
            -2460781995.399449,
            -2238387296.827821,
        ],
    ],
    [
        2269555200000,
        [
            4881475427.732377,
            -2458687020.943022,
            -2238323824.390295,
        ],
    ],
    [
        2270160000000,
        [
            4883433660.36904,
            -2456591859.334453,
            -2238260256.680355,
        ],
    ],
    [
        2270764800000,
        [
            4885390254.694893,
            -2454496581.200044,
            -2238196177.371701,
        ],
    ],
    [
        2271369600000,
        [
            4887345257.464137,
            -2452401076.613657,
            -2238131157.064461,
        ],
    ],
    [
        2271974400000,
        [
            4889298890.367545,
            -2450305093.390113,
            -2238064904.194309,
        ],
    ],
    [
        2272579200000,
        [
            4891251471.690435,
            -2448208326.236415,
            -2237997368.767479,
        ],
    ],
    [
        2273184000000,
        [
            4893203303.778325,
            -2446110525.376831,
            -2237928760.634212,
        ],
    ],
    [
        2273788800000,
        [
            4895154566.606296,
            -2444011584.268891,
            -2237859474.707458,
        ],
    ],
    [
        2274393600000,
        [
            4897105253.332835,
            -2441911576.193839,
            -2237789951.094841,
        ],
    ],
    [
        2274998400000,
        [
            4899055171.244203,
            -2439810729.648029,
            -2237720520.600131,
        ],
    ],
    [
        2275603200000,
        [
            4901004009.960782,
            -2437709348.858087,
            -2237651288.346506,
        ],
    ],
    [
        2276208000000,
        [
            4902951451.594288,
            -2435607706.286586,
            -2237582096.808609,
        ],
    ],
    [
        2276812800000,
        [
            4904897282.624448,
            -2433505946.693532,
            -2237512581.915091,
        ],
    ],
    [
        2277417600000,
        [
            4906841468.229654,
            -2431404036.836558,
            -2237442301.272177,
        ],
    ],
    [
        2278022400000,
        [
            4908784164.26796,
            -2429301777.35463,
            -2237370889.250956,
        ],
    ],
    [
        2278627200000,
        [
            4910725662.771501,
            -2427198872.816104,
            -2237298186.08023,
        ],
    ],
    [
        2279232000000,
        [
            4912666288.855865,
            -2425095036.42432,
            -2237224295.162323,
        ],
    ],
    [
        2279836800000,
        [
            4914606285.539786,
            -2422990092.231372,
            -2237149546.908567,
        ],
    ],
    [
        2280441600000,
        [
            4916545728.450772,
            -2420884037.89252,
            -2237074382.125389,
        ],
    ],
    [
        2281046400000,
        [
            4918484500.651331,
            -2418777045.502627,
            -2236999196.934828,
        ],
    ],
    [
        2281651200000,
        [
            4920422334.343102,
            -2416669400.057708,
            -2236924202.721287,
        ],
    ],
    [
        2282256000000,
        [
            4922358904.316093,
            -2414561398.667542,
            -2236849351.062561,
        ],
    ],
    [
        2282860800000,
        [
            4924293943.049278,
            -2412453246.538231,
            -2236774351.638213,
        ],
    ],
    [
        2283465600000,
        [
            4926227335.904071,
            -2410344984.946465,
            -2236698775.233789,
        ],
    ],
    [
        2284070400000,
        [
            4928159161.580377,
            -2408236476.363527,
            -2236622204.154488,
        ],
    ],
    [
        2284675200000,
        [
            4930089664.820818,
            -2406127451.705763,
            -2236544378.332315,
        ],
    ],
    [
        2285280000000,
        [
            4932019170.514731,
            -2404017604.112011,
            -2236465287.250874,
        ],
    ],
    [
        2285884800000,
        [
            4933947968.523319,
            -2401906696.9394,
            -2236385173.981749,
        ],
    ],
    [
        2286489600000,
        [
            4935876210.607903,
            -2399794647.021897,
            -2236304448.83979,
        ],
    ],
    [
        2287094400000,
        [
            4937803856.521565,
            -2397681553.406764,
            -2236223544.195977,
        ],
    ],
    [
        2287699200000,
        [
            4939730687.721593,
            -2395567662.30902,
            -2236142762.299784,
        ],
    ],
    [
        2288304000000,
        [
            4941656384.154221,
            -2393453280.49336,
            -2236062168.702906,
        ],
    ],
    [
        2288908800000,
        [
            4943580637.547552,
            -2391338666.054915,
            -2235981568.589221,
        ],
    ],
    [
        2289513600000,
        [
            4945503258.87333,
            -2389223935.991623,
            -2235900575.096611,
        ],
    ],
    [
        2290118400000,
        [
            4947424242.469307,
            -2387109025.855903,
            -2235818746.014239,
        ],
    ],
    [
        2290723200000,
        [
            4949343767.334726,
            -2384993713.388512,
            -2235735739.299448,
        ],
    ],
    [
        2291328000000,
        [
            4951262134.380918,
            -2382877696.076883,
            -2235651433.235996,
        ],
    ],
    [
        2291932800000,
        [
            4953179659.729143,
            -2380760697.38247,
            -2235565969.912816,
        ],
    ],
    [
        2292537600000,
        [
            4955096561.583489,
            -2378642564.749119,
            -2235479705.248732,
        ],
    ],
    [
        2293142400000,
        [
            4957012881.936542,
            -2376523323.723824,
            -2235393082.922738,
        ],
    ],
    [
        2293747200000,
        [
            4958928470.941031,
            -2374403169.128626,
            -2235306478.10134,
        ],
    ],
    [
        2294352000000,
        [
            4960843038.490893,
            -2372282397.2767,
            -2235220065.773772,
        ],
    ],
    [
        2294956800000,
        [
            4962756255.326911,
            -2370161302.649502,
            -2235133759.148171,
        ],
    ],
    [
        2295561600000,
        [
            4964667868.85409,
            -2368040075.152719,
            -2235047240.824257,
        ],
    ],
    [
        2296166400000,
        [
            4966577792.528108,
            -2365918734.359072,
            -2234960075.74906,
        ],
    ],
    [
        2296771200000,
        [
            4968486136.06406,
            -2363797122.967753,
            -2234871864.366263,
        ],
    ],
    [
        2297376000000,
        [
            4970393165.338396,
            -2361674962.594767,
            -2234782382.74437,
        ],
    ],
    [
        2297980800000,
        [
            4972299208.70929,
            -2359551953.423697,
            -2234691662.610808,
        ],
    ],
    [
        2298585600000,
        [
            4974204542.142455,
            -2357427881.307545,
            -2234599981.496877,
        ],
    ],
    [
        2299190400000,
        [
            4976109292.159739,
            -2355302694.066098,
            -2234507764.881472,
        ],
    ],
    [
        2299795200000,
        [
            4978013391.68607,
            -2353176520.028274,
            -2234415435.781079,
        ],
    ],
    [
        2300400000000,
        [
            4979916604.252595,
            -2351049622.991038,
            -2234323266.111596,
        ],
    ],
    [
        2301004800000,
        [
            4981818607.354394,
            -2348922309.978325,
            -2234231281.213558,
        ],
    ],
    [
        2301609600000,
        [
            4983719106.418217,
            -2346794823.405795,
            -2234139250.638433,
        ],
    ],
    [
        2302214400000,
        [
            4985617939.324605,
            -2344667255.760837,
            -2234046769.720201,
        ],
    ],
    [
        2302819200000,
        [
            4987515133.836754,
            -2342539517.771957,
            -2233953402.95073,
        ],
    ],
    [
        2303424000000,
        [
            4989410898.421907,
            -2340411370.698173,
            -2233858837.395236,
        ],
    ],
    [
        2304028800000,
        [
            4991305550.686667,
            -2338282509.651263,
            -2233762992.39417,
        ],
    ],
    [
        2304633600000,
        [
            4993199405.959231,
            -2336152669.441862,
            -2233666047.802022,
        ],
    ],
    [
        2305238400000,
        [
            4995092664.833072,
            -2334021718.514144,
            -2233568380.828171,
        ],
    ],
    [
        2305843200000,
        [
            4996985342.840588,
            -2331889705.987539,
            -2233470432.872217,
        ],
    ],
    [
        2306448000000,
        [
            4998877266.321009,
            -2329756843.328989,
            -2233372553.485689,
        ],
    ],
    [
        2307052800000,
        [
            5000768133.93892,
            -2327623428.78619,
            -2233274877.178296,
        ],
    ],
    [
        2307657600000,
        [
            5002657622.246469,
            -2325489741.727378,
            -2233177275.476894,
        ],
    ],
    [
        2308262400000,
        [
            5004545499.270534,
            -2323355943.322345,
            -2233079401.400854,
        ],
    ],
    [
        2308867200000,
        [
            5006431705.863002,
            -2321222018.981069,
            -2232980811.731045,
        ],
    ],
    [
        2309472000000,
        [
            5008316375.433602,
            -2319087783.428964,
            -2232881123.279519,
        ],
    ],
    [
        2310076800000,
        [
            5010199785.788581,
            -2316952946.017678,
            -2232780147.320528,
        ],
    ],
    [
        2310681600000,
        [
            5012082260.902847,
            -2314817212.980035,
            -2232677956.103201,
        ],
    ],
    [
        2311286400000,
        [
            5013964056.670152,
            -2312680391.224214,
            -2232574858.140076,
        ],
    ],
    [
        2311891200000,
        [
            5015845270.082219,
            -2310542455.909114,
            -2232471288.837939,
        ],
    ],
    [
        2312496000000,
        [
            5017725803.155078,
            -2308403558.387903,
            -2232367655.864633,
        ],
    ],
    [
        2313100800000,
        [
            5019605396.344458,
            -2306263973.636844,
            -2232264196.196416,
        ],
    ],
    [
        2313705600000,
        [
            5021483719.775587,
            -2304124004.391841,
            -2232160893.535939,
        ],
    ],
    [
        2314310400000,
        [
            5023360488.927234,
            -2301983874.678639,
            -2232057483.609429,
        ],
    ],
    [
        2314915200000,
        [
            5025235564.447716,
            -2299843650.584542,
            -2231953546.952211,
        ],
    ],
    [
        2315520000000,
        [
            5027109000.554199,
            -2297703217.170993,
            -2231848657.195628,
        ],
    ],
    [
        2316124800000,
        [
            5028981024.790479,
            -2295562319.759639,
            -2231742531.57013,
        ],
    ],
    [
        2316729600000,
        [
            5030851957.079486,
            -2293420654.243721,
            -2231635130.366641,
        ],
    ],
    [
        2317334400000,
        [
            5032722096.602368,
            -2291277974.791648,
            -2231526671.495178,
        ],
    ],
    [
        2317939200000,
        [
            5034591615.573093,
            -2289134181.81997,
            -2231417554.512028,
        ],
    ],
    [
        2318544000000,
        [
            5036460498.30574,
            -2286989358.483962,
            -2231308219.858106,
        ],
    ],
    [
        2319148800000,
        [
            5038328548.050988,
            -2284843741.394991,
            -2231198993.502743,
        ],
    ],
    [
        2319753600000,
        [
            5040195456.647776,
            -2282697636.394812,
            -2231089972.321148,
        ],
    ],
    [
        2320358400000,
        [
            5042060911.333447,
            -2280551311.867991,
            -2230980990.384915,
        ],
    ],
    [
        2320963200000,
        [
            5043924705.034255,
            -2278404905.64872,
            -2230871677.539444,
        ],
    ],
    [
        2321568000000,
        [
            5045786810.767801,
            -2276258376.339688,
            -2230761590.026466,
        ],
    ],
    [
        2322172800000,
        [
            5047647391.579845,
            -2274111517.698377,
            -2230650367.220246,
        ],
    ],
    [
        2322777600000,
        [
            5049506742.805792,
            -2271964031.345995,
            -2230537858.450033,
        ],
    ],
    [
        2323382400000,
        [
            5051365188.030066,
            -2269815631.586807,
            -2230424175.788348,
        ],
    ],
    [
        2323987200000,
        [
            5053222964.879045,
            -2267666146.019354,
            -2230309654.947458,
        ],
    ],
    [
        2324592000000,
        [
            5055080140.481292,
            -2265515576.687312,
            -2230194736.871666,
        ],
    ],
    [
        2325196800000,
        [
            5056936587.361135,
            -2263364099.388971,
            -2230079811.667427,
        ],
    ],
    [
        2325801600000,
        [
            5058792028.615274,
            -2261212001.557709,
            -2229965081.301712,
        ],
    ],
    [
        2326406400000,
        [
            5060646135.839545,
            -2259059581.343741,
            -2229850489.402471,
        ],
    ],
    [
        2327011200000,
        [
            5062498644.737607,
            -2256907042.257792,
            -2229735740.658308,
        ],
    ],
    [
        2327616000000,
        [
            5064349446.910078,
            -2254754420.368015,
            -2229620403.579936,
        ],
    ],
    [
        2328220800000,
        [
            5066198626.936765,
            -2252601572.102515,
            -2229504063.043721,
        ],
    ],
    [
        2328825600000,
        [
            5068046432.526359,
            -2250448225.753369,
            -2229386467.39556,
        ],
    ],
    [
        2329430400000,
        [
            5069893186.992199,
            -2248294077.196831,
            -2229267616.784608,
        ],
    ],
    [
        2330035200000,
        [
            5071739174.894864,
            -2246138896.658434,
            -2229147762.97111,
        ],
    ],
    [
        2330640000000,
        [
            5073584540.625936,
            -2243982610.045971,
            -2229027320.962771,
        ],
    ],
    [
        2331244800000,
        [
            5075429236.126931,
            -2241825325.718834,
            -2228906722.306833,
        ],
    ],
    [
        2331849600000,
        [
            5077273037.217801,
            -2239667296.411378,
            -2228786262.530532,
        ],
    ],
    [
        2332454400000,
        [
            5079115622.202553,
            -2237508830.495168,
            -2228665997.777266,
        ],
    ],
    [
        2333059200000,
        [
            5080956684.088969,
            -2235350184.762342,
            -2228545726.075761,
        ],
    ],
    [
        2333664000000,
        [
            5082796038.008685,
            -2233191475.596608,
            -2228425058.579812,
        ],
    ],
    [
        2334268800000,
        [
            5084633687.242719,
            -2231032638.450428,
            -2228303556.527035,
        ],
    ],
    [
        2334873600000,
        [
            5086469822.376766,
            -2228873450.063567,
            -2228180885.971415,
        ],
    ],
    [
        2335478400000,
        [
            5088304752.440905,
            -2226713608.071478,
            -2228056935.864099,
        ],
    ],
    [
        2336083200000,
        [
            5090138795.792782,
            -2224552839.50516,
            -2227931857.869749,
        ],
    ],
    [
        2336688000000,
        [
            5091972169.064289,
            -2222390997.810592,
            -2227806013.645365,
        ],
    ],
    [
        2337292800000,
        [
            5093804911.003919,
            -2220228115.138431,
            -2227679847.633688,
        ],
    ],
    [
        2337897600000,
        [
            5095636868.841404,
            -2218064391.371005,
            -2227553729.777157,
        ],
    ],
    [
        2338502400000,
        [
            5097467752.882178,
            -2215900123.459932,
            -2227427825.016275,
        ],
    ],
    [
        2339107200000,
        [
            5099297239.069573,
            -2213735601.035154,
            -2227302036.197225,
        ],
    ],
    [
        2339712000000,
        [
            5101125082.751985,
            -2211571005.346312,
            -2227176038.722194,
        ],
    ],
    [
        2340316800000,
        [
            5102951204.901098,
            -2209406345.876783,
            -2227049394.316048,
        ],
    ],
    [
        2340921600000,
        [
            5104775720.805503,
            -2207241457.074372,
            -2226921705.601924,
        ],
    ],
    [
        2341526400000,
        [
            5106598900.548491,
            -2205076057.096493,
            -2226792756.926239,
        ],
    ],
    [
        2342131200000,
        [
            5108421074.959684,
            -2202909846.682143,
            -2226662590.151955,
        ],
    ],
    [
        2342736000000,
        [
            5110242518.783451,
            -2200742613.245008,
            -2226531489.052435,
        ],
    ],
    [
        2343340800000,
        [
            5112063352.896342,
            -2198574306.215494,
            -2226399879.735243,
        ],
    ],
    [
        2343945600000,
        [
            5113883501.960474,
            -2196405055.615784,
            -2226268180.55231,
        ],
    ],
    [
        2344550400000,
        [
            5115702721.788769,
            -2194235125.296741,
            -2226136653.67013,
        ],
    ],
    [
        2345155200000,
        [
            5117520685.955397,
            -2192064818.446007,
            -2226005312.411849,
        ],
    ],
    [
        2345760000000,
        [
            5119337100.240377,
            -2189894370.177577,
            -2225873917.054504,
        ],
    ],
    [
        2346364800000,
        [
            5121151804.902101,
            -2187723864.683163,
            -2225742058.771339,
        ],
    ],
    [
        2346969600000,
        [
            5122964830.15351,
            -2185553204.927278,
            -2225609302.658639,
        ],
    ],
    [
        2347574400000,
        [
            5124776384.9154,
            -2183382146.197437,
            -2225475341.016929,
        ],
    ],
    [
        2348179200000,
        [
            5126586781.947356,
            -2181210382.556136,
            -2225340102.197712,
        ],
    ],
    [
        2348784000000,
        [
            5128396326.543451,
            -2179037655.214738,
            -2225203775.851484,
        ],
    ],
    [
        2349388800000,
        [
            5130205208.930538,
            -2176863843.76337,
            -2225066746.254328,
        ],
    ],
    [
        2349993600000,
        [
            5132013436.379624,
            -2174689007.976614,
            -2224929456.677151,
        ],
    ],
    [
        2350598400000,
        [
            5133820827.895096,
            -2172513366.857472,
            -2224792252.315598,
        ],
    ],
    [
        2351203200000,
        [
            5135627076.921098,
            -2170337222.47453,
            -2224655258.787884,
        ],
    ],
    [
        2351808000000,
        [
            5137431859.660202,
            -2168160853.986284,
            -2224518338.935434,
        ],
    ],
    [
        2352412800000,
        [
            5139234948.175225,
            -2165984419.974871,
            -2224381141.831393,
        ],
    ],
    [
        2353017600000,
        [
            5141036289.223522,
            -2163807903.302662,
            -2224243225.911123,
        ],
    ],
    [
        2353622400000,
        [
            5142836022.287704,
            -2161631117.417629,
            -2224104214.297086,
        ],
    ],
    [
        2354227200000,
        [
            5144634429.719468,
            -2159453772.743471,
            -2223963928.356917,
        ],
    ],
    [
        2354832000000,
        [
            5146431836.085397,
            -2157275580.028311,
            -2223822451.316861,
        ],
    ],
    [
        2355436800000,
        [
            5148228492.899055,
            -2155096353.556138,
            -2223680099.171813,
        ],
    ],
    [
        2356041600000,
        [
            5150024489.595316,
            -2152916077.982729,
            -2223537310.163144,
        ],
    ],
    [
        2356646400000,
        [
            5151819721.855377,
            -2150734915.677503,
            -2223394491.222897,
        ],
    ],
    [
        2357251200000,
        [
            5153613929.164468,
            -2148553150.226736,
            -2223251874.242817,
        ],
    ],
    [
        2357856000000,
        [
            5155406786.890499,
            -2146371085.816421,
            -2223109434.027224,
        ],
    ],
    [
        2358460800000,
        [
            5157198019.750071,
            -2144188941.398563,
            -2222966898.58202,
        ],
    ],
    [
        2359065600000,
        [
            5158987498.844748,
            -2142006775.945824,
            -2222823846.035529,
        ],
    ],
    [
        2359670400000,
        [
            5160775288.122033,
            -2139824468.267547,
            -2222679852.853837,
        ],
    ],
    [
        2360275200000,
        [
            5162561622.911708,
            -2137641759.446453,
            -2222534643.149659,
        ],
    ],
    [
        2360880000000,
        [
            5164346827.295287,
            -2135458344.375806,
            -2222388186.495564,
        ],
    ],
    [
        2361484800000,
        [
            5166131199.808055,
            -2133273979.823692,
            -2222240708.686374,
        ],
    ],
    [
        2362089600000,
        [
            5167914908.464738,
            -2131088570.323545,
            -2222092612.031099,
        ],
    ],
    [
        2362694400000,
        [
            5169697931.683212,
            -2128902202.108753,
            -2221944333.966895,
        ],
    ],
    [
        2363299200000,
        [
            5171480065.583081,
            -2126715113.415954,
            -2221796192.915604,
        ],
    ],
    [
        2363904000000,
        [
            5173260996.198203,
            -2124527610.892426,
            -2221648275.738681,
        ],
    ],
    [
        2364508800000,
        [
            5175040411.589375,
            -2122339961.348173,
            -2221500407.560552,
        ],
    ],
    [
        2365113600000,
        [
            5176818112.38431,
            -2120152297.017323,
            -2221352213.704509,
        ],
    ],
    [
        2365718400000,
        [
            5178594080.260056,
            -2117964568.755056,
            -2221203250.89171,
        ],
    ],
    [
        2366323200000,
        [
            5180368483.81843,
            -2115776564.008313,
            -2221053163.211632,
        ],
    ],
    [
        2366928000000,
        [
            5182141620.148731,
            -2113587981.826492,
            -2220901808.219065,
        ],
    ],
    [
        2367532800000,
        [
            5183913810.056795,
            -2111398538.813267,
            -2220749307.283314,
        ],
    ],
    [
        2368137600000,
        [
            5185685284.365944,
            -2109208068.766184,
            -2220596002.181412,
        ],
    ],
    [
        2368742400000,
        [
            5187456102.117679,
            -2107016580.893524,
            -2220442334.450894,
        ],
    ],
    [
        2369347200000,
        [
            5189226128.839721,
            -2104824256.827775,
            -2220288690.07682,
        ],
    ],
    [
        2369952000000,
        [
            5190995082.778008,
            -2102631387.108824,
            -2220135263.103403,
        ],
    ],
    [
        2370556800000,
        [
            5192762633.609611,
            -2100438268.936983,
            -2219981986.99812,
        ],
    ],
    [
        2371161600000,
        [
            5194528518.401948,
            -2098245101.994957,
            -2219828558.910615,
        ],
    ],
    [
        2371766400000,
        [
            5196292633.635782,
            -2096051919.538056,
            -2219674547.319092,
        ],
    ],
    [
        2372371200000,
        [
            5198055071.843452,
            -2093858577.304666,
            -2219519543.729809,
        ],
    ],
    [
        2372976000000,
        [
            5199816088.874067,
            -2091664803.415829,
            -2219363305.998447,
        ],
    ],
    [
        2373580800000,
        [
            5201576012.10586,
            -2089470295.047482,
            -2219205844.507434,
        ],
    ],
    [
        2374185600000,
        [
            5203335124.507178,
            -2087274827.318986,
            -2219047419.432941,
        ],
    ],
    [
        2374790400000,
        [
            5205093565.517231,
            -2085078333.207051,
            -2218888448.91934,
        ],
    ],
    [
        2375395200000,
        [
            5206851282.330342,
            -2082880927.181647,
            -2218729361.993404,
        ],
    ],
    [
        2376000000000,
        [
            5208608048.052938,
            -2080682865.560361,
            -2218570447.776873,
        ],
    ],
    [
        2376604800000,
        [
            5210363541.287074,
            -2078484456.798016,
            -2218411753.278653,
        ],
    ],
    [
        2377209600000,
        [
            5212117459.635282,
            -2076285952.996663,
            -2218253066.966927,
        ],
    ],
    [
        2377814400000,
        [
            5213869626.216994,
            -2074087461.736589,
            -2218093994.199485,
        ],
    ],
    [
        2378419200000,
        [
            5215620051.455734,
            -2071888909.355784,
            -2217934096.603764,
        ],
    ],
    [
        2379024000000,
        [
            5217368929.652669,
            -2069690067.686702,
            -2217773046.406882,
        ],
    ],
    [
        2379628800000,
        [
            5219116571.872583,
            -2067490634.843598,
            -2217610742.665963,
        ],
    ],
    [
        2380233600000,
        [
            5220863297.191202,
            -2065290341.415598,
            -2217447347.207272,
        ],
    ],
    [
        2380838400000,
        [
            5222609319.106478,
            -2063089045.086033,
            -2217283226.799769,
        ],
    ],
    [
        2381443200000,
        [
            5224354669.781638,
            -2060886781.526781,
            -2217118823.891967,
        ],
    ],
    [
        2382048000000,
        [
            5226099189.800402,
            -2058683752.314369,
            -2216954501.519663,
        ],
    ],
    [
        2382652800000,
        [
            5227842584.649782,
            -2056480253.85818,
            -2216790415.364812,
        ],
    ],
    [
        2383257600000,
        [
            5229584528.421105,
            -2054276572.414328,
            -2216626458.156119,
        ],
    ],
    [
        2383862400000,
        [
            5231324778.60239,
            -2052072882.588975,
            -2216462297.392214,
        ],
    ],
    [
        2384467200000,
        [
            5233063260.820097,
            -2049869185.847819,
            -2216297492.854273,
        ],
    ],
    [
        2385072000000,
        [
            5234800093.979585,
            -2047665310.246194,
            -2216131651.286832,
        ],
    ],
    [
        2385676800000,
        [
            5236535547.878566,
            -2045460970.790248,
            -2215964564.652703,
        ],
    ],
    [
        2386281600000,
        [
            5238269947.469169,
            -2043255870.210258,
            -2215796284.260044,
        ],
    ],
    [
        2386886400000,
        [
            5240003557.302459,
            -2041049804.973231,
            -2215627103.233399,
        ],
    ],
    [
        2387491200000,
        [
            5241736488.268818,
            -2038842737.404623,
            -2215457452.690486,
        ],
    ],
    [
        2388096000000,
        [
            5243468658.337449,
            -2036634807.814009,
            -2215287749.198804,
        ],
    ],
    [
        2388700800000,
        [
            5245199819.30337,
            -2034426285.563085,
            -2215118248.534511,
        ],
    ],
    [
        2389305600000,
        [
            5246929643.009194,
            -2032217476.20251,
            -2214948956.23354,
        ],
    ],
    [
        2389910400000,
        [
            5248657837.200312,
            -2030008614.523116,
            -2214779625.721427,
        ],
    ],
    [
        2390515200000,
        [
            5250384248.330632,
            -2027799782.085242,
            -2214609845.586876,
        ],
    ],
    [
        2391120000000,
        [
            5252108914.657096,
            -2025590879.386834,
            -2214439184.937595,
        ],
    ],
    [
        2391724800000,
        [
            5253832051.878086,
            -2023381661.847177,
            -2214267345.065794,
        ],
    ],
    [
        2392329600000,
        [
            5255553976.864143,
            -2021171826.69026,
            -2214094265.208132,
        ],
    ],
    [
        2392934400000,
        [
            5257274995.284547,
            -2018961121.10776,
            -2213920145.170593,
        ],
    ],
    [
        2393539200000,
        [
            5258995292.813883,
            -2016749433.334314,
            -2213745375.282452,
        ],
    ],
    [
        2394144000000,
        [
            5260714869.649993,
            -2014536833.544328,
            -2213570398.803809,
        ],
    ],
    [
        2394748800000,
        [
            5262433541.660111,
            -2012323550.364257,
            -2213395556.786702,
        ],
    ],
    [
        2395353600000,
        [
            5264151006.298614,
            -2010109891.206127,
            -2213220968.752702,
        ],
    ],
    [
        2395958400000,
        [
            5265866948.661775,
            -2007896134.296621,
            -2213046490.139837,
        ],
    ],
    [
        2396563200000,
        [
            5267581152.117812,
            -2005682432.203451,
            -2212871763.840055,
        ],
    ],
    [
        2397168000000,
        [
            5269293575.939319,
            -2003468759.837859,
            -2212696347.273847,
        ],
    ],
    [
        2397772800000,
        [
            5271004370.850307,
            -2001254924.090324,
            -2212519868.513764,
        ],
    ],
    [
        2398377600000,
        [
            5272713827.043883,
            -1999040631.870057,
            -2212342157.073945,
        ],
    ],
    [
        2398982400000,
        [
            5274422272.914964,
            -1996825593.450441,
            -2212163304.625861,
        ],
    ],
    [
        2399587200000,
        [
            5276129959.490328,
            -1994609625.348579,
            -2211983633.283058,
        ],
    ],
    [
        2400192000000,
        [
            5277836972.039262,
            -1992392715.588788,
            -2211803581.535287,
        ],
    ],
    [
        2400796800000,
        [
            5279543200.891181,
            -1990175027.702054,
            -2211623549.193722,
        ],
    ],
    [
        2401401600000,
        [
            5281248380.964343,
            -1987956843.0855,
            -2211443757.203281,
        ],
    ],
    [
        2402006400000,
        [
            5282952185.52702,
            -1985738462.667459,
            -2211264170.420917,
        ],
    ],
    [
        2402611200000,
        [
            5284654342.529914,
            -1983520100.926014,
            -2211084509.667047,
        ],
    ],
    [
        2403216000000,
        [
            5286354731.465506,
            -1981301808.806852,
            -2210904349.465186,
        ],
    ],
    [
        2403820800000,
        [
            5288053424.588677,
            -1979083455.307331,
            -2210723267.754819,
        ],
    ],
    [
        2404425600000,
        [
            5289750661.015014,
            -1976864774.524896,
            -2210540994.636519,
        ],
    ],
    [
        2405030400000,
        [
            5291446763.672441,
            -1974645458.931744,
            -2210357507.514565,
        ],
    ],
    [
        2405635200000,
        [
            5293142025.709951,
            -1972425267.152771,
            -2210173039.511571,
        ],
    ],
    [
        2406240000000,
        [
            5294836606.069159,
            -1970204109.098388,
            -2209987996.982267,
        ],
    ],
    [
        2406844800000,
        [
            5296530472.602006,
            -1967982077.420965,
            -2209802815.174503,
        ],
    ],
    [
        2407449600000,
        [
            5298223413.151363,
            -1965759414.199993,
            -2209617804.547855,
        ],
    ],
    [
        2408054400000,
        [
            5299915109.523967,
            -1963536425.73658,
            -2209433042.092369,
        ],
    ],
    [
        2408659200000,
        [
            5301605248.173742,
            -1961313375.437921,
            -2209248344.376867,
        ],
    ],
    [
        2409264000000,
        [
            5303293629.76405,
            -1959090391.73607,
            -2209063332.107555,
        ],
    ],
    [
        2409868800000,
        [
            5304980239.272133,
            -1956867423.67941,
            -2208877564.368359,
        ],
    ],
    [
        2410473600000,
        [
            5306665251.382689,
            -1954644259.284885,
            -2208690694.184722,
        ],
    ],
    [
        2411078400000,
        [
            5308348967.875896,
            -1952420599.75087,
            -2208502590.033979,
        ],
    ],
    [
        2411683200000,
        [
            5310031709.850368,
            -1950196165.731026,
            -2208313382.97384,
        ],
    ],
    [
        2412288000000,
        [
            5311713704.198409,
            -1947970797.970169,
            -2208123422.067783,
        ],
    ],
    [
        2412892800000,
        [
            5313395003.372199,
            -1945744514.752726,
            -2207933151.281092,
        ],
    ],
    [
        2413497600000,
        [
            5315075466.988062,
            -1943517505.663658,
            -2207742952.346407,
        ],
    ],
    [
        2414102400000,
        [
            5316754811.572798,
            -1941290064.99283,
            -2207553010.844337,
        ],
    ],
    [
        2414707200000,
        [
            5318432709.969601,
            -1939062489.207057,
            -2207363251.833611,
        ],
    ],
    [
        2415312000000,
        [
            5320108906.050858,
            -1936834973.777177,
            -2207173366.408009,
        ],
    ],
    [
        2415916800000,
        [
            5321783304.981894,
            -1934607545.222447,
            -2206982920.798049,
        ],
    ],
    [
        2416521600000,
        [
            5323456006.661269,
            -1932380052.99704,
            -2206791509.977548,
        ],
    ],
    [
        2417126400000,
        [
            5325127270.714853,
            -1930152224.101448,
            -2206598900.9311,
        ],
    ],
    [
        2417731200000,
        [
            5326797426.486807,
            -1927923760.100854,
            -2206405115.119724,
        ],
    ],
    [
        2418336000000,
        [
            5328466758.355935,
            -1925694441.948895,
            -2206210421.44324,
        ],
    ],
    [
        2418940800000,
        [
            5330135404.300837,
            -1923464207.804549,
            -2206015241.72324,
        ],
    ],
    [
        2419545600000,
        [
            5331803306.771029,
            -1921233176.693381,
            -2205820002.002522,
        ],
    ],
    [
        2420150400000,
        [
            5333470234.832314,
            -1919001606.880347,
            -2205624982.369403,
        ],
    ],
    [
        2420755200000,
        [
            5335135866.983372,
            -1916769804.502635,
            -2205430218.936479,
        ],
    ],
    [
        2421360000000,
        [
            5336799904.438999,
            -1914538016.022521,
            -2205235491.43063,
        ],
    ],
    [
        2421964800000,
        [
            5338462176.369475,
            -1912306341.504371,
            -2205040400.329336,
        ],
    ],
    [
        2422569600000,
        [
            5340122700.327165,
            -1910074699.26034,
            -2204844507.636265,
        ],
    ],
    [
        2423174400000,
        [
            5341781675.853422,
            -1907842854.960333,
            -2204647491.465356,
        ],
    ],
    [
        2423779200000,
        [
            5343439413.844799,
            -1905610504.591969,
            -2204449259.232585,
        ],
    ],
    [
        2424384000000,
        [
            5345096227.199628,
            -1903377381.809223,
            -2204249980.540135,
        ],
    ],
    [
        2424988800000,
        [
            5346752320.768226,
            -1901143352.710518,
            -2204050028.52914,
        ],
    ],
    [
        2425593600000,
        [
            5348407719.374166,
            -1898908463.704735,
            -2203849848.333077,
        ],
    ],
    [
        2426198400000,
        [
            5350062258.685145,
            -1896672924.266517,
            -2203649798.787625,
        ],
    ],
    [
        2426803200000,
        [
            5351715642.1682,
            -1894437033.219236,
            -2203450026.062417,
        ],
    ],
    [
        2427408000000,
        [
            5353367545.670308,
            -1892201074.977699,
            -2203250413.660481,
        ],
    ],
    [
        2428012800000,
        [
            5355017731.790635,
            -1889965220.278734,
            -2203050623.723724,
        ],
    ],
    [
        2428617600000,
        [
            5356666133.582389,
            -1887729466.113504,
            -2202850215.665081,
        ],
    ],
    [
        2429222400000,
        [
            5358312878.026597,
            -1885493637.03257,
            -2202648801.685009,
        ],
    ],
    [
        2429827200000,
        [
            5359958240.713671,
            -1883257447.821209,
            -2202446183.752661,
        ],
    ],
    [
        2430432000000,
        [
            5361602548.389162,
            -1881020604.765126,
            -2202242423.281775,
        ],
    ],
    [
        2431036800000,
        [
            5363246063.921718,
            -1878782909.796254,
            -2202037820.119751,
        ],
    ],
    [
        2431641600000,
        [
            5364888893.188843,
            -1876544331.833021,
            -2201832807.958013,
        ],
    ],
    [
        2432246400000,
        [
            5366530947.385968,
            -1874305019.592257,
            -2201627801.605661,
        ],
    ],
    [
        2432851200000,
        [
            5368171975.646163,
            -1872065250.084023,
            -2201423050.772933,
        ],
    ],
    [
        2433456000000,
        [
            5369811655.18606,
            -1869825330.711141,
            -2201218552.587834,
        ],
    ],
    [
        2434060800000,
        [
            5371449704.304046,
            -1867585491.353101,
            -2201014053.013528,
        ],
    ],
    [
        2434665600000,
        [
            5373085981.110311,
            -1865345805.335037,
            -2200809136.752347,
        ],
    ],
    [
        2435270400000,
        [
            5374720535.237644,
            -1863106164.653082,
            -2200603374.141573,
        ],
    ],
    [
        2435875200000,
        [
            5376353591.783329,
            -1860866318.306307,
            -2200396473.065557,
        ],
    ],
    [
        2436480000000,
        [
            5377985472.560274,
            -1858625961.090877,
            -2200188381.868639,
        ],
    ],
    [
        2437084800000,
        [
            5379616483.463876,
            -1856384841.156974,
            -2199979307.282298,
        ],
    ],
    [
        2437689600000,
        [
            5381246807.517312,
            -1854142848.793621,
            -2199769642.097966,
        ],
    ],
    [
        2438294400000,
        [
            5382876440.470241,
            -1851900055.74328,
            -2199559827.127782,
        ],
    ],
    [
        2438899200000,
        [
            5384505192.475698,
            -1849656690.297218,
            -2199350195.240514,
        ],
    ],
    [
        2439504000000,
        [
            5386132755.972145,
            -1847413056.655049,
            -2199140853.90796,
        ],
    ],
    [
        2440108800000,
        [
            5387758815.160741,
            -1845169428.029319,
            -2198931648.314914,
        ],
    ],
    [
        2440713600000,
        [
            5389383158.299189,
            -1842925950.622772,
            -2198722216.077706,
        ],
    ],
    [
        2441318400000,
        [
            5391005752.808358,
            -1840682590.685397,
            -2198512113.700481,
        ],
    ],
    [
        2441923200000,
        [
            5392626755.960708,
            -1838439145.865994,
            -2198300972.765198,
        ],
    ],
    [
        2442528000000,
        [
            5394246459.408302,
            -1836195317.540097,
            -2198088630.572808,
        ],
    ],
    [
        2443132800000,
        [
            5395865187.033404,
            -1833950816.050131,
            -2197875187.16886,
        ],
    ],
    [
        2443737600000,
        [
            5397483181.265699,
            -1831705461.820679,
            -2197660969.587548,
        ],
    ],
    [
        2444342400000,
        [
            5399100517.312651,
            -1829459248.188769,
            -2197446416.830753,
        ],
    ],
    [
        2444947200000,
        [
            5400717075.578871,
            -1827212343.936749,
            -2197231924.882842,
        ],
    ],
    [
        2445552000000,
        [
            5402332583.106739,
            -1824965033.667293,
            -2197017706.420468,
        ],
    ],
    [
        2446156800000,
        [
            5403946709.431532,
            -1822717617.268245,
            -2196803716.013104,
        ],
    ],
    [
        2446761600000,
        [
            5405559182.060103,
            -1820470304.909214,
            -2196589666.932183,
        ],
    ],
    [
        2447366400000,
        [
            5407169881.336164,
            -1818223144.226143,
            -2196375132.265989,
        ],
    ],
    [
        2447971200000,
        [
            5408778882.83593,
            -1815976004.221102,
            -2196159695.401169,
        ],
    ],
    [
        2448576000000,
        [
            5410386431.360143,
            -1813728621.303188,
            -2195943097.317476,
        ],
    ],
    [
        2449180800000,
        [
            5411992853.048549,
            -1811480692.362557,
            -2195725327.842667,
        ],
    ],
    [
        2449785600000,
        [
            5413598438.778496,
            -1809231983.354702,
            -2195506629.414597,
        ],
    ],
    [
        2450390400000,
        [
            5415203342.310069,
            -1806982413.208746,
            -2195287412.53623,
        ],
    ],
    [
        2450995200000,
        [
            5416807526.43137,
            -1804732083.385932,
            -2195068111.909487,
        ],
    ],
    [
        2451600000000,
        [
            5418410775.730178,
            -1802481243.067415,
            -2194849033.108023,
        ],
    ],
    [
        2452204800000,
        [
            5420012772.669313,
            -1800230201.913604,
            -2194630244.855618,
        ],
    ],
    [
        2452809600000,
        [
            5421613209.71222,
            -1797979221.824826,
            -2194411555.741671,
        ],
    ],
    [
        2453414400000,
        [
            5423211897.366022,
            -1795728426.232145,
            -2194192582.435949,
        ],
    ],
    [
        2454019200000,
        [
            5424808830.972197,
            -1793477757.932573,
            -2193972884.690615,
        ],
    ],
    [
        2454624000000,
        [
            5426404193.185533,
            -1791227000.22302,
            -2193752121.070835,
        ],
    ],
    [
        2455228800000,
        [
            5427998290.540821,
            -1788975854.88032,
            -2193530170.688788,
        ],
    ],
    [
        2455833600000,
        [
            5429591446.743592,
            -1786724048.74155,
            -2193307176.404628,
        ],
    ],
    [
        2456438400000,
        [
            5431183889.919922,
            -1784471429.65445,
            -2193083493.783223,
        ],
    ],
    [
        2457043200000,
        [
            5432775672.237059,
            -1782218020.261981,
            -2192859566.020636,
        ],
    ],
    [
        2457648000000,
        [
            5434366652.096452,
            -1779964011.946885,
            -2192635768.86337,
        ],
    ],
    [
        2458252800000,
        [
            5435956545.881989,
            -1777709698.10886,
            -2192412278.170187,
        ],
    ],
    [
        2458857600000,
        [
            5437545029.781428,
            -1775455370.256507,
            -2192189007.857525,
        ],
    ],
    [
        2459462400000,
        [
            5439131854.865766,
            -1773201215.172362,
            -2191965640.719572,
        ],
    ],
    [
        2460067200000,
        [
            5440716935.075944,
            -1770947249.385631,
            -2191741739.919802,
        ],
    ],
    [
        2460672000000,
        [
            5442300378.390906,
            -1768693312.94575,
            -2191516902.201298,
        ],
    ],
    [
        2461276800000,
        [
            5443882449.770976,
            -1766439125.307679,
            -2191290900.356978,
        ],
    ],
    [
        2461881600000,
        [
            5445463477.902331,
            -1764184384.529389,
            -2191063763.865182,
        ],
    ],
    [
        2462486400000,
        [
            5447043739.334634,
            -1761928874.233176,
            -2190835768.237481,
        ],
    ],
    [
        2463091200000,
        [
            5448623362.115318,
            -1759672539.866153,
            -2190607337.667086,
        ],
    ],
    [
        2463696000000,
        [
            5450202282.156683,
            -1757415507.13045,
            -2190378895.586136,
        ],
    ],
    [
        2464300800000,
        [
            5451780265.294314,
            -1755158036.608275,
            -2190150714.707014,
        ],
    ],
    [
        2464905600000,
        [
            5453356988.739986,
            -1752900432.218645,
            -2189922820.64144,
        ],
    ],
    [
        2465510400000,
        [
            5454932155.611548,
            -1750642934.659549,
            -2189694983.579624,
        ],
    ],
    [
        2466115200000,
        [
            5456505599.977388,
            -1748385636.672319,
            -2189466799.605246,
        ],
    ],
    [
        2466720000000,
        [
            5458077344.983847,
            -1746128450.195867,
            -2189237832.192289,
        ],
    ],
    [
        2467324800000,
        [
            5459647594.865144,
            -1743871136.717056,
            -2189007765.481073,
        ],
    ],
    [
        2467929600000,
        [
            5461216662.856853,
            -1741613391.235117,
            -2188776516.329573,
        ],
    ],
    [
        2468534400000,
        [
            5462784859.831173,
            -1739354950.574847,
            -2188544264.031381,
        ],
    ],
    [
        2469139200000,
        [
            5464352383.980849,
            -1737095686.805368,
            -2188311386.638709,
        ],
    ],
    [
        2469744000000,
        [
            5465919250.932446,
            -1734835652.72547,
            -2188078327.819019,
        ],
    ],
    [
        2470348800000,
        [
            5467485288.254315,
            -1732575064.345459,
            -2187845441.329369,
        ],
    ],
    [
        2470953600000,
        [
            5469050196.912355,
            -1730314225.71823,
            -2187612866.629847,
        ],
    ],
    [
        2471558400000,
        [
            5470613657.582079,
            -1728053421.233013,
            -2187380479.476087,
        ],
    ],
    [
        2472163200000,
        [
            5472175442.199922,
            -1725792815.549725,
            -2187147936.056443,
        ],
    ],
    [
        2472768000000,
        [
            5473735493.619272,
            -1723532397.722633,
            -2186914794.963478,
        ],
    ],
    [
        2473372800000,
        [
            5475293946.962497,
            -1721271985.993975,
            -2186680672.566075,
        ],
    ],
    [
        2473977600000,
        [
            5476851083.606291,
            -1719011291.450454,
            -2186445378.412524,
        ],
    ],
    [
        2474582400000,
        [
            5478407232.533802,
            -1716750020.12679,
            -2186208983.297039,
        ],
    ],
    [
        2475187200000,
        [
            5479962654.141644,
            -1714487977.477365,
            -2185971794.399174,
        ],
    ],
    [
        2475792000000,
        [
            5481517448.79342,
            -1712225137.219372,
            -2185734246.400657,
        ],
    ],
    [
        2476396800000,
        [
            5483071522.26094,
            -1709961650.563573,
            -2185496748.485164,
        ],
    ],
    [
        2477001600000,
        [
            5484624619.241629,
            -1707697793.442425,
            -2185259540.607209,
        ],
    ],
    [
        2477606400000,
        [
            5486176413.780509,
            -1705433869.810385,
            -2185022608.971299,
        ],
    ],
    [
        2478211200000,
        [
            5487726625.39582,
            -1703170104.906491,
            -2184785691.432319,
        ],
    ],
    [
        2478816000000,
        [
            5489275119.323006,
            -1700906565.879637,
            -2184548370.317131,
        ],
    ],
    [
        2479420800000,
        [
            5490821953.875379,
            -1698643137.256058,
            -2184310218.524116,
        ],
    ],
    [
        2480025600000,
        [
            5492367359.353025,
            -1696379561.409493,
            -2184070949.393754,
        ],
    ],
    [
        2480630400000,
        [
            5493911658.041358,
            -1694115529.791739,
            -2183830518.847506,
        ],
    ],
    [
        2481235200000,
        [
            5495455151.338299,
            -1691850791.871004,
            -2183589141.580619,
        ],
    ],
    [
        2481840000000,
        [
            5496998013.338376,
            -1689585243.249275,
            -2183347214.633892,
        ],
    ],
    [
        2482444800000,
        [
            5498540229.570969,
            -1687318961.73603,
            -2183105176.595023,
        ],
    ],
    [
        2483049600000,
        [
            5500081602.103371,
            -1685052179.462667,
            -2182863353.13991,
        ],
    ],
    [
        2483654400000,
        [
            5501621818.728466,
            -1682785201.199299,
            -2182621842.298203,
        ],
    ],
    [
        2484259200000,
        [
            5503160562.561281,
            -1680518297.007557,
            -2182380479.718827,
        ],
    ],
    [
        2484864000000,
        [
            5504697623.342835,
            -1678251607.391422,
            -2182138897.065303,
        ],
    ],
    [
        2485468800000,
        [
            5506232970.855292,
            -1675985094.953776,
            -2181896652.412791,
        ],
    ],
    [
        2486073600000,
        [
            5507766765.744505,
            -1673718558.464016,
            -2181653385.666027,
        ],
    ],
    [
        2486678400000,
        [
            5509299304.030422,
            -1671451702.853689,
            -2181408944.998028,
        ],
    ],
    [
        2487283200000,
        [
            5510830911.793447,
            -1669184242.951445,
            -2181163440.983441,
        ],
    ],
    [
        2487888000000,
        [
            5512361828.707395,
            -1666916006.269037,
            -2180917208.63518,
        ],
    ],
    [
        2488492800000,
        [
            5513892124.011349,
            -1664646995.282503,
            -2180670689.269664,
        ],
    ],
    [
        2489097600000,
        [
            5515421673.149546,
            -1662377386.609006,
            -2180424274.911119,
        ],
    ],
    [
        2489702400000,
        [
            5516950201.944638,
            -1660107469.189226,
            -2180178170.642,
        ],
    ],
    [
        2490307200000,
        [
            5518477383.182824,
            -1657837543.237895,
            -2179932322.462588,
        ],
    ],
    [
        2490912000000,
        [
            5520002952.297068,
            -1655567815.069922,
            -2179686436.614298,
        ],
    ],
    [
        2491516800000,
        [
            5521526800.87002,
            -1653298325.366167,
            -2179440083.895396,
        ],
    ],
    [
        2492121600000,
        [
            5523049014.788736,
            -1651028936.223699,
            -2179192851.241395,
        ],
    ],
    [
        2492726400000,
        [
            5524569844.619262,
            -1648759380.744173,
            -2178944487.067988,
        ],
    ],
    [
        2493331200000,
        [
            5526089619.130692,
            -1646489357.765847,
            -2178694990.772188,
        ],
    ],
    [
        2493936000000,
        [
            5527608631.360174,
            -1644218638.747852,
            -2178444614.203124,
        ],
    ],
    [
        2494540800000,
        [
            5529127035.853755,
            -1641947148.24877,
            -2178193772.390837,
        ],
    ],
    [
        2495145600000,
        [
            5530644793.996062,
            -1639674990.797352,
            -2177942896.553509,
        ],
    ],
    [
        2495750400000,
        [
            5532161689.318561,
            -1637402414.925336,
            -2177692282.943268,
        ],
    ],
    [
        2496355200000,
        [
            5533677405.755305,
            -1635129725.836504,
            -2177441988.947488,
        ],
    ],
    [
        2496960000000,
        [
            5535191640.445186,
            -1632857177.310617,
            -2177191812.388385,
        ],
    ],
    [
        2497564800000,
        [
            5536704211.706703,
            -1630584881.499933,
            -2176941362.672584,
        ],
    ],
    [
        2498169600000,
        [
            5538215123.650508,
            -1628312769.139388,
            -2176690198.589715,
        ],
    ],
    [
        2498774400000,
        [
            5539724565.005933,
            -1626040613.732682,
            -2176437983.129231,
        ],
    ],
    [
        2499379200000,
        [
            5541232843.470426,
            -1623768110.465143,
            -2176184601.495702,
        ],
    ],
    [
        2499984000000,
        [
            5542740278.068242,
            -1621494982.916613,
            -2175930202.015046,
        ],
    ],
    [
        2500588800000,
        [
            5544247086.701299,
            -1619221080.775576,
            -2175675144.373777,
        ],
    ],
    [
        2501193600000,
        [
            5545753309.826325,
            -1616946432.941497,
            -2175419872.304151,
        ],
    ],
    [
        2501798400000,
        [
            5547258797.577147,
            -1614671235.686504,
            -2175164756.11062,
        ],
    ],
    [
        2502403200000,
        [
            5548763262.094688,
            -1612395781.730519,
            -2174909961.711562,
        ],
    ],
    [
        2503008000000,
        [
            5550266377.588391,
            -1610120357.62601,
            -2174655392.363793,
        ],
    ],
    [
        2503612800000,
        [
            5551767895.654343,
            -1607845142.928903,
            -2174400722.654782,
        ],
    ],
    [
        2504217600000,
        [
            5553267733.39143,
            -1605570146.084315,
            -2174145513.189724,
        ],
    ],
    [
        2504822400000,
        [
            5554766001.950112,
            -1603295201.100651,
            -2173889365.33306,
        ],
    ],
    [
        2505427200000,
        [
            5556262966.47236,
            -1601020025.78464,
            -2173632060.832215,
        ],
    ],
    [
        2506032000000,
        [
            5557758952.415773,
            -1598744320.568067,
            -2173373638.43188,
        ],
    ],
    [
        2506636800000,
        [
            5559254230.18939,
            -1596467874.205677,
            -2173114380.986434,
        ],
    ],
    [
        2507241600000,
        [
            5560748918.495795,
            -1594190639.127748,
            -2172854715.946106,
        ],
    ],
    [
        2507846400000,
        [
            5562242941.676844,
            -1591912748.904454,
            -2172595064.283067,
        ],
    ],
    [
        2508451200000,
        [
            5563736056.578882,
            -1589634471.770787,
            -2172335692.550821,
        ],
    ],
    [
        2509056000000,
        [
            5565227938.864753,
            -1587356116.829163,
            -2172076619.797657,
        ],
    ],
    [
        2509660800000,
        [
            5566718297.179007,
            -1585077924.890746,
            -2171817610.381986,
        ],
    ],
    [
        2510265600000,
        [
            5568206974.597116,
            -1582799983.882732,
            -2171558256.863698,
        ],
    ],
    [
        2510870400000,
        [
            5569694003.869106,
            -1580522199.656706,
            -2171298124.898119,
        ],
    ],
    [
        2511475200000,
        [
            5571179596.556176,
            -1578244330.475009,
            -2171036906.898839,
        ],
    ],
    [
        2512080000000,
        [
            5572664069.131938,
            -1575966072.424741,
            -2170774529.977302,
        ],
    ],
    [
        2512684800000,
        [
            5574147732.272674,
            -1573687166.445577,
            -2170511181.94673,
        ],
    ],
    [
        2513289600000,
        [
            5575630781.480883,
            -1571407490.38547,
            -2170247245.988854,
        ],
    ],
    [
        2513894400000,
        [
            5577113228.045721,
            -1569127103.006385,
            -2169983165.489268,
        ],
    ],
    [
        2514499200000,
        [
            5578594895.700768,
            -1566846223.548019,
            -2169719287.428073,
        ],
    ],
    [
        2515104000000,
        [
            5580075483.616795,
            -1564565154.775129,
            -2169455740.770946,
        ],
    ],
    [
        2515708800000,
        [
            5581554672.800637,
            -1562284177.372826,
            -2169192391.742562,
        ],
    ],
    [
        2516313600000,
        [
            5583032239.70978,
            -1560003451.805427,
            -2168928890.957931,
        ],
    ],
    [
        2516918400000,
        [
            5584508137.184397,
            -1557722961.115373,
            -2168664796.493757,
        ],
    ],
    [
        2517523200000,
        [
            5585982511.2854,
            -1555442515.971051,
            -2168399729.488349,
        ],
    ],
    [
        2518128000000,
        [
            5587455649.057602,
            -1553161822.235946,
            -2168133507.670823,
        ],
    ],
    [
        2518732800000,
        [
            5588927878.803722,
            -1550880585.094939,
            -2167866209.657039,
        ],
    ],
    [
        2519337600000,
        [
            5590399456.049521,
            -1548598612.335945,
            -2167598147.571426,
        ],
    ],
    [
        2519942400000,
        [
            5591870473.772945,
            -1546315881.782376,
            -2167329756.957892,
        ],
    ],
    [
        2520547200000,
        [
            5593340829.688529,
            -1544032548.660566,
            -2167061442.373336,
        ],
    ],
    [
        2521152000000,
        [
            5594810262.841502,
            -1541748890.023845,
            -2166793434.344856,
        ],
    ],
    [
        2521756800000,
        [
            5596278445.704117,
            -1539465206.764139,
            -2166525708.582239,
        ],
    ],
    [
        2522361600000,
        [
            5597745098.996953,
            -1537181717.851684,
            -2166257994.405429,
        ],
    ],
    [
        2522966400000,
        [
            5599210089.993967,
            -1534898483.100171,
            -2165989869.548428,
        ],
    ],
    [
        2523571200000,
        [
            5600673479.777287,
            -1532615382.128131,
            -2165720909.383898,
        ],
    ],
    [
        2524176000000,
        [
            5602135502.346176,
            -1530332157.151105,
            -2165450837.126602,
        ],
    ],
];
